(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue-property-decorator"), require("@ht-lib/accounts-common"), require("@ht-lib/image-util"), require("@ht-lib/accounts-models"), require("@ht-lib/activity-collection"), require("@ht-lib/accounts-api-client"), require("lodash"), require("vue"), require("@ht-web/firebase-adapter"));
	else if(typeof define === 'function' && define.amd)
		define(["vue-property-decorator", "@ht-lib/accounts-common", "@ht-lib/image-util", "@ht-lib/accounts-models", "@ht-lib/activity-collection", "@ht-lib/accounts-api-client", "lodash", "vue", "@ht-web/firebase-adapter"], factory);
	else if(typeof exports === 'object')
		exports["quality-control"] = factory(require("vue-property-decorator"), require("@ht-lib/accounts-common"), require("@ht-lib/image-util"), require("@ht-lib/accounts-models"), require("@ht-lib/activity-collection"), require("@ht-lib/accounts-api-client"), require("lodash"), require("vue"), require("@ht-web/firebase-adapter"));
	else
		root["quality-control"] = factory(root["vue-property-decorator"], root["@ht-lib/accounts-common"], root["@ht-lib/image-util"], root["@ht-lib/accounts-models"], root["@ht-lib/activity-collection"], root["@ht-lib/accounts-api-client"], root["lodash"], root["vue"], root["@ht-web/firebase-adapter"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__01a6__, __WEBPACK_EXTERNAL_MODULE__03be__, __WEBPACK_EXTERNAL_MODULE__38a2__, __WEBPACK_EXTERNAL_MODULE__406b__, __WEBPACK_EXTERNAL_MODULE__44d9__, __WEBPACK_EXTERNAL_MODULE__5403__, __WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE__982d__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "dfbb");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01a6":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__01a6__;

/***/ }),

/***/ "022c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b4cc");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("b30d9356", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "03be":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__03be__;

/***/ }),

/***/ "048c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITF14 = exports.ITF = undefined;

var _ITF = __webpack_require__("4c4f");

var _ITF2 = _interopRequireDefault(_ITF);

var _ITF3 = __webpack_require__("64ff");

var _ITF4 = _interopRequireDefault(_ITF3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ITF = _ITF2.default;
exports.ITF14 = _ITF4.default;

/***/ }),

/***/ "0612":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Platform.js
var Platform = __webpack_require__("ad69");

// CONCATENATED MODULE: /workspace/node_modules/quasar/icon-set/material-icons.js
/* harmony default export */ var material_icons = ({
  name: 'material-icons',
  type: {
    positive: 'check_circle',
    negative: 'warning',
    info: 'info',
    warning: 'priority_high'
  },
  arrow: {
    up: 'arrow_upward',
    right: 'arrow_forward',
    down: 'arrow_downward',
    left: 'arrow_back',
    dropdown: 'arrow_drop_down'
  },
  chevron: {
    left: 'chevron_left',
    right: 'chevron_right'
  },
  colorPicker: {
    spectrum: 'gradient',
    tune: 'tune',
    palette: 'style'
  },
  pullToRefresh: {
    icon: 'refresh'
  },
  carousel: {
    left: 'chevron_left',
    right: 'chevron_right',
    up: 'keyboard_arrow_up',
    down: 'keyboard_arrow_down',
    navigationIcon: 'lens'
  },
  chip: {
    remove: 'cancel',
    selected: 'check'
  },
  datetime: {
    arrowLeft: 'chevron_left',
    arrowRight: 'chevron_right',
    now: 'access_time',
    today: 'today'
  },
  editor: {
    bold: 'format_bold',
    italic: 'format_italic',
    strikethrough: 'strikethrough_s',
    underline: 'format_underlined',
    unorderedList: 'format_list_bulleted',
    orderedList: 'format_list_numbered',
    subscript: 'vertical_align_bottom',
    superscript: 'vertical_align_top',
    hyperlink: 'link',
    toggleFullscreen: 'fullscreen',
    quote: 'format_quote',
    left: 'format_align_left',
    center: 'format_align_center',
    right: 'format_align_right',
    justify: 'format_align_justify',
    print: 'print',
    outdent: 'format_indent_decrease',
    indent: 'format_indent_increase',
    removeFormat: 'format_clear',
    formatting: 'text_format',
    fontSize: 'format_size',
    align: 'format_align_left',
    hr: 'remove',
    undo: 'undo',
    redo: 'redo',
    heading: 'format_size',
    code: 'code',
    size: 'format_size',
    font: 'font_download',
    viewSource: 'code'
  },
  expansionItem: {
    icon: 'keyboard_arrow_down',
    denseIcon: 'arrow_drop_down'
  },
  fab: {
    icon: 'add',
    activeIcon: 'close'
  },
  field: {
    clear: 'cancel',
    error: 'error'
  },
  pagination: {
    first: 'first_page',
    prev: 'keyboard_arrow_left',
    next: 'keyboard_arrow_right',
    last: 'last_page'
  },
  rating: {
    icon: 'grade'
  },
  stepper: {
    done: 'check',
    active: 'edit',
    error: 'warning'
  },
  tabs: {
    left: 'chevron_left',
    right: 'chevron_right',
    up: 'keyboard_arrow_up',
    down: 'keyboard_arrow_down'
  },
  table: {
    arrowUp: 'arrow_upward',
    warning: 'warning',
    firstPage: 'first_page',
    prevPage: 'chevron_left',
    nextPage: 'chevron_right',
    lastPage: 'last_page'
  },
  tree: {
    icon: 'play_arrow'
  },
  uploader: {
    done: 'done',
    clear: 'clear',
    add: 'add_box',
    upload: 'cloud_upload',
    removeQueue: 'clear_all',
    removeUploaded: 'done_all'
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/icon-set.js



/* harmony default export */ var icon_set = __webpack_exports__["a"] = ({
  install($q, queues, iconSet) {
    const initialSet = iconSet || material_icons;
    this.set = (setObject, ssrContext) => {
      const def = {
        ...setObject
      };
      if (Platform["e" /* isSSR */] === true) {
        if (ssrContext === void 0) {
          console.error('SSR ERROR: second param required: Quasar.iconSet.set(iconSet, ssrContext)');
          return;
        }
        def.set = ssrContext.$q.iconSet.set;
        ssrContext.$q.iconSet = def;
      } else {
        def.set = this.set;
        $q.iconSet = def;
      }
    };
    if (Platform["e" /* isSSR */] === true) {
      queues.server.push((q, ctx) => {
        q.iconSet = {};
        q.iconSet.set = setObject => {
          this.set(setObject, ctx.ssr);
        };
        q.iconSet.set(initialSet);
      });
    } else {
      external_vue_default.a.util.defineReactive($q, 'iconMapFn', void 0);
      external_vue_default.a.util.defineReactive($q, 'iconSet', {});
      this.set(initialSet);
    }
  }
});

/***/ }),

/***/ "06fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.codabar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding specification:
// http://www.barcodeisland.com/codabar.phtml

var codabar = function (_Barcode) {
	_inherits(codabar, _Barcode);

	function codabar(data, options) {
		_classCallCheck(this, codabar);

		if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
			data = "A" + data + "A";
		}

		var _this = _possibleConstructorReturn(this, (codabar.__proto__ || Object.getPrototypeOf(codabar)).call(this, data.toUpperCase(), options));

		_this.text = _this.options.text || _this.text.replace(/[A-D]/g, '');
		return _this;
	}

	_createClass(codabar, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
		}
	}, {
		key: "encode",
		value: function encode() {
			var result = [];
			var encodings = this.getEncodings();
			for (var i = 0; i < this.data.length; i++) {
				result.push(encodings[this.data.charAt(i)]);
				// for all characters except the last, append a narrow-space ("0")
				if (i !== this.data.length - 1) {
					result.push("0");
				}
			}
			return {
				text: this.text,
				data: result.join('')
			};
		}
	}, {
		key: "getEncodings",
		value: function getEncodings() {
			return {
				"0": "101010011",
				"1": "101011001",
				"2": "101001011",
				"3": "110010101",
				"4": "101101001",
				"5": "110101001",
				"6": "100101011",
				"7": "100101101",
				"8": "100110101",
				"9": "110100101",
				"-": "101001101",
				"$": "101100101",
				":": "1101011011",
				"/": "1101101011",
				".": "1101101101",
				"+": "1011011011",
				"A": "1011001001",
				"B": "1001001011",
				"C": "1010010011",
				"D": "1010011001"
			};
		}
	}]);

	return codabar;
}(_Barcode3.default);

exports.codabar = codabar;

/***/ }),

/***/ "0807":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Platform_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ad69");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_debounce_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("c3c5");




const SIZE_LIST = ['sm', 'md', 'lg', 'xl'];
const {
  passive
} = _utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* listenOpts */ "f"];
/* harmony default export */ __webpack_exports__["a"] = ({
  width: 0,
  height: 0,
  name: 'xs',
  sizes: {
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
  },
  lt: {
    sm: true,
    md: true,
    lg: true,
    xl: true
  },
  gt: {
    xs: false,
    sm: false,
    md: false,
    lg: false
  },
  xs: true,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  setSizes: _utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* noop */ "g"],
  setDebounce: _utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* noop */ "g"],
  install($q, queues, cfg) {
    if (_Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* isSSR */ "e"] === true) {
      $q.screen = this;
      return;
    }
    const {
      visualViewport
    } = window;
    const target = visualViewport || window;
    const scrollingElement = document.scrollingElement || document.documentElement;
    const getSize = visualViewport === void 0 || _Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* client */ "a"].is.mobile === true ? () => [Math.max(window.innerWidth, scrollingElement.clientWidth), Math.max(window.innerHeight, scrollingElement.clientHeight)] : () => [visualViewport.width * visualViewport.scale + window.innerWidth - scrollingElement.clientWidth, visualViewport.height * visualViewport.scale + window.innerHeight - scrollingElement.clientHeight];
    const classes = cfg.screen !== void 0 && cfg.screen.bodyClasses === true;
    const update = force => {
      const [w, h] = getSize();
      if (h !== this.height) {
        this.height = h;
      }
      if (w !== this.width) {
        this.width = w;
      } else if (force !== true) {
        return;
      }
      let s = this.sizes;
      this.gt.xs = w >= s.sm;
      this.gt.sm = w >= s.md;
      this.gt.md = w >= s.lg;
      this.gt.lg = w >= s.xl;
      this.lt.sm = w < s.sm;
      this.lt.md = w < s.md;
      this.lt.lg = w < s.lg;
      this.lt.xl = w < s.xl;
      this.xs = this.lt.sm;
      this.sm = this.gt.xs === true && this.lt.md === true;
      this.md = this.gt.sm === true && this.lt.lg === true;
      this.lg = this.gt.md === true && this.lt.xl === true;
      this.xl = this.gt.lg;
      s = this.xs === true && 'xs' || this.sm === true && 'sm' || this.md === true && 'md' || this.lg === true && 'lg' || 'xl';
      if (s !== this.name) {
        if (classes === true) {
          document.body.classList.remove(`screen--${this.name}`);
          document.body.classList.add(`screen--${s}`);
        }
        this.name = s;
      }
    };
    let updateEvt,
      updateSizes = {},
      updateDebounce = 16;
    this.setSizes = sizes => {
      SIZE_LIST.forEach(name => {
        if (sizes[name] !== void 0) {
          updateSizes[name] = sizes[name];
        }
      });
    };
    this.setDebounce = deb => {
      updateDebounce = deb;
    };
    const start = () => {
      const style = getComputedStyle(document.body);

      // if css props available
      if (style.getPropertyValue('--q-size-sm')) {
        SIZE_LIST.forEach(name => {
          this.sizes[name] = parseInt(style.getPropertyValue(`--q-size-${name}`), 10);
        });
      }
      this.setSizes = sizes => {
        SIZE_LIST.forEach(name => {
          if (sizes[name]) {
            this.sizes[name] = sizes[name];
          }
        });
        update(true);
      };
      this.setDebounce = delay => {
        updateEvt !== void 0 && target.removeEventListener('resize', updateEvt, passive);
        updateEvt = delay > 0 ? Object(_utils_debounce_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(update, delay) : update;
        target.addEventListener('resize', updateEvt, passive);
      };
      this.setDebounce(updateDebounce);
      if (Object.keys(updateSizes).length > 0) {
        this.setSizes(updateSizes);
        updateSizes = void 0; // free up memory
      } else {
        update();
      }

      // due to optimizations, this would be left out otherwise
      classes === true && this.name === 'xs' && document.body.classList.add('screen--xs');
    };
    if (_Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* fromSSR */ "c"] === true) {
      queues.takeover.push(start);
    } else {
      start();
    }
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.util.defineReactive($q, 'screen', this);
  }
});

/***/ }),

/***/ "0aaf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("feae");



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QItemSection',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    avatar: Boolean,
    thumbnail: Boolean,
    side: Boolean,
    top: Boolean,
    noWrap: Boolean
  },
  computed: {
    classes() {
      const side = this.avatar || this.side || this.thumbnail;
      return {
        'q-item__section--top': this.top,
        'q-item__section--avatar': this.avatar,
        'q-item__section--thumbnail': this.thumbnail,
        'q-item__section--side': side,
        'q-item__section--nowrap': this.noWrap,
        'q-item__section--main': !side,
        [`justify-${this.top ? 'start' : 'center'}`]: true
      };
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-item__section column',
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "0c9a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidInputException = function (_Error) {
	_inherits(InvalidInputException, _Error);

	function InvalidInputException(symbology, input) {
		_classCallCheck(this, InvalidInputException);

		var _this = _possibleConstructorReturn(this, (InvalidInputException.__proto__ || Object.getPrototypeOf(InvalidInputException)).call(this));

		_this.name = "InvalidInputException";

		_this.symbology = symbology;
		_this.input = input;

		_this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
		return _this;
	}

	return InvalidInputException;
}(Error);

var InvalidElementException = function (_Error2) {
	_inherits(InvalidElementException, _Error2);

	function InvalidElementException() {
		_classCallCheck(this, InvalidElementException);

		var _this2 = _possibleConstructorReturn(this, (InvalidElementException.__proto__ || Object.getPrototypeOf(InvalidElementException)).call(this));

		_this2.name = "InvalidElementException";
		_this2.message = "Not supported type to render on";
		return _this2;
	}

	return InvalidElementException;
}(Error);

var NoElementException = function (_Error3) {
	_inherits(NoElementException, _Error3);

	function NoElementException() {
		_classCallCheck(this, NoElementException);

		var _this3 = _possibleConstructorReturn(this, (NoElementException.__proto__ || Object.getPrototypeOf(NoElementException)).call(this));

		_this3.name = "NoElementException";
		_this3.message = "No element to render on.";
		return _this3;
	}

	return NoElementException;
}(Error);

exports.InvalidInputException = InvalidInputException;
exports.InvalidElementException = InvalidElementException;
exports.NoElementException = NoElementException;

/***/ }),

/***/ "0ea9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageControl_vue_vue_type_style_index_0_id_1311674c_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a13c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageControl_vue_vue_type_style_index_0_id_1311674c_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageControl_vue_vue_type_style_index_0_id_1311674c_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "116d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onKeyDownComposition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shouldIgnoreKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isKeyCode; });
let lastKeyCompositionStatus = false;
function onKeyDownComposition(evt) {
  lastKeyCompositionStatus = evt.isComposing === true;
}
function shouldIgnoreKey(evt) {
  return lastKeyCompositionStatus === true || evt !== Object(evt) || evt.isComposing === true || evt.qKeyEvent === true;
}
function isKeyCode(evt, keyCodes) {
  return shouldIgnoreKey(evt) === true ? false : [].concat(keyCodes).includes(evt.keyCode);
}

/***/ }),

/***/ "1323":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomImage_vue_vue_type_style_index_0_id_76fbbbc5_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("022c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomImage_vue_vue_type_style_index_0_id_76fbbbc5_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ZoomImage_vue_vue_type_style_index_0_id_76fbbbc5_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "135c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Platform.js
var Platform = __webpack_require__("ad69");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/icon/QIcon.js
var QIcon = __webpack_require__("a170");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinner.js
var QSpinner = __webpack_require__("88a8");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/patterns.js
var patterns = __webpack_require__("af68");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/debounce.js
var debounce = __webpack_require__("c3c5");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/mixins/validate.js


const lazyRulesValues = [true, false, 'ondemand'];
/* harmony default export */ var validate = ({
  props: {
    value: {},
    error: {
      type: Boolean,
      default: null
    },
    errorMessage: String,
    noErrorIcon: Boolean,
    rules: Array,
    reactiveRules: Boolean,
    lazyRules: {
      type: [Boolean, String],
      validator: v => lazyRulesValues.includes(v)
    }
  },
  data() {
    return {
      isDirty: null,
      innerError: false,
      innerErrorMessage: void 0
    };
  },
  watch: {
    value() {
      this.__validateIfNeeded();
    },
    disable(val) {
      if (val === true) {
        this.__resetValidation();
      } else {
        this.__validateIfNeeded(true);
      }
    },
    reactiveRules: {
      handler(val) {
        if (val === true) {
          if (this.unwatchRules === void 0) {
            this.unwatchRules = this.$watch('rules', () => {
              this.__validateIfNeeded(true);
            });
          }
        } else if (this.unwatchRules !== void 0) {
          this.unwatchRules();
          this.unwatchRules = void 0;
        }
      },
      immediate: true
    },
    focused(focused) {
      if (focused === true) {
        if (this.isDirty === null) {
          this.isDirty = false;
        }
      } else if (this.isDirty === false) {
        this.isDirty = true;
        if (this.hasActiveRules === true && this.lazyRules !== 'ondemand' &&
        // Don't re-trigger if it's already in progress;
        // It might mean that focus switched to submit btn and
        // QForm's submit() has been called already (ENTER key)
        this.innerLoading === false) {
          this.debouncedValidate();
        }
      }
    },
    hasError(invalid) {
      const targetEl = document.getElementById(this.targetUid);
      targetEl !== null && targetEl.setAttribute('aria-invalid', invalid === true);
    }
  },
  computed: {
    hasRules() {
      return this.rules !== void 0 && this.rules !== null && this.rules.length > 0;
    },
    hasActiveRules() {
      return this.disable !== true && this.hasRules === true;
    },
    hasError() {
      return this.error === true || this.innerError === true;
    },
    computedErrorMessage() {
      return typeof this.errorMessage === 'string' && this.errorMessage.length > 0 ? this.errorMessage : this.innerErrorMessage;
    }
  },
  created() {
    this.debouncedValidate = Object(debounce["a" /* default */])(this.validate, 0);
  },
  mounted() {
    this.validateIndex = 0;
  },
  beforeDestroy() {
    this.unwatchRules !== void 0 && this.unwatchRules();
    this.debouncedValidate.cancel();
  },
  methods: {
    resetValidation() {
      this.isDirty = null;
      this.__resetValidation();
    },
    /*
     * Return value
     *   - true (validation succeeded)
     *   - false (validation failed)
     *   - Promise (pending async validation)
     */
    validate(val = this.value) {
      if (this.hasActiveRules !== true) {
        return true;
      }
      const index = ++this.validateIndex;
      const setDirty = this.innerLoading !== true ? () => this.isDirty !== true && (this.isDirty = true) : () => {};
      const update = (err, msg) => {
        err === true && setDirty();
        if (this.innerError !== err) {
          this.innerError = err;
        }
        const m = msg || void 0;
        if (this.innerErrorMessage !== m) {
          this.innerErrorMessage = m;
        }
        if (this.innerLoading !== false) {
          this.innerLoading = false;
        }
      };
      const promises = [];
      for (let i = 0; i < this.rules.length; i++) {
        const rule = this.rules[i];
        let res;
        if (typeof rule === 'function') {
          res = rule(val, patterns["a" /* testPattern */]);
        } else if (typeof rule === 'string' && patterns["a" /* testPattern */][rule] !== void 0) {
          res = patterns["a" /* testPattern */][rule](val);
        }
        if (res === false || typeof res === 'string') {
          update(true, res);
          return false;
        } else if (res !== true && res !== void 0) {
          promises.push(res);
        }
      }
      if (promises.length === 0) {
        update(false);
        return true;
      }
      if (this.innerLoading !== true) {
        this.innerLoading = true;
      }
      return Promise.all(promises).then(res => {
        if (res === void 0 || Array.isArray(res) === false || res.length === 0) {
          index === this.validateIndex && update(false);
          return true;
        }
        const msg = res.find(r => r === false || typeof r === 'string');
        index === this.validateIndex && update(msg !== void 0, msg);
        return msg === void 0;
      }, e => {
        if (index === this.validateIndex) {
          console.error(e);
          update(true);
        }
        return false;
      });
    },
    __resetValidation() {
      this.debouncedValidate.cancel();
      this.validateIndex++;
      this.innerLoading = false;
      this.innerError = false;
      this.innerErrorMessage = void 0;
    },
    __validateIfNeeded(changedRules) {
      if (this.hasActiveRules === true && this.lazyRules !== 'ondemand' && (this.isDirty === true || this.lazyRules !== true && changedRules !== true)) {
        this.debouncedValidate();
      }
    }
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/dark.js
var dark = __webpack_require__("a583");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/attrs.js
var attrs = __webpack_require__("ae5c");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/slot.js
var slot = __webpack_require__("feae");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/uid.js
var uid = __webpack_require__("c9c2");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/event.js
var utils_event = __webpack_require__("a8d5");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/focus-manager.js
var focus_manager = __webpack_require__("fa15");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/field/QField.js











function getTargetUid(val) {
  return val === void 0 ? `f_${Object(uid["a" /* default */])()}` : val;
}
/* harmony default export */ var QField = __webpack_exports__["a"] = (external_vue_default.a.extend({
  name: 'QField',
  mixins: [dark["a" /* default */], validate, attrs["b" /* default */]],
  inheritAttrs: false,
  props: {
    label: String,
    stackLabel: Boolean,
    hint: String,
    hideHint: Boolean,
    prefix: String,
    suffix: String,
    labelColor: String,
    color: String,
    bgColor: String,
    filled: Boolean,
    outlined: Boolean,
    borderless: Boolean,
    standout: [Boolean, String],
    square: Boolean,
    loading: Boolean,
    labelSlot: Boolean,
    bottomSlots: Boolean,
    hideBottomSpace: Boolean,
    rounded: Boolean,
    dense: Boolean,
    itemAligned: Boolean,
    counter: Boolean,
    clearable: Boolean,
    clearIcon: String,
    disable: Boolean,
    readonly: Boolean,
    autofocus: Boolean,
    for: String,
    maxlength: [Number, String],
    maxValues: [Number, String] // private, do not add to JSON; internally needed by QSelect
  },
  data() {
    return {
      focused: false,
      targetUid: getTargetUid(this.for),
      // used internally by validation for QInput
      // or menu handling for QSelect
      innerLoading: false
    };
  },
  watch: {
    for(val) {
      // don't transform targetUid into a computed
      // prop as it will break SSR
      this.targetUid = getTargetUid(val);
    }
  },
  computed: {
    editable() {
      return this.disable !== true && this.readonly !== true;
    },
    hasValue() {
      const value = this.__getControl === void 0 ? this.value : this.innerValue;
      return value !== void 0 && value !== null && ('' + value).length > 0;
    },
    computedCounter() {
      if (this.counter !== false) {
        const len = typeof this.value === 'string' || typeof this.value === 'number' ? ('' + this.value).length : Array.isArray(this.value) === true ? this.value.length : 0;
        const max = this.maxlength !== void 0 ? this.maxlength : this.maxValues;
        return len + (max !== void 0 ? ' / ' + max : '');
      }
    },
    floatingLabel() {
      return this.stackLabel === true || this.focused === true || typeof this.inputValue === 'number' || typeof this.inputValue === 'string' && this.inputValue.length > 0 || this.hideSelected !== true && this.hasValue === true && (this.type !== 'number' || isNaN(this.value) === false) || this.displayValue !== void 0 && this.displayValue !== null && ('' + this.displayValue).length > 0;
    },
    shouldRenderBottom() {
      return this.bottomSlots === true || this.hint !== void 0 || this.hasRules === true || this.counter === true || this.error !== null;
    },
    classes() {
      return {
        [this.fieldClass]: this.fieldClass !== void 0,
        [`q-field--${this.styleType}`]: true,
        'q-field--rounded': this.rounded,
        'q-field--square': this.square,
        'q-field--focused': this.focused === true,
        'q-field--highlighted': this.focused === true || this.hasError === true,
        'q-field--float': this.floatingLabel,
        'q-field--labeled': this.hasLabel,
        'q-field--dense': this.dense,
        'q-field--item-aligned q-item-type': this.itemAligned,
        'q-field--dark': this.isDark,
        'q-field--auto-height': this.__getControl === void 0,
        'q-field--with-bottom': this.hideBottomSpace !== true && this.shouldRenderBottom === true,
        'q-field--error': this.hasError,
        'q-field--readonly': this.readonly === true && this.disable !== true,
        'q-field--disabled': this.disable === true
      };
    },
    styleType() {
      if (this.filled === true) {
        return 'filled';
      }
      if (this.outlined === true) {
        return 'outlined';
      }
      if (this.borderless === true) {
        return 'borderless';
      }
      if (this.standout) {
        return 'standout';
      }
      return 'standard';
    },
    contentClass() {
      const cls = [];
      if (this.hasError === true) {
        cls.push('text-negative');
      } else if (typeof this.standout === 'string' && this.standout.length > 0 && this.focused === true) {
        return this.standout;
      } else if (this.color !== void 0) {
        cls.push('text-' + this.color);
      }
      if (this.bgColor !== void 0) {
        cls.push(`bg-${this.bgColor}`);
      }
      return cls;
    },
    hasLabel() {
      return this.labelSlot === true || this.label !== void 0;
    },
    labelClass() {
      if (this.labelColor !== void 0 && this.hasError !== true) {
        return 'text-' + this.labelColor;
      }
    },
    controlSlotScope() {
      return {
        id: this.targetUid,
        field: this.$el,
        editable: this.editable,
        focused: this.focused,
        floatingLabel: this.floatingLabel,
        value: this.value,
        emitValue: this.__emitValue
      };
    },
    bottomSlotScope() {
      return {
        id: this.targetUid,
        field: this.$el,
        editable: this.editable,
        focused: this.focused,
        value: this.value,
        errorMessage: this.computedErrorMessage
      };
    },
    attrs() {
      const attrs = {
        for: this.targetUid
      };
      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      } else if (this.readonly === true) {
        attrs['aria-readonly'] = 'true';
      }
      return attrs;
    }
  },
  methods: {
    focus() {
      Object(focus_manager["a" /* addFocusFn */])(this.__focus);
    },
    blur() {
      Object(focus_manager["c" /* removeFocusFn */])(this.__focus);
      const el = document.activeElement;
      // IE can have null document.activeElement
      if (el !== null && this.$el.contains(el)) {
        el.blur();
      }
    },
    __focus() {
      const el = document.activeElement;
      let target = this.$refs.target;
      // IE can have null document.activeElement
      if (target !== void 0 && (el === null || el.id !== this.targetUid)) {
        target.hasAttribute('tabindex') === true || (target = target.querySelector('[tabindex]'));
        target !== null && target !== el && target.focus({
          preventScroll: true
        });
      }
    },
    __getContent(h) {
      const node = [];
      this.$scopedSlots.prepend !== void 0 && node.push(h('div', {
        staticClass: 'q-field__prepend q-field__marginal row no-wrap items-center',
        key: 'prepend',
        on: this.slotsEvents
      }, this.$scopedSlots.prepend()));
      node.push(h('div', {
        staticClass: 'q-field__control-container col relative-position row no-wrap q-anchor--skip'
      }, this.__getControlContainer(h)));
      this.hasError === true && this.noErrorIcon === false && node.push(this.__getInnerAppendNode(h, 'error', [h(QIcon["a" /* default */], {
        props: {
          name: this.$q.iconSet.field.error,
          color: 'negative'
        }
      })]));
      if (this.loading === true || this.innerLoading === true) {
        node.push(this.__getInnerAppendNode(h, 'inner-loading-append', this.$scopedSlots.loading !== void 0 ? this.$scopedSlots.loading() : [h(QSpinner["a" /* default */], {
          props: {
            color: this.color
          }
        })]));
      } else if (this.clearable === true && this.hasValue === true && this.editable === true) {
        node.push(this.__getInnerAppendNode(h, 'inner-clearable-append', [h(QIcon["a" /* default */], {
          staticClass: 'q-field__focusable-action',
          props: {
            tag: 'button',
            name: this.clearIcon || this.$q.iconSet.field.clear
          },
          attrs: attrs["c" /* iconAsButton */],
          on: this.clearableEvents
        })]));
      }
      this.$scopedSlots.append !== void 0 && node.push(h('div', {
        staticClass: 'q-field__append q-field__marginal row no-wrap items-center',
        key: 'append',
        on: this.slotsEvents
      }, this.$scopedSlots.append()));
      this.__getInnerAppend !== void 0 && node.push(this.__getInnerAppendNode(h, 'inner-append', this.__getInnerAppend(h)));
      this.__getControlChild !== void 0 && node.push(this.__getControlChild(h));
      return node;
    },
    __getControlContainer(h) {
      const node = [];
      this.prefix !== void 0 && this.prefix !== null && node.push(h('div', {
        staticClass: 'q-field__prefix no-pointer-events row items-center'
      }, [this.prefix]));
      if (this.hasShadow === true && this.__getShadowControl !== void 0) {
        node.push(this.__getShadowControl(h));
      }
      if (this.__getControl !== void 0) {
        node.push(this.__getControl(h));
      }
      // internal usage only:
      else if (this.$scopedSlots.rawControl !== void 0) {
        node.push(this.$scopedSlots.rawControl());
      } else if (this.$scopedSlots.control !== void 0) {
        node.push(h('div', {
          ref: 'target',
          staticClass: 'q-field__native row',
          attrs: {
            tabindex: -1,
            ...this.qAttrs,
            'data-autofocus': this.autofocus || void 0
          }
        }, this.$scopedSlots.control(this.controlSlotScope)));
      }
      this.hasLabel === true && node.push(h('div', {
        staticClass: 'q-field__label no-pointer-events absolute ellipsis',
        class: this.labelClass
      }, [Object(slot["c" /* slot */])(this, 'label', this.label)]));
      this.suffix !== void 0 && this.suffix !== null && node.push(h('div', {
        staticClass: 'q-field__suffix no-pointer-events row items-center'
      }, [this.suffix]));
      return node.concat(this.__getDefaultSlot !== void 0 ? this.__getDefaultSlot(h) : Object(slot["c" /* slot */])(this, 'default'));
    },
    __getBottom(h) {
      let msg, key;
      if (this.hasError === true) {
        key = 'q--slot-error';
        if (this.$scopedSlots.error !== void 0) {
          msg = this.$scopedSlots.error(this.bottomSlotScope);
        } else if (this.computedErrorMessage !== void 0) {
          msg = [h('div', {
            attrs: {
              role: 'alert'
            }
          }, [this.computedErrorMessage])];
          key = this.computedErrorMessage;
        }
      } else if (this.hideHint !== true || this.focused === true) {
        key = 'q--slot-hint';
        if (this.$scopedSlots.hint !== void 0) {
          msg = this.$scopedSlots.hint(this.bottomSlotScope);
        } else if (this.hint !== void 0) {
          msg = [h('div', [this.hint])];
          key = this.hint;
        }
      }
      const hasCounter = this.counter === true || this.$scopedSlots.counter !== void 0;
      if (this.hideBottomSpace === true && hasCounter === false && msg === void 0) {
        return;
      }
      const main = h('div', {
        key,
        staticClass: 'q-field__messages col'
      }, msg);
      return h('div', {
        staticClass: 'q-field__bottom row items-start q-field__bottom--' + (this.hideBottomSpace !== true ? 'animated' : 'stale'),
        on: {
          click: utils_event["i" /* prevent */]
        }
      }, [this.hideBottomSpace === true ? main : h('transition', {
        props: {
          name: 'q-transition--field-message'
        }
      }, [main]), hasCounter === true ? h('div', {
        staticClass: 'q-field__counter'
      }, this.$scopedSlots.counter !== void 0 ? this.$scopedSlots.counter() : [this.computedCounter]) : null]);
    },
    __getInnerAppendNode(h, key, content) {
      return content === null ? null : h('div', {
        staticClass: 'q-field__append q-field__marginal row no-wrap items-center q-anchor--skip',
        key
      }, content);
    },
    __onControlPopupShow(e) {
      e !== void 0 && Object(utils_event["k" /* stop */])(e);
      this.$emit('popup-show', e);
      this.hasPopupOpen = true;
      this.__onControlFocusin(e);
    },
    __onControlPopupHide(e) {
      e !== void 0 && Object(utils_event["k" /* stop */])(e);
      this.$emit('popup-hide', e);
      this.hasPopupOpen = false;
      this.__onControlFocusout(e);
    },
    __onControlFocusin(e) {
      clearTimeout(this.focusoutTimer);
      if (this.editable === true && this.focused === false) {
        this.focused = true;
        this.$emit('focus', e);
      }
    },
    __onControlFocusout(e, then) {
      clearTimeout(this.focusoutTimer);
      this.focusoutTimer = setTimeout(() => {
        if (document.hasFocus() === true && (this.hasPopupOpen === true || this.$refs === void 0 || this.$refs.control === void 0 || this.$refs.control.contains(document.activeElement) !== false)) {
          return;
        }
        if (this.focused === true) {
          this.focused = false;
          this.$emit('blur', e);
        }
        then !== void 0 && then();
      });
    },
    __clearValue(e) {
      // prevent activating the field but keep focus on desktop
      Object(utils_event["l" /* stopAndPrevent */])(e);
      if (this.$q.platform.is.mobile !== true) {
        const el = this.$refs.target || this.$el;
        el.focus();
      } else if (this.$el.contains(document.activeElement) === true) {
        document.activeElement.blur();
      }
      if (this.type === 'file') {
        // do not let focus be triggered
        // as it will make the native file dialog
        // appear for another selection
        this.$refs.input.value = null;
      }
      this.$emit('input', null);
      this.$emit('clear', this.value);
      this.$nextTick(() => {
        this.resetValidation();
        if (this.$q.platform.is.mobile !== true) {
          this.isDirty = false;
        }
      });
    },
    __emitValue(value) {
      this.$emit('input', value);
    }
  },
  render(h) {
    this.__onPreRender !== void 0 && this.__onPreRender();
    this.__onPostRender !== void 0 && this.$nextTick(this.__onPostRender);
    const attrs = this.__getControl === void 0 && this.$scopedSlots.control === void 0 ? {
      ...this.qAttrs,
      'data-autofocus': this.autofocus || void 0,
      ...this.attrs
    } : this.attrs;
    return h('label', {
      staticClass: 'q-field q-validation-component row no-wrap items-start',
      class: this.classes,
      attrs
    }, [this.$scopedSlots.before !== void 0 ? h('div', {
      staticClass: 'q-field__before q-field__marginal row no-wrap items-center',
      on: this.slotsEvents
    }, this.$scopedSlots.before()) : null, h('div', {
      staticClass: 'q-field__inner relative-position col self-stretch'
    }, [h('div', {
      ref: 'control',
      staticClass: 'q-field__control relative-position row no-wrap',
      class: this.contentClass,
      attrs: {
        tabindex: -1
      },
      on: this.controlEvents
    }, this.__getContent(h)), this.shouldRenderBottom === true ? this.__getBottom(h) : null]), this.$scopedSlots.after !== void 0 ? h('div', {
      staticClass: 'q-field__after q-field__marginal row no-wrap items-center',
      on: this.slotsEvents
    }, this.$scopedSlots.after()) : null]);
  },
  created() {
    this.__onPreRender !== void 0 && this.__onPreRender();
    this.slotsEvents = {
      click: utils_event["i" /* prevent */]
    };
    this.clearableEvents = {
      click: this.__clearValue
    };
    this.controlEvents = this.__getControlEvents !== void 0 ? this.__getControlEvents() : {
      focusin: this.__onControlFocusin,
      focusout: this.__onControlFocusout,
      'popup-show': this.__onControlPopupShow,
      'popup-hide': this.__onControlPopupHide
    };
  },
  mounted() {
    if (Platform["c" /* fromSSR */] === true && this.for === void 0) {
      this.targetUid = getTargetUid();
    }
    this.autofocus === true && this.focus();
  },
  activated() {
    if (this.shouldActivate !== true) {
      return;
    }
    this.autofocus === true && this.focus();
  },
  deactivated() {
    this.shouldActivate = true;
  },
  beforeDestroy() {
    clearTimeout(this.focusoutTimer);
  }
}));

/***/ }),

/***/ "1496":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a820");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a8d5");



const {
  passive
} = _utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* listenOpts */ "f"];
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QScrollObserver',
  props: {
    debounce: [String, Number],
    horizontal: Boolean,
    scrollTarget: {
      default: void 0
    }
  },
  render: _utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* noop */ "g"],
  // eslint-disable-line

  data() {
    return {
      pos: 0,
      dir: this.horizontal === true ? 'right' : 'down',
      dirChanged: false,
      dirChangePos: 0
    };
  },
  watch: {
    scrollTarget() {
      this.__unconfigureScrollTarget();
      this.__configureScrollTarget();
    },
    '$q.lang.rtl'() {
      this.__emit();
    }
  },
  methods: {
    getPosition() {
      return {
        position: this.pos,
        direction: this.dir,
        directionChanged: this.dirChanged,
        inflexionPosition: this.dirChangePos
      };
    },
    trigger(immediately) {
      if (immediately === true || this.debounce === 0 || this.debounce === '0') {
        this.__emit();
      } else if (this.clearTimer === void 0) {
        const [timer, fn] = this.debounce ? [setTimeout(this.__emit, this.debounce), clearTimeout] : [requestAnimationFrame(this.__emit), cancelAnimationFrame];
        this.clearTimer = () => {
          fn(timer);
          this.clearTimer = void 0;
        };
      }
    },
    __emit() {
      this.clearTimer !== void 0 && this.clearTimer();
      const fn = this.horizontal === true ? _utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* getHorizontalScrollPosition */ "a"] : _utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* getScrollPosition */ "c"];
      const pos = Math.max(0, fn(this.__scrollTarget)),
        delta = pos - this.pos,
        dir = this.horizontal === true ? delta < 0 ? 'left' : 'right' : delta < 0 ? 'up' : 'down';
      this.dirChanged = this.dir !== dir;
      if (this.dirChanged) {
        this.dir = dir;
        this.dirChangePos = this.pos;
      }
      this.pos = pos;
      this.$emit('scroll', this.getPosition());
    },
    __configureScrollTarget() {
      this.__scrollTarget = Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* getScrollTarget */ "d"])(this.$el.parentNode, this.scrollTarget);
      this.__scrollTarget.addEventListener('scroll', this.trigger, passive);
      this.trigger(true);
    },
    __unconfigureScrollTarget() {
      if (this.__scrollTarget !== void 0) {
        this.__scrollTarget.removeEventListener('scroll', this.trigger, passive);
        this.__scrollTarget = void 0;
      }
    }
  },
  mounted() {
    this.__configureScrollTarget();
  },
  beforeDestroy() {
    this.clearTimer !== void 0 && this.clearTimer();
    this.__unconfigureScrollTarget();
  }
}));

/***/ }),

/***/ "15cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_align_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4200");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("feae");




/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QCardActions',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_align_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    vertical: Boolean
  },
  computed: {
    classes() {
      return `q-card__actions--${this.vertical === true ? 'vert column' : 'horiz row'} ${this.alignClass}`;
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-card__actions',
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_3__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "1919":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a170");
/* harmony import */ var _mixins_checkbox_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d84a");



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QCheckbox',
  mixins: [_mixins_checkbox_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]],
  computed: {
    computedIcon() {
      return this.isTrue === true ? this.checkedIcon : this.isIndeterminate === true ? this.indeterminateIcon : this.uncheckedIcon;
    }
  },
  methods: {
    __getInner(h) {
      return this.computedIcon !== void 0 ? [h('div', {
        key: 'icon',
        staticClass: 'q-checkbox__icon-container absolute-full flex flex-center no-wrap'
      }, [h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
        staticClass: 'q-checkbox__icon',
        props: {
          name: this.computedIcon
        }
      })])] : [h('div', {
        key: 'svg',
        staticClass: 'q-checkbox__bg absolute'
      }, [h('svg', {
        staticClass: 'q-checkbox__svg fit absolute-full',
        attrs: {
          focusable: 'false' /* needed for IE11 */,
          viewBox: '0 0 24 24'
        }
      }, [h('path', {
        staticClass: 'q-checkbox__truthy',
        attrs: {
          fill: 'none',
          d: 'M1.73,12.91 8.1,19.28 22.79,4.59'
        }
      }), h('path', {
        staticClass: 'q-checkbox__indet',
        attrs: {
          d: 'M4,14H20V10H4'
        }
      })])])];
    }
  },
  created() {
    this.type = 'checkbox';
  }
}));

/***/ }),

/***/ "1dd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");
/* harmony import */ var _listeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a50a");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [_listeners_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    value: {
      type: Boolean,
      default: void 0
    }
  },
  data() {
    return {
      showing: false
    };
  },
  watch: {
    value(val) {
      this.__processModelChange(val);
    },
    $route() {
      this.hideOnRouteChange === true && this.showing === true && this.hide();
    }
  },
  methods: {
    toggle(evt) {
      this[this.showing === true ? 'hide' : 'show'](evt);
    },
    show(evt) {
      if (this.disable === true || this.__showCondition !== void 0 && this.__showCondition(evt) !== true) {
        return;
      }
      if (this.qListeners.input !== void 0 && _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === false) {
        this.$emit('input', true);
        this.payload = evt;
        this.$nextTick(() => {
          if (this.payload === evt) {
            this.payload = void 0;
          }
        });
      }
      if (this.value === void 0 || this.qListeners.input === void 0 || _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === true) {
        this.__processShow(evt);
      }
    },
    __processShow(evt) {
      if (this.showing === true) {
        return;
      }

      // need to call it before setting showing to true
      // in order to not ruin the animation
      this.__preparePortal !== void 0 && this.__preparePortal();
      this.showing = true;
      this.$emit('before-show', evt);
      if (this.__show !== void 0) {
        this.__show(evt);
      } else {
        this.$emit('show', evt);
      }
    },
    hide(evt) {
      if (this.disable === true) {
        return;
      }
      if (this.qListeners.input !== void 0 && _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === false) {
        this.$emit('input', false);
        this.payload = evt;
        this.$nextTick(() => {
          if (this.payload === evt) {
            this.payload = void 0;
          }
        });
      }
      if (this.value === void 0 || this.qListeners.input === void 0 || _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === true) {
        this.__processHide(evt);
      }
    },
    __processHide(evt) {
      if (this.showing === false) {
        return;
      }
      this.showing = false;
      this.$emit('before-hide', evt);
      if (this.__hide !== void 0) {
        this.__hide(evt);
      } else {
        this.$emit('hide', evt);
      }
    },
    __processModelChange(val) {
      if (this.disable === true && val === true) {
        this.qListeners.input !== void 0 && this.$emit('input', false);
      } else if (val === true !== this.showing) {
        this[`__process${val === true ? 'Show' : 'Hide'}`](this.payload);
      }
    }
  }
});

/***/ }),

/***/ "1de7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _directives_Ripple_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1f73");

/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Ripple: _directives_Ripple_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]
  },
  props: {
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  }
});

/***/ }),

/***/ "1f73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d818");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("116d");
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ad69");
/* harmony import */ var _utils_throttle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("3867");
/* harmony import */ var _install_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("63bb");






function showRipple(evt, el, ctx, forceCenter) {
  ctx.modifiers.stop === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* stop */ "k"])(evt);
  const color = ctx.modifiers.color;
  let center = ctx.modifiers.center;
  center = center === true || forceCenter === true;
  const node = document.createElement('span'),
    innerNode = document.createElement('span'),
    pos = Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* position */ "h"])(evt),
    {
      left,
      top,
      width,
      height
    } = el.getBoundingClientRect(),
    diameter = Math.sqrt(width * width + height * height),
    radius = diameter / 2,
    centerX = `${(width - diameter) / 2}px`,
    x = center ? centerX : `${pos.left - left - radius}px`,
    centerY = `${(height - diameter) / 2}px`,
    y = center ? centerY : `${pos.top - top - radius}px`;
  innerNode.className = 'q-ripple__inner';
  Object(_utils_dom_js__WEBPACK_IMPORTED_MODULE_0__[/* css */ "b"])(innerNode, {
    height: `${diameter}px`,
    width: `${diameter}px`,
    transform: `translate3d(${x},${y},0) scale3d(.2,.2,1)`,
    opacity: 0
  });
  node.className = `q-ripple${color ? ' text-' + color : ''}`;
  node.setAttribute('dir', 'ltr');
  node.appendChild(innerNode);
  el.appendChild(node);
  const abort = () => {
    node.remove();
    clearTimeout(timer);
  };
  ctx.abort.push(abort);
  let timer = setTimeout(() => {
    innerNode.classList.add('q-ripple__inner--enter');
    innerNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
    innerNode.style.opacity = 0.2;
    timer = setTimeout(() => {
      innerNode.classList.remove('q-ripple__inner--enter');
      innerNode.classList.add('q-ripple__inner--leave');
      innerNode.style.opacity = 0;
      timer = setTimeout(() => {
        node.remove();
        ctx.abort.splice(ctx.abort.indexOf(abort), 1);
      }, 275);
    }, 250);
  }, 50);
}
function updateModifiers(ctx, {
  modifiers,
  value,
  arg
}) {
  const cfg = Object.assign({}, _install_js__WEBPACK_IMPORTED_MODULE_5__[/* $q */ "a"].config.ripple, modifiers, value);
  ctx.modifiers = {
    early: cfg.early === true,
    stop: cfg.stop === true,
    center: cfg.center === true,
    color: cfg.color || arg,
    keyCodes: [].concat(cfg.keyCodes || 13)
  };
}
function destroy(el) {
  const ctx = el.__qripple;
  if (ctx !== void 0) {
    ctx.abort.forEach(fn => {
      fn();
    });
    Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* cleanEvt */ "b"])(ctx, 'main');
    delete el._qripple;
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ripple',
  inserted(el, binding) {
    if (el.__qripple !== void 0) {
      destroy(el);
      el.__qripple_destroyed = true;
    }
    const ctx = {
      enabled: binding.value !== false,
      modifiers: {},
      abort: [],
      start(evt) {
        if (ctx.enabled === true && evt.qSkipRipple !== true && (
        // on ENTER in form IE emits a PointerEvent with negative client cordinates
        _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_3__[/* client */ "a"].is.ie !== true || evt.clientX >= 0) && evt.type === (ctx.modifiers.early === true ? 'pointerdown' : 'click')) {
          showRipple(evt, el, ctx, evt.qKeyEvent === true);
        }
      },
      keystart: Object(_utils_throttle_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(evt => {
        if (ctx.enabled === true && evt.qSkipRipple !== true && Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_2__[/* isKeyCode */ "a"])(evt, ctx.modifiers.keyCodes) === true && evt.type === `key${ctx.modifiers.early === true ? 'down' : 'up'}`) {
          showRipple(evt, el, ctx, true);
        }
      }, 300)
    };
    updateModifiers(ctx, binding);
    el.__qripple = ctx;
    Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* addEvt */ "a"])(ctx, 'main', [[el, 'pointerdown', 'start', 'passive'], [el, 'click', 'start', 'passive'], [el, 'keydown', 'keystart', 'passive'], [el, 'keyup', 'keystart', 'passive']]);
  },
  update(el, binding) {
    const ctx = el.__qripple;
    if (ctx !== void 0 && binding.oldValue !== binding.value) {
      ctx.enabled = binding.value !== false;
      if (ctx.enabled === true && Object(binding.value) === binding.value) {
        updateModifiers(ctx, binding);
      }
    }
  },
  unbind(el) {
    if (el.__qripple_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__qripple_destroyed;
    }
  }
});

/***/ }),

/***/ "2747":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _resize_observer_QResizeObserver_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6e27");
/* harmony import */ var _scroll_observer_QScrollObserver_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1496");
/* harmony import */ var _directives_TouchPan_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("f452");
/* harmony import */ var _utils_format_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("536b");
/* harmony import */ var _utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a820");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("feae");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("479b");
/* harmony import */ var _utils_debounce_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("c3c5");
/* harmony import */ var _mixins_dark_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("a583");
/* harmony import */ var _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ae5c");











const getMinThumbSize = size => size >= 250 ? 50 : Math.ceil(size / 5);
const axisList = ['vertical', 'horizontal'];
const dirProps = {
  vertical: {
    offset: 'offsetY',
    scroll: 'scrollTop',
    dir: 'down',
    dist: 'y'
  },
  horizontal: {
    offset: 'offsetX',
    scroll: 'scrollLeft',
    dir: 'right',
    dist: 'x'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QScrollArea',
  mixins: [_mixins_dark_js__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"]],
  directives: {
    TouchPan: _directives_TouchPan_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]
  },
  props: {
    thumbStyle: Object,
    verticalThumbStyle: Object,
    horizontalThumbStyle: Object,
    barStyle: [Array, String, Object],
    verticalBarStyle: [Array, String, Object],
    horizontalBarStyle: [Array, String, Object],
    contentStyle: [Array, String, Object],
    contentActiveStyle: [Array, String, Object],
    delay: {
      type: [String, Number],
      default: 1000
    },
    visible: {
      type: Boolean,
      default: null
    },
    horizontal: Boolean,
    tabindex: [String, Number]
  },
  data() {
    return {
      // state management
      tempShowing: false,
      panning: false,
      hover: false,
      // other...
      container: {
        vertical: 0,
        horizontal: 0
      },
      scroll: {
        vertical: {
          position: 0,
          size: 0
        },
        horizontal: {
          position: 0,
          size: 0
        }
      }
    };
  },
  computed: {
    classes() {
      return 'q-scrollarea' + (this.isDark === true ? ' q-scrollarea--dark' : '');
    },
    verticalScrollPercentage() {
      const diff = this.scroll.vertical.size - this.container.vertical;
      if (diff <= 0) {
        return 0;
      }
      const p = Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_4__[/* between */ "a"])(this.scroll.vertical.position / diff, 0, 1);
      return Math.round(p * 10000) / 10000;
    },
    horizontalScrollPercentage() {
      const diff = this.scroll.horizontal.size - this.container.horizontal;
      if (diff <= 0) {
        return 0;
      }
      const p = Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_4__[/* between */ "a"])(Math.abs(this.scroll.horizontal.position) / diff, 0, 1);
      return Math.round(p * 10000) / 10000;
    },
    verticalThumbHidden() {
      return (this.visible === null ? this.hover : this.visible) !== true && this.tempShowing === false && this.panning === false || this.scroll.vertical.size <= this.container.vertical + 1;
    },
    horizontalThumbHidden() {
      return (this.visible === null ? this.hover : this.visible) !== true && this.tempShowing === false && this.panning === false || this.scroll.horizontal.size <= this.container.horizontal + 1;
    },
    verticalThumbStart() {
      return this.verticalScrollPercentage * (this.container.vertical - this.verticalThumbSize);
    },
    horizontalThumbStart() {
      return this.horizontalScrollPercentage * (this.container.horizontal - this.horizontalThumbSize);
    },
    verticalThumbSize() {
      return Math.round(Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_4__[/* between */ "a"])(this.container.vertical * this.container.vertical / this.scroll.vertical.size, getMinThumbSize(this.container.vertical), this.container.vertical));
    },
    horizontalThumbSize() {
      return Math.round(Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_4__[/* between */ "a"])(this.container.horizontal * this.container.horizontal / this.scroll.horizontal.size, getMinThumbSize(this.container.horizontal), this.container.horizontal));
    },
    verticalStyle() {
      return {
        ...this.thumbStyle,
        ...this.verticalThumbStyle,
        top: `${this.verticalThumbStart}px`,
        height: `${this.verticalThumbSize}px`
      };
    },
    horizontalStyle() {
      return {
        ...this.thumbStyle,
        ...this.horizontalThumbStyle,
        [this.$q.lang.rtl === true ? 'right' : 'left']: `${this.horizontalThumbStart}px`,
        width: `${this.horizontalThumbSize}px`
      };
    },
    verticalThumbClass() {
      return 'q-scrollarea__thumb q-scrollarea__thumb--v absolute-right' + (this.verticalThumbHidden === true ? ' q-scrollarea__thumb--invisible' : '');
    },
    horizontalThumbClass() {
      return 'q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom' + (this.horizontalThumbHidden === true ? ' q-scrollarea__thumb--invisible' : '');
    },
    verticalBarClass() {
      return 'q-scrollarea__bar q-scrollarea__bar--v absolute-right' + (this.verticalThumbHidden === true ? ' q-scrollarea__bar--invisible' : '');
    },
    horizontalBarClass() {
      return 'q-scrollarea__bar q-scrollarea__bar--h absolute-bottom' + (this.horizontalThumbHidden === true ? ' q-scrollarea__bar--invisible' : '');
    },
    scrollComputed() {
      return {
        vertical: {
          ...this.scroll.vertical,
          percentage: this.verticalScrollPercentage,
          thumbHidden: this.verticalThumbHidden,
          thumbStart: this.verticalThumbStart,
          thumbSize: this.verticalThumbSize,
          style: this.verticalStyle,
          thumbClass: this.verticalThumbClass,
          barClass: this.verticalBarClass
        },
        horizontal: {
          ...this.scroll.horizontal,
          percentage: this.horizontalScrollPercentage,
          thumbHidden: this.horizontalThumbHidden,
          thumbStart: this.horizontalThumbStart,
          thumbSize: this.horizontalThumbSize,
          style: this.horizontalStyle,
          thumbClass: this.horizontalThumbClass,
          barClass: this.horizontalBarClass
        }
      };
    },
    mainStyle() {
      return this.verticalThumbHidden === true && this.horizontalThumbHidden === true ? this.contentStyle : this.contentActiveStyle;
    },
    verticalThumbDirectives() {
      return [{
        name: 'touch-pan',
        modifiers: {
          vertical: true,
          prevent: true,
          mouse: true,
          mouseAllDir: true
        },
        value: e => {
          this.__panThumb(e, 'vertical');
        }
      }];
    },
    horizontalThumbDirectives() {
      return [{
        name: 'touch-pan',
        modifiers: {
          horizontal: true,
          prevent: true,
          mouse: true,
          mouseAllDir: true
        },
        value: e => {
          this.__panThumb(e, 'horizontal');
        }
      }];
    },
    scrollAttrs() {
      if (this.tabindex !== void 0) {
        return {
          tabindex: this.tabindex
        };
      }
    }
  },
  watch: {
    '$q.lang.rtl'(rtl) {
      this.setScrollPosition('horizontal', Math.abs(this.scroll.horizontal.position) * (rtl === true ? -1 : 1));
    }
  },
  methods: {
    getScrollTarget() {
      return this.$refs.target;
    },
    getScroll() {
      const info = {};
      axisList.forEach(axis => {
        const data = this.scrollComputed[axis];
        info[axis + 'Position'] = data.position;
        info[axis + 'Percentage'] = data.percentage;
        info[axis + 'Size'] = data.size;
        info[axis + 'ContainerSize'] = this.container[axis];
      });
      return info;
    },
    getScrollPosition(axis) {
      if (axis === 'both') {
        return {
          top: this.scroll.vertical.position,
          left: this.scroll.horizontal.position
        };
      }
      if (axisList.includes(axis) !== true) {
        axis = this.horizontal === true ? 'horizontal' : 'vertical';
      }
      return this.scroll[axis].position;
    },
    getScrollPercentage(axis) {
      if (axis === 'both') {
        return {
          top: this.verticalScrollPercentage,
          left: this.horizontalScrollPercentage
        };
      }
      if (axisList.includes(axis) !== true) {
        axis = this.horizontal === true ? 'horizontal' : 'vertical';
      }
      return this[`${axis}ScrollPercentage`];
    },
    setScrollPosition(axis, offset, duration) {
      if (axisList.includes(axis) === false) {
        if (isNaN(axis) === true) {
          console.error('[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)');
          return;
        }
        [axis, offset, duration] = [this.horizontal === true ? 'horizontal' : 'vertical', axis, offset];
      }
      const fn = axis === 'vertical' ? _utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__[/* setVerticalScrollPosition */ "k"] : _utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__[/* setHorizontalScrollPosition */ "i"];
      fn(this.$refs.target, offset, duration);
    },
    setScrollPercentage(axis, percentage, duration) {
      if (axisList.includes(axis) === false) {
        if (isNaN(axis) === true) {
          console.error('[QScrollArea]: wrong first param of setScrollPercentage (vertical/horizontal)');
          return;
        }
        [axis, percentage, duration] = [this.horizontal === true ? 'horizontal' : 'vertical', axis, percentage];
      }
      this.setScrollPosition(axis, percentage * (this.scroll[axis].size - this.container[axis]) * (axis === 'horizontal' && this.$q.lang.rtl === true ? -1 : 1), duration);
    },
    __updateContainer({
      height,
      width
    }) {
      let change = false;
      if (this.container.vertical !== height) {
        this.container.vertical = height;
        change = true;
      }
      if (this.container.horizontal !== width) {
        this.container.horizontal = width;
        change = true;
      }
      change === true && this.__startTimer();
    },
    __updateVerticalScroll({
      position
    }) {
      if (this.scroll.vertical.position !== position) {
        this.scroll.vertical.position = position;
        this.__startTimer();
      }
    },
    __updateHorizontalScroll({
      position
    }) {
      if (this.scroll.horizontal.position !== position) {
        this.scroll.horizontal.position = position;
        this.__startTimer();
      }
    },
    __updateScrollSize({
      height,
      width
    }) {
      let change = false;
      if (this.scroll.horizontal.size !== width) {
        this.scroll.horizontal.size = width;
        change = true;
      }
      if (this.scroll.vertical.size !== height) {
        this.scroll.vertical.size = height;
        change = true;
      }
      change === true && this.__startTimer();
    },
    __panThumb(e, axis) {
      const data = this.scrollComputed[axis];
      if (e.isFinal === true) {
        if (this.panning !== true) {
          return;
        }
        this.panning = false;
      } else if (e.isFirst === true) {
        if (data.thumbHidden === true) {
          return;
        }
        this.refPos = data.position;
        this.panning = true;
      } else if (this.panning !== true) {
        return;
      }
      const dProp = dirProps[axis];
      const containerSize = this.container[axis];
      const multiplier = (data.size - containerSize) / (containerSize - data.thumbSize);
      const distance = e.distance[dProp.dist];
      const pos = this.refPos + (e.direction === dProp.dir ? 1 : -1) * distance * multiplier;
      this.__setScroll(pos, axis);
    },
    __mouseDown(evt, axis) {
      const data = this.scrollComputed[axis];
      if (data.thumbHidden !== true) {
        const offset = evt[dirProps[axis].offset];
        if (offset < data.thumbStart || offset > data.thumbStart + data.thumbSize) {
          const pos = offset - data.thumbSize / 2;
          this.__setScroll(pos / this.container[axis] * data.size, axis);
        }
        const ref = axis === 'vertical' ? this.$refs.verticalThumb : this.$refs.horizontalThumb;
        // activate thumb pan
        if (ref !== void 0) {
          ref.dispatchEvent(new MouseEvent(evt.type, evt));
        }
      }
    },
    __verticalMouseDown(evt) {
      this.__mouseDown(evt, 'vertical');
    },
    __horizontalMouseDown(evt) {
      this.__mouseDown(evt, 'horizontal');
    },
    __startTimer() {
      if (this.tempShowing === true) {
        clearTimeout(this.timer);
      } else {
        this.tempShowing = true;
      }
      this.timer = setTimeout(() => {
        this.tempShowing = false;
      }, this.delay);
      this.$listeners.scroll !== void 0 && this.__emitScroll();
    },
    __setScroll(offset, axis) {
      this.$refs.target[dirProps[axis].scroll] = offset;
    },
    __mouseEnter() {
      this.hover = true;
    },
    __mouseLeave() {
      this.hover = false;
    }
  },
  render(h) {
    return h('div', {
      class: this.classes,
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'desk', {
        mouseenter: this.__mouseEnter,
        mouseleave: this.__mouseLeave
      })
    }, [h('div', {
      ref: 'target',
      staticClass: 'q-scrollarea__container scroll relative-position fit hide-scrollbar',
      attrs: this.scrollAttrs
    }, [h('div', {
      staticClass: 'q-scrollarea__content absolute',
      style: this.mainStyle
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_6__[/* mergeSlot */ "a"])([h(_resize_observer_QResizeObserver_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
      props: {
        debounce: 0
      },
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'resizeIn', {
        resize: this.__updateScrollSize
      })
    })], this, 'default')), h(_scroll_observer_QScrollObserver_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'scrollV', {
        scroll: this.__updateVerticalScroll
      })
    }), h(_scroll_observer_QScrollObserver_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
      props: {
        horizontal: true
      },
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'scrollH', {
        scroll: this.__updateHorizontalScroll
      })
    })]), h(_resize_observer_QResizeObserver_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
      props: {
        debounce: 0
      },
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'resizeOut', {
        resize: this.__updateContainer
      })
    }), h('div', {
      class: this.verticalBarClass,
      style: [this.barStyle, this.verticalBarStyle],
      attrs: _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__[/* ariaHidden */ "a"],
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'barV', {
        mousedown: this.__verticalMouseDown
      })
    }), h('div', {
      class: this.horizontalBarClass,
      style: [this.barStyle, this.horizontalBarStyle],
      attrs: _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__[/* ariaHidden */ "a"],
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'barH', {
        mousedown: this.__horizontalMouseDown
      })
    }), h('div', {
      ref: 'verticalThumb',
      class: this.verticalThumbClass,
      style: this.verticalStyle,
      attrs: _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__[/* ariaHidden */ "a"],
      directives: this.verticalThumbDirectives
    }), h('div', {
      ref: 'horizontalThumb',
      class: this.horizontalThumbClass,
      style: this.horizontalStyle,
      attrs: _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__[/* ariaHidden */ "a"],
      directives: this.horizontalThumbDirectives
    })]);
  },
  created() {
    // we have lots of listeners, so
    // ensure we're not emitting same info
    // multiple times
    this.__emitScroll = Object(_utils_debounce_js__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(() => {
      const info = this.getScroll();
      info.ref = this;
      this.$emit('scroll', info);
    }, 0);
  },
  activated() {
    if (this.__scrollPosition === void 0) {
      return;
    }
    const scrollTarget = this.getScrollTarget();
    if (scrollTarget !== void 0) {
      Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__[/* setHorizontalScrollPosition */ "i"])(scrollTarget, this.__scrollPosition.left);
      Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__[/* setVerticalScrollPosition */ "k"])(scrollTarget, this.__scrollPosition.top);
    }
  },
  deactivated() {
    this.__scrollPosition = this.getScrollPosition('both');
  },
  beforeDestroy() {
    this.__emitScroll.cancel();
    clearTimeout(this.timer);
  }
}));

/***/ }),

/***/ "2750":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFieldMixin; });
/* harmony default export */ __webpack_exports__["b"] = ({
  props: {
    name: String
  },
  computed: {
    formAttrs() {
      return {
        type: 'hidden',
        name: this.name,
        value: this.value
      };
    }
  },
  methods: {
    __injectFormInput(child, action, className) {
      child[action](this.$createElement('input', {
        staticClass: 'hidden',
        class: className,
        attrs: this.formAttrs,
        domProps: this.formDomProps
      }));
    }
  }
});
const FormFieldMixin = {
  props: {
    name: String
  },
  computed: {
    nameProp() {
      return this.name || this.for;
    }
  }
};

/***/ }),

/***/ "2767":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectRenderer = function () {
	function ObjectRenderer(object, encodings, options) {
		_classCallCheck(this, ObjectRenderer);

		this.object = object;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(ObjectRenderer, [{
		key: "render",
		value: function render() {
			this.object.encodings = this.encodings;
		}
	}]);

	return ObjectRenderer;
}();

exports.default = ObjectRenderer;

/***/ }),

/***/ "2a4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ en_us; });

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: /workspace/node_modules/quasar/lang/en-us.js
/* harmony default export */ var en_us = ({
  isoName: 'en-us',
  nativeName: 'English (US)',
  label: {
    clear: 'Clear',
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    set: 'Set',
    select: 'Select',
    reset: 'Reset',
    remove: 'Remove',
    update: 'Update',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    expand: function (label) {
      return label ? `Expand "${label}"` : 'Expand';
    },
    collapse: function (label) {
      return label ? `Collapse "${label}"` : 'Collapse';
    }
  },
  date: {
    days: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    daysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    firstDayOfWeek: 0,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: false,
    pluralDay: 'days'
  },
  table: {
    noData: 'No data available',
    noResults: 'No matching records found',
    loading: 'Loading...',
    selectedRecords: function (rows) {
      return rows === 1 ? '1 record selected.' : (rows === 0 ? 'No' : rows) + ' records selected.';
    },
    recordsPerPage: 'Records per page:',
    allRows: 'All',
    pagination: function (start, end, total) {
      return start + '-' + end + ' of ' + total;
    },
    columns: 'Columns'
  },
  editor: {
    url: 'URL',
    bold: 'Bold',
    italic: 'Italic',
    strikethrough: 'Strikethrough',
    underline: 'Underline',
    unorderedList: 'Unordered List',
    orderedList: 'Ordered List',
    subscript: 'Subscript',
    superscript: 'Superscript',
    hyperlink: 'Hyperlink',
    toggleFullscreen: 'Toggle Fullscreen',
    quote: 'Quote',
    left: 'Left align',
    center: 'Center align',
    right: 'Right align',
    justify: 'Justify align',
    print: 'Print',
    outdent: 'Decrease indentation',
    indent: 'Increase indentation',
    removeFormat: 'Remove formatting',
    formatting: 'Formatting',
    fontSize: 'Font Size',
    align: 'Align',
    hr: 'Insert Horizontal Rule',
    undo: 'Undo',
    redo: 'Redo',
    heading1: 'Heading 1',
    heading2: 'Heading 2',
    heading3: 'Heading 3',
    heading4: 'Heading 4',
    heading5: 'Heading 5',
    heading6: 'Heading 6',
    paragraph: 'Paragraph',
    code: 'Code',
    size1: 'Very small',
    size2: 'A bit small',
    size3: 'Normal',
    size4: 'Medium-large',
    size5: 'Big',
    size6: 'Very big',
    size7: 'Maximum',
    defaultFont: 'Default Font',
    viewSource: 'View Source'
  },
  tree: {
    noNodes: 'No nodes available',
    noResults: 'No matching nodes found'
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Platform.js
var Platform = __webpack_require__("ad69");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/lang.js



function getLocale() {
  if (Platform["e" /* isSSR */] === true) {
    return;
  }
  const val = navigator.language || navigator.languages[0] || navigator.browserLanguage || navigator.userLanguage || navigator.systemLanguage;
  if (val) {
    return val.toLowerCase();
  }
}
const Plugin = {
  getLocale,
  install($q, queues, lang) {
    const initialLang = lang || en_us;
    this.set = (langObject = en_us, ssrContext) => {
      const lang = {
        ...langObject,
        rtl: langObject.rtl === true,
        getLocale
      };
      if (Platform["e" /* isSSR */] === true) {
        if (ssrContext === void 0) {
          console.error('SSR ERROR: second param required: Quasar.lang.set(lang, ssrContext)');
          return;
        }
        const dir = lang.rtl === true ? 'rtl' : 'ltr';
        const attrs = `lang=${lang.isoName} dir=${dir}`;
        lang.set = ssrContext.$q.lang.set;
        ssrContext.Q_HTML_ATTRS = ssrContext.Q_PREV_LANG !== void 0 ? ssrContext.Q_HTML_ATTRS.replace(ssrContext.Q_PREV_LANG, attrs) : attrs;
        ssrContext.Q_PREV_LANG = attrs;
        ssrContext.$q.lang = lang;
      } else {
        if (Platform["c" /* fromSSR */] === false) {
          const el = document.documentElement;
          el.setAttribute('dir', lang.rtl === true ? 'rtl' : 'ltr');
          el.setAttribute('lang', lang.isoName);
        }
        lang.set = this.set;
        $q.lang = this.props = lang;
        this.isoName = lang.isoName;
        this.nativeName = lang.nativeName;
      }
    };
    if (Platform["e" /* isSSR */] === true) {
      queues.server.push((q, ctx) => {
        q.lang = {};
        q.lang.set = langObject => {
          this.set(langObject, ctx.ssr);
        };
        q.lang.set(initialLang);
      });
      this.isoName = initialLang.isoName;
      this.nativeName = initialLang.nativeName;
      this.props = initialLang;
    } else {
      external_vue_default.a.util.defineReactive($q, 'lang', {});
      this.set(initialLang);
    }
  }
};
/* harmony default export */ var src_lang = __webpack_exports__["a"] = (Plugin);


/***/ }),

/***/ "2b1e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Barcode = function Barcode(data, options) {
	_classCallCheck(this, Barcode);

	this.data = data;
	this.text = options.text || data;
	this.options = options;
};

exports.default = Barcode;

/***/ }),

/***/ "2b36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("feae");



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QPageContainer',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  inject: {
    layout: {
      default() {
        console.error('QPageContainer needs to be child of QLayout');
      }
    }
  },
  provide: {
    pageContainer: true
  },
  computed: {
    style() {
      const css = {};
      if (this.layout.header.space === true) {
        css.paddingTop = `${this.layout.header.size}px`;
      }
      if (this.layout.right.space === true) {
        css[`padding${this.$q.lang.rtl === true ? 'Left' : 'Right'}`] = `${this.layout.right.size}px`;
      }
      if (this.layout.footer.space === true) {
        css.paddingBottom = `${this.layout.footer.size}px`;
      }
      if (this.layout.left.space === true) {
        css[`padding${this.$q.lang.rtl === true ? 'Right' : 'Left'}`] = `${this.layout.left.size}px`;
      }
      return css;
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-page-container',
      style: this.style,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "2b6e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".invalid-class-name.q-field--highlighted .q-field__control:after,.invalid-class-name.q-field--highlighted .q-field__control:before,.invalid-class-name.q-field--highlighted .q-field__control:hover:after,.invalid-class-name.q-field--highlighted .q-field__control:hover:before,.invalid-class-name .q-field__control:after,.invalid-class-name .q-field__control:before{border:1px solid red}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2b74":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".rounded[data-v-1311674c]{border-radius:30%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2c64":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _constants = __webpack_require__("f120");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is the master class,
// it does require the start code to be included in the string
var CODE128 = function (_Barcode) {
	_inherits(CODE128, _Barcode);

	function CODE128(data, options) {
		_classCallCheck(this, CODE128);

		// Get array of ascii codes from data
		var _this = _possibleConstructorReturn(this, (CODE128.__proto__ || Object.getPrototypeOf(CODE128)).call(this, data.substring(1), options));

		_this.bytes = data.split('').map(function (char) {
			return char.charCodeAt(0);
		});
		return _this;
	}

	_createClass(CODE128, [{
		key: 'valid',
		value: function valid() {
			// ASCII value ranges 0-127, 200-211
			return (/^[\x00-\x7F\xC8-\xD3]+$/.test(this.data)
			);
		}

		// The public encoding function

	}, {
		key: 'encode',
		value: function encode() {
			var bytes = this.bytes;
			// Remove the start code from the bytes and set its index
			var startIndex = bytes.shift() - 105;
			// Get start set by index
			var startSet = _constants.SET_BY_CODE[startIndex];

			if (startSet === undefined) {
				throw new RangeError('The encoding does not start with a start character.');
			}

			if (this.shouldEncodeAsEan128() === true) {
				bytes.unshift(_constants.FNC1);
			}

			// Start encode with the right type
			var encodingResult = CODE128.next(bytes, 1, startSet);

			return {
				text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, '') : this.text,
				data:
				// Add the start bits
				CODE128.getBar(startIndex) +
				// Add the encoded bits
				encodingResult.result +
				// Add the checksum
				CODE128.getBar((encodingResult.checksum + startIndex) % _constants.MODULO) +
				// Add the end bits
				CODE128.getBar(_constants.STOP)
			};
		}

		// GS1-128/EAN-128

	}, {
		key: 'shouldEncodeAsEan128',
		value: function shouldEncodeAsEan128() {
			var isEAN128 = this.options.ean128 || false;
			if (typeof isEAN128 === 'string') {
				isEAN128 = isEAN128.toLowerCase() === 'true';
			}
			return isEAN128;
		}

		// Get a bar symbol by index

	}], [{
		key: 'getBar',
		value: function getBar(index) {
			return _constants.BARS[index] ? _constants.BARS[index].toString() : '';
		}

		// Correct an index by a set and shift it from the bytes array

	}, {
		key: 'correctIndex',
		value: function correctIndex(bytes, set) {
			if (set === _constants.SET_A) {
				var charCode = bytes.shift();
				return charCode < 32 ? charCode + 64 : charCode - 32;
			} else if (set === _constants.SET_B) {
				return bytes.shift() - 32;
			} else {
				return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
			}
		}
	}, {
		key: 'next',
		value: function next(bytes, pos, set) {
			if (!bytes.length) {
				return { result: '', checksum: 0 };
			}

			var nextCode = void 0,
			    index = void 0;

			// Special characters
			if (bytes[0] >= 200) {
				index = bytes.shift() - 105;
				var nextSet = _constants.SWAP[index];

				// Swap to other set
				if (nextSet !== undefined) {
					nextCode = CODE128.next(bytes, pos + 1, nextSet);
				}
				// Continue on current set but encode a special character
				else {
						// Shift
						if ((set === _constants.SET_A || set === _constants.SET_B) && index === _constants.SHIFT) {
							// Convert the next character so that is encoded correctly
							bytes[0] = set === _constants.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
						}
						nextCode = CODE128.next(bytes, pos + 1, set);
					}
			}
			// Continue encoding
			else {
					index = CODE128.correctIndex(bytes, set);
					nextCode = CODE128.next(bytes, pos + 1, set);
				}

			// Get the correct binary encoding and calculate the weight
			var enc = CODE128.getBar(index);
			var weight = index * pos;

			return {
				result: enc + nextCode.result,
				checksum: weight + nextCode.checksum
			};
		}
	}]);

	return CODE128;
}(_Barcode3.default);

exports.default = CODE128;

/***/ }),

/***/ "2ce7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__("2c64");

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__("f120");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128C = function (_CODE) {
	_inherits(CODE128C, _CODE);

	function CODE128C(string, options) {
		_classCallCheck(this, CODE128C);

		return _possibleConstructorReturn(this, (CODE128C.__proto__ || Object.getPrototypeOf(CODE128C)).call(this, _constants.C_START_CHAR + string, options));
	}

	_createClass(CODE128C, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.C_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128C;
}(_CODE3.default);

exports.default = CODE128C;

/***/ }),

/***/ "2d7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("95c4");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("3513");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1010 = function (_MSI) {
	_inherits(MSI1010, _MSI);

	function MSI1010(data, options) {
		_classCallCheck(this, MSI1010);

		data += (0, _checksums.mod10)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1010.__proto__ || Object.getPrototypeOf(MSI1010)).call(this, data, options));
	}

	return MSI1010;
}(_MSI3.default);

exports.default = MSI1010;

/***/ }),

/***/ "2ddd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "2f8e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-console: 0 */

var ErrorHandler = function () {
	function ErrorHandler(api) {
		_classCallCheck(this, ErrorHandler);

		this.api = api;
	}

	_createClass(ErrorHandler, [{
		key: "handleCatch",
		value: function handleCatch(e) {
			// If babel supported extending of Error in a correct way instanceof would be used here
			if (e.name === "InvalidInputException") {
				if (this.api._options.valid !== this.api._defaults.valid) {
					this.api._options.valid(false);
				} else {
					throw e.message;
				}
			} else {
				throw e;
			}

			this.api.render = function () {};
		}
	}, {
		key: "wrapBarcodeCall",
		value: function wrapBarcodeCall(func) {
			try {
				var result = func.apply(undefined, arguments);
				this.api._options.valid(true);
				return result;
			} catch (e) {
				this.handleCatch(e);

				return this.api;
			}
		}
	}]);

	return ErrorHandler;
}();

exports.default = ErrorHandler;

/***/ }),

/***/ "30b0":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "33a1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var defaults = {
	width: 2,
	height: 100,
	format: "auto",
	displayValue: true,
	fontOptions: "",
	font: "monospace",
	text: undefined,
	textAlign: "center",
	textPosition: "bottom",
	textMargin: 2,
	fontSize: 20,
	background: "#ffffff",
	lineColor: "#000000",
	margin: 10,
	marginTop: undefined,
	marginBottom: undefined,
	marginLeft: undefined,
	marginRight: undefined,
	valid: function valid() {}
};

exports.default = defaults;

/***/ }),

/***/ "3513":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mod10 = mod10;
exports.mod11 = mod11;
function mod10(number) {
	var sum = 0;
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[i]);
		if ((i + number.length) % 2 === 0) {
			sum += n;
		} else {
			sum += n * 2 % 10 + Math.floor(n * 2 / 10);
		}
	}
	return (10 - sum % 10) % 10;
}

function mod11(number) {
	var sum = 0;
	var weights = [2, 3, 4, 5, 6, 7];
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[number.length - 1 - i]);
		sum += weights[i % weights.length] * n;
	}
	return (11 - sum % 11) % 11;
}

/***/ }),

/***/ "36c0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return rgbToHex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return rgbToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hexToRgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hsvToRgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rgbToHsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return textToRgb; });
/* unused harmony export lighten */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return luminosity; });
/* unused harmony export brightness */
/* unused harmony export blend */
/* unused harmony export changeAlpha */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBrand; });
/* unused harmony export getPaletteColor */
/* unused harmony export stringToRgb */
const reRGBA = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function rgbToHex({
  r,
  g,
  b,
  a
}) {
  const alpha = a !== void 0;
  r = Math.round(r);
  g = Math.round(g);
  b = Math.round(b);
  if (r > 255 || g > 255 || b > 255 || alpha && a > 100) {
    throw new TypeError('Expected 3 numbers below 256 (and optionally one below 100)');
  }
  a = alpha ? (Math.round(255 * a / 100) | 1 << 8).toString(16).slice(1) : '';
  return '#' + (b | g << 8 | r << 16 | 1 << 24).toString(16).slice(1) + a;
}
function rgbToString({
  r,
  g,
  b,
  a
}) {
  return `rgb${a !== void 0 ? 'a' : ''}(${r},${g},${b}${a !== void 0 ? ',' + a / 100 : ''})`;
}
function hexToRgb(hex) {
  if (typeof hex !== 'string') {
    throw new TypeError('Expected a string');
  }
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  } else if (hex.length === 4) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
  }
  const num = parseInt(hex, 16);
  return hex.length > 6 ? {
    r: num >> 24 & 255,
    g: num >> 16 & 255,
    b: num >> 8 & 255,
    a: Math.round((num & 255) / 2.55)
  } : {
    r: num >> 16,
    g: num >> 8 & 255,
    b: num & 255
  };
}
function hsvToRgb({
  h,
  s,
  v,
  a
}) {
  let r, g, b;
  s = s / 100;
  v = v / 100;
  h = h / 360;
  const i = Math.floor(h * 6),
    f = h * 6 - i,
    p = v * (1 - s),
    q = v * (1 - f * s),
    t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
    a
  };
}
function rgbToHsv({
  r,
  g,
  b,
  a
}) {
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b),
    d = max - min,
    s = max === 0 ? 0 : d / max,
    v = max / 255;
  let h;
  switch (max) {
    case min:
      h = 0;
      break;
    case r:
      h = g - b + d * (g < b ? 6 : 0);
      h /= 6 * d;
      break;
    case g:
      h = b - r + d * 2;
      h /= 6 * d;
      break;
    case b:
      h = r - g + d * 4;
      h /= 6 * d;
      break;
  }
  return {
    h: Math.round(h * 360),
    s: Math.round(s * 100),
    v: Math.round(v * 100),
    a
  };
}
function textToRgb(str) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }
  const color = str.replace(/ /g, '');
  const m = reRGBA.exec(color);
  if (m === null) {
    return hexToRgb(color);
  }
  const rgb = {
    r: Math.min(255, parseInt(m[2], 10)),
    g: Math.min(255, parseInt(m[3], 10)),
    b: Math.min(255, parseInt(m[4], 10))
  };
  if (m[1]) {
    const alpha = parseFloat(m[5]);
    rgb.a = Math.min(1, isNaN(alpha) === true ? 1 : alpha) * 100;
  }
  return rgb;
}

/* works as darken if percent < 0 */
function lighten(color, percent) {
  if (typeof color !== 'string') {
    throw new TypeError('Expected a string as color');
  }
  if (typeof percent !== 'number') {
    throw new TypeError('Expected a numeric percent');
  }
  const rgb = textToRgb(color),
    t = percent < 0 ? 0 : 255,
    p = Math.abs(percent) / 100,
    R = rgb.r,
    G = rgb.g,
    B = rgb.b;
  return '#' + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}
function luminosity(color) {
  if (typeof color !== 'string' && (!color || color.r === void 0)) {
    throw new TypeError('Expected a string or a {r, g, b} object as color');
  }
  const rgb = typeof color === 'string' ? textToRgb(color) : color,
    r = rgb.r / 255,
    g = rgb.g / 255,
    b = rgb.b / 255,
    R = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4),
    G = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4),
    B = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}
function brightness(color) {
  if (typeof color !== 'string' && (!color || color.r === void 0)) {
    throw new TypeError('Expected a string or a {r, g, b} object as color');
  }
  const rgb = typeof color === 'string' ? textToRgb(color) : color;
  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
}
function blend(fgColor, bgColor) {
  if (typeof fgColor !== 'string' && (!fgColor || fgColor.r === void 0)) {
    throw new TypeError('Expected a string or a {r, g, b[, a]} object as fgColor');
  }
  if (typeof bgColor !== 'string' && (!bgColor || bgColor.r === void 0)) {
    throw new TypeError('Expected a string or a {r, g, b[, a]} object as bgColor');
  }
  const rgb1 = typeof fgColor === 'string' ? textToRgb(fgColor) : fgColor,
    r1 = rgb1.r / 255,
    g1 = rgb1.g / 255,
    b1 = rgb1.b / 255,
    a1 = rgb1.a !== void 0 ? rgb1.a / 100 : 1,
    rgb2 = typeof bgColor === 'string' ? textToRgb(bgColor) : bgColor,
    r2 = rgb2.r / 255,
    g2 = rgb2.g / 255,
    b2 = rgb2.b / 255,
    a2 = rgb2.a !== void 0 ? rgb2.a / 100 : 1,
    a = a1 + a2 * (1 - a1),
    r = Math.round((r1 * a1 + r2 * a2 * (1 - a1)) / a * 255),
    g = Math.round((g1 * a1 + g2 * a2 * (1 - a1)) / a * 255),
    b = Math.round((b1 * a1 + b2 * a2 * (1 - a1)) / a * 255);
  const ret = {
    r,
    g,
    b,
    a: Math.round(a * 100)
  };
  return typeof fgColor === 'string' ? rgbToHex(ret) : ret;
}
function changeAlpha(color, offset) {
  if (typeof color !== 'string') {
    throw new TypeError('Expected a string as color');
  }
  if (offset === void 0 || offset < -1 || offset > 1) {
    throw new TypeError('Expected offset to be between -1 and 1');
  }
  const {
    r,
    g,
    b,
    a
  } = textToRgb(color);
  const alpha = a !== void 0 ? a / 100 : 0;
  return rgbToHex({
    r,
    g,
    b,
    a: Math.round(Math.min(1, Math.max(0, alpha + offset)) * 100)
  });
}
function setBrand(color, value, element = document.body) {
  if (typeof color !== 'string') {
    throw new TypeError('Expected a string as color');
  }
  if (typeof value !== 'string') {
    throw new TypeError('Expected a string as value');
  }
  if (!(element instanceof Element)) {
    throw new TypeError('Expected a DOM element');
  }
  element.style.setProperty(`--q-color-${color}`, value);
}
function getBrand(color, element = document.body) {
  if (typeof color !== 'string') {
    throw new TypeError('Expected a string as color');
  }
  if (!(element instanceof Element)) {
    throw new TypeError('Expected a DOM element');
  }
  return getComputedStyle(element).getPropertyValue(`--q-color-${color}`).trim() || null;
}
function getPaletteColor(colorName) {
  if (typeof colorName !== 'string') {
    throw new TypeError('Expected a string as color');
  }
  const el = document.createElement('div');
  el.className = `text-${colorName} invisible fixed no-pointer-events`;
  document.body.appendChild(el);
  const result = getComputedStyle(el).getPropertyValue('color');
  el.remove();
  return rgbToHex(textToRgb(result));
}

// TODO: remove in v2
const stringToRgb = textToRgb;
/* unused harmony default export */ var _unused_webpack_default_export = ({
  rgbToHex,
  hexToRgb,
  hsvToRgb,
  rgbToHsv,
  textToRgb,
  lighten,
  luminosity,
  brightness,
  blend,
  changeAlpha,
  setBrand,
  getBrand,
  getPaletteColor
});

/***/ }),

/***/ "36d8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EAN2 = __webpack_require__("cf51");

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// http://www.barcodeisland.com/ean8.phtml

// Calculate the checksum digit
var checksum = function checksum(number) {
	var res = number.substr(0, 7).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a : sum + a * 3;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN8 = function (_EAN) {
	_inherits(EAN8, _EAN);

	function EAN8(data, options) {
		_classCallCheck(this, EAN8);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{7}$/) !== -1) {
			data += checksum(data);
		}

		return _possibleConstructorReturn(this, (EAN8.__proto__ || Object.getPrototypeOf(EAN8)).call(this, data, options));
	}

	_createClass(EAN8, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftText', this).call(this, 0, 4);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(0, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftEncode', this).call(this, data, 'LLLL');
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightText', this).call(this, 4, 4);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(4, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightEncode', this).call(this, data, 'RRRR');
		}
	}]);

	return EAN8;
}(_EAN3.default);

exports.default = EAN8;

/***/ }),

/***/ "3867":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (fn, limit = 250) {
  let wait = false,
    result;
  return function /* ...args */
  () {
    if (wait === false) {
      wait = true;
      setTimeout(() => {
        wait = false;
      }, limit);
      result = fn.apply(this, arguments);
    }
    return result;
  };
});

/***/ }),

/***/ "38a2":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__38a2__;

/***/ }),

/***/ "3b4c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("a951");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("b47d");
var ___CSS_LOADER_URL_IMPORT_1___ = __webpack_require__("89ad");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.i, "@font-face{font-family:Material Icons;font-style:normal;font-weight:400;font-display:block;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") format(\"woff2\"),url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") format(\"woff\")}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\"}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3e5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _key_composition_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("116d");

const handlers = [];
let escDown = false;
/* harmony default export */ __webpack_exports__["a"] = ({
  __install() {
    this.__installed = true;
    window.addEventListener('keydown', evt => {
      escDown = evt.keyCode === 27;
    });
    window.addEventListener('blur', () => {
      escDown === true && (escDown = false);
    });
    window.addEventListener('keyup', evt => {
      if (escDown === true) {
        escDown = false;
        if (handlers.length !== 0 && Object(_key_composition_js__WEBPACK_IMPORTED_MODULE_0__[/* isKeyCode */ "a"])(evt, 27) === true) {
          handlers[handlers.length - 1].fn(evt);
        }
      }
    });
  },
  register(comp, fn) {
    if (comp.$q.platform.is.desktop === true) {
      this.__installed !== true && this.__install();
      handlers.push({
        comp,
        fn
      });
    }
  },
  pop(comp) {
    if (comp.$q.platform.is.desktop === true) {
      const index = handlers.findIndex(h => h.comp === comp);
      if (index > -1) {
        handlers.splice(index, 1);
      }
    }
  }
});

/***/ }),

/***/ "3ecb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("559c");

var _encoder = __webpack_require__("b720");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_2#Encoding

var EAN2 = function (_Barcode) {
	_inherits(EAN2, _Barcode);

	function EAN2(data, options) {
		_classCallCheck(this, EAN2);

		return _possibleConstructorReturn(this, (EAN2.__proto__ || Object.getPrototypeOf(EAN2)).call(this, data, options));
	}

	_createClass(EAN2, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{2}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			// Choose the structure based on the number mod 4
			var structure = _constants.EAN2_STRUCTURE[parseInt(this.data) % 4];
			return {
				// Start bits + Encode the two digits with 01 in between
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN2;
}(_Barcode3.default);

exports.default = EAN2;

/***/ }),

/***/ "3f03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export btnPadding */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return btnDesignOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBtnDesign; });
/* harmony import */ var _align_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4200");
/* harmony import */ var _ripple_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1de7");
/* harmony import */ var _listeners_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a50a");
/* harmony import */ var _router_link_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("adc0");
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4ef2");





const btnPadding = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
};
const formTypes = ['button', 'submit', 'reset'];
const mediaTypeRe = /[^\s]\/[^\s]/;
const btnDesignOptions = ['flat', 'outline', 'push', 'unelevated'];
const getBtnDesign = (vm, defaultValue) => {
  if (vm.flat === true) return 'flat';
  if (vm.outline === true) return 'outline';
  if (vm.push === true) return 'push';
  if (vm.unelevated === true) return 'unelevated';
  return defaultValue;
};
/* harmony default export */ __webpack_exports__["b"] = ({
  mixins: [_listeners_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _ripple_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _router_link_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _align_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], Object(_size_js__WEBPACK_IMPORTED_MODULE_4__[/* getSizeMixin */ "b"])({
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
  })],
  props: {
    type: {
      type: String,
      default: 'button'
    },
    to: [Object, String],
    replace: Boolean,
    append: Boolean,
    label: [Number, String],
    icon: String,
    iconRight: String,
    ...btnDesignOptions.reduce((acc, val) => (acc[val] = Boolean) && acc, {}),
    square: Boolean,
    round: Boolean,
    rounded: Boolean,
    glossy: Boolean,
    size: String,
    fab: Boolean,
    fabMini: Boolean,
    padding: String,
    color: String,
    textColor: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    tabindex: [Number, String],
    align: {
      default: 'center'
    },
    stack: Boolean,
    stretch: Boolean,
    loading: {
      type: Boolean,
      default: null
    },
    disable: Boolean
  },
  computed: {
    style() {
      if (this.fab === false && this.fabMini === false) {
        return this.sizeStyle;
      }
    },
    isRounded() {
      return this.rounded === true || this.fab === true || this.fabMini === true;
    },
    isActionable() {
      return this.disable !== true && this.loading !== true;
    },
    computedTabIndex() {
      return this.isActionable === true ? this.tabindex || 0 : -1;
    },
    design() {
      return getBtnDesign(this, 'standard');
    },
    attrs() {
      const acc = {
        tabindex: this.computedTabIndex
      };
      if (this.hasLink === true) {
        Object.assign(acc, this.linkAttrs);
      } else if (formTypes.includes(this.type) === true) {
        acc.type = this.type;
      }
      if (this.linkTag === 'a') {
        if (this.disable === true) {
          acc['aria-disabled'] = 'true';
        } else if (acc.href === void 0) {
          acc.role = 'button';
        }
        if (this.hasRouterLink !== true && mediaTypeRe.test(this.type) === true) {
          acc.type = this.type;
        }
      } else if (this.disable === true) {
        acc.disabled = '';
        acc['aria-disabled'] = 'true';
      }
      if (this.loading === true && this.percentage !== void 0) {
        acc.role = 'progressbar';
        acc['aria-valuemin'] = 0;
        acc['aria-valuemax'] = 100;
        acc['aria-valuenow'] = this.percentage;
      }
      return acc;
    },
    classes() {
      let colors;
      if (this.color !== void 0) {
        if (this.flat === true || this.outline === true) {
          colors = `text-${this.textColor || this.color}`;
        } else {
          colors = `bg-${this.color} text-${this.textColor || 'white'}`;
        }
      } else if (this.textColor) {
        colors = `text-${this.textColor}`;
      }
      const shape = this.round === true ? 'round' : `rectangle${this.isRounded === true ? ' q-btn--rounded' : this.square === true ? ' q-btn--square' : ''}`;
      return `q-btn--${this.design} q-btn--${shape}` + (colors !== void 0 ? ' ' + colors : '') + (this.isActionable === true ? ' q-btn--actionable q-focusable q-hoverable' : this.disable === true ? ' disabled' : '') + (this.fab === true ? ' q-btn--fab' : this.fabMini === true ? ' q-btn--fab-mini' : '') + (this.noCaps === true ? ' q-btn--no-uppercase' : '') + (this.noWrap === true ? '' : ' q-btn--wrap') + (
      // this is for IE11
      this.dense === true ? ' q-btn--dense' : '') + (this.stretch === true ? ' no-border-radius self-stretch' : '') + (this.glossy === true ? ' glossy' : '');
    },
    innerClasses() {
      return this.alignClass + (this.stack === true ? ' column' : ' row') + (this.noWrap === true ? ' no-wrap text-no-wrap' : '') + (this.loading === true ? ' q-btn__content--hidden' : '');
    },
    wrapperStyle() {
      if (this.padding !== void 0) {
        return {
          padding: this.padding.split(/\s+/).map(v => v in btnPadding ? btnPadding[v] + 'px' : v).join(' '),
          minWidth: '0',
          minHeight: '0'
        };
      }
    }
  }
});

/***/ }),

/***/ "3f7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a8d5");


const getTrue = () => true;
function filterInvalidPath(path) {
  return typeof path === 'string' && path !== '' && path !== '/' && path !== '#/';
}
function normalizeExitPath(path) {
  path.startsWith('#') === true && (path = path.substr(1));
  path.startsWith('/') === false && (path = '/' + path);
  path.endsWith('/') === true && (path = path.substr(0, path.length - 1));
  return '#' + path;
}
function getShouldExitFn(cfg) {
  if (cfg.backButtonExit === false) {
    return () => false;
  }
  if (cfg.backButtonExit === '*') {
    return getTrue;
  }

  // Add default root path
  const exitPaths = ['#/'];

  // Add custom exit paths
  Array.isArray(cfg.backButtonExit) === true && exitPaths.push(...cfg.backButtonExit.filter(filterInvalidPath).map(normalizeExitPath));
  return () => exitPaths.includes(window.location.hash);
}
/* harmony default export */ __webpack_exports__["a"] = ({
  __history: [],
  add: _utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* noop */ "g"],
  remove: _utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* noop */ "g"],
  install(cfg) {
    if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === true) {
      return;
    }
    const {
      cordova,
      capacitor
    } = _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* client */ "a"].is;
    if (cordova !== true && capacitor !== true) {
      return;
    }
    const qConf = cfg[cordova === true ? 'cordova' : 'capacitor'];
    if (qConf !== void 0 && qConf.backButton === false) {
      return;
    }

    // if the '@capacitor/app' plugin is not installed
    // then we got nothing to do
    if (
    // if we're on Capacitor mode
    capacitor === true && (
    // and it's also not in Capacitor's main instance
    window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0)) {
      return;
    }
    this.add = entry => {
      if (entry.condition === void 0) {
        entry.condition = getTrue;
      }
      this.__history.push(entry);
    };
    this.remove = entry => {
      const index = this.__history.indexOf(entry);
      if (index >= 0) {
        this.__history.splice(index, 1);
      }
    };
    const shouldExit = getShouldExitFn(Object.assign({
      backButtonExit: true
    }, qConf));
    const backHandler = () => {
      if (this.__history.length) {
        const entry = this.__history[this.__history.length - 1];
        if (entry.condition() === true) {
          this.__history.pop();
          entry.handler();
        }
      } else if (shouldExit() === true) {
        navigator.app.exitApp();
      } else {
        window.history.back();
      }
    };
    if (cordova === true) {
      document.addEventListener('deviceready', () => {
        document.addEventListener('backbutton', backHandler, false);
      });
    } else {
      window.Capacitor.Plugins.App.addListener('backButton', backHandler);
    }
  }
});

/***/ }),

/***/ "4025":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
});

/***/ }),

/***/ "406b":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__406b__;

/***/ }),

/***/ "417a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".qc-image[data-v-4db7a124]{transition:transform .2s ease-out;height:100%;display:block;object-fit:contain}.loading[data-v-4db7a124],.selected-image[data-v-4db7a124]{background-color:#2196f3}.selected-image .qc-image[data-v-4db7a124]{transform:scale(.9)!important}.preferred-image[data-v-4db7a124]{background-color:#8bc34a}.preferred-image .qc-image[data-v-4db7a124]{transform:scale(.94)}.qc-image-container:not(.preferred-image):hover .qc-image[data-v-4db7a124]{transform:scale(1.04);box-shadow:0 0 3px 1px #000}.qc-image-container.preferred-image:hover .qc-image[data-v-4db7a124]{transform:scale(1);box-shadow:0 0 3px 1px #000}.bottom-text-small[data-v-4db7a124]{font-size:.55rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4200":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const alignMap = {
    left: 'start',
    center: 'center',
    right: 'end',
    between: 'between',
    around: 'around',
    evenly: 'evenly',
    stretch: 'stretch'
  },
  alignValues = Object.keys(alignMap);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    align: {
      type: String,
      validator: v => alignValues.includes(v)
    }
  },
  computed: {
    alignClass() {
      const align = this.align === void 0 ? this.vertical === true ? 'stretch' : 'left' : this.align;
      return `${this.vertical === true ? 'items' : 'justify'}-${alignMap[align]}`;
    }
  }
});

/***/ }),

/***/ "4351":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");

const isJapanese = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
const isChinese = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u;
const isKorean = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/;
const isPlainText = /[a-z0-9_ -]$/i;
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    __onComposition(e) {
      if (e.type === 'compositionend' || e.type === 'change') {
        if (e.target.qComposing !== true) {
          return;
        }
        e.target.qComposing = false;
        this.__onInput(e);
      } else if (e.type === 'compositionupdate' && e.target.qComposing !== true && typeof e.data === 'string') {
        const isComposing = _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* client */ "a"].is.firefox === true ? isPlainText.test(e.data) === false : isJapanese.test(e.data) === true || isChinese.test(e.data) === true || isKorean.test(e.data) === true;
        if (isComposing === true) {
          e.target.qComposing = true;
        }
      }
    }
  }
});

/***/ }),

/***/ "43f8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = __webpack_require__("f120");

// Match Set functions
var matchSetALength = function matchSetALength(string) {
	return string.match(new RegExp('^' + _constants.A_CHARS + '*'))[0].length;
};
var matchSetBLength = function matchSetBLength(string) {
	return string.match(new RegExp('^' + _constants.B_CHARS + '*'))[0].length;
};
var matchSetC = function matchSetC(string) {
	return string.match(new RegExp('^' + _constants.C_CHARS + '*'))[0];
};

// CODE128A or CODE128B
function autoSelectFromAB(string, isA) {
	var ranges = isA ? _constants.A_CHARS : _constants.B_CHARS;
	var untilC = string.match(new RegExp('^(' + ranges + '+?)(([0-9]{2}){2,})([^0-9]|$)'));

	if (untilC) {
		return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
	}

	var chars = string.match(new RegExp('^' + ranges + '+'))[0];

	if (chars.length === string.length) {
		return string;
	}

	return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
}

// CODE128C
function autoSelectFromC(string) {
	var cMatch = matchSetC(string);
	var length = cMatch.length;

	if (length === string.length) {
		return string;
	}

	string = string.substring(length);

	// Select A/B depending on the longest match
	var isA = matchSetALength(string) >= matchSetBLength(string);
	return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
}

// Detect Code Set (A, B or C) and format the string

exports.default = function (string) {
	var newString = void 0;
	var cLength = matchSetC(string).length;

	// Select 128C if the string start with enough digits
	if (cLength >= 2) {
		newString = _constants.C_START_CHAR + autoSelectFromC(string);
	} else {
		// Select A/B depending on the longest match
		var isA = matchSetALength(string) > matchSetBLength(string);
		newString = (isA ? _constants.A_START_CHAR : _constants.B_START_CHAR) + autoSelectFromAB(string, isA);
	}

	return newString.replace(/[\xCD\xCE]([^])[\xCD\xCE]/, // Any sequence between 205 and 206 characters
	function (match, char) {
		return String.fromCharCode(203) + char;
	});
};

/***/ }),

/***/ "448b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    transitionShow: {
      type: String,
      default: 'fade'
    },
    transitionHide: {
      type: String,
      default: 'fade'
    }
  },
  computed: {
    transitionProps() {
      const show = `q-transition--${this.transitionShow || this.defaultTransitionShow}`;
      const hide = `q-transition--${this.transitionHide || this.defaultTransitionHide}`;
      return {
        appear: true,
        enterClass: `${show}-enter`,
        enterActiveClass: `${show}-enter-active`,
        enterToClass: `${show}-enter-to`,
        leaveClass: `${hide}-leave`,
        leaveActiveClass: `${hide}-leave-active`,
        leaveToClass: `${hide}-leave-to`
      };
    }
  }
});

/***/ }),

/***/ "44d9":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__44d9__;

/***/ }),

/***/ "479b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cacheWithFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPropCacheMixin; });
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");

function cache(vm, key, obj) {
  if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === true) return obj;
  const k = `__qcache_${key}`;
  return vm[k] === void 0 ? vm[k] = obj : vm[k];
}
function cacheWithFn(vm, key, fn) {
  if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === true) return fn();
  const k = `__qcache_${key}`;
  return vm[k] === void 0 ? vm[k] = fn() : vm[k];
}
function getPropCacheMixin(propName, proxyPropName) {
  return {
    data() {
      const target = {};
      const source = this[propName];
      for (const prop in source) {
        target[prop] = source[prop];
      }
      return {
        [proxyPropName]: target
      };
    },
    watch: {
      [propName](newObj, oldObj) {
        const target = this[proxyPropName];
        if (oldObj !== void 0) {
          // we first delete obsolete events
          for (const prop in oldObj) {
            if (newObj[prop] === void 0) {
              this.$delete(target, prop);
            }
          }
        }
        for (const prop in newObj) {
          // we then update changed events
          if (target[prop] !== newObj[prop]) {
            this.$set(target, prop, newObj[prop]);
          }
        }
      }
    }
  };
}

/***/ }),

/***/ "4954":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var START_BIN = exports.START_BIN = '1010';
var END_BIN = exports.END_BIN = '11101';

var BINARIES = exports.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];

/***/ }),

/***/ "4b62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ViewGrid.vue?vue&type=template&id=d5bc87f4&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_vm.images.length > 0 ? _c('div', _vm._l(_vm.groupClassByPhotographer(_vm.images), function (pairs, index) {
    return _c('photographer-expansion', {
      key: index,
      attrs: {
        "show-move": _vm.showMove,
        "photographer-id": pairs[0],
        "allow-group-image-assignment": _vm.allowGroupImageAssignment,
        "class-group-images": _vm.classGroupImages,
        "image-options": _vm.imageOptions,
        "images": pairs[1],
        "is-lab-qc": _vm.isLabQC
      },
      on: {
        "move-to-class": function ($event) {
          return _vm.$emit('move-to-class', $event);
        },
        "update-zoom-id": _vm.updateZoomId,
        "assign-group-to-class": function ($event) {
          return _vm.$emit('assign-group-to-class', $event);
        }
      }
    });
  }), 1) : _c('div', {
    staticClass: "row justify-center text-italic text-grey"
  }, [_c('span', {
    staticClass: "q-mt-xl q-mb-md text-h6"
  }, [_vm._v("No Images")])]), _c('q-dialog', {
    model: {
      value: _vm.showModal,
      callback: function ($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('zoom-image', {
    attrs: {
      "zoomImages": _vm.zoomImages
    },
    on: {
      "update-zoom-id": _vm.updateZoomId
    }
  })], 1)], 1);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/ViewGrid.vue?vue&type=template&id=d5bc87f4&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: ./src/imageStore.ts
var imageStore = __webpack_require__("818c");

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__("60bb");
var external_lodash_default = /*#__PURE__*/__webpack_require__.n(external_lodash_);

// EXTERNAL MODULE: ./src/components/ZoomImage.vue + 4 modules
var ZoomImage = __webpack_require__("f9b2");

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/PhotographerExpansion.vue?vue&type=template&id=dee5cec0&lang=pug
var PhotographerExpansionvue_type_template_id_dee5cec0_lang_pug_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_vm.$vnode.key !== 0 ? _c('q-separator', {
    attrs: {
      "spaced": "lg",
      "inset": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "column",
    staticStyle: {
      "scroll-margin-top": "100px"
    },
    attrs: {
      "id": `photographer-${_vm.photographerId}`
    }
  }, [_c('div', {
    staticClass: "row full-width items-center q-pa-sm text-h6"
  }, [_c('div', {
    staticClass: "q-mr-lg"
  }, [_vm._v(_vm._s(_vm.photographerNameAndId))]), _c('q-chip', {
    attrs: {
      "icon": "mdi-camera-outline",
      "size": "md"
    }
  }, [_vm._v(_vm._s(_vm.images.length))])], 1), _vm._l(_vm.groupImagesByClass(_vm.images), function (images, className, index) {
    return _c('class-expansion', {
      key: index,
      attrs: {
        "className": className,
        "images": images,
        "photographer-id": _vm.photographerId,
        "imageOptions": _vm.imageOptions,
        "isLabQC": _vm.isLabQc,
        "show-move": _vm.showMove,
        "allow-group-image-assignment": _vm.allowGroupImageAssignment,
        "assigned-group-image": _vm.getAssignedGroupImage(className)
      },
      on: {
        "move-to-class": function ($event) {
          return _vm.$emit('move-to-class', $event);
        },
        "update-zoom-id": function ($event) {
          return _vm.$emit('update-zoom-id', $event);
        },
        "assign-group-to-class": function ($event) {
          return _vm.$emit('assign-group-to-class', $event);
        }
      }
    });
  })], 2)], 1);
};
var PhotographerExpansionvue_type_template_id_dee5cec0_lang_pug_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/PhotographerExpansion.vue?vue&type=template&id=dee5cec0&lang=pug

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./src/components/ClassExpansion.vue + 9 modules
var ClassExpansion = __webpack_require__("d66b");

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/PhotographerExpansion.vue?vue&type=script&lang=ts




/* harmony default export */ var PhotographerExpansionvue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'PhotographerExpansion',
  components: {
    ClassExpansion: ClassExpansion["a" /* default */]
  },
  props: {
    images: {
      type: Array,
      required: true
    },
    photographerId: {
      type: String,
      required: true
    },
    classGroupImages: {
      type: Object,
      default: null
    },
    imageOptions: {
      type: Object,
      required: true
    },
    isLabQc: {
      type: Boolean,
      default: false
    },
    showMove: {
      type: Boolean,
      default: false
    },
    allowGroupImageAssignment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      zoomId: null
    };
  },
  computed: {
    photographerNameAndId() {
      const photographer = imageStore["a" /* ImageStore */].Instance.photographers[this.photographerId];
      return photographer ? `${photographer.displayName} (${this.photographerId})` : `${this.photographerId} - Photographer not found`;
    }
  },
  methods: {
    groupImagesByClass(images) {
      return Object(external_lodash_["groupBy"])(images, x => x.className);
    },
    getAssignedGroupImage(className) {
      var _a;
      if (this.classGroupImages == null) {
        return null;
      }
      return (_a = imageStore["a" /* ImageStore */].Instance.allImages.find(x => {
        var _a;
        return x.longRef === ((_a = this.classGroupImages) !== null && _a !== void 0 ? _a : {})[className];
      })) !== null && _a !== void 0 ? _a : null;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/PhotographerExpansion.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_PhotographerExpansionvue_type_script_lang_ts = (PhotographerExpansionvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/separator/QSeparator.js
var QSeparator = __webpack_require__("6485");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/chip/QChip.js
var QChip = __webpack_require__("5759");

// EXTERNAL MODULE: /workspace/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js
var runtime_auto_import = __webpack_require__("d447");
var runtime_auto_import_default = /*#__PURE__*/__webpack_require__.n(runtime_auto_import);

// CONCATENATED MODULE: ./src/components/PhotographerExpansion.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_PhotographerExpansionvue_type_script_lang_ts,
  PhotographerExpansionvue_type_template_id_dee5cec0_lang_pug_render,
  PhotographerExpansionvue_type_template_id_dee5cec0_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PhotographerExpansion = (component.exports);



runtime_auto_import_default()(component, 'components', {QSeparator: QSeparator["a" /* default */],QChip: QChip["a" /* default */]});

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ViewGrid.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let ViewGridvue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  constructor() {
    super(...arguments);
    this.zoomId = null;
  }
  get showModal() {
    return this.zoomId !== null;
  }
  set showModal(val) {
    this.zoomId = null;
  }
  get zoomImages() {
    if (this.zoomId === null) return null;
    return imageStore["a" /* ImageStore */].Instance.zoomImages(this.zoomId, this.images);
  }
  groupClassByPhotographer(images) {
    return external_lodash_default()(images).groupBy(x => x.photographerCode).toPairs().sortBy(x => x[0]).value();
  }
  updateZoomId(ref) {
    this.zoomId = ref;
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ViewGridvue_type_script_lang_ts_default_1.prototype, "images", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ViewGridvue_type_script_lang_ts_default_1.prototype, "imageOptions", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: false,
  default: false
})], ViewGridvue_type_script_lang_ts_default_1.prototype, "isLabQC", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ViewGridvue_type_script_lang_ts_default_1.prototype, "allowGroupImageAssignment", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: null
})], ViewGridvue_type_script_lang_ts_default_1.prototype, "classGroupImages", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ViewGridvue_type_script_lang_ts_default_1.prototype, "showMove", void 0);
ViewGridvue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'ViewGrid',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  components: {
    PhotographerExpansion: PhotographerExpansion,
    ZoomImage: ZoomImage["a" /* default */]
  }
})], ViewGridvue_type_script_lang_ts_default_1);
/* harmony default export */ var ViewGridvue_type_script_lang_ts = (ViewGridvue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/ViewGrid.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_ViewGridvue_type_script_lang_ts = (ViewGridvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/dialog/QDialog.js
var QDialog = __webpack_require__("66e6");

// CONCATENATED MODULE: ./src/components/ViewGrid.vue





/* normalize component */

var ViewGrid_component = Object(componentNormalizer["a" /* default */])(
  components_ViewGridvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ViewGrid = __webpack_exports__["a"] = (ViewGrid_component.exports);


runtime_auto_import_default()(ViewGrid_component, 'components', {QDialog: QDialog["a" /* default */]});


/***/ }),

/***/ "4c4f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("4954");

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITF = function (_Barcode) {
	_inherits(ITF, _Barcode);

	function ITF() {
		_classCallCheck(this, ITF);

		return _possibleConstructorReturn(this, (ITF.__proto__ || Object.getPrototypeOf(ITF)).apply(this, arguments));
	}

	_createClass(ITF, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^([0-9]{2})+$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var _this2 = this;

			// Calculate all the digit pairs
			var encoded = this.data.match(/.{2}/g).map(function (pair) {
				return _this2.encodePair(pair);
			}).join('');

			return {
				data: _constants.START_BIN + encoded + _constants.END_BIN,
				text: this.text
			};
		}

		// Calculate the data of a number pair

	}, {
		key: 'encodePair',
		value: function encodePair(pair) {
			var second = _constants.BINARIES[pair[1]];

			return _constants.BINARIES[pair[0]].split('').map(function (first, idx) {
				return (first === '1' ? '111' : '1') + (second[idx] === '1' ? '000' : '0');
			}).join('');
		}
	}]);

	return ITF;
}(_Barcode3.default);

exports.default = ITF;

/***/ }),

/***/ "4ef2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSizeMixin; });
const sizes = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
};
function getSizeMixin(sizes) {
  return {
    props: {
      size: String
    },
    computed: {
      sizeStyle() {
        if (this.size !== void 0) {
          return {
            fontSize: this.size in sizes ? `${sizes[this.size]}px` : this.size
          };
        }
      }
    }
  };
}
/* harmony default export */ __webpack_exports__["a"] = (getSizeMixin(sizes));

/***/ }),

/***/ "536b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return humanStorageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return between; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normalizeToInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pad; });
const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
function humanStorageSize(bytes) {
  let u = 0;
  while (parseInt(bytes, 10) >= 1024 && u < units.length - 1) {
    bytes /= 1024;
    ++u;
  }
  return `${bytes.toFixed(1)}${units[u]}`;
}
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function between(v, min, max) {
  return max <= min ? min : Math.min(max, Math.max(min, v));
}
function normalizeToInterval(v, min, max) {
  if (max <= min) {
    return min;
  }
  const size = max - min + 1;
  let index = min + (v - min) % size;
  if (index < min) {
    index = size + index;
  }
  return index === 0 ? 0 : index; // fix for (-a % a) => -0
}
function pad(v, length = 2, char = '0') {
  if (v === void 0 || v === null) {
    return v;
  }
  const val = '' + v;
  return val.length >= length ? val : new Array(length - val.length + 1).join(char) + val;
}
/* unused harmony default export */ var _unused_webpack_default_export = ({
  humanStorageSize,
  capitalize,
  between,
  normalizeToInterval,
  pad
});

/***/ }),

/***/ "5403":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5403__;

/***/ }),

/***/ "553a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isDeepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isRegexp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isNumber; });
const hasMap = typeof Map === 'function',
  hasSet = typeof Set === 'function',
  hasArrayBuffer = typeof ArrayBuffer === 'function';
function isDeepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a !== null && b !== null && typeof a === 'object' && typeof b === 'object') {
    if (a.constructor !== b.constructor) {
      return false;
    }
    let length, i;
    if (a.constructor === Array) {
      length = a.length;
      if (length !== b.length) {
        return false;
      }
      for (i = length; i-- !== 0;) {
        if (isDeepEqual(a[i], b[i]) !== true) {
          return false;
        }
      }
      return true;
    }
    if (hasMap === true && a.constructor === Map) {
      if (a.size !== b.size) {
        return false;
      }
      let iter = a.entries();
      i = iter.next();
      while (i.done !== true) {
        if (b.has(i.value[0]) !== true) {
          return false;
        }
        i = iter.next();
      }
      iter = a.entries();
      i = iter.next();
      while (i.done !== true) {
        if (isDeepEqual(i.value[1], b.get(i.value[0])) !== true) {
          return false;
        }
        i = iter.next();
      }
      return true;
    }
    if (hasSet === true && a.constructor === Set) {
      if (a.size !== b.size) {
        return false;
      }
      const iter = a.entries();
      i = iter.next();
      while (i.done !== true) {
        if (b.has(i.value[0]) !== true) {
          return false;
        }
        i = iter.next();
      }
      return true;
    }
    if (hasArrayBuffer === true && a.buffer != null && a.buffer.constructor === ArrayBuffer) {
      length = a.length;
      if (length !== b.length) {
        return false;
      }
      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }
    if (a.constructor === RegExp) {
      return a.source === b.source && a.flags === b.flags;
    }
    if (a.valueOf !== Object.prototype.valueOf) {
      return a.valueOf() === b.valueOf();
    }
    if (a.toString !== Object.prototype.toString) {
      return a.toString() === b.toString();
    }
    const keys = Object.keys(a).filter(key => a[key] !== void 0);
    length = keys.length;
    if (length !== Object.keys(b).filter(key => b[key] !== void 0).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (isDeepEqual(a[key], b[key]) !== true) {
        return false;
      }
    }
    return true;
  }

  // true if both NaN, false otherwise
  return a !== a && b !== b; // eslint-disable-line no-self-compare
}

// not perfect, but what we ARE interested is for Arrays not to slip in
// as spread operator will mess things up in various areas
// see https://jsbench.me/tbl0iliyax/1
function isObject(v) {
  return v !== null && typeof v === 'object' && Array.isArray(v) !== true;
}
function isDate(v) {
  return Object.prototype.toString.call(v) === '[object Date]';
}
function isRegexp(v) {
  return Object.prototype.toString.call(v) === '[object RegExp]';
}
function isNumber(v) {
  return typeof v === 'number' && isFinite(v);
}
/* unused harmony default export */ var _unused_webpack_default_export = ({
  deepEqual: isDeepEqual,
  object: isObject,
  date: isDate,
  regexp: isRegexp,
  number: isNumber
});

/***/ }),

/***/ "559c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
// Standard start end and middle bits
var SIDE_BIN = exports.SIDE_BIN = '101';
var MIDDLE_BIN = exports.MIDDLE_BIN = '01010';

var BINARIES = exports.BINARIES = {
	'L': [// The L (left) type of encoding
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'G': [// The G type of encoding
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'],
	'R': [// The R (right) type of encoding
	'1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'],
	'O': [// The O (odd) encoding for UPC-E
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'E': [// The E (even) encoding for UPC-E
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
};

// Define the EAN-2 structure
var EAN2_STRUCTURE = exports.EAN2_STRUCTURE = ['LL', 'LG', 'GL', 'GG'];

// Define the EAN-5 structure
var EAN5_STRUCTURE = exports.EAN5_STRUCTURE = ['GGLLL', 'GLGLL', 'GLLGL', 'GLLLG', 'LGGLL', 'LLGGL', 'LLLGG', 'LGLGL', 'LGLLG', 'LLGLG'];

// Define the EAN-13 structure
var EAN13_STRUCTURE = exports.EAN13_STRUCTURE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

/***/ }),

/***/ "55ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getModifierDirections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shouldStart; });
const directions = ['left', 'right', 'up', 'down', 'horizontal', 'vertical'];
const modifiersAll = {
  left: true,
  right: true,
  up: true,
  down: true,
  horizontal: true,
  vertical: true,
  all: true
};

// This is especially important (not the main reason, but important)
// for TouchSwipe directive running on Firefox
// because text selection on such elements cannot be determined
// without additional work (on top of getSelection() API)
// https://bugzilla.mozilla.org/show_bug.cgi?id=85686
const avoidNodeNamesList = ['INPUT', 'TEXTAREA'];
function getModifierDirections(mod) {
  const dir = {};
  directions.forEach(direction => {
    if (mod[direction]) {
      dir[direction] = true;
    }
  });
  if (Object.keys(dir).length === 0) {
    return modifiersAll;
  }
  if (dir.horizontal === true) {
    dir.left = dir.right = true;
  }
  if (dir.vertical === true) {
    dir.up = dir.down = true;
  }
  if (dir.left === true && dir.right === true) {
    dir.horizontal = true;
  }
  if (dir.up === true && dir.down === true) {
    dir.vertical = true;
  }
  if (dir.horizontal === true && dir.vertical === true) {
    dir.all = true;
  }
  return dir;
}
function shouldStart(evt, ctx) {
  return ctx.event === void 0 && evt.target !== void 0 && evt.target.draggable !== true && typeof ctx.handler === 'function' && avoidNodeNamesList.includes(evt.target.nodeName.toUpperCase()) === false && (evt.qClonedBy === void 0 || evt.qClonedBy.indexOf(ctx.uid) === -1);
}

/***/ }),

/***/ "56bc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("95c4");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("3513");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1110 = function (_MSI) {
	_inherits(MSI1110, _MSI);

	function MSI1110(data, options) {
		_classCallCheck(this, MSI1110);

		data += (0, _checksums.mod11)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1110.__proto__ || Object.getPrototypeOf(MSI1110)).call(this, data, options));
	}

	return MSI1110;
}(_MSI3.default);

exports.default = MSI1110;

/***/ }),

/***/ "5759":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a170");
/* harmony import */ var _mixins_dark_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a583");
/* harmony import */ var _mixins_ripple_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1de7");
/* harmony import */ var _mixins_size_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4ef2");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("feae");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("479b");








/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QChip',
  mixins: [_mixins_ripple_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_dark_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], Object(_mixins_size_js__WEBPACK_IMPORTED_MODULE_4__[/* getSizeMixin */ "b"])({
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
  })],
  model: {
    event: 'remove'
  },
  props: {
    dense: Boolean,
    icon: String,
    iconRight: String,
    iconRemove: String,
    iconSelected: String,
    label: [String, Number],
    color: String,
    textColor: String,
    value: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: null
    },
    square: Boolean,
    outline: Boolean,
    clickable: Boolean,
    removable: Boolean,
    removeAriaLabel: String,
    tabindex: [String, Number],
    disable: Boolean
  },
  computed: {
    classes() {
      const text = this.outline === true ? this.color || this.textColor : this.textColor;
      return {
        [`bg-${this.color}`]: this.outline === false && this.color !== void 0,
        [`text-${text} q-chip--colored`]: text,
        disabled: this.disable,
        'q-chip--dense': this.dense,
        'q-chip--outline': this.outline,
        'q-chip--selected': this.selected,
        'q-chip--clickable cursor-pointer non-selectable q-hoverable': this.isClickable,
        'q-chip--square': this.square,
        'q-chip--dark q-dark': this.isDark
      };
    },
    hasLeftIcon() {
      return this.selected === true || this.icon !== void 0;
    },
    leftIcon() {
      return this.selected === true ? this.iconSelected || this.$q.iconSet.chip.selected : this.icon;
    },
    removeIcon() {
      return this.iconRemove || this.$q.iconSet.chip.remove;
    },
    isClickable() {
      return this.disable === false && (this.clickable === true || this.selected !== null);
    },
    attrs() {
      const chip = this.disable === true ? {
        tabindex: -1,
        'aria-disabled': 'true'
      } : {
        tabindex: this.tabindex || 0
      };
      const remove = {
        ...chip,
        role: 'button',
        'aria-hidden': 'false',
        'aria-label': this.removeAriaLabel || this.$q.lang.label.remove
      };
      return {
        chip,
        remove
      };
    }
  },
  methods: {
    __onKeyup(e) {
      e.keyCode === 13 /* ENTER */ && this.__onClick(e);
    },
    __onClick(e) {
      if (!this.disable) {
        this.$emit('update:selected', !this.selected);
        this.$emit('click', e);
      }
    },
    __onRemove(e) {
      if (e.keyCode === void 0 || e.keyCode === 13) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stopAndPrevent */ "l"])(e);
        !this.disable && this.$emit('remove', false);
      }
    },
    __getContent(h) {
      const child = [];
      this.isClickable === true && child.push(h('div', {
        staticClass: 'q-focus-helper'
      }));
      this.hasLeftIcon === true && child.push(h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
        staticClass: 'q-chip__icon q-chip__icon--left',
        props: {
          name: this.leftIcon
        }
      }));
      const label = this.label !== void 0 ? [h('div', {
        staticClass: 'ellipsis'
      }, [this.label])] : void 0;
      child.push(h('div', {
        staticClass: 'q-chip__content col row no-wrap items-center q-anchor--skip'
      }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_6__[/* mergeSlotSafely */ "b"])(label, this, 'default')));
      this.iconRight && child.push(h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
        staticClass: 'q-chip__icon q-chip__icon--right',
        props: {
          name: this.iconRight
        }
      }));
      this.removable === true && child.push(h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
        staticClass: 'q-chip__icon q-chip__icon--remove cursor-pointer',
        props: {
          name: this.removeIcon
        },
        attrs: this.attrs.remove,
        on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'non', {
          click: this.__onRemove,
          keyup: this.__onRemove
        })
      }));
      return child;
    }
  },
  render(h) {
    if (this.value === false) {
      return;
    }
    const data = {
      staticClass: 'q-chip row inline no-wrap items-center',
      class: this.classes,
      style: this.sizeStyle
    };
    this.isClickable === true && Object.assign(data, {
      attrs: this.attrs.chip,
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'click', {
        click: this.__onClick,
        keyup: this.__onKeyup
      }),
      directives: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'dir#' + this.ripple, [{
        name: 'ripple',
        value: this.ripple
      }])
    });
    return h('div', data, this.__getContent(h));
  }
}));

/***/ }),

/***/ "597b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global HTMLImageElement */
/* global HTMLCanvasElement */
/* global SVGElement */

var _getOptionsFromElement = __webpack_require__("f49e");

var _getOptionsFromElement2 = _interopRequireDefault(_getOptionsFromElement);

var _renderers = __webpack_require__("abb4");

var _renderers2 = _interopRequireDefault(_renderers);

var _exceptions = __webpack_require__("0c9a");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Takes an element and returns an object with information about how
// it should be rendered
// This could also return an array with these objects
// {
//   element: The element that the renderer should draw on
//   renderer: The name of the renderer
//   afterRender (optional): If something has to done after the renderer
//     completed, calls afterRender (function)
//   options (optional): Options that can be defined in the element
// }

function getRenderProperties(element) {
	// If the element is a string, query select call again
	if (typeof element === "string") {
		return querySelectedRenderProperties(element);
	}
	// If element is array. Recursivly call with every object in the array
	else if (Array.isArray(element)) {
			var returnArray = [];
			for (var i = 0; i < element.length; i++) {
				returnArray.push(getRenderProperties(element[i]));
			}
			return returnArray;
		}
		// If element, render on canvas and set the uri as src
		else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLImageElement) {
				return newCanvasRenderProperties(element);
			}
			// If SVG
			else if (element && element.nodeName && element.nodeName.toLowerCase() === 'svg' || typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
					return {
						element: element,
						options: (0, _getOptionsFromElement2.default)(element),
						renderer: _renderers2.default.SVGRenderer
					};
				}
				// If canvas (in browser)
				else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLCanvasElement) {
						return {
							element: element,
							options: (0, _getOptionsFromElement2.default)(element),
							renderer: _renderers2.default.CanvasRenderer
						};
					}
					// If canvas (in node)
					else if (element && element.getContext) {
							return {
								element: element,
								renderer: _renderers2.default.CanvasRenderer
							};
						} else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && !element.nodeName) {
							return {
								element: element,
								renderer: _renderers2.default.ObjectRenderer
							};
						} else {
							throw new _exceptions.InvalidElementException();
						}
}

function querySelectedRenderProperties(string) {
	var selector = document.querySelectorAll(string);
	if (selector.length === 0) {
		return undefined;
	} else {
		var returnArray = [];
		for (var i = 0; i < selector.length; i++) {
			returnArray.push(getRenderProperties(selector[i]));
		}
		return returnArray;
	}
}

function newCanvasRenderProperties(imgElement) {
	var canvas = document.createElement('canvas');
	return {
		element: canvas,
		options: (0, _getOptionsFromElement2.default)(imgElement),
		renderer: _renderers2.default.CanvasRenderer,
		afterRender: function afterRender() {
			imgElement.setAttribute("src", canvas.toDataURL());
		}
	};
}

exports.default = getRenderProperties;

/***/ }),

/***/ "5c27":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GenericBarcode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericBarcode = function (_Barcode) {
	_inherits(GenericBarcode, _Barcode);

	function GenericBarcode(data, options) {
		_classCallCheck(this, GenericBarcode);

		return _possibleConstructorReturn(this, (GenericBarcode.__proto__ || Object.getPrototypeOf(GenericBarcode)).call(this, data, options)); // Sets this.data and this.text
	}

	// Return the corresponding binary numbers for the data provided


	_createClass(GenericBarcode, [{
		key: "encode",
		value: function encode() {
			return {
				data: "10101010101010101010101010101010101010101",
				text: this.text
			};
		}

		// Resturn true/false if the string provided is valid for this encoder

	}, {
		key: "valid",
		value: function valid() {
			return true;
		}
	}]);

	return GenericBarcode;
}(_Barcode3.default);

exports.GenericBarcode = GenericBarcode;

/***/ }),

/***/ "5cf2":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "*,:after,:before{box-sizing:inherit;-webkit-tap-highlight-color:transparent;-moz-tap-highlight-color:transparent}#q-app,body,html{width:100%;direction:ltr}body.platform-ios.within-iframe,body.platform-ios.within-iframe #q-app{width:100px;min-width:100%}body,html{margin:0;box-sizing:border-box}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}img{border-style:none}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}hr{box-sizing:content-box;height:0;overflow:visible}button,input,optgroup,select,textarea{font:inherit;font-family:inherit;margin:0}optgroup{font-weight:700}button,input,select{overflow:visible;text-transform:none}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}button:-moz-focusring,input:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}.q-icon{line-height:1;width:1em;height:1em;flex-shrink:0;letter-spacing:normal;text-transform:none;white-space:nowrap;word-wrap:normal;direction:ltr;text-align:center;position:relative;box-sizing:content-box;fill:currentColor}.q-icon:after,.q-icon:before{width:100%;height:100%;display:flex!important;align-items:center;justify-content:center}.q-icon>img,.q-icon>svg{width:100%;height:100%}.material-icons,.material-icons-outlined,.material-icons-round,.material-icons-sharp,.material-symbols-outlined,.material-symbols-rounded,.material-symbols-sharp,.q-icon{user-select:none;cursor:inherit;font-size:inherit;display:inline-flex;align-items:center;justify-content:center;vertical-align:middle}.q-panel,.q-panel>div{height:100%;width:100%}.q-panel-parent{overflow:hidden;position:relative}.q-loading-bar{position:fixed;z-index:9998;transition:transform .5s cubic-bezier(0,0,.2,1),opacity .5s;background:#f44336}.q-loading-bar--top{left:0;right:0;top:0;width:100%}.q-loading-bar--bottom{left:0;right:0;bottom:0;width:100%}.q-loading-bar--right{top:0;bottom:0;right:0;height:100%}.q-loading-bar--left{top:0;bottom:0;left:0;height:100%}.q-avatar{position:relative;vertical-align:middle;display:inline-block;border-radius:50%;font-size:48px;height:1em;width:1em}.q-avatar__content{font-size:.5em;line-height:.5em}.q-avatar__content,.q-avatar img:not(.q-icon){border-radius:inherit;height:inherit;width:inherit}.q-avatar--square{border-radius:0}.q-badge{background-color:#027be3;background-color:var(--q-color-primary);color:#fff;padding:2px 6px;border-radius:4px;font-size:12px;min-height:12px;line-height:12px;font-weight:400;vertical-align:baseline}.q-badge--single-line{white-space:nowrap}.q-badge--multi-line{word-break:break-all;word-wrap:break-word}.q-badge--floating{position:absolute;top:-4px;right:-3px;cursor:inherit}.q-badge--transparent{opacity:.8}.q-badge--outline{background-color:transparent;border:1px solid currentColor}.q-badge--rounded{border-radius:1em}.q-banner{min-height:54px;padding:8px 16px;background:#fff}.q-banner--top-padding{padding-top:14px}.q-banner__avatar{min-width:1px!important}.q-banner__avatar>.q-avatar{font-size:46px}.q-banner__avatar>.q-icon{font-size:40px}.q-banner__actions.col-auto,.q-banner__avatar:not(:empty)+.q-banner__content{padding-left:16px}.q-banner__actions.col-all .q-btn-item{margin:4px 0 0 4px}.q-banner--dense{min-height:32px;padding:8px}.q-banner--dense.q-banner--top-padding{padding-top:12px}.q-banner--dense .q-banner__avatar>.q-avatar,.q-banner--dense .q-banner__avatar>.q-icon{font-size:28px}.q-banner--dense .q-banner__actions.col-auto,.q-banner--dense .q-banner__avatar:not(:empty)+.q-banner__content{padding-left:8px}.q-bar{background:rgba(0,0,0,.2)}.q-bar>.q-icon{margin-left:2px}.q-bar>div,.q-bar>div+.q-icon{margin-left:8px}.q-bar>.q-btn{margin-left:2px}.q-bar>.q-btn:first-child,.q-bar>.q-icon:first-child,.q-bar>div:first-child{margin-left:0}.q-bar--standard{padding:0 12px;height:32px;font-size:18px}.q-bar--standard>div{font-size:16px}.q-bar--standard .q-btn{font-size:11px}.q-bar--dense{padding:0 8px;height:24px;font-size:14px}.q-bar--dense .q-btn{font-size:8px}.q-bar--dark{background:hsla(0,0%,100%,.15)}.q-breadcrumbs__el{color:inherit}.q-breadcrumbs__el-icon{font-size:125%}.q-breadcrumbs__el-icon--with-label{margin-right:8px}[dir=rtl] .q-breadcrumbs__separator .q-icon{transform:scaleX(-1)}.q-btn{display:inline-flex;flex-direction:column;align-items:stretch;position:relative;outline:0;border:0;vertical-align:middle;padding:0;font-size:14px;line-height:1.715em;text-decoration:none;color:inherit;background:transparent;font-weight:500;text-transform:uppercase;text-align:center;width:auto;height:auto}.q-btn .q-icon,.q-btn .q-spinner{font-size:1.715em}.q-btn.disabled{opacity:.7!important}.q-btn__wrapper{padding:4px 16px;min-height:2.572em;border-radius:inherit;width:100%;height:100%}.q-btn__wrapper:before{content:\"\";display:block;position:absolute;left:0;right:0;top:0;bottom:0;border-radius:inherit;box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)}.q-btn--actionable{cursor:pointer}.q-btn--actionable.q-btn--standard .q-btn__wrapper:before{transition:box-shadow .3s cubic-bezier(.25,.8,.5,1)}.q-btn--actionable.q-btn--standard.q-btn--active .q-btn__wrapper:before,.q-btn--actionable.q-btn--standard:active .q-btn__wrapper:before{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px rgba(0,0,0,.14),0 1px 14px rgba(0,0,0,.12)}.q-btn--no-uppercase{text-transform:none}.q-btn--rectangle{border-radius:3px}.q-btn--outline{background:transparent!important}.q-btn--outline .q-btn__wrapper:before{border:1px solid currentColor}.q-btn--push{border-radius:7px}.q-btn--push .q-btn__wrapper:before{border-bottom:3px solid rgba(0,0,0,.15)}.q-btn--push.q-btn--actionable{transition:transform .3s cubic-bezier(.25,.8,.5,1)}.q-btn--push.q-btn--actionable .q-btn__wrapper:before{transition:top .3s cubic-bezier(.25,.8,.5,1),bottom .3s cubic-bezier(.25,.8,.5,1),border-bottom-width .3s cubic-bezier(.25,.8,.5,1)}.q-btn--push.q-btn--actionable.q-btn--active,.q-btn--push.q-btn--actionable:active{transform:translateY(2px)}.q-btn--push.q-btn--actionable.q-btn--active .q-btn__wrapper:before,.q-btn--push.q-btn--actionable:active .q-btn__wrapper:before{border-bottom-width:0}.q-btn--rounded{border-radius:28px}.q-btn--round{border-radius:50%}.q-btn--round .q-btn__wrapper{padding:0;min-width:3em;min-height:3em}.q-btn--flat .q-btn__wrapper:before,.q-btn--outline .q-btn__wrapper:before,.q-btn--unelevated .q-btn__wrapper:before{box-shadow:none}.q-btn--dense .q-btn__wrapper{padding:.285em;min-height:2em}.q-btn--dense.q-btn--round .q-btn__wrapper{padding:0;min-height:2.4em;min-width:2.4em}.q-btn--dense .on-left{margin-right:6px}.q-btn--dense .on-right{margin-left:6px}.q-btn--fab-mini .q-icon,.q-btn--fab .q-icon{font-size:24px}.q-btn--fab .q-icon{margin:auto}.q-btn--fab .q-btn__wrapper{padding:16px;min-height:56px;min-width:56px}.q-btn--fab-mini .q-btn__wrapper{padding:8px;min-height:40px;min-width:40px}.q-btn__content{transition:opacity .3s;z-index:0}.q-btn__content--hidden{opacity:0;pointer-events:none}.q-btn__progress{border-radius:inherit;z-index:0}.q-btn__progress-indicator{z-index:-1;transform:translateX(-100%);background:hsla(0,0%,100%,.25)}.q-btn__progress--dark .q-btn__progress-indicator{background:rgba(0,0,0,.2)}.q-btn--flat .q-btn__progress-indicator,.q-btn--outline .q-btn__progress-indicator{opacity:.2;background:currentColor}.q-btn-dropdown--split .q-btn-dropdown__arrow-container.q-btn--outline{border-left:1px solid currentColor}.q-btn-dropdown--split .q-btn-dropdown__arrow-container:not(.q-btn--outline){border-left:1px solid hsla(0,0%,100%,.3)}.q-btn-dropdown--split .q-btn-dropdown__arrow-container .q-btn__wrapper{padding:0 4px}.q-btn-dropdown--simple *+.q-btn-dropdown__arrow{margin-left:8px}.q-btn-dropdown__arrow{transition:transform .28s}.q-btn-dropdown--current{flex-grow:1}.q-btn-group{border-radius:3px;box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);vertical-align:middle}.q-btn-group>.q-btn-item{border-radius:inherit;align-self:stretch}.q-btn-group>.q-btn-item .q-btn__wrapper:before{box-shadow:none}.q-btn-group>.q-btn-item .q-badge--floating{right:0}.q-btn-group>.q-btn-group{box-shadow:none}.q-btn-group>.q-btn-group:first-child>.q-btn:first-child{border-top-left-radius:inherit;border-bottom-left-radius:inherit}.q-btn-group>.q-btn-group:last-child>.q-btn:last-child{border-top-right-radius:inherit;border-bottom-right-radius:inherit}.q-btn-group>.q-btn-group:not(:first-child)>.q-btn:first-child .q-btn__wrapper:before{border-left:0}.q-btn-group>.q-btn-group:not(:last-child)>.q-btn:last-child .q-btn__wrapper:before{border-right:0}.q-btn-group>.q-btn-item:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.q-btn-group>.q-btn-item:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.q-btn-group>.q-btn-item.q-btn--standard .q-btn__wrapper:before{z-index:-1}.q-btn-group--push{border-radius:7px}.q-btn-group--push>.q-btn--push.q-btn--actionable{transform:none}.q-btn-group--push>.q-btn--push.q-btn--actionable .q-btn__wrapper{transition:margin-top .3s cubic-bezier(.25,.8,.5,1),margin-bottom .3s cubic-bezier(.25,.8,.5,1),box-shadow .3s cubic-bezier(.25,.8,.5,1)}.q-btn-group--push>.q-btn--push.q-btn--actionable.q-btn--active .q-btn__wrapper,.q-btn-group--push>.q-btn--push.q-btn--actionable:active .q-btn__wrapper{margin-top:2px;margin-bottom:-2px}.q-btn-group--rounded{border-radius:28px}.q-btn-group--square{border-radius:0}.q-btn-group--flat,.q-btn-group--outline,.q-btn-group--unelevated{box-shadow:none}.q-btn-group--outline>.q-separator{display:none}.q-btn-group--outline>.q-btn-item+.q-btn-item .q-btn__wrapper:before{border-left:0}.q-btn-group--outline>.q-btn-item:not(:last-child) .q-btn__wrapper:before{border-right:0}.q-btn-group--stretch{align-self:stretch;border-radius:0}.q-btn-group--glossy>.q-btn-item{background-image:linear-gradient(180deg,hsla(0,0%,100%,.3),hsla(0,0%,100%,0) 50%,rgba(0,0,0,.12) 51%,rgba(0,0,0,.04))!important}.q-btn-group--spread>.q-btn-group{display:flex!important}.q-btn-group--spread>.q-btn-group>.q-btn-item:not(.q-btn-dropdown__arrow-container),.q-btn-group--spread>.q-btn-item{width:auto;min-width:0;max-width:100%;flex:10000 1 0%}.q-btn-toggle,.q-card{position:relative}.q-card{box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);border-radius:4px;vertical-align:top;background:#fff}.q-card>div:first-child,.q-card>img:first-child{border-top:0;border-top-left-radius:inherit;border-top-right-radius:inherit}.q-card>div:last-child,.q-card>img:last-child{border-bottom:0;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.q-card>div:not(:first-child),.q-card>img:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.q-card>div:not(:last-child),.q-card>img:not(:last-child){border-bottom-left-radius:0;border-bottom-right-radius:0}.q-card>div{border-left:0;border-right:0;box-shadow:none}.q-card--bordered{border:1px solid rgba(0,0,0,.12)}.q-card--dark{border-color:hsla(0,0%,100%,.28)}.q-card__section{position:relative}.q-card__section--vert{padding:16px}.q-card__section--horiz>div:first-child,.q-card__section--horiz>img:first-child{border-top-left-radius:inherit;border-bottom-left-radius:inherit}.q-card__section--horiz>div:last-child,.q-card__section--horiz>img:last-child{border-top-right-radius:inherit;border-bottom-right-radius:inherit}.q-card__section--horiz>div:not(:first-child),.q-card__section--horiz>img:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.q-card__section--horiz>div:not(:last-child),.q-card__section--horiz>img:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.q-card__section--horiz>div{border-top:0;border-bottom:0;box-shadow:none}.q-card__actions{padding:8px;align-items:center}.q-card__actions .q-btn--rectangle .q-btn__wrapper{padding:0 8px}.q-card__actions--horiz>.q-btn-group+.q-btn-item,.q-card__actions--horiz>.q-btn-item+.q-btn-group,.q-card__actions--horiz>.q-btn-item+.q-btn-item{margin-left:8px}.q-card__actions--vert>.q-btn-item.q-btn--round{align-self:center}.q-card__actions--vert>.q-btn-group+.q-btn-item,.q-card__actions--vert>.q-btn-item+.q-btn-group,.q-card__actions--vert>.q-btn-item+.q-btn-item{margin-top:4px}.q-card__actions--vert>.q-btn-group>.q-btn-item{flex-grow:1}.q-card>img{display:block;width:100%;max-width:100%;border:0}.q-carousel{background-color:#fff;height:400px}.q-carousel__slide{min-height:100%;background-size:cover;background-position:50%}.q-carousel .q-carousel--padding,.q-carousel__slide{padding:16px}.q-carousel__slides-container{height:100%}.q-carousel__control{color:#fff}.q-carousel__arrow{pointer-events:none}.q-carousel__arrow .q-icon{font-size:28px}.q-carousel__arrow .q-btn{pointer-events:all}.q-carousel__next-arrow--horizontal,.q-carousel__prev-arrow--horizontal{top:16px;bottom:16px}.q-carousel__prev-arrow--horizontal{left:16px}.q-carousel__next-arrow--horizontal{right:16px}.q-carousel__next-arrow--vertical,.q-carousel__prev-arrow--vertical{left:16px;right:16px}.q-carousel__prev-arrow--vertical{top:16px}.q-carousel__next-arrow--vertical{bottom:16px}.q-carousel__navigation--bottom,.q-carousel__navigation--top{left:16px;right:16px;overflow-x:auto;overflow-y:hidden}.q-carousel__navigation--top{top:16px}.q-carousel__navigation--bottom{bottom:16px}.q-carousel__navigation--left,.q-carousel__navigation--right{top:16px;bottom:16px;overflow-x:hidden;overflow-y:auto}.q-carousel__navigation--left>.q-carousel__navigation-inner,.q-carousel__navigation--right>.q-carousel__navigation-inner{flex-direction:column}.q-carousel__navigation--left{left:16px}.q-carousel__navigation--right{right:16px}.q-carousel__navigation-inner{flex:1 1 auto}.q-carousel__navigation .q-btn{margin:6px 4px}.q-carousel__navigation .q-btn .q-btn__wrapper{padding:5px}.q-carousel__navigation-icon--inactive{opacity:.7}.q-carousel .q-carousel__thumbnail{margin:2px;height:50px;width:auto;display:inline-block;cursor:pointer;border:1px solid transparent;border-radius:4px;vertical-align:middle;opacity:.7;transition:opacity .3s}.q-carousel .q-carousel__thumbnail--active,.q-carousel .q-carousel__thumbnail:hover{opacity:1}.q-carousel .q-carousel__thumbnail--active{border-color:currentColor;cursor:default}.q-carousel--arrows-vertical .q-carousel--padding,.q-carousel--arrows-vertical.q-carousel--with-padding .q-carousel__slide,.q-carousel--navigation-top .q-carousel--padding,.q-carousel--navigation-top.q-carousel--with-padding .q-carousel__slide{padding-top:60px}.q-carousel--arrows-vertical .q-carousel--padding,.q-carousel--arrows-vertical.q-carousel--with-padding .q-carousel__slide,.q-carousel--navigation-bottom .q-carousel--padding,.q-carousel--navigation-bottom.q-carousel--with-padding .q-carousel__slide{padding-bottom:60px}.q-carousel--arrows-horizontal .q-carousel--padding,.q-carousel--arrows-horizontal.q-carousel--with-padding .q-carousel__slide,.q-carousel--navigation-left .q-carousel--padding,.q-carousel--navigation-left.q-carousel--with-padding .q-carousel__slide{padding-left:60px}.q-carousel--arrows-horizontal .q-carousel--padding,.q-carousel--arrows-horizontal.q-carousel--with-padding .q-carousel__slide,.q-carousel--navigation-right .q-carousel--padding,.q-carousel--navigation-right.q-carousel--with-padding .q-carousel__slide{padding-right:60px}.q-carousel.fullscreen{height:100%}.q-message-label,.q-message-name,.q-message-stamp{font-size:small}.q-message-label{margin:24px 0;text-align:center}.q-message-stamp{color:inherit;margin-top:4px;opacity:.6;display:none}.q-message-avatar{border-radius:50%;width:48px;height:48px;min-width:48px}.q-message{margin-bottom:8px}.q-message:first-child .q-message-label{margin-top:0}.q-message-avatar--received{margin-right:8px}.q-message-text--received{color:#81c784;border-radius:4px 4px 4px 0}.q-message-text--received:last-child:before{right:100%;border-right:0 solid transparent;border-left:8px solid transparent;border-bottom:8px solid currentColor}.q-message-text-content--received{color:#000}.q-message-name--sent{text-align:right}.q-message-avatar--sent{margin-left:8px}.q-message-container--sent{flex-direction:row-reverse}.q-message-text--sent{color:#e0e0e0;border-radius:4px 4px 0 4px}.q-message-text--sent:last-child:before{left:100%;border-left:0 solid transparent;border-right:8px solid transparent;border-bottom:8px solid currentColor}.q-message-text-content--sent{color:#000}.q-message-text{background:currentColor;padding:8px;line-height:1.2;word-break:break-word;position:relative}.q-message-text+.q-message-text{margin-top:3px}.q-message-text:last-child{min-height:48px}.q-message-text:last-child .q-message-stamp{display:block}.q-message-text:last-child:before{content:\"\";position:absolute;bottom:0;width:0;height:0}.q-checkbox{vertical-align:middle}.q-checkbox__native{width:1px;height:1px}.q-checkbox__bg,.q-checkbox__icon-container{user-select:none}.q-checkbox__bg{top:25%;left:25%;width:50%;height:50%;border:2px solid currentColor;border-radius:2px;transition:background .22s cubic-bezier(0,0,.2,1) 0ms;-webkit-print-color-adjust:exact}.q-checkbox__icon{color:currentColor;font-size:.5em}.q-checkbox__svg{color:#fff}.q-checkbox__truthy{stroke:currentColor;stroke-width:3.12px;stroke-dashoffset:29.78334;stroke-dasharray:29.78334}.q-checkbox__indet{fill:currentColor;transform-origin:50% 50%;transform:rotate(-280deg) scale(0)}.q-checkbox__inner{font-size:40px;width:1em;min-width:1em;height:1em;outline:0;border-radius:50%;color:rgba(0,0,0,.54)}.q-checkbox__inner--indet,.q-checkbox__inner--truthy{color:#027be3;color:var(--q-color-primary)}.q-checkbox__inner--indet .q-checkbox__bg,.q-checkbox__inner--truthy .q-checkbox__bg{background:currentColor}.q-checkbox__inner--truthy path{stroke-dashoffset:0;transition:stroke-dashoffset .18s cubic-bezier(.4,0,.6,1) 0ms}.q-checkbox__inner--indet .q-checkbox__indet{transform:rotate(0) scale(1);transition:transform .22s cubic-bezier(0,0,.2,1) 0ms}.q-checkbox.disabled{opacity:.75!important}.q-checkbox--dark .q-checkbox__inner{color:hsla(0,0%,100%,.7)}.q-checkbox--dark .q-checkbox__inner:before{opacity:.32!important}.q-checkbox--dark .q-checkbox__inner--indet,.q-checkbox--dark .q-checkbox__inner--truthy{color:#027be3;color:var(--q-color-primary)}.q-checkbox--dense .q-checkbox__inner{width:.5em;min-width:.5em;height:.5em}.q-checkbox--dense .q-checkbox__bg{left:5%;top:5%;width:90%;height:90%}.q-checkbox--dense .q-checkbox__label{padding-left:.5em}.q-checkbox--dense.reverse .q-checkbox__label{padding-left:0;padding-right:.5em}body.desktop .q-checkbox:not(.disabled) .q-checkbox__inner:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:50%;background:currentColor;opacity:.12;transform:scale3d(0,0,1);transition:transform .22s cubic-bezier(0,0,.2,1)}body.desktop .q-checkbox:not(.disabled):focus .q-checkbox__inner:before,body.desktop .q-checkbox:not(.disabled):hover .q-checkbox__inner:before{transform:scaleX(1)}body.desktop .q-checkbox--dense:not(.disabled):focus .q-checkbox__inner:before,body.desktop .q-checkbox--dense:not(.disabled):hover .q-checkbox__inner:before{transform:scale3d(1.4,1.4,1)}.q-chip{vertical-align:middle;border-radius:16px;outline:0;position:relative;height:2em;max-width:100%;margin:4px;background:#e0e0e0;color:rgba(0,0,0,.87);font-size:14px;padding:.5em .9em}.q-chip--colored .q-chip__icon,.q-chip--dark .q-chip__icon{color:inherit}.q-chip--outline{background:transparent!important;border:1px solid currentColor}.q-chip .q-avatar{font-size:2em;margin-left:-.45em;margin-right:.2em;border-radius:16px}.q-chip--selected .q-avatar{display:none}.q-chip__icon{color:rgba(0,0,0,.54);font-size:1.5em;margin:-.2em}.q-chip__icon--left{margin-right:.2em}.q-chip__icon--right{margin-left:.2em}.q-chip__icon--remove{margin-left:.1em;margin-right:-.5em;opacity:.6;outline:0}.q-chip__icon--remove:focus,.q-chip__icon--remove:hover{opacity:1}.q-chip__content{white-space:nowrap}.q-chip--dense{border-radius:12px;padding:0 .4em;height:1.5em}.q-chip--dense .q-avatar{font-size:1.5em;margin-left:-.27em;margin-right:.1em;border-radius:12px}.q-chip--dense .q-chip__icon{font-size:1.25em}.q-chip--dense .q-chip__icon--left{margin-right:.195em}.q-chip--dense .q-chip__icon--remove{margin-right:-.25em}.q-chip--square{border-radius:4px}.q-chip--square .q-avatar{border-radius:3px 0 0 3px}body.desktop .q-chip--clickable:focus{box-shadow:0 1px 3px rgba(0,0,0,.2),0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.q-circular-progress{display:inline-block;position:relative;vertical-align:middle;width:1em;height:1em;line-height:1}.q-circular-progress.q-focusable{border-radius:50%}.q-circular-progress__svg{width:100%;height:100%}.q-circular-progress__text{font-size:.25em}.q-circular-progress--indeterminate .q-circular-progress__svg{transform-origin:50% 50%;animation:q-spin 2s linear infinite}.q-circular-progress--indeterminate .q-circular-progress__circle{stroke-dasharray:1 400;stroke-dashoffset:0;animation:q-circular-progress-circle 1.5s ease-in-out infinite}.q-color-picker{overflow:hidden;background:#fff;max-width:350px;vertical-align:top;min-width:180px;border-radius:4px;box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)}.q-color-picker .q-tab{padding:0!important}.q-color-picker--bordered{border:1px solid rgba(0,0,0,.12)}.q-color-picker__header-tabs{height:32px}.q-color-picker__header input{line-height:24px;border:0}.q-color-picker__header .q-tab{min-height:32px!important;height:32px!important}.q-color-picker__header .q-tab--inactive{background:linear-gradient(0deg,rgba(0,0,0,.3) 0,rgba(0,0,0,.15) 25%,rgba(0,0,0,.1))}.q-color-picker__error-icon{bottom:2px;right:2px;font-size:24px;opacity:0;transition:opacity .3s ease-in}.q-color-picker__header-content{position:relative;background:#fff}.q-color-picker__header-content--light{color:#000}.q-color-picker__header-content--dark{color:#fff}.q-color-picker__header-content--dark .q-tab--inactive:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;background:hsla(0,0%,100%,.2)}.q-color-picker__header-banner{height:36px}.q-color-picker__header-bg{background:#fff;background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==\")!important}.q-color-picker__footer{height:36px}.q-color-picker__footer .q-tab{min-height:36px!important;height:36px!important}.q-color-picker__footer .q-tab--inactive{background:linear-gradient(180deg,rgba(0,0,0,.3) 0,rgba(0,0,0,.15) 25%,rgba(0,0,0,.1))}.q-color-picker__spectrum{width:100%;height:100%}.q-color-picker__spectrum-tab{padding:0!important}.q-color-picker__spectrum-white{background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.q-color-picker__spectrum-black{background:linear-gradient(0deg,#000,transparent)}.q-color-picker__spectrum-circle{width:10px;height:10px;box-shadow:0 0 0 1.5px #fff,inset 0 0 1px 1px rgba(0,0,0,.3),0 0 1px 2px rgba(0,0,0,.4);border-radius:50%;transform:translate(-5px,-5px)}.q-color-picker__hue .q-slider__track{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)!important;opacity:1}.q-color-picker__alpha .q-slider__track-container{padding-top:0}.q-color-picker__alpha .q-slider__track:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:inherit;background:linear-gradient(90deg,hsla(0,0%,100%,0),#757575)}.q-color-picker__sliders{padding:0 16px}.q-color-picker__sliders .q-slider__thumb{color:#424242}.q-color-picker__sliders .q-slider__thumb path{stroke-width:2px;fill:transparent}.q-color-picker__sliders .q-slider--active path{stroke-width:3px}.q-color-picker__tune-tab .q-slider{margin-left:18px;margin-right:18px}.q-color-picker__tune-tab input{font-size:11px;border:1px solid #e0e0e0;border-radius:4px;width:3.5em}.q-color-picker__palette-tab{padding:0!important}.q-color-picker__palette-rows--editable .q-color-picker__cube{cursor:pointer}.q-color-picker__cube{padding-bottom:10%;width:10%!important}.q-color-picker input{color:inherit;background:transparent;outline:0;text-align:center}.q-color-picker .q-tabs{overflow:hidden}.q-color-picker .q-tab--active{box-shadow:0 0 14px 3px rgba(0,0,0,.2)}.q-color-picker .q-tab--active .q-focus-helper,.q-color-picker .q-tab__indicator{display:none}.q-color-picker .q-tab-panels{background:inherit}.q-color-picker--dark .q-color-picker__tune-tab input{border:1px solid hsla(0,0%,100%,.3)}.q-color-picker--dark .q-slider{color:#fafafa}.q-date{display:inline-flex;box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);border-radius:4px;background:#fff;width:290px;min-width:290px;max-width:100%}.q-date--bordered{border:1px solid rgba(0,0,0,.12)}.q-date__header{border-top-left-radius:inherit;color:#fff;background-color:#027be3;background-color:var(--q-color-primary);padding:16px}.q-date__actions{padding:0 16px 16px}.q-date__content,.q-date__main{outline:0}.q-date__content .q-btn{font-weight:400}.q-date__header-link{opacity:.64;outline:0;transition:opacity .3s ease-out}.q-date__header-link--active,.q-date__header-link:focus,.q-date__header-link:hover{opacity:1}.q-date__header-subtitle{font-size:14px;line-height:1.75;letter-spacing:.00938em}.q-date__header-title-label{font-size:24px;line-height:1.2;letter-spacing:.00735em}.q-date__view{height:100%;width:100%;min-height:290px;padding:16px}.q-date__navigation{height:12.5%}.q-date__navigation>div:first-child{width:8%;min-width:24px;justify-content:flex-end}.q-date__navigation>div:last-child{width:8%;min-width:24px;justify-content:flex-start}.q-date__calendar-weekdays{height:12.5%}.q-date__calendar-weekdays>div{opacity:.38;font-size:12px}.q-date__calendar-item{display:inline-flex;align-items:center;justify-content:center;vertical-align:middle;width:14.285%!important;height:12.5%!important;position:relative;padding:1px}.q-date__calendar-item:after{content:\"\";position:absolute;pointer-events:none;top:1px;right:0;bottom:1px;left:0;border-style:dashed;border-color:transparent;border-width:1px}.q-date__calendar-item>div,.q-date__calendar-item button{width:30px;height:30px;border-radius:50%}.q-date__calendar-item>div{line-height:30px;text-align:center}.q-date__calendar-item>button{line-height:22px}.q-date__calendar-item--out{opacity:.18}.q-date__calendar-item--fill{visibility:hidden}.q-date__range-from:before,.q-date__range-to:before,.q-date__range:before{content:\"\";background-color:currentColor;position:absolute;top:1px;bottom:1px;left:0;right:0;opacity:.3}.q-date__range-from:nth-child(7n-6):before,.q-date__range-to:nth-child(7n-6):before,.q-date__range:nth-child(7n-6):before{border-top-left-radius:0;border-bottom-left-radius:0}.q-date__range-from:nth-child(7n):before,.q-date__range-to:nth-child(7n):before,.q-date__range:nth-child(7n):before{border-top-right-radius:0;border-bottom-right-radius:0}.q-date__range-from:before{left:50%}.q-date__range-to:before{right:50%}.q-date__edit-range:after{border-color:currentColor transparent}.q-date__edit-range:nth-child(7n-6):after{border-top-left-radius:0;border-bottom-left-radius:0}.q-date__edit-range:nth-child(7n):after{border-top-right-radius:0;border-bottom-right-radius:0}.q-date__edit-range-from-to:after,.q-date__edit-range-from:after{left:4px;border-left-color:currentColor;border-top-color:currentColor;border-bottom-color:currentColor;border-top-left-radius:28px;border-bottom-left-radius:28px}.q-date__edit-range-from-to:after,.q-date__edit-range-to:after{right:4px;border-right-color:currentColor;border-top-color:currentColor;border-bottom-color:currentColor;border-top-right-radius:28px;border-bottom-right-radius:28px}.q-date__calendar-days-container{height:75%;min-height:192px}.q-date__calendar-days>div{height:16.66%!important}.q-date__event{position:absolute;bottom:2px;left:50%;height:5px;width:8px;border-radius:5px;background-color:#00a9e0;background-color:var(--q-color-secondary);transform:translate3d(-50%,0,0)}.q-date__today{box-shadow:0 0 1px 0 currentColor}.q-date__years-content{padding:0 8px}.q-date__months-item,.q-date__years-item{flex:0 0 33.3333%}.q-date--readonly .q-date__content,.q-date--readonly .q-date__header,.q-date.disabled .q-date__content,.q-date.disabled .q-date__header{pointer-events:none}.q-date--readonly .q-date__navigation{display:none}.q-date--portrait{flex-direction:column}.q-date--portrait-standard .q-date__content{height:calc(100% - 86px)}.q-date--portrait-standard .q-date__header{border-top-right-radius:inherit;height:86px}.q-date--portrait-standard .q-date__header-title{align-items:center;height:30px}.q-date--portrait-minimal .q-date__content{height:100%}.q-date--landscape{flex-direction:row;align-items:stretch;min-width:420px}.q-date--landscape>div{display:flex;flex-direction:column}.q-date--landscape .q-date__content{height:100%}.q-date--landscape-standard{min-width:420px}.q-date--landscape-standard .q-date__header{border-bottom-left-radius:inherit;min-width:110px;width:110px}.q-date--landscape-standard .q-date__header-title{flex-direction:column}.q-date--landscape-standard .q-date__header-today{margin-top:12px;margin-left:-8px}.q-date--landscape-minimal{width:310px}.q-date--dark{border-color:hsla(0,0%,100%,.28)}.q-dialog__title{font-size:1.25rem;font-weight:500;line-height:2rem;letter-spacing:.0125em}.q-dialog__progress{font-size:4rem}.q-dialog__inner{outline:0}.q-dialog__inner>div{pointer-events:all;overflow:auto;-webkit-overflow-scrolling:touch;will-change:scroll-position;border-radius:4px;box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px rgba(0,0,0,.14),0 1px 10px rgba(0,0,0,.12)}.q-dialog__inner--square>div{border-radius:0!important}.q-dialog__inner>.q-card>.q-card__actions .q-btn--rectangle .q-btn__wrapper{min-width:64px}.q-dialog__inner--minimized{padding:24px}.q-dialog__inner--minimized>div{max-height:calc(100vh - 48px)}.q-dialog__inner--maximized>div{height:100%;width:100%;max-height:100vh;max-width:100vw;border-radius:0!important}.q-dialog__inner--bottom,.q-dialog__inner--top{padding-top:0!important;padding-bottom:0!important}.q-dialog__inner--left,.q-dialog__inner--right{padding-right:0!important;padding-left:0!important}.q-dialog__inner--left:not(.q-dialog__inner--animating)>div,.q-dialog__inner--top:not(.q-dialog__inner--animating)>div{border-top-left-radius:0}.q-dialog__inner--right:not(.q-dialog__inner--animating)>div,.q-dialog__inner--top:not(.q-dialog__inner--animating)>div{border-top-right-radius:0}.q-dialog__inner--bottom:not(.q-dialog__inner--animating)>div,.q-dialog__inner--left:not(.q-dialog__inner--animating)>div{border-bottom-left-radius:0}.q-dialog__inner--bottom:not(.q-dialog__inner--animating)>div,.q-dialog__inner--right:not(.q-dialog__inner--animating)>div{border-bottom-right-radius:0}.q-dialog__inner--fullwidth>div{width:100%!important;max-width:100%!important}.q-dialog__inner--fullheight>div{height:100%!important;max-height:100%!important}.q-dialog__backdrop{z-index:-1;pointer-events:all;outline:0;background:rgba(0,0,0,.4)}body.platform-android:not(.native-mobile) .q-dialog__inner--minimized>div,body.platform-ios .q-dialog__inner--minimized>div{max-height:calc(100vh - 108px)}body.q-ios-padding .q-dialog__inner{padding-top:20px!important;padding-top:env(safe-area-inset-top)!important;padding-bottom:env(safe-area-inset-bottom)!important}body.q-ios-padding .q-dialog__inner>div{max-height:calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom))!important}@media (max-width:599.98px){.q-dialog__inner--bottom,.q-dialog__inner--top{padding-left:0;padding-right:0}.q-dialog__inner--bottom>div,.q-dialog__inner--top>div{width:100%!important}}@media (min-width:600px){.q-dialog__inner--minimized>div{max-width:560px}}.q-body--dialog{overflow:hidden}.q-bottom-sheet{padding-bottom:8px}.q-bottom-sheet__avatar{border-radius:50%}.q-bottom-sheet--list{width:400px}.q-bottom-sheet--list .q-icon,.q-bottom-sheet--list img{font-size:24px;width:24px;height:24px}.q-bottom-sheet--grid{width:700px}.q-bottom-sheet--grid .q-bottom-sheet__item{padding:8px;text-align:center;min-width:100px}.q-bottom-sheet--grid .q-bottom-sheet__empty-icon,.q-bottom-sheet--grid .q-icon,.q-bottom-sheet--grid img{font-size:48px;width:48px;height:48px;margin-bottom:8px}.q-bottom-sheet--grid .q-separator{margin:12px 0}.q-bottom-sheet__item{flex:0 0 33.3333%}@media (min-width:600px){.q-bottom-sheet__item{flex:0 0 25%}}.q-dialog-plugin{width:400px}.q-dialog-plugin__form{max-height:50vh}.q-dialog-plugin .q-card__section+.q-card__section{padding-top:0}.q-dialog-plugin--progress{text-align:center}.q-editor{border:1px solid rgba(0,0,0,.12);border-radius:4px;background-color:#fff}.q-editor.disabled{border-style:dashed}.q-editor.fullscreen{max-height:100%}.q-editor>div:first-child,.q-editor__toolbars-container,.q-editor__toolbars-container>div:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.q-editor__toolbars-container{max-width:100%}.q-editor__content{outline:0;padding:10px;min-height:10em;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;overflow:auto;max-width:100%}.q-editor__content pre{white-space:pre-wrap}.q-editor__content hr{border:0;outline:0;margin:1px;height:1px;background:rgba(0,0,0,.12)}.q-editor__content:empty:not(:focus):before{content:attr(placeholder);opacity:.7}.q-editor__toolbar{border-bottom:1px solid rgba(0,0,0,.12);min-height:32px}.q-editor .q-btn{margin:4px}.q-editor__toolbar-group{position:relative;margin:0 4px}.q-editor__toolbar-group+.q-editor__toolbar-group:before{content:\"\";position:absolute;left:-4px;top:4px;bottom:4px;width:1px;background:rgba(0,0,0,.12)}.q-editor__link-input{color:inherit;text-decoration:none;text-transform:none;border:none;border-radius:0;background:none;outline:0}.q-editor--flat,.q-editor--flat .q-editor__toolbar{border:0}.q-editor--dense .q-editor__toolbar-group{display:flex;align-items:center;flex-wrap:nowrap}.q-editor--dark{border-color:hsla(0,0%,100%,.28)}.q-editor--dark .q-editor__content hr{background:hsla(0,0%,100%,.28)}.q-editor--dark .q-editor__toolbar{border-color:hsla(0,0%,100%,.28)}.q-editor--dark .q-editor__toolbar-group+.q-editor__toolbar-group:before{background:hsla(0,0%,100%,.28)}.q-expansion-item__border{opacity:0}.q-expansion-item__toggle-icon{position:relative;transition:transform .3s}.q-expansion-item__toggle-icon--rotated{transform:rotate(180deg)}.q-expansion-item__toggle-focus{width:1em!important;height:1em!important;position:relative!important}.q-expansion-item__toggle-focus+.q-expansion-item__toggle-icon{margin-top:-1em}.q-expansion-item--standard.q-expansion-item--expanded>div>.q-expansion-item__border{opacity:1}.q-expansion-item--popup{transition:padding .5s}.q-expansion-item--popup>.q-expansion-item__container{border:1px solid rgba(0,0,0,.12)}.q-expansion-item--popup>.q-expansion-item__container>.q-separator{display:none}.q-expansion-item--popup.q-expansion-item--collapsed{padding:0 15px}.q-expansion-item--popup.q-expansion-item--expanded{padding:15px 0}.q-expansion-item--popup.q-expansion-item--expanded+.q-expansion-item--popup.q-expansion-item--expanded{padding-top:0}.q-expansion-item--popup.q-expansion-item--collapsed:not(:first-child)>.q-expansion-item__container{border-top-width:0}.q-expansion-item--popup.q-expansion-item--expanded+.q-expansion-item--popup.q-expansion-item--collapsed>.q-expansion-item__container{border-top-width:1px}.q-expansion-item__content>.q-card{box-shadow:none;border-radius:0}.q-expansion-item--expanded+.q-expansion-item--expanded>div>.q-expansion-item__border--top,.q-expansion-item:first-child>div>.q-expansion-item__border--top,.q-expansion-item:last-child>div>.q-expansion-item__border--bottom{opacity:0}.q-expansion-item--expanded .q-textarea--autogrow textarea{animation:q-expansion-done 0s}.z-fab{z-index:990}.q-fab{position:relative;vertical-align:middle}.q-fab>.q-btn{width:100%}.q-fab--form-rounded{border-radius:28px}.q-fab--form-square{border-radius:4px}.q-fab__active-icon,.q-fab__icon{transition:opacity .4s,transform .4s}.q-fab__icon{opacity:1;transform:rotate(0deg)}.q-fab__active-icon{opacity:0;transform:rotate(-180deg)}.q-fab__label--external{position:absolute;padding:0 8px;transition:opacity .18s cubic-bezier(.65,.815,.735,.395)}.q-fab__label--external-hidden{opacity:0;pointer-events:none}.q-fab__label--external-left{top:50%;left:-12px;transform:translate(-100%,-50%)}.q-fab__label--external-right{top:50%;right:-12px;transform:translate(100%,-50%)}.q-fab__label--external-bottom{bottom:-12px;left:50%;transform:translate(-50%,100%)}.q-fab__label--external-top{top:-12px;left:50%;transform:translate(-50%,-100%)}.q-fab__label--internal{padding:0;transition:font-size .12s cubic-bezier(.65,.815,.735,.395),max-height .12s cubic-bezier(.65,.815,.735,.395),opacity .07s cubic-bezier(.65,.815,.735,.395);max-height:30px}.q-fab__label--internal-hidden{font-size:0;opacity:0}.q-fab__label--internal-top{padding-bottom:.12em}.q-fab__label--internal-bottom{padding-top:.12em}.q-fab__label--internal-bottom.q-fab__label--internal-hidden,.q-fab__label--internal-top.q-fab__label--internal-hidden{max-height:0}.q-fab__label--internal-left{padding-left:.285em;padding-right:.571em}.q-fab__label--internal-right{padding-right:.285em;padding-left:.571em}.q-fab__icon-holder{min-width:24px;min-height:24px;position:relative}.q-fab__icon-holder--opened .q-fab__icon{transform:rotate(180deg);opacity:0}.q-fab__icon-holder--opened .q-fab__active-icon{transform:rotate(0deg);opacity:1}.q-fab__actions{position:absolute;opacity:0;transition:transform .18s ease-in,opacity .18s ease-in;pointer-events:none;align-items:center;justify-content:center;align-self:center;padding:3px}.q-fab__actions .q-btn{margin:5px}.q-fab__actions--right{transform-origin:0 50%;transform:scale(.4) translateX(-62px);height:56px;left:100%;margin-left:9px}.q-fab__actions--left{transform-origin:100% 50%;transform:scale(.4) translateX(62px);height:56px;right:100%;margin-right:9px;flex-direction:row-reverse}.q-fab__actions--up{transform-origin:50% 100%;transform:scale(.4) translateY(62px);width:56px;bottom:100%;margin-bottom:9px;flex-direction:column-reverse}.q-fab__actions--down{transform-origin:50% 0;transform:scale(.4) translateY(-62px);width:56px;top:100%;margin-top:9px;flex-direction:column}.q-fab__actions--down,.q-fab__actions--up{left:50%;margin-left:-28px}.q-fab__actions--opened{opacity:1;transform:scale(1) translate(.1px);pointer-events:all}.q-fab--align-left>.q-fab__actions--down,.q-fab--align-left>.q-fab__actions--up{align-items:flex-start;left:28px}.q-fab--align-right>.q-fab__actions--down,.q-fab--align-right>.q-fab__actions--up{align-items:flex-end;left:auto;right:0}.q-field{font-size:14px}.q-field ::-ms-clear,.q-field ::-ms-reveal{display:none}.q-field--with-bottom{padding-bottom:20px}.q-field__marginal{height:56px;color:rgba(0,0,0,.54);font-size:24px}.q-field__marginal>*+*{margin-left:2px}.q-field__marginal .q-avatar{font-size:32px}.q-field__before,.q-field__prepend{padding-right:12px}.q-field__after,.q-field__append{padding-left:12px}.q-field__after:empty,.q-field__append:empty{display:none}.q-field__append+.q-field__append{padding-left:2px}.q-field__inner{text-align:left}.q-field__bottom{font-size:12px;min-height:20px;line-height:1;color:rgba(0,0,0,.54);padding:8px 12px 0;backface-visibility:hidden}.q-field__bottom--animated{transform:translateY(100%);position:absolute;left:0;right:0;bottom:0}.q-field__messages{line-height:1}.q-field__messages>div{word-break:break-word;word-wrap:break-word;overflow-wrap:break-word}.q-field__messages>div+div{margin-top:4px}.q-field__counter{padding-left:8px;line-height:1}.q-field--item-aligned{padding:8px 16px}.q-field--item-aligned .q-field__before{min-width:56px}.q-field__control-container{height:inherit}.q-field__control{color:#027be3;color:var(--q-color-primary);height:56px;max-width:100%;outline:none}.q-field__control:after,.q-field__control:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none}.q-field__control:before{border-radius:inherit}.q-field__shadow{top:8px;opacity:0;overflow:hidden;white-space:pre-wrap;transition:opacity .36s cubic-bezier(.4,0,.2,1)}.q-field__shadow+.q-field__native::placeholder{transition:opacity .36s cubic-bezier(.4,0,.2,1)}.q-field__shadow+.q-field__native:focus::placeholder{opacity:0}.q-field__input,.q-field__native,.q-field__prefix,.q-field__suffix{font-weight:400;line-height:28px;letter-spacing:.00937em;text-decoration:inherit;text-transform:inherit;border:none;border-radius:0;background:none;color:rgba(0,0,0,.87);outline:0;padding:6px 0}.q-field__input,.q-field__native{width:100%;min-width:0;outline:0!important;user-select:auto}.q-field__input:-webkit-autofill,.q-field__native:-webkit-autofill{-webkit-animation-name:q-autofill;-webkit-animation-fill-mode:both}.q-field__input:-webkit-autofill+.q-field__label,.q-field__native:-webkit-autofill+.q-field__label{transform:translateY(-40%) scale(.75)}.q-field__input[type=color]+.q-field__label,.q-field__input[type=date]+.q-field__label,.q-field__input[type=datetime-local]+.q-field__label,.q-field__input[type=month]+.q-field__label,.q-field__input[type=time]+.q-field__label,.q-field__input[type=week]+.q-field__label,.q-field__native[type=color]+.q-field__label,.q-field__native[type=date]+.q-field__label,.q-field__native[type=datetime-local]+.q-field__label,.q-field__native[type=month]+.q-field__label,.q-field__native[type=time]+.q-field__label,.q-field__native[type=week]+.q-field__label{transform:translateY(-40%) scale(.75)}.q-field__input:invalid,.q-field__native:invalid{box-shadow:none}.q-field__native[type=file]{line-height:1em}.q-field__input{padding:0;height:0;min-height:24px;line-height:24px}.q-field__prefix,.q-field__suffix{transition:opacity .36s cubic-bezier(.4,0,.2,1);white-space:nowrap}.q-field__prefix{padding-right:4px}.q-field__suffix{padding-left:4px}.q-field--disabled .q-placeholder,.q-field--readonly .q-placeholder{opacity:1!important}.q-field--readonly.q-field--labeled .q-field__input,.q-field--readonly.q-field--labeled .q-field__native{cursor:default}.q-field--readonly.q-field--float .q-field__input,.q-field--readonly.q-field--float .q-field__native{cursor:text}.q-field--disabled .q-field__inner{cursor:not-allowed}.q-field--disabled .q-field__control{pointer-events:none}.q-field--disabled .q-field__control>div{opacity:.6!important}.q-field--disabled .q-field__control>div,.q-field--disabled .q-field__control>div *{outline:0!important}.q-field__label{left:0;right:0;top:18px;color:rgba(0,0,0,.6);font-size:16px;line-height:20px;font-weight:400;letter-spacing:.00937em;text-decoration:inherit;text-transform:inherit;transform-origin:left top;transition:transform .36s cubic-bezier(.4,0,.2,1),right .324s cubic-bezier(.4,0,.2,1);backface-visibility:hidden}.q-field--float .q-field__label{transform:translateY(-40%) scale(.75);right:-33.33333%;transition:transform .36s cubic-bezier(.4,0,.2,1),right .396s cubic-bezier(.4,0,.2,1)}.q-field--highlighted .q-field__label{color:currentColor}.q-field--highlighted .q-field__shadow{opacity:.5}.q-field--filled .q-field__control{padding:0 12px;background:rgba(0,0,0,.05);border-radius:4px 4px 0 0}.q-field--filled .q-field__control:before{background:rgba(0,0,0,.05);border-bottom:1px solid rgba(0,0,0,.42);opacity:0;transition:opacity .36s cubic-bezier(.4,0,.2,1),background .36s cubic-bezier(.4,0,.2,1)}.q-field--filled .q-field__control:hover:before{opacity:1}.q-field--filled .q-field__control:after{height:2px;top:auto;transform-origin:center bottom;transform:scaleX(0);background:currentColor;transition:transform .36s cubic-bezier(.4,0,.2,1)}.q-field--filled.q-field--rounded .q-field__control{border-radius:28px 28px 0 0}.q-field--filled.q-field--highlighted .q-field__control:before{opacity:1;background:rgba(0,0,0,.12)}.q-field--filled.q-field--highlighted .q-field__control:after{transform:scaleX(1)}.q-field--filled.q-field--dark .q-field__control,.q-field--filled.q-field--dark .q-field__control:before{background:hsla(0,0%,100%,.07)}.q-field--filled.q-field--dark.q-field--highlighted .q-field__control:before{background:hsla(0,0%,100%,.1)}.q-field--filled.q-field--readonly .q-field__control:before{opacity:1;background:transparent;border-bottom-style:dashed}.q-field--outlined .q-field__control{border-radius:4px;padding:0 12px}.q-field--outlined .q-field__control:before{border:1px solid rgba(0,0,0,.24);transition:border-color .36s cubic-bezier(.4,0,.2,1)}.q-field--outlined .q-field__control:hover:before{border-color:#000}.q-field--outlined .q-field__control:after{height:inherit;border-radius:inherit;border:2px solid transparent;transition:border-color .36s cubic-bezier(.4,0,.2,1)}.q-field--outlined .q-field__input:-webkit-autofill,.q-field--outlined .q-field__native:-webkit-autofill{margin-top:1px;margin-bottom:1px}.q-field--outlined.q-field--rounded .q-field__control{border-radius:28px}.q-field--outlined.q-field--highlighted .q-field__control:hover:before{border-color:transparent}.q-field--outlined.q-field--highlighted .q-field__control:after{border-color:currentColor;border-width:2px;transform:scaleX(1)}.q-field--outlined.q-field--readonly .q-field__control:before{border-style:dashed}.q-field--standard .q-field__control:before{border-bottom:1px solid rgba(0,0,0,.24);transition:border-color .36s cubic-bezier(.4,0,.2,1)}.q-field--standard .q-field__control:hover:before{border-color:#000}.q-field--standard .q-field__control:after{height:2px;top:auto;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;transform-origin:center bottom;transform:scaleX(0);background:currentColor;transition:transform .36s cubic-bezier(.4,0,.2,1)}.q-field--standard.q-field--highlighted .q-field__control:after{transform:scaleX(1)}.q-field--standard.q-field--readonly .q-field__control:before{border-bottom-style:dashed}.q-field--dark .q-field__control:before{border-color:hsla(0,0%,100%,.6)}.q-field--dark .q-field__control:hover:before{border-color:#fff}.q-field--dark .q-field__input,.q-field--dark .q-field__native,.q-field--dark .q-field__prefix,.q-field--dark .q-field__suffix{color:#fff}.q-field--dark .q-field__bottom,.q-field--dark .q-field__marginal,.q-field--dark:not(.q-field--highlighted) .q-field__label{color:hsla(0,0%,100%,.7)}.q-field--standout .q-field__control{padding:0 12px;background:rgba(0,0,0,.05);border-radius:4px;transition:box-shadow .36s cubic-bezier(.4,0,.2,1),background-color .36s cubic-bezier(.4,0,.2,1)}.q-field--standout .q-field__control:before{background:rgba(0,0,0,.07);opacity:0;transition:opacity .36s cubic-bezier(.4,0,.2,1),background .36s cubic-bezier(.4,0,.2,1)}.q-field--standout .q-field__control:hover:before{opacity:1}.q-field--standout.q-field--rounded .q-field__control{border-radius:28px}.q-field--standout.q-field--highlighted .q-field__control{box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);background:#000}.q-field--standout.q-field--highlighted .q-field__append,.q-field--standout.q-field--highlighted .q-field__input,.q-field--standout.q-field--highlighted .q-field__native,.q-field--standout.q-field--highlighted .q-field__prefix,.q-field--standout.q-field--highlighted .q-field__prepend,.q-field--standout.q-field--highlighted .q-field__suffix{color:#fff}.q-field--standout.q-field--readonly .q-field__control:before{opacity:1;background:transparent;border:1px dashed rgba(0,0,0,.24)}.q-field--standout.q-field--dark .q-field__control,.q-field--standout.q-field--dark .q-field__control:before{background:hsla(0,0%,100%,.07)}.q-field--standout.q-field--dark.q-field--highlighted .q-field__control{background:#fff}.q-field--standout.q-field--dark.q-field--highlighted .q-field__append,.q-field--standout.q-field--dark.q-field--highlighted .q-field__input,.q-field--standout.q-field--dark.q-field--highlighted .q-field__native,.q-field--standout.q-field--dark.q-field--highlighted .q-field__prefix,.q-field--standout.q-field--dark.q-field--highlighted .q-field__prepend,.q-field--standout.q-field--dark.q-field--highlighted .q-field__suffix{color:#000}.q-field--standout.q-field--dark.q-field--readonly .q-field__control:before{border-color:hsla(0,0%,100%,.24)}.q-field--labeled .q-field__native,.q-field--labeled .q-field__prefix,.q-field--labeled .q-field__suffix{line-height:24px;padding-top:24px;padding-bottom:8px}.q-field--labeled .q-field__shadow{top:0}.q-field--labeled:not(.q-field--float) .q-field__prefix,.q-field--labeled:not(.q-field--float) .q-field__suffix{opacity:0}.q-field--labeled:not(.q-field--float) .q-field__input::placeholder,.q-field--labeled:not(.q-field--float) .q-field__native::placeholder{color:transparent}.q-field--labeled.q-field--dense .q-field__native,.q-field--labeled.q-field--dense .q-field__prefix,.q-field--labeled.q-field--dense .q-field__suffix{padding-top:14px;padding-bottom:2px}.q-field--dense .q-field__shadow{top:0}.q-field--dense .q-field__control,.q-field--dense .q-field__marginal{height:40px}.q-field--dense .q-field__bottom{font-size:11px}.q-field--dense .q-field__label{font-size:14px;top:10px}.q-field--dense .q-field__before,.q-field--dense .q-field__prepend{padding-right:6px}.q-field--dense .q-field__after,.q-field--dense .q-field__append{padding-left:6px}.q-field--dense .q-field__append+.q-field__append{padding-left:2px}.q-field--dense .q-field__marginal .q-avatar{font-size:24px}.q-field--dense.q-field--float .q-field__label{transform:translateY(-30%) scale(.75)}.q-field--dense .q-field__input:-webkit-autofill+.q-field__label,.q-field--dense .q-field__native:-webkit-autofill+.q-field__label{transform:translateY(-30%) scale(.75)}.q-field--dense .q-field__input[type=color]+.q-field__label,.q-field--dense .q-field__input[type=date]+.q-field__label,.q-field--dense .q-field__input[type=datetime-local]+.q-field__label,.q-field--dense .q-field__input[type=month]+.q-field__label,.q-field--dense .q-field__input[type=time]+.q-field__label,.q-field--dense .q-field__input[type=week]+.q-field__label,.q-field--dense .q-field__native[type=color]+.q-field__label,.q-field--dense .q-field__native[type=date]+.q-field__label,.q-field--dense .q-field__native[type=datetime-local]+.q-field__label,.q-field--dense .q-field__native[type=month]+.q-field__label,.q-field--dense .q-field__native[type=time]+.q-field__label,.q-field--dense .q-field__native[type=week]+.q-field__label{transform:translateY(-30%) scale(.75)}.q-field--borderless.q-field--dense .q-field__control,.q-field--borderless .q-field__bottom,.q-field--standard.q-field--dense .q-field__control,.q-field--standard .q-field__bottom{padding-left:0;padding-right:0}.q-field--error .q-field__label{animation:q-field-label .36s}.q-field--error .q-field__bottom{color:#c10015;color:var(--q-color-negative)}.q-field__focusable-action{opacity:.6;cursor:pointer;outline:0!important;border:0;color:inherit;background:transparent;padding:0}.q-field__focusable-action:focus,.q-field__focusable-action:hover{opacity:1}.q-field--auto-height .q-field__control{height:auto}.q-field--auto-height .q-field__control,.q-field--auto-height .q-field__native{min-height:56px}.q-field--auto-height .q-field__native{align-items:center}.q-field--auto-height .q-field__control-container{padding-top:0}.q-field--auto-height .q-field__native,.q-field--auto-height .q-field__prefix,.q-field--auto-height .q-field__suffix{line-height:18px}.q-field--auto-height.q-field--labeled .q-field__control-container{padding-top:24px}.q-field--auto-height.q-field--labeled .q-field__shadow{top:24px}.q-field--auto-height.q-field--labeled .q-field__native,.q-field--auto-height.q-field--labeled .q-field__prefix,.q-field--auto-height.q-field--labeled .q-field__suffix{padding-top:0}.q-field--auto-height.q-field--labeled .q-field__native{min-height:24px}.q-field--auto-height.q-field--dense .q-field__control,.q-field--auto-height.q-field--dense .q-field__native{min-height:40px}.q-field--auto-height.q-field--dense.q-field--labeled .q-field__control-container{padding-top:14px}.q-field--auto-height.q-field--dense.q-field--labeled .q-field__shadow{top:14px}.q-field--auto-height.q-field--dense.q-field--labeled .q-field__native{min-height:24px}.q-field--square .q-field__control{border-radius:0!important}.q-transition--field-message-enter-active,.q-transition--field-message-leave-active{transition:transform .6s cubic-bezier(.86,0,.07,1),opacity .6s cubic-bezier(.86,0,.07,1)}.q-transition--field-message-enter,.q-transition--field-message-leave-to{opacity:0;transform:translateY(-10px)}.q-transition--field-message-leave,.q-transition--field-message-leave-active{position:absolute}.q-file .q-field__native{word-break:break-all}.q-file .q-field__input{opacity:0!important}.q-file .q-field__input::-webkit-file-upload-button{cursor:pointer}.q-file__filler{visibility:hidden;width:100%;border:none;padding:0}.q-file__dnd{outline:1px dashed currentColor;outline-offset:-4px}.q-form,.q-img{position:relative}.q-img{width:100%;display:inline-block;vertical-align:middle}.q-img__loading .q-spinner{font-size:50px}.q-img__image{border-radius:inherit;background-repeat:no-repeat}.q-img__content{overflow:hidden;border-radius:inherit}.q-img__content>div{position:absolute;padding:16px;color:#fff;background:rgba(0,0,0,.47)}.q-img--menu .q-img__image{pointer-events:none}.q-img--menu .q-img__image>img{pointer-events:all;opacity:0}.q-img--menu .q-img__content{pointer-events:none}.q-img--menu .q-img__content>div{pointer-events:all}.q-inner-loading{background:hsla(0,0%,100%,.6)}.q-inner-loading--dark{background:rgba(0,0,0,.4)}.q-inner-loading__label{margin-top:8px}.q-textarea .q-field__control{min-height:56px;height:auto}.q-textarea .q-field__control-container{padding-top:2px;padding-bottom:2px}.q-textarea .q-field__shadow{top:2px;bottom:2px}.q-textarea .q-field__native,.q-textarea .q-field__prefix,.q-textarea .q-field__suffix{line-height:18px}.q-textarea .q-field__native{resize:vertical;padding-top:17px;min-height:52px}.q-textarea.q-field--labeled .q-field__control-container{padding-top:26px}.q-textarea.q-field--labeled .q-field__shadow{top:26px}.q-textarea.q-field--labeled .q-field__native,.q-textarea.q-field--labeled .q-field__prefix,.q-textarea.q-field--labeled .q-field__suffix{padding-top:0}.q-textarea.q-field--labeled .q-field__native{min-height:26px;padding-top:1px}.q-textarea--autogrow .q-field__native{resize:none}.q-textarea.q-field--dense .q-field__control,.q-textarea.q-field--dense .q-field__native{min-height:36px}.q-textarea.q-field--dense .q-field__native{padding-top:9px}.q-textarea.q-field--dense.q-field--labeled .q-field__control-container{padding-top:14px}.q-textarea.q-field--dense.q-field--labeled .q-field__shadow{top:14px}.q-textarea.q-field--dense.q-field--labeled .q-field__native{min-height:24px;padding-top:3px}.q-textarea.q-field--dense.q-field--labeled .q-field__prefix,.q-textarea.q-field--dense.q-field--labeled .q-field__suffix{padding-top:2px}.q-textarea.disabled .q-field__native,body.mobile .q-textarea .q-field__native{resize:none}.q-intersection{position:relative}.q-item{min-height:48px;padding:8px 16px;color:inherit;transition:color .3s,background-color .3s}.q-item__section--side{color:#757575;align-items:flex-start;padding-right:16px;width:auto;min-width:0;max-width:100%}.q-item__section--side>.q-icon{font-size:24px}.q-item__section--side>.q-avatar{font-size:40px}.q-item__section--avatar{color:inherit;min-width:56px}.q-item__section--thumbnail img{width:100px;height:56px}.q-item__section--nowrap{white-space:nowrap}.q-item>.q-focus-helper+.q-item__section--thumbnail,.q-item>.q-item__section--thumbnail:first-child{margin-left:-16px}.q-item>.q-item__section--thumbnail:last-of-type{margin-right:-16px}.q-item__label{line-height:1.2em!important;max-width:100%}.q-item__label--overline{color:rgba(0,0,0,.7)}.q-item__label--caption{color:rgba(0,0,0,.54)}.q-item__label--header{color:#757575;padding:16px;font-size:.875rem;line-height:1.25rem;letter-spacing:.01786em}.q-list--padding .q-item__label--header,.q-separator--spaced+.q-item__label--header{padding-top:8px}.q-item__label+.q-item__label{margin-top:4px}.q-item__section--main{width:auto;min-width:0;max-width:100%;flex:10000 1 0%}.q-item__section--main+.q-item__section--main{margin-left:8px}.q-item__section--main~.q-item__section--side{align-items:flex-end;padding-right:0;padding-left:16px}.q-item__section--main.q-item__section--thumbnail{margin-left:0;margin-right:-16px}.q-list--bordered{border:1px solid rgba(0,0,0,.12)}.q-list--separator>.q-item-type+.q-item-type,.q-list--separator>.q-virtual-scroll__content>.q-item-type+.q-item-type{border-top:1px solid rgba(0,0,0,.12)}.q-list--padding{padding:8px 0}.q-item--dense,.q-list--dense>.q-item{min-height:32px;padding:2px 16px}.q-list--dark.q-list--separator>.q-item-type+.q-item-type,.q-list--dark.q-list--separator>.q-virtual-scroll__content>.q-item-type+.q-item-type{border-top-color:hsla(0,0%,100%,.28)}.q-item--dark,.q-list--dark{color:#fff;border-color:hsla(0,0%,100%,.28)}.q-item--dark .q-item__section--side:not(.q-item__section--avatar),.q-list--dark .q-item__section--side:not(.q-item__section--avatar){color:hsla(0,0%,100%,.7)}.q-item--dark .q-item__label--header,.q-list--dark .q-item__label--header{color:hsla(0,0%,100%,.64)}.q-item--dark .q-item__label--caption,.q-item--dark .q-item__label--overline,.q-list--dark .q-item__label--caption,.q-list--dark .q-item__label--overline{color:hsla(0,0%,100%,.8)}.q-item{position:relative}.q-item--active,.q-item.q-router-link--active{color:#027be3;color:var(--q-color-primary)}.q-knob{font-size:48px}.q-knob--editable{cursor:pointer;outline:0}.q-knob--editable:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:50%;box-shadow:none;transition:box-shadow .24s ease-in-out}.q-knob--editable:focus:before{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px rgba(0,0,0,.14),0 1px 10px rgba(0,0,0,.12)}.q-layout{width:100%;outline:0}.q-layout-container{position:relative;width:100%;height:100%}.q-layout-container .q-layout{min-height:100%}.q-layout-container>div{transform:translateZ(0)}.q-layout-container>div>div{min-height:0;max-height:100%}.q-layout__shadow{width:100%}.q-layout__shadow:after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;box-shadow:0 0 10px 2px rgba(0,0,0,.2),0 0 10px rgba(0,0,0,.24)}.q-layout__section--marginal{background-color:#027be3;background-color:var(--q-color-primary);color:#fff}.q-header--hidden{transform:translateY(-110%)}.q-header--bordered{border-bottom:1px solid rgba(0,0,0,.12)}.q-header .q-layout__shadow{bottom:-10px}.q-header .q-layout__shadow:after{bottom:10px}.q-footer--hidden{transform:translateY(110%)}.q-footer--bordered{border-top:1px solid rgba(0,0,0,.12)}.q-footer .q-layout__shadow{top:-10px}.q-footer .q-layout__shadow:after{top:10px}.q-footer,.q-header{z-index:2000}.q-drawer{position:absolute;top:0;bottom:0;background:#fff;z-index:1000}.q-drawer--on-top{z-index:3000}.q-drawer--left{left:0;transform:translateX(-100%)}.q-drawer--left.q-drawer--bordered{border-right:1px solid rgba(0,0,0,.12)}.q-drawer--left .q-layout__shadow{left:10px;right:-10px}.q-drawer--left .q-layout__shadow:after{right:10px}.q-drawer--right{right:0;transform:translateX(100%)}.q-drawer--right.q-drawer--bordered{border-left:1px solid rgba(0,0,0,.12)}.q-drawer--right .q-layout__shadow{left:-10px}.q-drawer--right .q-layout__shadow:after{left:10px}.q-drawer-container:not(.q-drawer--mini-animate) .q-drawer--mini{padding:0!important}.q-drawer-container:not(.q-drawer--mini-animate) .q-drawer--mini .q-item,.q-drawer-container:not(.q-drawer--mini-animate) .q-drawer--mini .q-item__section{text-align:center;justify-content:center;padding-left:0;padding-right:0;min-width:0}.q-drawer--mini .q-expansion-item__content,.q-drawer--mini .q-mini-drawer-hide,.q-drawer-container:not(.q-drawer--mini-animate) .q-drawer--mini .q-item__label,.q-drawer-container:not(.q-drawer--mini-animate) .q-drawer--mini .q-item__section--main,.q-drawer-container:not(.q-drawer--mini-animate) .q-drawer--mini .q-item__section--side~.q-item__section--side{display:none}.q-drawer--mini-animate .q-drawer__content{overflow-x:hidden;white-space:nowrap}.q-drawer--mobile .q-mini-drawer-hide,.q-drawer--mobile .q-mini-drawer-only,.q-drawer--standard .q-mini-drawer-only{display:none}.q-drawer__backdrop{z-index:2999!important;will-change:background-color}.q-drawer__opener{z-index:2001;height:100%;width:15px;user-select:none}.q-footer,.q-header,.q-layout,.q-page{position:relative}.q-page-sticky--shrink{pointer-events:none}.q-page-sticky--shrink>div{display:inline-block;pointer-events:auto}body.q-ios-padding .q-layout--standard .q-drawer--top-padding .q-drawer__content,body.q-ios-padding .q-layout--standard .q-header>.q-tabs:first-child .q-tabs-head,body.q-ios-padding .q-layout--standard .q-header>.q-toolbar:first-child{padding-top:20px;min-height:70px;padding-top:env(safe-area-inset-top);min-height:calc(env(safe-area-inset-top) + 50px)}body.q-ios-padding .q-layout--standard .q-drawer--top-padding .q-drawer__content,body.q-ios-padding .q-layout--standard .q-footer>.q-tabs:last-child .q-tabs-head,body.q-ios-padding .q-layout--standard .q-footer>.q-toolbar:last-child{padding-bottom:env(safe-area-inset-bottom);min-height:calc(env(safe-area-inset-bottom) + 50px)}.q-body--layout-animate .q-drawer__backdrop{transition:background-color .12s!important}.q-body--layout-animate .q-drawer{transition:transform .12s,width .12s,top .12s,bottom .12s!important}.q-body--layout-animate .q-layout__section--marginal{transition:transform .12s,left .12s,right .12s!important}.q-body--layout-animate .q-page-container{transition:padding-top .12s,padding-right .12s,padding-bottom .12s,padding-left .12s!important}.q-body--layout-animate .q-page-sticky{transition:transform .12s,left .12s,right .12s,top .12s,bottom .12s!important}body:not(.q-body--layout-animate) .q-layout--prevent-focus{visibility:hidden}.q-body--drawer-toggle{overflow-x:hidden!important}@media (max-width:599.98px){.q-layout-padding{padding:8px}}@media (min-width:600px) and (max-width:1439.98px){.q-layout-padding{padding:16px}}@media (min-width:1440px){.q-layout-padding{padding:24px}}body.body--dark .q-drawer,body.body--dark .q-footer,body.body--dark .q-header{border-color:hsla(0,0%,100%,.28)}body.platform-ios .q-layout--containerized{position:unset!important}.q-linear-progress{position:relative;width:100%;overflow:hidden;font-size:4px;height:1em;color:#027be3;color:var(--q-color-primary);transform:scaleX(1)}.q-linear-progress__model,.q-linear-progress__track{transform-origin:0 0}.q-linear-progress__model--with-transition,.q-linear-progress__track--with-transition{transition:transform .3s}.q-linear-progress--reverse .q-linear-progress__model,.q-linear-progress--reverse .q-linear-progress__track{transform-origin:0 100%}.q-linear-progress__model--determinate{background:currentColor}.q-linear-progress__model--indeterminate,.q-linear-progress__model--query{transition:none}.q-linear-progress__model--indeterminate:after,.q-linear-progress__model--indeterminate:before,.q-linear-progress__model--query:after,.q-linear-progress__model--query:before{background:currentColor;content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;transform-origin:0 0}.q-linear-progress__model--indeterminate:before,.q-linear-progress__model--query:before{animation:q-linear-progress--indeterminate 2.1s cubic-bezier(.65,.815,.735,.395) infinite}.q-linear-progress__model--indeterminate:after,.q-linear-progress__model--query:after{transform:translate3d(-101%,0,0) scaleX(1);animation:q-linear-progress--indeterminate-short 2.1s cubic-bezier(.165,.84,.44,1) infinite;animation-delay:1.15s}.q-linear-progress__track{opacity:.4}.q-linear-progress__track--light{background:rgba(0,0,0,.26)}.q-linear-progress__track--dark{background:hsla(0,0%,100%,.6)}.q-linear-progress__stripe{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0) 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0))!important;background-size:40px 40px!important}.q-linear-progress__stripe--with-transition{transition:width .3s}.q-menu{position:fixed!important;display:inline-block;max-width:95vw;box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);background:#fff;border-radius:4px;overflow-y:auto;overflow-x:hidden;outline:0;max-height:65vh;z-index:6000}.q-menu--square{border-radius:0}.q-option-group--inline>div{display:inline-block}.q-pagination input{text-align:center;-moz-appearance:textfield}.q-pagination input::-webkit-inner-spin-button,.q-pagination input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.q-pagination__content{margin-top:-2px;margin-left:-2px}.q-pagination__content>.q-btn,.q-pagination__content>.q-input,.q-pagination__middle>.q-btn{margin-top:2px;margin-left:2px}.q-parallax{position:relative;width:100%;overflow:hidden;border-radius:inherit}.q-parallax__media>img,.q-parallax__media>video{position:absolute;left:50%;bottom:0;min-width:100%;min-height:100%;will-change:transform;display:none}.q-popup-edit{padding:8px 16px}.q-popup-edit__buttons{margin-top:8px}.q-popup-edit__buttons .q-btn+.q-btn{margin-left:8px}.q-pull-to-refresh{position:relative}.q-pull-to-refresh__puller{border-radius:50%;width:40px;height:40px;color:#027be3;color:var(--q-color-primary);background:#fff;box-shadow:0 0 4px 0 rgba(0,0,0,.3)}.q-pull-to-refresh__puller--animating{transition:transform .3s,opacity .3s}.q-radio{vertical-align:middle}.q-radio__native{width:1px;height:1px}.q-radio__bg,.q-radio__icon-container{user-select:none}.q-radio__bg{top:25%;left:25%;width:50%;height:50%;-webkit-print-color-adjust:exact}.q-radio__bg path{fill:currentColor}.q-radio__icon{color:currentColor;font-size:.5em}.q-radio__check{transform-origin:50% 50%;transform:scale3d(0,0,1);transition:transform .22s cubic-bezier(0,0,.2,1) 0ms}.q-radio__inner{font-size:40px;width:1em;min-width:1em;height:1em;outline:0;border-radius:50%;color:rgba(0,0,0,.54)}.q-radio__inner--truthy{color:#027be3;color:var(--q-color-primary)}.q-radio__inner--truthy .q-radio__check{transform:scaleX(1)}.q-radio.disabled{opacity:.75!important}.q-radio--dark .q-radio__inner{color:hsla(0,0%,100%,.7)}.q-radio--dark .q-radio__inner:before{opacity:.32!important}.q-radio--dark .q-radio__inner--truthy{color:#027be3;color:var(--q-color-primary)}.q-radio--dense .q-radio__inner{width:.5em;min-width:.5em;height:.5em}.q-radio--dense .q-radio__bg{left:0;top:0;width:100%;height:100%}.q-radio--dense .q-radio__label{padding-left:.5em}.q-radio--dense.reverse .q-radio__label{padding-left:0;padding-right:.5em}body.desktop .q-radio:not(.disabled) .q-radio__inner:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:50%;background:currentColor;opacity:.12;transform:scale3d(0,0,1);transition:transform .22s cubic-bezier(0,0,.2,1) 0ms}body.desktop .q-radio:not(.disabled):focus .q-radio__inner:before,body.desktop .q-radio:not(.disabled):hover .q-radio__inner:before{transform:scaleX(1)}body.desktop .q-radio--dense:not(.disabled):focus .q-radio__inner:before,body.desktop .q-radio--dense:not(.disabled):hover .q-radio__inner:before{transform:scale3d(1.5,1.5,1)}.q-rating{color:#ffeb3b;vertical-align:middle}.q-rating__icon-container{height:1em;outline:0}.q-rating__icon-container+.q-rating__icon-container{margin-left:2px}.q-rating__icon{color:currentColor;text-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);position:relative;opacity:.4;transition:transform .2s ease-in,opacity .2s ease-in}.q-rating__icon--hovered{transform:scale(1.3)}.q-rating__icon--active{opacity:1}.q-rating__icon--exselected{opacity:.7}.q-rating--no-dimming .q-rating__icon{opacity:1}.q-rating--editable .q-rating__icon-container{cursor:pointer}.q-responsive{position:relative;max-width:100%;max-height:100%}.q-responsive__filler{width:inherit;max-width:inherit;height:inherit;max-height:inherit}.q-responsive__content{border-radius:inherit}.q-responsive__content>*{width:100%!important;height:100%!important;max-height:100%!important;max-width:100%!important}.q-scrollarea{position:relative;contain:strict}.q-scrollarea__bar,.q-scrollarea__thumb{opacity:.2;transition:opacity .3s;will-change:opacity;cursor:grab}.q-scrollarea__bar--v,.q-scrollarea__thumb--v{right:0;width:10px}.q-scrollarea__bar--h,.q-scrollarea__thumb--h{bottom:0;height:10px}.q-scrollarea__bar--invisible,.q-scrollarea__thumb--invisible{opacity:0!important;pointer-events:none}.q-scrollarea__thumb{background:#000}.q-scrollarea__thumb:hover{opacity:.3}.q-scrollarea__thumb:active{opacity:.5}.q-scrollarea__content{min-height:100%;min-width:100%}.q-scrollarea--dark .q-scrollarea__thumb{background:#fff}.q-select--without-input .q-field__control{cursor:pointer}.q-select--with-input .q-field__control{cursor:text}.q-select .q-field__input{min-width:50px!important;cursor:text}.q-select .q-field__input--padding{padding-left:4px}.q-select__autocomplete-input,.q-select__focus-target{position:absolute;outline:0!important;width:1px;height:1px;padding:0;border:0;opacity:0}.q-select__dropdown-icon{cursor:pointer;transition:transform .28s}.q-select.q-field--readonly .q-field__control,.q-select.q-field--readonly .q-select__dropdown-icon{cursor:default}.q-select__dialog{width:90vw!important;max-width:90vw!important;max-height:calc(100vh - 70px)!important;background:#fff;display:flex;flex-direction:column}.q-select__dialog>.scroll{position:relative;background:inherit}body.mobile:not(.native-mobile) .q-select__dialog{max-height:calc(100vh - 108px)!important}body.platform-android.native-mobile .q-dialog__inner--top .q-select__dialog{max-height:calc(100vh - 24px)!important}body.platform-android:not(.native-mobile) .q-dialog__inner--top .q-select__dialog{max-height:calc(100vh - 80px)!important}body.platform-ios.native-mobile .q-dialog__inner--top>div{border-radius:4px}body.platform-ios.native-mobile .q-dialog__inner--top .q-select__dialog--focused{max-height:47vh!important}body.platform-ios:not(.native-mobile) .q-dialog__inner--top .q-select__dialog--focused{max-height:50vh!important}.q-separator{border:0;background:rgba(0,0,0,.12);margin:0;transition:background .3s,opacity .3s;flex-shrink:0}.q-separator--dark{background:hsla(0,0%,100%,.28)}.q-separator--horizontal{display:block;height:1px}.q-separator--horizontal-inset{margin-left:16px;margin-right:16px}.q-separator--horizontal-item-inset{margin-left:72px;margin-right:0}.q-separator--horizontal-item-thumbnail-inset{margin-left:116px;margin-right:0}.q-separator--vertical{width:1px;height:auto;align-self:stretch}.q-separator--vertical-inset{margin-top:8px;margin-bottom:8px}.q-skeleton{background:rgba(0,0,0,.12);border-radius:4px;box-sizing:border-box}.q-skeleton--anim{cursor:wait}.q-skeleton:before{content:\"\\00a0\"}.q-skeleton--type-text{transform:scaleY(.5)}.q-skeleton--type-circle,.q-skeleton--type-QAvatar{height:48px;width:48px;border-radius:50%}.q-skeleton--type-QBtn{width:90px;height:36px}.q-skeleton--type-QBadge{width:70px;height:16px}.q-skeleton--type-QChip{width:90px;height:28px;border-radius:16px}.q-skeleton--type-QToolbar{height:50px}.q-skeleton--type-QCheckbox,.q-skeleton--type-QRadio{width:40px;height:40px;border-radius:50%}.q-skeleton--type-QToggle{width:56px;height:40px;border-radius:7px}.q-skeleton--type-QRange,.q-skeleton--type-QSlider{height:40px}.q-skeleton--type-QInput{height:56px}.q-skeleton--bordered{border:1px solid rgba(0,0,0,.05)}.q-skeleton--square{border-radius:0}.q-skeleton--anim-fade{animation:q-skeleton--fade 1.5s linear .5s infinite}.q-skeleton--anim-pulse{animation:q-skeleton--pulse 1.5s ease-in-out .5s infinite}.q-skeleton--anim-pulse-x{animation:q-skeleton--pulse-x 1.5s ease-in-out .5s infinite}.q-skeleton--anim-pulse-y{animation:q-skeleton--pulse-y 1.5s ease-in-out .5s infinite}.q-skeleton--anim-blink,.q-skeleton--anim-pop,.q-skeleton--anim-wave{position:relative;overflow:hidden;z-index:1}.q-skeleton--anim-blink:after,.q-skeleton--anim-pop:after,.q-skeleton--anim-wave:after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;z-index:0}.q-skeleton--anim-blink:after{background:hsla(0,0%,100%,.7);animation:q-skeleton--fade 1.5s linear .5s infinite}.q-skeleton--anim-wave:after{background:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));animation:q-skeleton--wave 1.5s linear .5s infinite}.q-skeleton--dark{background:hsla(0,0%,100%,.05)}.q-skeleton--dark.q-skeleton--bordered{border:1px solid hsla(0,0%,100%,.25)}.q-skeleton--dark.q-skeleton--anim-wave:after{background:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.1),hsla(0,0%,100%,0))}.q-skeleton--dark.q-skeleton--anim-blink:after{background:hsla(0,0%,100%,.2)}.q-slide-item{position:relative;background:#fff}.q-slide-item__bottom,.q-slide-item__left,.q-slide-item__right,.q-slide-item__top{visibility:hidden;font-size:14px;color:#fff}.q-slide-item__bottom .q-icon,.q-slide-item__left .q-icon,.q-slide-item__right .q-icon,.q-slide-item__top .q-icon{font-size:1.714em}.q-slide-item__left{background:#4caf50;padding:8px 16px}.q-slide-item__left>div{transform-origin:left center}.q-slide-item__right{background:#ff9800;padding:8px 16px}.q-slide-item__right>div{transform-origin:right center}.q-slide-item__top{background:#2196f3;padding:16px 8px}.q-slide-item__top>div{transform-origin:top center}.q-slide-item__bottom{background:#9c27b0;padding:16px 8px}.q-slide-item__bottom>div{transform-origin:bottom center}.q-slide-item__content{background:inherit;transition:transform .2s ease-in;user-select:none;cursor:pointer}.q-slider{position:relative}.q-slider--h{width:100%}.q-slider--v{height:200px}.q-slider--editable .q-slider__track-container{cursor:grab}.q-slider__track-container{outline:0}.q-slider__track-container--h{width:100%;padding:12px 0}.q-slider__track-container--h .q-slider__selection{will-change:width,left}.q-slider__track-container--v{height:100%;padding:0 12px}.q-slider__track-container--v .q-slider__selection{will-change:height,top}.q-slider__track{color:#027be3;color:var(--q-color-primary);background:rgba(0,0,0,.1);border-radius:4px;width:inherit;height:inherit}.q-slider__inner{background:rgba(0,0,0,.1)}.q-slider__inner,.q-slider__selection{border-radius:inherit;width:100%;height:100%}.q-slider__selection{background:currentColor}.q-slider__markers{color:rgba(0,0,0,.3);border-radius:inherit;width:100%;height:100%}.q-slider__markers:after{content:\"\";position:absolute;background:currentColor}.q-slider__markers--h{background-image:repeating-linear-gradient(90deg,currentColor,currentColor 2px,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0))}.q-slider__markers--h:after{height:100%;width:2px;top:0;right:0}.q-slider__markers--v{background-image:repeating-linear-gradient(180deg,currentColor,currentColor 2px,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0))}.q-slider__markers--v:after{width:100%;height:2px;left:0;bottom:0}.q-slider__marker-labels-container{position:relative;width:100%;height:100%;min-height:24px;min-width:24px}.q-slider__marker-labels{position:absolute}.q-slider__marker-labels--h-standard{top:0}.q-slider__marker-labels--h-switched{bottom:0}.q-slider__marker-labels--h-ltr{transform:translateX(-50%)}.q-slider__marker-labels--h-rtl{transform:translateX(50%)}.q-slider__marker-labels--v-standard{left:4px}.q-slider__marker-labels--v-switched{right:4px}.q-slider__marker-labels--v-ltr{transform:translateY(-50%)}.q-slider__marker-labels--v-rtl{transform:translateY(50%)}.q-slider__thumb{z-index:1;outline:0;color:#027be3;color:var(--q-color-primary);transition:transform .18s ease-out,fill .18s ease-out,stroke .18s ease-out}.q-slider__thumb.q-slider--focus{opacity:1!important}.q-slider__thumb--h{top:50%;will-change:left}.q-slider__thumb--h-ltr{transform:scale(1) translate(-50%,-50%)}.q-slider__thumb--h-rtl{transform:scale(1) translate(50%,-50%)}.q-slider__thumb--v{left:50%;will-change:top}.q-slider__thumb--v-ltr{transform:scale(1) translate(-50%,-50%)}.q-slider__thumb--v-rtl{transform:scale(1) translate(-50%,50%)}.q-slider__thumb-shape{top:0;left:0;stroke-width:3.5;stroke:currentColor;transition:transform .28s}.q-slider__thumb-shape path{stroke:currentColor;fill:currentColor}.q-slider__focus-ring{border-radius:50%;opacity:0;transition:transform .26667s ease-out,opacity .26667s ease-out,background-color .26667s ease-out;transition-delay:.14s}.q-slider__pin{opacity:0;white-space:nowrap;transition:opacity .28s ease-out;transition-delay:.14s}.q-slider__pin:before{content:\"\";width:0;height:0;position:absolute}.q-slider__pin--h:before{border-left:6px solid transparent;border-right:6px solid transparent;left:50%;transform:translateX(-50%)}.q-slider__pin--h-standard{bottom:100%}.q-slider__pin--h-standard:before{bottom:2px;border-top:6px solid currentColor}.q-slider__pin--h-switched{top:100%}.q-slider__pin--h-switched:before{top:2px;border-bottom:6px solid currentColor}.q-slider__pin--v{top:0}.q-slider__pin--v:before{top:50%;transform:translateY(-50%);border-top:6px solid transparent;border-bottom:6px solid transparent}.q-slider__pin--v-standard{left:100%}.q-slider__pin--v-standard:before{left:2px;border-right:6px solid currentColor}.q-slider__pin--v-switched{right:100%}.q-slider__pin--v-switched:before{right:2px;border-left:6px solid currentColor}.q-slider__label{z-index:1;white-space:nowrap;position:absolute}.q-slider__label--h{left:50%;transform:translateX(-50%)}.q-slider__label--h-standard{bottom:7px}.q-slider__label--h-switched{top:7px}.q-slider__label--v{top:50%;transform:translateY(-50%)}.q-slider__label--v-standard{left:7px}.q-slider__label--v-switched{right:7px}.q-slider__text-container{min-height:25px;padding:2px 8px;border-radius:4px;background:currentColor;position:relative;text-align:center}.q-slider__text{color:#fff;font-size:12px}.q-slider--no-value .q-slider__inner,.q-slider--no-value .q-slider__selection,.q-slider--no-value .q-slider__thumb{opacity:0}.q-slider--focus .q-slider__focus-ring,body.desktop .q-slider.q-slider--editable .q-slider__track-container:hover .q-slider__focus-ring{background:currentColor;transform:scale3d(1.55,1.55,1);opacity:.25}.q-slider--focus .q-slider__inner,.q-slider--focus .q-slider__selection,.q-slider--focus .q-slider__thumb,body.desktop .q-slider.q-slider--editable .q-slider__track-container:hover .q-slider__inner,body.desktop .q-slider.q-slider--editable .q-slider__track-container:hover .q-slider__selection,body.desktop .q-slider.q-slider--editable .q-slider__track-container:hover .q-slider__thumb{opacity:1}.q-slider--inactive .q-slider__thumb--h{transition:left .28s,right .28s}.q-slider--inactive .q-slider__thumb--v{transition:top .28s,bottom .28s}.q-slider--inactive .q-slider__selection{transition:width .28s,left .28s,right .28s,height .28s,top .28s,bottom .28s}.q-slider--inactive .q-slider__text-container{transition:transform .28s}.q-slider--active{cursor:grabbing}.q-slider--active .q-slider__thumb-shape{transform:scale(1.5)}.q-slider--active.q-slider--label .q-slider__thumb-shape,.q-slider--active .q-slider__focus-ring{transform:scale(0)!important}.q-slider--label.q-slider--active .q-slider__pin,.q-slider--label .q-slider--focus .q-slider__pin,.q-slider--label.q-slider--label-always .q-slider__pin,body.desktop .q-slider.q-slider--enabled .q-slider__track-container:hover .q-slider__pin{opacity:1}.q-slider--dark .q-slider__inner,.q-slider--dark .q-slider__track{background:hsla(0,0%,100%,.1)}.q-slider--dark .q-slider__markers{color:hsla(0,0%,100%,.3)}.q-slider--dense .q-slider__track-container--h{padding:6px 0}.q-slider--dense .q-slider__track-container--v{padding:0 6px}.q-space{flex-grow:1!important}.q-spinner{vertical-align:middle}.q-spinner-mat{animation:q-spin 2s linear infinite;transform-origin:center center}.q-spinner-mat .path{stroke-dasharray:1,200;stroke-dashoffset:0;animation:q-mat-dash 1.5s ease-in-out infinite}.q-splitter__panel{position:relative;z-index:0}.q-splitter__panel>.q-splitter{width:100%;height:100%}.q-splitter__separator{background-color:rgba(0,0,0,.12);user-select:none;position:relative;z-index:1}.q-splitter__separator-area>*{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.q-splitter--dark .q-splitter__separator{background-color:hsla(0,0%,100%,.28)}.q-splitter--vertical>.q-splitter__panel{height:100%}.q-splitter--vertical.q-splitter--active{cursor:col-resize}.q-splitter--vertical>.q-splitter__separator{width:1px}.q-splitter--vertical>.q-splitter__separator>div{left:-6px;right:-6px}.q-splitter--vertical.q-splitter--workable>.q-splitter__separator{cursor:col-resize}.q-splitter--horizontal>.q-splitter__panel{width:100%}.q-splitter--horizontal.q-splitter--active{cursor:row-resize}.q-splitter--horizontal>.q-splitter__separator{height:1px}.q-splitter--horizontal>.q-splitter__separator>div{top:-6px;bottom:-6px}.q-splitter--horizontal.q-splitter--workable>.q-splitter__separator{cursor:row-resize}.q-splitter__after,.q-splitter__before{overflow:auto}.q-stepper{box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);border-radius:4px;background:#fff}.q-stepper__title{font-size:14px;line-height:18px;letter-spacing:.1px}.q-stepper__caption{font-size:12px;line-height:14px}.q-stepper__dot{contain:layout;margin-right:8px;font-size:14px;width:24px;min-width:24px;height:24px;border-radius:50%;background:currentColor}.q-stepper__dot span{color:#fff}.q-stepper__tab{padding:8px 24px;font-size:14px;color:#9e9e9e;flex-direction:row}.q-stepper--dark .q-stepper__dot span{color:#000}.q-stepper__tab--navigation{user-select:none;cursor:pointer}.q-stepper__tab--active,.q-stepper__tab--done{color:#027be3;color:var(--q-color-primary)}.q-stepper__tab--active .q-stepper__dot,.q-stepper__tab--active .q-stepper__label,.q-stepper__tab--done .q-stepper__dot,.q-stepper__tab--done .q-stepper__label{text-shadow:0 0 0 currentColor}.q-stepper__tab--disabled .q-stepper__dot{background:rgba(0,0,0,.22)}.q-stepper__tab--disabled .q-stepper__label{color:rgba(0,0,0,.32)}.q-stepper__tab--error{color:#c10015;color:var(--q-color-negative)}.q-stepper__tab--error-with-icon .q-stepper__dot{background:transparent!important}.q-stepper__tab--error-with-icon .q-stepper__dot span{color:currentColor}.q-stepper__tab--error-with-icon .q-stepper__dot .q-icon{font-size:24px}.q-stepper__header{border-top-left-radius:inherit;border-top-right-radius:inherit}.q-stepper__header--border{border-bottom:1px solid rgba(0,0,0,.12)}.q-stepper__header--standard-labels .q-stepper__tab{min-height:72px;justify-content:center}.q-stepper__header--standard-labels .q-stepper__tab:first-child{justify-content:flex-start}.q-stepper__header--standard-labels .q-stepper__tab:last-child{justify-content:flex-end}.q-stepper__header--standard-labels .q-stepper__tab:only-child{justify-content:center}.q-stepper__header--standard-labels .q-stepper__dot:after{display:none}.q-stepper__header--alternative-labels .q-stepper__tab{min-height:104px;padding:24px 32px;flex-direction:column;justify-content:flex-start}.q-stepper__header--alternative-labels .q-stepper__dot{margin-right:0}.q-stepper__header--alternative-labels .q-stepper__label{margin-top:8px;text-align:center}.q-stepper__header--alternative-labels .q-stepper__label:after,.q-stepper__header--alternative-labels .q-stepper__label:before{display:none}.q-stepper__header--contracted,.q-stepper__header--contracted.q-stepper__header--alternative-labels .q-stepper__tab{min-height:72px}.q-stepper__header--contracted.q-stepper__header--alternative-labels .q-stepper__tab:first-child{align-items:flex-start}.q-stepper__header--contracted.q-stepper__header--alternative-labels .q-stepper__tab:last-child{align-items:flex-end}.q-stepper__header--contracted .q-stepper__tab{padding:24px 0}.q-stepper__header--contracted .q-stepper__tab:first-child .q-stepper__dot{transform:translateX(24px)}.q-stepper__header--contracted .q-stepper__tab:last-child .q-stepper__dot{transform:translateX(-24px)}.q-stepper__header--contracted .q-stepper__tab:not(:last-child) .q-stepper__dot:after{display:block!important}.q-stepper__header--contracted .q-stepper__dot{margin:0}.q-stepper__header--contracted .q-stepper__label{display:none}.q-stepper__nav{padding-top:24px}.q-stepper--bordered{border:1px solid rgba(0,0,0,.12)}.q-stepper--horizontal .q-stepper__step-inner{padding:24px}.q-stepper--horizontal .q-stepper__tab:first-child{border-top-left-radius:inherit}.q-stepper--horizontal .q-stepper__tab:last-child{border-top-right-radius:inherit}.q-stepper--horizontal .q-stepper__tab:first-child .q-stepper__dot:before,.q-stepper--horizontal .q-stepper__tab:last-child .q-stepper__dot:after,.q-stepper--horizontal .q-stepper__tab:last-child .q-stepper__label:after{display:none}.q-stepper--horizontal .q-stepper__tab{overflow:hidden}.q-stepper--horizontal .q-stepper__line{contain:layout}.q-stepper--horizontal .q-stepper__line:after,.q-stepper--horizontal .q-stepper__line:before{position:absolute;top:50%;height:1px;width:100vw;background:rgba(0,0,0,.12)}.q-stepper--horizontal .q-stepper__dot:after,.q-stepper--horizontal .q-stepper__label:after{content:\"\";left:100%;margin-left:8px}.q-stepper--horizontal .q-stepper__dot:before{content:\"\";right:100%;margin-right:8px}.q-stepper--horizontal>.q-stepper__nav{padding:0 24px 24px}.q-stepper--vertical{padding:16px 0}.q-stepper--vertical .q-stepper__tab{padding:12px 24px}.q-stepper--vertical .q-stepper__title{line-height:18px}.q-stepper--vertical .q-stepper__step-inner{padding:0 24px 32px 60px}.q-stepper--vertical>.q-stepper__nav{padding:24px 24px 0}.q-stepper--vertical .q-stepper__step{overflow:hidden}.q-stepper--vertical .q-stepper__dot{margin-right:12px}.q-stepper--vertical .q-stepper__dot:after,.q-stepper--vertical .q-stepper__dot:before{content:\"\";position:absolute;left:50%;width:1px;height:99999px;background:rgba(0,0,0,.12)}.q-stepper--vertical .q-stepper__dot:before{bottom:100%;margin-bottom:8px}.q-stepper--vertical .q-stepper__dot:after{top:100%;margin-top:8px}.q-stepper--vertical .q-stepper__step:first-child .q-stepper__dot:before,.q-stepper--vertical .q-stepper__step:last-child .q-stepper__dot:after{display:none}.q-stepper--vertical .q-stepper__step:last-child .q-stepper__step-inner{padding-bottom:8px}.q-stepper--dark.q-stepper--bordered,.q-stepper--dark .q-stepper__header--border{border-color:hsla(0,0%,100%,.28)}.q-stepper--dark.q-stepper--horizontal .q-stepper__line:after,.q-stepper--dark.q-stepper--horizontal .q-stepper__line:before,.q-stepper--dark.q-stepper--vertical .q-stepper__dot:after,.q-stepper--dark.q-stepper--vertical .q-stepper__dot:before{background:hsla(0,0%,100%,.28)}.q-stepper--dark .q-stepper__tab--disabled{color:hsla(0,0%,100%,.28)}.q-stepper--dark .q-stepper__tab--disabled .q-stepper__dot{background:hsla(0,0%,100%,.28)}.q-stepper--dark .q-stepper__tab--disabled .q-stepper__label{color:hsla(0,0%,100%,.54)}.q-tab-panels{background:#fff}.q-tab-panel{padding:16px}.q-markup-table{overflow:auto;background:#fff}.q-table{width:100%;max-width:100%;border-collapse:separate;border-spacing:0}.q-table tbody td,.q-table thead tr{height:48px}.q-table th{font-weight:500;font-size:12px;user-select:none}.q-table th.sortable{cursor:pointer}.q-table th.sortable:hover .q-table__sort-icon{opacity:.64}.q-table th.sorted .q-table__sort-icon{opacity:.86!important}.q-table th.sort-desc .q-table__sort-icon{transform:rotate(180deg)}.q-table td,.q-table th{padding:7px 16px;background-color:inherit}.q-table td,.q-table th,.q-table thead{border-style:solid;border-width:0}.q-table tbody td{font-size:13px}.q-table__card{color:#000;background-color:#fff;border-radius:4px;box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)}.q-table__card .q-table__middle{flex:1 1 auto}.q-table__card .q-table__bottom,.q-table__card .q-table__top{flex:0 0 auto}.q-table__container{position:relative}.q-table__container.fullscreen{max-height:100%}.q-table__container>div:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.q-table__container>div:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.q-table__container>.q-inner-loading{border-radius:inherit!important}.q-table__top{padding:12px 16px}.q-table__top .q-table__control{flex-wrap:wrap}.q-table__title{font-size:20px;letter-spacing:.005em;font-weight:400}.q-table__separator{min-width:8px!important}.q-table__progress{height:0!important}.q-table__progress th{padding:0!important;border:0!important}.q-table__progress .q-linear-progress{position:absolute;bottom:0}.q-table__middle{max-width:100%}.q-table__bottom{min-height:50px;padding:4px 14px 4px 16px;font-size:12px}.q-table__bottom .q-table__control{min-height:24px}.q-table__bottom-nodata-icon{font-size:200%;margin-right:8px}.q-table__bottom-item{margin-right:16px}.q-table__control{display:flex;align-items:center}.q-table__sort-icon{transition:transform .3s cubic-bezier(.25,.8,.5,1);opacity:0;font-size:120%}.q-table__sort-icon--center,.q-table__sort-icon--left{margin-left:4px}.q-table__sort-icon--right{margin-right:4px}.q-table--col-auto-width{width:1px}.q-table--flat{box-shadow:none}.q-table--bordered{border:1px solid rgba(0,0,0,.12)}.q-table--square{border-radius:0}.q-table__linear-progress{height:2px}.q-table--no-wrap td,.q-table--no-wrap th{white-space:nowrap}.q-table--grid{box-shadow:none;border-radius:4px}.q-table--grid .q-table__top{padding-bottom:4px}.q-table--grid .q-table__middle{min-height:2px;margin-bottom:4px}.q-table--grid .q-table__middle thead,.q-table--grid .q-table__middle thead th{border:0!important}.q-table--grid .q-table__linear-progress{bottom:0}.q-table--grid .q-table__bottom{border-top:0}.q-table--grid .q-table__grid-content{flex:1 1 auto}.q-table--grid.fullscreen{background:inherit}.q-table__grid-item-card{vertical-align:top;padding:12px}.q-table__grid-item-card .q-separator{margin:12px 0}.q-table__grid-item-row+.q-table__grid-item-row{margin-top:8px}.q-table__grid-item-title{opacity:.54;font-weight:500;font-size:12px}.q-table__grid-item-value{font-size:13px}.q-table__grid-item{padding:4px;transition:transform .3s cubic-bezier(.25,.8,.5,1)}.q-table__grid-item--selected{transform:scale(.95)}.q-table--cell-separator tbody tr:not(:last-child)>td,.q-table--cell-separator thead th,.q-table--horizontal-separator tbody tr:not(:last-child)>td,.q-table--horizontal-separator thead th{border-bottom-width:1px}.q-table--cell-separator td,.q-table--cell-separator th,.q-table--vertical-separator td,.q-table--vertical-separator th{border-left-width:1px}.q-table--cell-separator.q-table--loading tr:nth-last-child(2) th,.q-table--cell-separator thead tr:last-child th,.q-table--vertical-separator.q-table--loading tr:nth-last-child(2) th,.q-table--vertical-separator thead tr:last-child th{border-bottom-width:1px}.q-table--cell-separator td:first-child,.q-table--cell-separator th:first-child,.q-table--vertical-separator td:first-child,.q-table--vertical-separator th:first-child{border-left:0}.q-table--cell-separator .q-table__top,.q-table--vertical-separator .q-table__top{border-bottom:1px solid rgba(0,0,0,.12)}.q-table--dense .q-table__top{padding:6px 16px}.q-table--dense .q-table__bottom{min-height:33px}.q-table--dense .q-table__sort-icon{font-size:110%}.q-table--dense .q-table td,.q-table--dense .q-table th{padding:4px 8px}.q-table--dense .q-table tbody td,.q-table--dense .q-table tbody tr,.q-table--dense .q-table thead tr{height:28px}.q-table--dense .q-table td:first-child,.q-table--dense .q-table th:first-child{padding-left:16px}.q-table--dense .q-table td:last-child,.q-table--dense .q-table th:last-child{padding-right:16px}.q-table--dense .q-table__bottom-item{margin-right:8px}.q-table--dense .q-table__select .q-field__control,.q-table--dense .q-table__select .q-field__native{min-height:24px;padding:0}.q-table--dense .q-table__select .q-field__marginal{height:24px}.q-table__bottom{border-top:1px solid rgba(0,0,0,.12)}.q-table td,.q-table th,.q-table thead,.q-table tr{border-color:rgba(0,0,0,.12)}.q-table tbody td{position:relative}.q-table tbody td:after,.q-table tbody td:before{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}.q-table tbody td:before{background:rgba(0,0,0,.03)}.q-table tbody td:after{background:rgba(0,0,0,.06)}.q-table tbody tr.selected td:after,body.desktop .q-table>tbody>tr:not(.q-tr--no-hover):hover>td:not(.q-td--no-hover):before{content:\"\"}.q-table--dark,.q-table--dark .q-table__bottom,.q-table--dark td,.q-table--dark th,.q-table--dark thead,.q-table--dark tr,.q-table__card--dark{border-color:hsla(0,0%,100%,.28)}.q-table--dark tbody td:before{background:hsla(0,0%,100%,.07)}.q-table--dark tbody td:after{background:hsla(0,0%,100%,.1)}.q-table--dark.q-table--cell-separator .q-table__top,.q-table--dark.q-table--vertical-separator .q-table__top{border-color:hsla(0,0%,100%,.28)}.q-tab{padding:0 16px;min-height:48px;transition:color .3s,background-color .3s;text-transform:uppercase;white-space:nowrap;color:inherit;text-decoration:none}.q-tab--full{min-height:72px}.q-tab--no-caps{text-transform:none}.q-tab__content{height:inherit;padding:4px 0;min-width:40px}.q-tab__content--inline .q-tab__icon+.q-tab__label{padding-left:8px}.q-tab__content .q-chip--floating{top:0;right:-16px}.q-tab__icon{width:24px;height:24px;font-size:24px}.q-tab__label{font-size:14px;line-height:1.715em;font-weight:500}.q-tab .q-badge{top:3px;right:-12px}.q-tab__alert,.q-tab__alert-icon{position:absolute}.q-tab__alert{top:7px;right:-9px;height:10px;width:10px;border-radius:50%;background:currentColor}.q-tab__alert-icon{top:2px;right:-12px;font-size:18px}.q-tab__indicator{opacity:0;height:2px;background:currentColor}.q-tab--active .q-tab__indicator{opacity:1;transform-origin:left}.q-tab--inactive{opacity:.85}.q-tabs{position:relative;transition:color .3s,background-color .3s}.q-tabs--scrollable.q-tabs__arrows--outside.q-tabs--horizontal{padding-left:36px;padding-right:36px}.q-tabs--scrollable.q-tabs__arrows--outside.q-tabs--vertical{padding-top:36px;padding-bottom:36px}.q-tabs--scrollable.q-tabs__arrows--outside .q-tabs__arrow--faded{opacity:.3;pointer-events:none}.q-tabs--not-scrollable .q-tabs__arrow,.q-tabs--scrollable.q-tabs__arrows--inside .q-tabs__arrow--faded{display:none}.q-tabs--not-scrollable .q-tabs__content{border-radius:inherit}.q-tabs__arrow{cursor:pointer;font-size:32px;min-width:36px;text-shadow:0 0 3px #fff,0 0 1px #fff,0 0 1px #000;transition:opacity .3s}.q-tabs__content{overflow:hidden;flex:1 1 auto}.q-tabs__content--align-center{justify-content:center}.q-tabs__content--align-right{justify-content:flex-end}.q-tabs__content--align-justify .q-tab{flex:1 1 auto}.q-tabs__offset{display:none}.q-tabs--horizontal .q-tabs__arrow{height:100%}.q-tabs--horizontal .q-tabs__arrow--start{top:0;left:0;bottom:0}.q-tabs--horizontal .q-tabs__arrow--end{top:0;right:0;bottom:0}.q-tabs--vertical,.q-tabs--vertical .q-tabs__content{display:block!important;height:100%}.q-tabs--vertical .q-tabs__arrow{width:100%;height:36px;text-align:center}.q-tabs--vertical .q-tabs__arrow--start{top:0;left:0;right:0}.q-tabs--vertical .q-tabs__arrow--end{left:0;right:0;bottom:0}.q-tabs--vertical .q-tab{padding:0 8px}.q-tabs--vertical .q-tab__indicator{height:unset;width:2px}.q-tabs--vertical.q-tabs--not-scrollable .q-tabs__content{height:100%}.q-tabs--vertical.q-tabs--dense .q-tab__content{min-width:24px}.q-tabs--dense .q-tab{min-height:36px}.q-tabs--dense .q-tab--full{min-height:52px}.q-time{box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);border-radius:4px;background:#fff;outline:0;width:290px;min-width:290px;max-width:100%}.q-time--bordered{border:1px solid rgba(0,0,0,.12)}.q-time__header{border-top-left-radius:inherit;color:#fff;background-color:#027be3;background-color:var(--q-color-primary);padding:16px;font-weight:300}.q-time__actions{padding:0 16px 16px}.q-time__header-label{font-size:28px;line-height:1;letter-spacing:-.00833em}.q-time__header-label>div+div{margin-left:4px}.q-time__link{opacity:.56;outline:0;transition:opacity .3s ease-out}.q-time__link--active,.q-time__link:focus,.q-time__link:hover{opacity:1}.q-time__header-ampm{font-size:16px;letter-spacing:.1em}.q-time__content{padding:16px}.q-time__content:before{content:\"\";display:block;padding-bottom:100%}.q-time__container-parent{padding:16px}.q-time__container-child{border-radius:50%;background:rgba(0,0,0,.12)}.q-time__clock{padding:24px;width:100%;height:100%;max-width:100%;max-height:100%;font-size:14px}.q-time__clock-circle{position:relative}.q-time__clock-center{height:6px;width:6px;margin:auto;border-radius:50%;min-height:0;background:currentColor}.q-time__clock-pointer{width:2px;height:50%;transform-origin:0 0;min-height:0;position:absolute;left:50%;right:0;bottom:0;color:#027be3;color:var(--q-color-primary);background:currentColor;transform:translateX(-50%)}.q-time__clock-pointer:after,.q-time__clock-pointer:before{content:\"\";position:absolute;left:50%;border-radius:50%;background:currentColor;transform:translateX(-50%)}.q-time__clock-pointer:before{bottom:-4px;width:8px;height:8px}.q-time__clock-pointer:after{top:-3px;height:6px;width:6px}.q-time__clock-position{position:absolute;min-height:32px;width:32px;height:32px;font-size:12px;line-height:32px;margin:0;padding:0;transform:translate(-50%,-50%);border-radius:50%}.q-time__clock-position--disable{opacity:.4}.q-time__clock-position--active{background-color:#027be3;background-color:var(--q-color-primary);color:#fff}.q-time__clock-pos-0{top:0;left:50%}.q-time__clock-pos-1{top:6.7%;left:75%}.q-time__clock-pos-2{top:25%;left:93.3%}.q-time__clock-pos-3{top:50%;left:100%}.q-time__clock-pos-4{top:75%;left:93.3%}.q-time__clock-pos-5{top:93.3%;left:75%}.q-time__clock-pos-6{top:100%;left:50%}.q-time__clock-pos-7{top:93.3%;left:25%}.q-time__clock-pos-8{top:75%;left:6.7%}.q-time__clock-pos-9{top:50%;left:0}.q-time__clock-pos-10{top:25%;left:6.7%}.q-time__clock-pos-11{top:6.7%;left:25%}.q-time__clock-pos-12{top:15%;left:50%}.q-time__clock-pos-13{top:19.69%;left:67.5%}.q-time__clock-pos-14{top:32.5%;left:80.31%}.q-time__clock-pos-15{top:50%;left:85%}.q-time__clock-pos-16{top:67.5%;left:80.31%}.q-time__clock-pos-17{top:80.31%;left:67.5%}.q-time__clock-pos-18{top:85%;left:50%}.q-time__clock-pos-19{top:80.31%;left:32.5%}.q-time__clock-pos-20{top:67.5%;left:19.69%}.q-time__clock-pos-21{top:50%;left:15%}.q-time__clock-pos-22{top:32.5%;left:19.69%}.q-time__clock-pos-23{top:19.69%;left:32.5%}.q-time__now-button{background-color:#027be3;background-color:var(--q-color-primary);color:#fff;top:12px;right:12px}.q-time--readonly .q-time__content,.q-time--readonly .q-time__header-ampm,.q-time.disabled .q-time__content,.q-time.disabled .q-time__header-ampm{pointer-events:none}.q-time--portrait{display:inline-flex;flex-direction:column}.q-time--portrait .q-time__header{border-top-right-radius:inherit;min-height:86px}.q-time--portrait .q-time__header-ampm{margin-left:12px}.q-time--portrait.q-time--bordered .q-time__content{margin:1px 0}.q-time--landscape{display:inline-flex;align-items:stretch;min-width:420px}.q-time--landscape>div{display:flex;flex-direction:column;justify-content:center}.q-time--landscape .q-time__header{border-bottom-left-radius:inherit;min-width:156px}.q-time--landscape .q-time__header-ampm{margin-top:12px}.q-time--dark{border-color:hsla(0,0%,100%,.28)}.q-timeline{padding:0;width:100%;list-style:none}.q-timeline h6{line-height:inherit}.q-timeline--dark{color:#fff}.q-timeline--dark .q-timeline__subtitle{opacity:.7}.q-timeline__content{padding-bottom:24px}.q-timeline__title{margin-top:0;margin-bottom:16px}.q-timeline__subtitle{font-size:12px;margin-bottom:8px;opacity:.6;text-transform:uppercase;letter-spacing:1px;font-weight:700}.q-timeline__dot{position:absolute;top:0;bottom:0;width:15px}.q-timeline__dot:after,.q-timeline__dot:before{content:\"\";background:currentColor;display:block;position:absolute}.q-timeline__dot:before{border:3px solid transparent;border-radius:100%;height:15px;width:15px;top:4px;left:0;transition:background .3s ease-in-out,border .3s ease-in-out}.q-timeline__dot:after{width:3px;opacity:.4;top:24px;bottom:0;left:6px}.q-timeline__dot .q-icon{position:absolute;top:0;left:0;right:0;font-size:16px;height:38px;line-height:38px;width:100%;color:#fff}.q-timeline__dot .q-icon>img,.q-timeline__dot .q-icon>svg{width:1em;height:1em}.q-timeline__dot-img{position:absolute;top:4px;left:0;right:0;height:31px;width:31px;background:currentColor;border-radius:50%}.q-timeline__heading{position:relative}.q-timeline__heading:first-child .q-timeline__heading-title{padding-top:0}.q-timeline__heading:last-child .q-timeline__heading-title{padding-bottom:0}.q-timeline__heading-title{padding:32px 0;margin:0}.q-timeline__entry{position:relative;line-height:22px}.q-timeline__entry:last-child{padding-bottom:0!important}.q-timeline__entry:last-child .q-timeline__dot:after{content:none}.q-timeline__entry--icon .q-timeline__dot{width:31px}.q-timeline__entry--icon .q-timeline__dot:before{height:31px;width:31px}.q-timeline__entry--icon .q-timeline__dot:after{top:41px;left:14px}.q-timeline__entry--icon .q-timeline__subtitle{padding-top:8px}.q-timeline--dense--right .q-timeline__entry{padding-left:40px}.q-timeline--dense--right .q-timeline__entry--icon .q-timeline__dot{left:-8px}.q-timeline--dense--right .q-timeline__dot{left:0}.q-timeline--dense--left .q-timeline__heading{text-align:right}.q-timeline--dense--left .q-timeline__entry{padding-right:40px}.q-timeline--dense--left .q-timeline__entry--icon .q-timeline__dot{right:-8px}.q-timeline--dense--left .q-timeline__content,.q-timeline--dense--left .q-timeline__subtitle,.q-timeline--dense--left .q-timeline__title{text-align:right}.q-timeline--dense--left .q-timeline__dot{right:0}.q-timeline--comfortable{display:table}.q-timeline--comfortable .q-timeline__heading{display:table-row;font-size:200%}.q-timeline--comfortable .q-timeline__heading>div{display:table-cell}.q-timeline--comfortable .q-timeline__entry{display:table-row;padding:0}.q-timeline--comfortable .q-timeline__entry--icon .q-timeline__content{padding-top:8px}.q-timeline--comfortable .q-timeline__content,.q-timeline--comfortable .q-timeline__dot,.q-timeline--comfortable .q-timeline__subtitle{display:table-cell;vertical-align:top}.q-timeline--comfortable .q-timeline__subtitle{width:35%}.q-timeline--comfortable .q-timeline__dot{position:relative;min-width:31px}.q-timeline--comfortable--right .q-timeline__heading .q-timeline__heading-title{margin-left:-50px}.q-timeline--comfortable--right .q-timeline__subtitle{text-align:right;padding-right:30px}.q-timeline--comfortable--right .q-timeline__content{padding-left:30px}.q-timeline--comfortable--right .q-timeline__entry--icon .q-timeline__dot{left:-8px}.q-timeline--comfortable--left .q-timeline__heading{text-align:right}.q-timeline--comfortable--left .q-timeline__heading .q-timeline__heading-title{margin-right:-50px}.q-timeline--comfortable--left .q-timeline__subtitle{padding-left:30px}.q-timeline--comfortable--left .q-timeline__content{padding-right:30px}.q-timeline--comfortable--left .q-timeline__content,.q-timeline--comfortable--left .q-timeline__title{text-align:right}.q-timeline--comfortable--left .q-timeline__entry--icon .q-timeline__dot{right:0}.q-timeline--comfortable--left .q-timeline__dot{right:-8px}.q-timeline--loose .q-timeline__heading-title{text-align:center;margin-left:0}.q-timeline--loose .q-timeline__content,.q-timeline--loose .q-timeline__dot,.q-timeline--loose .q-timeline__entry,.q-timeline--loose .q-timeline__subtitle{display:block;margin:0;padding:0}.q-timeline--loose .q-timeline__dot{position:absolute;left:50%;margin-left:-7.15px}.q-timeline--loose .q-timeline__entry{padding-bottom:24px;overflow:hidden}.q-timeline--loose .q-timeline__entry--icon .q-timeline__dot{margin-left:-15px}.q-timeline--loose .q-timeline__entry--icon .q-timeline__subtitle{line-height:38px}.q-timeline--loose .q-timeline__entry--icon .q-timeline__content{padding-top:8px}.q-timeline--loose .q-timeline__entry--left .q-timeline__content,.q-timeline--loose .q-timeline__entry--right .q-timeline__subtitle{float:left;padding-right:30px;text-align:right}.q-timeline--loose .q-timeline__entry--left .q-timeline__subtitle,.q-timeline--loose .q-timeline__entry--right .q-timeline__content{float:right;text-align:left;padding-left:30px}.q-timeline--loose .q-timeline__content,.q-timeline--loose .q-timeline__subtitle{width:50%}.q-toggle{vertical-align:middle}.q-toggle__native{width:1px;height:1px}.q-toggle__track{height:.35em;border-radius:.175em;opacity:.38;background:currentColor}.q-toggle__thumb{top:.25em;left:.25em;width:.5em;height:.5em;transition:left .22s cubic-bezier(.4,0,.2,1);user-select:none;z-index:0}.q-toggle__thumb:after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:50%;background:#fff;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.q-toggle__thumb .q-icon{font-size:.3em;min-width:1em;color:#000;opacity:.54;z-index:1}.q-toggle__inner{font-size:40px;width:1.4em;min-width:1.4em;height:1em;padding:.325em .3em;-webkit-print-color-adjust:exact}.q-toggle__inner--indet .q-toggle__thumb{left:.45em}.q-toggle__inner--truthy{color:#027be3;color:var(--q-color-primary)}.q-toggle__inner--truthy .q-toggle__track{opacity:.54}.q-toggle__inner--truthy .q-toggle__thumb{left:.65em}.q-toggle__inner--truthy .q-toggle__thumb:after{background-color:currentColor}.q-toggle__inner--truthy .q-toggle__thumb .q-icon{color:#fff;opacity:1}.q-toggle.disabled{opacity:.75!important}.q-toggle--dark .q-toggle__inner{color:#fff}.q-toggle--dark .q-toggle__inner--truthy{color:#027be3;color:var(--q-color-primary)}.q-toggle--dark .q-toggle__thumb:before{opacity:.32!important}.q-toggle--dense .q-toggle__inner{width:.8em;min-width:.8em;height:.5em;padding:.07625em 0}.q-toggle--dense .q-toggle__thumb{top:0;left:0}.q-toggle--dense .q-toggle__inner--indet .q-toggle__thumb{left:.15em}.q-toggle--dense .q-toggle__inner--truthy .q-toggle__thumb{left:.3em}.q-toggle--dense .q-toggle__label{padding-left:.5em}.q-toggle--dense.reverse .q-toggle__label{padding-left:0;padding-right:.5em}body.desktop .q-toggle:not(.disabled) .q-toggle__thumb:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:50%;background:currentColor;opacity:.12;transform:scale3d(0,0,1);transition:transform .22s cubic-bezier(0,0,.2,1)}body.desktop .q-toggle:not(.disabled):focus .q-toggle__thumb:before,body.desktop .q-toggle:not(.disabled):hover .q-toggle__thumb:before{transform:scale3d(2,2,1)}body.desktop .q-toggle--dense:not(.disabled):focus .q-toggle__thumb:before,body.desktop .q-toggle--dense:not(.disabled):hover .q-toggle__thumb:before{transform:scale3d(1.5,1.5,1)}.q-toolbar{position:relative;padding:0 12px;min-height:50px;width:100%}.q-toolbar--inset{padding-left:58px}.q-toolbar .q-avatar{font-size:38px}.q-toolbar__title{flex:1 1 0%;min-width:1px;max-width:100%;font-size:21px;font-weight:400;letter-spacing:.01em;padding:0 12px}.q-toolbar__title:first-child{padding-left:0}.q-toolbar__title:last-child{padding-right:0}.q-tooltip--style{font-size:10px;color:#fafafa;background:#757575;border-radius:4px;text-transform:none;font-weight:400}.q-tooltip{z-index:9000;position:fixed!important;overflow-y:auto;overflow-x:hidden;padding:6px 10px}@media (max-width:599.98px){.q-tooltip{font-size:14px;padding:8px 16px}}.q-tree{position:relative;color:#9e9e9e}.q-tree__node{padding:0 0 3px 22px}.q-tree__node:after{content:\"\";position:absolute;top:-3px;bottom:0;width:2px;right:auto;left:-13px;border-left:1px solid currentColor}.q-tree__node:last-child:after{display:none}.q-tree__node--disabled{pointer-events:none}.q-tree__node--disabled .disabled{opacity:1!important}.q-tree__node--disabled>.disabled,.q-tree__node--disabled>div,.q-tree__node--disabled>i{opacity:.6!important}.q-tree__node--disabled>.disabled .q-tree__node--disabled>.disabled,.q-tree__node--disabled>.disabled .q-tree__node--disabled>div,.q-tree__node--disabled>.disabled .q-tree__node--disabled>i,.q-tree__node--disabled>div .q-tree__node--disabled>.disabled,.q-tree__node--disabled>div .q-tree__node--disabled>div,.q-tree__node--disabled>div .q-tree__node--disabled>i,.q-tree__node--disabled>i .q-tree__node--disabled>.disabled,.q-tree__node--disabled>i .q-tree__node--disabled>div,.q-tree__node--disabled>i .q-tree__node--disabled>i{opacity:1!important}.q-tree__node-header:before{content:\"\";position:absolute;top:-3px;bottom:50%;width:31px;left:-35px;border-left:1px solid currentColor;border-bottom:1px solid currentColor}.q-tree__children{padding-left:25px}.q-tree__node-body{padding:5px 0 8px 5px}.q-tree__node--parent{padding-left:2px}.q-tree__node--parent>.q-tree__node-header:before{width:15px;left:-15px}.q-tree__node--parent>.q-tree__node-collapsible>.q-tree__node-body{padding:5px 0 8px 27px}.q-tree__node--parent>.q-tree__node-collapsible>.q-tree__node-body:after{content:\"\";position:absolute;top:0;width:2px;height:100%;right:auto;left:12px;border-left:1px solid currentColor;bottom:50px}.q-tree__node--link{cursor:pointer}.q-tree__node-header{padding:4px;margin-top:3px;border-radius:4px;outline:0}.q-tree__node-header-content{color:#000;transition:color .3s}.q-tree__node--selected .q-tree__node-header-content{color:#9e9e9e}.q-tree__icon,.q-tree__node-header-content .q-icon{font-size:21px}.q-tree__img{height:42px;border-radius:2px}.q-tree__avatar,.q-tree__node-header-content .q-avatar{font-size:28px;border-radius:50%;width:28px;height:28px}.q-tree__arrow,.q-tree__spinner{font-size:16px;margin-right:4px}.q-tree__arrow{transition:transform .3s}.q-tree__arrow--rotate{transform:rotate(90deg)}.q-tree__tickbox{margin-right:4px}.q-tree>.q-tree__node{padding:0}.q-tree>.q-tree__node:after,.q-tree>.q-tree__node>.q-tree__node-header:before{display:none}.q-tree>.q-tree__node--child>.q-tree__node-header{padding-left:24px}.q-tree--dark .q-tree__node-header-content{color:#fff}.q-tree--no-connectors .q-tree__node-body:after,.q-tree--no-connectors .q-tree__node-header:before,.q-tree--no-connectors .q-tree__node:after{display:none!important}.q-tree--dense>.q-tree__node--child>.q-tree__node-header{padding-left:1px}.q-tree--dense .q-tree__arrow,.q-tree--dense .q-tree__spinner{margin-right:1px}.q-tree--dense .q-tree__img{height:32px}.q-tree--dense .q-tree__tickbox{margin-right:3px}.q-tree--dense .q-tree__node{padding:0}.q-tree--dense .q-tree__node:after{top:0;left:-8px}.q-tree--dense .q-tree__node-header{margin-top:0;padding:1px}.q-tree--dense .q-tree__node-header:before{top:0;left:-8px;width:8px}.q-tree--dense .q-tree__node--child{padding-left:17px}.q-tree--dense .q-tree__node--child>.q-tree__node-header:before{left:-25px;width:21px}.q-tree--dense .q-tree__node-body{padding:0 0 2px}.q-tree--dense .q-tree__node--parent>.q-tree__node-collapsible>.q-tree__node-body{padding:0 0 2px 20px}.q-tree--dense .q-tree__node--parent>.q-tree__node-collapsible>.q-tree__node-body:after{left:8px}.q-tree--dense .q-tree__children{padding-left:16px}[dir=rtl] .q-tree__arrow{transform:rotate(180deg)}[dir=rtl] .q-tree__arrow--rotate{transform:rotate(90deg)}.q-uploader{box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);border-radius:4px;vertical-align:top;background:#fff;position:relative;width:320px;max-height:320px}.q-uploader--bordered{border:1px solid rgba(0,0,0,.12)}.q-uploader__input{opacity:0;width:100%;height:100%;cursor:pointer!important;z-index:1}.q-uploader__input::-webkit-file-upload-button{cursor:pointer}.q-uploader__file:before{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;background:currentColor;opacity:.04}.q-uploader__file:before,.q-uploader__header{border-top-left-radius:inherit;border-top-right-radius:inherit}.q-uploader__header{position:relative;background-color:#027be3;background-color:var(--q-color-primary);color:#fff;width:100%}.q-uploader__spinner{font-size:24px;margin-right:4px}.q-uploader__header-content{padding:8px}.q-uploader__dnd{outline:1px dashed currentColor;outline-offset:-4px;background:hsla(0,0%,100%,.6)}.q-uploader__overlay{font-size:36px;color:#000;background-color:hsla(0,0%,100%,.6)}.q-uploader__list{position:relative;border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;padding:8px;min-height:60px;flex:1 1 auto}.q-uploader__file{border-radius:4px 4px 0 0;border:1px solid rgba(0,0,0,.12)}.q-uploader__file .q-circular-progress{font-size:24px}.q-uploader__file--img{color:#fff;height:200px;min-width:200px;background-position:50% 50%;background-size:cover;background-repeat:no-repeat}.q-uploader__file--img:before{content:none}.q-uploader__file--img .q-circular-progress{color:#fff}.q-uploader__file--img .q-uploader__file-header{padding-bottom:24px;background:linear-gradient(180deg,rgba(0,0,0,.7) 20%,hsla(0,0%,100%,0))}.q-uploader__file+.q-uploader__file{margin-top:8px}.q-uploader__file-header{position:relative;padding:4px 8px;border-top-left-radius:inherit;border-top-right-radius:inherit}.q-uploader__file-header-content{padding-right:8px}.q-uploader__file-status{font-size:24px;margin-right:4px}.q-uploader__title{font-size:14px;font-weight:700;line-height:18px;word-break:break-word}.q-uploader__subtitle{font-size:12px;line-height:18px}.q-uploader--disable .q-uploader__header,.q-uploader--disable .q-uploader__list{pointer-events:none}.q-uploader--dark,.q-uploader--dark .q-uploader__file{border-color:hsla(0,0%,100%,.28)}.q-uploader--dark .q-uploader__dnd,.q-uploader--dark .q-uploader__overlay{background:hsla(0,0%,100%,.3)}.q-uploader--dark .q-uploader__overlay{color:#fff}.q-video{position:relative;overflow:hidden;border-radius:inherit}.q-video embed,.q-video iframe,.q-video object{width:100%;height:100%}.q-video--responsive{height:0}.q-video--responsive embed,.q-video--responsive iframe,.q-video--responsive object{position:absolute;top:0;left:0}.q-virtual-scroll:focus{outline:0}.q-virtual-scroll__content{outline:none;contain:content}.q-virtual-scroll__content>*{overflow-anchor:none}.q-virtual-scroll__content>[data-q-vs-anchor]{overflow-anchor:auto}.q-virtual-scroll__padding{background:linear-gradient(hsla(0,0%,100%,0),hsla(0,0%,100%,0) 20%,hsla(0,0%,50.2%,.03) 0,hsla(0,0%,50.2%,.08) 50%,hsla(0,0%,50.2%,.03) 80%,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0));background-size:100% 50px;background-size:var(--q-virtual-scroll-item-width,100%) var(--q-virtual-scroll-item-height,50px)}.q-table .q-virtual-scroll__padding tr{height:0!important}.q-table .q-virtual-scroll__padding td{padding:0!important}.q-virtual-scroll--horizontal{align-items:stretch}.q-virtual-scroll--horizontal,.q-virtual-scroll--horizontal .q-virtual-scroll__content{display:flex;flex-direction:row;flex-wrap:nowrap}.q-virtual-scroll--horizontal .q-virtual-scroll__content,.q-virtual-scroll--horizontal .q-virtual-scroll__content>*,.q-virtual-scroll--horizontal .q-virtual-scroll__padding{flex:0 0 auto}.q-virtual-scroll--horizontal .q-virtual-scroll__padding{background:linear-gradient(270deg,hsla(0,0%,100%,0),hsla(0,0%,100%,0) 20%,hsla(0,0%,50.2%,.03) 0,hsla(0,0%,50.2%,.08) 50%,hsla(0,0%,50.2%,.03) 80%,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0));background-size:50px 100%;background-size:var(--q-virtual-scroll-item-width,50px) var(--q-virtual-scroll-item-height,100%)}.q-ripple{width:100%;height:100%;border-radius:inherit;z-index:0;overflow:hidden;contain:strict}.q-ripple,.q-ripple__inner{position:absolute;top:0;left:0;color:inherit;pointer-events:none}.q-ripple__inner{opacity:0;border-radius:50%;background:currentColor;will-change:transform,opacity}.q-ripple__inner--enter{transition:transform .225s cubic-bezier(.4,0,.2,1),opacity .1s cubic-bezier(.4,0,.2,1)}.q-ripple__inner--leave{transition:opacity .25s cubic-bezier(.4,0,.2,1)}.q-morph--internal,.q-morph--invisible{opacity:0!important;pointer-events:none!important;position:fixed!important;right:200vw!important;bottom:200vh!important}.q-loading{color:#000;position:fixed!important}.q-loading:before{content:\"\";position:fixed;top:0;right:0;bottom:0;left:0;background:currentColor;opacity:.5;z-index:-1}.q-loading>div{margin:40px 20px 0;max-width:450px;text-align:center}.q-notifications__list{z-index:9500;pointer-events:none;left:0;right:0;margin-bottom:10px;position:relative}.q-notifications__list--center{top:0;bottom:0}.q-notifications__list--top{top:0}.q-notifications__list--bottom{bottom:0}body.q-ios-padding .q-notifications__list--center,body.q-ios-padding .q-notifications__list--top{top:20px;top:env(safe-area-inset-top)}body.q-ios-padding .q-notifications__list--bottom,body.q-ios-padding .q-notifications__list--center{bottom:env(safe-area-inset-bottom)}.q-notification{box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12);border-radius:4px;pointer-events:all;display:inline-flex;margin:10px 10px 0;transition:transform 1s,opacity 1s;z-index:9500;flex-shrink:0;max-width:95vw;background:#323232;color:#fff;font-size:14px}.q-notification__icon{font-size:24px;flex:0 0 1em}.q-notification__icon--additional{margin-right:16px}.q-notification__avatar{font-size:32px}.q-notification__avatar--additional{margin-right:8px}.q-notification__spinner{font-size:32px}.q-notification__spinner--additional{margin-right:8px}.q-notification__message{padding:8px 0}.q-notification__caption{font-size:.9em;opacity:.7}.q-notification__actions{color:#027be3;color:var(--q-color-primary)}.q-notification__badge{animation:q-notif-badge .42s;padding:4px 8px;position:absolute;background:#c10015;box-shadow:0 1px 3px rgba(0,0,0,.2),0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);background-color:#c10015;background-color:var(--q-color-negative);color:#fff;border-radius:4px;font-size:12px;line-height:12px}.q-notification__badge--top-left,.q-notification__badge--top-right{top:-6px}.q-notification__badge--bottom-left,.q-notification__badge--bottom-right{bottom:-6px}.q-notification__badge--bottom-left,.q-notification__badge--top-left{left:-22px}.q-notification__badge--bottom-right,.q-notification__badge--top-right{right:-22px}.q-notification__progress{z-index:-1;position:absolute;height:3px;bottom:0;left:-10px;right:-10px;animation:q-notif-progress linear;background:currentColor;opacity:.3;border-radius:4px 4px 0 0;transform-origin:0 50%;transform:scaleX(0)}.q-notification--standard{padding:0 16px;min-height:48px}.q-notification--standard .q-notification__actions{padding:6px 0 6px 8px;margin-right:-8px}.q-notification--multi-line{min-height:68px;padding:8px 16px}.q-notification--multi-line .q-notification__badge--top-left,.q-notification--multi-line .q-notification__badge--top-right{top:-15px}.q-notification--multi-line .q-notification__badge--bottom-left,.q-notification--multi-line .q-notification__badge--bottom-right{bottom:-15px}.q-notification--multi-line .q-notification__progress{bottom:-8px}.q-notification--multi-line .q-notification__actions{padding:0}.q-notification--multi-line .q-notification__actions--with-media{padding-left:25px}.q-notification--top-enter,.q-notification--top-leave-to,.q-notification--top-left-enter,.q-notification--top-left-leave-to,.q-notification--top-right-enter,.q-notification--top-right-leave-to{opacity:0;transform:translateY(-50px);z-index:9499}.q-notification--center-enter,.q-notification--center-leave-to,.q-notification--left-enter,.q-notification--left-leave-to,.q-notification--right-enter,.q-notification--right-leave-to{opacity:0;transform:rotateX(90deg);z-index:9499}.q-notification--bottom-enter,.q-notification--bottom-leave-to,.q-notification--bottom-left-enter,.q-notification--bottom-left-leave-to,.q-notification--bottom-right-enter,.q-notification--bottom-right-leave-to{opacity:0;transform:translateY(50px);z-index:9499}.q-notification--bottom-leave-active,.q-notification--bottom-left-leave-active,.q-notification--bottom-right-leave-active,.q-notification--center-leave-active,.q-notification--left-leave-active,.q-notification--right-leave-active,.q-notification--top-leave-active,.q-notification--top-left-leave-active,.q-notification--top-right-leave-active{position:absolute;z-index:9499;margin-left:0;margin-right:0}.q-notification--center-leave-active,.q-notification--top-leave-active{top:0}.q-notification--bottom-leave-active,.q-notification--bottom-left-leave-active,.q-notification--bottom-right-leave-active{bottom:0}@media (min-width:600px){.q-notification{max-width:65vw}}:root{--animate-duration:0.3s;--animate-delay:0.3s;--animate-repeat:1}.animated{animation-duration:var(--animate-duration);animation-fill-mode:both}.animated.infinite{animation-iteration-count:infinite}.animated.hinge{animation-duration:2s}.animated.repeat-1{animation-iteration-count:var(--animate-repeat)}.animated.repeat-2{animation-iteration-count:calc(var(--animate-repeat)*2)}.animated.repeat-3{animation-iteration-count:calc(var(--animate-repeat)*3)}.animated.delay-1s{animation-delay:var(--animate-delay)}.animated.delay-2s{animation-delay:calc(var(--animate-delay)*2)}.animated.delay-3s{animation-delay:calc(var(--animate-delay)*3)}.animated.delay-4s{animation-delay:calc(var(--animate-delay)*4)}.animated.delay-5s{animation-delay:calc(var(--animate-delay)*5)}.animated.faster{animation-duration:calc(var(--animate-duration)/2)}.animated.fast{animation-duration:calc(var(--animate-duration)*0.8)}.animated.slow{animation-duration:calc(var(--animate-duration)*2)}.animated.slower{animation-duration:calc(var(--animate-duration)*3)}@media (prefers-reduced-motion:reduce),print{.animated{animation-duration:1ms!important;transition-duration:1ms!important;animation-iteration-count:1!important}.animated[class*=Out]{opacity:0}}.q-animate--scale{animation:q-scale .15s;animation-timing-function:cubic-bezier(.25,.8,.25,1)}.q-animate--fade{animation:q-fade .2s}:root{--q-color-primary:#027be3;--q-color-secondary:#00a9e0;--q-color-accent:#9c27b0;--q-color-positive:#79b928;--q-color-negative:#c10015;--q-color-info:#31ccec;--q-color-warning:#f2c037;--q-color-dark:#1d1d1d;--q-color-dark-page:#121212}.text-dark{color:#1d1d1d!important;color:var(--q-color-dark)!important}.bg-dark{background:#1d1d1d!important;background:var(--q-color-dark)!important}.text-primary{color:#027be3!important;color:var(--q-color-primary)!important}.bg-primary{background:#027be3!important;background:var(--q-color-primary)!important}.text-secondary{color:#00a9e0!important;color:var(--q-color-secondary)!important}.bg-secondary{background:#00a9e0!important;background:var(--q-color-secondary)!important}.text-accent{color:#9c27b0!important;color:var(--q-color-accent)!important}.bg-accent{background:#9c27b0!important;background:var(--q-color-accent)!important}.text-positive{color:#79b928!important;color:var(--q-color-positive)!important}.bg-positive{background:#79b928!important;background:var(--q-color-positive)!important}.text-negative{color:#c10015!important;color:var(--q-color-negative)!important}.bg-negative{background:#c10015!important;background:var(--q-color-negative)!important}.text-info{color:#31ccec!important;color:var(--q-color-info)!important}.bg-info{background:#31ccec!important;background:var(--q-color-info)!important}.text-warning{color:#f2c037!important;color:var(--q-color-warning)!important}.bg-warning{background:#f2c037!important;background:var(--q-color-warning)!important}.text-white{color:#fff!important}.bg-white{background:#fff!important}.text-black{color:#000!important}.bg-black{background:#000!important}.text-transparent{color:transparent!important}.bg-transparent{background:transparent!important}.text-separator{color:rgba(0,0,0,.12)!important}.bg-separator{background:rgba(0,0,0,.12)!important}.text-dark-separator{color:hsla(0,0%,100%,.28)!important}.bg-dark-separator{background:hsla(0,0%,100%,.28)!important}.text-red{color:#f44336!important}.text-red-1{color:#ffebee!important}.text-red-2{color:#ffcdd2!important}.text-red-3{color:#ef9a9a!important}.text-red-4{color:#e57373!important}.text-red-5{color:#ef5350!important}.text-red-6{color:#f44336!important}.text-red-7{color:#e53935!important}.text-red-8{color:#d32f2f!important}.text-red-9{color:#c62828!important}.text-red-10{color:#b71c1c!important}.text-red-11{color:#ff8a80!important}.text-red-12{color:#ff5252!important}.text-red-13{color:#ff1744!important}.text-red-14{color:#d50000!important}.text-pink{color:#e91e63!important}.text-pink-1{color:#fce4ec!important}.text-pink-2{color:#f8bbd0!important}.text-pink-3{color:#f48fb1!important}.text-pink-4{color:#f06292!important}.text-pink-5{color:#ec407a!important}.text-pink-6{color:#e91e63!important}.text-pink-7{color:#d81b60!important}.text-pink-8{color:#c2185b!important}.text-pink-9{color:#ad1457!important}.text-pink-10{color:#880e4f!important}.text-pink-11{color:#ff80ab!important}.text-pink-12{color:#ff4081!important}.text-pink-13{color:#f50057!important}.text-pink-14{color:#c51162!important}.text-purple{color:#9c27b0!important}.text-purple-1{color:#f3e5f5!important}.text-purple-2{color:#e1bee7!important}.text-purple-3{color:#ce93d8!important}.text-purple-4{color:#ba68c8!important}.text-purple-5{color:#ab47bc!important}.text-purple-6{color:#9c27b0!important}.text-purple-7{color:#8e24aa!important}.text-purple-8{color:#7b1fa2!important}.text-purple-9{color:#6a1b9a!important}.text-purple-10{color:#4a148c!important}.text-purple-11{color:#ea80fc!important}.text-purple-12{color:#e040fb!important}.text-purple-13{color:#d500f9!important}.text-purple-14{color:#a0f!important}.text-deep-purple{color:#673ab7!important}.text-deep-purple-1{color:#ede7f6!important}.text-deep-purple-2{color:#d1c4e9!important}.text-deep-purple-3{color:#b39ddb!important}.text-deep-purple-4{color:#9575cd!important}.text-deep-purple-5{color:#7e57c2!important}.text-deep-purple-6{color:#673ab7!important}.text-deep-purple-7{color:#5e35b1!important}.text-deep-purple-8{color:#512da8!important}.text-deep-purple-9{color:#4527a0!important}.text-deep-purple-10{color:#311b92!important}.text-deep-purple-11{color:#b388ff!important}.text-deep-purple-12{color:#7c4dff!important}.text-deep-purple-13{color:#651fff!important}.text-deep-purple-14{color:#6200ea!important}.text-indigo{color:#3f51b5!important}.text-indigo-1{color:#e8eaf6!important}.text-indigo-2{color:#c5cae9!important}.text-indigo-3{color:#9fa8da!important}.text-indigo-4{color:#7986cb!important}.text-indigo-5{color:#5c6bc0!important}.text-indigo-6{color:#3f51b5!important}.text-indigo-7{color:#3949ab!important}.text-indigo-8{color:#303f9f!important}.text-indigo-9{color:#283593!important}.text-indigo-10{color:#1a237e!important}.text-indigo-11{color:#8c9eff!important}.text-indigo-12{color:#536dfe!important}.text-indigo-13{color:#3d5afe!important}.text-indigo-14{color:#304ffe!important}.text-blue{color:#2196f3!important}.text-blue-1{color:#e3f2fd!important}.text-blue-2{color:#bbdefb!important}.text-blue-3{color:#90caf9!important}.text-blue-4{color:#64b5f6!important}.text-blue-5{color:#42a5f5!important}.text-blue-6{color:#2196f3!important}.text-blue-7{color:#1e88e5!important}.text-blue-8{color:#1976d2!important}.text-blue-9{color:#1565c0!important}.text-blue-10{color:#0d47a1!important}.text-blue-11{color:#82b1ff!important}.text-blue-12{color:#448aff!important}.text-blue-13{color:#2979ff!important}.text-blue-14{color:#2962ff!important}.text-light-blue{color:#03a9f4!important}.text-light-blue-1{color:#e1f5fe!important}.text-light-blue-2{color:#b3e5fc!important}.text-light-blue-3{color:#81d4fa!important}.text-light-blue-4{color:#4fc3f7!important}.text-light-blue-5{color:#29b6f6!important}.text-light-blue-6{color:#03a9f4!important}.text-light-blue-7{color:#039be5!important}.text-light-blue-8{color:#0288d1!important}.text-light-blue-9{color:#0277bd!important}.text-light-blue-10{color:#01579b!important}.text-light-blue-11{color:#80d8ff!important}.text-light-blue-12{color:#40c4ff!important}.text-light-blue-13{color:#00b0ff!important}.text-light-blue-14{color:#0091ea!important}.text-cyan{color:#00bcd4!important}.text-cyan-1{color:#e0f7fa!important}.text-cyan-2{color:#b2ebf2!important}.text-cyan-3{color:#80deea!important}.text-cyan-4{color:#4dd0e1!important}.text-cyan-5{color:#26c6da!important}.text-cyan-6{color:#00bcd4!important}.text-cyan-7{color:#00acc1!important}.text-cyan-8{color:#0097a7!important}.text-cyan-9{color:#00838f!important}.text-cyan-10{color:#006064!important}.text-cyan-11{color:#84ffff!important}.text-cyan-12{color:#18ffff!important}.text-cyan-13{color:#00e5ff!important}.text-cyan-14{color:#00b8d4!important}.text-teal{color:#009688!important}.text-teal-1{color:#e0f2f1!important}.text-teal-2{color:#b2dfdb!important}.text-teal-3{color:#80cbc4!important}.text-teal-4{color:#4db6ac!important}.text-teal-5{color:#26a69a!important}.text-teal-6{color:#009688!important}.text-teal-7{color:#00897b!important}.text-teal-8{color:#00796b!important}.text-teal-9{color:#00695c!important}.text-teal-10{color:#004d40!important}.text-teal-11{color:#a7ffeb!important}.text-teal-12{color:#64ffda!important}.text-teal-13{color:#1de9b6!important}.text-teal-14{color:#00bfa5!important}.text-green{color:#4caf50!important}.text-green-1{color:#e8f5e9!important}.text-green-2{color:#c8e6c9!important}.text-green-3{color:#a5d6a7!important}.text-green-4{color:#81c784!important}.text-green-5{color:#66bb6a!important}.text-green-6{color:#4caf50!important}.text-green-7{color:#43a047!important}.text-green-8{color:#388e3c!important}.text-green-9{color:#2e7d32!important}.text-green-10{color:#1b5e20!important}.text-green-11{color:#b9f6ca!important}.text-green-12{color:#69f0ae!important}.text-green-13{color:#00e676!important}.text-green-14{color:#00c853!important}.text-light-green{color:#8bc34a!important}.text-light-green-1{color:#f1f8e9!important}.text-light-green-2{color:#dcedc8!important}.text-light-green-3{color:#c5e1a5!important}.text-light-green-4{color:#aed581!important}.text-light-green-5{color:#9ccc65!important}.text-light-green-6{color:#8bc34a!important}.text-light-green-7{color:#7cb342!important}.text-light-green-8{color:#689f38!important}.text-light-green-9{color:#558b2f!important}.text-light-green-10{color:#33691e!important}.text-light-green-11{color:#ccff90!important}.text-light-green-12{color:#b2ff59!important}.text-light-green-13{color:#76ff03!important}.text-light-green-14{color:#64dd17!important}.text-lime{color:#cddc39!important}.text-lime-1{color:#f9fbe7!important}.text-lime-2{color:#f0f4c3!important}.text-lime-3{color:#e6ee9c!important}.text-lime-4{color:#dce775!important}.text-lime-5{color:#d4e157!important}.text-lime-6{color:#cddc39!important}.text-lime-7{color:#c0ca33!important}.text-lime-8{color:#afb42b!important}.text-lime-9{color:#9e9d24!important}.text-lime-10{color:#827717!important}.text-lime-11{color:#f4ff81!important}.text-lime-12{color:#eeff41!important}.text-lime-13{color:#c6ff00!important}.text-lime-14{color:#aeea00!important}.text-yellow{color:#ffeb3b!important}.text-yellow-1{color:#fffde7!important}.text-yellow-2{color:#fff9c4!important}.text-yellow-3{color:#fff59d!important}.text-yellow-4{color:#fff176!important}.text-yellow-5{color:#ffee58!important}.text-yellow-6{color:#ffeb3b!important}.text-yellow-7{color:#fdd835!important}.text-yellow-8{color:#fbc02d!important}.text-yellow-9{color:#f9a825!important}.text-yellow-10{color:#f57f17!important}.text-yellow-11{color:#ffff8d!important}.text-yellow-12{color:#ff0!important}.text-yellow-13{color:#ffea00!important}.text-yellow-14{color:#ffd600!important}.text-amber{color:#ffc107!important}.text-amber-1{color:#fff8e1!important}.text-amber-2{color:#ffecb3!important}.text-amber-3{color:#ffe082!important}.text-amber-4{color:#ffd54f!important}.text-amber-5{color:#ffca28!important}.text-amber-6{color:#ffc107!important}.text-amber-7{color:#ffb300!important}.text-amber-8{color:#ffa000!important}.text-amber-9{color:#ff8f00!important}.text-amber-10{color:#ff6f00!important}.text-amber-11{color:#ffe57f!important}.text-amber-12{color:#ffd740!important}.text-amber-13{color:#ffc400!important}.text-amber-14{color:#ffab00!important}.text-orange{color:#ff9800!important}.text-orange-1{color:#fff3e0!important}.text-orange-2{color:#ffe0b2!important}.text-orange-3{color:#ffcc80!important}.text-orange-4{color:#ffb74d!important}.text-orange-5{color:#ffa726!important}.text-orange-6{color:#ff9800!important}.text-orange-7{color:#fb8c00!important}.text-orange-8{color:#f57c00!important}.text-orange-9{color:#ef6c00!important}.text-orange-10{color:#e65100!important}.text-orange-11{color:#ffd180!important}.text-orange-12{color:#ffab40!important}.text-orange-13{color:#ff9100!important}.text-orange-14{color:#ff6d00!important}.text-deep-orange{color:#ff5722!important}.text-deep-orange-1{color:#fbe9e7!important}.text-deep-orange-2{color:#ffccbc!important}.text-deep-orange-3{color:#ffab91!important}.text-deep-orange-4{color:#ff8a65!important}.text-deep-orange-5{color:#ff7043!important}.text-deep-orange-6{color:#ff5722!important}.text-deep-orange-7{color:#f4511e!important}.text-deep-orange-8{color:#e64a19!important}.text-deep-orange-9{color:#d84315!important}.text-deep-orange-10{color:#bf360c!important}.text-deep-orange-11{color:#ff9e80!important}.text-deep-orange-12{color:#ff6e40!important}.text-deep-orange-13{color:#ff3d00!important}.text-deep-orange-14{color:#dd2c00!important}.text-brown{color:#795548!important}.text-brown-1{color:#efebe9!important}.text-brown-2{color:#d7ccc8!important}.text-brown-3{color:#bcaaa4!important}.text-brown-4{color:#a1887f!important}.text-brown-5{color:#8d6e63!important}.text-brown-6{color:#795548!important}.text-brown-7{color:#6d4c41!important}.text-brown-8{color:#5d4037!important}.text-brown-9{color:#4e342e!important}.text-brown-10{color:#3e2723!important}.text-brown-11{color:#d7ccc8!important}.text-brown-12{color:#bcaaa4!important}.text-brown-13{color:#8d6e63!important}.text-brown-14{color:#5d4037!important}.text-grey{color:#9e9e9e!important}.text-grey-1{color:#fafafa!important}.text-grey-2{color:#f5f5f5!important}.text-grey-3{color:#eee!important}.text-grey-4{color:#e0e0e0!important}.text-grey-5{color:#bdbdbd!important}.text-grey-6{color:#9e9e9e!important}.text-grey-7{color:#757575!important}.text-grey-8{color:#616161!important}.text-grey-9{color:#424242!important}.text-grey-10{color:#212121!important}.text-grey-11{color:#f5f5f5!important}.text-grey-12{color:#eee!important}.text-grey-13{color:#bdbdbd!important}.text-grey-14{color:#616161!important}.text-blue-grey{color:#607d8b!important}.text-blue-grey-1{color:#eceff1!important}.text-blue-grey-2{color:#cfd8dc!important}.text-blue-grey-3{color:#b0bec5!important}.text-blue-grey-4{color:#90a4ae!important}.text-blue-grey-5{color:#78909c!important}.text-blue-grey-6{color:#607d8b!important}.text-blue-grey-7{color:#546e7a!important}.text-blue-grey-8{color:#455a64!important}.text-blue-grey-9{color:#37474f!important}.text-blue-grey-10{color:#263238!important}.text-blue-grey-11{color:#cfd8dc!important}.text-blue-grey-12{color:#b0bec5!important}.text-blue-grey-13{color:#78909c!important}.text-blue-grey-14{color:#455a64!important}.bg-red{background:#f44336!important}.bg-red-1{background:#ffebee!important}.bg-red-2{background:#ffcdd2!important}.bg-red-3{background:#ef9a9a!important}.bg-red-4{background:#e57373!important}.bg-red-5{background:#ef5350!important}.bg-red-6{background:#f44336!important}.bg-red-7{background:#e53935!important}.bg-red-8{background:#d32f2f!important}.bg-red-9{background:#c62828!important}.bg-red-10{background:#b71c1c!important}.bg-red-11{background:#ff8a80!important}.bg-red-12{background:#ff5252!important}.bg-red-13{background:#ff1744!important}.bg-red-14{background:#d50000!important}.bg-pink{background:#e91e63!important}.bg-pink-1{background:#fce4ec!important}.bg-pink-2{background:#f8bbd0!important}.bg-pink-3{background:#f48fb1!important}.bg-pink-4{background:#f06292!important}.bg-pink-5{background:#ec407a!important}.bg-pink-6{background:#e91e63!important}.bg-pink-7{background:#d81b60!important}.bg-pink-8{background:#c2185b!important}.bg-pink-9{background:#ad1457!important}.bg-pink-10{background:#880e4f!important}.bg-pink-11{background:#ff80ab!important}.bg-pink-12{background:#ff4081!important}.bg-pink-13{background:#f50057!important}.bg-pink-14{background:#c51162!important}.bg-purple{background:#9c27b0!important}.bg-purple-1{background:#f3e5f5!important}.bg-purple-2{background:#e1bee7!important}.bg-purple-3{background:#ce93d8!important}.bg-purple-4{background:#ba68c8!important}.bg-purple-5{background:#ab47bc!important}.bg-purple-6{background:#9c27b0!important}.bg-purple-7{background:#8e24aa!important}.bg-purple-8{background:#7b1fa2!important}.bg-purple-9{background:#6a1b9a!important}.bg-purple-10{background:#4a148c!important}.bg-purple-11{background:#ea80fc!important}.bg-purple-12{background:#e040fb!important}.bg-purple-13{background:#d500f9!important}.bg-purple-14{background:#a0f!important}.bg-deep-purple{background:#673ab7!important}.bg-deep-purple-1{background:#ede7f6!important}.bg-deep-purple-2{background:#d1c4e9!important}.bg-deep-purple-3{background:#b39ddb!important}.bg-deep-purple-4{background:#9575cd!important}.bg-deep-purple-5{background:#7e57c2!important}.bg-deep-purple-6{background:#673ab7!important}.bg-deep-purple-7{background:#5e35b1!important}.bg-deep-purple-8{background:#512da8!important}.bg-deep-purple-9{background:#4527a0!important}.bg-deep-purple-10{background:#311b92!important}.bg-deep-purple-11{background:#b388ff!important}.bg-deep-purple-12{background:#7c4dff!important}.bg-deep-purple-13{background:#651fff!important}.bg-deep-purple-14{background:#6200ea!important}.bg-indigo{background:#3f51b5!important}.bg-indigo-1{background:#e8eaf6!important}.bg-indigo-2{background:#c5cae9!important}.bg-indigo-3{background:#9fa8da!important}.bg-indigo-4{background:#7986cb!important}.bg-indigo-5{background:#5c6bc0!important}.bg-indigo-6{background:#3f51b5!important}.bg-indigo-7{background:#3949ab!important}.bg-indigo-8{background:#303f9f!important}.bg-indigo-9{background:#283593!important}.bg-indigo-10{background:#1a237e!important}.bg-indigo-11{background:#8c9eff!important}.bg-indigo-12{background:#536dfe!important}.bg-indigo-13{background:#3d5afe!important}.bg-indigo-14{background:#304ffe!important}.bg-blue{background:#2196f3!important}.bg-blue-1{background:#e3f2fd!important}.bg-blue-2{background:#bbdefb!important}.bg-blue-3{background:#90caf9!important}.bg-blue-4{background:#64b5f6!important}.bg-blue-5{background:#42a5f5!important}.bg-blue-6{background:#2196f3!important}.bg-blue-7{background:#1e88e5!important}.bg-blue-8{background:#1976d2!important}.bg-blue-9{background:#1565c0!important}.bg-blue-10{background:#0d47a1!important}.bg-blue-11{background:#82b1ff!important}.bg-blue-12{background:#448aff!important}.bg-blue-13{background:#2979ff!important}.bg-blue-14{background:#2962ff!important}.bg-light-blue{background:#03a9f4!important}.bg-light-blue-1{background:#e1f5fe!important}.bg-light-blue-2{background:#b3e5fc!important}.bg-light-blue-3{background:#81d4fa!important}.bg-light-blue-4{background:#4fc3f7!important}.bg-light-blue-5{background:#29b6f6!important}.bg-light-blue-6{background:#03a9f4!important}.bg-light-blue-7{background:#039be5!important}.bg-light-blue-8{background:#0288d1!important}.bg-light-blue-9{background:#0277bd!important}.bg-light-blue-10{background:#01579b!important}.bg-light-blue-11{background:#80d8ff!important}.bg-light-blue-12{background:#40c4ff!important}.bg-light-blue-13{background:#00b0ff!important}.bg-light-blue-14{background:#0091ea!important}.bg-cyan{background:#00bcd4!important}.bg-cyan-1{background:#e0f7fa!important}.bg-cyan-2{background:#b2ebf2!important}.bg-cyan-3{background:#80deea!important}.bg-cyan-4{background:#4dd0e1!important}.bg-cyan-5{background:#26c6da!important}.bg-cyan-6{background:#00bcd4!important}.bg-cyan-7{background:#00acc1!important}.bg-cyan-8{background:#0097a7!important}.bg-cyan-9{background:#00838f!important}.bg-cyan-10{background:#006064!important}.bg-cyan-11{background:#84ffff!important}.bg-cyan-12{background:#18ffff!important}.bg-cyan-13{background:#00e5ff!important}.bg-cyan-14{background:#00b8d4!important}.bg-teal{background:#009688!important}.bg-teal-1{background:#e0f2f1!important}.bg-teal-2{background:#b2dfdb!important}.bg-teal-3{background:#80cbc4!important}.bg-teal-4{background:#4db6ac!important}.bg-teal-5{background:#26a69a!important}.bg-teal-6{background:#009688!important}.bg-teal-7{background:#00897b!important}.bg-teal-8{background:#00796b!important}.bg-teal-9{background:#00695c!important}.bg-teal-10{background:#004d40!important}.bg-teal-11{background:#a7ffeb!important}.bg-teal-12{background:#64ffda!important}.bg-teal-13{background:#1de9b6!important}.bg-teal-14{background:#00bfa5!important}.bg-green{background:#4caf50!important}.bg-green-1{background:#e8f5e9!important}.bg-green-2{background:#c8e6c9!important}.bg-green-3{background:#a5d6a7!important}.bg-green-4{background:#81c784!important}.bg-green-5{background:#66bb6a!important}.bg-green-6{background:#4caf50!important}.bg-green-7{background:#43a047!important}.bg-green-8{background:#388e3c!important}.bg-green-9{background:#2e7d32!important}.bg-green-10{background:#1b5e20!important}.bg-green-11{background:#b9f6ca!important}.bg-green-12{background:#69f0ae!important}.bg-green-13{background:#00e676!important}.bg-green-14{background:#00c853!important}.bg-light-green{background:#8bc34a!important}.bg-light-green-1{background:#f1f8e9!important}.bg-light-green-2{background:#dcedc8!important}.bg-light-green-3{background:#c5e1a5!important}.bg-light-green-4{background:#aed581!important}.bg-light-green-5{background:#9ccc65!important}.bg-light-green-6{background:#8bc34a!important}.bg-light-green-7{background:#7cb342!important}.bg-light-green-8{background:#689f38!important}.bg-light-green-9{background:#558b2f!important}.bg-light-green-10{background:#33691e!important}.bg-light-green-11{background:#ccff90!important}.bg-light-green-12{background:#b2ff59!important}.bg-light-green-13{background:#76ff03!important}.bg-light-green-14{background:#64dd17!important}.bg-lime{background:#cddc39!important}.bg-lime-1{background:#f9fbe7!important}.bg-lime-2{background:#f0f4c3!important}.bg-lime-3{background:#e6ee9c!important}.bg-lime-4{background:#dce775!important}.bg-lime-5{background:#d4e157!important}.bg-lime-6{background:#cddc39!important}.bg-lime-7{background:#c0ca33!important}.bg-lime-8{background:#afb42b!important}.bg-lime-9{background:#9e9d24!important}.bg-lime-10{background:#827717!important}.bg-lime-11{background:#f4ff81!important}.bg-lime-12{background:#eeff41!important}.bg-lime-13{background:#c6ff00!important}.bg-lime-14{background:#aeea00!important}.bg-yellow{background:#ffeb3b!important}.bg-yellow-1{background:#fffde7!important}.bg-yellow-2{background:#fff9c4!important}.bg-yellow-3{background:#fff59d!important}.bg-yellow-4{background:#fff176!important}.bg-yellow-5{background:#ffee58!important}.bg-yellow-6{background:#ffeb3b!important}.bg-yellow-7{background:#fdd835!important}.bg-yellow-8{background:#fbc02d!important}.bg-yellow-9{background:#f9a825!important}.bg-yellow-10{background:#f57f17!important}.bg-yellow-11{background:#ffff8d!important}.bg-yellow-12{background:#ff0!important}.bg-yellow-13{background:#ffea00!important}.bg-yellow-14{background:#ffd600!important}.bg-amber{background:#ffc107!important}.bg-amber-1{background:#fff8e1!important}.bg-amber-2{background:#ffecb3!important}.bg-amber-3{background:#ffe082!important}.bg-amber-4{background:#ffd54f!important}.bg-amber-5{background:#ffca28!important}.bg-amber-6{background:#ffc107!important}.bg-amber-7{background:#ffb300!important}.bg-amber-8{background:#ffa000!important}.bg-amber-9{background:#ff8f00!important}.bg-amber-10{background:#ff6f00!important}.bg-amber-11{background:#ffe57f!important}.bg-amber-12{background:#ffd740!important}.bg-amber-13{background:#ffc400!important}.bg-amber-14{background:#ffab00!important}.bg-orange{background:#ff9800!important}.bg-orange-1{background:#fff3e0!important}.bg-orange-2{background:#ffe0b2!important}.bg-orange-3{background:#ffcc80!important}.bg-orange-4{background:#ffb74d!important}.bg-orange-5{background:#ffa726!important}.bg-orange-6{background:#ff9800!important}.bg-orange-7{background:#fb8c00!important}.bg-orange-8{background:#f57c00!important}.bg-orange-9{background:#ef6c00!important}.bg-orange-10{background:#e65100!important}.bg-orange-11{background:#ffd180!important}.bg-orange-12{background:#ffab40!important}.bg-orange-13{background:#ff9100!important}.bg-orange-14{background:#ff6d00!important}.bg-deep-orange{background:#ff5722!important}.bg-deep-orange-1{background:#fbe9e7!important}.bg-deep-orange-2{background:#ffccbc!important}.bg-deep-orange-3{background:#ffab91!important}.bg-deep-orange-4{background:#ff8a65!important}.bg-deep-orange-5{background:#ff7043!important}.bg-deep-orange-6{background:#ff5722!important}.bg-deep-orange-7{background:#f4511e!important}.bg-deep-orange-8{background:#e64a19!important}.bg-deep-orange-9{background:#d84315!important}.bg-deep-orange-10{background:#bf360c!important}.bg-deep-orange-11{background:#ff9e80!important}.bg-deep-orange-12{background:#ff6e40!important}.bg-deep-orange-13{background:#ff3d00!important}.bg-deep-orange-14{background:#dd2c00!important}.bg-brown{background:#795548!important}.bg-brown-1{background:#efebe9!important}.bg-brown-2{background:#d7ccc8!important}.bg-brown-3{background:#bcaaa4!important}.bg-brown-4{background:#a1887f!important}.bg-brown-5{background:#8d6e63!important}.bg-brown-6{background:#795548!important}.bg-brown-7{background:#6d4c41!important}.bg-brown-8{background:#5d4037!important}.bg-brown-9{background:#4e342e!important}.bg-brown-10{background:#3e2723!important}.bg-brown-11{background:#d7ccc8!important}.bg-brown-12{background:#bcaaa4!important}.bg-brown-13{background:#8d6e63!important}.bg-brown-14{background:#5d4037!important}.bg-grey{background:#9e9e9e!important}.bg-grey-1{background:#fafafa!important}.bg-grey-2{background:#f5f5f5!important}.bg-grey-3{background:#eee!important}.bg-grey-4{background:#e0e0e0!important}.bg-grey-5{background:#bdbdbd!important}.bg-grey-6{background:#9e9e9e!important}.bg-grey-7{background:#757575!important}.bg-grey-8{background:#616161!important}.bg-grey-9{background:#424242!important}.bg-grey-10{background:#212121!important}.bg-grey-11{background:#f5f5f5!important}.bg-grey-12{background:#eee!important}.bg-grey-13{background:#bdbdbd!important}.bg-grey-14{background:#616161!important}.bg-blue-grey{background:#607d8b!important}.bg-blue-grey-1{background:#eceff1!important}.bg-blue-grey-2{background:#cfd8dc!important}.bg-blue-grey-3{background:#b0bec5!important}.bg-blue-grey-4{background:#90a4ae!important}.bg-blue-grey-5{background:#78909c!important}.bg-blue-grey-6{background:#607d8b!important}.bg-blue-grey-7{background:#546e7a!important}.bg-blue-grey-8{background:#455a64!important}.bg-blue-grey-9{background:#37474f!important}.bg-blue-grey-10{background:#263238!important}.bg-blue-grey-11{background:#cfd8dc!important}.bg-blue-grey-12{background:#b0bec5!important}.bg-blue-grey-13{background:#78909c!important}.bg-blue-grey-14{background:#455a64!important}.shadow-transition{transition:box-shadow .28s cubic-bezier(.4,0,.2,1)!important}.shadow-1{box-shadow:0 1px 3px rgba(0,0,0,.2),0 1px 1px rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.shadow-up-1{box-shadow:0 -1px 3px rgba(0,0,0,.2),0 -1px 1px rgba(0,0,0,.14),0 -2px 1px -1px rgba(0,0,0,.12)}.shadow-2{box-shadow:0 1px 5px rgba(0,0,0,.2),0 2px 2px rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)}.shadow-up-2{box-shadow:0 -1px 5px rgba(0,0,0,.2),0 -2px 2px rgba(0,0,0,.14),0 -3px 1px -2px rgba(0,0,0,.12)}.shadow-3{box-shadow:0 1px 8px rgba(0,0,0,.2),0 3px 4px rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.12)}.shadow-up-3{box-shadow:0 -1px 8px rgba(0,0,0,.2),0 -3px 4px rgba(0,0,0,.14),0 -3px 3px -2px rgba(0,0,0,.12)}.shadow-4{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px rgba(0,0,0,.14),0 1px 10px rgba(0,0,0,.12)}.shadow-up-4{box-shadow:0 -2px 4px -1px rgba(0,0,0,.2),0 -4px 5px rgba(0,0,0,.14),0 -1px 10px rgba(0,0,0,.12)}.shadow-5{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px rgba(0,0,0,.14),0 1px 14px rgba(0,0,0,.12)}.shadow-up-5{box-shadow:0 -3px 5px -1px rgba(0,0,0,.2),0 -5px 8px rgba(0,0,0,.14),0 -1px 14px rgba(0,0,0,.12)}.shadow-6{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px rgba(0,0,0,.14),0 1px 18px rgba(0,0,0,.12)}.shadow-up-6{box-shadow:0 -3px 5px -1px rgba(0,0,0,.2),0 -6px 10px rgba(0,0,0,.14),0 -1px 18px rgba(0,0,0,.12)}.shadow-7{box-shadow:0 4px 5px -2px rgba(0,0,0,.2),0 7px 10px 1px rgba(0,0,0,.14),0 2px 16px 1px rgba(0,0,0,.12)}.shadow-up-7{box-shadow:0 -4px 5px -2px rgba(0,0,0,.2),0 -7px 10px 1px rgba(0,0,0,.14),0 -2px 16px 1px rgba(0,0,0,.12)}.shadow-8{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.shadow-up-8{box-shadow:0 -5px 5px -3px rgba(0,0,0,.2),0 -8px 10px 1px rgba(0,0,0,.14),0 -3px 14px 2px rgba(0,0,0,.12)}.shadow-9{box-shadow:0 5px 6px -3px rgba(0,0,0,.2),0 9px 12px 1px rgba(0,0,0,.14),0 3px 16px 2px rgba(0,0,0,.12)}.shadow-up-9{box-shadow:0 -5px 6px -3px rgba(0,0,0,.2),0 -9px 12px 1px rgba(0,0,0,.14),0 -3px 16px 2px rgba(0,0,0,.12)}.shadow-10{box-shadow:0 6px 6px -3px rgba(0,0,0,.2),0 10px 14px 1px rgba(0,0,0,.14),0 4px 18px 3px rgba(0,0,0,.12)}.shadow-up-10{box-shadow:0 -6px 6px -3px rgba(0,0,0,.2),0 -10px 14px 1px rgba(0,0,0,.14),0 -4px 18px 3px rgba(0,0,0,.12)}.shadow-11{box-shadow:0 6px 7px -4px rgba(0,0,0,.2),0 11px 15px 1px rgba(0,0,0,.14),0 4px 20px 3px rgba(0,0,0,.12)}.shadow-up-11{box-shadow:0 -6px 7px -4px rgba(0,0,0,.2),0 -11px 15px 1px rgba(0,0,0,.14),0 -4px 20px 3px rgba(0,0,0,.12)}.shadow-12{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.shadow-up-12{box-shadow:0 -7px 8px -4px rgba(0,0,0,.2),0 -12px 17px 2px rgba(0,0,0,.14),0 -5px 22px 4px rgba(0,0,0,.12)}.shadow-13{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12)}.shadow-up-13{box-shadow:0 -7px 8px -4px rgba(0,0,0,.2),0 -13px 19px 2px rgba(0,0,0,.14),0 -5px 24px 4px rgba(0,0,0,.12)}.shadow-14{box-shadow:0 7px 9px -4px rgba(0,0,0,.2),0 14px 21px 2px rgba(0,0,0,.14),0 5px 26px 4px rgba(0,0,0,.12)}.shadow-up-14{box-shadow:0 -7px 9px -4px rgba(0,0,0,.2),0 -14px 21px 2px rgba(0,0,0,.14),0 -5px 26px 4px rgba(0,0,0,.12)}.shadow-15{box-shadow:0 8px 9px -5px rgba(0,0,0,.2),0 15px 22px 2px rgba(0,0,0,.14),0 6px 28px 5px rgba(0,0,0,.12)}.shadow-up-15{box-shadow:0 -8px 9px -5px rgba(0,0,0,.2),0 -15px 22px 2px rgba(0,0,0,.14),0 -6px 28px 5px rgba(0,0,0,.12)}.shadow-16{box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)}.shadow-up-16{box-shadow:0 -8px 10px -5px rgba(0,0,0,.2),0 -16px 24px 2px rgba(0,0,0,.14),0 -6px 30px 5px rgba(0,0,0,.12)}.shadow-17{box-shadow:0 8px 11px -5px rgba(0,0,0,.2),0 17px 26px 2px rgba(0,0,0,.14),0 6px 32px 5px rgba(0,0,0,.12)}.shadow-up-17{box-shadow:0 -8px 11px -5px rgba(0,0,0,.2),0 -17px 26px 2px rgba(0,0,0,.14),0 -6px 32px 5px rgba(0,0,0,.12)}.shadow-18{box-shadow:0 9px 11px -5px rgba(0,0,0,.2),0 18px 28px 2px rgba(0,0,0,.14),0 7px 34px 6px rgba(0,0,0,.12)}.shadow-up-18{box-shadow:0 -9px 11px -5px rgba(0,0,0,.2),0 -18px 28px 2px rgba(0,0,0,.14),0 -7px 34px 6px rgba(0,0,0,.12)}.shadow-19{box-shadow:0 9px 12px -6px rgba(0,0,0,.2),0 19px 29px 2px rgba(0,0,0,.14),0 7px 36px 6px rgba(0,0,0,.12)}.shadow-up-19{box-shadow:0 -9px 12px -6px rgba(0,0,0,.2),0 -19px 29px 2px rgba(0,0,0,.14),0 -7px 36px 6px rgba(0,0,0,.12)}.shadow-20{box-shadow:0 10px 13px -6px rgba(0,0,0,.2),0 20px 31px 3px rgba(0,0,0,.14),0 8px 38px 7px rgba(0,0,0,.12)}.shadow-up-20{box-shadow:0 -10px 13px -6px rgba(0,0,0,.2),0 -20px 31px 3px rgba(0,0,0,.14),0 -8px 38px 7px rgba(0,0,0,.12)}.shadow-21{box-shadow:0 10px 13px -6px rgba(0,0,0,.2),0 21px 33px 3px rgba(0,0,0,.14),0 8px 40px 7px rgba(0,0,0,.12)}.shadow-up-21{box-shadow:0 -10px 13px -6px rgba(0,0,0,.2),0 -21px 33px 3px rgba(0,0,0,.14),0 -8px 40px 7px rgba(0,0,0,.12)}.shadow-22{box-shadow:0 10px 14px -6px rgba(0,0,0,.2),0 22px 35px 3px rgba(0,0,0,.14),0 8px 42px 7px rgba(0,0,0,.12)}.shadow-up-22{box-shadow:0 -10px 14px -6px rgba(0,0,0,.2),0 -22px 35px 3px rgba(0,0,0,.14),0 -8px 42px 7px rgba(0,0,0,.12)}.shadow-23{box-shadow:0 11px 14px -7px rgba(0,0,0,.2),0 23px 36px 3px rgba(0,0,0,.14),0 9px 44px 8px rgba(0,0,0,.12)}.shadow-up-23{box-shadow:0 -11px 14px -7px rgba(0,0,0,.2),0 -23px 36px 3px rgba(0,0,0,.14),0 -9px 44px 8px rgba(0,0,0,.12)}.shadow-24{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12)}.shadow-up-24{box-shadow:0 -11px 15px -7px rgba(0,0,0,.2),0 -24px 38px 3px rgba(0,0,0,.14),0 -9px 46px 8px rgba(0,0,0,.12)}.no-shadow,.shadow-0{box-shadow:none!important}.inset-shadow{box-shadow:inset 0 7px 9px -7px rgba(0,0,0,.7)!important}.inset-shadow-down{box-shadow:inset 0 -7px 9px -7px rgba(0,0,0,.7)!important}.z-marginals{z-index:2000}.z-notify{z-index:9500}.z-fullscreen{z-index:6000}.z-inherit{z-index:inherit!important}.column,.flex,.row{display:flex;flex-wrap:wrap}.column.inline,.flex.inline,.row.inline{display:inline-flex}.row.reverse{flex-direction:row-reverse}.column{flex-direction:column}.column.reverse{flex-direction:column-reverse}.wrap{flex-wrap:wrap}.no-wrap{flex-wrap:nowrap}.reverse-wrap{flex-wrap:wrap-reverse}.order-first{order:-10000}.order-last{order:10000}.order-none{order:0}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.flex-center,.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.flex-center,.items-center{align-items:center}.items-baseline{align-items:baseline}.items-stretch{align-items:stretch}.content-start{align-content:flex-start}.content-end{align-content:flex-end}.content-center{align-content:center}.content-stretch{align-content:stretch}.content-between{align-content:space-between}.content-around{align-content:space-around}.self-start{align-self:flex-start}.self-end{align-self:flex-end}.self-center{align-self:center}.self-baseline{align-self:baseline}.self-stretch{align-self:stretch}.q-gutter-none,.q-gutter-none>*,.q-gutter-x-none,.q-gutter-x-none>*{margin-left:0}.q-gutter-none,.q-gutter-none>*,.q-gutter-y-none,.q-gutter-y-none>*{margin-top:0}.q-col-gutter-none,.q-col-gutter-x-none{margin-left:0}.q-col-gutter-none>*,.q-col-gutter-x-none>*{padding-left:0}.q-col-gutter-none,.q-col-gutter-y-none{margin-top:0}.q-col-gutter-none>*,.q-col-gutter-y-none>*{padding-top:0}.q-gutter-x-xs,.q-gutter-xs{margin-left:-4px}.q-gutter-x-xs>*,.q-gutter-xs>*{margin-left:4px}.q-gutter-xs,.q-gutter-y-xs{margin-top:-4px}.q-gutter-xs>*,.q-gutter-y-xs>*{margin-top:4px}.q-col-gutter-x-xs,.q-col-gutter-xs{margin-left:-4px}.q-col-gutter-x-xs>*,.q-col-gutter-xs>*{padding-left:4px}.q-col-gutter-xs,.q-col-gutter-y-xs{margin-top:-4px}.q-col-gutter-xs>*,.q-col-gutter-y-xs>*{padding-top:4px}.q-gutter-sm,.q-gutter-x-sm{margin-left:-8px}.q-gutter-sm>*,.q-gutter-x-sm>*{margin-left:8px}.q-gutter-sm,.q-gutter-y-sm{margin-top:-8px}.q-gutter-sm>*,.q-gutter-y-sm>*{margin-top:8px}.q-col-gutter-sm,.q-col-gutter-x-sm{margin-left:-8px}.q-col-gutter-sm>*,.q-col-gutter-x-sm>*{padding-left:8px}.q-col-gutter-sm,.q-col-gutter-y-sm{margin-top:-8px}.q-col-gutter-sm>*,.q-col-gutter-y-sm>*{padding-top:8px}.q-gutter-md,.q-gutter-x-md{margin-left:-16px}.q-gutter-md>*,.q-gutter-x-md>*{margin-left:16px}.q-gutter-md,.q-gutter-y-md{margin-top:-16px}.q-gutter-md>*,.q-gutter-y-md>*{margin-top:16px}.q-col-gutter-md,.q-col-gutter-x-md{margin-left:-16px}.q-col-gutter-md>*,.q-col-gutter-x-md>*{padding-left:16px}.q-col-gutter-md,.q-col-gutter-y-md{margin-top:-16px}.q-col-gutter-md>*,.q-col-gutter-y-md>*{padding-top:16px}.q-gutter-lg,.q-gutter-x-lg{margin-left:-24px}.q-gutter-lg>*,.q-gutter-x-lg>*{margin-left:24px}.q-gutter-lg,.q-gutter-y-lg{margin-top:-24px}.q-gutter-lg>*,.q-gutter-y-lg>*{margin-top:24px}.q-col-gutter-lg,.q-col-gutter-x-lg{margin-left:-24px}.q-col-gutter-lg>*,.q-col-gutter-x-lg>*{padding-left:24px}.q-col-gutter-lg,.q-col-gutter-y-lg{margin-top:-24px}.q-col-gutter-lg>*,.q-col-gutter-y-lg>*{padding-top:24px}.q-gutter-x-xl,.q-gutter-xl{margin-left:-48px}.q-gutter-x-xl>*,.q-gutter-xl>*{margin-left:48px}.q-gutter-xl,.q-gutter-y-xl{margin-top:-48px}.q-gutter-xl>*,.q-gutter-y-xl>*{margin-top:48px}.q-col-gutter-x-xl,.q-col-gutter-xl{margin-left:-48px}.q-col-gutter-x-xl>*,.q-col-gutter-xl>*{padding-left:48px}.q-col-gutter-xl,.q-col-gutter-y-xl{margin-top:-48px}.q-col-gutter-xl>*,.q-col-gutter-y-xl>*{padding-top:48px}@media (min-width:0){.flex>.col,.flex>.col-0,.flex>.col-1,.flex>.col-2,.flex>.col-3,.flex>.col-4,.flex>.col-5,.flex>.col-6,.flex>.col-7,.flex>.col-8,.flex>.col-9,.flex>.col-10,.flex>.col-11,.flex>.col-12,.flex>.col-auto,.flex>.col-grow,.flex>.col-shrink,.flex>.col-xs,.flex>.col-xs-0,.flex>.col-xs-1,.flex>.col-xs-2,.flex>.col-xs-3,.flex>.col-xs-4,.flex>.col-xs-5,.flex>.col-xs-6,.flex>.col-xs-7,.flex>.col-xs-8,.flex>.col-xs-9,.flex>.col-xs-10,.flex>.col-xs-11,.flex>.col-xs-12,.flex>.col-xs-auto,.flex>.col-xs-grow,.flex>.col-xs-shrink,.row>.col,.row>.col-0,.row>.col-1,.row>.col-2,.row>.col-3,.row>.col-4,.row>.col-5,.row>.col-6,.row>.col-7,.row>.col-8,.row>.col-9,.row>.col-10,.row>.col-11,.row>.col-12,.row>.col-auto,.row>.col-grow,.row>.col-shrink,.row>.col-xs,.row>.col-xs-0,.row>.col-xs-1,.row>.col-xs-2,.row>.col-xs-3,.row>.col-xs-4,.row>.col-xs-5,.row>.col-xs-6,.row>.col-xs-7,.row>.col-xs-8,.row>.col-xs-9,.row>.col-xs-10,.row>.col-xs-11,.row>.col-xs-12,.row>.col-xs-auto,.row>.col-xs-grow,.row>.col-xs-shrink{width:auto;min-width:0;max-width:100%}.column>.col,.column>.col-0,.column>.col-1,.column>.col-2,.column>.col-3,.column>.col-4,.column>.col-5,.column>.col-6,.column>.col-7,.column>.col-8,.column>.col-9,.column>.col-10,.column>.col-11,.column>.col-12,.column>.col-auto,.column>.col-grow,.column>.col-shrink,.column>.col-xs,.column>.col-xs-0,.column>.col-xs-1,.column>.col-xs-2,.column>.col-xs-3,.column>.col-xs-4,.column>.col-xs-5,.column>.col-xs-6,.column>.col-xs-7,.column>.col-xs-8,.column>.col-xs-9,.column>.col-xs-10,.column>.col-xs-11,.column>.col-xs-12,.column>.col-xs-auto,.column>.col-xs-grow,.column>.col-xs-shrink,.flex>.col,.flex>.col-0,.flex>.col-1,.flex>.col-2,.flex>.col-3,.flex>.col-4,.flex>.col-5,.flex>.col-6,.flex>.col-7,.flex>.col-8,.flex>.col-9,.flex>.col-10,.flex>.col-11,.flex>.col-12,.flex>.col-auto,.flex>.col-grow,.flex>.col-shrink,.flex>.col-xs,.flex>.col-xs-0,.flex>.col-xs-1,.flex>.col-xs-2,.flex>.col-xs-3,.flex>.col-xs-4,.flex>.col-xs-5,.flex>.col-xs-6,.flex>.col-xs-7,.flex>.col-xs-8,.flex>.col-xs-9,.flex>.col-xs-10,.flex>.col-xs-11,.flex>.col-xs-12,.flex>.col-xs-auto,.flex>.col-xs-grow,.flex>.col-xs-shrink{height:auto;min-height:0;max-height:100%}.col,.col-xs{flex:10000 1 0%}.col-0,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-xs-0,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-auto{flex:0 0 auto}.col-grow,.col-xs-grow{flex:1 0 auto}.col-shrink,.col-xs-shrink{flex:0 1 auto}.row>.col-0,.row>.col-xs-0{height:auto;width:0}.row>.offset-0,.row>.offset-xs-0{margin-left:0}.column>.col-0,.column>.col-xs-0{height:0%;width:auto}.row>.col-1,.row>.col-xs-1{height:auto;width:8.3333%}.row>.offset-1,.row>.offset-xs-1{margin-left:8.3333%}.column>.col-1,.column>.col-xs-1{height:8.3333%;width:auto}.row>.col-2,.row>.col-xs-2{height:auto;width:16.6667%}.row>.offset-2,.row>.offset-xs-2{margin-left:16.6667%}.column>.col-2,.column>.col-xs-2{height:16.6667%;width:auto}.row>.col-3,.row>.col-xs-3{height:auto;width:25%}.row>.offset-3,.row>.offset-xs-3{margin-left:25%}.column>.col-3,.column>.col-xs-3{height:25%;width:auto}.row>.col-4,.row>.col-xs-4{height:auto;width:33.3333%}.row>.offset-4,.row>.offset-xs-4{margin-left:33.3333%}.column>.col-4,.column>.col-xs-4{height:33.3333%;width:auto}.row>.col-5,.row>.col-xs-5{height:auto;width:41.6667%}.row>.offset-5,.row>.offset-xs-5{margin-left:41.6667%}.column>.col-5,.column>.col-xs-5{height:41.6667%;width:auto}.row>.col-6,.row>.col-xs-6{height:auto;width:50%}.row>.offset-6,.row>.offset-xs-6{margin-left:50%}.column>.col-6,.column>.col-xs-6{height:50%;width:auto}.row>.col-7,.row>.col-xs-7{height:auto;width:58.3333%}.row>.offset-7,.row>.offset-xs-7{margin-left:58.3333%}.column>.col-7,.column>.col-xs-7{height:58.3333%;width:auto}.row>.col-8,.row>.col-xs-8{height:auto;width:66.6667%}.row>.offset-8,.row>.offset-xs-8{margin-left:66.6667%}.column>.col-8,.column>.col-xs-8{height:66.6667%;width:auto}.row>.col-9,.row>.col-xs-9{height:auto;width:75%}.row>.offset-9,.row>.offset-xs-9{margin-left:75%}.column>.col-9,.column>.col-xs-9{height:75%;width:auto}.row>.col-10,.row>.col-xs-10{height:auto;width:83.3333%}.row>.offset-10,.row>.offset-xs-10{margin-left:83.3333%}.column>.col-10,.column>.col-xs-10{height:83.3333%;width:auto}.row>.col-11,.row>.col-xs-11{height:auto;width:91.6667%}.row>.offset-11,.row>.offset-xs-11{margin-left:91.6667%}.column>.col-11,.column>.col-xs-11{height:91.6667%;width:auto}.row>.col-12,.row>.col-xs-12{height:auto;width:100%}.row>.offset-12,.row>.offset-xs-12{margin-left:100%}.column>.col-12,.column>.col-xs-12{height:100%;width:auto}.row>.col-all{height:auto;flex:0 0 100%}}@media (min-width:600px){.flex>.col-sm,.flex>.col-sm-0,.flex>.col-sm-1,.flex>.col-sm-2,.flex>.col-sm-3,.flex>.col-sm-4,.flex>.col-sm-5,.flex>.col-sm-6,.flex>.col-sm-7,.flex>.col-sm-8,.flex>.col-sm-9,.flex>.col-sm-10,.flex>.col-sm-11,.flex>.col-sm-12,.flex>.col-sm-auto,.flex>.col-sm-grow,.flex>.col-sm-shrink,.row>.col-sm,.row>.col-sm-0,.row>.col-sm-1,.row>.col-sm-2,.row>.col-sm-3,.row>.col-sm-4,.row>.col-sm-5,.row>.col-sm-6,.row>.col-sm-7,.row>.col-sm-8,.row>.col-sm-9,.row>.col-sm-10,.row>.col-sm-11,.row>.col-sm-12,.row>.col-sm-auto,.row>.col-sm-grow,.row>.col-sm-shrink{width:auto;min-width:0;max-width:100%}.column>.col-sm,.column>.col-sm-0,.column>.col-sm-1,.column>.col-sm-2,.column>.col-sm-3,.column>.col-sm-4,.column>.col-sm-5,.column>.col-sm-6,.column>.col-sm-7,.column>.col-sm-8,.column>.col-sm-9,.column>.col-sm-10,.column>.col-sm-11,.column>.col-sm-12,.column>.col-sm-auto,.column>.col-sm-grow,.column>.col-sm-shrink,.flex>.col-sm,.flex>.col-sm-0,.flex>.col-sm-1,.flex>.col-sm-2,.flex>.col-sm-3,.flex>.col-sm-4,.flex>.col-sm-5,.flex>.col-sm-6,.flex>.col-sm-7,.flex>.col-sm-8,.flex>.col-sm-9,.flex>.col-sm-10,.flex>.col-sm-11,.flex>.col-sm-12,.flex>.col-sm-auto,.flex>.col-sm-grow,.flex>.col-sm-shrink{height:auto;min-height:0;max-height:100%}.col-sm{flex:10000 1 0%}.col-sm-0,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto{flex:0 0 auto}.col-sm-grow{flex:1 0 auto}.col-sm-shrink{flex:0 1 auto}.row>.col-sm-0{height:auto;width:0}.row>.offset-sm-0{margin-left:0}.column>.col-sm-0{height:0%;width:auto}.row>.col-sm-1{height:auto;width:8.3333%}.row>.offset-sm-1{margin-left:8.3333%}.column>.col-sm-1{height:8.3333%;width:auto}.row>.col-sm-2{height:auto;width:16.6667%}.row>.offset-sm-2{margin-left:16.6667%}.column>.col-sm-2{height:16.6667%;width:auto}.row>.col-sm-3{height:auto;width:25%}.row>.offset-sm-3{margin-left:25%}.column>.col-sm-3{height:25%;width:auto}.row>.col-sm-4{height:auto;width:33.3333%}.row>.offset-sm-4{margin-left:33.3333%}.column>.col-sm-4{height:33.3333%;width:auto}.row>.col-sm-5{height:auto;width:41.6667%}.row>.offset-sm-5{margin-left:41.6667%}.column>.col-sm-5{height:41.6667%;width:auto}.row>.col-sm-6{height:auto;width:50%}.row>.offset-sm-6{margin-left:50%}.column>.col-sm-6{height:50%;width:auto}.row>.col-sm-7{height:auto;width:58.3333%}.row>.offset-sm-7{margin-left:58.3333%}.column>.col-sm-7{height:58.3333%;width:auto}.row>.col-sm-8{height:auto;width:66.6667%}.row>.offset-sm-8{margin-left:66.6667%}.column>.col-sm-8{height:66.6667%;width:auto}.row>.col-sm-9{height:auto;width:75%}.row>.offset-sm-9{margin-left:75%}.column>.col-sm-9{height:75%;width:auto}.row>.col-sm-10{height:auto;width:83.3333%}.row>.offset-sm-10{margin-left:83.3333%}.column>.col-sm-10{height:83.3333%;width:auto}.row>.col-sm-11{height:auto;width:91.6667%}.row>.offset-sm-11{margin-left:91.6667%}.column>.col-sm-11{height:91.6667%;width:auto}.row>.col-sm-12{height:auto;width:100%}.row>.offset-sm-12{margin-left:100%}.column>.col-sm-12{height:100%;width:auto}}@media (min-width:1024px){.flex>.col-md,.flex>.col-md-0,.flex>.col-md-1,.flex>.col-md-2,.flex>.col-md-3,.flex>.col-md-4,.flex>.col-md-5,.flex>.col-md-6,.flex>.col-md-7,.flex>.col-md-8,.flex>.col-md-9,.flex>.col-md-10,.flex>.col-md-11,.flex>.col-md-12,.flex>.col-md-auto,.flex>.col-md-grow,.flex>.col-md-shrink,.row>.col-md,.row>.col-md-0,.row>.col-md-1,.row>.col-md-2,.row>.col-md-3,.row>.col-md-4,.row>.col-md-5,.row>.col-md-6,.row>.col-md-7,.row>.col-md-8,.row>.col-md-9,.row>.col-md-10,.row>.col-md-11,.row>.col-md-12,.row>.col-md-auto,.row>.col-md-grow,.row>.col-md-shrink{width:auto;min-width:0;max-width:100%}.column>.col-md,.column>.col-md-0,.column>.col-md-1,.column>.col-md-2,.column>.col-md-3,.column>.col-md-4,.column>.col-md-5,.column>.col-md-6,.column>.col-md-7,.column>.col-md-8,.column>.col-md-9,.column>.col-md-10,.column>.col-md-11,.column>.col-md-12,.column>.col-md-auto,.column>.col-md-grow,.column>.col-md-shrink,.flex>.col-md,.flex>.col-md-0,.flex>.col-md-1,.flex>.col-md-2,.flex>.col-md-3,.flex>.col-md-4,.flex>.col-md-5,.flex>.col-md-6,.flex>.col-md-7,.flex>.col-md-8,.flex>.col-md-9,.flex>.col-md-10,.flex>.col-md-11,.flex>.col-md-12,.flex>.col-md-auto,.flex>.col-md-grow,.flex>.col-md-shrink{height:auto;min-height:0;max-height:100%}.col-md{flex:10000 1 0%}.col-md-0,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto{flex:0 0 auto}.col-md-grow{flex:1 0 auto}.col-md-shrink{flex:0 1 auto}.row>.col-md-0{height:auto;width:0}.row>.offset-md-0{margin-left:0}.column>.col-md-0{height:0%;width:auto}.row>.col-md-1{height:auto;width:8.3333%}.row>.offset-md-1{margin-left:8.3333%}.column>.col-md-1{height:8.3333%;width:auto}.row>.col-md-2{height:auto;width:16.6667%}.row>.offset-md-2{margin-left:16.6667%}.column>.col-md-2{height:16.6667%;width:auto}.row>.col-md-3{height:auto;width:25%}.row>.offset-md-3{margin-left:25%}.column>.col-md-3{height:25%;width:auto}.row>.col-md-4{height:auto;width:33.3333%}.row>.offset-md-4{margin-left:33.3333%}.column>.col-md-4{height:33.3333%;width:auto}.row>.col-md-5{height:auto;width:41.6667%}.row>.offset-md-5{margin-left:41.6667%}.column>.col-md-5{height:41.6667%;width:auto}.row>.col-md-6{height:auto;width:50%}.row>.offset-md-6{margin-left:50%}.column>.col-md-6{height:50%;width:auto}.row>.col-md-7{height:auto;width:58.3333%}.row>.offset-md-7{margin-left:58.3333%}.column>.col-md-7{height:58.3333%;width:auto}.row>.col-md-8{height:auto;width:66.6667%}.row>.offset-md-8{margin-left:66.6667%}.column>.col-md-8{height:66.6667%;width:auto}.row>.col-md-9{height:auto;width:75%}.row>.offset-md-9{margin-left:75%}.column>.col-md-9{height:75%;width:auto}.row>.col-md-10{height:auto;width:83.3333%}.row>.offset-md-10{margin-left:83.3333%}.column>.col-md-10{height:83.3333%;width:auto}.row>.col-md-11{height:auto;width:91.6667%}.row>.offset-md-11{margin-left:91.6667%}.column>.col-md-11{height:91.6667%;width:auto}.row>.col-md-12{height:auto;width:100%}.row>.offset-md-12{margin-left:100%}.column>.col-md-12{height:100%;width:auto}}@media (min-width:1440px){.flex>.col-lg,.flex>.col-lg-0,.flex>.col-lg-1,.flex>.col-lg-2,.flex>.col-lg-3,.flex>.col-lg-4,.flex>.col-lg-5,.flex>.col-lg-6,.flex>.col-lg-7,.flex>.col-lg-8,.flex>.col-lg-9,.flex>.col-lg-10,.flex>.col-lg-11,.flex>.col-lg-12,.flex>.col-lg-auto,.flex>.col-lg-grow,.flex>.col-lg-shrink,.row>.col-lg,.row>.col-lg-0,.row>.col-lg-1,.row>.col-lg-2,.row>.col-lg-3,.row>.col-lg-4,.row>.col-lg-5,.row>.col-lg-6,.row>.col-lg-7,.row>.col-lg-8,.row>.col-lg-9,.row>.col-lg-10,.row>.col-lg-11,.row>.col-lg-12,.row>.col-lg-auto,.row>.col-lg-grow,.row>.col-lg-shrink{width:auto;min-width:0;max-width:100%}.column>.col-lg,.column>.col-lg-0,.column>.col-lg-1,.column>.col-lg-2,.column>.col-lg-3,.column>.col-lg-4,.column>.col-lg-5,.column>.col-lg-6,.column>.col-lg-7,.column>.col-lg-8,.column>.col-lg-9,.column>.col-lg-10,.column>.col-lg-11,.column>.col-lg-12,.column>.col-lg-auto,.column>.col-lg-grow,.column>.col-lg-shrink,.flex>.col-lg,.flex>.col-lg-0,.flex>.col-lg-1,.flex>.col-lg-2,.flex>.col-lg-3,.flex>.col-lg-4,.flex>.col-lg-5,.flex>.col-lg-6,.flex>.col-lg-7,.flex>.col-lg-8,.flex>.col-lg-9,.flex>.col-lg-10,.flex>.col-lg-11,.flex>.col-lg-12,.flex>.col-lg-auto,.flex>.col-lg-grow,.flex>.col-lg-shrink{height:auto;min-height:0;max-height:100%}.col-lg{flex:10000 1 0%}.col-lg-0,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto{flex:0 0 auto}.col-lg-grow{flex:1 0 auto}.col-lg-shrink{flex:0 1 auto}.row>.col-lg-0{height:auto;width:0}.row>.offset-lg-0{margin-left:0}.column>.col-lg-0{height:0%;width:auto}.row>.col-lg-1{height:auto;width:8.3333%}.row>.offset-lg-1{margin-left:8.3333%}.column>.col-lg-1{height:8.3333%;width:auto}.row>.col-lg-2{height:auto;width:16.6667%}.row>.offset-lg-2{margin-left:16.6667%}.column>.col-lg-2{height:16.6667%;width:auto}.row>.col-lg-3{height:auto;width:25%}.row>.offset-lg-3{margin-left:25%}.column>.col-lg-3{height:25%;width:auto}.row>.col-lg-4{height:auto;width:33.3333%}.row>.offset-lg-4{margin-left:33.3333%}.column>.col-lg-4{height:33.3333%;width:auto}.row>.col-lg-5{height:auto;width:41.6667%}.row>.offset-lg-5{margin-left:41.6667%}.column>.col-lg-5{height:41.6667%;width:auto}.row>.col-lg-6{height:auto;width:50%}.row>.offset-lg-6{margin-left:50%}.column>.col-lg-6{height:50%;width:auto}.row>.col-lg-7{height:auto;width:58.3333%}.row>.offset-lg-7{margin-left:58.3333%}.column>.col-lg-7{height:58.3333%;width:auto}.row>.col-lg-8{height:auto;width:66.6667%}.row>.offset-lg-8{margin-left:66.6667%}.column>.col-lg-8{height:66.6667%;width:auto}.row>.col-lg-9{height:auto;width:75%}.row>.offset-lg-9{margin-left:75%}.column>.col-lg-9{height:75%;width:auto}.row>.col-lg-10{height:auto;width:83.3333%}.row>.offset-lg-10{margin-left:83.3333%}.column>.col-lg-10{height:83.3333%;width:auto}.row>.col-lg-11{height:auto;width:91.6667%}.row>.offset-lg-11{margin-left:91.6667%}.column>.col-lg-11{height:91.6667%;width:auto}.row>.col-lg-12{height:auto;width:100%}.row>.offset-lg-12{margin-left:100%}.column>.col-lg-12{height:100%;width:auto}}@media (min-width:1920px){.flex>.col-xl,.flex>.col-xl-0,.flex>.col-xl-1,.flex>.col-xl-2,.flex>.col-xl-3,.flex>.col-xl-4,.flex>.col-xl-5,.flex>.col-xl-6,.flex>.col-xl-7,.flex>.col-xl-8,.flex>.col-xl-9,.flex>.col-xl-10,.flex>.col-xl-11,.flex>.col-xl-12,.flex>.col-xl-auto,.flex>.col-xl-grow,.flex>.col-xl-shrink,.row>.col-xl,.row>.col-xl-0,.row>.col-xl-1,.row>.col-xl-2,.row>.col-xl-3,.row>.col-xl-4,.row>.col-xl-5,.row>.col-xl-6,.row>.col-xl-7,.row>.col-xl-8,.row>.col-xl-9,.row>.col-xl-10,.row>.col-xl-11,.row>.col-xl-12,.row>.col-xl-auto,.row>.col-xl-grow,.row>.col-xl-shrink{width:auto;min-width:0;max-width:100%}.column>.col-xl,.column>.col-xl-0,.column>.col-xl-1,.column>.col-xl-2,.column>.col-xl-3,.column>.col-xl-4,.column>.col-xl-5,.column>.col-xl-6,.column>.col-xl-7,.column>.col-xl-8,.column>.col-xl-9,.column>.col-xl-10,.column>.col-xl-11,.column>.col-xl-12,.column>.col-xl-auto,.column>.col-xl-grow,.column>.col-xl-shrink,.flex>.col-xl,.flex>.col-xl-0,.flex>.col-xl-1,.flex>.col-xl-2,.flex>.col-xl-3,.flex>.col-xl-4,.flex>.col-xl-5,.flex>.col-xl-6,.flex>.col-xl-7,.flex>.col-xl-8,.flex>.col-xl-9,.flex>.col-xl-10,.flex>.col-xl-11,.flex>.col-xl-12,.flex>.col-xl-auto,.flex>.col-xl-grow,.flex>.col-xl-shrink{height:auto;min-height:0;max-height:100%}.col-xl{flex:10000 1 0%}.col-xl-0,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto{flex:0 0 auto}.col-xl-grow{flex:1 0 auto}.col-xl-shrink{flex:0 1 auto}.row>.col-xl-0{height:auto;width:0}.row>.offset-xl-0{margin-left:0}.column>.col-xl-0{height:0%;width:auto}.row>.col-xl-1{height:auto;width:8.3333%}.row>.offset-xl-1{margin-left:8.3333%}.column>.col-xl-1{height:8.3333%;width:auto}.row>.col-xl-2{height:auto;width:16.6667%}.row>.offset-xl-2{margin-left:16.6667%}.column>.col-xl-2{height:16.6667%;width:auto}.row>.col-xl-3{height:auto;width:25%}.row>.offset-xl-3{margin-left:25%}.column>.col-xl-3{height:25%;width:auto}.row>.col-xl-4{height:auto;width:33.3333%}.row>.offset-xl-4{margin-left:33.3333%}.column>.col-xl-4{height:33.3333%;width:auto}.row>.col-xl-5{height:auto;width:41.6667%}.row>.offset-xl-5{margin-left:41.6667%}.column>.col-xl-5{height:41.6667%;width:auto}.row>.col-xl-6{height:auto;width:50%}.row>.offset-xl-6{margin-left:50%}.column>.col-xl-6{height:50%;width:auto}.row>.col-xl-7{height:auto;width:58.3333%}.row>.offset-xl-7{margin-left:58.3333%}.column>.col-xl-7{height:58.3333%;width:auto}.row>.col-xl-8{height:auto;width:66.6667%}.row>.offset-xl-8{margin-left:66.6667%}.column>.col-xl-8{height:66.6667%;width:auto}.row>.col-xl-9{height:auto;width:75%}.row>.offset-xl-9{margin-left:75%}.column>.col-xl-9{height:75%;width:auto}.row>.col-xl-10{height:auto;width:83.3333%}.row>.offset-xl-10{margin-left:83.3333%}.column>.col-xl-10{height:83.3333%;width:auto}.row>.col-xl-11{height:auto;width:91.6667%}.row>.offset-xl-11{margin-left:91.6667%}.column>.col-xl-11{height:91.6667%;width:auto}.row>.col-xl-12{height:auto;width:100%}.row>.offset-xl-12{margin-left:100%}.column>.col-xl-12{height:100%;width:auto}}.rounded-borders{border-radius:4px}.border-radius-inherit{border-radius:inherit}.no-transition{transition:none!important}.transition-0{transition:0s!important}.glossy{background-image:linear-gradient(180deg,hsla(0,0%,100%,.3),hsla(0,0%,100%,0) 50%,rgba(0,0,0,.12) 51%,rgba(0,0,0,.04))!important}.q-placeholder::placeholder{color:inherit;opacity:.7}.q-body--fullscreen-mixin,.q-body--prevent-scroll{position:fixed!important}.q-body--force-scrollbar{overflow-y:scroll}.q-no-input-spinner{-moz-appearance:textfield!important}.q-no-input-spinner::-webkit-inner-spin-button,.q-no-input-spinner::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.q-link{outline:0;text-decoration:none}.q-link--focusable:focus-visible{text-decoration:underline dashed currentColor 1px}body.electron .q-electron-drag{-webkit-user-select:none;-webkit-app-region:drag}body.electron .q-electron-drag--exception,body.electron .q-electron-drag .q-btn-item{-webkit-app-region:no-drag}img.responsive{max-width:100%;height:auto}.non-selectable{user-select:none!important}.scroll{overflow:auto}.scroll,.scroll-x,.scroll-y{-webkit-overflow-scrolling:touch;will-change:scroll-position}.scroll-x{overflow-x:auto}.scroll-y{overflow-y:auto}.no-scroll{overflow:hidden!important}.no-pointer-events,.no-pointer-events--children,.no-pointer-events--children *{pointer-events:none!important}.all-pointer-events{pointer-events:all!important}.cursor-pointer{cursor:pointer!important}.cursor-not-allowed{cursor:not-allowed!important}.cursor-inherit{cursor:inherit!important}.cursor-none{cursor:none!important}[aria-busy=true]{cursor:progress}[aria-controls],[role=button]{cursor:pointer}[aria-disabled]{cursor:default}.rotate-45{transform:rotate(45deg)}.rotate-90{transform:rotate(90deg)}.rotate-135{transform:rotate(135deg)}.rotate-180{transform:rotate(180deg)}.rotate-205{transform:rotate(205deg)}.rotate-225{transform:rotate(225deg)}.rotate-270{transform:rotate(270deg)}.rotate-315{transform:rotate(315deg)}.flip-horizontal{transform:scaleX(-1)}.flip-vertical{transform:scaleY(-1)}.float-left{float:left}.float-right{float:right}.relative-position{position:relative}.fixed,.fixed-bottom,.fixed-bottom-left,.fixed-bottom-right,.fixed-center,.fixed-full,.fixed-left,.fixed-right,.fixed-top,.fixed-top-left,.fixed-top-right,.fullscreen{position:fixed}.absolute,.absolute-bottom,.absolute-bottom-left,.absolute-bottom-right,.absolute-center,.absolute-full,.absolute-left,.absolute-right,.absolute-top,.absolute-top-left,.absolute-top-right{position:absolute}.absolute-top,.fixed-top{top:0;left:0;right:0}.absolute-right,.fixed-right{top:0;right:0;bottom:0}.absolute-bottom,.fixed-bottom{right:0;bottom:0;left:0}.absolute-left,.fixed-left{top:0;bottom:0;left:0}.absolute-top-left,.fixed-top-left{top:0;left:0}.absolute-top-right,.fixed-top-right{top:0;right:0}.absolute-bottom-left,.fixed-bottom-left{bottom:0;left:0}.absolute-bottom-right,.fixed-bottom-right{bottom:0;right:0}.fullscreen{z-index:6000;border-radius:0!important;max-width:100vw;max-height:100vh}body.q-ios-padding .fullscreen{padding-top:20px!important;padding-top:env(safe-area-inset-top)!important;padding-bottom:env(safe-area-inset-bottom)!important}.absolute-full,.fixed-full,.fullscreen{top:0;right:0;bottom:0;left:0}.absolute-center,.fixed-center{top:50%;left:50%;transform:translate(-50%,-50%)}.vertical-top{vertical-align:top!important}.vertical-middle{vertical-align:middle!important}.vertical-bottom{vertical-align:bottom!important}.on-left{margin-right:12px}.on-right{margin-left:12px}.q-position-engine{margin-top:var(--q-pe-top,0)!important;margin-left:var(--q-pe-left,0)!important;will-change:auto;visibility:collapse}:root{--q-size-xs:0;--q-size-sm:600px;--q-size-md:1024px;--q-size-lg:1440px;--q-size-xl:1920px}.fit{width:100%!important}.fit,.full-height{height:100%!important}.full-width{width:100%!important;margin-left:0!important;margin-right:0!important}.window-height{margin-top:0!important;margin-bottom:0!important;height:100vh!important}.window-width{margin-left:0!important;margin-right:0!important;width:100vw!important}.block{display:block!important}.inline-block{display:inline-block!important}.q-pa-none{padding:0 0}.q-pl-none{padding-left:0}.q-pr-none{padding-right:0}.q-pt-none,.q-py-none{padding-top:0}.q-pb-none,.q-py-none{padding-bottom:0}.q-px-none{padding-left:0;padding-right:0}.q-ma-none{margin:0 0}.q-ml-none{margin-left:0}.q-mr-none{margin-right:0}.q-mt-none,.q-my-none{margin-top:0}.q-mb-none,.q-my-none{margin-bottom:0}.q-mx-none{margin-left:0;margin-right:0}.q-pa-xs{padding:4px 4px}.q-pl-xs{padding-left:4px}.q-pr-xs{padding-right:4px}.q-pt-xs,.q-py-xs{padding-top:4px}.q-pb-xs,.q-py-xs{padding-bottom:4px}.q-px-xs{padding-left:4px;padding-right:4px}.q-ma-xs{margin:4px 4px}.q-ml-xs{margin-left:4px}.q-mr-xs{margin-right:4px}.q-mt-xs,.q-my-xs{margin-top:4px}.q-mb-xs,.q-my-xs{margin-bottom:4px}.q-mx-xs{margin-left:4px;margin-right:4px}.q-pa-sm{padding:8px 8px}.q-pl-sm{padding-left:8px}.q-pr-sm{padding-right:8px}.q-pt-sm,.q-py-sm{padding-top:8px}.q-pb-sm,.q-py-sm{padding-bottom:8px}.q-px-sm{padding-left:8px;padding-right:8px}.q-ma-sm{margin:8px 8px}.q-ml-sm{margin-left:8px}.q-mr-sm{margin-right:8px}.q-mt-sm,.q-my-sm{margin-top:8px}.q-mb-sm,.q-my-sm{margin-bottom:8px}.q-mx-sm{margin-left:8px;margin-right:8px}.q-pa-md{padding:16px 16px}.q-pl-md{padding-left:16px}.q-pr-md{padding-right:16px}.q-pt-md,.q-py-md{padding-top:16px}.q-pb-md,.q-py-md{padding-bottom:16px}.q-px-md{padding-left:16px;padding-right:16px}.q-ma-md{margin:16px 16px}.q-ml-md{margin-left:16px}.q-mr-md{margin-right:16px}.q-mt-md,.q-my-md{margin-top:16px}.q-mb-md,.q-my-md{margin-bottom:16px}.q-mx-md{margin-left:16px;margin-right:16px}.q-pa-lg{padding:24px 24px}.q-pl-lg{padding-left:24px}.q-pr-lg{padding-right:24px}.q-pt-lg,.q-py-lg{padding-top:24px}.q-pb-lg,.q-py-lg{padding-bottom:24px}.q-px-lg{padding-left:24px;padding-right:24px}.q-ma-lg{margin:24px 24px}.q-ml-lg{margin-left:24px}.q-mr-lg{margin-right:24px}.q-mt-lg,.q-my-lg{margin-top:24px}.q-mb-lg,.q-my-lg{margin-bottom:24px}.q-mx-lg{margin-left:24px;margin-right:24px}.q-pa-xl{padding:48px 48px}.q-pl-xl{padding-left:48px}.q-pr-xl{padding-right:48px}.q-pt-xl,.q-py-xl{padding-top:48px}.q-pb-xl,.q-py-xl{padding-bottom:48px}.q-px-xl{padding-left:48px;padding-right:48px}.q-ma-xl{margin:48px 48px}.q-ml-xl{margin-left:48px}.q-mr-xl{margin-right:48px}.q-mt-xl,.q-my-xl{margin-top:48px}.q-mb-xl,.q-my-xl{margin-bottom:48px}.q-mx-xl{margin-left:48px;margin-right:48px}.q-mt-auto,.q-my-auto{margin-top:auto}.q-ml-auto{margin-left:auto}.q-mb-auto,.q-my-auto{margin-bottom:auto}.q-mr-auto,.q-mx-auto{margin-right:auto}.q-mx-auto{margin-left:auto}.q-touch{user-select:none;user-drag:none;-khtml-user-drag:none;-webkit-user-drag:none}.q-touch-x{touch-action:pan-x}.q-touch-y{touch-action:pan-y}.q-transition--fade-leave-active,.q-transition--flip-leave-active,.q-transition--jump-down-leave-active,.q-transition--jump-left-leave-active,.q-transition--jump-right-leave-active,.q-transition--jump-up-leave-active,.q-transition--rotate-leave-active,.q-transition--scale-leave-active,.q-transition--slide-down-leave-active,.q-transition--slide-left-leave-active,.q-transition--slide-right-leave-active,.q-transition--slide-up-leave-active{position:absolute}.q-transition--slide-down-enter-active,.q-transition--slide-down-leave-active,.q-transition--slide-left-enter-active,.q-transition--slide-left-leave-active,.q-transition--slide-right-enter-active,.q-transition--slide-right-leave-active,.q-transition--slide-up-enter-active,.q-transition--slide-up-leave-active{transition:transform .3s cubic-bezier(.215,.61,.355,1)}.q-transition--slide-right-enter{transform:translate3d(-100%,0,0)}.q-transition--slide-left-enter,.q-transition--slide-right-leave-to{transform:translate3d(100%,0,0)}.q-transition--slide-left-leave-to{transform:translate3d(-100%,0,0)}.q-transition--slide-up-enter{transform:translate3d(0,100%,0)}.q-transition--slide-down-enter,.q-transition--slide-up-leave-to{transform:translate3d(0,-100%,0)}.q-transition--slide-down-leave-to{transform:translate3d(0,100%,0)}.q-transition--jump-down-enter-active,.q-transition--jump-down-leave-active,.q-transition--jump-left-enter-active,.q-transition--jump-left-leave-active,.q-transition--jump-right-enter-active,.q-transition--jump-right-leave-active,.q-transition--jump-up-enter-active,.q-transition--jump-up-leave-active{transition:opacity .3s,transform .3s}.q-transition--jump-down-enter,.q-transition--jump-down-leave-to,.q-transition--jump-left-enter,.q-transition--jump-left-leave-to,.q-transition--jump-right-enter,.q-transition--jump-right-leave-to,.q-transition--jump-up-enter,.q-transition--jump-up-leave-to{opacity:0}.q-transition--jump-right-enter{transform:translate3d(-15px,0,0)}.q-transition--jump-left-enter,.q-transition--jump-right-leave-to{transform:translate3d(15px,0,0)}.q-transition--jump-left-leave-to{transform:translateX(-15px)}.q-transition--jump-up-enter{transform:translate3d(0,15px,0)}.q-transition--jump-down-enter,.q-transition--jump-up-leave-to{transform:translate3d(0,-15px,0)}.q-transition--jump-down-leave-to{transform:translate3d(0,15px,0)}.q-transition--fade-enter-active,.q-transition--fade-leave-active{transition:opacity .3s ease-out}.q-transition--fade-enter,.q-transition--fade-leave,.q-transition--fade-leave-to{opacity:0}.q-transition--scale-enter-active,.q-transition--scale-leave-active{transition:opacity .3s,transform .3s cubic-bezier(.215,.61,.355,1)}.q-transition--scale-enter,.q-transition--scale-leave,.q-transition--scale-leave-to{opacity:0;transform:scale3d(0,0,1)}.q-transition--rotate-enter-active,.q-transition--rotate-leave-active{transition:opacity .3s,transform .3s cubic-bezier(.215,.61,.355,1);transform-style:preserve-3d}.q-transition--rotate-enter,.q-transition--rotate-leave,.q-transition--rotate-leave-to{opacity:0;transform:scale3d(0,0,1) rotate(90deg)}.q-transition--flip-down-enter-active,.q-transition--flip-down-leave-active,.q-transition--flip-left-enter-active,.q-transition--flip-left-leave-active,.q-transition--flip-right-enter-active,.q-transition--flip-right-leave-active,.q-transition--flip-up-enter-active,.q-transition--flip-up-leave-active{transition:transform .3s;backface-visibility:hidden}.q-transition--flip-down-enter-to,.q-transition--flip-down-leave,.q-transition--flip-left-enter-to,.q-transition--flip-left-leave,.q-transition--flip-right-enter-to,.q-transition--flip-right-leave,.q-transition--flip-up-enter-to,.q-transition--flip-up-leave{transform:perspective(400px) rotate3d(1,1,0,0deg)}.q-transition--flip-right-enter{transform:perspective(400px) rotateY(-180deg)}.q-transition--flip-left-enter,.q-transition--flip-right-leave-to{transform:perspective(400px) rotateY(180deg)}.q-transition--flip-left-leave-to{transform:perspective(400px) rotateY(-180deg)}.q-transition--flip-up-enter{transform:perspective(400px) rotateX(-180deg)}.q-transition--flip-down-enter,.q-transition--flip-up-leave-to{transform:perspective(400px) rotateX(180deg)}.q-transition--flip-down-leave-to{transform:perspective(400px) rotateX(-180deg)}body{min-width:100px;min-height:100%;font-family:Roboto,-apple-system,Helvetica Neue,Helvetica,Arial,sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-smoothing:antialiased;line-height:1.5;font-size:14px}h1{font-size:6rem;line-height:6rem;letter-spacing:-.01562em}h1,h2{font-weight:300}h2{font-size:3.75rem;line-height:3.75rem;letter-spacing:-.00833em}h3{font-size:3rem;line-height:3.125rem;letter-spacing:normal}h3,h4{font-weight:400}h4{font-size:2.125rem;line-height:2.5rem;letter-spacing:.00735em}h5{font-size:1.5rem;font-weight:400;letter-spacing:normal}h5,h6{line-height:2rem}h6{font-size:1.25rem;font-weight:500;letter-spacing:.0125em}p{margin:0 0 16px}.text-h1{font-size:6rem;font-weight:300;line-height:6rem;letter-spacing:-.01562em}.text-h2{font-size:3.75rem;font-weight:300;line-height:3.75rem;letter-spacing:-.00833em}.text-h3{font-size:3rem;font-weight:400;line-height:3.125rem;letter-spacing:normal}.text-h4{font-size:2.125rem;font-weight:400;line-height:2.5rem;letter-spacing:.00735em}.text-h5{font-size:1.5rem;font-weight:400;line-height:2rem;letter-spacing:normal}.text-h6{font-size:1.25rem;font-weight:500;line-height:2rem;letter-spacing:.0125em}.text-subtitle1{font-size:1rem;font-weight:400;line-height:1.75rem;letter-spacing:.00937em}.text-subtitle2{font-size:.875rem;font-weight:500;line-height:1.375rem;letter-spacing:.00714em}.text-body1{font-size:1rem;font-weight:400;line-height:1.5rem;letter-spacing:.03125em}.text-body2{font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.01786em}.text-overline{font-size:.75rem;font-weight:500;line-height:2rem;letter-spacing:.16667em}.text-caption{font-size:.75rem;font-weight:400;line-height:1.25rem;letter-spacing:.03333em}.text-uppercase{text-transform:uppercase}.text-lowercase{text-transform:lowercase}.text-capitalize{text-transform:capitalize}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.text-justify{text-align:justify;hyphens:auto}.text-italic{font-style:italic}.text-bold{font-weight:700}.text-no-wrap{white-space:nowrap}.text-strike{text-decoration:line-through}.text-weight-thin{font-weight:100}.text-weight-light{font-weight:300}.text-weight-regular{font-weight:400}.text-weight-medium{font-weight:500}.text-weight-bold{font-weight:700}.text-weight-bolder{font-weight:900}small{font-size:80%}big{font-size:170%}sub{bottom:-.25em}sup{top:-.5em}.no-margin{margin:0!important}.no-padding{padding:0!important}.no-border{border:0!important}.no-border-radius{border-radius:0!important}.no-box-shadow{box-shadow:none!important}.no-outline{outline:0!important}.ellipsis{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.ellipsis-2-lines,.ellipsis-3-lines{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical}.ellipsis-2-lines{-webkit-line-clamp:2}.ellipsis-3-lines{-webkit-line-clamp:3}.readonly{cursor:default!important}.disabled,.disabled *,[disabled],[disabled] *{outline:0!important;cursor:not-allowed!important}.disabled,[disabled]{opacity:.6!important}.hidden{display:none!important}.invisible,.invisible *{visibility:hidden!important;transition:none!important;animation:none!important}.transparent{background:transparent!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.overflow-hidden-y{overflow-y:hidden!important}.hide-scrollbar{scrollbar-width:none;-ms-overflow-style:none}.hide-scrollbar::-webkit-scrollbar{width:0;height:0;display:none}.dimmed:after,.light-dimmed:after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0}.dimmed:after{background:rgba(0,0,0,.4)!important}.light-dimmed:after{background:hsla(0,0%,100%,.6)!important}.z-top{z-index:7000!important}.z-max{z-index:9998!important}body.capacitor .capacitor-hide,body.cordova .cordova-hide,body.desktop .desktop-hide,body.electron .electron-hide,body.mobile .mobile-hide,body.native-mobile .native-mobile-hide,body.platform-android .platform-android-hide,body.platform-ios .platform-ios-hide,body.touch .touch-hide,body.within-iframe .within-iframe-hide,body:not(.capacitor) .capacitor-only,body:not(.cordova) .cordova-only,body:not(.desktop) .desktop-only,body:not(.electron) .electron-only,body:not(.mobile) .mobile-only,body:not(.native-mobile) .native-mobile-only,body:not(.platform-android) .platform-android-only,body:not(.platform-ios) .platform-ios-only,body:not(.touch) .touch-only,body:not(.within-iframe) .within-iframe-only{display:none!important}@media (orientation:portrait){.orientation-landscape{display:none!important}}@media (orientation:landscape){.orientation-portrait{display:none!important}}@media screen{.print-only{display:none!important}}@media print{.print-hide{display:none!important}}@media (max-width:599.98px){.gt-lg,.gt-md,.gt-sm,.gt-xs,.lg,.md,.sm,.xl,.xs-hide{display:none!important}}@media (min-width:600px) and (max-width:1023.98px){.gt-lg,.gt-md,.gt-sm,.lg,.lt-sm,.md,.sm-hide,.xl,.xs{display:none!important}}@media (min-width:1024px) and (max-width:1439.98px){.gt-lg,.gt-md,.lg,.lt-md,.lt-sm,.md-hide,.sm,.xl,.xs{display:none!important}}@media (min-width:1440px) and (max-width:1919.98px){.gt-lg,.lg-hide,.lt-lg,.lt-md,.lt-sm,.md,.sm,.xl,.xs{display:none!important}}@media (min-width:1920px){.lg,.lt-lg,.lt-md,.lt-sm,.lt-xl,.md,.sm,.xl-hide,.xs{display:none!important}}.q-focus-helper,.q-focusable,.q-hoverable,.q-manual-focusable{outline:0}body.desktop .q-focus-helper{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;border-radius:inherit;opacity:0;transition:background-color .3s cubic-bezier(.25,.8,.5,1),opacity .4s cubic-bezier(.25,.8,.5,1)}body.desktop .q-focus-helper:after,body.desktop .q-focus-helper:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;border-radius:inherit;transition:background-color .3s cubic-bezier(.25,.8,.5,1),opacity .6s cubic-bezier(.25,.8,.5,1)}body.desktop .q-focus-helper:before{background:#000}body.desktop .q-focus-helper:after{background:#fff}body.desktop .q-focus-helper--rounded{border-radius:4px}body.desktop .q-focus-helper--round{border-radius:50%}body.desktop .q-focusable:focus>.q-focus-helper,body.desktop .q-hoverable:hover>.q-focus-helper,body.desktop .q-manual-focusable--focused>.q-focus-helper{background:currentColor;opacity:.15}body.desktop .q-focusable:focus>.q-focus-helper:before,body.desktop .q-hoverable:hover>.q-focus-helper:before,body.desktop .q-manual-focusable--focused>.q-focus-helper:before{opacity:.1}body.desktop .q-focusable:focus>.q-focus-helper:after,body.desktop .q-hoverable:hover>.q-focus-helper:after,body.desktop .q-manual-focusable--focused>.q-focus-helper:after{opacity:.4}body.desktop .q-focusable:focus>.q-focus-helper,body.desktop .q-manual-focusable--focused>.q-focus-helper{opacity:.22}body.body--dark{color:#fff;background:#121212;background:var(--q-color-dark-page)}.q-dark{color:#fff;background:#424242;background:var(--q-color-dark)}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.q-item:after,.q-notification:after,.q-toolbar:after{content:\"\";font-size:0;visibility:collapse;display:inline;width:0}.q-banner>.q-banner__avatar{min-height:38px}.q-banner--dense>.q-banner__avatar{min-height:20px}.q-item:after{min-height:32px}.q-item--denseafter,.q-list--dense>.q-itemafter{min-height:24px}.q-toolbar:after{min-height:50px}.q-notification--standard:after{min-height:48px}.q-notification--multi-line{min-height:68px}.q-btn__wrapper,.q-menu .q-item__section--main,.q-table__middle,.q-time__content,.q-toolbar__title{flex-basis:auto}.q-banner__content{flex-basis:0!important}.q-dialog__inner>.q-banner>.q-banner__content,.q-menu>.q-banner>.q-banner__content{flex-basis:auto!important}.q-tab__content{flex-basis:auto;min-width:100%}.q-card__actions--vert{flex:0 0 auto}.column{min-width:0}.q-item__section--avatar{min-width:56px}button.q-btn--actionable:active:hover .q-btn__wrapper{margin:-1px 1px 1px -1px}.q-btn-group--push>button.q-btn--push.q-btn--actionable:active:hover .q-btn__wrapper{margin:1px 1px -1px -1px}.q-btn{overflow:visible}.q-btn--wrap{flex-direction:row}.q-carousel__slide>*{max-width:100%}.q-tabs--vertical .q-tab__indicator{height:auto}.q-spinner{animation:q-ie-spinner 2s linear infinite;transform-origin:center center;opacity:.5}.q-spinner.q-spinner-mat .path{stroke-dasharray:89,200}.q-checkbox__indet{opacity:0}.q-checkbox__inner--indet .q-checkbox__indet{opacity:1}.q-radio__check{opacity:0}.q-radio__inner--truthy .q-radio__check{opacity:1}.q-date__main{min-height:290px!important}.q-date__months{align-items:stretch}.q-time--portrait .q-time__main{display:flex;flex-direction:column;flex-wrap:nowrap;flex:1 0 auto}.q-field__prefix,.q-field__suffix{flex:1 0 auto}.q-field__bottom--stale .q-field__messages{left:12px}.q-field--borderless .q-field__bottom--stale .q-field__messages,.q-field--standard .q-field__bottom--stale .q-field__messages{left:0}.q-field--float .q-field__label{max-width:100%}.q-focus-helper{z-index:1}}@supports (-ms-ime-align:auto){.q-item:after,.q-notification:after,.q-toolbar:after{content:\"\";font-size:0;visibility:collapse;display:inline;width:0}.q-banner>.q-banner__avatar{min-height:38px}.q-banner--dense>.q-banner__avatar{min-height:20px}.q-item:after{min-height:32px}.q-item--denseafter,.q-list--dense>.q-itemafter{min-height:24px}.q-toolbar:after{min-height:50px}.q-notification--standard:after{min-height:48px}.q-notification--multi-line{min-height:68px}.q-btn__wrapper,.q-menu .q-item__section--main,.q-table__middle,.q-time__content,.q-toolbar__title{flex-basis:auto}.q-banner__content{flex-basis:0!important}.q-dialog__inner>.q-banner>.q-banner__content,.q-menu>.q-banner>.q-banner__content{flex-basis:auto!important}.q-tab__content{flex-basis:auto;min-width:100%}.q-card__actions--vert{flex:0 0 auto}.column{min-width:0}@media (-ms-high-contrast:none) and (min-width:0),screen and (-ms-high-contrast:active) and (min-width:0){.flex>.col,.flex>.col-xs,.row>.col,.row>.col-xs{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:600px),screen and (-ms-high-contrast:active) and (min-width:600px){.flex>.col-sm,.row>.col-sm{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:1024px),screen and (-ms-high-contrast:active) and (min-width:1024px){.flex>.col-md,.row>.col-md{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:1440px),screen and (-ms-high-contrast:active) and (min-width:1440px){.flex>.col-lg,.row>.col-lg{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:1920px),screen and (-ms-high-contrast:active) and (min-width:1920px){.flex>.col-xl,.row>.col-xl{flex-basis:auto;min-width:0}}.q-item__section--avatar{min-width:56px}button.q-btn--actionable:active:hover .q-btn__wrapper{margin:-1px 1px 1px -1px}.q-btn-group--push>button.q-btn--push.q-btn--actionable:active:hover .q-btn__wrapper{margin:1px 1px -1px -1px}.q-btn{overflow:visible}.q-btn--wrap{flex-direction:row}.q-carousel__slide>*{max-width:100%}.q-tabs--vertical .q-tab__indicator{height:auto}.q-spinner{animation:q-ie-spinner 2s linear infinite;transform-origin:center center;opacity:.5}.q-spinner.q-spinner-mat .path{stroke-dasharray:89,200}.q-checkbox__indet{opacity:0}.q-checkbox__inner--indet .q-checkbox__indet{opacity:1}.q-radio__check{opacity:0}.q-radio__inner--truthy .q-radio__check{opacity:1}.q-date__main{min-height:290px!important}.q-date__months{align-items:stretch}.q-time--portrait .q-time__main{display:flex;flex-direction:column;flex-wrap:nowrap;flex:1 0 auto}.q-field__prefix,.q-field__suffix{flex:1 0 auto}.q-field__bottom--stale .q-field__messages{left:12px}.q-field--borderless .q-field__bottom--stale .q-field__messages,.q-field--standard .q-field__bottom--stale .q-field__messages{left:0}.q-field--float .q-field__label{max-width:100%}.q-focus-helper{z-index:1}}@keyframes q-circular-progress-circle{0%{stroke-dasharray:1,400;stroke-dashoffset:0}50%{stroke-dasharray:400,400;stroke-dashoffset:-100}to{stroke-dasharray:400,400;stroke-dashoffset:-300}}@keyframes q-expansion-done{0%{--q-exp-done:1}}@keyframes q-field-label{40%{margin-left:2px}60%,80%{margin-left:-2px}70%,90%{margin-left:2px}}@keyframes q-autofill{to{background:transparent;color:inherit}}@keyframes q-linear-progress--indeterminate{0%{transform:translate3d(-35%,0,0) scaleX(.35)}60%{transform:translate3d(100%,0,0) scaleX(.9)}to{transform:translate3d(100%,0,0) scaleX(.9)}}@keyframes q-linear-progress--indeterminate-short{0%{transform:translate3d(-101%,0,0) scaleX(1)}60%{transform:translate3d(107%,0,0) scaleX(.01)}to{transform:translate3d(107%,0,0) scaleX(.01)}}@keyframes q-skeleton--fade{0%{opacity:1}50%{opacity:.4}to{opacity:1}}@keyframes q-skeleton--pulse{0%{transform:scale(1)}50%{transform:scale(.85)}to{transform:scale(1)}}@keyframes q-skeleton--pulse-x{0%{transform:scaleX(1)}50%{transform:scaleX(.75)}to{transform:scaleX(1)}}@keyframes q-skeleton--pulse-y{0%{transform:scaleY(1)}50%{transform:scaleY(.75)}to{transform:scaleY(1)}}@keyframes q-skeleton--wave{0%{transform:translateX(-100%)}to{transform:translateX(100%)}}@keyframes q-spin{0%{transform:rotate(0deg)}25%{transform:rotate(90deg)}50%{transform:rotate(180deg)}75%{transform:rotate(270deg)}to{transform:rotate(359deg)}}@keyframes q-mat-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px}to{stroke-dasharray:89,200;stroke-dashoffset:-124px}}@keyframes q-notif-badge{15%{transform:translate3d(-25%,0,0) rotate(-5deg)}30%{transform:translate3d(20%,0,0) rotate(3deg)}45%{transform:translate3d(-15%,0,0) rotate(-3deg)}60%{transform:translate3d(10%,0,0) rotate(2deg)}75%{transform:translate3d(-5%,0,0) rotate(-1deg)}}@keyframes q-notif-progress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}@keyframes q-scale{0%{transform:scale(1)}50%{transform:scale(1.04)}to{transform:scale(1)}}@keyframes q-fade{0%{opacity:0}to{opacity:1}}@keyframes q-ie-spinner{0%{opacity:.5}50%{opacity:1}to{opacity:.5}}@media (-ms-high-contrast:none) and (min-width:0),screen and (-ms-high-contrast:active) and (min-width:0){.flex>.col,.flex>.col-xs,.row>.col,.row>.col-xs{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:600px),screen and (-ms-high-contrast:active) and (min-width:600px){.flex>.col-sm,.row>.col-sm{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:1024px),screen and (-ms-high-contrast:active) and (min-width:1024px){.flex>.col-md,.row>.col-md{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:1440px),screen and (-ms-high-contrast:active) and (min-width:1440px){.flex>.col-lg,.row>.col-lg{flex-basis:auto;min-width:0}}@media (-ms-high-contrast:none) and (min-width:1920px),screen and (-ms-high-contrast:active) and (min-width:1920px){.flex>.col-xl,.row>.col-xl{flex-basis:auto;min-width:0}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5d8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ "60bb":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__60bb__;

/***/ }),

/***/ "63bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ install_queues; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ $q; });

// EXTERNAL MODULE: /workspace/node_modules/quasar/package.json
var quasar_package = __webpack_require__("e074");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Platform.js
var Platform = __webpack_require__("ad69");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Screen.js
var Screen = __webpack_require__("0807");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Dark.js
var Dark = __webpack_require__("d3a0");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/history.js
var src_history = __webpack_require__("3f7f");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/lang.js + 1 modules
var lang = __webpack_require__("2a4b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/colors.js
var colors = __webpack_require__("36c0");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/event.js
var utils_event = __webpack_require__("a8d5");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/key-composition.js
var key_composition = __webpack_require__("116d");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/body.js




function getMobilePlatform(is) {
  if (is.ios === true) return 'ios';
  if (is.android === true) return 'android';
}
function getBodyClasses({
  is,
  has,
  within
}, cfg) {
  const cls = [is.desktop === true ? 'desktop' : 'mobile', `${has.touch === false ? 'no-' : ''}touch`];
  if (is.mobile === true) {
    const mobile = getMobilePlatform(is);
    mobile !== void 0 && cls.push('platform-' + mobile);
  }
  if (is.nativeMobile === true) {
    const type = is.nativeMobileWrapper;
    cls.push(type);
    cls.push('native-mobile');
    if (is.ios === true && (cfg[type] === void 0 || cfg[type].iosStatusBarPadding !== false)) {
      cls.push('q-ios-padding');
    }
  } else if (is.electron === true) {
    cls.push('electron');
  } else if (is.bex === true) {
    cls.push('bex');
  }
  within.iframe === true && cls.push('within-iframe');
  return cls;
}

// SSR takeover corrections
function clientUpdate() {
  const classes = document.body.className;
  let newCls = classes;
  if (Platform["d" /* iosCorrection */] !== void 0) {
    newCls = newCls.replace('desktop', 'platform-ios mobile');
  }
  if (Platform["a" /* client */].has.touch === true) {
    newCls = newCls.replace('no-touch', 'touch');
  }
  if (Platform["a" /* client */].within.iframe === true) {
    newCls += ' within-iframe';
  }
  if (classes !== newCls) {
    document.body.className = newCls;
  }
}
function setColors(brand) {
  for (const color in brand) {
    Object(colors["h" /* setBrand */])(color, brand[color]);
  }
}
/* harmony default export */ var body = ({
  install(queues, cfg) {
    if (Platform["e" /* isSSR */] === true) {
      queues.server.push((q, ctx) => {
        const cls = getBodyClasses(q.platform, cfg),
          fn = ctx.ssr.setBodyClasses;
        if (cfg.screen !== void 0 && cfg.screen.bodyClass === true) {
          cls.push('screen--xs');
        }
        if (typeof fn === 'function') {
          fn(cls);
        } else {
          ctx.ssr.Q_BODY_CLASSES = cls.join(' ');
        }
      });
      return;
    }
    if (Platform["c" /* fromSSR */] === true) {
      clientUpdate();
    } else {
      const cls = getBodyClasses(Platform["a" /* client */], cfg);
      if (Platform["a" /* client */].is.ie === true && Platform["a" /* client */].is.versionNumber === 11) {
        cls.forEach(c => document.body.classList.add(c));
      } else {
        document.body.classList.add.apply(document.body.classList, cls);
      }
    }
    cfg.brand !== void 0 && setColors(cfg.brand);
    if (Platform["a" /* client */].is.ios === true) {
      // needed for iOS button active state
      document.body.addEventListener('touchstart', utils_event["g" /* noop */]);
    }
    window.addEventListener('keydown', key_composition["b" /* onKeyDownComposition */], true);
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/icon-set.js + 1 modules
var icon_set = __webpack_require__("0612");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/install.js








const autoInstalled = [Platform["b" /* default */], Screen["a" /* default */], Dark["a" /* default */]];
const install_queues = {
  server: [],
  // on SSR update
  takeover: [] // on client takeover
};
const $q = {
  version: quasar_package["a" /* version */],
  config: {}
};
/* harmony default export */ var install = __webpack_exports__["b"] = (function (Vue, opts = {}) {
  if (this.__qInstalled === true) {
    return;
  }
  this.__qInstalled = true;
  const cfg = $q.config = Object.freeze(opts.config || {});

  // required plugins
  Platform["b" /* default */].install($q, install_queues);
  body.install(install_queues, cfg);
  Dark["a" /* default */].install($q, install_queues, cfg);
  Screen["a" /* default */].install($q, install_queues, cfg);
  src_history["a" /* default */].install(cfg);
  lang["a" /* default */].install($q, install_queues, opts.lang);
  icon_set["a" /* default */].install($q, install_queues, opts.iconSet);
  if (Platform["e" /* isSSR */] === true) {
    Vue.mixin({
      beforeCreate() {
        this.$q = this.$root.$options.$q;
      }
    });
  } else {
    Vue.prototype.$q = $q;
  }
  opts.components && Object.keys(opts.components).forEach(key => {
    const c = opts.components[key];
    if (typeof c === 'function') {
      Vue.component(c.options.name, c);
    }
  });
  opts.directives && Object.keys(opts.directives).forEach(key => {
    const d = opts.directives[key];
    if (d.name !== void 0 && d.unbind !== void 0) {
      Vue.directive(d.name, d);
    }
  });
  if (opts.plugins) {
    const param = {
      $q,
      queues: install_queues,
      cfg
    };
    Object.keys(opts.plugins).forEach(key => {
      const p = opts.plugins[key];
      if (typeof p.install === 'function' && autoInstalled.includes(p) === false) {
        p.install(param);
      }
    });
  }
});

/***/ }),

/***/ "6485":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export margins */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a583");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a50a");



const insetMap = {
  true: 'inset',
  item: 'item-inset',
  'item-thumbnail': 'item-thumbnail-inset'
};
const margins = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24
};
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QSeparator',
  mixins: [_mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]],
  props: {
    spaced: [Boolean, String],
    inset: [Boolean, String],
    vertical: Boolean,
    color: String,
    size: String
  },
  computed: {
    orientation() {
      return this.vertical === true ? 'vertical' : 'horizontal';
    },
    classPrefix() {
      return ` q-separator--${this.orientation}`;
    },
    insetClass() {
      return this.inset !== false ? `${this.classPrefix}-${insetMap[this.inset]}` : '';
    },
    classes() {
      return `q-separator${this.classPrefix}${this.insetClass}` + (this.color !== void 0 ? ` bg-${this.color}` : '') + (this.isDark === true ? ' q-separator--dark' : '');
    },
    style() {
      const style = {};
      if (this.size !== void 0) {
        style[this.vertical === true ? 'width' : 'height'] = this.size;
      }
      if (this.spaced !== false) {
        const size = this.spaced === true ? `${margins.md}px` : this.spaced in margins ? `${margins[this.spaced]}px` : this.spaced;
        const props = this.vertical === true ? ['Left', 'Right'] : ['Top', 'Bottom'];
        style[`margin${props[0]}`] = style[`margin${props[1]}`] = size;
      }
      return style;
    },
    attrs() {
      return {
        'aria-orientation': this.orientation
      };
    }
  },
  render(h) {
    return h('hr', {
      staticClass: 'q-separator',
      class: this.classes,
      style: this.style,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    });
  }
}));

/***/ }),

/***/ "64ff":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ITF2 = __webpack_require__("4c4f");

var _ITF3 = _interopRequireDefault(_ITF2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Calculate the checksum digit
var checksum = function checksum(data) {
	var res = data.substr(0, 13).split('').map(function (num) {
		return parseInt(num, 10);
	}).reduce(function (sum, n, idx) {
		return sum + n * (3 - idx % 2 * 2);
	}, 0);

	return Math.ceil(res / 10) * 10 - res;
};

var ITF14 = function (_ITF) {
	_inherits(ITF14, _ITF);

	function ITF14(data, options) {
		_classCallCheck(this, ITF14);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{13}$/) !== -1) {
			data += checksum(data);
		}
		return _possibleConstructorReturn(this, (ITF14.__proto__ || Object.getPrototypeOf(ITF14)).call(this, data, options));
	}

	_createClass(ITF14, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
		}
	}]);

	return ITF14;
}(_ITF3.default);

exports.default = ITF14;

/***/ }),

/***/ "65a6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _history_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3f7f");

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    __addHistory() {
      this.__historyEntry = {
        condition: () => {
          return this.hideOnRouteChange === true;
        },
        handler: this.hide
      };
      _history_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].add(this.__historyEntry);
    },
    __removeHistory() {
      if (this.__historyEntry !== void 0) {
        _history_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].remove(this.__historyEntry);
        this.__historyEntry = void 0;
      }
    }
  },
  beforeDestroy() {
    this.showing === true && this.__removeHistory();
  }
});

/***/ }),

/***/ "66e6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_history_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("65a6");
/* harmony import */ var _mixins_timeout_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("f3c6");
/* harmony import */ var _mixins_model_toggle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1dd9");
/* harmony import */ var _mixins_portal_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d485");
/* harmony import */ var _mixins_prevent_scroll_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9a9f");
/* harmony import */ var _mixins_attrs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ae5c");
/* harmony import */ var _mixins_transition_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("448b");
/* harmony import */ var _utils_dom_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("d818");
/* harmony import */ var _utils_private_escape_key_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("3e5f");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("feae");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("479b");
/* harmony import */ var _utils_private_focus_manager_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("fa15");
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ad69");















let maximizedModals = 0;
const positionClass = {
  standard: 'fixed-full flex-center',
  top: 'fixed-top justify-center',
  bottom: 'fixed-bottom justify-center',
  right: 'fixed-right items-center',
  left: 'fixed-left items-center'
};
const defaultTransitions = {
  standard: ['scale', 'scale'],
  top: ['slide-down', 'slide-up'],
  bottom: ['slide-up', 'slide-down'],
  right: ['slide-left', 'slide-right'],
  left: ['slide-right', 'slide-left']
};
const backdropAttrs = {
  ..._mixins_attrs_js__WEBPACK_IMPORTED_MODULE_6__[/* ariaHidden */ "a"],
  tabindex: -1
};
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QDialog',
  mixins: [_mixins_attrs_js__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"], _mixins_transition_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], _mixins_history_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_timeout_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_model_toggle_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_portal_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "c"], _mixins_prevent_scroll_js__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]],
  props: {
    persistent: Boolean,
    autoClose: Boolean,
    allowFocusOutside: Boolean,
    noEscDismiss: Boolean,
    noBackdropDismiss: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    noShake: Boolean,
    seamless: Boolean,
    maximized: Boolean,
    fullWidth: Boolean,
    fullHeight: Boolean,
    square: Boolean,
    position: {
      type: String,
      default: 'standard',
      validator: val => val === 'standard' || ['top', 'bottom', 'left', 'right'].includes(val)
    },
    transitionShow: String,
    transitionHide: String
  },
  data() {
    return {
      animating: false
    };
  },
  watch: {
    maximized(state) {
      this.showing === true && this.__updateMaximized(state);
    },
    useBackdrop(v) {
      this.__preventScroll(v);
      this.__preventFocusout(v);
    }
  },
  computed: {
    classes() {
      return `q-dialog__inner--${this.maximized === true ? 'maximized' : 'minimized'} ` + `q-dialog__inner--${this.position} ${positionClass[this.position]}` + (this.animating === true ? ' q-dialog__inner--animating' : '') + (this.fullWidth === true ? ' q-dialog__inner--fullwidth' : '') + (this.fullHeight === true ? ' q-dialog__inner--fullheight' : '') + (this.square === true ? ' q-dialog__inner--square' : '');
    },
    defaultTransitionShow() {
      return defaultTransitions[this.position][0];
    },
    defaultTransitionHide() {
      return defaultTransitions[this.position][1];
    },
    useBackdrop() {
      return this.showing === true && this.seamless !== true;
    },
    hideOnRouteChange() {
      return this.persistent !== true && this.noRouteDismiss !== true && this.seamless !== true;
    },
    onEvents() {
      const on = {
        ...this.qListeners,
        // stop propagating these events from children
        input: _utils_event_js__WEBPACK_IMPORTED_MODULE_11__[/* stop */ "k"],
        'popup-show': _utils_event_js__WEBPACK_IMPORTED_MODULE_11__[/* stop */ "k"],
        'popup-hide': _utils_event_js__WEBPACK_IMPORTED_MODULE_11__[/* stop */ "k"]
      };
      if (this.autoClose === true) {
        on.click = this.__onAutoClose;
      }
      return on;
    },
    attrs() {
      return {
        role: 'dialog',
        'aria-modal': this.useBackdrop === true ? 'true' : 'false',
        ...this.qAttrs
      };
    }
  },
  methods: {
    focus(selector) {
      Object(_utils_private_focus_manager_js__WEBPACK_IMPORTED_MODULE_13__[/* addFocusFn */ "a"])(() => {
        let node = this.__getInnerNode();
        if (node === void 0 || node.contains(document.activeElement) === true) {
          return;
        }
        node = (selector !== '' ? node.querySelector(selector) : null) || node.querySelector('[autofocus][tabindex], [data-autofocus][tabindex]') || node.querySelector('[autofocus] [tabindex], [data-autofocus] [tabindex]') || node.querySelector('[autofocus], [data-autofocus]') || node;
        node.focus({
          preventScroll: true
        });
      });
    },
    shake(focusTarget) {
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus({
          preventScroll: true
        });
      } else {
        this.focus();
      }
      this.$emit('shake');
      const node = this.__getInnerNode();
      if (node !== void 0) {
        node.classList.remove('q-animate--scale');
        node.classList.add('q-animate--scale');
        clearTimeout(this.shakeTimeout);
        this.shakeTimeout = setTimeout(() => {
          node.classList.remove('q-animate--scale');
        }, 170);
      }
    },
    __getInnerNode() {
      return this.__portal !== void 0 && this.__portal.$refs !== void 0 ? this.__portal.$refs.inner : void 0;
    },
    __show(evt) {
      this.__addHistory();

      // IE can have null document.activeElement
      this.__refocusTarget = _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_14__[/* client */ "a"].is.mobile !== true && this.noRefocus === false && document.activeElement !== null ? document.activeElement : void 0;
      this.$el.dispatchEvent(Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_11__[/* create */ "c"])('popup-show', {
        bubbles: true
      }));
      this.__updateMaximized(this.maximized);
      _utils_private_escape_key_js__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].register(this, escEvt => {
        if (this.seamless !== true) {
          if (this.persistent === true || this.noEscDismiss === true) {
            this.maximized !== true && this.noShake !== true && this.shake();
          } else {
            this.$emit('escape-key');
            this.hide(escEvt);
          }
        }
      });
      this.__showPortal();
      this.animating = true;
      if (this.noFocus !== true) {
        // IE can have null document.activeElement
        document.activeElement !== null && document.activeElement.blur();
        this.__registerTick(this.focus);
      } else {
        this.__removeTick();
      }

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(() => {
        if (this.$q.platform.is.ios === true) {
          if (this.seamless !== true && document.activeElement) {
            const {
                top,
                bottom
              } = document.activeElement.getBoundingClientRect(),
              {
                innerHeight
              } = window,
              height = window.visualViewport !== void 0 ? window.visualViewport.height : innerHeight;
            if (top > 0 && bottom > height / 2) {
              document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollHeight - height, bottom >= innerHeight ? Infinity : Math.ceil(document.scrollingElement.scrollTop + bottom - height / 2));
            }
            document.activeElement.scrollIntoView();
          }

          // required in order to avoid the "double-tap needed" issue
          this.__portal.$el.click();
        }
        this.animating = false;
        this.__showPortal(true); // done showing
        this.$emit('show', evt);
      }, 300);
    },
    __hide(evt) {
      this.__removeTick();
      this.__removeHistory();
      this.__cleanup(true);
      this.__hidePortal();
      this.animating = true;

      // check null for IE
      if (this.__refocusTarget !== void 0 && this.__refocusTarget !== null) {
        ((evt && evt.type.indexOf('key') === 0 ? this.__refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || this.__refocusTarget).focus();
        this.__refocusTarget = void 0;
      }
      this.$el.dispatchEvent(Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_11__[/* create */ "c"])('popup-hide', {
        bubbles: true
      }));

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(() => {
        this.__hidePortal(true); // done hiding, now destroy
        this.animating = false;
        this.$emit('hide', evt);
      }, 300);
    },
    __cleanup(hiding) {
      clearTimeout(this.shakeTimeout);
      if (hiding === true || this.showing === true) {
        _utils_private_escape_key_js__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].pop(this);
        this.__updateMaximized(false);
        if (this.seamless !== true) {
          this.__preventScroll(false);
          this.__preventFocusout(false);
        }
      }
    },
    __updateMaximized(active) {
      if (active === true) {
        if (this.isMaximized !== true) {
          maximizedModals < 1 && document.body.classList.add('q-body--dialog');
          maximizedModals++;
          this.isMaximized = true;
        }
      } else if (this.isMaximized === true) {
        if (maximizedModals < 2) {
          document.body.classList.remove('q-body--dialog');
        }
        maximizedModals--;
        this.isMaximized = false;
      }
    },
    __preventFocusout(state) {
      if (this.$q.platform.is.desktop === true) {
        const action = `${state === true ? 'add' : 'remove'}EventListener`;
        document.body[action]('focusin', this.__onFocusChange);
      }
    },
    __onAutoClose(e) {
      this.hide(e);
      this.qListeners.click !== void 0 && this.$emit('click', e);
    },
    __onBackdropClick(e) {
      if (this.persistent !== true && this.noBackdropDismiss !== true) {
        this.hide(e);
      } else if (this.noShake !== true) {
        this.shake(e.relatedTarget);
      }
    },
    __onFocusChange(e) {
      // the focus is not in a vue child component
      if (this.allowFocusOutside !== true && this.__portalIsAccessible === true && Object(_utils_dom_js__WEBPACK_IMPORTED_MODULE_8__[/* childHasFocus */ "a"])(this.__portal.$el, e.target) !== true) {
        this.focus('[tabindex]:not([tabindex="-1"])');
      }
    },
    __renderPortal(h) {
      return h('div', {
        staticClass: `q-dialog fullscreen no-pointer-events q-dialog--${this.useBackdrop === true ? 'modal' : 'seamless'}`,
        class: this.contentClass,
        style: this.contentStyle,
        attrs: this.attrs
      }, [h('transition', {
        props: {
          name: 'q-transition--fade'
        }
      }, this.useBackdrop === true ? [h('div', {
        staticClass: 'q-dialog__backdrop fixed-full',
        attrs: backdropAttrs,
        on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_12__[/* default */ "b"])(this, 'bkdrop', {
          [this.backdropEvt]: this.__onBackdropClick
        })
      })] : null), h('transition', {
        props: {
          ...this.transitionProps
        }
      }, [this.showing === true ? h('div', {
        ref: 'inner',
        staticClass: 'q-dialog__inner flex no-pointer-events',
        class: this.classes,
        attrs: {
          tabindex: -1
        },
        on: this.onEvents
      }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_10__[/* slot */ "c"])(this, 'default')) : null])]);
    }
  },
  created() {
    this.__useTick('__registerTick', '__removeTick');
    this.__useTimeout('__registerTimeout');
    this.backdropEvt = this.$q.platform.is.ios === true || this.$q.platform.is.safari ? 'click' : 'focusin';
  },
  mounted() {
    this.__processModelChange(this.value);
  },
  beforeDestroy() {
    this.__cleanup();
    this.__refocusTarget = void 0;
  }
}));

/***/ }),

/***/ "6a4d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("95c4");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("3513");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI10 = function (_MSI) {
	_inherits(MSI10, _MSI);

	function MSI10(data, options) {
		_classCallCheck(this, MSI10);

		return _possibleConstructorReturn(this, (MSI10.__proto__ || Object.getPrototypeOf(MSI10)).call(this, data + (0, _checksums.mod10)(data), options));
	}

	return MSI10;
}(_MSI3.default);

exports.default = MSI10;

/***/ }),

/***/ "6b0e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPCE = exports.UPC = exports.EAN2 = exports.EAN5 = exports.EAN8 = exports.EAN13 = undefined;

var _EAN = __webpack_require__("a031");

var _EAN2 = _interopRequireDefault(_EAN);

var _EAN3 = __webpack_require__("36d8");

var _EAN4 = _interopRequireDefault(_EAN3);

var _EAN5 = __webpack_require__("8367");

var _EAN6 = _interopRequireDefault(_EAN5);

var _EAN7 = __webpack_require__("3ecb");

var _EAN8 = _interopRequireDefault(_EAN7);

var _UPC = __webpack_require__("95c8");

var _UPC2 = _interopRequireDefault(_UPC);

var _UPCE = __webpack_require__("7d12");

var _UPCE2 = _interopRequireDefault(_UPCE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EAN13 = _EAN2.default;
exports.EAN8 = _EAN4.default;
exports.EAN5 = _EAN6.default;
exports.EAN2 = _EAN8.default;
exports.UPC = _UPC2.default;
exports.UPCE = _UPCE2.default;

/***/ }),

/***/ "6c52":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = optionsFromStrings;

// Convert string to integers/booleans where it should be

function optionsFromStrings(options) {
	var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];

	for (var intOption in intOptions) {
		if (intOptions.hasOwnProperty(intOption)) {
			intOption = intOptions[intOption];
			if (typeof options[intOption] === "string") {
				options[intOption] = parseInt(options[intOption], 10);
			}
		}
	}

	if (typeof options["displayValue"] === "string") {
		options["displayValue"] = options["displayValue"] != "false";
	}

	return options;
}

/***/ }),

/***/ "6c83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CODE128C = exports.CODE128B = exports.CODE128A = exports.CODE128 = undefined;

var _CODE128_AUTO = __webpack_require__("acfe");

var _CODE128_AUTO2 = _interopRequireDefault(_CODE128_AUTO);

var _CODE128A = __webpack_require__("f0a5");

var _CODE128A2 = _interopRequireDefault(_CODE128A);

var _CODE128B = __webpack_require__("87f7");

var _CODE128B2 = _interopRequireDefault(_CODE128B);

var _CODE128C = __webpack_require__("2ce7");

var _CODE128C2 = _interopRequireDefault(_CODE128C);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CODE128 = _CODE128_AUTO2.default;
exports.CODE128A = _CODE128A2.default;
exports.CODE128B = _CODE128B2.default;
exports.CODE128C = _CODE128C2.default;

/***/ }),

/***/ "6ca9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a583");
/* harmony import */ var _mixins_tag_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4025");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("feae");





/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QCard',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_tag_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]],
  props: {
    square: Boolean,
    flat: Boolean,
    bordered: Boolean
  },
  computed: {
    classes() {
      return 'q-card' + (this.isDark === true ? ' q-card--dark q-dark' : '') + (this.bordered === true ? ' q-card--bordered' : '') + (this.square === true ? ' q-card--square no-border-radius' : '') + (this.flat === true ? ' q-card--flat no-shadow' : '');
    }
  },
  render(h) {
    return h(this.tag, {
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "6e27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a8d5");
/* harmony import */ var _mixins_can_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b181");
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ad69");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("479b");





/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QResizeObserver',
  mixins: [_mixins_can_render_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]],
  props: {
    debounce: {
      type: [String, Number],
      default: 100
    }
  },
  data() {
    return this.hasObserver === true ? {} : {
      url: this.$q.platform.is.ie === true ? null : 'about:blank'
    };
  },
  methods: {
    trigger(immediately) {
      if (immediately === true || this.debounce === 0 || this.debounce === '0') {
        this.__emit();
      } else if (this.timer === null) {
        this.timer = setTimeout(this.__emit, this.debounce);
      }
    },
    __emit() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (!this.$el || !this.$el.parentNode) {
        return;
      }
      const parent = this.$el.parentNode,
        size = {
          width: parent.offsetWidth,
          height: parent.offsetHeight
        };
      if (size.width === this.size.width && size.height === this.size.height) {
        return;
      }
      this.size = size;
      this.$emit('resize', this.size);
    },
    __cleanup() {
      if (this.curDocView !== void 0) {
        // iOS is fuzzy, need to check it first
        if (this.curDocView.removeEventListener !== void 0) {
          this.curDocView.removeEventListener('resize', this.trigger, _utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* listenOpts */ "f"].passive);
        }
        this.curDocView = void 0;
      }
    },
    __onObjLoad() {
      this.__cleanup();
      if (this.$el.contentDocument) {
        this.curDocView = this.$el.contentDocument.defaultView;
        this.curDocView.addEventListener('resize', this.trigger, _utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* listenOpts */ "f"].passive);
      }
      this.__emit();
    }
  },
  render(h) {
    if (this.canRender === false || this.hasObserver === true) {
      return;
    }
    return h('object', {
      style: this.style,
      attrs: {
        tabindex: -1,
        // fix for Firefox
        type: 'text/html',
        data: this.url,
        'aria-hidden': 'true'
      },
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"])(this, 'load', {
        load: this.__onObjLoad
      })
    });
  },
  beforeCreate() {
    this.size = {
      width: -1,
      height: -1
    };
    if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_3__[/* isSSR */ "e"] === true) {
      return;
    }
    this.hasObserver = typeof ResizeObserver !== 'undefined';
    if (this.hasObserver !== true) {
      this.style = `${this.$q.platform.is.ie ? 'visibility:hidden;' : ''}display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;`;
    }
  },
  mounted() {
    this.timer = null;
    if (this.hasObserver === true) {
      this.observer = new ResizeObserver(this.trigger);
      this.observer.observe(this.$el.parentNode);
      this.__emit();
      return;
    }
    if (this.$q.platform.is.ie === true) {
      this.url = 'about:blank';
      this.__emit();
    } else {
      this.__onObjLoad();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    if (this.hasObserver === true) {
      if (this.observer !== void 0 && this.$el.parentNode) {
        this.observer.unobserve(this.$el.parentNode);
      }
      return;
    }
    this.__cleanup();
  }
}));

/***/ }),

/***/ "74c0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("feae");



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QPage',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  inject: {
    pageContainer: {
      default() {
        console.error('QPage needs to be child of QPageContainer');
      }
    },
    layout: {}
  },
  props: {
    padding: Boolean,
    styleFn: Function
  },
  computed: {
    style() {
      const offset = (this.layout.header.space === true ? this.layout.header.size : 0) + (this.layout.footer.space === true ? this.layout.footer.size : 0);
      if (typeof this.styleFn === 'function') {
        const height = this.layout.container === true ? this.layout.containerHeight : this.$q.screen.height;
        return this.styleFn(offset, height);
      }
      return {
        minHeight: this.layout.container === true ? this.layout.containerHeight - offset + 'px' : this.$q.screen.height === 0 ? `calc(100vh - ${offset}px)` : this.$q.screen.height - offset + 'px'
      };
    },
    classes() {
      if (this.padding === true) {
        return 'q-layout-padding';
      }
    }
  },
  render(h) {
    return h('main', {
      staticClass: 'q-page',
      style: this.style,
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "7765":
/***/ (function(module, exports, __webpack_require__) {

var JsBarcode = __webpack_require__("995f");

var VueBarcode = {
   render: function (createElement) {
    return createElement('div', [
      createElement(this.elementTag, {
        style: { display: this.valid ? undefined : 'none' },
        'class': ['vue-barcode-element']
      }),
      createElement('div', {
        style: { display: this.valid ? 'none' : undefined }
      }, this.$slots.default),
    ]);
  },
  props: {
    value: [String, Number],
    format: [String],
    width: [String, Number],
    height: [String, Number],
    displayValue: {
      type:  [String, Boolean],
      default: true
    },
    text: [String, Number],
    fontOptions : [String],
    font: [String],
    textAlign: [String],
    textPosition: [String],
    textMargin: [String, Number],
    fontSize: [String, Number],
    background: [String],
    lineColor: [String],
    margin: [String, Number],
    marginTop: [String, Number],
    marginBottom: [String, Number],
    marginLeft: [String, Number],
    marginRight: [String, Number],
    flat: [Boolean],
    ean128: [String, Boolean],
    elementTag: {
      type: String,
      default: 'svg',
      validator: function (value) {
          return ['canvas', 'svg', 'img'].indexOf(value) !== -1
      }
    }
  },
  mounted: function(){
    this.$watch('$props', render, { deep: true, immediate: true });
    render.call(this);
  },
  data: function(){
    return {valid: true};
  }
};

function render(){
  var that = this;

  var settings = {
    format: this.format,
    width: this.width,
    height: this.height,
    displayValue: this.displayValue,
    text: this.text,
    fontOptions: this.fontOptions,
    font: this.font,
    textAlign: this.textAlign,
    textPosition: this.textPosition,
    textMargin: this.textMargin,
    fontSize: this.fontSize,
    background: this.background,
    lineColor: this.lineColor,
    margin: this.margin,
    marginTop: this.marginTop,
    marginBottom: this.marginBottom,
    marginLeft: this.marginLeft,
    marginRight: this.marginRight,
    flat: this.flat,
    ean128: this.ean128,
    valid: function (valid) {
      that.valid = valid;
    },
    elementTag: this.elementTag
  };

  removeUndefinedProps(settings);

  JsBarcode(this.$el.querySelector('.vue-barcode-element'), String(this.value), settings);
}

function removeUndefinedProps(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop) && obj[prop] === undefined) {
      delete obj[prop];
    }
  }
}

module.exports = VueBarcode;


/***/ }),

/***/ "79ca":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("417a");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("02c39b5f", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7d12":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _encoder = __webpack_require__("b720");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _UPC = __webpack_require__("95c8");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
//
// UPC-E documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#UPC-E

var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];

var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];

var UPCE = function (_Barcode) {
	_inherits(UPCE, _Barcode);

	function UPCE(data, options) {
		_classCallCheck(this, UPCE);

		var _this = _possibleConstructorReturn(this, (UPCE.__proto__ || Object.getPrototypeOf(UPCE)).call(this, data, options));
		// Code may be 6 or 8 digits;
		// A 7 digit code is ambiguous as to whether the extra digit
		// is a UPC-A check or number system digit.


		_this.isValid = false;
		if (data.search(/^[0-9]{6}$/) !== -1) {
			_this.middleDigits = data;
			_this.upcA = expandToUPCA(data, "0");
			_this.text = options.text || '' + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
			_this.isValid = true;
		} else if (data.search(/^[01][0-9]{7}$/) !== -1) {
			_this.middleDigits = data.substring(1, data.length - 1);
			_this.upcA = expandToUPCA(_this.middleDigits, data[0]);

			if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
				_this.isValid = true;
			} else {
				// checksum mismatch
				return _possibleConstructorReturn(_this);
			}
		} else {
			return _possibleConstructorReturn(_this);
		}

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPCE, [{
		key: 'valid',
		value: function valid() {
			return this.isValid;
		}
	}, {
		key: 'encode',
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: 'flatEncoding',
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += this.encodeMiddleDigits();
			result += "010101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: 'guardedEncoding',
		value: function guardedEncoding() {
			var result = [];

			// Add the UPC-A number system digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[0],
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101",
				options: { height: this.guardHeight }
			});

			// Add the 6 UPC-E digits
			result.push({
				data: this.encodeMiddleDigits(),
				text: this.text.substring(1, 7),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: "010101",
				options: { height: this.guardHeight }
			});

			// Add the UPC-A check digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[7],
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}, {
		key: 'encodeMiddleDigits',
		value: function encodeMiddleDigits() {
			var numberSystem = this.upcA[0];
			var checkDigit = this.upcA[this.upcA.length - 1];
			var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
			return (0, _encoder2.default)(this.middleDigits, parity);
		}
	}]);

	return UPCE;
}(_Barcode3.default);

function expandToUPCA(middleDigits, numberSystem) {
	var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
	var expansion = EXPANSIONS[lastUpcE];

	var result = "";
	var digitIndex = 0;
	for (var i = 0; i < expansion.length; i++) {
		var c = expansion[i];
		if (c === 'X') {
			result += middleDigits[digitIndex++];
		} else {
			result += c;
		}
	}

	result = '' + numberSystem + result;
	return '' + result + (0, _UPC.checksum)(result);
}

exports.default = UPCE;

/***/ }),

/***/ "7e6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a583");
/* harmony import */ var _mixins_tag_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4025");
/* harmony import */ var _mixins_router_link_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("adc0");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("feae");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("116d");








/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QItem',
  mixins: [_mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_router_link_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_tag_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]],
  props: {
    active: {
      type: Boolean,
      default: null
    },
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  computed: {
    isActionable() {
      return this.clickable === true || this.hasLink === true || this.tag === 'label';
    },
    isClickable() {
      return this.disable !== true && this.isActionable === true;
    },
    classes() {
      return 'q-item q-item-type row no-wrap' + (this.dense === true ? ' q-item--dense' : '') + (this.isDark === true ? ' q-item--dark' : '') + (this.hasLink === true && this.active === null ? this.linkClass : this.active === true ? ` q-item--active${this.activeClass !== void 0 ? ` ${this.activeClass}` : ''} ` : '') + (this.disable === true ? ' disabled' : '') + (this.isClickable === true ? ' q-item--clickable q-link cursor-pointer ' + (this.manualFocus === true ? 'q-manual-focusable' : 'q-focusable q-hoverable') + (this.focused === true ? ' q-manual-focusable--focused' : '') : '');
    },
    style() {
      if (this.insetLevel !== void 0) {
        const dir = this.$q.lang.rtl === true ? 'Right' : 'Left';
        return {
          ['padding' + dir]: 16 + this.insetLevel * 56 + 'px'
        };
      }
    },
    onEvents() {
      return {
        ...this.qListeners,
        click: this.__onClick,
        keyup: this.__onKeyup
      };
    }
  },
  methods: {
    __onClick(e) {
      if (this.isClickable === true) {
        if (this.$refs.blurTarget !== void 0) {
          if (e.qKeyEvent !== true && document.activeElement === this.$el) {
            this.$refs.blurTarget.focus();
          } else if (document.activeElement === this.$refs.blurTarget) {
            this.$el.focus();
          }
        }
        this.__navigateOnClick(e);
      }
    },
    __onKeyup(e) {
      if (this.isClickable === true && Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_7__[/* isKeyCode */ "a"])(e, 13) === true) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_6__[/* stopAndPrevent */ "l"])(e);

        // for ripple
        e.qKeyEvent = true;

        // for click trigger
        const evt = new MouseEvent('click', e);
        evt.qKeyEvent = true;
        this.$el.dispatchEvent(evt);
      }
      this.$emit('keyup', e);
    },
    __getContent(h) {
      const child = Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_5__[/* uniqueSlot */ "d"])(this, 'default', []);
      this.isClickable === true && child.unshift(h('div', {
        staticClass: 'q-focus-helper',
        attrs: {
          tabindex: -1
        },
        ref: 'blurTarget'
      }));
      return child;
    }
  },
  render(h) {
    const data = {
      class: this.classes,
      style: this.style,
      attrs: {
        role: 'listitem'
      },
      on: this.onEvents
    };
    if (this.isClickable === true) {
      data.attrs.tabindex = this.tabindex || '0';
      Object.assign(data.attrs, this.linkAttrs);
    } else if (this.isActionable === true) {
      data.attrs['aria-disabled'] = 'true';
    }
    return h(this.linkTag, data, this.__getContent(h));
  }
}));

/***/ }),

/***/ "7efe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_tag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4025");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("feae");




/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QCardSection',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_tag_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    horizontal: Boolean
  },
  computed: {
    classes() {
      return 'q-card__section ' + `q-card__section--${this.horizontal === true ? 'horiz row no-wrap' : 'vert'}`;
    }
  },
  render(h) {
    return h(this.tag, {
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_3__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "8030":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_anchor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a62b");
/* harmony import */ var _mixins_timeout_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("f3c6");
/* harmony import */ var _mixins_model_toggle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1dd9");
/* harmony import */ var _mixins_portal_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d485");
/* harmony import */ var _mixins_transition_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("448b");
/* harmony import */ var _utils_scroll_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("a820");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_selection_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ab5b");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("feae");
/* harmony import */ var _utils_private_position_engine_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("f4c5");











const attrs = {
  role: 'tooltip'
};
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QTooltip',
  mixins: [_mixins_anchor_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_timeout_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_model_toggle_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_portal_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "c"], _mixins_transition_js__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]],
  props: {
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    },
    transitionShow: {
      default: 'jump-down'
    },
    transitionHide: {
      default: 'jump-up'
    },
    anchor: {
      type: String,
      default: 'bottom middle',
      validator: _utils_private_position_engine_js__WEBPACK_IMPORTED_MODULE_10__[/* validatePosition */ "d"]
    },
    self: {
      type: String,
      default: 'top middle',
      validator: _utils_private_position_engine_js__WEBPACK_IMPORTED_MODULE_10__[/* validatePosition */ "d"]
    },
    offset: {
      type: Array,
      default: () => [14, 14],
      validator: _utils_private_position_engine_js__WEBPACK_IMPORTED_MODULE_10__[/* validateOffset */ "c"]
    },
    scrollTarget: {
      default: void 0
    },
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    anchorOrigin() {
      return Object(_utils_private_position_engine_js__WEBPACK_IMPORTED_MODULE_10__[/* parsePosition */ "a"])(this.anchor, this.$q.lang.rtl);
    },
    selfOrigin() {
      return Object(_utils_private_position_engine_js__WEBPACK_IMPORTED_MODULE_10__[/* parsePosition */ "a"])(this.self, this.$q.lang.rtl);
    },
    hideOnRouteChange() {
      return this.persistent !== true;
    }
  },
  methods: {
    __show(evt) {
      this.__showPortal();
      this.__registerTick(() => {
        this.observer = new MutationObserver(() => this.updatePosition());
        this.observer.observe(this.__portal.$el, {
          attributes: false,
          childList: true,
          characterData: true,
          subtree: true
        });
        this.updatePosition();
        this.__configureScrollTarget();
      });
      if (this.unwatch === void 0) {
        this.unwatch = this.$watch(() => this.$q.screen.width + '|' + this.$q.screen.height + '|' + this.self + '|' + this.anchor + '|' + this.$q.lang.rtl, this.updatePosition);
      }

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(() => {
        this.__showPortal(true);
        this.$emit('show', evt);
      }, 300);
    },
    __hide(evt) {
      this.__removeTick();
      this.__anchorCleanup();
      this.__hidePortal();

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(() => {
        this.__hidePortal(true); // done hiding, now destroy
        this.$emit('hide', evt);
      }, 300);
    },
    __anchorCleanup() {
      if (this.observer !== void 0) {
        this.observer.disconnect();
        this.observer = void 0;
      }
      if (this.unwatch !== void 0) {
        this.unwatch();
        this.unwatch = void 0;
      }
      this.__unconfigureScrollTarget();
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_7__[/* cleanEvt */ "b"])(this, 'tooltipTemp');
    },
    updatePosition() {
      if (this.anchorEl === void 0 || this.__portal === void 0) {
        return;
      }
      const el = this.__portal.$el;
      if (el.nodeType === 8) {
        // IE replaces the comment with delay
        setTimeout(this.updatePosition, 25);
        return;
      }
      Object(_utils_private_position_engine_js__WEBPACK_IMPORTED_MODULE_10__[/* setPosition */ "b"])({
        el,
        offset: this.offset,
        anchorEl: this.anchorEl,
        anchorOrigin: this.anchorOrigin,
        selfOrigin: this.selfOrigin,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth
      });
    },
    __delayShow(evt) {
      if (this.$q.platform.is.mobile === true) {
        Object(_utils_private_selection_js__WEBPACK_IMPORTED_MODULE_8__[/* clearSelection */ "a"])();
        document.body.classList.add('non-selectable');
        const target = this.anchorEl;
        const evts = ['touchmove', 'touchcancel', 'touchend', 'click'].map(e => [target, e, '__delayHide', 'passiveCapture']);
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_7__[/* addEvt */ "a"])(this, 'tooltipTemp', evts);
      }
      this.__registerTimeout(() => {
        this.show(evt);
      }, this.delay);
    },
    __delayHide(evt) {
      if (this.$q.platform.is.mobile === true) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_7__[/* cleanEvt */ "b"])(this, 'tooltipTemp');
        Object(_utils_private_selection_js__WEBPACK_IMPORTED_MODULE_8__[/* clearSelection */ "a"])();
        // delay needed otherwise selection still occurs
        setTimeout(() => {
          document.body.classList.remove('non-selectable');
        }, 10);
      }

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(() => {
        this.hide(evt);
      }, this.hideDelay);
    },
    __configureAnchorEl() {
      if (this.noParentEvent === true || this.anchorEl === void 0) {
        return;
      }
      const evts = this.$q.platform.is.mobile === true ? [[this.anchorEl, 'touchstart', '__delayShow', 'passive']] : [[this.anchorEl, 'mouseenter', '__delayShow', 'passive'], [this.anchorEl, 'mouseleave', '__delayHide', 'passive']];
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_7__[/* addEvt */ "a"])(this, 'anchor', evts);
    },
    __unconfigureScrollTarget() {
      if (this.__scrollTarget !== void 0) {
        this.__changeScrollEvent(this.__scrollTarget);
        this.__scrollTarget = void 0;
      }
    },
    __configureScrollTarget() {
      if (this.anchorEl !== void 0 || this.scrollTarget !== void 0) {
        this.__scrollTarget = Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_6__[/* getScrollTarget */ "d"])(this.anchorEl, this.scrollTarget);
        const fn = this.noParentEvent === true ? this.updatePosition : this.hide;
        this.__changeScrollEvent(this.__scrollTarget, fn);
      }
    },
    __renderPortal(h) {
      return h('transition', {
        props: {
          ...this.transitionProps
        }
      }, [this.showing === true ? h('div', {
        staticClass: 'q-tooltip q-tooltip--style q-position-engine no-pointer-events',
        class: this.contentClass,
        style: this.contentStyle,
        attrs
      }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_9__[/* slot */ "c"])(this, 'default')) : null]);
    }
  },
  created() {
    this.__useTick('__registerTick', '__removeTick');
    this.__useTimeout('__registerTimeout');
  },
  mounted() {
    this.__processModelChange(this.value);
  }
}));

/***/ }),

/***/ "8077":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonVirtPropsList; });
/* harmony import */ var _utils_debounce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c3c5");
/* harmony import */ var _utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a820");


const aggBucketSize = 1000;
const scrollToEdges = ['start', 'center', 'end', 'start-force', 'center-force', 'end-force'];
const filterProto = Array.prototype.filter;
function sumFn(acc, h) {
  return acc + h;
}
function getScrollDetails(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
  const parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent,
    propElSize = horizontal === true ? 'offsetWidth' : 'offsetHeight',
    details = {
      scrollStart: 0,
      scrollViewSize: -stickyStart - stickyEnd,
      scrollMaxSize: 0,
      offsetStart: -stickyStart,
      offsetEnd: -stickyEnd
    };
  if (horizontal === true) {
    if (parent === window) {
      details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
      details.scrollViewSize += document.documentElement.clientWidth;
    } else {
      details.scrollStart = parentCalc.scrollLeft;
      details.scrollViewSize += parentCalc.clientWidth;
    }
    details.scrollMaxSize = parentCalc.scrollWidth;
    if (rtl === true) {
      details.scrollStart = (Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* rtlHasScrollBug */ "h"])() === true ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
    }
  } else {
    if (parent === window) {
      details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
      details.scrollViewSize += document.documentElement.clientHeight;
    } else {
      details.scrollStart = parentCalc.scrollTop;
      details.scrollViewSize += parentCalc.clientHeight;
    }
    details.scrollMaxSize = parentCalc.scrollHeight;
  }
  if (beforeRef !== void 0) {
    for (let el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling) {
      if (el.classList.contains('q-virtual-scroll--skip') === false) {
        details.offsetStart += el[propElSize];
      }
    }
  }
  if (afterRef !== void 0) {
    for (let el = afterRef.nextElementSibling; el !== null; el = el.nextElementSibling) {
      if (el.classList.contains('q-virtual-scroll--skip') === false) {
        details.offsetEnd += el[propElSize];
      }
    }
  }
  if (child !== parent) {
    const parentRect = parentCalc.getBoundingClientRect(),
      childRect = child.getBoundingClientRect();
    if (horizontal === true) {
      details.offsetStart += childRect.left - parentRect.left;
      details.offsetEnd -= childRect.width;
    } else {
      details.offsetStart += childRect.top - parentRect.top;
      details.offsetEnd -= childRect.height;
    }
    if (parent !== window) {
      details.offsetStart += details.scrollStart;
    }
    details.offsetEnd += details.scrollMaxSize - details.offsetStart;
  }
  return details;
}
function setScroll(parent, scroll, horizontal, rtl) {
  if (scroll === 'end') {
    scroll = (parent === window ? document.body : parent)[horizontal === true ? 'scrollWidth' : 'scrollHeight'];
  }
  if (parent === window) {
    if (horizontal === true) {
      if (rtl === true) {
        scroll = (Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* rtlHasScrollBug */ "h"])() === true ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - scroll;
      }
      window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    } else {
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
    }
  } else if (horizontal === true) {
    if (rtl === true) {
      scroll = (Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* rtlHasScrollBug */ "h"])() === true ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
    }
    parent.scrollLeft = scroll;
  } else {
    parent.scrollTop = scroll;
  }
}
function sumSize(sizeAgg, size, from, to) {
  if (from >= to) {
    return 0;
  }
  const lastTo = size.length,
    fromAgg = Math.floor(from / aggBucketSize),
    toAgg = Math.floor((to - 1) / aggBucketSize) + 1;
  let total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);
  if (from % aggBucketSize !== 0) {
    total -= size.slice(fromAgg * aggBucketSize, from).reduce(sumFn, 0);
  }
  if (to % aggBucketSize !== 0 && to !== lastTo) {
    total -= size.slice(to, toAgg * aggBucketSize).reduce(sumFn, 0);
  }
  return total;
}
const commonVirtScrollProps = {
  virtualScrollSliceSize: {
    type: [Number, String],
    default: null
  },
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },
  virtualScrollItemSize: {
    type: [Number, String],
    default: 24
  },
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },
  tableColspan: [Number, String]
};
function setOverflowAnchor(contentEl, index) {
  if (setOverflowAnchor.isSupported === void 0) {
    setOverflowAnchor.isSupported = window.getComputedStyle(document.body).overflowAnchor !== void 0;
  }
  if (setOverflowAnchor.isSupported === false || contentEl === void 0) {
    return;
  }
  cancelAnimationFrame(contentEl._qOverflowAnimationFrame);
  contentEl._qOverflowAnimationFrame = requestAnimationFrame(() => {
    if (contentEl === void 0) {
      return;
    }
    const children = contentEl.children || [];
    filterProto.call(children, el => el.dataset && el.dataset.qVsAnchor !== void 0).forEach(el => {
      delete el.dataset.qVsAnchor;
    });
    const el = children[index];
    if (el && el.dataset) {
      el.dataset.qVsAnchor = '';
    }
  });
}
const commonVirtPropsList = Object.keys(commonVirtScrollProps);
/* harmony default export */ __webpack_exports__["b"] = ({
  props: {
    virtualScrollHorizontal: Boolean,
    ...commonVirtScrollProps
  },
  data() {
    return {
      virtualScrollSliceRange: {
        from: 0,
        to: 0
      }
    };
  },
  watch: {
    needsSliceRecalc() {
      this.__setVirtualScrollSize();
    },
    needsReset() {
      this.reset();
    }
  },
  computed: {
    needsReset() {
      return ['virtualScrollItemSizeComputed', 'virtualScrollHorizontal'].map(p => this[p]).join(';');
    },
    needsSliceRecalc() {
      return this.needsReset + ';' + ['virtualScrollSliceRatioBefore', 'virtualScrollSliceRatioAfter'].map(p => this[p]).join(';');
    },
    colspanAttr() {
      return this.tableColspan !== void 0 ? {
        colspan: this.tableColspan
      } : {
        colspan: 100
      };
    },
    virtualScrollItemSizeComputed() {
      return this.virtualScrollItemSize;
    }
  },
  methods: {
    reset() {
      this.__resetVirtualScroll(this.prevToIndex, true);
    },
    refresh(toIndex) {
      this.__resetVirtualScroll(toIndex === void 0 ? this.prevToIndex : toIndex);
    },
    scrollTo(toIndex, edge) {
      const scrollEl = this.__getVirtualScrollTarget();
      if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
        return;
      }
      const scrollDetails = getScrollDetails(scrollEl, this.__getVirtualScrollEl(), this.$refs.before, this.$refs.after, this.virtualScrollHorizontal, this.$q.lang.rtl, this.virtualScrollStickySizeStart, this.virtualScrollStickySizeEnd);
      this.__scrollViewSize !== scrollDetails.scrollViewSize && this.__setVirtualScrollSize(scrollDetails.scrollViewSize);
      this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, Math.min(this.virtualScrollLength - 1, Math.max(0, parseInt(toIndex, 10) || 0)), 0, scrollToEdges.indexOf(edge) > -1 ? edge : this.prevToIndex > -1 && toIndex > this.prevToIndex ? 'end' : 'start');
    },
    __onVirtualScrollEvt() {
      const scrollEl = this.__getVirtualScrollTarget();
      if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
        return;
      }
      const scrollDetails = getScrollDetails(scrollEl, this.__getVirtualScrollEl(), this.$refs.before, this.$refs.after, this.virtualScrollHorizontal, this.$q.lang.rtl, this.virtualScrollStickySizeStart, this.virtualScrollStickySizeEnd),
        listLastIndex = this.virtualScrollLength - 1,
        listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - this.virtualScrollPaddingAfter;
      if (this.prevScrollStart === scrollDetails.scrollStart) {
        return;
      }
      if (scrollDetails.scrollMaxSize <= 0) {
        this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);
        return;
      }
      this.__scrollViewSize !== scrollDetails.scrollViewSize && this.__setVirtualScrollSize(scrollDetails.scrollViewSize);
      this.__updateVirtualScrollSizes(this.virtualScrollSliceRange.from);
      const scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(this.virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));
      if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
        this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, listLastIndex, scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - this.virtualScrollSizesAgg.reduce(sumFn, 0));
        return;
      }
      let toIndex = 0,
        listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart,
        offset = listOffset;
      if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= this.virtualScrollPaddingBefore) {
        listOffset -= this.virtualScrollPaddingBefore;
        toIndex = this.virtualScrollSliceRange.from;
        offset = listOffset;
      } else {
        for (let j = 0; listOffset >= this.virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
          listOffset -= this.virtualScrollSizesAgg[j];
          toIndex += aggBucketSize;
        }
      }
      while (listOffset > 0 && toIndex < listLastIndex) {
        listOffset -= this.virtualScrollSizes[toIndex];
        if (listOffset > -scrollDetails.scrollViewSize) {
          toIndex++;
          offset = listOffset;
        } else {
          offset = this.virtualScrollSizes[toIndex] + listOffset;
        }
      }
      this.__setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset);
    },
    __setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset, align) {
      const alignForce = typeof align === 'string' && align.indexOf('-force') > -1;
      const alignEnd = alignForce === true ? align.replace('-force', '') : align;
      const alignRange = alignEnd !== void 0 ? alignEnd : 'start';
      let from = Math.max(0, toIndex - this.virtualScrollSliceSizeComputed[alignRange]),
        to = from + this.virtualScrollSliceSizeComputed.total;
      if (to > this.virtualScrollLength) {
        to = this.virtualScrollLength;
        from = Math.max(0, to - this.virtualScrollSliceSizeComputed.total);
      }
      this.prevScrollStart = scrollDetails.scrollStart;
      const rangeChanged = from !== this.virtualScrollSliceRange.from || to !== this.virtualScrollSliceRange.to;
      if (rangeChanged === false && alignEnd === void 0) {
        this.__emitScroll(toIndex);
        return;
      }
      const {
        activeElement
      } = document;
      const contentEl = this.$refs.content;
      if (rangeChanged === true && contentEl !== void 0 && contentEl !== activeElement && contentEl.contains(activeElement) === true) {
        contentEl.addEventListener('focusout', this.__onBlurRefocusFn);
        setTimeout(() => {
          contentEl !== void 0 && contentEl.removeEventListener('focusout', this.__onBlurRefocusFn);
        });
      }
      setOverflowAnchor(contentEl, toIndex - from);
      const sizeBefore = alignEnd !== void 0 ? this.virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0) : 0;
      if (rangeChanged === true) {
        // vue key matching algorithm works only if
        // the array of VNodes changes on only one of the ends
        // so we first change one end and then the other

        const tempTo = to >= this.virtualScrollSliceRange.from && from <= this.virtualScrollSliceRange.to ? this.virtualScrollSliceRange.to : to;
        this.virtualScrollSliceRange = {
          from,
          to: tempTo
        };
        this.virtualScrollPaddingBefore = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, 0, from);
        this.virtualScrollPaddingAfter = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, this.virtualScrollSliceRange.to, this.virtualScrollLength);
        requestAnimationFrame(() => {
          if (this.virtualScrollSliceRange.to !== to && this.prevScrollStart === scrollDetails.scrollStart) {
            this.virtualScrollSliceRange = {
              from: this.virtualScrollSliceRange.from,
              to
            };
            this.virtualScrollPaddingAfter = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, to, this.virtualScrollLength);
          }
        });
      }
      requestAnimationFrame(() => {
        // if the scroll was changed give up
        // (another call to __setVirtualScrollSliceRange before animation frame)
        if (this.prevScrollStart !== scrollDetails.scrollStart) {
          return;
        }
        if (rangeChanged === true) {
          this.__updateVirtualScrollSizes(from);
        }
        const sizeAfter = this.virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0),
          posStart = sizeAfter + scrollDetails.offsetStart + this.virtualScrollPaddingBefore,
          posEnd = posStart + this.virtualScrollSizes[toIndex];
        let scrollPosition = posStart + offset;
        if (alignEnd !== void 0) {
          const sizeDiff = sizeAfter - sizeBefore;
          const scrollStart = scrollDetails.scrollStart + sizeDiff;
          scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === 'end' ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === 'start' ? 0 : Math.round((scrollDetails.scrollViewSize - this.virtualScrollSizes[toIndex]) / 2));
        }
        this.prevScrollStart = scrollPosition;
        setScroll(scrollEl, scrollPosition, this.virtualScrollHorizontal, this.$q.lang.rtl);
        this.__emitScroll(toIndex);
      });
    },
    __updateVirtualScrollSizes(from) {
      const contentEl = this.$refs.content;
      if (contentEl !== void 0) {
        const children = filterProto.call(contentEl.children || [], el => el.classList && el.classList.contains('q-virtual-scroll--skip') === false),
          // fallback [] for IE
          childrenLength = children.length,
          sizeFn = this.virtualScrollHorizontal === true ? el => el.getBoundingClientRect().width : el => el.offsetHeight;
        let index = from,
          size,
          diff;
        for (let i = 0; i < childrenLength;) {
          size = sizeFn(children[i]);
          i++;
          while (i < childrenLength && children[i].classList.contains('q-virtual-scroll--with-prev') === true) {
            size += sizeFn(children[i]);
            i++;
          }
          diff = size - this.virtualScrollSizes[index];
          if (diff !== 0) {
            this.virtualScrollSizes[index] += diff;
            this.virtualScrollSizesAgg[Math.floor(index / aggBucketSize)] += diff;
          }
          index++;
        }
      }
    },
    __resetVirtualScroll(toIndex, fullReset) {
      const defaultSize = 1 * this.virtualScrollItemSizeComputed;
      if (fullReset === true || Array.isArray(this.virtualScrollSizes) === false) {
        this.virtualScrollSizes = [];
      }
      const oldVirtualScrollSizesLength = this.virtualScrollSizes.length;
      this.virtualScrollSizes.length = this.virtualScrollLength;
      for (let i = this.virtualScrollLength - 1; i >= oldVirtualScrollSizesLength; i--) {
        this.virtualScrollSizes[i] = defaultSize;
      }
      const jMax = Math.floor((this.virtualScrollLength - 1) / aggBucketSize);
      this.virtualScrollSizesAgg = [];
      for (let j = 0; j <= jMax; j++) {
        let size = 0;
        const iMax = Math.min((j + 1) * aggBucketSize, this.virtualScrollLength);
        for (let i = j * aggBucketSize; i < iMax; i++) {
          size += this.virtualScrollSizes[i];
        }
        this.virtualScrollSizesAgg.push(size);
      }
      this.prevToIndex = -1;
      this.prevScrollStart = void 0;
      this.virtualScrollPaddingBefore = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, 0, this.virtualScrollSliceRange.from);
      this.virtualScrollPaddingAfter = sumSize(this.virtualScrollSizesAgg, this.virtualScrollSizes, this.virtualScrollSliceRange.to, this.virtualScrollLength);
      if (toIndex >= 0) {
        this.__updateVirtualScrollSizes(this.virtualScrollSliceRange.from);
        this.$nextTick(() => {
          this.scrollTo(toIndex);
        });
      } else {
        this.__onVirtualScrollEvt();
      }
    },
    __setVirtualScrollSize(scrollViewSize) {
      if (scrollViewSize === void 0 && typeof window !== 'undefined') {
        const scrollEl = this.__getVirtualScrollTarget();
        if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
          scrollViewSize = getScrollDetails(scrollEl, this.__getVirtualScrollEl(), this.$refs.before, this.$refs.after, this.virtualScrollHorizontal, this.$q.lang.rtl, this.virtualScrollStickySizeStart, this.virtualScrollStickySizeEnd).scrollViewSize;
        }
      }
      this.__scrollViewSize = scrollViewSize;
      const virtualScrollSliceRatioBefore = parseFloat(this.virtualScrollSliceRatioBefore) || 0;
      const virtualScrollSliceRatioAfter = parseFloat(this.virtualScrollSliceRatioAfter) || 0;
      const multiplier = 1 + virtualScrollSliceRatioBefore + virtualScrollSliceRatioAfter;
      const view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / this.virtualScrollItemSizeComputed);
      const baseSize = Math.max(1, view, Math.ceil((this.virtualScrollSliceSize > 0 ? this.virtualScrollSliceSize : 10) / multiplier));
      this.virtualScrollSliceSizeComputed = {
        total: Math.ceil(baseSize * multiplier),
        start: Math.ceil(baseSize * virtualScrollSliceRatioBefore),
        center: Math.ceil(baseSize * (0.5 + virtualScrollSliceRatioBefore)),
        end: Math.ceil(baseSize * (1 + virtualScrollSliceRatioBefore)),
        view
      };
    },
    __padVirtualScroll(h, tag, content) {
      const paddingSize = this.virtualScrollHorizontal === true ? 'width' : 'height';
      const style = {
        ['--q-virtual-scroll-item-' + paddingSize]: this.virtualScrollItemSizeComputed + 'px'
      };
      return [tag === 'tbody' ? h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'before',
        ref: 'before'
      }, [h('tr', [h('td', {
        style: {
          [paddingSize]: `${this.virtualScrollPaddingBefore}px`,
          ...style
        },
        attrs: this.colspanAttr
      })])]) : h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'before',
        ref: 'before',
        style: {
          [paddingSize]: `${this.virtualScrollPaddingBefore}px`,
          ...style
        }
      }), h(tag, {
        staticClass: 'q-virtual-scroll__content',
        key: 'content',
        ref: 'content',
        attrs: {
          tabindex: -1
        }
      }, content), tag === 'tbody' ? h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'after',
        ref: 'after'
      }, [h('tr', [h('td', {
        style: {
          [paddingSize]: `${this.virtualScrollPaddingAfter}px`,
          ...style
        },
        attrs: this.colspanAttr
      })])]) : h(tag, {
        staticClass: 'q-virtual-scroll__padding',
        key: 'after',
        ref: 'after',
        style: {
          [paddingSize]: `${this.virtualScrollPaddingAfter}px`,
          ...style
        }
      })];
    },
    __emitScroll(index) {
      if (this.prevToIndex !== index) {
        this.qListeners['virtual-scroll'] !== void 0 && this.$emit('virtual-scroll', {
          index,
          from: this.virtualScrollSliceRange.from,
          to: this.virtualScrollSliceRange.to - 1,
          direction: index < this.prevToIndex ? 'decrease' : 'increase',
          ref: this
        });
        this.prevToIndex = index;
      }
    },
    __onBlurRefocusFn() {
      this.$refs.content !== void 0 && this.$refs.content.focus();
    }
  },
  created() {
    this.__setVirtualScrollSize();
  },
  activated() {
    if (this.shouldActivate !== true) {
      return;
    }
    const scrollEl = this.__getVirtualScrollTarget();
    if (this.prevScrollStart !== void 0 && scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
      setScroll(scrollEl, this.prevScrollStart, this.virtualScrollHorizontal, this.$q.lang.rtl);
    } else {
      this.scrollTo(this.prevToIndex);
    }
  },
  deactivated() {
    this.shouldActivate = true;
  },
  beforeMount() {
    this.__onVirtualScrollEvt = Object(_utils_debounce_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this.__onVirtualScrollEvt, this.$q.platform.is.ios === true ? 120 : 35);
    this.__setVirtualScrollSize();
  },
  beforeDestroy() {
    this.__onVirtualScrollEvt.cancel();
  }
});

/***/ }),

/***/ "818c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageStore; });
/* harmony import */ var _ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("03be");
/* harmony import */ var _ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("406b");
/* harmony import */ var _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ht_lib_image_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("38a2");
/* harmony import */ var _ht_lib_image_util__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ht_lib_image_util__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("982d");
/* harmony import */ var _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("60bb");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_5__);
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _ImageStore_bucketName;






const deletedLongRef = '00000000000000000000000000000000';
const statusIcons = {
  FLAGGED: 'mdi-flag-variant-outline',
  REJECTED: 'mdi-trash-can-outline',
  NONE: ''
};
function getIcon(status) {
  return statusIcons[status];
}
var ImageState;
(function (ImageState) {
  ImageState[ImageState["New"] = 0] = "New";
  ImageState[ImageState["ReUpload"] = 1] = "ReUpload";
  ImageState[ImageState["Uploaded"] = 2] = "Uploaded";
  ImageState[ImageState["Ready"] = 3] = "Ready";
  ImageState[ImageState["Deleted"] = 4] = "Deleted";
})(ImageState || (ImageState = {}));
function imageState(image) {
  const {
    longRef,
    uploaded,
    thumbnailHighName,
    thumbnailLowName
  } = image;
  const validThumbnail = [thumbnailHighName, thumbnailLowName].every(x => x != null && x !== '');
  switch (true) {
    case longRef === deletedLongRef:
      return ImageState.Deleted;
    case !uploaded && !validThumbnail:
      return ImageState.New;
    case !uploaded && validThumbnail:
      return ImageState.ReUpload;
    case uploaded && !validThumbnail:
      return ImageState.Uploaded;
    case uploaded && validThumbnail:
      return ImageState.Ready;
    default:
      throwInvalidImageState(image);
  }
}
function throwInvalidImageState(image) {
  throw new Error(`${image.longRef} -- Invalid image state. ${JSON.stringify(lodash__WEBPACK_IMPORTED_MODULE_4___default.a.pick(image, 'url', 'uploaded'))}`);
}
class ImageStore {
  constructor() {
    this.photographers = {};
    this.images = {};
    this.selectedImageRefs = [];
    _ImageStore_bucketName.set(this, '');
    this._loaded = false;
    this.debounceLoaded = lodash__WEBPACK_IMPORTED_MODULE_4___default.a.debounce(() => {
      this._loaded = true;
    }, 500);
    this._isUploading = false;
  }
  static get Instance() {
    if (ImageStore.instance === undefined) {
      ImageStore.instance = vue__WEBPACK_IMPORTED_MODULE_5___default.a.observable(new ImageStore());
    }
    return ImageStore.instance;
  }
  get loaded() {
    console.debug('ImageStore->loaded');
    return this._loaded;
  }
  get isUploading() {
    console.debug('ImageStore->isUploading');
    return this._isUploading;
  }
  set isUploading(value) {
    this._isUploading = value;
  }
  get bucketName() {
    if (__classPrivateFieldGet(this, _ImageStore_bucketName, "f") === '') {
      throwThumbnailBucketNotSet();
    }
    return __classPrivateFieldGet(this, _ImageStore_bucketName, "f");
  }
  set bucketName(value) {
    if (typeof value !== 'string' || value.length === 0) {
      throwThumbnailBucketNotSet();
    }
    __classPrivateFieldSet(this, _ImageStore_bucketName, value, "f");
  }
  get allImages() {
    console.debug('ImageStore->allImages');
    return Object.values(this.images);
  }
  get flaggedImages() {
    console.debug('ImageStore->flaggedImages');
    return this.allImages.filter(x => x.status === _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__["ImageStatus"].FLAGGED);
  }
  get rejectedImages() {
    console.debug('ImageStore->rejectedImages');
    return this.allImages.filter(x => x.status === _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__["ImageStatus"].REJECTED);
  }
  get normalImages() {
    console.debug('ImageStore->normalImages');
    return this.allImages.filter(x => x.status === _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__["ImageStatus"].NONE);
  }
  get selectedImages() {
    console.debug('ImageStore->selectedImages');
    return this.findSelectedImages(this.allImages);
  }
  get photographersArray() {
    console.debug('ImageStore->photographersArray');
    return lodash__WEBPACK_IMPORTED_MODULE_4___default.a.sortBy(Object.values(this.photographers), x => x.photographerId);
  }
  static LoadNewJob(job, uploaderId) {
    return ImageStore.Instance.LoadJob(job, uploaderId);
  }
  static LoadNewAimsJobNumber(aimsJobNumber) {
    return ImageStore.Instance.LoadAimsJobNumber(aimsJobNumber);
  }
  static ClearJob() {
    return ImageStore.Instance.clearJob();
  }
  findSelectedImages(images) {
    console.debug('ImageStore->findSelectedImages');
    if (images.length === 0 || this.selectedImageRefs.length === 0) return [];
    const found = [];
    const [arr1, arr2] = [images, this.selectedImageRefs];
    const [big, small] = arr1.length > arr2.length ? [arr1, arr2] : [arr2, arr1];
    const xIsLongRef = typeof big[0] === 'string';
    for (const x of big) {
      if (found.length === images.length) break;
      let longRef;
      let image;
      for (const y of small) {
        [longRef, image] = xIsLongRef ? [x, y] : [y, x];
        if (longRef === image.longRef) {
          found.push(image);
          break;
        }
      }
    }
    return found;
  }
  classNames(longRef) {
    var _a;
    console.debug('ImageStore->classNames()');
    const groupClass = (_a = this.allImages.find(x => x.longRef === longRef)) === null || _a === void 0 ? void 0 : _a.className;
    const classNames = lodash__WEBPACK_IMPORTED_MODULE_4___default.a.uniq(this.allImages.map(x => {
      var _a;
      return (_a = x.className) !== null && _a !== void 0 ? _a : 'UNKNOWN CLASS';
    }));
    return classNames.filter(x => x !== groupClass);
  }
  zoomImages(zoomId, images) {
    console.debug('ImageStore->zoomImages()');
    const getImage = index => {
      var _a;
      return this.images[(_a = images[index]) === null || _a === void 0 ? void 0 : _a.longRef];
    };
    const index = images.findIndex(x => x.longRef === zoomId);
    const hasZoom = zoomId !== '' && index >= 0;
    if (hasZoom) {
      return {
        active: getImage(index),
        next: getImage(index + 1),
        prev: getImage(index - 1)
      };
    }
    return {
      active: getImage(0),
      next: getImage(1)
    };
  }
  search(images, rawTerm) {
    console.debug('ImageStore->search()');
    const term = rawTerm.toUpperCase();
    return images.filter(x => {
      var _a, _b;
      const refMatch = x.ref.toUpperCase().startsWith(term);
      const pupilMatch = (_b = (_a = x.pupilId) === null || _a === void 0 ? void 0 : _a.toUpperCase().startsWith(term)) !== null && _b !== void 0 ? _b : false;
      return refMatch || pupilMatch;
    });
  }
  updateStatus(id, status) {
    console.debug('ImageStore->updateStatus()');
    try {
      const image = Object(_ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0__["getImage"])(this.allImages, id);
      if (image.status === status) {
        return;
      }
      if (status === _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__["ImageStatus"].REJECTED) {
        Object(_ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0__["rejectImage"])(this.allImages, id);
      } else if (image.status === _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__["ImageStatus"].REJECTED) {
        Object(_ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0__["acceptImage"])(this.allImages, id, status);
      } else {
        image.status = status;
      }
    } catch (e) {
      console.error('Could not update image status', e);
    }
  }
  updateAllSelect(value) {
    console.debug('ImageStore->updateAllSelect()');
    if (value) {
      this.selectedImageRefs.push(...Object.keys(this.images));
    } else {
      this.selectedImageRefs.splice(0, this.selectedImageRefs.length);
    }
  }
  updateAllCPSelected(value) {
    console.debug('ImageStore->updateAllCPSelected()');
    for (const longRef of this.selectedImageRefs) {
      const image = this.images[longRef];
      image.childProtectionIssue = value;
    }
  }
  updateCP(longRef, b) {
    console.debug('ImageStore->updateCP()');
    const image = this.images[longRef];
    if (image !== undefined) {
      image.childProtectionIssue = b;
    }
  }
  updateSelectedStatus(newStatus) {
    console.debug('ImageStore->updateSelectedStatus()');
    const shouldUpdateImage = image => {
      if (!this.isSelected(image.longRef)) {
        return false;
      }
      return !(newStatus === _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__["ImageStatus"].FLAGGED && image.status === _ht_lib_accounts_models__WEBPACK_IMPORTED_MODULE_1__["ImageStatus"].REJECTED);
    };
    for (const longRef of this.selectedImageRefs) {
      const image = this.images[longRef];
      if (shouldUpdateImage(image)) {
        this.updateStatus(longRef, newStatus);
      }
    }
  }
  moveSelectedToClass(className) {
    console.debug('ImageStore->moveSelectedToClass()');
    for (const longRef of this.selectedImageRefs) {
      try {
        Object(_ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0__["updateClass"])(this.allImages, longRef, className);
      } catch (e) {
        console.error('Could not move image to class', e);
      }
    }
  }
  async duplicateImageToClasses(longRef, classNames) {
    const image = this.images[longRef];
    if (image == null) {
      throw new Error(`No image found for longRef ${longRef}`);
    }
    await Promise.all(classNames.map(async className => {
      const longRef = await _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__["Image"].generateImageLongref();
      const newImage = {
        ...image,
        className
      };
      await this.duplicateImage(longRef, image.longRef, newImage);
    }));
  }
  toggleSelected(longRef) {
    console.debug('ImageStore->toggleSelected()');
    const index = this.selectedIndex(longRef);
    if (index === -1) {
      this.setSelected(longRef, true, index);
    } else {
      this.setSelected(longRef, false, index);
    }
  }
  setSelected(longRef, value, index = null) {
    console.debug('ImageStore->setSelected()');
    if (index === null) {
      index = this.selectedIndex(longRef);
    }
    if (value && index === -1) {
      this.selectedImageRefs.push(longRef);
    } else if (!value && index !== -1) {
      this.selectedImageRefs.splice(index, 1);
    }
  }
  selectedIndex(longRef) {
    console.debug('ImageStore->selectedIndex()');
    return this.selectedImageRefs.indexOf(longRef);
  }
  isSelected(longRef) {
    console.debug('ImageStore->isSelected');
    if (this.selectedImageRefs.length === 0) return false;
    return this.selectedImageRefs.includes(longRef);
  }
  async save() {
    console.debug('ImageStore->save()');
    const images = this.allImages.map(x => {
      var _a, _b;
      return {
        longRef: x.longRef,
        childProtectionIssue: x.childProtectionIssue,
        className: x.className,
        isPreferred: x.isPreferred,
        pupilId: (_a = x.pupilId) !== null && _a !== void 0 ? _a : null,
        pupilName: (_b = x.pupilName) !== null && _b !== void 0 ? _b : null,
        status: x.status
      };
    });
    await Object(_ht_lib_image_util__WEBPACK_IMPORTED_MODULE_2__["batchUpdateImages"])(images);
  }
  LoadJob(job, uploaderId) {
    this.clearJob();
    let imagesQuery = _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__["Image"].byJobId(job.id);
    if (uploaderId != null) {
      imagesQuery = _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__["Image"].query(imagesQuery, _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__["Image"].byUploaderId(uploaderId));
    }
    return this.setupSnapshot(imagesQuery);
  }
  LoadAimsJobNumber(aimsJobNumber) {
    this.clearJob();
    const imagesQuery = (aimsJobNumber === null || aimsJobNumber === void 0 ? void 0 : aimsJobNumber.isComplete) ? _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__["Image"].byAimsJob(aimsJobNumber.accountCode, aimsJobNumber.jobCode) : null;
    return this.setupSnapshot(imagesQuery);
  }
  clearJob() {
    var _a;
    (_a = this.unsubsribeSnapshot) === null || _a === void 0 ? void 0 : _a.call(this);
    this.selectedImageRefs.splice(0, this.selectedImageRefs.length);
    clearObject(this.images);
    clearObject(this.photographers);
  }
  setupSnapshot(imagesQuery) {
    var _a;
    (_a = this.unsubsribeSnapshot) === null || _a === void 0 ? void 0 : _a.call(this);
    if (imagesQuery === null) {
      throw new Error('Cannot setup snapshot. Neither job nor aims job number was provided');
    }
    const {
      unsubscribe
    } = imagesQuery.listenChangesMapCache({
      onAddedOrModified: item => this.loadImage(item.model),
      onRemoved: longRef => {
        vue__WEBPACK_IMPORTED_MODULE_5___default.a.delete(this.images, longRef);
      },
      defaultMetadata: null
    });
    this.unsubsribeSnapshot = unsubscribe;
    setTimeout(() => this.debounceLoaded(), 5000);
    return this;
  }
  loadImage(imageEntry) {
    var _a, _b;
    console.debug('ImageStore->loadImage()');
    if (this.photographers[imageEntry.photographerCode] === undefined) {
      this.loadPhotographer(imageEntry.photographerCode).catch(e => console.error('Error loading Photographer for lookup', e));
    }
    const currentImage = this.images[imageEntry.longRef];
    const image = {
      ...imageEntry,
      url: (_a = currentImage === null || currentImage === void 0 ? void 0 : currentImage.url) !== null && _a !== void 0 ? _a : null,
      loading: (_b = currentImage === null || currentImage === void 0 ? void 0 : currentImage.loading) !== null && _b !== void 0 ? _b : true
    };
    switch (imageState(image)) {
      case ImageState.New:
        // Newly uploaded image will not have thumbnails, but should generate.
        console.debug(`${image.longRef} -- State: New`);
        break;
      case ImageState.ReUpload:
        // Re-uploaded image will have thumbnails, but should regenerate.
        console.debug(`${image.longRef} -- State: ReUpload`);
        break;
      case ImageState.Uploaded:
        // Uploaded image has no thumbnails generated. (unusual)
        console.debug(`${image.longRef} -- State: Uploaded`);
        Object(_ht_lib_image_util__WEBPACK_IMPORTED_MODULE_2__["getThumbnailObjectURL"])(this.bucketName, image, true);
        break;
      case ImageState.Ready:
        // Uploaded and have thumbnails
        console.debug(`${image.longRef} -- State: Ready`);
        image.url = Object(_ht_lib_image_util__WEBPACK_IMPORTED_MODULE_2__["buildThumbnailUrl"])(this.bucketName, image.thumbnailLowName);
        image.loading = false;
        break;
      case ImageState.Deleted:
        console.debug(`${image.longRef} -- State: Deleted`);
        image.url = Object(_ht_lib_image_util__WEBPACK_IMPORTED_MODULE_2__["buildThumbnailUrl"])(this.bucketName, deletedLongRef);
        image.loading = false;
        break;
      default:
        throwInvalidImageState(image);
    }
    if (!this._loaded) {
      this.debounceLoaded();
    }
    this.addOrSetImage(image);
  }
  async duplicateImage(longRef, originalLongRef, image) {
    const {
      url,
      loading,
      ...imageEntry
    } = image;
    delete imageEntry.thumbnailHighName;
    delete imageEntry.thumbnailLowName;
    return await _ht_web_firebase_adapter__WEBPACK_IMPORTED_MODULE_3__["Image"].addImage(longRef, {
      ...imageEntry,
      longRef: longRef,
      ref: longRef.substring(0, 10),
      originalLongRef: originalLongRef,
      nexusId: null,
      imported: false,
      uploaded: false,
      hash: null
    });
  }
  async loadPhotographer(photographerCode) {
    var _a;
    console.debug(`ImageStore->loadPhotographer(${photographerCode})`);
    this.addOrSetPhotographer(photographerCode, {
      photographerId: photographerCode,
      displayName: 'Unknown Photographer',
      found: false
    });
    const photographersSnapshot = await Object(_ht_lib_accounts_common__WEBPACK_IMPORTED_MODULE_0__["photographerCollection"])().where('photographerId', '==', photographerCode).get();
    if (photographersSnapshot.empty) {
      console.error(`Found 0 photographer(s) for ${photographerCode}, expected at least 1`);
      return;
    }
    // A photographerId can match more than one lookup: changing a real name creates a new
    // profile (and lookup) and leaves the old one behind, archived. Prefer a non-archived
    // record, falling back to the first if all are archived, instead of giving up when the
    // count isn't exactly 1. (photographersLookup has no client-visible timestamp, so there is
    // no deterministic "most recently created" tiebreak here as there is server-side.)
    const docs = photographersSnapshot.docs;
    const best = (_a = docs.find(d => !d.data().archived)) !== null && _a !== void 0 ? _a : docs[0];
    if (docs.length > 1) {
      console.warn(`Found ${docs.length} photographer lookups for ${photographerCode}; using ${best.id}`);
    }
    this.addOrSetPhotographer(photographerCode, {
      photographerId: photographerCode,
      displayName: best.data().displayName,
      found: true
    });
  }
  addOrSetImage(image) {
    vue__WEBPACK_IMPORTED_MODULE_5___default.a.set(this.images, image.longRef, image);
  }
  addOrSetPhotographer(photographerId, value) {
    vue__WEBPACK_IMPORTED_MODULE_5___default.a.set(this.photographers, photographerId, value);
  }
}
_ImageStore_bucketName = new WeakMap();
function clearObject(obj) {
  for (const key in obj) {
    vue__WEBPACK_IMPORTED_MODULE_5___default.a.delete(obj, key);
  }
}
function throwThumbnailBucketNotSet() {
  throw new Error('Thumbnail Bucket is not set');
}

/***/ }),

/***/ "82fa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/Worksheet.vue?vue&type=template&id=4d0ef3ae&scoped=true&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "worksheet text-black fixed-top"
  }, [_c('div', {
    staticClass: "q-mt-sm",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "text-left text-h4"
  }, [_vm._v(_vm._s(_vm.jobData.account.name))]), _c('div', {
    staticClass: "text-right text-h5"
  }, [_vm._v(_vm._s(_vm.jobData.account.code))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('q-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Job Type:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.jobData.jobType))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Is Datalinked:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.isDataLinked))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Is Out of Hours:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.isOutOfHours))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Image Count:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.jobData.imageCount))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Take Date:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.takeDate))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Committed Date:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.committedDate))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Aims Number Added Date:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.aimsAddedDate))])], 1)], 1), _vm.account.warningText ? _c('q-item', {
    staticClass: "text-negative col"
  }, [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Account Warning:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.account.warningText))])], 1)], 1) : _vm._e()], 1), _c('q-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('q-item-label', {
    staticClass: "text-h6",
    attrs: {
      "header": ""
    }
  }, [_vm._v("Contact")]), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Name:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.jobAccountContactCustom.name))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Headteacher:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.jobData.account.headTeacherName))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": "",
      "top": ""
    }
  }, [_vm._v("Dispatch Address:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value",
    domProps: {
      "innerHTML": _vm._s(_vm.accountAddress)
    }
  })], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Phone:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.jobAccountContactCustom.phone))])], 1)], 1), _c('q-item', [_c('q-item-section', {
    staticClass: "item-label",
    attrs: {
      "side": ""
    }
  }, [_vm._v("Email:")]), _c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.jobAccountContactCustom.email))])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "col",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('q-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('q-item-label', {
    staticClass: "text-h6",
    attrs: {
      "header": ""
    }
  }, [_vm._v("Commissions")]), _c('q-item', [_c('q-item-section', [_c('q-item-label', [_vm._v(_vm._s(_vm.jobData.account.name) + " Web:")]), _c('q-item-label', [_vm._v(_vm._s(_vm.jobData.account.name) + " Mod:")])], 1), _c('q-item-section', {
    attrs: {
      "side": "",
      "top": ""
    }
  }, [_c('q-item-label', [_vm._v(_vm._s(_vm.commission.web) + "%")]), _c('q-item-label', [_vm._v(_vm._s(_vm.commission.mod) + "%")])], 1)], 1), _c('q-separator', {
    attrs: {
      "spaced": "",
      "color": "grey-1"
    }
  }), _c('q-item', [_c('q-item-section', {
    staticClass: "q-pb-xs"
  }, [_c('q-item-label', [_vm._v(_vm._s(_vm.jobData.account.holder.name) + " (" + _vm._s(_vm.jobData.account.holder.code || 'No Code') + "):")]), _c('q-item-label', {
    staticClass: "q-ml-sm",
    attrs: {
      "caption": ""
    }
  }, [_vm._v("(account holder)")])], 1), _c('q-item-section', {
    attrs: {
      "side": "",
      "top": ""
    }
  }, [_c('q-item-label', [_vm._v(_vm._s(_vm.commission.accountHolder) + "%")])], 1)], 1), _vm._l(_vm.jobData.photographersMap, function (photographer) {
    return _c('q-item', {
      key: photographer.id
    }, [_c('q-item-section', {
      staticClass: "q-pb-xs"
    }, [_c('q-item-label', [_vm._v(_vm._s(photographer.name) + " (" + _vm._s(photographer.code || 'No Code') + "):")]), _c('q-item-label', {
      staticClass: "q-ml-sm",
      attrs: {
        "caption": ""
      }
    }, [_vm._v("(" + _vm._s(photographer.role) + ")")])], 1), _c('q-item-section', {
      attrs: {
        "side": "",
        "top": ""
      }
    }, [_c('q-item-label', [_vm._v(_vm._s(photographer.commission) + "%")])], 1)], 1);
  }), _c('q-item', [_c('q-item-section', {
    staticClass: "q-mt-xs"
  }, [_c('q-item-label', [_vm._v("Total Commission:")])], 1), _c('q-item-section', {
    attrs: {
      "side": ""
    }
  }, [_c('q-item-label', [_vm._v(_vm._s(_vm.commission.total) + "%")])], 1)], 1)], 2)], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('q-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('q-item-label', {
    staticClass: "text-h6",
    attrs: {
      "header": ""
    }
  }, [_vm._v("Notes")]), _c('q-item', [_c('q-item-section', [_c('q-item-label', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.jobData.notes))])], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "fixed-bottom-right"
  }, [_c('barcode', {
    attrs: {
      "value": _vm.barcodeValue
    }
  }, [_vm._v("Error creating barcode")])], 1)])]);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/Worksheet.vue?vue&type=template&id=4d0ef3ae&scoped=true&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: /workspace/node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__("5d8b");

// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || Object(esm_typeof["a" /* default */])(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/toDate/index.js


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || Object(esm_typeof["a" /* default */])(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions_defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions_defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions_defaultOptions = newOptions;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize_localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize_localize);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var en_US_locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (en_US_locale);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
// CONCATENATED MODULE: /workspace/node_modules/date-fns/esm/fromUnixTime/index.js



/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param {Number} unixTime - the given Unix timestamp (in seconds)
 * @returns {Date} the date
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */
function fromUnixTime(dirtyUnixTime) {
  requiredArgs(1, arguments);
  var unixTime = toInteger(dirtyUnixTime);
  return toDate(unixTime * 1000);
}
// EXTERNAL MODULE: /workspace/node_modules/vue-barcode/index.js
var vue_barcode = __webpack_require__("7765");
var vue_barcode_default = /*#__PURE__*/__webpack_require__.n(vue_barcode);

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/Worksheet.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



const dateFormat = 'do MMM yyyy';
let Worksheetvue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  get accountAddress() {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.jobData.account.dispatchAddress) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.replace(/,\s/g, ',<br>')) !== null && _c !== void 0 ? _c : '';
  }
  get commission() {
    var _a, _b, _c;
    const photographerTotal = Object.values(this.jobData.photographersMap).reduce((sum, p) => {
      var _a;
      sum += (_a = p.commission) !== null && _a !== void 0 ? _a : 0;
      return sum;
    }, 0);
    const mod = (_a = this.jobData.accountCommissionMod) !== null && _a !== void 0 ? _a : 0;
    const web = (_b = this.jobData.accountCommissionWeb) !== null && _b !== void 0 ? _b : 0;
    const accountHolder = (_c = this.jobData.account.holder.commission) !== null && _c !== void 0 ? _c : 0;
    const total = photographerTotal + accountHolder;
    return {
      mod,
      web,
      accountHolder,
      total
    };
  }
  // Optional Chaining and Nullish coalescing operators (?. ??) are only support in Vue 3 templates.
  get jobAccountContactCustom() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
      name: (_c = (_b = (_a = this.jobData.account) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '',
      phone: (_f = (_e = (_d = this.jobData.account) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.phone) !== null && _f !== void 0 ? _f : '',
      email: (_j = (_h = (_g = this.jobData.account) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.email) !== null && _j !== void 0 ? _j : ''
    };
  }
  get isDataLinked() {
    return booleanToYesNo(this.jobData.isDataLinked);
  }
  get isOutOfHours() {
    return booleanToYesNo(this.jobData.outOfHours);
  }
  get takeDate() {
    return format(this.jobData.takeDate, dateFormat);
  }
  get committedDate() {
    var _a;
    return this.formatDate((_a = this.jobData.committedToLabUnixTimestamp) !== null && _a !== void 0 ? _a : 0);
  }
  get aimsAddedDate() {
    var _a;
    return this.formatDate((_a = this.jobData.aimsNumAddedUnixTimestamp) !== null && _a !== void 0 ? _a : 0);
  }
  get barcodeValue() {
    var _a;
    const aimsJobNumber = (_a = this.jobData.aimsJobNumber) !== null && _a !== void 0 ? _a : '';
    return aimsJobNumber.length > 0 ? `${this.jobData.account.code}-${aimsJobNumber}` : this.jobData.account.code;
  }
  formatDate(dateTimestamp) {
    return dateTimestamp > 0 ? format(fromUnixTime(dateTimestamp), dateFormat) : 'None Set';
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], Worksheetvue_type_script_lang_ts_default_1.prototype, "jobData", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], Worksheetvue_type_script_lang_ts_default_1.prototype, "account", void 0);
Worksheetvue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'Worksheet',
  components: {
    barcode: vue_barcode_default.a
  }
})], Worksheetvue_type_script_lang_ts_default_1);
/* harmony default export */ var Worksheetvue_type_script_lang_ts = (Worksheetvue_type_script_lang_ts_default_1);
function booleanToYesNo(value) {
  return (value !== null && value !== void 0 ? value : false) ? 'Yes' : 'No';
}
// CONCATENATED MODULE: ./src/components/Worksheet.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_Worksheetvue_type_script_lang_ts = (Worksheetvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/Worksheet.vue?vue&type=style&index=0&id=4d0ef3ae&prod&lang=stylus&scoped=true
var Worksheetvue_type_style_index_0_id_4d0ef3ae_prod_lang_stylus_scoped_true = __webpack_require__("e230");

// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QList.js
var QList = __webpack_require__("c588");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItem.js
var QItem = __webpack_require__("7e6f");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItemSection.js
var QItemSection = __webpack_require__("0aaf");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItemLabel.js
var QItemLabel = __webpack_require__("be86");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/separator/QSeparator.js
var QSeparator = __webpack_require__("6485");

// EXTERNAL MODULE: /workspace/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js
var runtime_auto_import = __webpack_require__("d447");
var runtime_auto_import_default = /*#__PURE__*/__webpack_require__.n(runtime_auto_import);

// CONCATENATED MODULE: ./src/components/Worksheet.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_Worksheetvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ef3ae",
  null
  
)

/* harmony default export */ var Worksheet = __webpack_exports__["a"] = (component.exports);






runtime_auto_import_default()(component, 'components', {QList: QList["a" /* default */],QItem: QItem["a" /* default */],QItemSection: QItemSection["a" /* default */],QItemLabel: QItemLabel["a" /* default */],QSeparator: QSeparator["a" /* default */]});


/***/ }),

/***/ "8310":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export features */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enableFeatures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFeatureEnabled; });
const features = ['SPLIT_JOB'];
const enabledFeatures = new Set();
function enableFeatures(...feature) {
  feature.forEach(x => enabledFeatures.add(x));
}
function isFeatureEnabled(feature) {
  return enabledFeatures.has(feature);
}

/***/ }),

/***/ "8367":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("559c");

var _encoder = __webpack_require__("b720");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_5#Encoding

var checksum = function checksum(data) {
	var result = data.split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 9 : sum + a * 3;
	}, 0);
	return result % 10;
};

var EAN5 = function (_Barcode) {
	_inherits(EAN5, _Barcode);

	function EAN5(data, options) {
		_classCallCheck(this, EAN5);

		return _possibleConstructorReturn(this, (EAN5.__proto__ || Object.getPrototypeOf(EAN5)).call(this, data, options));
	}

	_createClass(EAN5, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{5}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var structure = _constants.EAN5_STRUCTURE[checksum(this.data)];
			return {
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN5;
}(_Barcode3.default);

exports.default = EAN5;

/***/ }),

/***/ "87f7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__("2c64");

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__("f120");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128B = function (_CODE) {
	_inherits(CODE128B, _CODE);

	function CODE128B(string, options) {
		_classCallCheck(this, CODE128B);

		return _possibleConstructorReturn(this, (CODE128B.__proto__ || Object.getPrototypeOf(CODE128B)).call(this, _constants.B_START_CHAR + string, options));
	}

	_createClass(CODE128B, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.B_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128B;
}(_CODE3.default);

exports.default = CODE128B;

/***/ }),

/***/ "8862":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ImageControl.vue?vue&type=template&id=1311674c&scoped=true&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "div"
  }, [_vm.showMore || _vm.showControls ? _c('div', {
    staticClass: "absolute-top-right",
    staticStyle: {
      "z-index": "100"
    }
  }, [_c('q-btn', {
    attrs: {
      "round": "",
      "dense": "",
      "color": "primary",
      "icon": "mdi-dots-horizontal"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.showMore = !_vm.showMore;
      }
    }
  }), _c('q-menu', {
    model: {
      value: _vm.showMore,
      callback: function ($$v) {
        _vm.showMore = $$v;
      },
      expression: "showMore"
    }
  }, [_c('q-list', _vm._l(_vm.actions, function (action) {
    return _c('q-item', {
      directives: [{
        name: "close-popup",
        rawName: "v-close-popup"
      }],
      key: action.label,
      attrs: {
        "clickable": ""
      },
      on: {
        "click": () => action.fn()
      }
    }, [_c('q-item-section', [_vm._v(_vm._s(action.label))])], 1);
  }), 1)], 1)], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showControls,
      expression: "showControls"
    }],
    staticClass: "absolute-bottom-right q-pb-xs",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('q-btn', {
    attrs: {
      "round": "",
      "dense": "",
      "color": "primary",
      "icon": _vm.zoomIcon
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.zoom();
      }
    }
  })], 1), _c('div', {
    staticClass: "absolute-top row",
    staticStyle: {
      "grid-column-start": "2",
      "grid-row-start": "2"
    }
  }, [_vm.iconName ? _c('q-icon', {
    staticClass: "bg-white rounded",
    attrs: {
      "name": _vm.iconName,
      "color": "black",
      "size": "md"
    }
  }) : _vm._e(), _vm.isCP ? _c('q-icon', {
    staticClass: "bg-warning rounded",
    attrs: {
      "outlined": "",
      "name": "mdi-shield-account",
      "size": "md"
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/ImageControl.vue?vue&type=template&id=1311674c&scoped=true&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: ./src/imageStore.ts
var imageStore = __webpack_require__("818c");

// EXTERNAL MODULE: external "@ht-lib/accounts-models"
var accounts_models_ = __webpack_require__("406b");

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/DuplicateImageToClassesDialog.vue?vue&type=template&id=421244ca&lang=pug
var DuplicateImageToClassesDialogvue_type_template_id_421244ca_lang_pug_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('q-dialog', {
    ref: "dialog",
    on: {
      "show": _vm.onShow,
      "hide": _vm.onHide
    }
  }, [_c('q-card', {
    staticStyle: {
      "min-width": "450px"
    }
  }, [_c('q-card-section', {
    staticClass: "row items-center bg-blue-grey-1"
  }, [_c('div', {
    staticClass: "text-h6"
  }, [_vm._v("Select the classes to duplicate to.")]), _c('q-space'), _c('q-btn', {
    attrs: {
      "icon": "close",
      "dense": "",
      "flat": "",
      "round": ""
    },
    on: {
      "click": _vm.hide
    }
  })], 1), _c('q-card-section', {
    staticClass: "column q-gutter-md"
  }, [_c('q-list', _vm._l(_vm.checklist, function (item) {
    return _c('q-item', {
      key: item.className
    }, [_c('q-item-section', {
      attrs: {
        "side": "",
        "top": ""
      }
    }, [_c('q-checkbox', {
      staticClass: "text-h6",
      attrs: {
        "disable": item.disabled,
        "label": item.className
      },
      model: {
        value: item.selected,
        callback: function ($$v) {
          _vm.$set(item, "selected", $$v);
        },
        expression: "item.selected"
      }
    })], 1)], 1);
  }), 1)], 1), _c('q-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('q-btn', {
    attrs: {
      "label": "Cancel",
      "color": "red"
    },
    on: {
      "click": _vm.hide
    }
  }), _c('q-btn', {
    attrs: {
      "label": "Save",
      "color": "green",
      "disabled": _vm.noItemsSelected
    },
    on: {
      "click": _vm.onConfirmClick
    }
  })], 1)], 1)], 1);
};
var DuplicateImageToClassesDialogvue_type_template_id_421244ca_lang_pug_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/DuplicateImageToClassesDialog.vue?vue&type=template&id=421244ca&lang=pug

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/DuplicateImageToClassesDialog.vue?vue&type=script&lang=ts


/* harmony default export */ var DuplicateImageToClassesDialogvue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'DuplicateImageToClassesDialog',
  props: {
    longRef: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      checklist: [],
      classNames: [],
      image: undefined
    };
  },
  computed: {
    noItemsSelected() {
      return !this.checklist.some(x => x.selected);
    }
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onShow() {
      this.populate();
    },
    populate() {
      this.image = imageStore["a" /* ImageStore */].Instance.images[this.longRef];
      this.classNames = imageStore["a" /* ImageStore */].Instance.classNames('').sort();
      this.checklist = this.classNames.map(x => {
        var _a;
        return {
          disabled: ((_a = this.image) === null || _a === void 0 ? void 0 : _a.className) === x,
          selected: false,
          className: x
        };
      });
    },
    onHide() {
      this.$emit('hide');
    },
    async onConfirmClick() {
      const classNames = this.checklist.filter(x => x.selected).map(x => x.className);
      await imageStore["a" /* ImageStore */].Instance.duplicateImageToClasses(this.longRef, classNames);
      this.hide();
    }
  }
}));
// CONCATENATED MODULE: ./src/components/DuplicateImageToClassesDialog.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_DuplicateImageToClassesDialogvue_type_script_lang_ts = (DuplicateImageToClassesDialogvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/dialog/QDialog.js
var QDialog = __webpack_require__("66e6");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCard.js
var QCard = __webpack_require__("6ca9");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCardSection.js
var QCardSection = __webpack_require__("7efe");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/space/QSpace.js
var QSpace = __webpack_require__("f63b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/btn/QBtn.js
var QBtn = __webpack_require__("b20c");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QList.js
var QList = __webpack_require__("c588");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItem.js
var QItem = __webpack_require__("7e6f");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItemSection.js
var QItemSection = __webpack_require__("0aaf");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/checkbox/QCheckbox.js
var QCheckbox = __webpack_require__("1919");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCardActions.js
var QCardActions = __webpack_require__("15cd");

// EXTERNAL MODULE: /workspace/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js
var runtime_auto_import = __webpack_require__("d447");
var runtime_auto_import_default = /*#__PURE__*/__webpack_require__.n(runtime_auto_import);

// CONCATENATED MODULE: ./src/components/DuplicateImageToClassesDialog.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_DuplicateImageToClassesDialogvue_type_script_lang_ts,
  DuplicateImageToClassesDialogvue_type_template_id_421244ca_lang_pug_render,
  DuplicateImageToClassesDialogvue_type_template_id_421244ca_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DuplicateImageToClassesDialog = (component.exports);











runtime_auto_import_default()(component, 'components', {QDialog: QDialog["a" /* default */],QCard: QCard["a" /* default */],QCardSection: QCardSection["a" /* default */],QSpace: QSpace["a" /* default */],QBtn: QBtn["a" /* default */],QList: QList["a" /* default */],QItem: QItem["a" /* default */],QItemSection: QItemSection["a" /* default */],QCheckbox: QCheckbox["a" /* default */],QCardActions: QCardActions["a" /* default */]});

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ImageControl.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let ImageControlvue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  constructor() {
    super(...arguments);
    this.showMore = false;
  }
  zoom() {
    return this.isZoom ? null : this.image.longRef;
  }
  get zoomIcon() {
    return this.isZoom ? 'mdi-minus' : 'mdi-magnify';
  }
  get iconName() {
    return Object(imageStore["b" /* getIcon */])(this.image.status);
  }
  get actions() {
    return [this.groupImageAction, this.cpAction, this.flagAction, this.duplicateAction, this.rejectAction, this.clearAction].filter(x => x.show);
  }
  get isCP() {
    return this.image.childProtectionIssue;
  }
  get groupImageAction() {
    return {
      label: 'Assign to Class',
      show: this.image.shotTypeId === 2 && this.allowGroupImageAssignment,
      fn: this.groupImage
    };
  }
  get cpAction() {
    return {
      label: this.image.childProtectionIssue ? 'No CP Issue' : 'CP Issue',
      show: true,
      fn: this.toggleCP
    };
  }
  get flagAction() {
    return {
      label: this.image.status !== accounts_models_["ImageStatus"].FLAGGED ? this.isLabQC ? 'Flag For Edit' : 'Flag for Analysis' : 'Unflag',
      show: true,
      fn: this.toggleFlag
    };
  }
  get duplicateAction() {
    return {
      label: 'Duplicate',
      show: this.allowDuplicatingImage && !this.image.childProtectionIssue,
      fn: () => this.showDuplicate()
    };
  }
  get rejectAction() {
    return {
      label: this.image.status !== accounts_models_["ImageStatus"].REJECTED ? 'Reject' : 'Unreject',
      show: true,
      fn: this.toggleReject
    };
  }
  get clearAction() {
    return {
      label: 'Clear',
      show: true,
      fn: this.reset
    };
  }
  get showIcon() {
    return this.iconName !== '' && !this.showControls;
  }
  reset() {
    imageStore["a" /* ImageStore */].Instance.updateCP(this.image.longRef, false);
    imageStore["a" /* ImageStore */].Instance.updateStatus(this.image.longRef, accounts_models_["ImageStatus"].NONE);
  }
  groupImage() {
    return this.image.longRef;
  }
  toggleCP() {
    imageStore["a" /* ImageStore */].Instance.updateCP(this.image.longRef, !this.image.childProtectionIssue);
  }
  showDuplicate() {
    this.$q.dialog({
      component: DuplicateImageToClassesDialog,
      parent: this,
      longRef: this.image.longRef
    });
  }
  toggleReject() {
    const newStatus = this.image.status === accounts_models_["ImageStatus"].REJECTED ? accounts_models_["ImageStatus"].NONE : accounts_models_["ImageStatus"].REJECTED;
    imageStore["a" /* ImageStore */].Instance.updateStatus(this.image.longRef, newStatus);
  }
  toggleFlag() {
    const newStatus = this.image.status === accounts_models_["ImageStatus"].FLAGGED ? accounts_models_["ImageStatus"].NONE : accounts_models_["ImageStatus"].FLAGGED;
    imageStore["a" /* ImageStore */].Instance.updateStatus(this.image.longRef, newStatus);
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ImageControlvue_type_script_lang_ts_default_1.prototype, "image", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ImageControlvue_type_script_lang_ts_default_1.prototype, "showControls", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: false,
  default: false
})], ImageControlvue_type_script_lang_ts_default_1.prototype, "isZoom", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ImageControlvue_type_script_lang_ts_default_1.prototype, "showSelected", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ImageControlvue_type_script_lang_ts_default_1.prototype, "isLabQC", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ImageControlvue_type_script_lang_ts_default_1.prototype, "allowGroupImageAssignment", void 0);
__decorate([Object(external_vue_property_decorator_["Inject"])({
  from: 'allow-duplicate-image',
  default: false
})], ImageControlvue_type_script_lang_ts_default_1.prototype, "allowDuplicatingImage", void 0);
__decorate([Object(external_vue_property_decorator_["Emit"])('zoom')], ImageControlvue_type_script_lang_ts_default_1.prototype, "zoom", null);
__decorate([Object(external_vue_property_decorator_["Emit"])('assign-group-to-class')], ImageControlvue_type_script_lang_ts_default_1.prototype, "groupImage", null);
ImageControlvue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'ImageControl'
})], ImageControlvue_type_script_lang_ts_default_1);
/* harmony default export */ var ImageControlvue_type_script_lang_ts = (ImageControlvue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/ImageControl.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_ImageControlvue_type_script_lang_ts = (ImageControlvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/ImageControl.vue?vue&type=style&index=0&id=1311674c&prod&lang=stylus&scoped=true
var ImageControlvue_type_style_index_0_id_1311674c_prod_lang_stylus_scoped_true = __webpack_require__("0ea9");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/menu/QMenu.js + 2 modules
var QMenu = __webpack_require__("b7fa");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/icon/QIcon.js
var QIcon = __webpack_require__("a170");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/directives/ClosePopup.js
var ClosePopup = __webpack_require__("e106");

// CONCATENATED MODULE: ./src/components/ImageControl.vue






/* normalize component */

var ImageControl_component = Object(componentNormalizer["a" /* default */])(
  components_ImageControlvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "1311674c",
  null
  
)

/* harmony default export */ var ImageControl = __webpack_exports__["a"] = (ImageControl_component.exports);







runtime_auto_import_default()(ImageControl_component, 'components', {QBtn: QBtn["a" /* default */],QMenu: QMenu["a" /* default */],QList: QList["a" /* default */],QItem: QItem["a" /* default */],QItemSection: QItemSection["a" /* default */],QIcon: QIcon["a" /* default */]});runtime_auto_import_default()(ImageControl_component, 'directives', {ClosePopup: ClosePopup["a" /* default */]});


/***/ }),

/***/ "88a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _spinner_mixin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ab6b");


/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QSpinner',
  mixins: [_spinner_mixin_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    thickness: {
      type: Number,
      default: 5
    }
  },
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner q-spinner-mat',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '25 25 50 50'
      }
    }, [h('circle', {
      staticClass: 'path',
      attrs: {
        'cx': '50',
        'cy': '50',
        'r': '20',
        'fill': 'none',
        'stroke': 'currentColor',
        'stroke-width': this.thickness,
        'stroke-miterlimit': '10'
      }
    })]);
  }
}));

/***/ }),

/***/ "89ad":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNa.3e1afe59.woff";

/***/ }),

/***/ "8ab9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pharmacode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf

var pharmacode = function (_Barcode) {
	_inherits(pharmacode, _Barcode);

	function pharmacode(data, options) {
		_classCallCheck(this, pharmacode);

		var _this = _possibleConstructorReturn(this, (pharmacode.__proto__ || Object.getPrototypeOf(pharmacode)).call(this, data, options));

		_this.number = parseInt(data, 10);
		return _this;
	}

	_createClass(pharmacode, [{
		key: "encode",
		value: function encode() {
			var z = this.number;
			var result = "";

			// http://i.imgur.com/RMm4UDJ.png
			// (source: http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf, page: 34)
			while (!isNaN(z) && z != 0) {
				if (z % 2 === 0) {
					// Even
					result = "11100" + result;
					z = (z - 2) / 2;
				} else {
					// Odd
					result = "100" + result;
					z = (z - 1) / 2;
				}
			}

			// Remove the two last zeroes
			result = result.slice(0, -2);

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.number >= 3 && this.number <= 131070;
		}
	}]);

	return pharmacode;
}(_Barcode3.default);

exports.pharmacode = pharmacode;

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "90fa":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("de60");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("b6c3e4c4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9438":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "95c4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// https://en.wikipedia.org/wiki/MSI_Barcode#Character_set_and_binary_lookup

var MSI = function (_Barcode) {
	_inherits(MSI, _Barcode);

	function MSI(data, options) {
		_classCallCheck(this, MSI);

		return _possibleConstructorReturn(this, (MSI.__proto__ || Object.getPrototypeOf(MSI)).call(this, data, options));
	}

	_createClass(MSI, [{
		key: "encode",
		value: function encode() {
			// Start bits
			var ret = "110";

			for (var i = 0; i < this.data.length; i++) {
				// Convert the character to binary (always 4 binary digits)
				var digit = parseInt(this.data[i]);
				var bin = digit.toString(2);
				bin = addZeroes(bin, 4 - bin.length);

				// Add 100 for every zero and 110 for every 1
				for (var b = 0; b < bin.length; b++) {
					ret += bin[b] == "0" ? "100" : "110";
				}
			}

			// End bits
			ret += "1001";

			return {
				data: ret,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]+$/) !== -1;
		}
	}]);

	return MSI;
}(_Barcode3.default);

function addZeroes(number, n) {
	for (var i = 0; i < n; i++) {
		number = "0" + number;
	}
	return number;
}

exports.default = MSI;

/***/ }),

/***/ "95c8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.checksum = checksum;

var _encoder = __webpack_require__("b720");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding

var UPC = function (_Barcode) {
	_inherits(UPC, _Barcode);

	function UPC(data, options) {
		_classCallCheck(this, UPC);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{11}$/) !== -1) {
			data += checksum(data);
		}

		var _this = _possibleConstructorReturn(this, (UPC.__proto__ || Object.getPrototypeOf(UPC)).call(this, data, options));

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPC, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
		}
	}, {
		key: "encode",
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: "flatEncoding",
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += (0, _encoder2.default)(this.data.substr(0, 6), "LLLLLL");
			result += "01010";
			result += (0, _encoder2.default)(this.data.substr(6, 6), "RRRRRR");
			result += "101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "guardedEncoding",
		value: function guardedEncoding() {
			var result = [];

			// Add the first digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(0, 1),
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101" + (0, _encoder2.default)(this.data[0], "L"),
				options: { height: this.guardHeight }
			});

			// Add the left side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(1, 5), "LLLLL"),
				text: this.text.substr(1, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the middle bits
			result.push({
				data: "01010",
				options: { height: this.guardHeight }
			});

			// Add the right side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(6, 5), "RRRRR"),
				text: this.text.substr(6, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: (0, _encoder2.default)(this.data[11], "R") + "101",
				options: { height: this.guardHeight }
			});

			// Add the last digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(11, 1),
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}]);

	return UPC;
}(_Barcode3.default);

// Calulate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit


function checksum(number) {
	var result = 0;

	var i;
	for (i = 1; i < 11; i += 2) {
		result += parseInt(number[i]);
	}
	for (i = 0; i < 11; i += 2) {
		result += parseInt(number[i]) * 3;
	}

	return (10 - result % 10) % 10;
}

exports.default = UPC;

/***/ }),

/***/ "982d":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__982d__;

/***/ }),

/***/ "995f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _barcodes = __webpack_require__("e278");

var _barcodes2 = _interopRequireDefault(_barcodes);

var _merge = __webpack_require__("e795");

var _merge2 = _interopRequireDefault(_merge);

var _linearizeEncodings = __webpack_require__("cfbe");

var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);

var _fixOptions = __webpack_require__("f445");

var _fixOptions2 = _interopRequireDefault(_fixOptions);

var _getRenderProperties = __webpack_require__("597b");

var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);

var _optionsFromStrings = __webpack_require__("6c52");

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _ErrorHandler = __webpack_require__("2f8e");

var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);

var _exceptions = __webpack_require__("0c9a");

var _defaults = __webpack_require__("33a1");

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The protype of the object returned from the JsBarcode() call


// Help functions
var API = function API() {};

// The first call of the library API
// Will return an object with all barcodes calls and the data that is used
// by the renderers


// Default values


// Exceptions
// Import all the barcodes
var JsBarcode = function JsBarcode(element, text, options) {
	var api = new API();

	if (typeof element === "undefined") {
		throw Error("No element to render on was provided.");
	}

	// Variables that will be pased through the API calls
	api._renderProperties = (0, _getRenderProperties2.default)(element);
	api._encodings = [];
	api._options = _defaults2.default;
	api._errorHandler = new _ErrorHandler2.default(api);

	// If text is set, use the simple syntax (render the barcode directly)
	if (typeof text !== "undefined") {
		options = options || {};

		if (!options.format) {
			options.format = autoSelectBarcode();
		}

		api.options(options)[options.format](text, options).render();
	}

	return api;
};

// To make tests work TODO: remove
JsBarcode.getModule = function (name) {
	return _barcodes2.default[name];
};

// Register all barcodes
for (var name in _barcodes2.default) {
	if (_barcodes2.default.hasOwnProperty(name)) {
		// Security check if the propery is a prototype property
		registerBarcode(_barcodes2.default, name);
	}
}
function registerBarcode(barcodes, name) {
	API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function (text, options) {
		var api = this;
		return api._errorHandler.wrapBarcodeCall(function () {
			// Ensure text is options.text
			options.text = typeof options.text === 'undefined' ? undefined : '' + options.text;

			var newOptions = (0, _merge2.default)(api._options, options);
			newOptions = (0, _optionsFromStrings2.default)(newOptions);
			var Encoder = barcodes[name];
			var encoded = encode(text, Encoder, newOptions);
			api._encodings.push(encoded);

			return api;
		});
	};
}

// encode() handles the Encoder call and builds the binary string to be rendered
function encode(text, Encoder, options) {
	// Ensure that text is a string
	text = "" + text;

	var encoder = new Encoder(text, options);

	// If the input is not valid for the encoder, throw error.
	// If the valid callback option is set, call it instead of throwing error
	if (!encoder.valid()) {
		throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
	}

	// Make a request for the binary data (and other infromation) that should be rendered
	var encoded = encoder.encode();

	// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
	// Convert to [1-1, 1-2, 2, 3-1, 3-2]
	encoded = (0, _linearizeEncodings2.default)(encoded);

	// Merge
	for (var i = 0; i < encoded.length; i++) {
		encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
	}

	return encoded;
}

function autoSelectBarcode() {
	// If CODE128 exists. Use it
	if (_barcodes2.default["CODE128"]) {
		return "CODE128";
	}

	// Else, take the first (probably only) barcode
	return Object.keys(_barcodes2.default)[0];
}

// Sets global encoder options
// Added to the api by the JsBarcode function
API.prototype.options = function (options) {
	this._options = (0, _merge2.default)(this._options, options);
	return this;
};

// Will create a blank space (usually in between barcodes)
API.prototype.blank = function (size) {
	var zeroes = new Array(size + 1).join("0");
	this._encodings.push({ data: zeroes });
	return this;
};

// Initialize JsBarcode on all HTML elements defined.
API.prototype.init = function () {
	// Should do nothing if no elements where found
	if (!this._renderProperties) {
		return;
	}

	// Make sure renderProperies is an array
	if (!Array.isArray(this._renderProperties)) {
		this._renderProperties = [this._renderProperties];
	}

	var renderProperty;
	for (var i in this._renderProperties) {
		renderProperty = this._renderProperties[i];
		var options = (0, _merge2.default)(this._options, renderProperty.options);

		if (options.format == "auto") {
			options.format = autoSelectBarcode();
		}

		this._errorHandler.wrapBarcodeCall(function () {
			var text = options.value;
			var Encoder = _barcodes2.default[options.format.toUpperCase()];
			var encoded = encode(text, Encoder, options);

			render(renderProperty, encoded, options);
		});
	}
};

// The render API call. Calls the real render function.
API.prototype.render = function () {
	if (!this._renderProperties) {
		throw new _exceptions.NoElementException();
	}

	if (Array.isArray(this._renderProperties)) {
		for (var i = 0; i < this._renderProperties.length; i++) {
			render(this._renderProperties[i], this._encodings, this._options);
		}
	} else {
		render(this._renderProperties, this._encodings, this._options);
	}

	return this;
};

API.prototype._defaults = _defaults2.default;

// Prepares the encodings and calls the renderer
function render(renderProperties, encodings, options) {
	encodings = (0, _linearizeEncodings2.default)(encodings);

	for (var i = 0; i < encodings.length; i++) {
		encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
		(0, _fixOptions2.default)(encodings[i].options);
	}

	(0, _fixOptions2.default)(options);

	var Renderer = renderProperties.renderer;
	var renderer = new Renderer(renderProperties.element, encodings, options);
	renderer.render();

	if (renderProperties.afterRender) {
		renderProperties.afterRender();
	}
}

// Export to browser
if (typeof window !== "undefined") {
	window.JsBarcode = JsBarcode;
}

// Export to jQuery
/*global jQuery */
if (typeof jQuery !== 'undefined') {
	jQuery.fn.JsBarcode = function (content, options) {
		var elementArray = [];
		jQuery(this).each(function () {
			elementArray.push(this);
		});
		return JsBarcode(elementArray, content, options);
	};
}

// Export to commonJS
module.exports = JsBarcode;

/***/ }),

/***/ "9a9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return preventScroll; });
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a820");
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ad69");



let registered = 0,
  scrollPositionX,
  scrollPositionY,
  maxScrollTop,
  vpPendingUpdate = false,
  bodyLeft,
  bodyTop,
  href,
  closeTimer;
function onWheel(e) {
  if (shouldPreventScroll(e)) {
    Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* stopAndPrevent */ "l"])(e);
  }
}
function shouldPreventScroll(e) {
  if (e.target === document.body || e.target.classList.contains('q-layout__backdrop')) {
    return true;
  }
  const path = Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* getEventPath */ "d"])(e),
    shift = e.shiftKey && !e.deltaX,
    scrollY = !shift && Math.abs(e.deltaX) <= Math.abs(e.deltaY),
    delta = shift || scrollY ? e.deltaY : e.deltaX;
  for (let index = 0; index < path.length; index++) {
    const el = path[index];
    if (Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* hasScrollbar */ "g"])(el, scrollY)) {
      return scrollY ? delta < 0 && el.scrollTop === 0 ? true : delta > 0 && el.scrollTop + el.clientHeight === el.scrollHeight : delta < 0 && el.scrollLeft === 0 ? true : delta > 0 && el.scrollLeft + el.clientWidth === el.scrollWidth;
    }
  }
  return true;
}
function onAppleScroll(e) {
  if (e.target === document) {
    // required, otherwise iOS blocks further scrolling
    // until the mobile scrollbar dissappears
    document.scrollingElement.scrollTop = document.scrollingElement.scrollTop; // eslint-disable-line
  }
}
function onAppleResize(evt) {
  if (vpPendingUpdate === true) {
    return;
  }
  vpPendingUpdate = true;
  requestAnimationFrame(() => {
    vpPendingUpdate = false;
    const {
        height
      } = evt.target,
      {
        clientHeight,
        scrollTop
      } = document.scrollingElement;
    if (maxScrollTop === void 0 || height !== window.innerHeight) {
      maxScrollTop = clientHeight - height;
      document.scrollingElement.scrollTop = scrollTop;
    }
    if (scrollTop > maxScrollTop) {
      document.scrollingElement.scrollTop -= Math.ceil((scrollTop - maxScrollTop) / 8);
    }
  });
}
function apply(action) {
  const body = document.body,
    hasViewport = window.visualViewport !== void 0;
  if (action === 'add') {
    const overflowY = window.getComputedStyle(body).overflowY;
    scrollPositionX = Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* getHorizontalScrollPosition */ "a"])(window);
    scrollPositionY = Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_1__[/* getScrollPosition */ "c"])(window);
    bodyLeft = body.style.left;
    bodyTop = body.style.top;
    href = window.location.href;
    body.style.left = `-${scrollPositionX}px`;
    body.style.top = `-${scrollPositionY}px`;
    if (overflowY !== 'hidden' && (overflowY === 'scroll' || body.scrollHeight > window.innerHeight)) {
      body.classList.add('q-body--force-scrollbar');
    }
    body.classList.add('q-body--prevent-scroll');
    document.qScrollPrevented = true;
    if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_2__[/* client */ "a"].is.ios === true) {
      if (hasViewport === true) {
        window.scrollTo(0, 0);
        window.visualViewport.addEventListener('resize', onAppleResize, _utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* listenOpts */ "f"].passiveCapture);
        window.visualViewport.addEventListener('scroll', onAppleResize, _utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* listenOpts */ "f"].passiveCapture);
        window.scrollTo(0, 0);
      } else {
        window.addEventListener('scroll', onAppleScroll, _utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* listenOpts */ "f"].passiveCapture);
      }
    }
  }
  if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_2__[/* client */ "a"].is.desktop === true && _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_2__[/* client */ "a"].is.mac === true) {
    // ref. https://developers.google.com/web/updates/2017/01/scrolling-intervention
    window[`${action}EventListener`]('wheel', onWheel, _utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* listenOpts */ "f"].notPassive);
  }
  if (action === 'remove') {
    if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_2__[/* client */ "a"].is.ios === true) {
      if (hasViewport === true) {
        window.visualViewport.removeEventListener('resize', onAppleResize, _utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* listenOpts */ "f"].passiveCapture);
        window.visualViewport.removeEventListener('scroll', onAppleResize, _utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* listenOpts */ "f"].passiveCapture);
      } else {
        window.removeEventListener('scroll', onAppleScroll, _utils_event_js__WEBPACK_IMPORTED_MODULE_0__[/* listenOpts */ "f"].passiveCapture);
      }
    }
    body.classList.remove('q-body--prevent-scroll');
    body.classList.remove('q-body--force-scrollbar');
    document.qScrollPrevented = false;
    body.style.left = bodyLeft;
    body.style.top = bodyTop;

    // scroll back only if route has not changed
    if (window.location.href === href) {
      window.scrollTo(scrollPositionX, scrollPositionY);
    }
    maxScrollTop = void 0;
  }
}
function preventScroll(state) {
  let action = 'add';
  if (state === true) {
    registered++;
    if (closeTimer !== void 0) {
      clearTimeout(closeTimer);
      closeTimer = void 0;
      return;
    }
    if (registered > 1) {
      return;
    }
  } else {
    if (registered === 0) {
      return;
    }
    registered--;
    if (registered > 0) {
      return;
    }
    action = 'remove';
    if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_2__[/* client */ "a"].is.ios === true && _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_2__[/* client */ "a"].is.nativeMobile === true) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        apply(action);
        closeTimer = void 0;
      }, 100);
      return;
    }
  }
  apply(action);
}
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    __preventScroll(state) {
      if (state !== this.preventedScroll && (this.preventedScroll !== void 0 || state === true)) {
        this.preventedScroll = state;
        preventScroll(state);
      }
    }
  }
});

/***/ }),

/***/ "9cfc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2b6e");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("623282e1", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9da5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b0a1");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("98316d44", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a031":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _constants = __webpack_require__("559c");

var _EAN2 = __webpack_require__("cf51");

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode

// Calculate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
var checksum = function checksum(number) {
	var res = number.substr(0, 12).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 3 : sum + a;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN13 = function (_EAN) {
	_inherits(EAN13, _EAN);

	function EAN13(data, options) {
		_classCallCheck(this, EAN13);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{12}$/) !== -1) {
			data += checksum(data);
		}

		// Adds a last character to the end of the barcode
		var _this = _possibleConstructorReturn(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));

		_this.lastChar = options.lastChar;
		return _this;
	}

	_createClass(EAN13, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftText', this).call(this, 1, 6);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(1, 6);
			var structure = _constants.EAN13_STRUCTURE[this.data[0]];
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftEncode', this).call(this, data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightText', this).call(this, 7, 6);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(7, 6);
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightEncode', this).call(this, data, 'RRRRRR');
		}

		// The "standard" way of printing EAN13 barcodes with guard bars

	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var data = _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'encodeGuarded', this).call(this);

			// Extend data with left digit & last character
			if (this.options.displayValue) {
				data.unshift({
					data: '000000000000',
					text: this.text.substr(0, 1),
					options: { textAlign: 'left', fontSize: this.fontSize }
				});

				if (this.options.lastChar) {
					data.push({
						data: '00'
					});
					data.push({
						data: '00000',
						text: this.options.lastChar,
						options: { fontSize: this.fontSize }
					});
				}
			}

			return data;
		}
	}]);

	return EAN13;
}(_EAN3.default);

exports.default = EAN13;

/***/ }),

/***/ "a13c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2b74");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("7974aff8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a142":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/Image.vue?vue&type=template&id=4db7a124&scoped=true&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "relative-position",
    style: _vm.imageSizeStyle
  }, [_vm.onScreen ? _c('div', {
    staticClass: "qc-image-container",
    class: _vm.imgContainerClass,
    on: {
      "mouseover": function ($event) {
        _vm.hover = true;
      },
      "mouseleave": function ($event) {
        _vm.hover = false;
      },
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelected.apply(null, arguments);
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loaded,
      expression: "!loaded"
    }],
    staticClass: "absolute-top column justify-center items-center fit text-center text-subtitle2 q-px-sm"
  }, [_vm._v(_vm._s(_vm.imageDivText))]), typeof _vm.image.url === 'string' && _vm.image.url.length > 0 ? [_c('img', {
    staticClass: "qc-image",
    attrs: {
      "draggable": "false",
      "src": _vm.image.url
    },
    on: {
      "~load": function ($event) {
        return _vm.onLoad.apply(null, arguments);
      }
    }
  }), _c('image-control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loaded,
      expression: "loaded"
    }],
    attrs: {
      "showSelected": "",
      "image": _vm.image,
      "isLabQC": _vm.isLabQC,
      "showControls": _vm.hover,
      "allow-group-image-assignment": _vm.allowGroupImageAssignment
    },
    on: {
      "zoom": function ($event) {
        return _vm.$emit('update-zoom-id', $event);
      },
      "assign-group-to-class": function ($event) {
        return _vm.$emit('assign-group-to-class', $event);
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBottomBar,
      expression: "showBottomBar"
    }],
    staticClass: "absolute-bottom overflow bg-grey-10 text-white q-pa-xs q-mx-sm q-mb-xs",
    class: _vm.bottomTextClass
  }, [_vm._v(_vm._s(_vm.bottomText))])] : _vm._e()], 2) : _vm._e()]);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/Image.vue?vue&type=template&id=4db7a124&scoped=true&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: ./src/imageStore.ts
var imageStore = __webpack_require__("818c");

// EXTERNAL MODULE: ./src/components/ImageControl.vue + 9 modules
var ImageControl = __webpack_require__("8862");

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/Image.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let Imagevue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  constructor() {
    super(...arguments);
    this.hover = false;
    this.loaded = false;
    this.width = this.image.shotTypeId === 2 ? 187 : 120;
    this.height = 150;
  }
  get imageSizeStyle() {
    return `width: ${this.width}px !important; height: ${this.height}px`;
  }
  get isSelected() {
    return imageStore["a" /* ImageStore */].Instance.isSelected(this.image.longRef);
  }
  get imgContainerClass() {
    if (!this.loaded) return 'loading';
    if (this.isSelected) return 'selected-image';
    if (this.image.isPreferred) return 'preferred-image';
    return '';
  }
  get imageDivText() {
    if (this.image.uploaded || this.image.loading) {
      return 'Loading...';
    } else if (imageStore["a" /* ImageStore */].Instance.isUploading) {
      return 'Uploading...';
    }
    return 'This image has not been uploaded';
  }
  get showBottomBar() {
    return (this.imageOptions.showRef || this.imageOptions.showLinking) && this.bottomText !== '';
  }
  get bottomTextBothShowing() {
    return this.imageOptions.showRef && this.imageOptions.showLinking;
  }
  get bottomTextClass() {
    return this.bottomTextBothShowing ? 'bottom-text-small' : 'text-subtitle2';
  }
  get bottomText() {
    var _a;
    if (this.bottomTextBothShowing) return `${this.image.ref}: ${(_a = this.image.pupilId) !== null && _a !== void 0 ? _a : ''}`;else if (this.imageOptions.showRef) return this.image.ref;else if (this.imageOptions.showLinking && typeof this.image.pupilId === 'string') return this.image.pupilId;else return '';
  }
  toggleSelected() {
    imageStore["a" /* ImageStore */].Instance.toggleSelected(this.image.longRef);
  }
  onLoad(event) {
    if (this.loaded) return;
    this.width = event.target.width;
    this.height = event.target.height;
    this.loaded = true;
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], Imagevue_type_script_lang_ts_default_1.prototype, "image", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], Imagevue_type_script_lang_ts_default_1.prototype, "imageOptions", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], Imagevue_type_script_lang_ts_default_1.prototype, "isLabQC", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], Imagevue_type_script_lang_ts_default_1.prototype, "allowGroupImageAssignment", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: true
})], Imagevue_type_script_lang_ts_default_1.prototype, "onScreen", void 0);
Imagevue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'ImageComp',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  components: {
    ImageControl: ImageControl["a" /* default */]
  }
})], Imagevue_type_script_lang_ts_default_1);
/* harmony default export */ var Imagevue_type_script_lang_ts = (Imagevue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/Image.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_Imagevue_type_script_lang_ts = (Imagevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/Image.vue?vue&type=style&index=0&id=4db7a124&prod&lang=stylus&scoped=true
var Imagevue_type_style_index_0_id_4db7a124_prod_lang_stylus_scoped_true = __webpack_require__("e599");

// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// CONCATENATED MODULE: ./src/components/Image.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_Imagevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "4db7a124",
  null
  
)

/* harmony default export */ var Image = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "a170":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_size_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4ef2");
/* harmony import */ var _mixins_tag_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4025");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("feae");





const defaultViewBox = '0 0 24 24';
const sameFn = i => i;
const ionFn = i => `ionicons ${i}`;
const libMap = {
  'mdi-': i => `mdi ${i}`,
  'icon-': sameFn,
  // fontawesome equiv
  'bt-': i => `bt ${i}`,
  'eva-': i => `eva ${i}`,
  'ion-md': ionFn,
  'ion-ios': ionFn,
  'ion-logo': ionFn,
  'iconfont ': sameFn,
  'ti-': i => `themify-icon ${i}`,
  'bi-': i => `bootstrap-icons ${i}`
};
const matMap = {
  o_: '-outlined',
  r_: '-round',
  s_: '-sharp'
};
const symMap = {
  sym_o_: '-outlined',
  sym_r_: '-rounded',
  sym_s_: '-sharp'
};
const libRE = new RegExp('^(' + Object.keys(libMap).join('|') + ')');
const matRE = new RegExp('^(' + Object.keys(matMap).join('|') + ')');
const symRE = new RegExp('^(' + Object.keys(symMap).join('|') + ')');
const mRE = /^[Mm]\s?[-+]?\.?\d/;
const imgRE = /^img:/;
const svgUseRE = /^svguse:/;
const ionRE = /^ion-/;
const faRE = /^(fa-(sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QIcon',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_size_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_tag_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]],
  props: {
    tag: {
      type: String,
      default: 'i'
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  computed: {
    classes() {
      return 'q-icon' + (this.left === true ? ' on-left' : '') + (this.right === true ? ' on-right' : '') + (this.color !== void 0 ? ` text-${this.color}` : '');
    },
    type() {
      let cls;
      let icon = this.name;
      if (icon === 'none' || !icon) {
        return {
          none: true
        };
      }
      if (this.$q.iconMapFn !== void 0) {
        const res = this.$q.iconMapFn(icon);
        if (res !== void 0) {
          if (res.icon !== void 0) {
            icon = res.icon;
            if (icon === 'none' || !icon) {
              return {
                none: true
              };
            }
          } else {
            return {
              cls: res.cls,
              content: res.content !== void 0 ? res.content : ' '
            };
          }
        }
      }
      if (mRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split('|');
        return {
          svg: true,
          viewBox,
          nodes: def.split('&&').map(path => {
            const [d, style, transform] = path.split('@@');
            return this.$createElement('path', {
              attrs: {
                d,
                transform
              },
              style
            });
          })
        };
      }
      if (imgRE.test(icon) === true) {
        return {
          img: true,
          src: icon.substring(4)
        };
      }
      if (svgUseRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split('|');
        return {
          svguse: true,
          src: def.substring(7),
          viewBox
        };
      }
      let content = ' ';
      const matches = icon.match(libRE);
      if (matches !== null) {
        cls = libMap[matches[1]](icon);
      } else if (faRE.test(icon) === true) {
        cls = icon;
      } else if (ionRE.test(icon) === true) {
        cls = `ionicons ion-${this.$q.platform.is.ios === true ? 'ios' : 'md'}${icon.substr(3)}`;
      } else if (symRE.test(icon) === true) {
        // "notranslate" class is for Google Translate
        // to avoid tampering with Material Symbols ligature font
        //
        // Caution: To be able to add suffix to the class name,
        // keep the 'material-symbols' at the end of the string.
        cls = 'notranslate material-symbols';
        const matches = icon.match(symRE);
        if (matches !== null) {
          icon = icon.substring(6);
          cls += symMap[matches[1]];
        }
        content = icon;
      } else {
        // "notranslate" class is for Google Translate
        // to avoid tampering with Material Icons ligature font
        //
        // Caution: To be able to add suffix to the class name,
        // keep the 'material-icons' at the end of the string.
        cls = 'notranslate material-icons';
        const matches = icon.match(matRE);
        if (matches !== null) {
          icon = icon.substring(2);
          cls += matMap[matches[1]];
        }
        content = icon;
      }
      return {
        cls,
        content
      };
    }
  },
  render(h) {
    const data = {
      class: this.classes,
      style: this.sizeStyle,
      on: {
        ...this.qListeners
      },
      attrs: {
        'aria-hidden': 'true',
        role: 'presentation'
      }
    };
    if (this.type.none === true) {
      return h(this.tag, data, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__[/* slot */ "c"])(this, 'default'));
    }
    if (this.type.img === true) {
      return h('span', data, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__[/* mergeSlot */ "a"])([h('img', {
        attrs: {
          src: this.type.src
        }
      })], this, 'default'));
    }
    if (this.type.svg === true) {
      return h('span', data, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__[/* mergeSlot */ "a"])([h('svg', {
        attrs: {
          viewBox: this.type.viewBox || '0 0 24 24',
          focusable: 'false' /* needed for IE11 */
        }
      }, this.type.nodes)], this, 'default'));
    }
    if (this.type.svguse === true) {
      return h('span', data, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__[/* mergeSlot */ "a"])([h('svg', {
        attrs: {
          viewBox: this.type.viewBox,
          focusable: 'false' /* needed for IE11 */
        }
      }, [h('use', {
        attrs: {
          'xlink:href': this.type.src
        }
      })])], this, 'default'));
    }
    if (this.type.cls !== void 0) {
      data.class += ' ' + this.type.cls;
    }
    return h(this.tag, data, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__[/* mergeSlot */ "a"])([this.type.content], this, 'default'));
  }
}));

/***/ }),

/***/ "a25e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageBasic_vue_vue_type_style_index_0_id_7b4c9052_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("90fa");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageBasic_vue_vue_type_style_index_0_id_7b4c9052_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageBasic_vue_vue_type_style_index_0_id_7b4c9052_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a439":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileValueMixin; });
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("479b");



function filterFiles(files, rejectedFiles, failedPropValidation, filterFn) {
  const acceptedFiles = [];
  files.forEach(file => {
    if (filterFn(file) === true) {
      acceptedFiles.push(file);
    } else {
      rejectedFiles.push({
        failedPropValidation,
        file
      });
    }
  });
  return acceptedFiles;
}
function stopAndPreventDrag(e) {
  e && e.dataTransfer && (e.dataTransfer.dropEffect = 'copy');
  Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* stopAndPrevent */ "l"])(e);
}
/* harmony default export */ __webpack_exports__["b"] = ({
  props: {
    multiple: Boolean,
    accept: String,
    capture: String,
    maxFileSize: [Number, String],
    maxTotalSize: [Number, String],
    maxFiles: [Number, String],
    filter: Function
  },
  computed: {
    extensions() {
      if (this.accept !== void 0) {
        return this.accept.split(',').map(ext => {
          ext = ext.trim();
          if (ext === '*') {
            // support "*"
            return '*/';
          } else if (ext.endsWith('/*')) {
            // support "image/*" or "*/*"
            ext = ext.slice(0, ext.length - 1);
          }
          return ext.toUpperCase();
        });
      }
    },
    maxFilesNumber() {
      return parseInt(this.maxFiles, 10);
    },
    maxTotalSizeNumber() {
      return parseInt(this.maxTotalSize, 10);
    }
  },
  methods: {
    pickFiles(ev) {
      if (this.editable === true) {
        if (ev !== Object(ev)) {
          ev = {
            target: null
          };
        }
        if (ev.target !== null && ev.target.matches('input[type="file"]') === true) {
          // stop propagation if it's not a real pointer event
          ev.clientX === 0 && ev.clientY === 0 && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* stop */ "k"])(ev);
        } else {
          const input = this.__getFileInput();
          input && input !== ev.target && input.click(ev);
        }
      }
    },
    addFiles(files) {
      if (this.editable && files) {
        this.__addFiles(null, files);
      }
    },
    __processFiles(e, filesToProcess, currentFileList, append) {
      let files = Array.from(filesToProcess || e.target.files);
      const rejectedFiles = [];
      const done = () => {
        if (rejectedFiles.length > 0) {
          this.$emit('rejected', rejectedFiles);
        }
      };

      // filter file types
      if (this.accept !== void 0 && this.extensions.indexOf('*/') === -1) {
        files = filterFiles(files, rejectedFiles, 'accept', file => {
          return this.extensions.some(ext => file.type.toUpperCase().startsWith(ext) || file.name.toUpperCase().endsWith(ext));
        });
        if (files.length === 0) {
          return done();
        }
      }

      // filter max file size
      if (this.maxFileSize !== void 0) {
        const maxFileSize = parseInt(this.maxFileSize, 10);
        files = filterFiles(files, rejectedFiles, 'max-file-size', file => {
          return file.size <= maxFileSize;
        });
        if (files.length === 0) {
          return done();
        }
      }

      // Cordova/iOS allows selecting multiple files even when the
      // multiple attribute is not specified. We also normalize drag'n'dropped
      // files here:
      if (this.multiple !== true && files.length > 0) {
        files = [files[0]];
      }
      files.forEach(file => {
        file.__key = file.webkitRelativePath + file.lastModified + file.name + file.size;
      });
      if (append === true) {
        // Avoid duplicate files
        const filenameMap = currentFileList.map(entry => entry.__key);
        files = filterFiles(files, rejectedFiles, 'duplicate', file => {
          return filenameMap.includes(file.__key) === false;
        });
      }
      if (files.length === 0) {
        return done();
      }
      if (this.maxTotalSize !== void 0) {
        let size = append === true ? currentFileList.reduce((total, file) => total + file.size, 0) : 0;
        files = filterFiles(files, rejectedFiles, 'max-total-size', file => {
          size += file.size;
          return size <= this.maxTotalSizeNumber;
        });
        if (files.length === 0) {
          return done();
        }
      }

      // do we have custom filter function?
      if (typeof this.filter === 'function') {
        const filteredFiles = this.filter(files);
        files = filterFiles(files, rejectedFiles, 'filter', file => {
          return filteredFiles.includes(file);
        });
      }
      if (this.maxFiles !== void 0) {
        let filesNumber = append === true ? currentFileList.length : 0;
        files = filterFiles(files, rejectedFiles, 'max-files', () => {
          filesNumber++;
          return filesNumber <= this.maxFilesNumber;
        });
        if (files.length === 0) {
          return done();
        }
      }
      done();
      if (files.length > 0) {
        return files;
      }
    },
    __onDragOver(e) {
      stopAndPreventDrag(e);
      this.dnd !== true && (this.dnd = true);
    },
    __onDragLeave(e) {
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* stopAndPrevent */ "l"])(e);

      // Safari bug: relatedTarget is null for over 10 years
      // https://bugs.webkit.org/show_bug.cgi?id=66547
      const gone = e.relatedTarget !== null || _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].is.safari !== true ? e.relatedTarget !== this.$refs.dnd : document.elementsFromPoint(e.clientX, e.clientY).includes(this.$refs.dnd) === false;
      gone === true && (this.dnd = false);
    },
    __onDrop(e) {
      stopAndPreventDrag(e);
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        this.__addFiles(null, files);
      }
      this.dnd = false;
    },
    __getDnd(h, type) {
      if (this.dnd === true) {
        return h('div', {
          staticClass: `q-${type}__dnd absolute-full`,
          ref: 'dnd',
          on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(this, 'dnd', {
            dragenter: stopAndPreventDrag,
            dragover: stopAndPreventDrag,
            dragleave: this.__onDragLeave,
            drop: this.__onDrop
          })
        });
      }
    }
  }
});
const FileValueMixin = {
  computed: {
    formDomProps() {
      if (this.type !== 'file') {
        return;
      }
      try {
        const dt = 'DataTransfer' in window ? new DataTransfer() : 'ClipboardEvent' in window ? new ClipboardEvent('').clipboardData : void 0;
        if (Object(this.value) === this.value) {
          ('length' in this.value ? Array.from(this.value) : [this.value]).forEach(file => {
            dt.items.add(file);
          });
        }
        return {
          files: dt.files
        };
      } catch (e) {
        return {
          files: void 0
        };
      }
    }
  }
};

/***/ }),

/***/ "a44c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: /workspace/node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: /workspace/node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "a4ac":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5cf2");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("c767b30a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a50a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("479b");

/* harmony default export */ __webpack_exports__["a"] = (Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_0__[/* getPropCacheMixin */ "c"])('$listeners', 'qListeners'));

/***/ }),

/***/ "a511":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ad69");
/* harmony import */ var _scroll_observer_QScrollObserver_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1496");
/* harmony import */ var _resize_observer_QResizeObserver_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("6e27");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("a50a");
/* harmony import */ var _utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a820");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("feae");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("479b");








/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QLayout',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]],
  provide() {
    return {
      layout: this
    };
  },
  props: {
    container: Boolean,
    view: {
      type: String,
      default: 'hhh lpr fff',
      validator: v => /^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(v.toLowerCase())
    }
  },
  data() {
    return {
      // page related
      height: this.$q.screen.height,
      width: this.container === true ? 0 : this.$q.screen.width,
      // container only prop
      containerHeight: 0,
      scrollbarWidth: _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* onSSR */ "f"] === true ? 0 : Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__[/* getScrollbarWidth */ "e"])(),
      header: {
        size: 0,
        offset: 0,
        space: false
      },
      right: {
        size: 300,
        offset: 0,
        space: false
      },
      footer: {
        size: 0,
        offset: 0,
        space: false
      },
      left: {
        size: 300,
        offset: 0,
        space: false
      },
      scroll: {
        position: 0,
        direction: 'down'
      }
    };
  },
  computed: {
    rows() {
      const rows = this.view.toLowerCase().split(' ');
      return {
        top: rows[0].split(''),
        middle: rows[1].split(''),
        bottom: rows[2].split('')
      };
    },
    style() {
      return this.container === true ? null : {
        minHeight: this.$q.screen.height + 'px'
      };
    },
    // used by container only
    targetStyle() {
      if (this.scrollbarWidth !== 0) {
        return {
          [this.$q.lang.rtl === true ? 'left' : 'right']: `${this.scrollbarWidth}px`
        };
      }
    },
    targetChildStyle() {
      if (this.scrollbarWidth !== 0) {
        return {
          [this.$q.lang.rtl === true ? 'right' : 'left']: 0,
          [this.$q.lang.rtl === true ? 'left' : 'right']: `-${this.scrollbarWidth}px`,
          width: `calc(100% + ${this.scrollbarWidth}px)`
        };
      }
    },
    totalWidth() {
      return this.width + this.scrollbarWidth;
    },
    classes() {
      return 'q-layout q-layout--' + (this.container === true ? 'containerized' : 'standard');
    },
    scrollbarEvtAction() {
      return this.container !== true && this.scrollbarWidth > 0 ? 'add' : 'remove';
    }
  },
  watch: {
    scrollbarEvtAction: '__updateScrollEvent'
  },
  created() {
    this.instances = {};
  },
  mounted() {
    this.scrollbarEvtAction === 'add' && this.__updateScrollEvent('add');
  },
  beforeDestroy() {
    this.scrollbarEvtAction === 'add' && this.__updateScrollEvent('remove');
  },
  render(h) {
    const layout = h('div', {
      class: this.classes,
      style: this.style,
      attrs: {
        tabindex: -1
      },
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_6__[/* mergeSlot */ "a"])([h(_scroll_observer_QScrollObserver_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'scroll', {
        scroll: this.__onPageScroll
      })
    }), h(_resize_observer_QResizeObserver_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'resizeOut', {
        resize: this.__onPageResize
      })
    })], this, 'default'));
    return this.container === true ? h('div', {
      staticClass: 'q-layout-container overflow-hidden'
    }, [h(_resize_observer_QResizeObserver_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(this, 'resizeIn', {
        resize: this.__onContainerResize
      })
    }), h('div', {
      staticClass: 'absolute-full',
      style: this.targetStyle
    }, [h('div', {
      staticClass: 'scroll',
      style: this.targetChildStyle
    }, [layout])])]) : layout;
  },
  methods: {
    __animate() {
      if (this.timer !== void 0) {
        clearTimeout(this.timer);
      } else {
        document.body.classList.add('q-body--layout-animate');
      }
      this.timer = setTimeout(() => {
        document.body.classList.remove('q-body--layout-animate');
        this.timer = void 0;
      }, 150);
    },
    __onPageScroll(data) {
      if (this.container === true || document.qScrollPrevented !== true) {
        this.scroll = data;
      }
      this.qListeners.scroll !== void 0 && this.$emit('scroll', data);
    },
    __onPageResize({
      height,
      width
    }) {
      let resized = false;
      if (this.height !== height) {
        resized = true;
        this.height = height;
        if (this.qListeners['scroll-height'] !== void 0) {
          this.$emit('scroll-height', height);
        }
        this.__updateScrollbarWidth();
      }
      if (this.width !== width) {
        resized = true;
        this.width = width;
      }
      if (resized === true && this.qListeners.resize !== void 0) {
        this.$emit('resize', {
          height,
          width
        });
      }
    },
    __onContainerResize({
      height
    }) {
      if (this.containerHeight !== height) {
        this.containerHeight = height;
        this.__updateScrollbarWidth();
      }
    },
    __updateScrollbarWidth() {
      if (this.container === true) {
        const width = this.height > this.containerHeight ? Object(_utils_scroll_js__WEBPACK_IMPORTED_MODULE_5__[/* getScrollbarWidth */ "e"])() : 0;
        if (this.scrollbarWidth !== width) {
          this.scrollbarWidth = width;
        }
      }
    },
    __updateScrollEvent(action) {
      if (this.timerScrollbar !== void 0 && action === 'remove') {
        clearTimeout(this.timerScrollbar);
        this.__restoreScrollbar();
      }
      window[`${action}EventListener`]('resize', this.__hideScrollbar);
    },
    __hideScrollbar() {
      if (this.timerScrollbar === void 0) {
        const el = document.body;

        // if it has no scrollbar then there's nothing to do
        if (el.scrollHeight > this.$q.screen.height) {
          return;
        }
        el.classList.add('hide-scrollbar');
      } else {
        clearTimeout(this.timerScrollbar);
      }
      this.timerScrollbar = setTimeout(this.__restoreScrollbar, 200);
    },
    __restoreScrollbar() {
      this.timerScrollbar = void 0;
      document.body.classList.remove('hide-scrollbar');
    }
  }
}));

/***/ }),

/***/ "a583":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    isDark() {
      return this.dark === null ? this.$q.dark.isActive : this.dark;
    }
  }
});

/***/ }),

/***/ "a5af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/QCReview.vue?vue&type=template&id=69b5a30d&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_vm.isPrintPending && _vm.isLabQC && _vm.hasJob && _vm.account ? _c('worksheet', {
    staticClass: "print-only",
    attrs: {
      "account": _vm.account,
      "jobData": _vm.job
    }
  }) : _vm._e(), _c('q-layout', {
    staticClass: "print-hide",
    style: `height: calc(100vh - ${_vm.config.height}px)`,
    attrs: {
      "view": "hhh lpR fff",
      "container": ""
    }
  }, [_c('q-drawer', {
    attrs: {
      "show-if-above": "",
      "side": "right",
      "width": 200,
      "value": _vm.loaded
    }
  }, [_c('q-scroll-area', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loaded,
      expression: "loaded"
    }],
    staticClass: "fit"
  }, [_c('div', {
    staticClass: "q-pa-sm"
  }, [_c('div', {
    staticClass: "q-mb-md"
  }, [_c('q-input', {
    attrs: {
      "dense": "",
      "size": "sm",
      "rounded": "",
      "outlined": ""
    },
    on: {
      "input": _vm.clearSelectedImagesOnFilter
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('q-icon', {
          attrs: {
            "name": "mdi-magnify"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c('div', {
    staticClass: "q-my-sm q-px-sm"
  }, [_c('q-toggle', {
    staticClass: "q-pb-sm",
    attrs: {
      "dense": "",
      "size": "sm",
      "label": "Image References"
    },
    model: {
      value: _vm.imageOptions.showRef,
      callback: function ($$v) {
        _vm.$set(_vm.imageOptions, "showRef", $$v);
      },
      expression: "imageOptions.showRef"
    }
  }), _c('q-toggle', {
    staticClass: "q-pb-sm",
    attrs: {
      "dense": "",
      "size": "sm",
      "label": "Identifiers"
    },
    model: {
      value: _vm.imageOptions.showLinking,
      callback: function ($$v) {
        _vm.$set(_vm.imageOptions, "showLinking", $$v);
      },
      expression: "imageOptions.showLinking"
    }
  }), _c('q-toggle', {
    staticClass: "q-pb-sm",
    attrs: {
      "dense": "",
      "size": "sm",
      "label": "Rejected"
    },
    model: {
      value: _vm.showRejected,
      callback: function ($$v) {
        _vm.showRejected = $$v;
      },
      expression: "showRejected"
    }
  }), _c('q-toggle', {
    staticClass: "q-pb-sm",
    attrs: {
      "dense": "",
      "size": "sm",
      "label": "Job Info"
    },
    model: {
      value: _vm.showJobInfoBar,
      callback: function ($$v) {
        _vm.showJobInfoBar = $$v;
      },
      expression: "showJobInfoBar"
    }
  }), _vm.isLabQC ? _c('q-toggle', {
    staticClass: "q-pb-sm",
    attrs: {
      "dense": "",
      "size": "sm",
      "label": "Flagged Only"
    },
    on: {
      "input": _vm.clearSelectedImagesOnFilter
    },
    model: {
      value: _vm.flaggedOnly,
      callback: function ($$v) {
        _vm.flaggedOnly = $$v;
      },
      expression: "flaggedOnly"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "items-center q-my-sm q-px-sm"
  }, [_c('div', {
    staticClass: "q-gutter-sm column"
  }, [_c('q-btn', {
    attrs: {
      "size": "sm",
      "label": "Deselect all",
      "aria-label": "Deselect all",
      "align": "between",
      "icon": "mdi-select-off",
      "disabled": !_vm.showMove
    },
    on: {
      "click": function ($event) {
        return _vm.updateAllSelect(false);
      }
    }
  }), _vm.featureSplitJob && _vm.isLabQC && _vm.jobCode != null || _vm.jobCode !== '' ? _c('q-btn', {
    attrs: {
      "size": "sm",
      "label": "Move to Job",
      "aria-label": "Move to Job",
      "align": "between",
      "icon": "mdi-folder-move",
      "disabled": !_vm.showMove
    },
    on: {
      "click": _vm.showMoveJob
    }
  }) : _vm._e(), _c('q-btn', {
    attrs: {
      "size": "sm",
      "label": "Create class",
      "aria-label": "Create class",
      "align": "between",
      "icon": "mdi-folder-plus",
      "disabled": !_vm.showMove
    },
    on: {
      "click": function ($event) {
        _vm.showCreateClass = true;
      }
    }
  }), _vm.isLabQC ? _c('q-btn', {
    attrs: {
      "size": "sm",
      "label": "Add Image",
      "aria-label": "Add Image",
      "align": "between",
      "icon": "mdi-file-plus"
    },
    on: {
      "click": function ($event) {
        _vm.showAddImage = true;
      }
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "text-center q-my-sm q-px-sm"
  }, [_c('div', {
    staticClass: "q-mb-sm",
    staticStyle: {
      "font-size": "9px"
    }
  }, [_vm._v("IMAGE ACTIONS")]), _c('div', {
    staticClass: "column q-gutter-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row justify-between q-gutter-sm",
    staticStyle: {
      "height": "33px"
    }
  }, [_c('q-btn', {
    staticClass: "col",
    staticStyle: {
      "width": "40%",
      "padding": "1px 0"
    },
    attrs: {
      "size": "sm",
      "label": _vm.isLabQC ? 'Flag' : 'Flag',
      "dense": "",
      "aria-label": "Flag",
      "icon": "mdi-flag",
      "disabled": !_vm.showMove
    },
    on: {
      "click": function ($event) {
        return _vm.updateSelectedFlag(true);
      }
    }
  }), _c('q-btn', {
    staticClass: "col",
    staticStyle: {
      "width": "40%",
      "padding": "1px 0"
    },
    attrs: {
      "size": "sm",
      "label": _vm.isLabQC ? 'Unflag' : 'Unflag',
      "dense": "",
      "aria-label": "Unflag",
      "icon": "mdi-flag-outline",
      "disabled": !_vm.showMove
    },
    on: {
      "click": function ($event) {
        return _vm.updateSelectedFlag(false);
      }
    }
  })], 1)]), _c('q-btn', {
    attrs: {
      "size": "sm",
      "label": "Child Protection",
      "align": "between",
      "icon": "mdi-shield-account",
      "disabled": !_vm.showMove
    },
    on: {
      "click": function ($event) {
        return _vm.childProtection(true);
      }
    }
  }), _c('q-btn', {
    attrs: {
      "no-wrap": "",
      "size": "sm",
      "label": "Reject",
      "align": "between",
      "icon": "mdi-trash-can-outline",
      "disabled": !_vm.showMove
    },
    on: {
      "click": function ($event) {
        return _vm.updateSelectedReject();
      }
    }
  }), _c('q-btn', {
    attrs: {
      "size": "sm",
      "label": "Reset",
      "align": "between",
      "icon": "mdi-undo",
      "disabled": !_vm.showMove
    },
    on: {
      "click": function ($event) {
        return _vm.reset();
      }
    }
  }), _vm.hasJob ? _c('q-btn', {
    attrs: {
      "size": "sm",
      "label": "Show Job Notes",
      "icon": "mdi-note-text",
      "align": "between"
    },
    on: {
      "click": function ($event) {
        _vm.showJobNotes = true;
      }
    }
  }) : _vm._e()], 1)]), _vm.showPrintWorksheet ? _c('div', [_c('div', {
    staticClass: "q-gutter-md column q-pa-sm"
  }, [_c('q-btn', {
    attrs: {
      "size": "sm",
      "align": "between",
      "icon": "mdi-printer",
      "label": "Print Worksheet",
      "aria-label": "Print Worksheet"
    },
    on: {
      "click": function ($event) {
        return _vm.printWorksheet();
      }
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "q-px-sm q-mt-md"
  }, [_c('div', {
    staticClass: "q-gutter-sm column"
  }, [_vm.config.showFinishSave || _vm.config.showSave ? _c('q-btn', {
    attrs: {
      "size": "sm",
      "color": "positive",
      "label": "Save",
      "icon": "mdi-content-save-all",
      "align": "between",
      "loading": _vm.saving,
      "aria-label": "Save"
    },
    on: {
      "click": function ($event) {
        return _vm.saveJob();
      }
    }
  }) : _vm._e(), _vm.config.showFinishSave ? _c('q-btn', {
    attrs: {
      "size": "sm",
      "align": "between",
      "color": "primary",
      "icon": "mdi-check-all",
      "label": _vm.finishName,
      "loading": _vm.finishing,
      "aria-label": _vm.finishName
    },
    on: {
      "click": function ($event) {
        return _vm.finishQC();
      }
    }
  }) : _vm._e()], 1)])])])], 1), _c('q-page-container', [_c('q-page', {
    attrs: {
      "style-fn": _vm.pageStyleFn
    }
  }, [!_vm.loaded ? _c('div', {
    staticClass: "absolute-center"
  }, [_c('q-spinner', {
    attrs: {
      "size": "100px"
    }
  })], 1) : [_c('info-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showJobInfoBar && _vm.hasJob,
      expression: "showJobInfoBar && hasJob"
    }],
    attrs: {
      "job": _vm.job
    }
  }), _c('div', {
    staticClass: "row",
    style: _vm.showJobInfoBar ? 'margin-top: 96px' : ''
  }, [_c('div', {
    staticClass: "col"
  }, [_c('view-grid', {
    attrs: {
      "images": _vm.images,
      "imageOptions": _vm.imageOptions,
      "forceOpen": _vm.searchActive,
      "isLabQC": _vm.isLabQC,
      "show-move": _vm.showMove,
      "allow-group-image-assignment": _vm.allowGroupImageAssignment,
      "class-group-images": _vm.classGroupImages
    },
    on: {
      "move-to-class": _vm.moveToClass,
      "assign-group-to-class": _vm.showAssignGroupToClassDialog
    }
  }), _vm.images.length === 0 && _vm.flaggedOnly ? _c('div', {
    staticClass: "row justify-center"
  }, [_c('q-btn', {
    attrs: {
      "label": "Show All",
      "flat": "",
      "size": "12px"
    },
    on: {
      "click": _vm.showAll
    }
  })], 1) : _vm._e()], 1)])], _vm.isLabQC ? _c('q-dialog', {
    model: {
      value: _vm.showCheckPrint,
      callback: function ($$v) {
        _vm.showCheckPrint = $$v;
      },
      expression: "showCheckPrint"
    }
  }, [_c('q-card', [_c('q-btn', {
    staticClass: "absolute-top",
    staticStyle: {
      "margin-left": "auto",
      "zIndex": "10"
    },
    attrs: {
      "dense": "",
      "flat": "",
      "icon": "close"
    },
    on: {
      "click": function ($event) {
        _vm.showCheckPrint = false;
      }
    }
  }), _c('q-card-section', [_c('div', {
    staticClass: "text-h6 text-center"
  }, [_vm._v("You have not printed the worksheet yet, are you sure you want to continue?")])]), _c('q-card-actions', {
    attrs: {
      "align": "around"
    }
  }, [_c('q-btn', {
    attrs: {
      "label": "Finish",
      "no-caps": "",
      "aria-label": _vm.finishName
    },
    on: {
      "click": function ($event) {
        return _vm.finishQC();
      }
    }
  }), _c('q-btn', {
    attrs: {
      "color": "primary",
      "no-caps": "",
      "label": "Print Worksheet"
    },
    on: {
      "click": function ($event) {
        return _vm.printWorksheet();
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _c('q-dialog', {
    model: {
      value: _vm.showJobNotes,
      callback: function ($$v) {
        _vm.showJobNotes = $$v;
      },
      expression: "showJobNotes"
    }
  }, [_c('q-card', {
    staticStyle: {
      "width": "600px"
    }
  }, [_c('q-card-section', {
    staticClass: "row q-pb-none"
  }, [_c('div', {
    staticClass: "text-h6"
  }, [_vm._v("Job Notes")]), _c('q-space'), _c('q-btn', {
    directives: [{
      name: "close-popup",
      rawName: "v-close-popup"
    }],
    attrs: {
      "icon": "close",
      "dense": "",
      "flat": ""
    }
  })], 1), _c('q-card-section', [_c('q-input', {
    staticClass: "bg-yellow-1",
    attrs: {
      "type": "textarea",
      "rows": "20",
      "autofocus": "",
      "outlined": "",
      "placeholder": "Job Notes"
    },
    model: {
      value: _vm.jobNotes,
      callback: function ($$v) {
        _vm.jobNotes = $$v;
      },
      expression: "jobNotes"
    }
  })], 1), _c('q-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('q-btn', {
    attrs: {
      "color": "positive",
      "label": "Save"
    },
    on: {
      "click": _vm.saveNotes
    }
  })], 1)], 1)], 1), _c('q-dialog', {
    on: {
      "show": _vm.classCreatorShown
    },
    model: {
      value: _vm.showCreateClass,
      callback: function ($$v) {
        _vm.showCreateClass = $$v;
      },
      expression: "showCreateClass"
    }
  }, [_c('q-card', {
    staticStyle: {
      "width": "600px"
    }
  }, [_c('q-btn', {
    staticClass: "absolute-top",
    staticStyle: {
      "margin-left": "auto",
      "zIndex": "10"
    },
    attrs: {
      "dense": "",
      "flat": "",
      "icon": "close"
    },
    on: {
      "click": function ($event) {
        _vm.showCreateClass = false;
      }
    }
  }), _c('q-card-section', [_c('div', {
    staticClass: "text-h6"
  }, [_vm._v("Create Class")]), _c('p', [_vm._v("Class names must only contain letters, numbers, dashes, and spaces")]), _c('q-input', {
    ref: "newClassName",
    staticClass: "bg-yellow-1 q-pa-none",
    class: {
      'invalid-class-name': !_vm.newClassNameValid
    },
    attrs: {
      "type": "input",
      "dense": "",
      "outlined": "",
      "placeholder": "Enter Class Name",
      "maxlength": "100"
    },
    model: {
      value: _vm.newClassName,
      callback: function ($$v) {
        _vm.newClassName = $$v;
      },
      expression: "newClassName"
    }
  })], 1), _c('q-separator'), _c('q-card-actions', [_c('q-btn', {
    staticClass: "q-ml-auto",
    attrs: {
      "color": "positive",
      "label": "Save",
      "disabled": !_vm.newClassNameValid
    },
    on: {
      "click": _vm.moveToNewClass
    }
  })], 1)], 1)], 1), _vm.isLabQC ? _c('q-dialog', {
    model: {
      value: _vm.showAddImage,
      callback: function ($$v) {
        _vm.showAddImage = $$v;
      },
      expression: "showAddImage"
    }
  }, [_c('image-upload', {
    attrs: {
      "job": _vm.jobData,
      "accountCode": _vm.accountCode,
      "jobCode": _vm.jobCode
    }
  })], 1) : _vm._e()], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/QCReview.vue?vue&type=template&id=69b5a30d&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/JobMoveDialog.vue?vue&type=template&id=ef491558&lang=pug
var JobMoveDialogvue_type_template_id_ef491558_lang_pug_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('q-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": _vm.loading
    },
    on: {
      "show": _vm.onShow,
      "hide": _vm.onHide
    }
  }, [_c('q-card', {
    staticStyle: {
      "min-width": "500px"
    }
  }, [_c('q-card-section', {
    staticClass: "row items-center bg-blue-grey-1"
  }, [_c('div', {
    staticClass: "text-h6"
  }, [_vm._v("Move to Job")]), _c('q-space'), _c('q-btn', {
    attrs: {
      "icon": "close",
      "dense": "",
      "flat": "",
      "round": "",
      "disable": _vm.loading
    },
    on: {
      "click": _vm.hide
    }
  })], 1), _c('q-card-section', {
    staticClass: "column q-gutter-md"
  }, [_c('span', [_vm._v("You are about to split " + _vm._s(_vm.images.length) + " images to another job.")]), _c('p', [_vm._v("Please select a Job Type for these images.")]), _c('q-select', {
    staticClass: "q-px-md",
    attrs: {
      "label": "Job Type",
      "filled": "",
      "menu-anchor": "bottom left",
      "menu-self": "top left",
      "use-input": "",
      "emit-value": "",
      "input-debounce": "0",
      "options": _vm.jobTypesOptions
    },
    on: {
      "filter": _vm.filterJobTypes
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (scope) {
        return [_c('q-item', _vm._g(_vm._b({}, 'q-item', scope.itemProps, false), scope.itemEvents), [_c('q-item-section', {
          attrs: {
            "avatar": ""
          }
        }, [_c('q-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: scope.opt.icon,
            expression: "scope.opt.icon"
          }],
          attrs: {
            "name": scope.opt.icon
          }
        })], 1), _c('q-item-section', [_c('q-item-label', {
          domProps: {
            "innerHTML": _vm._s(scope.opt.label)
          }
        }), _c('q-item-label', {
          attrs: {
            "caption": ""
          }
        }, [_vm._v(_vm._s(scope.opt.description))])], 1), scope.opt.imageCount !== undefined ? _c('q-item-section', {
          attrs: {
            "side": "",
            "top": ""
          }
        }, [_c('q-item-label', {
          attrs: {
            "caption": ""
          }
        }, [_vm._v(_vm._s(scope.opt.imageCount) + " images")])], 1) : _vm._e()], 1), scope.opt.separator ? _c('q-separator') : _vm._e()];
      }
    }]),
    model: {
      value: _vm.selectedJobType,
      callback: function ($$v) {
        _vm.selectedJobType = $$v;
      },
      expression: "selectedJobType"
    }
  })], 1), _c('q-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('q-btn', {
    attrs: {
      "label": "Cancel",
      "flat": "",
      "disable": _vm.loading
    },
    on: {
      "click": _vm.hide
    }
  }), _c('q-btn', {
    attrs: {
      "label": "Confirm",
      "color": "primary",
      "flat": "",
      "loading": _vm.loading,
      "disable": _vm.selectedJobType === null
    },
    on: {
      "click": _vm.onConfirmClick
    }
  })], 1)], 1)], 1);
};
var JobMoveDialogvue_type_template_id_ef491558_lang_pug_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/JobMoveDialog.vue?vue&type=template&id=ef491558&lang=pug

// EXTERNAL MODULE: external "@ht-web/firebase-adapter"
var firebase_adapter_ = __webpack_require__("982d");

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__("60bb");

// EXTERNAL MODULE: ./src/axios.ts
var axios = __webpack_require__("f532");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/JobMoveDialog.vue?vue&type=script&lang=ts




/* harmony default export */ var JobMoveDialogvue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'JobMoveDialog',
  props: {
    aimsJobNumber: {
      type: String,
      required: true
    },
    sourceJobSnapshot: {
      type: Object,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      getJobTypesPromise: Promise.resolve([]),
      job: null,
      jobs: [],
      jobTypes: [],
      jobTypesOptions: [],
      selectedJobType: null,
      unsubscribeJobs: null
    };
  },
  beforeDestroy() {
    var _a;
    (_a = this.unsubscribeJobs) === null || _a === void 0 ? void 0 : _a.call(this);
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    async onShow() {
      console.log('onShow');
      try {
        const job = this.sourceJobSnapshot.data();
        if (job === undefined) {
          throw new Error('Job not found');
        }
        this.job = job;
        if (this.jobTypes.length === 0) {
          this.getJobTypesPromise = getJobTypes(this.sourceJobSnapshot.id, job);
          this.jobTypes = await this.getJobTypesPromise;
          if (this.jobTypes.length === 0) {
            throw new Error('No valid job types found');
          }
        }
        this.unsubscribeJobs = subscribeToJobs(this.job.account.code, this.aimsJobNumber, this.jobs, this.jobTypes);
      } catch (e) {
        console.error(e);
        this.$q.notify({
          type: 'negative',
          message: e instanceof Error ? e.message : String(e)
        });
        this.hide();
      }
    },
    onHide() {
      var _a;
      (_a = this.unsubscribeJobs) === null || _a === void 0 ? void 0 : _a.call(this);
    },
    async filterJobTypes(inputValue, update) {
      await this.getJobTypesPromise;
      let filtered = this.jobTypes;
      if (inputValue !== '') {
        const needle = inputValue.toLocaleLowerCase();
        filtered = this.jobTypes.filter(x => x.label.toLocaleLowerCase().includes(needle));
      }
      update(() => {
        this.jobTypesOptions.splice(0, this.jobTypesOptions.length, ...filtered);
      });
    },
    async onConfirmClick() {
      if (this.job === null) {
        throw new Error('Job not found');
      }
      if (this.selectedJobType === null) {
        throw new Error('No job type selected');
      }
      try {
        this.loading = true;
        await Object(axios["a" /* getAxios */])().post(`/https-job/api/job/${this.sourceJobSnapshot.id}/split`, {
          dstJobType: this.selectedJobType,
          imageIds: this.images.map(x => x.longRef)
        });
      } finally {
        this.loading = false;
        this.hide();
      }
    }
  }
}));
const sortOptionsDebounced = Object(external_lodash_["debounce"])(sortOptions, 250);
async function getJobTypes(jobId, job) {
  const {
    data: jobTypes
  } = await Object(axios["a" /* getAxios */])().get(`/https-job/api/job/${jobId}/split/compatiblejobtypes`);
  const options = jobTypes.map(jobType => {
    const isThisJob = jobType.id === job.jobType;
    const obj = {
      description: jobType.description,
      value: jobType.id,
      label: isThisJob ? `${jobType.id} (This Job)` : jobType.id
    };
    if (isThisJob) {
      obj.disable = true;
    }
    return obj;
  });
  sortOptions(options);
  return options;
}
function subscribeToJobs(accountCode, aimsJobNumber, jobs, jobTypes) {
  const cache = new firebase_adapter_["ArrayCache"](jobs, null);
  return firebase_adapter_["Job"].byAimsJobNumber(accountCode, aimsJobNumber).listenChangesWithCache(cache, {
    defaultMetadata: null,
    onAdded: item => {
      const jobType = jobTypes.find(x => x.value === item.model.jobType);
      if (jobType !== undefined) {
        jobType.icon = 'mdi-alpha-j-circle';
        jobType.imageCount = item.model.imageCount;
      }
      sortOptionsDebounced(jobTypes, jobs);
    }
  });
}
function sortOptions(jobTypes, jobs = []) {
  // Show jobs that exist first
  const uniqJobTypes = Object(external_lodash_["uniq"])(jobs.map(x => x.model.jobType));
  jobTypes.sort((a, b) => (b.disable === true ? 1 : 0) - (a.disable === true ? 1 : 0) || +uniqJobTypes.includes(b.label) - +uniqJobTypes.includes(a.label) || a.label.localeCompare(b.label));
  // Apply a separator between existing jobs and jobs that don't exist
  let separatorApplied = false;
  for (let i = jobTypes.length - 1; i >= 0; i--) {
    if (!separatorApplied && jobTypes[i].icon !== undefined) {
      jobTypes[i].separator = true;
      separatorApplied = true;
      continue;
    }
    if (jobTypes[i].separator !== undefined) {
      jobTypes[i].separator = false;
    }
  }
}
// CONCATENATED MODULE: ./src/components/JobMoveDialog.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_JobMoveDialogvue_type_script_lang_ts = (JobMoveDialogvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/dialog/QDialog.js
var QDialog = __webpack_require__("66e6");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCard.js
var QCard = __webpack_require__("6ca9");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCardSection.js
var QCardSection = __webpack_require__("7efe");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/space/QSpace.js
var QSpace = __webpack_require__("f63b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/btn/QBtn.js
var QBtn = __webpack_require__("b20c");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/select/QSelect.js
var QSelect = __webpack_require__("dc96");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItem.js
var QItem = __webpack_require__("7e6f");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItemSection.js
var QItemSection = __webpack_require__("0aaf");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/icon/QIcon.js
var QIcon = __webpack_require__("a170");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItemLabel.js
var QItemLabel = __webpack_require__("be86");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/separator/QSeparator.js
var QSeparator = __webpack_require__("6485");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCardActions.js
var QCardActions = __webpack_require__("15cd");

// EXTERNAL MODULE: /workspace/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js
var runtime_auto_import = __webpack_require__("d447");
var runtime_auto_import_default = /*#__PURE__*/__webpack_require__.n(runtime_auto_import);

// CONCATENATED MODULE: ./src/components/JobMoveDialog.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_JobMoveDialogvue_type_script_lang_ts,
  JobMoveDialogvue_type_template_id_ef491558_lang_pug_render,
  JobMoveDialogvue_type_template_id_ef491558_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var JobMoveDialog = (component.exports);













runtime_auto_import_default()(component, 'components', {QDialog: QDialog["a" /* default */],QCard: QCard["a" /* default */],QCardSection: QCardSection["a" /* default */],QSpace: QSpace["a" /* default */],QBtn: QBtn["a" /* default */],QSelect: QSelect["a" /* default */],QItem: QItem["a" /* default */],QItemSection: QItemSection["a" /* default */],QIcon: QIcon["a" /* default */],QItemLabel: QItemLabel["a" /* default */],QSeparator: QSeparator["a" /* default */],QCardActions: QCardActions["a" /* default */]});

// EXTERNAL MODULE: ./src/components/ViewGrid.vue + 9 modules
var ViewGrid = __webpack_require__("4b62");

// EXTERNAL MODULE: ./src/components/Worksheet.vue + 40 modules
var Worksheet = __webpack_require__("82fa");

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/AssignGroupImageDialog.vue?vue&type=template&id=59ecbe56&lang=pug
var AssignGroupImageDialogvue_type_template_id_59ecbe56_lang_pug_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('q-dialog', {
    ref: "dialog",
    on: {
      "show": _vm.onShow,
      "hide": _vm.onHide
    }
  }, [_c('q-card', {
    staticStyle: {
      "min-width": "450px"
    }
  }, [_c('q-card-section', {
    staticClass: "row items-center bg-blue-grey-1"
  }, [_c('div', {
    staticClass: "text-h6"
  }, [_vm._v("Select a class to assign to.")]), _c('q-space'), _c('q-btn', {
    attrs: {
      "icon": "close",
      "dense": "",
      "flat": "",
      "round": ""
    },
    on: {
      "click": _vm.hide
    }
  })], 1), _c('q-card-section', {
    staticClass: "column q-gutter-md"
  }, [_c('q-list', _vm._l(_vm.checklist.slice().reverse(), function (item) {
    return _c('q-item', {
      key: item.className
    }, [_c('q-item-section', {
      attrs: {
        "side": "",
        "top": ""
      }
    }, [_c('q-checkbox', {
      attrs: {
        "disable": item.disabled
      },
      model: {
        value: item.selected,
        callback: function ($$v) {
          _vm.$set(item, "selected", $$v);
        },
        expression: "item.selected"
      }
    })], 1), _c('q-item-section', [_c('q-item-label', {
      staticClass: "text-h6",
      attrs: {
        "disabled": item.disabled
      }
    }, [_vm._v(_vm._s(item.className))])], 1), item.disabled ? _c('q-item-section', {
      attrs: {
        "side": ""
      }
    }, [_c('q-btn', {
      attrs: {
        "icon": "delete",
        "round": "",
        "color": "red",
        "size": "sm"
      },
      on: {
        "click": () => {
          item.disabled = false;
          item.selectedLongRef = null;
        }
      }
    })], 1) : _vm._e()], 1);
  }), 1)], 1), _c('q-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('q-btn', {
    attrs: {
      "label": "Cancel",
      "color": "red"
    },
    on: {
      "click": _vm.hide
    }
  }), _c('q-btn', {
    attrs: {
      "label": "Save",
      "color": "green"
    },
    on: {
      "click": _vm.onConfirmClick
    }
  })], 1)], 1)], 1);
};
var AssignGroupImageDialogvue_type_template_id_59ecbe56_lang_pug_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/AssignGroupImageDialog.vue?vue&type=template&id=59ecbe56&lang=pug

// EXTERNAL MODULE: ./src/imageStore.ts
var imageStore = __webpack_require__("818c");

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/AssignGroupImageDialog.vue?vue&type=script&lang=ts



/* harmony default export */ var AssignGroupImageDialogvue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'AssignGroupImageDialog',
  props: {
    longRef: {
      type: String,
      required: true
    },
    jobId: {
      type: String,
      required: true
    },
    classGroupImages: {
      type: Object,
      required: false,
      default: () => ({})
    },
    groupLongRef: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      checklist: [],
      classNames: []
    };
  },
  mounted() {
    this.classNames = imageStore["a" /* ImageStore */].Instance.classNames(this.longRef).sort();
  },
  methods: {
    show() {
      console.debug('AssignGroupImageDialog->show()');
      this.$refs.dialog.show();
    },
    hide() {
      console.debug('AssignGroupImageDialog->hide()');
      this.$refs.dialog.hide();
    },
    onShow() {
      console.debug('AssignGroupImageDialog->onShow()');
      this.populate();
    },
    populate() {
      this.checklist = this.classNames.map(x => {
        const classInMap = this.classGroupImages[x];
        const disabled = classInMap !== undefined && classInMap !== this.groupLongRef;
        const selected = classInMap !== undefined && classInMap === this.groupLongRef;
        const r = {
          disabled,
          selectedLongRef: disabled ? classInMap : null,
          selected,
          className: x
        };
        return r;
      });
      console.debug('AssignGroupImageDialog->populate() -> checklist: ', this.checklist);
    },
    onHide() {
      console.debug('AssignGroupImageDialog->onHide()');
      this.$emit('hide');
    },
    async onConfirmClick() {
      const update = {};
      for (const a of this.checklist) {
        if (a.selected) {
          update[a.className] = this.groupLongRef;
        } else if (a.disabled && a.selectedLongRef !== null) {
          update[a.className] = a.selectedLongRef;
        }
      }
      try {
        await firebase_adapter_["Job"].byId(this.jobId).update({
          classGroupImages: update
        });
        this.$emit('ok', update);
        this.hide();
      } catch (e) {
        console.error(`error saving classGroupImages: ${e}`);
        throw e;
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/AssignGroupImageDialog.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_AssignGroupImageDialogvue_type_script_lang_ts = (AssignGroupImageDialogvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QList.js
var QList = __webpack_require__("c588");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/checkbox/QCheckbox.js
var QCheckbox = __webpack_require__("1919");

// CONCATENATED MODULE: ./src/components/AssignGroupImageDialog.vue





/* normalize component */

var AssignGroupImageDialog_component = Object(componentNormalizer["a" /* default */])(
  components_AssignGroupImageDialogvue_type_script_lang_ts,
  AssignGroupImageDialogvue_type_template_id_59ecbe56_lang_pug_render,
  AssignGroupImageDialogvue_type_template_id_59ecbe56_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AssignGroupImageDialog = (AssignGroupImageDialog_component.exports);












runtime_auto_import_default()(AssignGroupImageDialog_component, 'components', {QDialog: QDialog["a" /* default */],QCard: QCard["a" /* default */],QCardSection: QCardSection["a" /* default */],QSpace: QSpace["a" /* default */],QBtn: QBtn["a" /* default */],QList: QList["a" /* default */],QItem: QItem["a" /* default */],QItemSection: QItemSection["a" /* default */],QCheckbox: QCheckbox["a" /* default */],QItemLabel: QItemLabel["a" /* default */],QCardActions: QCardActions["a" /* default */]});

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/InfoBar.vue?vue&type=template&id=52d59262&lang=pug
var InfoBarvue_type_template_id_52d59262_lang_pug_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "column fixed-top bg-white",
    staticStyle: {
      "z-index": "999",
      "width": "calc(100vw - 200px)",
      "border-bottom": "1px solid gainsboro"
    }
  }, [_c('div', {
    staticClass: "row q-px-sm q-gutter-xl items-center"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('span', {
    staticClass: "text-overline"
  }, [_vm._v("Account Name")]), _vm.job.account.name ? _c('div', [_vm._v(_vm._s(_vm.job.account.name))]) : _c('div', [_vm._v("None")])]), _c('div', {
    staticClass: "col-auto"
  }, [_c('span', {
    staticClass: "text-overline"
  }, [_vm._v("Account Code")]), _vm.job.account.code ? _c('div', [_vm._v(_vm._s(_vm.job.account.code))]) : _c('div', [_vm._v("None")])]), _c('div', {
    staticClass: "col-auto"
  }, [_c('span', {
    staticClass: "text-overline"
  }, [_vm._v("Job Number")]), _vm.job.account.code && _vm.job.aimsJobNumber ? _c('div', [_vm._v(_vm._s(_vm.job.account.code) + " - " + _vm._s(_vm.job.aimsJobNumber))]) : _c('div', [_vm._v("None")])]), _c('div', {
    staticClass: "col-auto"
  }, [_c('span', {
    staticClass: "text-overline"
  }, [_vm._v("Job Type")]), _vm.job.jobType ? _c('div', [_vm._v(_vm._s(_vm.job.jobType))]) : _c('div', [_vm._v("None")])]), _c('div', {
    staticClass: "col-auto"
  }, [_c('q-chip', {
    attrs: {
      "icon": "mdi-camera-outline",
      "size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.imageCount)), _c('q-tooltip', [_vm._v("Total Image Count")])], 1)], 1), _c('div', {
    staticClass: "col-auto"
  }, [_c('q-chip', {
    attrs: {
      "icon": "mdi-account",
      "size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.photographers.length)), _c('q-tooltip', [_vm._v("Photographers")])], 1)], 1)]), _c('photographer-scroll-state-provider', {
    staticClass: "row q-px-sm q-py-sm",
    attrs: {
      "photographers": _vm.photographers
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (slotProps) {
        return _vm._l(_vm.photographers, function (photographer) {
          return _c('div', {
            key: photographer.photographerId,
            staticClass: "col-auto q-gutter-md"
          }, [_c('info-bar-photographer-chip', {
            attrs: {
              "photographer": photographer,
              "is-scrolled-to": slotProps.matchingPhotographer === photographer.photographerId
            }
          })], 1);
        });
      }
    }])
  })], 1);
};
var InfoBarvue_type_template_id_52d59262_lang_pug_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/InfoBar.vue?vue&type=template&id=52d59262&lang=pug

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/InfoBarPhotographerChip.vue?vue&type=template&id=623b579e
var InfoBarPhotographerChipvue_type_template_id_623b579e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('q-chip', {
    attrs: {
      "square": "",
      "clickable": "",
      "size": "11px",
      "color": _vm.photographerChipStyle
    },
    on: {
      "click": _vm.photographerClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.photographer.displayName) + " ")]);
};
var InfoBarPhotographerChipvue_type_template_id_623b579e_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/InfoBarPhotographerChip.vue?vue&type=template&id=623b579e

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/InfoBarPhotographerChip.vue?vue&type=script&lang=ts

/* harmony default export */ var InfoBarPhotographerChipvue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'InfoBarPhotographerChip',
  props: {
    photographer: {
      type: Object,
      required: true
    },
    isScrolledTo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    photographerChipStyle() {
      return this.isScrolledTo ? 'primary' : '';
    }
  },
  methods: {
    photographerClicked() {
      var _a;
      (_a = document.getElementById(`photographer-${this.photographer.photographerId}`)) === null || _a === void 0 ? void 0 : _a.scrollIntoView(true);
    }
  }
}));
// CONCATENATED MODULE: ./src/components/InfoBarPhotographerChip.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_InfoBarPhotographerChipvue_type_script_lang_ts = (InfoBarPhotographerChipvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/chip/QChip.js
var QChip = __webpack_require__("5759");

// CONCATENATED MODULE: ./src/components/InfoBarPhotographerChip.vue





/* normalize component */

var InfoBarPhotographerChip_component = Object(componentNormalizer["a" /* default */])(
  components_InfoBarPhotographerChipvue_type_script_lang_ts,
  InfoBarPhotographerChipvue_type_template_id_623b579e_render,
  InfoBarPhotographerChipvue_type_template_id_623b579e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InfoBarPhotographerChip = (InfoBarPhotographerChip_component.exports);


runtime_auto_import_default()(InfoBarPhotographerChip_component, 'components', {QChip: QChip["a" /* default */]});

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/PhotographerScrollStateProvider.vue?vue&type=template&id=9597c1b0
var PhotographerScrollStateProvidervue_type_template_id_9597c1b0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_vm._t("default", null, {
    "matchingPhotographer": _vm.matchingPhotographer
  })], 2);
};
var PhotographerScrollStateProvidervue_type_template_id_9597c1b0_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/PhotographerScrollStateProvider.vue?vue&type=template&id=9597c1b0

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/PhotographerScrollStateProvider.vue?vue&type=script&lang=ts

/* harmony default export */ var PhotographerScrollStateProvidervue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'PhotographerScrollStateProvider',
  props: {
    photographers: {
      type: Array,
      required: true
    },
    yOffset: {
      type: Number,
      default: 150
    }
  },
  data() {
    return {
      enabled: true,
      photographerScrollRegions: [],
      scrollEventTicking: false,
      scrollArea: null,
      totalScrollHeight: 0,
      scrollY: 0,
      resizeObserver: null
    };
  },
  mounted() {
    this.scrollArea = document.getElementsByClassName('scroll')[0];
    const heightWatchable = document.querySelector('.q-layout .q-layout--containerized');
    if (this.scrollArea === undefined || heightWatchable === null) {
      console.warn('No scroll area found, dynamic photographer badge feedback will not work');
      this.enabled = false;
      return;
    }
    this.resizeObserver = new ResizeObserver(() => this.getPhotographerScrollRegions());
    this.resizeObserver.observe(heightWatchable);
    window.addEventListener('scroll', this.onScroll, true);
  },
  beforeDestroy() {
    var _a;
    if (this.enabled) {
      window.removeEventListener('scroll', this.onScroll, true);
      (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
  },
  computed: {
    matchingPhotographer() {
      var _a;
      return (_a = this.photographerScrollRegions.find(x => this.scrollY >= x.start && this.scrollY < x.end)) === null || _a === void 0 ? void 0 : _a.photographer;
    }
  },
  methods: {
    getPhotographerScrollRegions() {
      const scrollRegions = this.photographers.map((x, index) => {
        var _a;
        const photographer = x.photographerId;
        const rect = (_a = document.getElementById(`photographer-${x.photographerId}`)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (rect === undefined) return {
          photographer,
          start: -1,
          end: -1
        };
        const start = index === 0 ? 0 : rect.y - this.yOffset + this.scrollY;
        const end = start + rect.height;
        return {
          photographer,
          start,
          end
        };
      });
      this.photographerScrollRegions.splice(0, this.photographerScrollRegions.length, ...scrollRegions);
    },
    onScroll() {
      if (!this.scrollEventTicking) {
        this.scrollEventTicking = true;
        window.requestAnimationFrame(() => {
          var _a, _b;
          this.scrollY = (_b = (_a = this.scrollArea) === null || _a === void 0 ? void 0 : _a.scrollTop) !== null && _b !== void 0 ? _b : 0;
          this.scrollEventTicking = false;
        });
      }
    }
  }
}));
// CONCATENATED MODULE: ./src/components/PhotographerScrollStateProvider.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_PhotographerScrollStateProvidervue_type_script_lang_ts = (PhotographerScrollStateProvidervue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/layout/QLayout.js
var QLayout = __webpack_require__("a511");

// CONCATENATED MODULE: ./src/components/PhotographerScrollStateProvider.vue





/* normalize component */

var PhotographerScrollStateProvider_component = Object(componentNormalizer["a" /* default */])(
  components_PhotographerScrollStateProvidervue_type_script_lang_ts,
  PhotographerScrollStateProvidervue_type_template_id_9597c1b0_render,
  PhotographerScrollStateProvidervue_type_template_id_9597c1b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PhotographerScrollStateProvider = (PhotographerScrollStateProvider_component.exports);


runtime_auto_import_default()(PhotographerScrollStateProvider_component, 'components', {QLayout: QLayout["a" /* default */]});

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/InfoBar.vue?vue&type=script&lang=ts




/* harmony default export */ var InfoBarvue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'InfoBar',
  components: {
    PhotographerScrollStateProvider: PhotographerScrollStateProvider,
    InfoBarPhotographerChip: InfoBarPhotographerChip
  },
  props: {
    job: {
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    imageCount() {
      return imageStore["a" /* ImageStore */].Instance.allImages.length;
    },
    photographers() {
      return imageStore["a" /* ImageStore */].Instance.photographersArray;
    }
  }
}));
// CONCATENATED MODULE: ./src/components/InfoBar.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_InfoBarvue_type_script_lang_ts = (InfoBarvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/tooltip/QTooltip.js
var QTooltip = __webpack_require__("8030");

// CONCATENATED MODULE: ./src/components/InfoBar.vue





/* normalize component */

var InfoBar_component = Object(componentNormalizer["a" /* default */])(
  components_InfoBarvue_type_script_lang_ts,
  InfoBarvue_type_template_id_52d59262_lang_pug_render,
  InfoBarvue_type_template_id_52d59262_lang_pug_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InfoBar = (InfoBar_component.exports);



runtime_auto_import_default()(InfoBar_component, 'components', {QChip: QChip["a" /* default */],QTooltip: QTooltip["a" /* default */]});

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ImageUpload.vue?vue&type=template&id=d75c5056&scoped=true&lang=pug
var ImageUploadvue_type_template_id_d75c5056_scoped_true_lang_pug_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('q-card', {
    staticClass: "relative-position"
  }, [_c('q-card-section', {
    staticClass: "row items-center bg-blue-grey-1"
  }, [_c('div', {
    staticClass: "text-h4"
  }, [_vm._v("Add an Image")]), _c('q-space'), _c('q-btn', {
    directives: [{
      name: "close-popup",
      rawName: "v-close-popup"
    }],
    attrs: {
      "dense": "",
      "flat": "",
      "round": "",
      "icon": "close"
    }
  })], 1), _c('q-card-section', [_vm._v("Use this feature for the following purposes"), _c('ul', [_c('li', [_vm._v("Upload an composite or z-class image which does not have an image reference yet")]), _c('li', [_vm._v("Upload a rejected image from a CD produced before May 2021")])]), _vm._v("For all other use cases, this feature is not supported and may produce unexpected results. Use the \"Lab Upload\" feature instead")]), !_vm.hasRequiredData ? _c('q-card-section', [_vm._v("Please ensure this is a cloud job or that at least one image has been uploaded to the job before attempting to upload this image")]) : _vm.loaded ? _c('q-card-section', [_c('div', {
    staticClass: "col-12"
  }, [_vm.errorMessages.length > 0 ? _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.errorMessages, function (message) {
    return _c('div', {
      staticClass: "col-12 text-center"
    }, [_vm._v(_vm._s(message))]);
  }), 0) : _vm._e(), _vm.showImageSelect ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('q-btn', {
    staticClass: "full-width",
    attrs: {
      "color": "primary",
      "icon": "mdi-cloud-upload",
      "label": "Choose Image"
    },
    on: {
      "click": _vm.selectImageButtonClicked
    }
  }, [_c('input', {
    ref: "selectImageInput",
    attrs: {
      "id": "select-image-button",
      "type": "file",
      "data-cy": "file-input",
      "accept": "image/jpeg"
    },
    on: {
      "change": function ($event) {
        return _vm.inputFile($event.target.files);
      }
    }
  })])], 1)]) : _vm.showUploadConfirmation ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm.imageOnSameAccount ? _c('div', [_c('div', {
    staticClass: "row justify-center"
  }, [_vm._v(_vm._s(`Are you sure you want to replace existing image ${_vm.ref}?`))]), _c('div', {
    staticClass: "row justify-center"
  }, [_c('q-btn', {
    staticClass: "q-mx-sm",
    attrs: {
      "color": "primary",
      "icon": "mdi-cloud-upload",
      "label": "Upload"
    },
    on: {
      "click": _vm.doUpload
    }
  }), _c('q-btn', {
    staticClass: "q-mx-sm",
    attrs: {
      "color": "negative",
      "icon": "mdi-close-circle",
      "label": "Choose again"
    },
    on: {
      "click": _vm.reset
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "row justify-center"
  }, [_vm._v(_vm._s(`Cannot upload image ${_vm.ref}, it already exists in another job ${_vm.image.accountCode}-${_vm.image.jobCode}`))]), _c('div', {
    staticClass: "row justify-center"
  }, [_c('q-btn', {
    attrs: {
      "color": "negative",
      "icon": "mdi-cloud-upload",
      "label": "Restart"
    },
    on: {
      "click": _vm.reset
    }
  })], 1)])])]) : _vm.showDataCollection ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row q-my-sm"
  }, [_c('div', {
    staticClass: "col-4 q-px-sm"
  }, [_c('q-select', {
    staticClass: "full-width",
    attrs: {
      "disable": !_vm.canChooseMarket,
      "options": _vm.markets,
      "value": _vm.userSelectedMarket,
      "label": "Market",
      "stack-label": ""
    },
    on: {
      "input": _vm.updateMarket
    }
  })], 1), _vm.jobTypesFromImages.length > 0 ? _c('div', {
    staticClass: "col-4 q-px-sm"
  }, [_c('q-select', {
    staticClass: "full-width",
    attrs: {
      "disable": !_vm.canChooseJobType,
      "options": _vm.jobTypes,
      "value": _vm.userSelectedJobType,
      "label": "Job Type",
      "stack-label": ""
    },
    on: {
      "input": _vm.updateJobType
    }
  })], 1) : _vm._e(), _vm.jobTypesFromImages.length === 0 && _vm.jobSubTypesFromImages.length > 0 ? _c('div', {
    staticClass: "col-4 q-px-sm"
  }, [_c('q-select', {
    staticClass: "full-width",
    attrs: {
      "disable": !_vm.canChooseJobSubtype,
      "options": _vm.jobSubtypes,
      "value": _vm.userSelectedJobSubtype,
      "label": "JST",
      "stack-label": ""
    },
    on: {
      "input": _vm.updateJobSubtype
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "col-4 q-px-sm"
  }, [_c('q-select', {
    staticClass: "full-width",
    attrs: {
      "options": _vm.photographers,
      "value": _vm.userSelectedPhotographer,
      "label": "Photographer",
      "stack-label": ""
    },
    on: {
      "input": _vm.updatePhotographer
    }
  })], 1)]), _c('div', {
    staticClass: "row q-my-sm"
  }, [_c('div', {
    staticClass: "col-4 q-px-sm"
  }, [_c('q-select', {
    staticClass: "full-width",
    attrs: {
      "options": _vm.classes,
      "value": _vm.userSelectedClassName,
      "label": "Class",
      "use-input": "",
      "new-value-mode": "add-unique",
      "stack-label": ""
    },
    on: {
      "input": _vm.updateClass
    }
  })], 1), _c('div', {
    staticClass: "col-4 q-px-sm"
  }, [_c('q-select', {
    staticClass: "full-width",
    attrs: {
      "options": _vm.shotTypes,
      "value": _vm.userSelectedShotType,
      "label": "Image Type",
      "stack-label": ""
    },
    on: {
      "input": _vm.updateShotType
    }
  })], 1), _c('div', {
    staticClass: "col-4 q-px-sm"
  }, [_c('q-btn', {
    staticClass: "full-width",
    attrs: {
      "color": "primary",
      "icon": "mdi-cloud-upload",
      "label": "Upload",
      "disable": _vm.validatedForm.hasErrors === 'true'
    },
    on: {
      "click": _vm.checkImage
    }
  })], 1)])])]) : _vm.showDoneActions ? _c('div', {
    staticClass: "row justify-center"
  }, [_c('q-btn', {
    staticClass: "q-mx-sm",
    attrs: {
      "color": "primary",
      "icon": "mdi-cloud-upload",
      "label": "Next Image"
    },
    on: {
      "click": _vm.reset
    }
  }), _c('q-btn', {
    directives: [{
      name: "close-popup",
      rawName: "v-close-popup"
    }],
    staticClass: "q-mx-sm",
    attrs: {
      "color": "positive",
      "icon": "mdi-check",
      "label": "Done"
    }
  })], 1) : _vm._e()])]) : _vm._e()], 1);
};
var ImageUploadvue_type_template_id_d75c5056_scoped_true_lang_pug_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/ImageUpload.vue?vue&type=template&id=d75c5056&scoped=true&lang=pug

// EXTERNAL MODULE: external "@ht-lib/accounts-models"
var accounts_models_ = __webpack_require__("406b");

// EXTERNAL MODULE: external "@ht-lib/accounts-api-client"
var accounts_api_client_ = __webpack_require__("5403");

// EXTERNAL MODULE: external "@ht-lib/accounts-common"
var accounts_common_ = __webpack_require__("03be");

// CONCATENATED MODULE: ./src/common.ts

const common_option = (value, label) => ({
  value,
  label: label !== null && label !== void 0 ? label : value
});
function getStringValue(object, key) {
  const value = object[key];
  if (typeof value === 'function') {
    return String(value());
  } else {
    return String(value);
  }
}
const common_options = (items, valueKey, labelKey) => {
  return Object(external_lodash_["uniqBy"])(items.filter(i => i[valueKey] != null).map(i => common_option(getStringValue(i, valueKey), getStringValue(i, labelKey !== null && labelKey !== void 0 ? labelKey : valueKey))), 'value');
};
// EXTERNAL MODULE: /workspace/node_modules/@ht-lib/image-reference-validator/lib/index.js
var lib = __webpack_require__("a67d");

// EXTERNAL MODULE: external "@ht-lib/image-util"
var image_util_ = __webpack_require__("38a2");

// CONCATENATED MODULE: ./src/class.ts
const classNameRegEx = /[^a-zA-Z0-9-\s]/g;
const classNameValid = name => name.trim().length > 0 && !classNameRegEx.test(name.trim());
const sanitizeClassName = name => name.trim().replace(classNameRegEx, '');
// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ImageUpload.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};












var ImageState;
(function (ImageState) {
  ImageState["needsImage"] = "needsImage";
  ImageState["needsConfirmation"] = "needsConfirmation";
  ImageState["needsData"] = "needsData";
  ImageState["done"] = "done";
})(ImageState || (ImageState = {}));
let ImageUploadvue_type_script_lang_ts_default_1 = class default_1 extends external_vue_default.a {
  constructor() {
    super(...arguments);
    this.loaded = false;
    this.canChooseMarket = true;
    this.canChooseJobType = false;
    this.canChooseJobSubtype = false;
    this.userSelectedMarket = common_option('S', 'Schools');
    this.userSelectedPhotographer = common_option('', 'Photographer');
    this.userSelectedClassName = common_option('', '');
    this.userSelectedShotType = common_option(accounts_models_["ShotType"].PortraitMode.toString(), 'Portrait');
    this.userSelectedJobType = common_option('', 'Job Type');
    this.userSelectedJobSubtype = common_option('', 'JST');
    this.errorMessages = [];
    this.ref = null;
    this.longRef = null;
    this.imageState = ImageState.needsImage;
  }
  get hasRequiredData() {
    var _a;
    if (this.photographers.length === 0) {
      console.log('No photographers found in job or images');
      return false;
    }
    if (this.takeDate == null) {
      console.log('No take date found in job or images');
      return false;
    }
    if (((_a = this.job) === null || _a === void 0 ? void 0 : _a.jobType) === null && this.jobTypesFromImages.length === 0 && this.jobSubTypesFromImages.length === 0) {
      console.log('No job type or job subtype found in job or images');
      return false;
    }
    return true;
  }
  // If this is a Nexus CD Upload job it won't have a cloud job, so images act as a fallback for collecting data
  // Also acts as a fallback for any data not found on the job
  get images() {
    return imageStore["a" /* ImageStore */].Instance.allImages;
  }
  get markets() {
    return this.canChooseMarket ? [common_option('S', 'Schools'), common_option('G', 'Grads')] : [this.userSelectedMarket];
  }
  get jobTypes() {
    return this.canChooseJobType ? this.jobTypesFromImages : [this.userSelectedJobType];
  }
  get jobSubtypes() {
    return this.canChooseJobSubtype ? this.jobSubTypesFromImages : [this.userSelectedMarket];
  }
  get jobTypesFromImages() {
    return common_options(this.images, 'jobType');
  }
  get jobSubTypesFromImages() {
    return common_options(this.images, 'jobSubTypeId');
  }
  get photographers() {
    if (this.job != null) {
      return common_options(Object.values(this.job.photographersMap), 'code', 'name');
    } else {
      return common_options(this.images, 'photographerCode');
    }
  }
  get classes() {
    return common_options(this.images, 'className');
  }
  get shotTypes() {
    return [common_option(accounts_models_["ShotType"].PortraitMode.toString(), 'Portrait'), common_option(accounts_models_["ShotType"].IndoorGroup.toString(), 'Groups')];
  }
  get takeDateFromImages() {
    return Object(external_lodash_["uniq"])(this.images.map(i => i.takeDate).filter(date => date != null));
  }
  get takeDate() {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.job) === null || _a === void 0 ? void 0 : _a.takeDate) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : this.takeDateFromImages[0];
  }
  get userJobType() {
    const jobType = this.userSelectedJobType.value;
    return jobType.length > 0 ? jobType : null;
  }
  get userJobSubtype() {
    const jobSubtype = this.userSelectedJobSubtype.value;
    return jobSubtype.length > 0 ? parseInt(jobSubtype, 10) : null;
  }
  get showImageSelect() {
    return this.imageState === ImageState.needsImage;
  }
  get showUploadConfirmation() {
    return this.imageState === ImageState.needsConfirmation;
  }
  get showDataCollection() {
    return this.imageState === ImageState.needsData;
  }
  get showDoneActions() {
    return this.imageState === ImageState.done;
  }
  get imageOnSameAccount() {
    return this.image != null && this.image.accountCode === this.accountCode && this.image.jobCode === this.jobCode;
  }
  get validatedForm() {
    var _a, _b;
    const photographerCode = this.userSelectedPhotographer.value;
    const className = this.userSelectedClassName.value;
    const takeDate = this.takeDate;
    const jobType = (_b = (_a = this.job) === null || _a === void 0 ? void 0 : _a.jobType) !== null && _b !== void 0 ? _b : this.userJobType;
    const jobSubTypeId = this.userJobSubtype;
    const shotTypeId = parseInt(this.userSelectedShotType.value, 10);
    const ref = this.ref;
    const longRef = this.longRef;
    const errors = [];
    this.errorMessages = [];
    if (photographerCode === '') {
      errors.push('Please choose a photographer');
    }
    if (className.length === 0) {
      errors.push('Please choose a class name');
    }
    if (takeDate == null) {
      errors.push('Could not get take date');
    }
    if (jobType == null && jobSubTypeId == null) {
      errors.push('Please choose a job type or job subtype');
    }
    if (ref == null || longRef == null) {
      errors.push('image reference not set, make sure a file has been selected');
    }
    errors.forEach(e => this.errorMessages.push(e));
    if (errors.length > 0) {
      return {
        hasErrors: 'true',
        errors
      };
    }
    return {
      hasErrors: 'false',
      photographerCode,
      className,
      takeDate: takeDate,
      jobType,
      jobSubTypeId,
      shotTypeId,
      ref: ref,
      longRef: longRef
    };
  }
  async created() {
    var _a;
    if (((_a = this.job) === null || _a === void 0 ? void 0 : _a.jobType) != null) {
      this.userSelectedJobType = common_option(this.job.jobType);
      await this.setMarket(this.job.jobType);
    } else if (this.jobTypesFromImages.length === 1) {
      this.userSelectedJobType = this.jobTypesFromImages[0];
      await this.setMarket(this.jobTypesFromImages[0].value);
    } else if (this.jobSubTypesFromImages.length === 1) {
      this.userSelectedJobSubtype = this.jobSubTypesFromImages[0];
    } else {
      this.canChooseJobType = this.jobTypesFromImages.length > 0;
      this.canChooseJobSubtype = this.jobSubTypesFromImages.length > 0;
    }
    this.loaded = true;
  }
  async setMarket(jobType) {
    var _a;
    const aimsData = await Object(accounts_common_["getJobTypeFromCode"])(jobType);
    this.updateMarket(common_option((_a = aimsData === null || aimsData === void 0 ? void 0 : aimsData.market) !== null && _a !== void 0 ? _a : 'S'));
    this.canChooseMarket = false;
  }
  updateMarket(input) {
    console.log('market input', input);
    this.userSelectedMarket = input;
  }
  updateJobType(input) {
    console.log('jobType input', input);
    this.userSelectedJobType = input;
  }
  updateJobSubtype(input) {
    console.log('jst input', input);
    this.userSelectedJobSubtype = input;
  }
  updatePhotographer(input) {
    console.log('photographer input', input);
    this.userSelectedPhotographer = input;
  }
  updateClass(input) {
    console.log('class input', input);
    if (input == null) {
      input = '';
    }
    if (typeof input === 'string') {
      input = common_option(input);
    }
    input.value = sanitizeClassName(input.value);
    this.userSelectedClassName = input;
  }
  updateShotType(input) {
    console.log('shotType input', input);
    this.userSelectedShotType = input;
  }
  selectImageButtonClicked() {
    this.selectImageInput.value = '';
    this.selectImageInput.click();
  }
  reset() {
    this.ref = null;
    this.longRef = null;
    this.image = undefined;
    this.file = undefined;
    this.errorMessages = [];
    this.imageState = ImageState.needsImage;
  }
  async inputFile(files) {
    var _a;
    this.reset();
    const file = files.item(0);
    if (file == null) {
      return;
    }
    this.file = file;
    const name = file.name.toUpperCase();
    if (!name.endsWith('.JPG') && !name.endsWith('.JPEG')) {
      return;
    }
    let ref = name.split('.')[0];
    let longRef = '';
    const filenameIsLongref = ref.length === 32 && /^[\da-f]+$/i.test(ref);
    let existingImage;
    if (filenameIsLongref) {
      longRef = ref;
      ref = ref.substring(0, 10);
      existingImage = await firebase_adapter_["Image"].byId(longRef).singleOrNull();
    } else if (Object(lib["validateImageRef"])(ref)) {
      longRef = await firebase_adapter_["Image"].generateImageLongref(ref);
      if (((_a = this.job) === null || _a === void 0 ? void 0 : _a.market) != null) {
        existingImage = await firebase_adapter_["Image"].byRef(this.job.market, ref).singleOrNull();
      }
    } else {
      longRef = await firebase_adapter_["Image"].generateImageLongref();
      ref = longRef.substring(0, 10);
    }
    this.image = existingImage;
    this.ref = ref;
    this.longRef = longRef;
    this.imageState = existingImage == null ? ImageState.needsData : ImageState.needsConfirmation;
    console.log('got file names', ref, longRef, this.image, this.imageState);
  }
  async checkImage() {
    const market = this.userSelectedMarket.value;
    const ref = this.ref;
    const image = await firebase_adapter_["Image"].byRef(market, ref).singleOrNull();
    if (image == null) {
      await this.doUpload();
    } else {
      this.image = image;
      this.imageState = ImageState.needsConfirmation;
    }
  }
  async doUpload() {
    try {
      if (this.file == null) {
        throw new Error('File must be selected before upload');
      }
      const labUploader = await Object(accounts_common_["getUserProfileId"])();
      const image = this.getImage(labUploader);
      const doc = firebase_adapter_["Image"].byId(image.longRef);
      const data = await doc.singleOrNull();
      if (data == null) {
        image.isPreferred = Object(accounts_common_["getImageNewPreferredValue"])(this.images, Object(accounts_common_["imageChangeData"])(image));
        console.log('image', image);
        await firebase_adapter_["Image"].addImage(image.longRef, image);
        await Object(accounts_api_client_["insertImageToExistingJob"])(image.longRef);
      }
      await Object(image_util_["uploadSingleImage"])({
        longRef: image.longRef,
        file: this.file,
        uploaded: false
      });
      // TODO:: Ensure QCReview screen is reactive to changes in upload status of new image
    } catch (e) {
      console.log('image error', e);
      this.errorMessages.push('Could not successfullly upload the image. Please try again.');
    } finally {
      this.imageState = ImageState.done;
    }
  }
  getImage(labUploader) {
    var _a, _b, _c, _d, _e, _f;
    const result = this.validatedForm;
    if (result.hasErrors === 'true') {
      throw new Error('Some data was incorrect ' + result.errors.join('\n'));
    }
    const {
      photographerCode,
      className,
      takeDate,
      jobType,
      jobSubTypeId,
      shotTypeId,
      ref,
      longRef
    } = result;
    return {
      longRef,
      ref,
      market: this.userSelectedMarket.value,
      status: accounts_models_["ImageStatus"].NONE,
      photographerCode,
      className,
      shotTypeId,
      orientation: shotTypeId === accounts_models_["ShotType"].PortraitMode ? 270 : 0,
      takeDate,
      labUploader,
      jobType,
      jobSubTypeId,
      accountCode: this.accountCode,
      jobCode: this.jobCode,
      accountId: (_b = (_a = this.job) === null || _a === void 0 ? void 0 : _a.accountId) !== null && _b !== void 0 ? _b : null,
      bookingId: (_d = (_c = this.job) === null || _c === void 0 ? void 0 : _c.bookingId) !== null && _d !== void 0 ? _d : null,
      jobId: (_f = (_e = this.job) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : null,
      uploaded: false,
      childProtectionIssue: false,
      imported: false,
      studioFlagged: false,
      studioRejected: false,
      isPreferred: false,
      uploaderId: null,
      pupilName: null,
      nexusId: null,
      nudge: null,
      studioJobId: null,
      ratio: null,
      sizingCode: null,
      pupilId: null,
      hash: null,
      colourCorrection: null
    };
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true,
  type: String
})], ImageUploadvue_type_script_lang_ts_default_1.prototype, "accountCode", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: false,
  default: null,
  type: String
})], ImageUploadvue_type_script_lang_ts_default_1.prototype, "jobCode", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: false,
  default: null
})], ImageUploadvue_type_script_lang_ts_default_1.prototype, "job", void 0);
__decorate([Object(external_vue_property_decorator_["Ref"])()], ImageUploadvue_type_script_lang_ts_default_1.prototype, "selectImageInput", void 0);
ImageUploadvue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'ImageUpload'
})], ImageUploadvue_type_script_lang_ts_default_1);
/* harmony default export */ var ImageUploadvue_type_script_lang_ts = (ImageUploadvue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/ImageUpload.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_ImageUploadvue_type_script_lang_ts = (ImageUploadvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/ImageUpload.vue?vue&type=style&index=0&id=d75c5056&prod&lang=stylus&scoped=true
var ImageUploadvue_type_style_index_0_id_d75c5056_prod_lang_stylus_scoped_true = __webpack_require__("ba27");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/directives/ClosePopup.js
var ClosePopup = __webpack_require__("e106");

// CONCATENATED MODULE: ./src/components/ImageUpload.vue






/* normalize component */

var ImageUpload_component = Object(componentNormalizer["a" /* default */])(
  components_ImageUploadvue_type_script_lang_ts,
  ImageUploadvue_type_template_id_d75c5056_scoped_true_lang_pug_render,
  ImageUploadvue_type_template_id_d75c5056_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "d75c5056",
  null
  
)

/* harmony default export */ var ImageUpload = (ImageUpload_component.exports);






runtime_auto_import_default()(ImageUpload_component, 'components', {QCard: QCard["a" /* default */],QCardSection: QCardSection["a" /* default */],QSpace: QSpace["a" /* default */],QBtn: QBtn["a" /* default */],QSelect: QSelect["a" /* default */]});runtime_auto_import_default()(ImageUpload_component, 'directives', {ClosePopup: ClosePopup["a" /* default */]});

// EXTERNAL MODULE: ./src/features.ts
var features = __webpack_require__("8310");

// EXTERNAL MODULE: external "@ht-lib/activity-collection"
var activity_collection_ = __webpack_require__("44d9");

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/QCReview.vue?vue&type=script&lang=ts
var QCReviewvue_type_script_lang_ts_decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};















let QCReviewvue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  constructor() {
    var _a;
    super(...arguments);
    this.allowDuplicatingImage = (_a = this.config.allowDuplicatingImage) !== null && _a !== void 0 ? _a : false;
    this.jobSnapshot = null;
    this.job = null;
    this.account = null;
    this.allowGroupImageAssignment = false;
    this.isPrintPending = false;
    this.showCheckPrint = false;
    this.hasPrinted = false;
    this.showJobNotes = false;
    this.showCreateClass = false;
    this.showAddImage = false;
    this.flaggedOnly = false;
    this.search = '';
    this.saving = false;
    this.finishing = false;
    this.showRejected = true;
    this.showJobInfoBar = true;
    this.jobNotes = '';
    this.newClassName = '';
    this.userMatchesJob = true;
    /** FEATURES */
    this.featureSplitJob = Object(features["b" /* isFeatureEnabled */])('SPLIT_JOB');
    /** */
    this.imageOptions = {
      showRef: false,
      showLinking: false
    };
  }
  get isLabQC() {
    return this.config.inLab;
  }
  get showMove() {
    return this.imageStore.selectedImageRefs.length > 0;
  }
  get classGroupImages() {
    if (this.job == null) {
      return undefined;
    }
    return this.job.classGroupImages;
  }
  get loaded() {
    return this.imageStore.loaded;
  }
  get jobData() {
    if (this.jobSnapshot !== null && this.job !== null) {
      return {
        id: this.jobSnapshot.id,
        ...this.job
      };
    }
    return null;
  }
  get jobIsCompleted() {
    var _a;
    return ((_a = this.job) === null || _a === void 0 ? void 0 : _a.status) === accounts_models_["JobStatus"].COMPLETE;
  }
  get imageStore() {
    // reactivity hack
    // if (typeof ImageStore.Instance.newImages === 'undefined') {
    //   throw new Error('This would never happen')
    // }
    return imageStore["a" /* ImageStore */].Instance;
  }
  get accountCode() {
    var _a, _b, _c, _d;
    return (_d = (_b = (_a = this.jobData) === null || _a === void 0 ? void 0 : _a.account.code) !== null && _b !== void 0 ? _b : (_c = this.aimsJobNumber) === null || _c === void 0 ? void 0 : _c.accountCode) !== null && _d !== void 0 ? _d : null;
  }
  get jobCode() {
    var _a, _b, _c, _d;
    return (_d = (_b = (_a = this.jobData) === null || _a === void 0 ? void 0 : _a.aimsJobNumber) !== null && _b !== void 0 ? _b : (_c = this.aimsJobNumber) === null || _c === void 0 ? void 0 : _c.jobCode) !== null && _d !== void 0 ? _d : null;
  }
  get hasJob() {
    return this.job != null;
  }
  get finishName() {
    return this.isLabQC ? 'Finish QC' : 'Commit To Lab';
  }
  get images() {
    console.debug('QCReview->images');
    let filtered;
    if (this.flaggedOnly) {
      filtered = this.imageStore.flaggedImages;
    } else {
      if (this.showRejected) {
        filtered = [...this.imageStore.normalImages, ...this.imageStore.flaggedImages, ...this.imageStore.rejectedImages];
      } else {
        filtered = [...this.imageStore.normalImages, ...this.imageStore.flaggedImages];
      }
    }
    const search = this.search.trim();
    if (search.length > 0) {
      filtered = this.imageStore.search(filtered, search);
    }
    return Object(external_lodash_["sortBy"])(filtered, x => x.photographerCode, x => x.className, x => x.takeDate);
  }
  get newClassNameValid() {
    return classNameValid(this.newClassName);
  }
  get show() {
    return this.job !== null;
  }
  get searchActive() {
    return this.search.trim().length > 0;
  }
  get showPrintWorksheet() {
    return this.config.showPrintWorksheet && this.job !== null && this.job.market !== 'G';
  }
  async updated() {
    var _a, _b, _c, _d;
    // console.debug('QCReview Updated')
    if (this.isPrintPending) {
      console.log('Printing Job: ', (_a = this.jobSnapshot) === null || _a === void 0 ? void 0 : _a.id);
      window.print();
      this.hasPrinted = true;
      this.isPrintPending = false;
      if (this.jobSnapshot) {
        await Object(activity_collection_["addActivity"])({
          contextId: this.jobSnapshot.id,
          userId: (_c = (_b = this.$auth.user) === null || _b === void 0 ? void 0 : _b.uid) !== null && _c !== void 0 ? _c : 'UNKNOWN',
          message: 'Printed job worksheet',
          type: activity_collection_["ActivityType"].JOB,
          labels: ['jobQcWorksheetPrinted', `status: ${(_d = this.job) === null || _d === void 0 ? void 0 : _d.status}`]
        });
      }
    }
  }
  async beforeDestroy() {
    var _a, _b;
    console.debug('QCReview->beforeDestroy');
    if (this.finishing) {
      this.finishing = false;
    } else if (this.jobSnapshot != null && ((_a = this.job) === null || _a === void 0 ? void 0 : _a.status) === accounts_models_["JobStatus"].QC_IN_PROGRESS && this.userMatchesJob) {
      const update = {
        status: accounts_models_["JobStatus"].READY_FOR_QC
      };
      await Object(accounts_common_["updateJob"])(this.jobSnapshot.id, update);
    }
    (_b = this.accountUnlisten) === null || _b === void 0 ? void 0 : _b.call(this);
    imageStore["a" /* ImageStore */].ClearJob();
  }
  async saveNotes() {
    if (this.jobSnapshot != null && this.hasJob) {
      await Object(accounts_common_["updateJob"])(this.jobSnapshot.id, {
        notes: this.jobNotes
      });
      this.job.notes = this.jobNotes;
    }
    this.showJobNotes = false;
  }
  async created() {
    var _a, _b, _c, _d, _e, _f;
    this.showJobInfoBar = this.showJobInfo;
    this.flaggedOnly = this.isLabQC;
    if (this.jobSnap != null) {
      this.jobSnapshot = this.jobSnap;
      this.job = this.jobSnapshot.data();
    } else if (this.jobId != null) {
      console.log('QC - Loading new Job');
      this.jobSnapshot = await Object(accounts_common_["getJob"])(this.jobId);
      this.job = this.jobSnapshot.data();
      /** QC in Progress -- GUARD */
      const userViewing = this.job.userViewing;
      const currentUser = this.$auth.user;
      if (userViewing && currentUser) {
        this.userMatchesJob = userViewing.id === currentUser.uid;
        const qcInProgress = this.job.status === accounts_models_["JobStatus"].QC_IN_PROGRESS;
        const haveUserIds = currentUser.uid != null && currentUser.uid !== '' && userViewing.id != null && userViewing.id !== '';
        const userMismatch = haveUserIds && !this.userMatchesJob;
        if (qcInProgress && userMismatch) {
          console.log('Job is in review and by another user');
          this.$q.dialog({
            title: 'QC in Progress',
            message: `This job is currently being reviewed by ${userViewing.name}.`,
            noEscDismiss: true,
            noBackdropDismiss: true,
            noRouteDismiss: false
          }).onOk(async () => {
            if (this.$route.redirectedFrom != null) {
              console.debug(`Redirecting to ${this.$route.redirectedFrom}`);
              await this.$router.replace(this.$route.redirectedFrom);
            } else {
              console.debug('Redirecting to root. (No redirectedFrom)');
              await this.$router.replace({
                path: '/'
              });
            }
          });
          return;
        }
      }
      /** END GUARD */
      imageStore["a" /* ImageStore */].LoadNewJob(this.jobSnapshot);
    } else if (((_a = this.aimsJobNumber) === null || _a === void 0 ? void 0 : _a.isComplete) === true) {
      console.log('QC - Loading new Job by AIMS');
      imageStore["a" /* ImageStore */].LoadNewAimsJobNumber(this.aimsJobNumber);
    }
    this.showRejected = !this.isLabQC;
    if (this.job != null && this.jobSnapshot != null && this.isLabQC && this.hasJob) {
      // This has been disabled. It's been temporarily replaced by the "Duplicate" option in the ImageControl menu.
      // await this.setAllowGroupImageAssignment(this.jobSnapshot.id)
      const accountId = this.job.accountId;
      if (accountId !== undefined) {
        this.accountUnlisten = Object(accounts_common_["getAccountRef"])(accountId).onSnapshot(acc => {
          var _a;
          this.account = (_a = acc.data()) !== null && _a !== void 0 ? _a : null;
        });
      }
    }
    this.jobNotes = (_c = (_b = this.job) === null || _b === void 0 ? void 0 : _b.notes) !== null && _c !== void 0 ? _c : '';
    this.hasPrinted = this.jobIsCompleted;
    if (this.jobSnapshot) {
      await Object(activity_collection_["addActivity"])({
        contextId: this.jobSnapshot.id,
        userId: (_e = (_d = this.$auth.user) === null || _d === void 0 ? void 0 : _d.uid) !== null && _e !== void 0 ? _e : 'UNKNOWN',
        message: 'QC job opened',
        type: activity_collection_["ActivityType"].JOB,
        labels: ['jobQcOpen', `status: ${(_f = this.job) === null || _f === void 0 ? void 0 : _f.status}`]
      });
    }
  }
  childProtection(isChildProtected, removeSelected = true) {
    this.imageStore.updateAllCPSelected(isChildProtected);
    if (removeSelected) {
      this.updateAllSelect(false);
    }
  }
  async setAllowGroupImageAssignment(jobId) {
    const jobConfig = await Object(axios["a" /* getAxios */])().get(`/https-job/api/job/${jobId}/config`);
    this.allowGroupImageAssignment = jobConfig.data.isGroupCombination;
  }
  showAssignGroupToClassDialog(longRef) {
    var _a, _b;
    console.log('showAssignGroupToClassDialog', longRef);
    this.$q.dialog({
      component: AssignGroupImageDialog,
      parent: this,
      jobId: this.jobId,
      classGroupImages: (_b = (_a = this.job) === null || _a === void 0 ? void 0 : _a.classGroupImages) !== null && _b !== void 0 ? _b : {},
      groupLongRef: longRef
    }).onOk(data => {
      external_vue_property_decorator_["Vue"].set(this.job, 'classGroupImages', data);
    });
  }
  updateAllSelect(selected) {
    this.imageStore.updateAllSelect(selected);
  }
  updateSelectedFlag(value) {
    this.updateAllStatus(value ? accounts_models_["ImageStatus"].FLAGGED : accounts_models_["ImageStatus"].NONE);
  }
  updateSelectedReject() {
    this.updateAllStatus(accounts_models_["ImageStatus"].REJECTED);
  }
  updateSelectedNone() {
    this.updateAllStatus(accounts_models_["ImageStatus"].NONE);
  }
  reset() {
    this.childProtection(false, false);
    this.updateSelectedNone();
  }
  updateAllStatus(status) {
    this.imageStore.updateSelectedStatus(status);
    this.updateAllSelect(false);
  }
  moveToNewClass() {
    const className = sanitizeClassName(this.newClassName);
    if (className.length > 0) {
      this.moveToClass(className);
      this.showCreateClass = false;
    }
  }
  async controlButton(bConfig) {
    await this.imageStore.save();
    if (bConfig.route != null) {
      await this.$router.push(bConfig.route);
    }
  }
  printWorksheet() {
    const print = () => {
      this.isPrintPending = true;
      this.showCheckPrint = false;
    };
    if (this.jobIsCompleted) {
      this.$q.dialog({
        title: 'Job has been Completed',
        message: 'This job has already been completed, are you sure you wish to reprint the worksheet?',
        cancel: true,
        persistent: true
      }).onOk(() => {
        print();
      });
    } else {
      print();
    }
  }
  async saveJob() {
    var _a, _b, _c;
    if (this.saving) return;
    this.saving = true;
    if (this.jobSnapshot) {
      await Object(activity_collection_["addActivity"])({
        contextId: this.jobSnapshot.id,
        userId: (_b = (_a = this.$auth.user) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : 'UNKNOWN',
        message: 'QC job saved',
        type: activity_collection_["ActivityType"].JOB,
        labels: ['jobQcSaved', `status: ${(_c = this.job) === null || _c === void 0 ? void 0 : _c.status}`]
      });
    }
    await this.controlButton(this.config.save);
    this.saving = false;
  }
  async finishQC() {
    var _a, _b, _c;
    if (this.finishing) return;
    if (this.isLabQC && this.showPrintWorksheet && !this.hasPrinted) {
      this.hasPrinted = true;
      this.printWorksheet();
      return;
    }
    this.finishing = true;
    if (this.config.finish.cb) {
      await this.config.finish.cb(this.jobSnapshot);
    }
    if (this.jobSnapshot) {
      await Object(activity_collection_["addActivity"])({
        contextId: this.jobSnapshot.id,
        userId: (_b = (_a = this.$auth.user) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : 'UNKNOWN',
        message: 'QC job finished',
        type: activity_collection_["ActivityType"].JOB,
        labels: ['jobQcFinish', `status: ${(_c = this.job) === null || _c === void 0 ? void 0 : _c.status}`]
      });
    }
    await this.controlButton(this.config.finish);
  }
  showMoveJob() {
    this.$q.dialog({
      component: JobMoveDialog,
      parent: this,
      aimsJobNumber: this.jobCode,
      sourceJobSnapshot: this.jobSnapshot,
      images: this.imageStore.selectedImages
    });
  }
  pageStyleFn(offset, height) {
    return `min-height: calc(100vh - ${this.config.height}px - 96px; border-right: 1px solid gainsboro;`;
  }
  showAll() {
    this.flaggedOnly = false;
  }
  clearSelectedImagesOnFilter() {
    this.updateAllSelect(false);
  }
  classCreatorShown() {
    this.$refs.newClassName.$el.focus();
    this.newClassName = '';
  }
  moveToClass(className) {
    this.imageStore.moveSelectedToClass(className);
    this.updateAllSelect(false);
  }
};
QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Prop"])()], QCReviewvue_type_script_lang_ts_default_1.prototype, "jobId", void 0);
QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Prop"])()], QCReviewvue_type_script_lang_ts_default_1.prototype, "jobSnap", void 0);
QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Prop"])()], QCReviewvue_type_script_lang_ts_default_1.prototype, "aimsJobNumber", void 0);
QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Prop"])({
  default: ''
})], QCReviewvue_type_script_lang_ts_default_1.prototype, "imageRef", void 0);
QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], QCReviewvue_type_script_lang_ts_default_1.prototype, "config", void 0);
QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Prop"])({
  default: true
})], QCReviewvue_type_script_lang_ts_default_1.prototype, "showJobInfo", void 0);
QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Provide"])('allow-duplicate-image')], QCReviewvue_type_script_lang_ts_default_1.prototype, "allowDuplicatingImage", void 0);
QCReviewvue_type_script_lang_ts_default_1 = QCReviewvue_type_script_lang_ts_decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'QCReview',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  components: {
    InfoBar: InfoBar,
    ViewGrid: ViewGrid["a" /* default */],
    Worksheet: Worksheet["a" /* default */],
    ImageUpload: ImageUpload
  }
})], QCReviewvue_type_script_lang_ts_default_1);
/* harmony default export */ var QCReviewvue_type_script_lang_ts = (QCReviewvue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/QCReview.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_QCReviewvue_type_script_lang_ts = (QCReviewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/QCReview.vue?vue&type=style&index=0&id=69b5a30d&prod&lang=css
var QCReviewvue_type_style_index_0_id_69b5a30d_prod_lang_css = __webpack_require__("bef4");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/drawer/QDrawer.js
var QDrawer = __webpack_require__("da18");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/scroll-area/QScrollArea.js
var QScrollArea = __webpack_require__("2747");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/input/QInput.js + 1 modules
var QInput = __webpack_require__("d114");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/toggle/QToggle.js
var QToggle = __webpack_require__("de96");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/page/QPageContainer.js
var QPageContainer = __webpack_require__("2b36");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/page/QPage.js
var QPage = __webpack_require__("74c0");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinner.js
var QSpinner = __webpack_require__("88a8");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/field/QField.js + 1 modules
var QField = __webpack_require__("135c");

// CONCATENATED MODULE: ./src/components/QCReview.vue






/* normalize component */

var QCReview_component = Object(componentNormalizer["a" /* default */])(
  components_QCReviewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var QCReview = __webpack_exports__["default"] = (QCReview_component.exports);


















runtime_auto_import_default()(QCReview_component, 'components', {QLayout: QLayout["a" /* default */],QDrawer: QDrawer["a" /* default */],QScrollArea: QScrollArea["a" /* default */],QInput: QInput["a" /* default */],QIcon: QIcon["a" /* default */],QToggle: QToggle["a" /* default */],QBtn: QBtn["a" /* default */],QPageContainer: QPageContainer["a" /* default */],QPage: QPage["a" /* default */],QSpinner: QSpinner["a" /* default */],QDialog: QDialog["a" /* default */],QCard: QCard["a" /* default */],QCardSection: QCardSection["a" /* default */],QCardActions: QCardActions["a" /* default */],QSpace: QSpace["a" /* default */],QSeparator: QSeparator["a" /* default */],QField: QField["a" /* default */]});runtime_auto_import_default()(QCReview_component, 'directives', {ClosePopup: ClosePopup["a" /* default */]});


/***/ }),

/***/ "a62b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_private_selection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ab5b");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d818");
/* harmony import */ var _utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("116d");




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    target: {
      default: true
    },
    noParentEvent: Boolean,
    contextMenu: Boolean
  },
  watch: {
    contextMenu(val) {
      if (this.anchorEl !== void 0) {
        this.__unconfigureAnchorEl();
        this.__configureAnchorEl(val);
      }
    },
    target() {
      if (this.anchorEl !== void 0) {
        this.__unconfigureAnchorEl();
      }
      this.__pickAnchorEl();
    },
    noParentEvent(val) {
      if (this.anchorEl !== void 0) {
        if (val === true) {
          this.__unconfigureAnchorEl();
        } else {
          this.__configureAnchorEl();
        }
      }
    }
  },
  methods: {
    __showCondition(evt) {
      // abort with no parent configured or on multi-touch
      if (this.anchorEl === void 0) {
        return false;
      }
      if (evt === void 0) {
        return true;
      }
      return evt.touches === void 0 || evt.touches.length <= 1;
    },
    __contextClick(evt) {
      this.hide(evt);
      this.$nextTick(() => {
        this.show(evt);
      });
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* prevent */ "i"])(evt);
    },
    __toggleKey(evt) {
      Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_3__[/* isKeyCode */ "a"])(evt, 13) === true && this.toggle(evt);
    },
    __mobileCleanup(evt) {
      this.anchorEl.classList.remove('non-selectable');
      clearTimeout(this.touchTimer);
      if (this.showing === true && evt !== void 0) {
        Object(_utils_private_selection_js__WEBPACK_IMPORTED_MODULE_0__[/* clearSelection */ "a"])();
      }
    },
    __mobilePrevent: _utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* prevent */ "i"],
    __mobileTouch(evt) {
      this.__mobileCleanup(evt);
      if (this.__showCondition(evt) !== true) {
        return;
      }
      this.hide(evt);
      this.anchorEl.classList.add('non-selectable');
      const target = evt.target;
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* addEvt */ "a"])(this, 'anchor', [[target, 'touchmove', '__mobileCleanup', 'passive'], [target, 'touchend', '__mobileCleanup', 'passive'], [target, 'touchcancel', '__mobileCleanup', 'passive'], [this.anchorEl, 'contextmenu', '__mobilePrevent', 'notPassive']]);
      this.touchTimer = setTimeout(() => {
        this.show(evt);
      }, 300);
    },
    __unconfigureAnchorEl() {
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* cleanEvt */ "b"])(this, 'anchor');
    },
    __configureAnchorEl(context = this.contextMenu) {
      if (this.noParentEvent === true || this.anchorEl === void 0) {
        return;
      }
      let evts;
      if (context === true) {
        if (this.$q.platform.is.mobile === true) {
          evts = [[this.anchorEl, 'touchstart', '__mobileTouch', 'passive']];
        } else {
          evts = [[this.anchorEl, 'click', 'hide', 'passive'], [this.anchorEl, 'contextmenu', '__contextClick', 'notPassive']];
        }
      } else {
        evts = [[this.anchorEl, 'click', 'toggle', 'passive'], [this.anchorEl, 'keyup', '__toggleKey', 'passive']];
      }
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* addEvt */ "a"])(this, 'anchor', evts);
    },
    __setAnchorEl(el) {
      this.anchorEl = el;
      while (this.anchorEl.classList.contains('q-anchor--skip')) {
        this.anchorEl = this.anchorEl.parentNode;
      }
      this.__configureAnchorEl();
    },
    __pickAnchorEl() {
      if (this.target === false || this.target === '' || this.parentEl === null) {
        this.anchorEl = void 0;
      } else if (this.target === true) {
        this.__setAnchorEl(this.parentEl);
      } else {
        this.anchorEl = Object(_utils_dom_js__WEBPACK_IMPORTED_MODULE_2__[/* getElement */ "d"])(this.target) || void 0;
        if (this.anchorEl !== void 0) {
          this.__configureAnchorEl();
        } else {
          console.error(`Anchor: target "${this.target}" not found`, this);
        }
      }
    },
    __changeScrollEvent(scrollTarget, fn) {
      const fnProp = `${fn !== void 0 ? 'add' : 'remove'}EventListener`;
      const fnHandler = fn !== void 0 ? fn : this.__scrollFn;
      if (scrollTarget !== window) {
        scrollTarget[fnProp]('scroll', fnHandler, _utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* listenOpts */ "f"].passive);
      }
      window[fnProp]('scroll', fnHandler, _utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* listenOpts */ "f"].passive);
      this.__scrollFn = fn;
    }
  },
  created() {
    if (typeof this.__configureScrollTarget === 'function' && typeof this.__unconfigureScrollTarget === 'function') {
      this.noParentEventWatcher = this.$watch('noParentEvent', () => {
        if (this.__scrollTarget !== void 0) {
          this.__unconfigureScrollTarget();
          this.__configureScrollTarget();
        }
      });
    }
  },
  mounted() {
    this.parentEl = this.$el.parentNode;
    this.__pickAnchorEl();
    if (this.value === true && this.anchorEl === void 0) {
      this.$emit('input', false);
    }
  },
  beforeDestroy() {
    clearTimeout(this.touchTimer);
    this.noParentEventWatcher !== void 0 && this.noParentEventWatcher();
    this.__anchorCleanup !== void 0 && this.__anchorCleanup();
    this.__unconfigureAnchorEl();
  }
});

/***/ }),

/***/ "a67d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLongRef = exports.validateImageRef = void 0;
function validateImageRef(imageRef, { allowPartial, allowEmpty } = {}) {
    const SIZE = 10;
    const TEST_EXP = /^[\da-f]+$/i;
    if (imageRef === undefined || imageRef.length === 0) {
        return allowEmpty === true;
    }
    if (allowPartial === true) {
        return TEST_EXP.test(imageRef);
    }
    if (imageRef.length === SIZE) {
        return TEST_EXP.test(imageRef);
    }
    return false;
}
exports.validateImageRef = validateImageRef;
function validateLongRef(longRef, { allowNexusLongRef = true } = {}) {
    if (typeof longRef !== 'string') {
        return false;
    }
    const TEST_EXP = /^[0-9A-F]{32}$/;
    const NEXUS_TEXT_EXP = /^[GS]-\d+$/;
    if (allowNexusLongRef && NEXUS_TEXT_EXP.test(longRef)) {
        return true;
    }
    return TEST_EXP.test(longRef);
}
exports.validateLongRef = validateLongRef;


/***/ }),

/***/ "a7f3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    __refocusTargetEl() {
      if (this.disable !== true) {
        return this.$createElement('span', {
          ref: 'refocusTarget',
          staticClass: 'no-outline',
          attrs: {
            tabindex: -1
          }
        });
      }
    }
  },
  methods: {
    __refocusTarget(e) {
      if (e !== void 0 && e.type.indexOf('key') === 0) {
        if (document.activeElement !== this.$el && this.$el.contains(document.activeElement) === true) {
          this.$el.focus();
        }
      } else if ((e === void 0 || this.$el.contains(e.target) === true) && this.$refs.refocusTarget !== void 0) {
        this.$refs.refocusTarget.focus();
      }
    }
  }
});

/***/ }),

/***/ "a7fa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {/* unused harmony export CONSTANTS */
/* unused harmony export DecodeBase64StringError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deferred; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ErrorFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FirebaseError; });
/* unused harmony export MAX_VALUE_MILLIS */
/* unused harmony export RANDOM_FACTOR */
/* unused harmony export Sha1 */
/* unused harmony export areCookiesEnabled */
/* unused harmony export assert */
/* unused harmony export assertionError */
/* unused harmony export async */
/* unused harmony export base64 */
/* unused harmony export base64Decode */
/* unused harmony export base64Encode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return base64urlEncodeWithoutPadding; });
/* unused harmony export calculateBackoffMillis */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return contains; });
/* unused harmony export createMockUserToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createSubscribe; });
/* unused harmony export decode */
/* unused harmony export deepCopy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deepExtend; });
/* unused harmony export errorPrefix */
/* unused harmony export extractQuerystring */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDefaultAppConfig; });
/* unused harmony export getDefaultEmulatorHost */
/* unused harmony export getDefaultEmulatorHostnameAndPort */
/* unused harmony export getDefaults */
/* unused harmony export getExperimentalSetting */
/* unused harmony export getGlobal */
/* unused harmony export getModularInstance */
/* unused harmony export getUA */
/* unused harmony export isAdmin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isBrowser; });
/* unused harmony export isBrowserExtension */
/* unused harmony export isElectron */
/* unused harmony export isEmpty */
/* unused harmony export isIE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isIndexedDBAvailable; });
/* unused harmony export isMobileCordova */
/* unused harmony export isNode */
/* unused harmony export isNodeSdk */
/* unused harmony export isReactNative */
/* unused harmony export isSafari */
/* unused harmony export isUWP */
/* unused harmony export isValidFormat */
/* unused harmony export isValidTimestamp */
/* unused harmony export issuedAtTime */
/* unused harmony export jsonEval */
/* unused harmony export map */
/* unused harmony export ordinal */
/* unused harmony export promiseWithTimeout */
/* unused harmony export querystring */
/* unused harmony export querystringDecode */
/* unused harmony export safeGet */
/* unused harmony export stringLength */
/* unused harmony export stringToByteArray */
/* unused harmony export stringify */
/* unused harmony export uuidv4 */
/* unused harmony export validateArgCount */
/* unused harmony export validateCallback */
/* unused harmony export validateContextObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return validateIndexedDBOpenable; });
/* unused harmony export validateNamespace */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw new DecodeBase64StringError();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (const prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
    if (typeof process === 'undefined' || "object" === 'undefined') {
        return;
    }
    const defaultsJsonString = Object({"NODE_ENV":"production","BASE_URL":"/"}).__FIREBASE_DEFAULTS__;
    if (defaultsJsonString) {
        return JSON.parse(defaultsJsonString);
    }
};
const getDefaultsFromCookie = () => {
    if (typeof document === 'undefined') {
        return;
    }
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    }
    catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
    try {
        return (getDefaultsFromGlobal() ||
            getDefaultsFromEnvVariable() ||
            getDefaultsFromCookie());
    }
    catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */
const getDefaultEmulatorHost = (productName) => { var _a, _b; return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName]; };
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */
const getDefaultEmulatorHostnameAndPort = (productName) => {
    const host = getDefaultEmulatorHost(productName);
    if (!host) {
        return undefined;
    }
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
        throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    }
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') {
        // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
        return [host.substring(1, separatorIndex - 1), port];
    }
    else {
        return [host.substring(0, separatorIndex), port];
    }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const getDefaultAppConfig = () => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config; };
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */
const getExperimentalSetting = (name) => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`]; };

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    const payload = Object.assign({ 
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`, aud: project, iat, exp: iat + 3600, auth_time: iat, sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') {
        return true;
    }
    else if (forceEnvironment === 'browser') {
        return false;
    }
    try {
        return (Object.prototype.toString.call(global.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        !!navigator.userAgent &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    }
    catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */
function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(() => deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams)) {
        if (Array.isArray(value)) {
            value.forEach(arrayVal => {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(token => {
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
    constructor() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (let i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    compress_(buf, offset) {
        if (!offset) {
            offset = 0;
        }
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (let i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (let i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (let i = 16; i < 80; i++) {
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (let i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            const t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */
    digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (let i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for (let i = 0; i < 5; i++) {
            for (let j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    constructor(executor, onNoObservers) {
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(() => {
            executor(this);
        })
            .catch(e => {
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer) => {
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer) => {
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer) => {
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error,
                complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(() => {
                try {
                    if (this.finalError) {
                        observer.error(this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    }
    forEachObserver(fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (let i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            if (this.observers !== undefined && this.observers[i] !== undefined) {
                try {
                    fn(this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    }
    close(err) {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return (...args) => {
        Promise.resolve(true)
            .then(() => {
            fn(...args);
        })
            .catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const method of methods) {
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        const error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */
const uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return `${i}`;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    const dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}


//# sourceMappingURL=index.esm2017.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("30b0"), __webpack_require__("e7d7")))

/***/ }),

/***/ "a820":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rtlHasScrollBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getScrollTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getScrollHeight; });
/* unused harmony export getScrollWidth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getVerticalScrollPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getScrollPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHorizontalScrollPosition; });
/* unused harmony export animVerticalScrollTo */
/* unused harmony export animScrollTo */
/* unused harmony export animHorizontalScrollTo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setVerticalScrollPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setScrollPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setHorizontalScrollPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getScrollbarWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasScrollbar; });
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d818");


const scrollTargets = _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === true ? [] : [null, document, document.body, document.scrollingElement, document.documentElement];
let rtlHasScrollBugStatus;
function rtlHasScrollBug() {
  if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* isSSR */ "e"] === true) {
    return false;
  }
  if (rtlHasScrollBugStatus === void 0) {
    const scroller = document.createElement('div');
    const spacer = document.createElement('div');
    Object.assign(scroller.style, {
      direction: 'rtl',
      width: '1px',
      height: '1px',
      overflow: 'auto'
    });
    Object.assign(spacer.style, {
      width: '1000px',
      height: '1px'
    });
    scroller.appendChild(spacer);
    document.body.appendChild(scroller);
    scroller.scrollLeft = -1000;
    rtlHasScrollBugStatus = scroller.scrollLeft >= 0;
    scroller.remove();
  }
  return rtlHasScrollBugStatus;
}
function getScrollTarget(el, targetEl) {
  let target = Object(_dom_js__WEBPACK_IMPORTED_MODULE_1__[/* getElement */ "d"])(targetEl);
  if (target === null) {
    if (el !== Object(el) || typeof el.closest !== 'function') {
      return window;
    }
    target = el.closest('.scroll,.scroll-y,.overflow-auto');
  }
  return scrollTargets.includes(target) ? window : target;
}
function getScrollHeight(el) {
  return (el === window ? document.body : el).scrollHeight;
}
function getScrollWidth(el) {
  return (el === window ? document.body : el).scrollWidth;
}
function getVerticalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : scrollTarget.scrollTop;
}
const getScrollPosition = getVerticalScrollPosition;
function getHorizontalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : scrollTarget.scrollLeft;
}
function animVerticalScrollTo(el, to, duration = 0 /* , prevTime */) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getVerticalScrollPosition(el);
  if (duration <= 0) {
    if (pos !== to) {
      setScroll(el, to);
    }
    return;
  }
  requestAnimationFrame(nowTime => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to - pos) / Math.max(frameTime, duration) * frameTime;
    setScroll(el, newPos);
    if (newPos !== to) {
      animVerticalScrollTo(el, to, duration - frameTime, nowTime);
    }
  });
}
const animScrollTo = animVerticalScrollTo;
function animHorizontalScrollTo(el, to, duration = 0 /* , prevTime */) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getHorizontalScrollPosition(el);
  if (duration <= 0) {
    if (pos !== to) {
      setHorizontalScroll(el, to);
    }
    return;
  }
  requestAnimationFrame(nowTime => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to - pos) / Math.max(frameTime, duration) * frameTime;
    setHorizontalScroll(el, newPos);
    if (newPos !== to) {
      animHorizontalScrollTo(el, to, duration - frameTime, nowTime);
    }
  });
}
function setScroll(scrollTarget, offset) {
  if (scrollTarget === window) {
    window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, offset);
    return;
  }
  scrollTarget.scrollTop = offset;
}
function setHorizontalScroll(scrollTarget, offset) {
  if (scrollTarget === window) {
    window.scrollTo(offset, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    return;
  }
  scrollTarget.scrollLeft = offset;
}
function setVerticalScrollPosition(scrollTarget, offset, duration) {
  if (duration) {
    animVerticalScrollTo(scrollTarget, offset, duration);
    return;
  }
  setScroll(scrollTarget, offset);
}
const setScrollPosition = setVerticalScrollPosition;
function setHorizontalScrollPosition(scrollTarget, offset, duration) {
  if (duration) {
    animHorizontalScrollTo(scrollTarget, offset, duration);
    return;
  }
  setHorizontalScroll(scrollTarget, offset);
}
let size;
function getScrollbarWidth() {
  if (size !== void 0) {
    return size;
  }
  const inner = document.createElement('p'),
    outer = document.createElement('div');
  Object(_dom_js__WEBPACK_IMPORTED_MODULE_1__[/* css */ "b"])(inner, {
    width: '100%',
    height: '200px'
  });
  Object(_dom_js__WEBPACK_IMPORTED_MODULE_1__[/* css */ "b"])(outer, {
    position: 'absolute',
    top: '0px',
    left: '0px',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  });
  outer.appendChild(inner);
  document.body.appendChild(outer);
  const w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  let w2 = inner.offsetWidth;
  if (w1 === w2) {
    w2 = outer.clientWidth;
  }
  outer.remove();
  size = w1 - w2;
  return size;
}
function hasScrollbar(el, onY = true) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  return onY ? el.scrollHeight > el.clientHeight && (el.classList.contains('scroll') || el.classList.contains('overflow-auto') || ['auto', 'scroll'].includes(window.getComputedStyle(el)['overflow-y'])) : el.scrollWidth > el.clientWidth && (el.classList.contains('scroll') || el.classList.contains('overflow-auto') || ['auto', 'scroll'].includes(window.getComputedStyle(el)['overflow-x']));
}
/* unused harmony default export */ var _unused_webpack_default_export = ({
  getScrollTarget,
  getScrollHeight,
  getScrollWidth,
  getScrollPosition,
  getVerticalScrollPosition,
  getHorizontalScrollPosition,
  rtlHasScrollBug,
  animScrollTo,
  animVerticalScrollTo,
  animHorizontalScrollTo,
  setScrollPosition,
  setVerticalScrollPosition,
  setHorizontalScrollPosition,
  getScrollbarWidth,
  hasScrollbar
});

/***/ }),

/***/ "a8d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return listenOpts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return leftClick; });
/* unused harmony export middleClick */
/* unused harmony export rightClick */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getEventPath; });
/* unused harmony export getMouseWheelDistance */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return stop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return prevent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return stopAndPrevent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return stopAndPreventClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return preventDraggable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEvt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cleanEvt; });
const listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
};
try {
  var opts = Object.defineProperty({}, 'passive', {
    get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: {
          passive: true
        },
        notPassive: {
          passive: false
        },
        passiveCapture: {
          passive: true,
          capture: true
        },
        notPassiveCapture: {
          passive: false,
          capture: true
        }
      });
    }
  });
  window.addEventListener('qtest', null, opts);
  window.removeEventListener('qtest', null, opts);
} catch (e) {}
function noop() {}
function leftClick(e) {
  return e.button === 0;
}
function middleClick(e) {
  return e.button === 1;
}
function rightClick(e) {
  return e.button === 2;
}
function position(e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }
  return {
    top: e.clientY,
    left: e.clientX
  };
}
function getEventPath(e) {
  if (e.path) {
    return e.path;
  }
  if (e.composedPath) {
    return e.composedPath();
  }
  const path = [];
  let el = e.target;
  while (el) {
    path.push(el);
    if (el.tagName === 'HTML') {
      path.push(document);
      path.push(window);
      return path;
    }
    el = el.parentElement;
  }
}

// Reasonable defaults
const LINE_HEIGHT = 40,
  PAGE_HEIGHT = 800;
function getMouseWheelDistance(e) {
  let x = e.deltaX,
    y = e.deltaY;
  if ((x || y) && e.deltaMode) {
    const multiplier = e.deltaMode === 1 ? LINE_HEIGHT : PAGE_HEIGHT;
    x *= multiplier;
    y *= multiplier;
  }
  if (e.shiftKey && !x) {
    [y, x] = [x, y];
  }
  return {
    x,
    y
  };
}
function stop(e) {
  e.stopPropagation();
}
function prevent(e) {
  e.cancelable !== false && e.preventDefault();
}
function stopAndPrevent(e) {
  e.cancelable !== false && e.preventDefault();
  e.stopPropagation();
}
function stopAndPreventClick(evt) {
  stopAndPrevent(evt);
  if (evt.type === 'mousedown') {
    const handler = e => {
      e.target === evt.target && stopAndPrevent(e);
      document.removeEventListener('click', handler, listenOpts.notPassiveCapture);
    };
    document.addEventListener('click', handler, listenOpts.notPassiveCapture);
  }
}
function preventDraggable(el, status) {
  if (el === void 0 || status === true && el.__dragPrevented === true) {
    return;
  }
  const fn = status === true ? el => {
    el.__dragPrevented = true;
    el.addEventListener('dragstart', prevent, listenOpts.notPassiveCapture);
  } : el => {
    delete el.__dragPrevented;
    el.removeEventListener('dragstart', prevent, listenOpts.notPassiveCapture);
  };
  el.querySelectorAll('a, img').forEach(fn);
}
function create(name, {
  bubbles = false,
  cancelable = false
} = {}) {
  try {
    return new CustomEvent(name, {
      bubbles,
      cancelable
    });
  } catch (e) {
    // IE doesn't support `new Event()`, so...
    const evt = document.createEvent('Event');
    evt.initEvent(name, bubbles, cancelable);
    return evt;
  }
}
function addEvt(ctx, targetName, events) {
  const name = `__q_${targetName}_evt`;
  ctx[name] = ctx[name] !== void 0 ? ctx[name].concat(events) : events;
  events.forEach(evt => {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
  });
}
function cleanEvt(ctx, targetName) {
  const name = `__q_${targetName}_evt`;
  if (ctx[name] !== void 0) {
    ctx[name].forEach(evt => {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
    });
    ctx[name] = void 0;
  }
}

/*
 * also update /types/utils/event.d.ts
 */

/* unused harmony default export */ var _unused_webpack_default_export = ({
  listenOpts,
  leftClick,
  middleClick,
  rightClick,
  position,
  getEventPath,
  getMouseWheelDistance,
  stop,
  prevent,
  stopAndPrevent,
  preventDraggable,
  create
});

/***/ }),

/***/ "a951":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    // eslint-disable-next-line no-param-reassign
    options = {};
  } // eslint-disable-next-line no-underscore-dangle, no-param-reassign


  url = url && url.__esModule ? url.default : url;

  if (typeof url !== 'string') {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(1, -1);
  }

  if (options.hash) {
    // eslint-disable-next-line no-param-reassign
    url += options.hash;
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, '\\n'), "\"");
  }

  return url;
};

/***/ }),

/***/ "ab5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearSelection; });
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");

function clearSelection() {
  if (window.getSelection !== void 0) {
    const selection = window.getSelection();
    if (selection.empty !== void 0) {
      selection.empty();
    } else if (selection.removeAllRanges !== void 0) {
      selection.removeAllRanges();
      _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].is.mobile !== true && selection.addRange(document.createRange());
    }
  } else if (document.selection !== void 0) {
    document.selection.empty();
  }
}

/***/ }),

/***/ "ab6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mixins_size_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4ef2");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a50a");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    color: String,
    size: {
      type: [Number, String],
      default: '1em'
    }
  },
  computed: {
    cSize() {
      return this.size in _mixins_size_js__WEBPACK_IMPORTED_MODULE_0__[/* sizes */ "c"] ? `${_mixins_size_js__WEBPACK_IMPORTED_MODULE_0__[/* sizes */ "c"][this.size]}px` : this.size;
    },
    classes() {
      if (this.color) {
        return `text-${this.color}`;
      }
    }
  }
});

/***/ }),

/***/ "abb4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _canvas = __webpack_require__("f1aa");

var _canvas2 = _interopRequireDefault(_canvas);

var _svg = __webpack_require__("d4b4");

var _svg2 = _interopRequireDefault(_svg);

var _object = __webpack_require__("2767");

var _object2 = _interopRequireDefault(_object);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };

/***/ }),

/***/ "acfe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE2 = __webpack_require__("2c64");

var _CODE3 = _interopRequireDefault(_CODE2);

var _auto = __webpack_require__("43f8");

var _auto2 = _interopRequireDefault(_auto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128AUTO = function (_CODE) {
	_inherits(CODE128AUTO, _CODE);

	function CODE128AUTO(data, options) {
		_classCallCheck(this, CODE128AUTO);

		// ASCII value ranges 0-127, 200-211
		if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, (0, _auto2.default)(data), options));
		} else {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, data, options));
		}
		return _possibleConstructorReturn(_this);
	}

	return CODE128AUTO;
}(_CODE3.default);

exports.default = CODE128AUTO;

/***/ }),

/***/ "ad69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSSR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fromSSR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return onSSR; });
/* unused harmony export iosEmulated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return iosCorrection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return client; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-mixed-operators */


const isSSR = typeof window === 'undefined';
let fromSSR = false;
let onSSR = isSSR;
let iosEmulated = false;
let iosCorrection;
function getMatch(userAgent, platformMatch) {
  const match = /(edge|edga|edgios)\/([\w.]+)/.exec(userAgent) || /(opr)[\/]([\w.]+)/.exec(userAgent) || /(vivaldi)[\/]([\w.]+)/.exec(userAgent) || /(chrome|crios)[\/]([\w.]+)/.exec(userAgent) || /(iemobile)[\/]([\w.]+)/.exec(userAgent) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent) || /(firefox|fxios)[\/]([\w.]+)/.exec(userAgent) || /(webkit)[\/]([\w.]+)/.exec(userAgent) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(userAgent) || /(msie) ([\w.]+)/.exec(userAgent) || userAgent.indexOf('trident') >= 0 && /(rv)(?::| )([\w.]+)/.exec(userAgent) || userAgent.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(userAgent) || [];
  return {
    browser: match[5] || match[3] || match[1] || '',
    version: match[2] || match[4] || '0',
    versionNumber: match[4] || match[2] || '0',
    platform: platformMatch[0] || ''
  };
}
function getPlatformMatch(userAgent) {
  return /(ipad)/.exec(userAgent) || /(ipod)/.exec(userAgent) || /(windows phone)/.exec(userAgent) || /(iphone)/.exec(userAgent) || /(kindle)/.exec(userAgent) || /(silk)/.exec(userAgent) || /(android)/.exec(userAgent) || /(win)/.exec(userAgent) || /(mac)/.exec(userAgent) || /(linux)/.exec(userAgent) || /(cros)/.exec(userAgent) || /(playbook)/.exec(userAgent) || /(bb)/.exec(userAgent) || /(blackberry)/.exec(userAgent) || [];
}
const hasTouch = isSSR === false ? 'ontouchstart' in window || window.navigator.maxTouchPoints > 0 : false;
function applyIosCorrection(is) {
  iosCorrection = {
    is: {
      ...is
    }
  };
  delete is.mac;
  delete is.desktop;
  const platform = Math.min(window.innerHeight, window.innerWidth) > 414 ? 'ipad' : 'iphone';
  Object.assign(is, {
    mobile: true,
    ios: true,
    platform,
    [platform]: true
  });
}
function getPlatform(UA) {
  const userAgent = UA.toLowerCase(),
    platformMatch = getPlatformMatch(userAgent),
    matched = getMatch(userAgent, platformMatch),
    browser = {};
  if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    browser.versionNumber = parseInt(matched.versionNumber, 10);
  }
  if (matched.platform) {
    browser[matched.platform] = true;
  }
  const knownMobiles = browser.android || browser.ios || browser.bb || browser.blackberry || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.playbook || browser.silk || browser['windows phone'];

  // These are all considered mobile platforms, meaning they run a mobile browser
  if (knownMobiles === true || userAgent.indexOf('mobile') > -1) {
    browser.mobile = true;
    if (browser.edga || browser.edgios) {
      browser.edge = true;
      matched.browser = 'edge';
    } else if (browser.crios) {
      browser.chrome = true;
      matched.browser = 'chrome';
    } else if (browser.fxios) {
      browser.firefox = true;
      matched.browser = 'firefox';
    }
  }
  // If it's not mobile we should consider it's desktop platform, meaning it runs a desktop browser
  // It's a workaround for anonymized user agents
  // (browser.cros || browser.mac || browser.linux || browser.win)
  else {
    browser.desktop = true;
  }

  // Set iOS if on iPod, iPad or iPhone
  if (browser.ipod || browser.ipad || browser.iphone) {
    browser.ios = true;
  }
  if (browser['windows phone']) {
    browser.winphone = true;
    delete browser['windows phone'];
  }

  // Chrome, Opera 15+, Vivaldi and Safari are webkit based browsers
  if (browser.chrome || browser.opr || browser.safari || browser.vivaldi ||
  // we expect unknown, non iOS mobile browsers to be webkit based

  browser.mobile === true && browser.ios !== true && knownMobiles !== true) {
    browser.webkit = true;
  }

  // IE11 has a new token so we will assign it msie to avoid breaking changes
  if (browser.rv || browser.iemobile) {
    matched.browser = 'ie';
    browser.ie = true;
  }

  // Blackberry browsers are marked as Safari on BlackBerry
  if (browser.safari && browser.blackberry || browser.bb) {
    matched.browser = 'blackberry';
    browser.blackberry = true;
  }

  // Playbook browsers are marked as Safari on Playbook
  if (browser.safari && browser.playbook) {
    matched.browser = 'playbook';
    browser.playbook = true;
  }

  // Opera 15+ are identified as opr
  if (browser.opr) {
    matched.browser = 'opera';
    browser.opera = true;
  }

  // Stock Android browsers are marked as Safari on Android.
  if (browser.safari && browser.android) {
    matched.browser = 'android';
    browser.android = true;
  }

  // Kindle browsers are marked as Safari on Kindle
  if (browser.safari && browser.kindle) {
    matched.browser = 'kindle';
    browser.kindle = true;
  }

  // Kindle Silk browsers are marked as Safari on Kindle
  if (browser.safari && browser.silk) {
    matched.browser = 'silk';
    browser.silk = true;
  }
  if (browser.vivaldi) {
    matched.browser = 'vivaldi';
    browser.vivaldi = true;
  }

  // Assign the name and platform variable
  browser.name = matched.browser;
  browser.platform = matched.platform;
  if (isSSR === false) {
    if (userAgent.indexOf('electron') > -1) {
      browser.electron = true;
    } else if (document.location.href.indexOf('-extension://') > -1) {
      browser.bex = true;
    } else {
      if (window.Capacitor !== void 0) {
        browser.capacitor = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = 'capacitor';
      } else if (window._cordovaNative !== void 0 || window.cordova !== void 0) {
        browser.cordova = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = 'cordova';
      }
      if (hasTouch === true && browser.mac === true && (browser.desktop === true && browser.safari === true || browser.nativeMobile === true && browser.android !== true && browser.ios !== true && browser.ipad !== true)) {
        /*
        * Correction needed for iOS since the default
        * setting on iPad is to request desktop view; if we have
        * touch support and the user agent says it's a
        * desktop, we infer that it's an iPhone/iPad with desktop view
        * so we must fix the false positives
        */
        applyIosCorrection(browser);
      }
    }
    fromSSR = browser.nativeMobile === void 0 && browser.electron === void 0 && document.querySelector('[data-server-rendered]') !== null;
    if (fromSSR === true) {
      onSSR = true;
    }
  }
  return browser;
}
const userAgent = isSSR !== true ? navigator.userAgent || navigator.vendor || window.opera : '';
const ssrClient = {
  has: {
    touch: false,
    webStorage: false
  },
  within: {
    iframe: false
  }
};

// We export "client" for hydration error-free parts,
// like touch directives who do not (and must NOT) wait
// for the client takeover;
// Do NOT import this directly in your app, unless you really know
// what you are doing.
const client = isSSR === false ? {
  userAgent,
  is: getPlatform(userAgent),
  has: {
    touch: hasTouch,
    webStorage: (() => {
      try {
        if (window.localStorage) {
          return true;
        }
      } catch (e) {}
      return false;
    })()
  },
  within: {
    iframe: window.self !== window.top
  }
} : ssrClient;
const Platform = {
  install($q, queues) {
    if (isSSR === true) {
      // we're on server-side, so we push
      // to the server queue instead of
      // applying directly
      queues.server.push((q, ctx) => {
        q.platform = this.parseSSR(ctx.ssr);
      });
    } else if (fromSSR === true) {
      // must match with server-side before
      // client taking over in order to prevent
      // hydration errors
      Object.assign(this, client, iosCorrection, ssrClient);

      // takeover should increase accuracy for
      // the rest of the props; we also avoid
      // hydration errors
      queues.takeover.push(q => {
        onSSR = fromSSR = false;
        Object.assign(q.platform, client);
        iosCorrection = void 0;
      });

      // we need to make platform reactive
      // for the takeover phase
      vue__WEBPACK_IMPORTED_MODULE_0___default.a.util.defineReactive($q, 'platform', this);
    } else {
      // we don't have any business with SSR, so
      // directly applying...
      Object.assign(this, client);
      $q.platform = this;
    }
  }
};
if (isSSR === true) {
  Platform.parseSSR = ( /* ssrContext */ssr) => {
    const userAgent = ssr.req.headers['user-agent'] || ssr.req.headers['User-Agent'] || '';
    return {
      ...client,
      userAgent,
      is: getPlatform(userAgent)
    };
  };
} else {
  iosEmulated = client.is.ios === true && window.navigator.vendor.toLowerCase().indexOf('apple') === -1;
}
/* harmony default export */ __webpack_exports__["b"] = (Platform);

/***/ }),

/***/ "adc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerLinkProps; });
const trailingSlashRE = /\/?$/;
function equals(current, target) {
  if (Object.keys(current).length !== Object.keys(target).length) {
    return false;
  }

  // route query and params are strings when read from URL
  for (const key in target) {
    if (!(key in current) || String(current[key]) !== String(target[key])) {
      return false;
    }
  }
  return true;
}
function includes(current, target) {
  for (const key in target) {
    if (!(key in current)) {
      return false;
    }
  }
  return true;
}
function isSameRoute(current, target) {
  if (!target) {
    return false;
  }
  if (current.path && target.path) {
    return current.path.replace(trailingSlashRE, '') === target.path.replace(trailingSlashRE, '') && current.hash === target.hash && equals(current.query, target.query);
  }
  return typeof current.name === 'string' && current.name === target.name && current.hash === target.hash && equals(current.query, target.query) === true && equals(current.params, target.params) === true;
}
function isIncludedRoute(current, target) {
  return current.path.replace(trailingSlashRE, '/').indexOf(target.path.replace(trailingSlashRE, '/')) === 0 && (typeof target.hash !== 'string' || target.hash.length < 2 || current.hash === target.hash) && includes(current.query, target.query) === true;
}
const routerLinkProps = {
  // router-link
  to: [String, Object],
  exact: Boolean,
  append: Boolean,
  replace: Boolean,
  activeClass: {
    type: String,
    default: 'q-router-link--active'
  },
  exactActiveClass: {
    type: String,
    default: 'q-router-link--exact-active'
  },
  // regular <a> link
  href: String,
  target: String,
  // state
  disable: Boolean
};

// external props: type, tag
// external: fallbackTag

/* harmony default export */ __webpack_exports__["a"] = ({
  props: routerLinkProps,
  computed: {
    hasHrefLink() {
      return this.disable !== true && this.href !== void 0;
    },
    // beware, it gets overwritten in QRouteTab
    hasRouterLinkProps() {
      return this.$router !== void 0 && this.disable !== true && this.hasHrefLink !== true && this.to !== void 0 && this.to !== null && this.to !== '';
    },
    resolvedLink() {
      return this.hasRouterLinkProps === true ? this.__getLink(this.to, this.append) : null;
    },
    hasRouterLink() {
      return this.resolvedLink !== null;
    },
    hasLink() {
      return this.hasHrefLink === true || this.hasRouterLink === true;
    },
    linkTag() {
      return this.type === 'a' || this.hasLink === true ? 'a' : this.tag || this.fallbackTag || 'div';
    },
    linkAttrs() {
      return this.hasHrefLink === true ? {
        href: this.href,
        target: this.target
      } : this.hasRouterLink === true ? {
        href: this.resolvedLink.href,
        target: this.target
      } : {};
    },
    linkIsActive() {
      return this.hasRouterLink === true && isIncludedRoute(this.$route, this.resolvedLink.route);
    },
    linkIsExactActive() {
      return this.hasRouterLink === true && isSameRoute(this.$route, this.resolvedLink.route);
    },
    linkClass() {
      return this.hasRouterLink === true ? this.linkIsExactActive === true ? ` ${this.exactActiveClass} ${this.activeClass}` : this.exact === true ? '' : this.linkIsActive === true ? ` ${this.activeClass}` : '' : '';
    }
  },
  methods: {
    __getLink(to, append) {
      // we protect from accessing this.$route without
      // actually needing it so that we won't trigger
      // unnecessary updates in computed props using this method
      try {
        return append === true ? this.$router.resolve(to, this.$route, true) : this.$router.resolve(to);
      } catch (_) {}
      return null;
    },
    /**
     * @returns Promise<RouterLocation|RouterError|false> | Promise<RouterLocation|false|void>
     */
    __navigateToRouterLink(e, {
      returnRouterError,
      to,
      replace = this.replace,
      append
    } = {}) {
      if (this.disable === true) {
        // ensure native navigation is prevented in all cases,
        // like in QRouteTab where hasRouterLinkProps does not care about disable state
        e.preventDefault();
        return Promise.resolve(false);
      }
      if (
      // don't redirect with control keys;
      // should match RouterLink from Vue Router
      e.metaKey || e.altKey || e.ctrlKey || e.shiftKey ||
      // don't redirect on right click
      e.button !== void 0 && e.button !== 0 ||
      // don't redirect if it should open in a new window
      this.target === '_blank') {
        return Promise.resolve(false);
      }
      e.preventDefault();
      const resolvedLink = to === void 0 ? this.resolvedLink : this.__getLink(to, append);
      if (resolvedLink === null) {
        return Promise[returnRouterError === true ? 'reject' : 'resolve'](false);
      }
      const promise = this.$router[replace === true ? 'replace' : 'push'](resolvedLink.location);
      return returnRouterError === true ? promise : promise.catch(() => {});
    },
    __navigateOnClick(e) {
      if (this.hasRouterLink === true) {
        const go = opts => this.__navigateToRouterLink(e, opts);
        this.$emit('click', e, go);

        // for backward compatibility
        e.navigate === false && e.preventDefault();
        e.defaultPrevented !== true && go();
      } else {
        this.$emit('click', e);
      }
    }
  }
});

/***/ }),

/***/ "ae5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ariaHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return iconAsButton; });
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("479b");

const ariaHidden = {
  'aria-hidden': 'true'
};
const iconAsButton = {
  tabindex: 0,
  type: 'button',
  'aria-hidden': false,
  role: null
};
/* harmony default export */ __webpack_exports__["b"] = (Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_0__[/* getPropCacheMixin */ "c"])('$attrs', 'qAttrs'));

/***/ }),

/***/ "af68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return testPattern; });
// file referenced from docs

const hex = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/,
  hexa = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/,
  hexOrHexa = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/,
  rgb = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/,
  rgba = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
const testPattern = {
  date: v => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v),
  time: v => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v),
  fulltime: v => /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(v),
  timeOrFulltime: v => /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v),
  // -- RFC 5322 --
  // -- Added in v1.18.10 --
  // This is a basic helper validation.
  // For something more complex (like RFC 822) you should write and use your own rule.
  // We won't be accepting PRs to enhance the one below because of the reason above.
  email: v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v),
  hexColor: v => hex.test(v),
  hexaColor: v => hexa.test(v),
  hexOrHexaColor: v => hexOrHexa.test(v),
  rgbColor: v => rgb.test(v),
  rgbaColor: v => rgba.test(v),
  rgbOrRgbaColor: v => rgb.test(v) || rgba.test(v),
  hexOrRgbColor: v => hex.test(v) || rgb.test(v),
  hexaOrRgbaColor: v => hexa.test(v) || rgba.test(v),
  anyColor: v => hexOrHexa.test(v) || rgb.test(v) || rgba.test(v)
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  testPattern
});

/***/ }),

/***/ "b0a1":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".worksheet[data-v-4d0ef3ae]{display:none;width:210mm;min-height:294mm}.item-value[data-v-4d0ef3ae]{overflow-wrap:break-word;white-space:pre-line}@page{size:A4;margin:1cm}@media print{body[data-v-4d0ef3ae],html[data-v-4d0ef3ae]{width:210mm;height:294mm}.worksheet[data-v-4d0ef3ae]{display:block;border:initial;border-radius:initial;width:auto;min-height:0;box-shadow:none;background:initial;break-after:always}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b181":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");
// using it to manage SSR rendering with best performance

/* harmony default export */ __webpack_exports__["a"] = ({
  data() {
    return {
      canRender: !_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* onSSR */ "f"]
    };
  },
  mounted() {
    this.canRender === false && (this.canRender = true);
  }
});

/***/ }),

/***/ "b20c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a170");
/* harmony import */ var _spinner_QSpinner_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("88a8");
/* harmony import */ var _mixins_btn_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3f03");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("feae");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("116d");







const {
  passiveCapture
} = _utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* listenOpts */ "f"];
let touchTarget = void 0,
  keyboardTarget = void 0,
  mouseTarget = void 0;
const iconAttrs = {
  role: 'img',
  'aria-hidden': 'true'
};
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QBtn',
  mixins: [_mixins_btn_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"]],
  props: {
    percentage: Number,
    darkPercentage: Boolean
  },
  computed: {
    hasLabel() {
      return this.label !== void 0 && this.label !== null && this.label !== '';
    },
    computedRipple() {
      return this.ripple === false ? false : {
        keyCodes: this.hasLink === true ? [13, 32] : [13],
        ...(this.ripple === true ? {} : this.ripple)
      };
    },
    percentageStyle() {
      const val = Math.max(0, Math.min(100, this.percentage));
      if (val > 0) {
        return {
          transition: 'transform 0.6s',
          transform: `translateX(${val - 100}%)`
        };
      }
    },
    onEvents() {
      if (this.loading === true) {
        return {
          mousedown: this.__onLoadingEvt,
          touchstart: this.__onLoadingEvt,
          click: this.__onLoadingEvt,
          keydown: this.__onLoadingEvt,
          keyup: this.__onLoadingEvt
        };
      }
      if (this.isActionable === true) {
        const on = {
          ...this.qListeners,
          click: this.click,
          keydown: this.__onKeydown,
          mousedown: this.__onMousedown
        };
        if (this.$q.platform.has.touch === true) {
          on[`${on.touchstart === void 0 ? '&' : ''}touchstart`] = this.__onTouchstart;
        }
        return on;
      }
      return {
        // needed; especially for disabled <a> tags
        click: _utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stopAndPrevent */ "l"]
      };
    },
    directives() {
      if (this.disable !== true && this.ripple !== false) {
        return [{
          name: 'ripple',
          value: this.computedRipple,
          modifiers: {
            center: this.round
          }
        }];
      }
    }
  },
  methods: {
    click(e) {
      if (e !== void 0) {
        if (e.defaultPrevented === true) {
          return;
        }
        const el = document.activeElement;
        // focus button if it came from ENTER on form
        // prevent the new submit (already done)
        if (this.type === 'submit' && (this.$q.platform.is.ie === true && (e.clientX < 0 || e.clientY < 0) || el !== document.body && this.$el.contains(el) === false &&
        // required for iOS and desktop Safari
        el.contains(this.$el) === false)) {
          this.$el.focus();
          const onClickCleanup = () => {
            document.removeEventListener('keydown', _utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stopAndPrevent */ "l"], true);
            document.removeEventListener('keyup', onClickCleanup, passiveCapture);
            this.$el !== void 0 && this.$el.removeEventListener('blur', onClickCleanup, passiveCapture);
          };
          document.addEventListener('keydown', _utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stopAndPrevent */ "l"], true);
          document.addEventListener('keyup', onClickCleanup, passiveCapture);
          this.$el.addEventListener('blur', onClickCleanup, passiveCapture);
        }
      }
      this.__navigateOnClick(e);
    },
    __onKeydown(e) {
      this.$emit('keydown', e);
      if (Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_6__[/* isKeyCode */ "a"])(e, [13, 32]) === true) {
        if (keyboardTarget !== this.$el) {
          keyboardTarget !== void 0 && this.__cleanup();
          if (e.defaultPrevented !== true) {
            // focus external button if the focus helper was focused before
            this.$el.focus();
            keyboardTarget = this.$el;
            this.$el.classList.add('q-btn--active');
            document.addEventListener('keyup', this.__onPressEnd, true);
            this.$el.addEventListener('blur', this.__onPressEnd, passiveCapture);
          }
        }
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stopAndPrevent */ "l"])(e);
      }
    },
    __onTouchstart(e) {
      this.$emit('touchstart', e);
      if (touchTarget !== this.$el) {
        touchTarget !== void 0 && this.__cleanup();
        if (e.defaultPrevented !== true) {
          touchTarget = this.$el;
          const target = this.touchTargetEl = e.target;
          target.addEventListener('touchcancel', this.__onPressEnd, passiveCapture);
          target.addEventListener('touchend', this.__onPressEnd, passiveCapture);
        }
      }

      // avoid duplicated mousedown event
      // triggering another early ripple
      this.avoidMouseRipple = true;
      clearTimeout(this.mouseTimer);
      this.mouseTimer = setTimeout(() => {
        this.avoidMouseRipple = false;
      }, 200);
    },
    __onMousedown(e) {
      e.qSkipRipple = this.avoidMouseRipple === true;
      this.$emit('mousedown', e);
      if (mouseTarget !== this.$el) {
        mouseTarget !== void 0 && this.__cleanup();
        if (e.defaultPrevented !== true) {
          mouseTarget = this.$el;
          this.$el.classList.add('q-btn--active');
          document.addEventListener('mouseup', this.__onPressEnd, passiveCapture);
        }
      }
    },
    __onPressEnd(e) {
      // needed for IE (because it emits blur when focusing button from focus helper)
      if (e !== void 0 && e.type === 'blur' && document.activeElement === this.$el) {
        return;
      }
      if (e !== void 0 && e.type === 'keyup') {
        if (keyboardTarget === this.$el && Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_6__[/* isKeyCode */ "a"])(e, [13, 32]) === true) {
          // for click trigger
          const evt = new MouseEvent('click', e);
          evt.qKeyEvent = true;
          e.defaultPrevented === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* prevent */ "i"])(evt);
          e.cancelBubble === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stop */ "k"])(evt);
          this.$el.dispatchEvent(evt);
          Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stopAndPrevent */ "l"])(e);

          // for ripple
          e.qKeyEvent = true;
        }
        this.$emit('keyup', e);
      }
      this.__cleanup();
    },
    __cleanup(destroying) {
      const blurTarget = this.$refs.blurTarget;
      if (destroying !== true && (touchTarget === this.$el || mouseTarget === this.$el) && blurTarget !== void 0 && blurTarget !== document.activeElement && this.$el.contains(document.activeElement) === true) {
        blurTarget.setAttribute('tabindex', -1);
        blurTarget.focus();
      }
      if (touchTarget === this.$el) {
        const target = this.touchTargetEl;
        target.removeEventListener('touchcancel', this.__onPressEnd, passiveCapture);
        target.removeEventListener('touchend', this.__onPressEnd, passiveCapture);
        touchTarget = this.touchTargetEl = void 0;
      }
      if (mouseTarget === this.$el) {
        document.removeEventListener('mouseup', this.__onPressEnd, passiveCapture);
        mouseTarget = void 0;
      }
      if (keyboardTarget === this.$el) {
        document.removeEventListener('keyup', this.__onPressEnd, true);
        this.$el !== void 0 && this.$el.removeEventListener('blur', this.__onPressEnd, passiveCapture);
        keyboardTarget = void 0;
      }
      this.$el !== void 0 && this.$el.classList.remove('q-btn--active');
    },
    __onLoadingEvt(evt) {
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_5__[/* stopAndPrevent */ "l"])(evt);
      evt.qSkipRipple = true;
    }
  },
  beforeDestroy() {
    this.__cleanup(true);
  },
  render(h) {
    let inner = [];
    this.icon !== void 0 && inner.push(h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
      attrs: iconAttrs,
      props: {
        name: this.icon,
        left: this.stack === false && this.hasLabel === true
      }
    }));
    this.hasLabel === true && inner.push(h('span', {
      staticClass: 'block'
    }, [this.label]));
    inner = Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_4__[/* mergeSlot */ "a"])(inner, this, 'default');
    if (this.iconRight !== void 0 && this.round === false) {
      inner.push(h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
        attrs: iconAttrs,
        props: {
          name: this.iconRight,
          right: this.stack === false && this.hasLabel === true
        }
      }));
    }
    const child = [h('span', {
      staticClass: 'q-focus-helper',
      ref: 'blurTarget'
    })];
    if (this.loading === true && this.percentage !== void 0) {
      child.push(h('span', {
        staticClass: 'q-btn__progress absolute-full overflow-hidden',
        class: this.darkPercentage === true ? 'q-btn__progress--dark' : ''
      }, [h('span', {
        staticClass: 'q-btn__progress-indicator fit block',
        style: this.percentageStyle
      })]));
    }
    child.push(h('span', {
      staticClass: 'q-btn__wrapper col row q-anchor--skip',
      style: this.wrapperStyle
    }, [h('span', {
      staticClass: 'q-btn__content text-center col items-center q-anchor--skip',
      class: this.innerClasses
    }, inner)]));
    this.loading !== null && child.push(h('transition', {
      props: {
        name: 'q-transition--fade'
      }
    }, this.loading === true ? [h('span', {
      key: 'loading',
      staticClass: 'absolute-full flex flex-center'
    }, this.$scopedSlots.loading !== void 0 ? this.$scopedSlots.loading() : [h(_spinner_QSpinner_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])])] : void 0));
    return h(this.hasLink === true || this.type === 'a' ? 'a' : 'button', {
      staticClass: 'q-btn q-btn-item non-selectable no-outline',
      class: this.classes,
      style: this.style,
      attrs: this.attrs,
      on: this.onEvents,
      directives: this.directives
    }, child);
  }
}));

/***/ }),

/***/ "b47d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.a4160421.woff2";

/***/ }),

/***/ "b4cc":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".image-size[data-v-76fbbbc5]{min-height:480px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b720":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = __webpack_require__("559c");

// Encode data string
var encode = function encode(data, structure, separator) {
	var encoded = data.split('').map(function (val, idx) {
		return _constants.BINARIES[structure[idx]];
	}).map(function (val, idx) {
		return val ? val[data[idx]] : '';
	});

	if (separator) {
		var last = data.length - 1;
		encoded = encoded.map(function (val, idx) {
			return idx < last ? val + separator : val;
		});
	}

	return encoded.join('');
};

exports.default = encode;

/***/ }),

/***/ "b7fa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/anchor.js
var mixins_anchor = __webpack_require__("a62b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/timeout.js
var timeout = __webpack_require__("f3c6");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/model-toggle.js
var model_toggle = __webpack_require__("1dd9");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/dark.js
var dark = __webpack_require__("a583");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/portal.js
var portal = __webpack_require__("d485");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/transition.js
var transition = __webpack_require__("448b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/attrs.js
var attrs = __webpack_require__("ae5c");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Platform.js
var Platform = __webpack_require__("ad69");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/event.js
var utils_event = __webpack_require__("a8d5");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/private/vm.js
function getVmOfNode(el) {
  for (let node = el; node !== null; node = node.parentNode) {
    // node.__vue__ can be null if the instance was destroyed
    if (node.__vue__ !== void 0) {
      return node.__vue__;
    }
  }
}
function isVmChildOf(childVm, parentVm) {
  // node.__vue__ can be null if the instance was destroyed
  if (childVm === null || parentVm === null) {
    return null;
  }
  for (let vm = childVm; vm !== void 0; vm = vm.$parent) {
    if (vm === parentVm) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/menu/ClickOutside.js



let timer;
const {
    notPassiveCapture,
    passiveCapture
  } = utils_event["f" /* listenOpts */],
  handlers = {
    click: [],
    focus: []
  };
function hasModalsAbove(node) {
  while ((node = node.nextElementSibling) !== null) {
    if (node.classList.contains('q-dialog--modal')) {
      return true;
    }
  }
  return false;
}
function execHandlers(list, evt) {
  for (let i = list.length - 1; i >= 0; i--) {
    if (list[i](evt) === void 0) {
      return;
    }
  }
}
function globalHandler(evt) {
  clearTimeout(timer);

  // prevent autofocus on body resulting from blur
  if (evt.type === 'focusin' && (Platform["a" /* client */].is.ie === true && evt.target === document.body || evt.target.hasAttribute('tabindex') === true)) {
    timer = setTimeout(() => {
      execHandlers(handlers.focus, evt);
    }, Platform["a" /* client */].is.ie === true ? 500 : 200);
  } else {
    execHandlers(handlers.click, evt);
  }
}
/* harmony default export */ var ClickOutside = ({
  name: 'click-outside',
  bind(el, {
    value,
    arg
  }, vnode) {
    const vmEl = vnode.componentInstance || vnode.context;
    const ctx = {
      trigger: value,
      toggleEl: arg,
      handler(evt) {
        const target = evt.target;
        if (evt.qClickOutside !== true && document.body.contains(target) === true && target.nodeType !== 8 &&
        // directives that prevent click by using pointer-events none generate click on html element
        target !== document.documentElement && target.classList.contains('no-pointer-events') === false && hasModalsAbove(el) !== true && (ctx.toggleEl === void 0 || ctx.toggleEl.contains(target) === false) && (target === document.body || isVmChildOf(getVmOfNode(target), vmEl) === false)) {
          // mark the event as being processed by clickOutside
          // used to prevent refocus after menu close
          evt.qClickOutside = true;
          return ctx.trigger(evt);
        }
      }
    };
    if (el.__qclickoutside) {
      el.__qclickoutside_old = el.__qclickoutside;
    }
    el.__qclickoutside = ctx;
    if (handlers.click.length === 0) {
      document.addEventListener('mousedown', globalHandler, notPassiveCapture);
      document.addEventListener('touchstart', globalHandler, notPassiveCapture);
      document.addEventListener('focusin', globalHandler, passiveCapture);
    }
    handlers.click.push(ctx.handler);
    ctx.timerFocusin = setTimeout(() => {
      handlers.focus.push(ctx.handler);
    }, 500);
  },
  update(el, {
    value,
    oldValue,
    arg
  }) {
    const ctx = el.__qclickoutside;
    if (value !== oldValue) {
      ctx.trigger = value;
    }
    if (arg !== ctx.arg) {
      ctx.toggleEl = arg;
    }
  },
  unbind(el) {
    const ctx = el.__qclickoutside_old || el.__qclickoutside;
    if (ctx !== void 0) {
      clearTimeout(ctx.timerFocusin);
      const indexClick = handlers.click.findIndex(h => h === ctx.handler),
        indexFocus = handlers.focus.findIndex(h => h === ctx.handler);
      indexClick > -1 && handlers.click.splice(indexClick, 1);
      indexFocus > -1 && handlers.focus.splice(indexFocus, 1);
      if (handlers.click.length === 0) {
        clearTimeout(timer);
        document.removeEventListener('mousedown', globalHandler, notPassiveCapture);
        document.removeEventListener('touchstart', globalHandler, notPassiveCapture);
        document.removeEventListener('focusin', globalHandler, passiveCapture);
      }
      delete el[el.__qclickoutside_old ? '__qclickoutside_old' : '__qclickoutside'];
    }
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/scroll.js
var utils_scroll = __webpack_require__("a820");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/escape-key.js
var escape_key = __webpack_require__("3e5f");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/slot.js
var slot = __webpack_require__("feae");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/focus-manager.js
var focus_manager = __webpack_require__("fa15");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/position-engine.js
var position_engine = __webpack_require__("f4c5");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/menu/QMenu.js
















/* harmony default export */ var QMenu = __webpack_exports__["a"] = (external_vue_default.a.extend({
  name: 'QMenu',
  mixins: [attrs["b" /* default */], dark["a" /* default */], mixins_anchor["a" /* default */], timeout["a" /* default */], model_toggle["a" /* default */], portal["c" /* default */], transition["a" /* default */]],
  directives: {
    ClickOutside: ClickOutside
  },
  props: {
    persistent: Boolean,
    autoClose: Boolean,
    separateClosePopup: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    fit: Boolean,
    cover: Boolean,
    square: Boolean,
    anchor: {
      type: String,
      validator: position_engine["d" /* validatePosition */]
    },
    self: {
      type: String,
      validator: position_engine["d" /* validatePosition */]
    },
    offset: {
      type: Array,
      validator: position_engine["c" /* validateOffset */]
    },
    scrollTarget: {
      default: void 0
    },
    touchPosition: Boolean,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  computed: {
    anchorOrigin() {
      return Object(position_engine["a" /* parsePosition */])(this.anchor || (this.cover === true ? 'center middle' : 'bottom start'), this.$q.lang.rtl);
    },
    selfOrigin() {
      return this.cover === true ? this.anchorOrigin : Object(position_engine["a" /* parsePosition */])(this.self || 'top start', this.$q.lang.rtl);
    },
    menuClass() {
      return (this.square === true ? ' q-menu--square' : '') + (this.isDark === true ? ' q-menu--dark q-dark' : '');
    },
    hideOnRouteChange() {
      return this.persistent !== true && this.noRouteDismiss !== true;
    },
    onEvents() {
      const on = {
        ...this.qListeners,
        // stop propagating these events from children
        input: utils_event["k" /* stop */],
        'popup-show': utils_event["k" /* stop */],
        'popup-hide': utils_event["k" /* stop */]
      };
      if (this.autoClose === true) {
        on.click = this.__onAutoClose;
      }
      return on;
    },
    attrs() {
      return {
        tabindex: -1,
        role: 'menu',
        ...this.qAttrs
      };
    }
  },
  methods: {
    focus() {
      Object(focus_manager["a" /* addFocusFn */])(() => {
        let node = this.__portal !== void 0 && this.__portal.$refs !== void 0 ? this.__portal.$refs.inner : void 0;
        if (node !== void 0 && node.contains(document.activeElement) !== true) {
          node = node.querySelector('[autofocus][tabindex], [data-autofocus][tabindex]') || node.querySelector('[autofocus] [tabindex], [data-autofocus] [tabindex]') || node.querySelector('[autofocus], [data-autofocus]') || node;
          node.focus({
            preventScroll: true
          });
        }
      });
    },
    __show(evt) {
      // IE can have null document.activeElement
      this.__refocusTarget = Platform["a" /* client */].is.mobile !== true && this.noRefocus === false && document.activeElement !== null ? document.activeElement : void 0;
      escape_key["a" /* default */].register(this, escEvt => {
        if (this.persistent !== true) {
          this.$emit('escape-key');
          this.hide(escEvt);
        }
      });
      this.__showPortal();
      this.__configureScrollTarget();
      this.absoluteOffset = void 0;
      if (evt !== void 0 && (this.touchPosition || this.contextMenu)) {
        const pos = Object(utils_event["h" /* position */])(evt);
        if (pos.left !== void 0) {
          const {
            top,
            left
          } = this.anchorEl.getBoundingClientRect();
          this.absoluteOffset = {
            left: pos.left - left,
            top: pos.top - top
          };
        }
      }
      if (this.unwatch === void 0) {
        this.unwatch = this.$watch(() => this.$q.screen.width + '|' + this.$q.screen.height + '|' + this.self + '|' + this.anchor + '|' + this.$q.lang.rtl, this.updatePosition);
      }
      this.$el.dispatchEvent(Object(utils_event["c" /* create */])('popup-show', {
        bubbles: true
      }));

      // IE can have null document.activeElement
      if (this.noFocus !== true && document.activeElement !== null) {
        document.activeElement.blur();
      }
      this.__registerTick(() => {
        this.updatePosition();
        this.noFocus !== true && this.focus();
      });
      this.__registerTimeout(() => {
        // required in order to avoid the "double-tap needed" issue
        if (this.$q.platform.is.ios === true) {
          // if auto-close, then this click should
          // not close the menu
          this.__avoidAutoClose = this.autoClose;
          this.__portal.$el.click();
        }
        this.updatePosition();
        this.__showPortal(true); // done showing
        this.$emit('show', evt);
      }, 300);
    },
    __hide(evt) {
      this.__removeTick();
      this.__anchorCleanup(true);
      this.__hidePortal();

      // check null for IE
      if (this.__refocusTarget !== void 0 && this.__refocusTarget !== null && (
      // menu was hidden from code or ESC plugin
      evt === void 0 ||
      // menu was not closed from a mouse or touch clickOutside
      evt.qClickOutside !== true)) {
        ((evt && evt.type.indexOf('key') === 0 ? this.__refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || this.__refocusTarget).focus();
        this.__refocusTarget = void 0;
      }
      this.$el.dispatchEvent(Object(utils_event["c" /* create */])('popup-hide', {
        bubbles: true
      }));

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(() => {
        this.__hidePortal(true); // done hiding, now destroy
        this.$emit('hide', evt);
      }, 300);
    },
    __anchorCleanup(hiding) {
      this.absoluteOffset = void 0;
      if (this.unwatch !== void 0) {
        this.unwatch();
        this.unwatch = void 0;
      }
      if (hiding === true || this.showing === true) {
        escape_key["a" /* default */].pop(this);
        this.__unconfigureScrollTarget();
      }
    },
    __unconfigureScrollTarget() {
      if (this.__scrollTarget !== void 0) {
        this.__changeScrollEvent(this.__scrollTarget);
        this.__scrollTarget = void 0;
      }
    },
    __configureScrollTarget() {
      if (this.anchorEl !== void 0 || this.scrollTarget !== void 0) {
        this.__scrollTarget = Object(utils_scroll["d" /* getScrollTarget */])(this.anchorEl, this.scrollTarget);
        this.__changeScrollEvent(this.__scrollTarget, this.updatePosition);
      }
    },
    __onAutoClose(e) {
      // if auto-close, then the ios double-tap fix which
      // issues a click should not close the menu
      if (this.__avoidAutoClose !== true) {
        Object(portal["a" /* closePortalMenus */])(this, e);
        this.qListeners.click !== void 0 && this.$emit('click', e);
      } else {
        this.__avoidAutoClose = false;
      }
    },
    updatePosition() {
      if (this.anchorEl === void 0 || this.__portal === void 0) {
        return;
      }
      const el = this.__portal.$el;
      if (el.nodeType === 8) {
        // IE replaces the comment with delay
        setTimeout(this.updatePosition, 25);
        return;
      }
      Object(position_engine["b" /* setPosition */])({
        el,
        offset: this.offset,
        anchorEl: this.anchorEl,
        anchorOrigin: this.anchorOrigin,
        selfOrigin: this.selfOrigin,
        absoluteOffset: this.absoluteOffset,
        fit: this.fit,
        cover: this.cover,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth
      });
    },
    __onClickOutside(e) {
      if (this.persistent !== true && this.showing === true) {
        const targetClassList = e.target.classList;
        Object(portal["a" /* closePortalMenus */])(this, e);
        if (
        // always prevent touch event
        e.type === 'touchstart' ||
        // prevent click if it's on a dialog backdrop
        targetClassList.contains('q-dialog__backdrop')) {
          Object(utils_event["m" /* stopAndPreventClick */])(e);
        }
        return true;
      }
    },
    __renderPortal(h) {
      return h('transition', {
        props: {
          ...this.transitionProps
        }
      }, [this.showing === true ? h('div', {
        ref: 'inner',
        staticClass: 'q-menu q-position-engine scroll' + this.menuClass,
        class: this.contentClass,
        style: this.contentStyle,
        attrs: this.attrs,
        on: this.onEvents,
        directives: [{
          name: 'click-outside',
          value: this.__onClickOutside,
          arg: this.anchorEl
        }]
      }, Object(slot["c" /* slot */])(this, 'default')) : null]);
    }
  },
  created() {
    this.__useTick('__registerTick', '__removeTick');
    this.__useTimeout('__registerTimeout');
  },
  mounted() {
    this.__processModelChange(this.value);
  },
  beforeDestroy() {
    this.__refocusTarget = void 0;

    // When the menu is destroyed while open we can only emit the event on anchorEl
    if (this.showing === true && this.anchorEl !== void 0) {
      this.anchorEl.dispatchEvent(Object(utils_event["c" /* create */])('popup-hide', {
        bubbles: true
      }));
    }
  }
}));

/***/ }),

/***/ "b937":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "#select-image-button[data-v-d75c5056]{display:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b9ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = __webpack_require__("95c4");

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = __webpack_require__("3513");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI11 = function (_MSI) {
	_inherits(MSI11, _MSI);

	function MSI11(data, options) {
		_classCallCheck(this, MSI11);

		return _possibleConstructorReturn(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums.mod11)(data), options));
	}

	return MSI11;
}(_MSI3.default);

exports.default = MSI11;

/***/ }),

/***/ "ba27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageUpload_vue_vue_type_style_index_0_id_d75c5056_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f27e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageUpload_vue_vue_type_style_index_0_id_d75c5056_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_ImageUpload_vue_vue_type_style_index_0_id_d75c5056_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "be86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("feae");



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QItemLabel',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    overline: Boolean,
    caption: Boolean,
    header: Boolean,
    lines: [Number, String]
  },
  computed: {
    classes() {
      return {
        'q-item__label--overline text-overline': this.overline,
        'q-item__label--caption text-caption': this.caption,
        'q-item__label--header': this.header,
        'ellipsis': parseInt(this.lines, 10) === 1
      };
    },
    style() {
      if (this.lines !== void 0 && parseInt(this.lines, 10) > 1) {
        return {
          overflow: 'hidden',
          display: '-webkit-box',
          '-webkit-box-orient': 'vertical',
          '-webkit-line-clamp': this.lines
        };
      }
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-item__label',
      style: this.style,
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_2__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "bef4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_QCReview_vue_vue_type_style_index_0_id_69b5a30d_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9cfc");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_QCReview_vue_vue_type_style_index_0_id_69b5a30d_prod_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_QCReview_vue_vue_type_style_index_0_id_69b5a30d_prod_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c3c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (fn, wait = 250, immediate) {
  let timeout;
  function debounced( /* ...args */
  ) {
    const args = arguments;
    const later = () => {
      timeout = void 0;
      if (immediate !== true) {
        fn.apply(this, args);
      }
    };
    clearTimeout(timeout);
    if (immediate === true && timeout === void 0) {
      fn.apply(this, args);
    }
    timeout = setTimeout(later, wait);
  }
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  return debounced;
});

/***/ }),

/***/ "c588":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a583");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a50a");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("feae");




/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QList',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_dark_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: {
    bordered: Boolean,
    dense: Boolean,
    separator: Boolean,
    padding: Boolean,
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    classes() {
      return 'q-list' + (this.bordered === true ? ' q-list--bordered' : '') + (this.dense === true ? ' q-list--dense' : '') + (this.separator === true ? ' q-list--separator' : '') + (this.isDark === true ? ' q-list--dark' : '') + (this.padding === true ? ' q-list--padding' : '');
    }
  },
  render(h) {
    return h(this.tag, {
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_3__[/* slot */ "c"])(this, 'default'));
  }
}));

/***/ }),

/***/ "c9c2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Based on the work of https://github.com/jchook/uuid-random
 */

let buf,
  bufIdx = 0;
const hexBytes = new Array(256);

// Pre-calculate toString(16) for speed
for (let i = 0; i < 256; i++) {
  hexBytes[i] = (i + 0x100).toString(16).substr(1);
}

// Use best available PRNG
const randomBytes = (() => {
  // Node & Browser support
  const lib = typeof crypto !== 'undefined' ? crypto : typeof window !== 'undefined' ? window.msCrypto // IE11
  : void 0;
  if (lib !== void 0) {
    if (lib.randomBytes !== void 0) {
      return lib.randomBytes;
    }
    if (lib.getRandomValues !== void 0) {
      return n => {
        var bytes = new Uint8Array(n);
        lib.getRandomValues(bytes);
        return bytes;
      };
    }
  }
  return n => {
    const r = [];
    for (let i = n; i > 0; i--) {
      r.push(Math.floor(Math.random() * 256));
    }
    return r;
  };
})();

// Buffer random numbers for speed
// Reduce memory usage by decreasing this number (min 16)
// or improve speed by increasing this number (try 16384)
const BUFFER_SIZE = 4096;
/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Buffer some random bytes for speed
  if (buf === void 0 || bufIdx + 16 > BUFFER_SIZE) {
    bufIdx = 0;
    buf = randomBytes(BUFFER_SIZE);
  }
  const b = Array.prototype.slice.call(buf, bufIdx, bufIdx += 16);
  b[6] = b[6] & 0x0f | 0x40;
  b[8] = b[8] & 0x3f | 0x80;
  return hexBytes[b[0]] + hexBytes[b[1]] + hexBytes[b[2]] + hexBytes[b[3]] + '-' + hexBytes[b[4]] + hexBytes[b[5]] + '-' + hexBytes[b[6]] + hexBytes[b[7]] + '-' + hexBytes[b[8]] + hexBytes[b[9]] + '-' + hexBytes[b[10]] + hexBytes[b[11]] + hexBytes[b[12]] + hexBytes[b[13]] + hexBytes[b[14]] + hexBytes[b[15]];
});

/***/ }),

/***/ "cd06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CODE39 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Code_39#Encoding

var CODE39 = function (_Barcode) {
	_inherits(CODE39, _Barcode);

	function CODE39(data, options) {
		_classCallCheck(this, CODE39);

		data = data.toUpperCase();

		// Calculate mod43 checksum if enabled
		if (options.mod43) {
			data += getCharacter(mod43checksum(data));
		}

		return _possibleConstructorReturn(this, (CODE39.__proto__ || Object.getPrototypeOf(CODE39)).call(this, data, options));
	}

	_createClass(CODE39, [{
		key: "encode",
		value: function encode() {
			// First character is always a *
			var result = getEncoding("*");

			// Take every character and add the binary representation to the result
			for (var i = 0; i < this.data.length; i++) {
				result += getEncoding(this.data[i]) + "0";
			}

			// Last character is always a *
			result += getEncoding("*");

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
		}
	}]);

	return CODE39;
}(_Barcode3.default);

// All characters. The position in the array is the (checksum) value


var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];

// The decimal representation of the characters, is converted to the
// corresponding binary with the getEncoding function
var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];

// Get the binary representation of a character by converting the encodings
// from decimal to binary
function getEncoding(character) {
	return getBinary(characterValue(character));
}

function getBinary(characterValue) {
	return encodings[characterValue].toString(2);
}

function getCharacter(characterValue) {
	return characters[characterValue];
}

function characterValue(character) {
	return characters.indexOf(character);
}

function mod43checksum(data) {
	var checksum = 0;
	for (var i = 0; i < data.length; i++) {
		checksum += characterValue(data[i]);
	}

	checksum = checksum % 43;
	return checksum;
}

exports.CODE39 = CODE39;

/***/ }),

/***/ "cdc9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MSI1110 = exports.MSI1010 = exports.MSI11 = exports.MSI10 = exports.MSI = undefined;

var _MSI = __webpack_require__("95c4");

var _MSI2 = _interopRequireDefault(_MSI);

var _MSI3 = __webpack_require__("6a4d");

var _MSI4 = _interopRequireDefault(_MSI3);

var _MSI5 = __webpack_require__("b9ca");

var _MSI6 = _interopRequireDefault(_MSI5);

var _MSI7 = __webpack_require__("2d7f");

var _MSI8 = _interopRequireDefault(_MSI7);

var _MSI9 = __webpack_require__("56bc");

var _MSI10 = _interopRequireDefault(_MSI9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MSI = _MSI2.default;
exports.MSI10 = _MSI4.default;
exports.MSI11 = _MSI6.default;
exports.MSI1010 = _MSI8.default;
exports.MSI1110 = _MSI10.default;

/***/ }),

/***/ "cf51":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__("559c");

var _encoder = __webpack_require__("b720");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = __webpack_require__("2b1e");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Base class for EAN8 & EAN13
var EAN = function (_Barcode) {
	_inherits(EAN, _Barcode);

	function EAN(data, options) {
		_classCallCheck(this, EAN);

		// Make sure the font is not bigger than the space between the guard bars
		var _this = _possibleConstructorReturn(this, (EAN.__proto__ || Object.getPrototypeOf(EAN)).call(this, data, options));

		_this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(EAN, [{
		key: 'encode',
		value: function encode() {
			return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
		}
	}, {
		key: 'leftText',
		value: function leftText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var textOptions = { fontSize: this.fontSize };
			var guardOptions = { height: this.guardHeight };

			return [{ data: _constants.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants.SIDE_BIN, options: guardOptions }];
		}
	}, {
		key: 'encodeFlat',
		value: function encodeFlat() {
			var data = [_constants.SIDE_BIN, this.leftEncode(), _constants.MIDDLE_BIN, this.rightEncode(), _constants.SIDE_BIN];

			return {
				data: data.join(''),
				text: this.text
			};
		}
	}]);

	return EAN;
}(_Barcode3.default);

exports.default = EAN;

/***/ }),

/***/ "cfbe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = linearizeEncodings;

// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
// Convert to [1-1, 1-2, 2, 3-1, 3-2]

function linearizeEncodings(encodings) {
	var linearEncodings = [];
	function nextLevel(encoded) {
		if (Array.isArray(encoded)) {
			for (var i = 0; i < encoded.length; i++) {
				nextLevel(encoded[i]);
			}
		} else {
			encoded.text = encoded.text || "";
			encoded.data = encoded.data || "";
			linearEncodings.push(encoded);
		}
	}
	nextLevel(encodings);

	return linearEncodings;
}

/***/ }),

/***/ "d114":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/field/QField.js + 1 modules
var QField = __webpack_require__("135c");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/form.js
var mixins_form = __webpack_require__("2750");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/file.js
var file = __webpack_require__("a439");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/key-composition.js
var key_composition = __webpack_require__("116d");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/mixins/mask.js


// leave NAMED_MASKS at top of file (code referenced from docs)
const NAMED_MASKS = {
  date: '####/##/##',
  datetime: '####/##/## ##:##',
  time: '##:##',
  fulltime: '##:##:##',
  phone: '(###) ### - ####',
  card: '#### #### #### ####'
};
const TOKENS = {
  '#': {
    pattern: '[\\d]',
    negate: '[^\\d]'
  },
  S: {
    pattern: '[a-zA-Z]',
    negate: '[^a-zA-Z]'
  },
  N: {
    pattern: '[0-9a-zA-Z]',
    negate: '[^0-9a-zA-Z]'
  },
  A: {
    pattern: '[a-zA-Z]',
    negate: '[^a-zA-Z]',
    transform: v => v.toLocaleUpperCase()
  },
  a: {
    pattern: '[a-zA-Z]',
    negate: '[^a-zA-Z]',
    transform: v => v.toLocaleLowerCase()
  },
  X: {
    pattern: '[0-9a-zA-Z]',
    negate: '[^0-9a-zA-Z]',
    transform: v => v.toLocaleUpperCase()
  },
  x: {
    pattern: '[0-9a-zA-Z]',
    negate: '[^0-9a-zA-Z]',
    transform: v => v.toLocaleLowerCase()
  }
};
const KEYS = Object.keys(TOKENS);
KEYS.forEach(key => {
  TOKENS[key].regex = new RegExp(TOKENS[key].pattern);
});
const tokenRegexMask = new RegExp('\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([' + KEYS.join('') + '])|(.)', 'g'),
  escRegex = /[.*+?^${}()|[\]\\]/g;
const MARKER = String.fromCharCode(1);
/* harmony default export */ var mask = ({
  props: {
    mask: String,
    reverseFillMask: Boolean,
    fillMask: [Boolean, String],
    unmaskedValue: Boolean
  },
  watch: {
    type() {
      this.__updateMaskInternals();
    },
    autogrow() {
      this.__updateMaskInternals();
    },
    mask(v) {
      if (v !== void 0) {
        this.__updateMaskValue(this.innerValue, true);
      } else {
        const val = this.__unmask(this.innerValue);
        this.__updateMaskInternals();
        this.value !== val && this.$emit('input', val);
      }
    },
    fillMask() {
      this.hasMask === true && this.__updateMaskValue(this.innerValue, true);
    },
    reverseFillMask() {
      this.hasMask === true && this.__updateMaskValue(this.innerValue, true);
    },
    unmaskedValue() {
      this.hasMask === true && this.__updateMaskValue(this.innerValue);
    }
  },
  methods: {
    __getInitialMaskedValue() {
      this.__updateMaskInternals();
      if (this.hasMask === true) {
        const masked = this.__mask(this.__unmask(this.value));
        return this.fillMask !== false ? this.__fillWithMask(masked) : masked;
      }
      return this.value;
    },
    __getPaddedMaskMarked(size) {
      if (size < this.maskMarked.length) {
        return this.maskMarked.slice(-size);
      }
      let maskMarked = this.maskMarked,
        pad = '';
      const padPos = maskMarked.indexOf(MARKER);
      if (padPos > -1) {
        for (let i = size - maskMarked.length; i > 0; i--) {
          pad += MARKER;
        }
        maskMarked = maskMarked.slice(0, padPos) + pad + maskMarked.slice(padPos);
      }
      return maskMarked;
    },
    __updateMaskInternals() {
      this.hasMask = this.mask !== void 0 && this.mask.length > 0 && (this.autogrow === true || ['textarea', 'text', 'search', 'url', 'tel', 'password'].includes(this.type));
      if (this.hasMask === false) {
        this.computedUnmask = void 0;
        this.maskMarked = '';
        this.maskReplaced = '';
        return;
      }
      const computedMask = NAMED_MASKS[this.mask] === void 0 ? this.mask : NAMED_MASKS[this.mask],
        fillChar = typeof this.fillMask === 'string' && this.fillMask.length > 0 ? this.fillMask.slice(0, 1) : '_',
        fillCharEscaped = fillChar.replace(escRegex, '\\$&'),
        unmask = [],
        extract = [],
        mask = [];
      let firstMatch = this.reverseFillMask === true,
        unmaskChar = '',
        negateChar = '';
      computedMask.replace(tokenRegexMask, (_, char1, esc, token, char2) => {
        if (token !== void 0) {
          const c = TOKENS[token];
          mask.push(c);
          negateChar = c.negate;
          if (firstMatch === true) {
            extract.push('(?:' + negateChar + '+)?(' + c.pattern + '+)?(?:' + negateChar + '+)?(' + c.pattern + '+)?');
            firstMatch = false;
          }
          extract.push('(?:' + negateChar + '+)?(' + c.pattern + ')?');
        } else if (esc !== void 0) {
          unmaskChar = '\\' + (esc === '\\' ? '' : esc);
          mask.push(esc);
          unmask.push('([^' + unmaskChar + ']+)?' + unmaskChar + '?');
        } else {
          const c = char1 !== void 0 ? char1 : char2;
          unmaskChar = c === '\\' ? '\\\\\\\\' : c.replace(escRegex, '\\\\$&');
          mask.push(c);
          unmask.push('([^' + unmaskChar + ']+)?' + unmaskChar + '?');
        }
      });
      const unmaskMatcher = new RegExp('^' + unmask.join('') + '(' + (unmaskChar === '' ? '.' : '[^' + unmaskChar + ']') + '+)?' + (unmaskChar === '' ? '' : '[' + unmaskChar + ']*') + '$'),
        extractLast = extract.length - 1,
        extractMatcher = extract.map((re, index) => {
          if (index === 0 && this.reverseFillMask === true) {
            return new RegExp('^' + fillCharEscaped + '*' + re);
          } else if (index === extractLast) {
            return new RegExp('^' + re + '(' + (negateChar === '' ? '.' : negateChar) + '+)?' + (this.reverseFillMask === true ? '$' : fillCharEscaped + '*'));
          }
          return new RegExp('^' + re);
        });
      this.computedMask = mask;
      this.computedUnmask = val => {
        const unmaskMatch = unmaskMatcher.exec(this.reverseFillMask === true ? val : val.slice(0, mask.length + 1));
        if (unmaskMatch !== null) {
          val = unmaskMatch.slice(1).join('');
        }
        const extractMatch = [],
          extractMatcherLength = extractMatcher.length;
        for (let i = 0, str = val; i < extractMatcherLength; i++) {
          const m = extractMatcher[i].exec(str);
          if (m === null) {
            break;
          }
          str = str.slice(m.shift().length);
          extractMatch.push(...m);
        }
        if (extractMatch.length > 0) {
          return extractMatch.join('');
        }
        return val;
      };
      this.maskMarked = mask.map(v => typeof v === 'string' ? v : MARKER).join('');
      this.maskReplaced = this.maskMarked.split(MARKER).join(fillChar);
    },
    __updateMaskValue(rawVal, updateMaskInternals, inputType) {
      const inp = this.$refs.input,
        end = inp.selectionEnd,
        endReverse = inp.value.length - end,
        unmasked = this.__unmask(rawVal);

      // Update here so unmask uses the original fillChar
      updateMaskInternals === true && this.__updateMaskInternals();
      const preMasked = this.__mask(unmasked),
        masked = this.fillMask !== false ? this.__fillWithMask(preMasked) : preMasked,
        changed = this.innerValue !== masked;

      // We want to avoid "flickering" so we set value immediately
      inp.value !== masked && (inp.value = masked);
      changed === true && (this.innerValue = masked);
      document.activeElement === inp && this.$nextTick(() => {
        if (masked === this.maskReplaced) {
          const cursor = this.reverseFillMask === true ? this.maskReplaced.length : 0;
          inp.setSelectionRange(cursor, cursor, 'forward');
          return;
        }
        if (inputType === 'insertFromPaste' && this.reverseFillMask !== true) {
          const maxEnd = inp.selectionEnd;
          let cursor = end - 1;
          // each non-marker char means we move once to right
          for (let i = this.__pastedTextStart; i <= cursor && i < maxEnd; i++) {
            if (this.maskMarked[i] !== MARKER) {
              cursor++;
            }
          }
          this.__moveCursorRight(inp, cursor);
          return;
        }
        if (['deleteContentBackward', 'deleteContentForward'].indexOf(inputType) > -1) {
          const cursor = this.reverseFillMask === true ? end === 0 ? masked.length > preMasked.length ? 1 : 0 : Math.max(0, masked.length - (masked === this.maskReplaced ? 0 : Math.min(preMasked.length, endReverse) + 1)) + 1 : end;
          inp.setSelectionRange(cursor, cursor, 'forward');
          return;
        }
        if (this.reverseFillMask === true) {
          if (changed === true) {
            const cursor = Math.max(0, masked.length - (masked === this.maskReplaced ? 0 : Math.min(preMasked.length, endReverse + 1)));
            if (cursor === 1 && end === 1) {
              inp.setSelectionRange(cursor, cursor, 'forward');
            } else {
              this.__moveCursorRightReverse(inp, cursor);
            }
          } else {
            const cursor = masked.length - endReverse;
            inp.setSelectionRange(cursor, cursor, 'backward');
          }
        } else {
          if (changed === true) {
            const cursor = Math.max(0, this.maskMarked.indexOf(MARKER), Math.min(preMasked.length, end) - 1);
            this.__moveCursorRight(inp, cursor);
          } else {
            const cursor = end - 1;
            this.__moveCursorRight(inp, cursor);
          }
        }
      });
      const val = this.unmaskedValue === true ? this.__unmask(masked) : masked;
      String(this.value) !== val && this.__emitValue(val, true);
    },
    __moveCursorForPaste(inp, start, end) {
      const preMasked = this.__mask(this.__unmask(inp.value));
      start = Math.max(0, this.maskMarked.indexOf(MARKER), Math.min(preMasked.length, start));
      this.__pastedTextStart = start;
      inp.setSelectionRange(start, end, 'forward');
    },
    __moveCursorLeft(inp, cursor) {
      const noMarkBefore = this.maskMarked.slice(cursor - 1).indexOf(MARKER) === -1;
      let i = Math.max(0, cursor - 1);
      for (; i >= 0; i--) {
        if (this.maskMarked[i] === MARKER) {
          cursor = i;
          noMarkBefore === true && cursor++;
          break;
        }
      }
      if (i < 0 && this.maskMarked[cursor] !== void 0 && this.maskMarked[cursor] !== MARKER) {
        return this.__moveCursorRight(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, 'backward');
    },
    __moveCursorRight(inp, cursor) {
      const limit = inp.value.length;
      let i = Math.min(limit, cursor + 1);
      for (; i <= limit; i++) {
        if (this.maskMarked[i] === MARKER) {
          cursor = i;
          break;
        } else if (this.maskMarked[i - 1] === MARKER) {
          cursor = i;
        }
      }
      if (i > limit && this.maskMarked[cursor - 1] !== void 0 && this.maskMarked[cursor - 1] !== MARKER) {
        return this.__moveCursorLeft(inp, limit);
      }
      inp.setSelectionRange(cursor, cursor, 'forward');
    },
    __moveCursorLeftReverse(inp, cursor) {
      const maskMarked = this.__getPaddedMaskMarked(inp.value.length);
      let i = Math.max(0, cursor - 1);
      for (; i >= 0; i--) {
        if (maskMarked[i - 1] === MARKER) {
          cursor = i;
          break;
        } else if (maskMarked[i] === MARKER) {
          cursor = i;
          if (i === 0) {
            break;
          }
        }
      }
      if (i < 0 && maskMarked[cursor] !== void 0 && maskMarked[cursor] !== MARKER) {
        return this.__moveCursorRightReverse(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, 'backward');
    },
    __moveCursorRightReverse(inp, cursor) {
      const limit = inp.value.length,
        maskMarked = this.__getPaddedMaskMarked(limit),
        noMarkBefore = maskMarked.slice(0, cursor + 1).indexOf(MARKER) === -1;
      let i = Math.min(limit, cursor + 1);
      for (; i <= limit; i++) {
        if (maskMarked[i - 1] === MARKER) {
          cursor = i;
          cursor > 0 && noMarkBefore === true && cursor--;
          break;
        }
      }
      if (i > limit && maskMarked[cursor - 1] !== void 0 && maskMarked[cursor - 1] !== MARKER) {
        return this.__moveCursorLeftReverse(inp, limit);
      }
      inp.setSelectionRange(cursor, cursor, 'forward');
    },
    __onMaskedClick(e) {
      this.qListeners.click !== void 0 && this.$emit('click', e);
      this.__selectionAnchor = void 0;
    },
    __onMaskedKeydown(e) {
      this.qListeners.keydown !== void 0 && this.$emit('keydown', e);
      if (Object(key_composition["c" /* shouldIgnoreKey */])(e) === true) {
        return;
      }
      const inp = this.$refs.input,
        start = inp.selectionStart,
        end = inp.selectionEnd;
      if (!e.shiftKey) {
        this.__selectionAnchor = void 0;
      }
      if (e.keyCode === 37 || e.keyCode === 39) {
        // Left / Right
        if (e.shiftKey && this.__selectionAnchor === void 0) {
          this.__selectionAnchor = inp.selectionDirection === 'forward' ? start : end;
        }
        const fn = this['__moveCursor' + (e.keyCode === 39 ? 'Right' : 'Left') + (this.reverseFillMask === true ? 'Reverse' : '')];
        e.preventDefault();
        fn(inp, this.__selectionAnchor === start ? end : start);
        if (e.shiftKey) {
          const anchor = this.__selectionAnchor;
          const cursor = inp.selectionStart;
          inp.setSelectionRange(Math.min(anchor, cursor), Math.max(anchor, cursor), 'forward');
        }
      } else if (e.keyCode === 8 &&
      // Backspace
      this.reverseFillMask !== true && start === end) {
        this.__moveCursorLeft(inp, start);
        inp.setSelectionRange(inp.selectionStart, end, 'backward');
      } else if (e.keyCode === 46 &&
      // Delete
      this.reverseFillMask === true && start === end) {
        this.__moveCursorRightReverse(inp, end);
        inp.setSelectionRange(start, inp.selectionEnd, 'forward');
      }
      this.$emit('keydown', e);
    },
    __mask(val) {
      if (val === void 0 || val === null || val === '') {
        return '';
      }
      if (this.reverseFillMask === true) {
        return this.__maskReverse(val);
      }
      const mask = this.computedMask;
      let valIndex = 0,
        output = '';
      for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
        const valChar = val[valIndex],
          maskDef = mask[maskIndex];
        if (typeof maskDef === 'string') {
          output += maskDef;
          valChar === maskDef && valIndex++;
        } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
          output += maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar;
          valIndex++;
        } else {
          return output;
        }
      }
      return output;
    },
    __maskReverse(val) {
      const mask = this.computedMask,
        firstTokenIndex = this.maskMarked.indexOf(MARKER);
      let valIndex = val.length - 1,
        output = '';
      for (let maskIndex = mask.length - 1; maskIndex >= 0 && valIndex > -1; maskIndex--) {
        const maskDef = mask[maskIndex];
        let valChar = val[valIndex];
        if (typeof maskDef === 'string') {
          output = maskDef + output;
          valChar === maskDef && valIndex--;
        } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
          do {
            output = (maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar) + output;
            valIndex--;
            valChar = val[valIndex];
            // eslint-disable-next-line no-unmodified-loop-condition
          } while (firstTokenIndex === maskIndex && valChar !== void 0 && maskDef.regex.test(valChar));
        } else {
          return output;
        }
      }
      return output;
    },
    __unmask(val) {
      return typeof val !== 'string' || this.computedUnmask === void 0 ? typeof val === 'number' ? this.computedUnmask('' + val) : val : this.computedUnmask(val);
    },
    __fillWithMask(val) {
      if (this.maskReplaced.length - val.length <= 0) {
        return val;
      }
      return this.reverseFillMask === true && val.length > 0 ? this.maskReplaced.slice(0, -val.length) + val : val + this.maskReplaced.slice(val.length);
    }
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/composition.js
var composition = __webpack_require__("4351");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/listeners.js
var listeners = __webpack_require__("a50a");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/event.js
var utils_event = __webpack_require__("a8d5");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/focus-manager.js
var focus_manager = __webpack_require__("fa15");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/input/QInput.js









/* harmony default export */ var QInput = __webpack_exports__["a"] = (external_vue_default.a.extend({
  name: 'QInput',
  mixins: [QField["a" /* default */], mask, composition["a" /* default */], mixins_form["a" /* FormFieldMixin */], file["a" /* FileValueMixin */], listeners["a" /* default */]],
  props: {
    value: {
      required: false
    },
    shadowText: String,
    type: {
      type: String,
      default: 'text'
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea

    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  watch: {
    value(v) {
      if (this.hasMask === true) {
        if (this.stopValueWatcher === true) {
          this.stopValueWatcher = false;
          if (String(v) === this.emitCachedValue) {
            return;
          }
        }
        this.__updateMaskValue(v);
      } else if (this.innerValue !== v) {
        this.innerValue = v;
        if (this.type === 'number' && this.hasOwnProperty('tempValue') === true) {
          if (this.typedNumber === true) {
            this.typedNumber = false;
          } else {
            delete this.tempValue;
          }
        }
      }

      // textarea only
      this.autogrow === true && this.$nextTick(this.__adjustHeight);
    },
    // some browsers lose the native input value
    // so we need to reattach it dynamically
    // (like type="password" <-> type="text"; see #12078)
    type() {
      if (this.$refs.input) {
        this.$refs.input.value = this.value;
      }
    },
    autogrow(autogrow) {
      // textarea only
      if (autogrow === true) {
        this.$nextTick(this.__adjustHeight);
      }
      // if it has a number of rows set respect it
      else if (this.qAttrs.rows > 0 && this.$refs.input !== void 0) {
        const inp = this.$refs.input;
        inp.style.height = 'auto';
      }
    },
    dense() {
      this.autogrow === true && this.$nextTick(this.__adjustHeight);
    }
  },
  data() {
    return {
      innerValue: this.__getInitialMaskedValue()
    };
  },
  computed: {
    isTextarea() {
      return this.type === 'textarea' || this.autogrow === true;
    },
    isTypeText() {
      return this.isTextarea === true || ['text', 'search', 'url', 'tel', 'password'].includes(this.type);
    },
    fieldClass() {
      return `q-${this.isTextarea === true ? 'textarea' : 'input'}` + (this.autogrow === true ? ' q-textarea--autogrow' : '');
    },
    hasShadow() {
      return this.type !== 'file' && typeof this.shadowText === 'string' && this.shadowText.length > 0;
    },
    onEvents() {
      const on = {
        ...this.qListeners,
        input: this.__onInput,
        paste: this.__onPaste,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        change: this.__onChange,
        blur: this.__onFinishEditing,
        focus: utils_event["k" /* stop */]
      };
      on.compositionstart = on.compositionupdate = on.compositionend = this.__onComposition;
      if (this.hasMask === true) {
        on.keydown = this.__onMaskedKeydown;
        // reset selection anchor on pointer selection
        on.click = this.__onMaskedClick;
      }
      if (this.autogrow === true) {
        on.animationend = this.__onAnimationend;
      }
      return on;
    },
    inputAttrs() {
      const attrs = {
        tabindex: 0,
        'data-autofocus': this.autofocus || void 0,
        rows: this.type === 'textarea' ? 6 : void 0,
        'aria-label': this.label,
        name: this.nameProp,
        ...this.qAttrs,
        id: this.targetUid,
        type: this.type,
        maxlength: this.maxlength,
        disabled: this.disable === true,
        readonly: this.readonly === true
      };
      if (this.autogrow === true) {
        attrs.rows = 1;
      }
      return attrs;
    }
  },
  methods: {
    focus() {
      Object(focus_manager["a" /* addFocusFn */])(() => {
        const el = document.activeElement;
        if (this.$refs.input !== void 0 && this.$refs.input !== el && (
        // IE can have null document.activeElement
        el === null || el.id !== this.targetUid)) {
          this.$refs.input.focus({
            preventScroll: true
          });
        }
      });
    },
    select() {
      this.$refs.input !== void 0 && this.$refs.input.select();
    },
    getNativeElement() {
      return this.$refs.input;
    },
    __onPaste(e) {
      if (this.hasMask === true && this.reverseFillMask !== true) {
        const inp = e.target;
        this.__moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
      }
      this.$emit('paste', e);
    },
    __onInput(e) {
      if (!e || !e.target || e.target.qComposing === true) {
        return;
      }
      if (this.type === 'file') {
        this.$emit('input', e.target.files);
        return;
      }
      const val = e.target.value;
      if (this.hasMask === true) {
        this.__updateMaskValue(val, false, e.inputType);
      } else {
        this.__emitValue(val);
        if (this.isTypeText === true && e.target === document.activeElement) {
          const {
            selectionStart,
            selectionEnd
          } = e.target;
          if (selectionStart !== void 0 && selectionEnd !== void 0) {
            this.$nextTick(() => {
              if (e.target === document.activeElement && val.indexOf(e.target.value) === 0) {
                e.target.setSelectionRange(selectionStart, selectionEnd);
              }
            });
          }
        }
      }

      // we need to trigger it immediately too,
      // to avoid "flickering"
      this.autogrow === true && this.__adjustHeight();
    },
    __onAnimationend(e) {
      this.qListeners.animationend !== void 0 && this.$emit('animationend', e);
      this.__adjustHeight();
    },
    __emitValue(val, stopWatcher) {
      this.emitValueFn = () => {
        if (this.type !== 'number' && this.hasOwnProperty('tempValue') === true) {
          delete this.tempValue;
        }
        if (this.value !== val && this.emitCachedValue !== val) {
          this.emitCachedValue = val;
          stopWatcher === true && (this.stopValueWatcher = true);
          this.$emit('input', val);
          this.$nextTick(() => {
            this.emitCachedValue === val && (this.emitCachedValue = NaN);
          });
        }
        this.emitValueFn = void 0;
      };
      if (this.type === 'number') {
        this.typedNumber = true;
        this.tempValue = val;
      }
      if (this.debounce !== void 0) {
        clearTimeout(this.emitTimer);
        this.tempValue = val;
        this.emitTimer = setTimeout(this.emitValueFn, this.debounce);
      } else {
        this.emitValueFn();
      }
    },
    // textarea only
    __adjustHeight() {
      requestAnimationFrame(() => {
        const inp = this.$refs.input;
        if (inp !== void 0) {
          const parentStyle = inp.parentNode.style;
          // chrome does not keep scroll #15498
          const {
            scrollTop
          } = inp;
          // chrome calculates a smaller scrollHeight when in a .column container
          const {
            overflowY,
            maxHeight
          } = this.$q.platform.is.firefox === true ? {} : window.getComputedStyle(inp);
          // on firefox or if overflowY is specified as scroll #14263, #14344
          // we don't touch overflow
          // firefox is not so bad in the end
          const changeOverflow = overflowY !== void 0 && overflowY !== 'scroll';

          // reset height of textarea to a small size to detect the real height
          // but keep the total control size the same
          changeOverflow === true && (inp.style.overflowY = 'hidden');
          parentStyle.marginBottom = inp.scrollHeight - 1 + 'px';
          inp.style.height = '1px';
          inp.style.height = inp.scrollHeight + 'px';
          // we should allow scrollbars only
          // if there is maxHeight and content is taller than maxHeight
          changeOverflow === true && (inp.style.overflowY = parseInt(maxHeight, 10) < inp.scrollHeight ? 'auto' : 'hidden');
          parentStyle.marginBottom = '';
          inp.scrollTop = scrollTop;
        }
      });
    },
    __onChange(e) {
      this.__onComposition(e);
      clearTimeout(this.emitTimer);
      this.emitValueFn !== void 0 && this.emitValueFn();
      this.$emit('change', e);
    },
    __onFinishEditing(e) {
      e !== void 0 && Object(utils_event["k" /* stop */])(e);
      clearTimeout(this.emitTimer);
      this.emitValueFn !== void 0 && this.emitValueFn();
      this.typedNumber = false;
      this.stopValueWatcher = false;
      delete this.tempValue;

      // we need to use setTimeout instead of this.$nextTick
      // to avoid a bug where focusout is not emitted for type date/time/week/...
      this.type !== 'file' && setTimeout(() => {
        if (this.$refs.input !== void 0) {
          this.$refs.input.value = this.innerValue !== void 0 ? this.innerValue : '';
        }
      });
    },
    __getCurValue() {
      return this.hasOwnProperty('tempValue') === true ? this.tempValue : this.innerValue !== void 0 ? this.innerValue : '';
    },
    __getShadowControl(h) {
      return h('div', {
        staticClass: 'q-field__native q-field__shadow absolute-bottom no-pointer-events' + (this.isTextarea === true ? '' : ' text-no-wrap')
      }, [h('span', {
        staticClass: 'invisible'
      }, this.__getCurValue()), h('span', this.shadowText)]);
    },
    __getControl(h) {
      return h(this.isTextarea === true ? 'textarea' : 'input', {
        ref: 'input',
        staticClass: 'q-field__native q-placeholder',
        style: this.inputStyle,
        class: this.inputClass,
        attrs: this.inputAttrs,
        on: this.onEvents,
        domProps: this.type !== 'file' ? {
          value: this.__getCurValue()
        } : this.formDomProps
      });
    }
  },
  created() {
    this.emitCachedValue = NaN;
  },
  mounted() {
    // textarea only
    this.autogrow === true && this.__adjustHeight();
  },
  beforeDestroy() {
    this.__onFinishEditing();
  }
}));

/***/ }),

/***/ "d36b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getTotalWidthOfEncodings = exports.calculateEncodingAttributes = exports.getBarcodePadding = exports.getEncodingHeight = exports.getMaximumHeightOfEncodings = undefined;

var _merge = __webpack_require__("e795");

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEncodingHeight(encoding, options) {
	return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
}

function getBarcodePadding(textWidth, barcodeWidth, options) {
	if (options.displayValue && barcodeWidth < textWidth) {
		if (options.textAlign == "center") {
			return Math.floor((textWidth - barcodeWidth) / 2);
		} else if (options.textAlign == "left") {
			return 0;
		} else if (options.textAlign == "right") {
			return Math.floor(textWidth - barcodeWidth);
		}
	}
	return 0;
}

function calculateEncodingAttributes(encodings, barcodeOptions, context) {
	for (var i = 0; i < encodings.length; i++) {
		var encoding = encodings[i];
		var options = (0, _merge2.default)(barcodeOptions, encoding.options);

		// Calculate the width of the encoding
		var textWidth;
		if (options.displayValue) {
			textWidth = messureText(encoding.text, options, context);
		} else {
			textWidth = 0;
		}

		var barcodeWidth = encoding.data.length * options.width;
		encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));

		encoding.height = getEncodingHeight(encoding, options);

		encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
	}
}

function getTotalWidthOfEncodings(encodings) {
	var totalWidth = 0;
	for (var i = 0; i < encodings.length; i++) {
		totalWidth += encodings[i].width;
	}
	return totalWidth;
}

function getMaximumHeightOfEncodings(encodings) {
	var maxHeight = 0;
	for (var i = 0; i < encodings.length; i++) {
		if (encodings[i].height > maxHeight) {
			maxHeight = encodings[i].height;
		}
	}
	return maxHeight;
}

function messureText(string, options, context) {
	var ctx;

	if (context) {
		ctx = context;
	} else if (typeof document !== "undefined") {
		ctx = document.createElement("canvas").getContext("2d");
	} else {
		// If the text cannot be messured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;

	// Calculate the width of the encoding
	var measureTextResult = ctx.measureText(string);
	if (!measureTextResult) {
		// Some implementations don't implement measureText and return undefined.
		// If the text cannot be measured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	var size = measureTextResult.width;
	return size;
}

exports.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
exports.getEncodingHeight = getEncodingHeight;
exports.getBarcodePadding = getBarcodePadding;
exports.calculateEncodingAttributes = calculateEncodingAttributes;
exports.getTotalWidthOfEncodings = getTotalWidthOfEncodings;

/***/ }),

/***/ "d3a0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Platform_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ad69");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a8d5");



const Dark = {
  isActive: false,
  mode: false,
  install($q, queues, {
    dark
  }) {
    this.isActive = dark === true;
    if (_Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* isSSR */ "e"] === true) {
      queues.server.push((q, ctx) => {
        q.dark = {
          isActive: false,
          mode: false,
          set: val => {
            ctx.ssr.Q_BODY_CLASSES = ctx.ssr.Q_BODY_CLASSES.replace(' body--light', '').replace(' body--dark', '') + ` body--${val === true ? 'dark' : 'light'}`;
            q.dark.isActive = val === true;
            q.dark.mode = val;
          },
          toggle: () => {
            q.dark.set(q.dark.isActive === false);
          }
        };
        q.dark.set(dark);
      });
      this.set = _utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* noop */ "g"];
      return;
    }
    const initialVal = dark !== void 0 ? dark : false;
    if (_Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* fromSSR */ "c"] === true) {
      const ssrSet = val => {
        this.__fromSSR = val;
      };
      const originalSet = this.set;
      this.set = ssrSet;
      ssrSet(initialVal);
      queues.takeover.push(() => {
        this.set = originalSet;
        this.set(this.__fromSSR);
      });
    } else {
      this.set(initialVal);
    }
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.util.defineReactive(this, 'isActive', this.isActive);
    vue__WEBPACK_IMPORTED_MODULE_0___default.a.util.defineReactive($q, 'dark', this);
  },
  set(val) {
    this.mode = val;
    if (val === 'auto') {
      if (this.__media === void 0) {
        this.__media = window.matchMedia('(prefers-color-scheme: dark)');
        this.__updateMedia = () => {
          this.set('auto');
        };
        this.__media.addListener(this.__updateMedia);
      }
      val = this.__media.matches;
    } else if (this.__media !== void 0) {
      this.__media.removeListener(this.__updateMedia);
      this.__media = void 0;
    }
    this.isActive = val === true;
    document.body.classList.remove(`body--${val === true ? 'light' : 'dark'}`);
    document.body.classList.add(`body--${val === true ? 'dark' : 'light'}`);
  },
  toggle() {
    Dark.set(Dark.isActive === false);
  },
  __media: void 0
};
/* harmony default export */ __webpack_exports__["a"] = (Dark);

/***/ }),

/***/ "d447":
/***/ (function(module, exports) {

/**
 * Quasar runtime for auto-importing
 * components or directives.
 *
 * Warning! This file does NOT get transpiled by Babel
 * but is included into the UI code.
 *
 * @param {component} Vue Component object
 * @param {type}      One of 'components' or 'directives'
 * @param {items}     Object containing components or directives
 */
module.exports = function qInstall (component, type, items) {
  var opt

  if (typeof component.exports === 'function') {
    opt = component.exports.extendOptions
    opt[type] = component.exports.options[type]
  }
  else {
    opt = component.options
  }

  if (opt[type] === void 0) {
    opt[type] = items
  }
  else {
    var target = opt[type]
    for (var i in items) {
      if (target[i] === void 0) {
        target[i] = items[i]
      }
    }
  }
}


/***/ }),

/***/ "d485":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closePortalMenus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closePortals; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ad69");
/* harmony import */ var _utils_dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d818");
/* harmony import */ var _utils_private_focus_manager_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fa15");
/* harmony import */ var _utils_debounce_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c3c5");





function closePortalMenus(vm, evt) {
  do {
    if (vm.$options.name === 'QMenu') {
      vm.hide(evt);

      // is this a point of separation?
      if (vm.separateClosePopup === true) {
        return vm.$parent;
      }
    } else if (vm.__renderPortal !== void 0) {
      // treat it as point of separation if parent is QPopupProxy
      // (so mobile matches desktop behavior)
      // and hide it too
      if (vm.$parent !== void 0 && vm.$parent.$options.name === 'QPopupProxy') {
        vm.hide(evt);
        return vm.$parent;
      } else {
        return vm;
      }
    }
    vm = vm.$parent;
  } while (vm !== void 0 && (vm.$el.contains === void 0 ||
  // IE polyfill does not work on comments
  vm.$el.contains(evt.target) !== true));
}
function closePortals(vm, evt, depth) {
  while (depth !== 0 && vm !== void 0) {
    if (vm.__renderPortal !== void 0) {
      depth--;
      if (vm.$options.name === 'QMenu') {
        vm = closePortalMenus(vm, evt);
        continue;
      }
      vm.hide(evt);
    }
    vm = vm.$parent;
  }
}
function isOnGlobalDialog(vm) {
  while (vm !== void 0) {
    if (vm.$options.name === 'QGlobalDialog') {
      return true;
    }
    if (vm.$options.name === 'QDialog') {
      return false;
    }
    vm = vm.$parent;
  }
  return false;
}
const Portal = {
  inheritAttrs: false,
  props: {
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object]
  },
  methods: {
    __showPortal(isReady) {
      if (isReady === true) {
        Object(_utils_private_focus_manager_js__WEBPACK_IMPORTED_MODULE_3__[/* removeFocusWaitFlag */ "d"])(this.focusObj);
        this.__portalIsAccessible = true;
        return;
      }
      this.__portalIsAccessible = false;
      if (this.__portalIsActive === true) {
        return;
      }
      this.__portalIsActive = true;
      if (this.focusObj === void 0) {
        this.focusObj = {};
      }
      Object(_utils_private_focus_manager_js__WEBPACK_IMPORTED_MODULE_3__[/* addFocusWaitFlag */ "b"])(this.focusObj);
      if (this.$q.fullscreen !== void 0 && this.$q.fullscreen.isCapable === true) {
        const append = () => {
          if (this.__portal === void 0) {
            return;
          }
          const newParent = Object(_utils_dom_js__WEBPACK_IMPORTED_MODULE_2__[/* getBodyFullscreenElement */ "c"])(this.$q.fullscreen.activeEl);
          if (this.__portal.$el.parentElement !== newParent && newParent.contains(this.$el) === (this.__onGlobalDialog === false)) {
            newParent.appendChild(this.__portal.$el);
          }
        };
        this.unwatchFullscreen = this.$watch('$q.fullscreen.activeEl', Object(_utils_debounce_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(append, 50));
        if (this.__onGlobalDialog === false || this.$q.fullscreen.isActive === true) {
          append();
        }
      } else if (this.__portal !== void 0 && this.__onGlobalDialog === false) {
        document.body.appendChild(this.__portal.$el);
      }
    },
    __hidePortal(isReady) {
      this.__portalIsAccessible = false;
      if (isReady !== true) {
        return;
      }
      this.__portalIsActive = false;
      Object(_utils_private_focus_manager_js__WEBPACK_IMPORTED_MODULE_3__[/* removeFocusWaitFlag */ "d"])(this.focusObj);
      if (this.__portal !== void 0) {
        if (this.unwatchFullscreen !== void 0) {
          this.unwatchFullscreen();
          this.unwatchFullscreen = void 0;
        }
        if (this.__onGlobalDialog === false) {
          this.__portal.$destroy();
          this.__portal.$el.remove();
        }
        this.__portal = void 0;
      }
    },
    __preparePortal() {
      if (this.__portal === void 0) {
        this.__portal = this.__onGlobalDialog === true ? {
          $el: this.$el,
          $refs: this.$refs
        } : new vue__WEBPACK_IMPORTED_MODULE_0___default.a({
          name: 'QPortal',
          parent: this,
          inheritAttrs: false,
          render: h => this.__renderPortal(h),
          components: this.$options.components,
          directives: this.$options.directives
        }).$mount();
      }
    }
  },
  render(h) {
    if (this.__onGlobalDialog === true) {
      return this.__renderPortal(h);
    }
    if (this.__portal !== void 0) {
      this.__portal.$forceUpdate();
    }
  },
  beforeDestroy() {
    this.__hidePortal(true);
  }
};
if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* isSSR */ "e"] === false) {
  Portal.created = function () {
    this.__onGlobalDialog = isOnGlobalDialog(this.$parent);
  };
}
/* harmony default export */ __webpack_exports__["c"] = (Portal);

/***/ }),

/***/ "d4b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__("e795");

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__("d36b");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgns = "http://www.w3.org/2000/svg";

var SVGRenderer = function () {
	function SVGRenderer(svg, encodings, options) {
		_classCallCheck(this, SVGRenderer);

		this.svg = svg;
		this.encodings = encodings;
		this.options = options;
		this.document = options.xmlDocument || document;
	}

	_createClass(SVGRenderer, [{
		key: "render",
		value: function render() {
			var currentX = this.options.marginLeft;

			this.prepareSVG();
			for (var i = 0; i < this.encodings.length; i++) {
				var encoding = this.encodings[i];
				var encodingOptions = (0, _merge2.default)(this.options, encoding.options);

				var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);

				this.setGroupOptions(group, encodingOptions);

				this.drawSvgBarcode(group, encodingOptions, encoding);
				this.drawSVGText(group, encodingOptions, encoding);

				currentX += encoding.width;
			}
		}
	}, {
		key: "prepareSVG",
		value: function prepareSVG() {
			// Clear the SVG
			while (this.svg.firstChild) {
				this.svg.removeChild(this.svg.firstChild);
			}

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			var width = totalWidth + this.options.marginLeft + this.options.marginRight;
			this.setSvgAttributes(width, maxHeight);

			if (this.options.background) {
				this.drawRect(0, 0, width, maxHeight, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
			}
		}
	}, {
		key: "drawSvgBarcode",
		value: function drawSvgBarcode(parent, options, encoding) {
			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.fontSize + options.textMargin;
			} else {
				yFrom = 0;
			}

			var barWidth = 0;
			var x = 0;
			for (var b = 0; b < binary.length; b++) {
				x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					barWidth++;
				} else if (barWidth > 0) {
					this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
					barWidth = 0;
				}
			}

			// Last draw is needed since the barcode ends with 1
			if (barWidth > 0) {
				this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
			}
		}
	}, {
		key: "drawSVGText",
		value: function drawSVGText(parent, options, encoding) {
			var textElem = this.document.createElementNS(svgns, 'text');

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);

				if (options.textPosition == "top") {
					y = options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.fontSize;
				}

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					textElem.setAttribute("text-anchor", "start");
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					textElem.setAttribute("text-anchor", "end");
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						textElem.setAttribute("text-anchor", "middle");
					}

				textElem.setAttribute("x", x);
				textElem.setAttribute("y", y);

				textElem.appendChild(this.document.createTextNode(encoding.text));

				parent.appendChild(textElem);
			}
		}
	}, {
		key: "setSvgAttributes",
		value: function setSvgAttributes(width, height) {
			var svg = this.svg;
			svg.setAttribute("width", width + "px");
			svg.setAttribute("height", height + "px");
			svg.setAttribute("x", "0px");
			svg.setAttribute("y", "0px");
			svg.setAttribute("viewBox", "0 0 " + width + " " + height);

			svg.setAttribute("xmlns", svgns);
			svg.setAttribute("version", "1.1");

			svg.setAttribute("style", "transform: translate(0,0)");
		}
	}, {
		key: "createGroup",
		value: function createGroup(x, y, parent) {
			var group = this.document.createElementNS(svgns, 'g');
			group.setAttribute("transform", "translate(" + x + ", " + y + ")");

			parent.appendChild(group);

			return group;
		}
	}, {
		key: "setGroupOptions",
		value: function setGroupOptions(group, options) {
			group.setAttribute("style", "fill:" + options.lineColor + ";");
		}
	}, {
		key: "drawRect",
		value: function drawRect(x, y, width, height, parent) {
			var rect = this.document.createElementNS(svgns, 'rect');

			rect.setAttribute("x", x);
			rect.setAttribute("y", y);
			rect.setAttribute("width", width);
			rect.setAttribute("height", height);

			parent.appendChild(rect);

			return rect;
		}
	}]);

	return SVGRenderer;
}();

exports.default = SVGRenderer;

/***/ }),

/***/ "d66b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ClassExpansion.vue?vue&type=template&id=812cfb4c&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row full-width items-center justify-between bg-blue-grey-2 q-px-md shadow-1",
    staticStyle: {
      "min-height": "60px",
      "font-size": "16px"
    }
  }, [_vm.intersected ? [_c('div', {
    staticClass: "q-mr-lg"
  }, [_vm._v(_vm._s(_vm.className))]), _c('div', {
    staticClass: "row items-center"
  }, [_vm.assignedGroupImage !== null ? _c('div', {
    staticClass: "row items-center q-gutter-md q-mr-xl"
  }, [_c('div', {
    staticClass: "column items-center"
  }, [_c('div', {
    staticClass: "text-subtitle2"
  }, [_vm._v("Assigned Group:")]), _c('div', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.assignedGroupImage.className))])]), _c('image-basic', {
    attrs: {
      "image": _vm.assignedGroupImage
    }
  })], 1) : _vm._e(), _c('q-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMove,
      expression: "showMove"
    }],
    staticClass: "q-mr-xl",
    attrs: {
      "color": "primary",
      "unelevated": "",
      "size": "12px"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.moveToClass.apply(null, arguments);
      }
    }
  }, [_vm._v("Move selected images to class")]), _c('q-chip', {
    staticClass: "q-mr-sm",
    attrs: {
      "icon": "mdi-camera-outline"
    }
  }, [_vm._v(_vm._s(_vm.images.length))]), _c('q-chip', {
    staticClass: "q-mr-xl",
    class: _vm.childProtectionColour,
    attrs: {
      "icon": "mdi-shield-account"
    }
  }, [_vm._v(_vm._s(_vm.childProtectionCount))]), _c('q-checkbox', {
    staticClass: "q-mr-sm",
    attrs: {
      "value": _vm.allSelected,
      "dense": ""
    },
    on: {
      "input": _vm.updateSelectionState
    }
  }, [_c('span', {
    staticClass: "text-body2"
  }, [_vm._v(_vm._s(_vm.selectedCount) + " selected")])])], 1)] : _vm._e()], 2), _c('div', {
    staticClass: "row q-gutter-xs q-pa-sm"
  }, _vm._l(_vm.images, function (image) {
    return _c('image-comp', {
      key: image.longRef,
      staticClass: "col-auto",
      attrs: {
        "on-screen": _vm.intersected,
        "image": image,
        "imageOptions": _vm.imageOptions,
        "isLabQC": _vm.isLabQC,
        "allow-group-image-assignment": _vm.allowGroupImageAssignment
      },
      on: {
        "update-zoom-id": function ($event) {
          return _vm.$emit('update-zoom-id', $event);
        },
        "assign-group-to-class": function ($event) {
          return _vm.$emit('assign-group-to-class', $event);
        }
      }
    });
  }), 1)]);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/ClassExpansion.vue?vue&type=template&id=812cfb4c&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: ./src/imageStore.ts
var imageStore = __webpack_require__("818c");

// EXTERNAL MODULE: ./src/components/Image.vue + 4 modules
var Image = __webpack_require__("a142");

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ImageBasic.vue?vue&type=template&id=7b4c9052&scoped=true&lang=pug
var ImageBasicvue_type_template_id_7b4c9052_scoped_true_lang_pug_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('img', {
    staticClass: "qc-image",
    attrs: {
      "loading": "lazy",
      "draggable": "false",
      "height": _vm.height,
      "src": _vm.image.url
    }
  });
};
var ImageBasicvue_type_template_id_7b4c9052_scoped_true_lang_pug_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/ImageBasic.vue?vue&type=template&id=7b4c9052&scoped=true&lang=pug

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ImageBasic.vue?vue&type=script&lang=ts

/* harmony default export */ var ImageBasicvue_type_script_lang_ts = (external_vue_default.a.extend({
  name: 'ImageBasic',
  props: {
    image: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {};
  },
  methods: {}
}));
// CONCATENATED MODULE: ./src/components/ImageBasic.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_ImageBasicvue_type_script_lang_ts = (ImageBasicvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/ImageBasic.vue?vue&type=style&index=0&id=7b4c9052&prod&lang=stylus&scoped=true
var ImageBasicvue_type_style_index_0_id_7b4c9052_prod_lang_stylus_scoped_true = __webpack_require__("a25e");

// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// CONCATENATED MODULE: ./src/components/ImageBasic.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_ImageBasicvue_type_script_lang_ts,
  ImageBasicvue_type_template_id_7b4c9052_scoped_true_lang_pug_render,
  ImageBasicvue_type_template_id_7b4c9052_scoped_true_lang_pug_staticRenderFns,
  false,
  null,
  "7b4c9052",
  null
  
)

/* harmony default export */ var ImageBasic = (component.exports);
// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ClassExpansion.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let ClassExpansionvue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  constructor() {
    super(...arguments);
    this.observer = null;
    this.intersected = false;
  }
  get selected() {
    if (imageStore["a" /* ImageStore */].Instance.selectedImageRefs.length === 0) return [];
    return imageStore["a" /* ImageStore */].Instance.findSelectedImages(this.images);
  }
  get allSelected() {
    return this.selected.length === this.images.length;
  }
  get selectedCount() {
    return this.selected.length;
  }
  get childProtectionCount() {
    return this.images.filter(i => i.childProtectionIssue).length;
  }
  get childProtectionColour() {
    const count = this.childProtectionCount;
    if (count === this.images.length) return 'text-negative';else if (count > 0) return 'text-warning';else return '';
  }
  mounted() {
    // console.debug('ClassExpansion Mounted', this.className)
    this.observer = new IntersectionObserver(entries => {
      this.intersected = entries[0].isIntersecting;
    });
    this.observer.observe(this.$el);
  }
  beforeDestroy() {
    var _a;
    (_a = this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
  }
  updateSelectionState(state) {
    for (const image of this.images) {
      imageStore["a" /* ImageStore */].Instance.setSelected(image.longRef, state);
    }
  }
  moveToClass() {
    return this.className;
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "images", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "imageOptions", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "className", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "photographerId", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: false,
  default: false
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "isLabQC", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "allowGroupImageAssignment", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: null
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "assignedGroupImage", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  default: false
})], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "showMove", void 0);
__decorate([Object(external_vue_property_decorator_["Emit"])()], ClassExpansionvue_type_script_lang_ts_default_1.prototype, "moveToClass", null);
ClassExpansionvue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'ClassExpansion',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  components: {
    ImageComp: Image["a" /* default */],
    ImageBasic: ImageBasic
  }
})], ClassExpansionvue_type_script_lang_ts_default_1);
/* harmony default export */ var ClassExpansionvue_type_script_lang_ts = (ClassExpansionvue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/ClassExpansion.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_ClassExpansionvue_type_script_lang_ts = (ClassExpansionvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/btn/QBtn.js
var QBtn = __webpack_require__("b20c");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/chip/QChip.js
var QChip = __webpack_require__("5759");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/checkbox/QCheckbox.js
var QCheckbox = __webpack_require__("1919");

// EXTERNAL MODULE: /workspace/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js
var runtime_auto_import = __webpack_require__("d447");
var runtime_auto_import_default = /*#__PURE__*/__webpack_require__.n(runtime_auto_import);

// CONCATENATED MODULE: ./src/components/ClassExpansion.vue





/* normalize component */

var ClassExpansion_component = Object(componentNormalizer["a" /* default */])(
  components_ClassExpansionvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ClassExpansion = __webpack_exports__["a"] = (ClassExpansion_component.exports);




runtime_auto_import_default()(ClassExpansion_component, 'components', {QBtn: QBtn["a" /* default */],QChip: QChip["a" /* default */],QCheckbox: QCheckbox["a" /* default */]});


/***/ }),

/***/ "d818":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return offset; });
/* unused harmony export style */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return height; });
/* unused harmony export width */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* unused harmony export cssBatch */
/* unused harmony export ready */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return childHasFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBodyFullscreenElement; });
function offset(el) {
  if (el === window) {
    return {
      top: 0,
      left: 0
    };
  }
  const {
    top,
    left
  } = el.getBoundingClientRect();
  return {
    top,
    left
  };
}
function style(el, property) {
  return window.getComputedStyle(el).getPropertyValue(property);
}
function height(el) {
  return el === window ? window.innerHeight : el.getBoundingClientRect().height;
}
function width(el) {
  return el === window ? window.innerWidth : el.getBoundingClientRect().width;
}
function css(element, css) {
  const style = element.style;
  Object.keys(css).forEach(prop => {
    style[prop] = css[prop];
  });
}
function cssBatch(elements, style) {
  elements.forEach(el => css(el, style));
}
function ready(fn) {
  if (typeof fn !== 'function') {
    return;
  }
  if (document.readyState !== 'loading') {
    return fn();
  }
  document.addEventListener('DOMContentLoaded', fn, false);
}

// internal
function getElement(el) {
  const type = typeof el;
  if (type === 'function') {
    el = el();
  }
  if (type === 'string') {
    try {
      el = document.querySelector(el);
    } catch (err) {}
  }
  if (el !== Object(el)) {
    return null;
  }
  return el._isVue === true && el.$el !== void 0 ? el.$el : el;
}

// internal
function childHasFocus(el, focusedEl) {
  if (el === void 0 || el.contains(focusedEl) === true) {
    return true;
  }
  for (let next = el.nextElementSibling; next !== null; next = next.nextElementSibling) {
    if (next.contains(focusedEl)) {
      return true;
    }
  }
  return false;
}

// internal
function getBodyFullscreenElement(activeEl) {
  return activeEl === document.documentElement || activeEl === null ? document.body : activeEl;
}
/* unused harmony default export */ var _unused_webpack_default_export = ({
  offset,
  style,
  height,
  width,
  css,
  cssBatch,
  ready
});

/***/ }),

/***/ "d84a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _dark_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a583");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a8d5");
/* harmony import */ var _form_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2750");
/* harmony import */ var _option_size_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ee82");
/* harmony import */ var _refocus_target_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("a7f3");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("feae");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("479b");







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [_dark_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], _option_size_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _form_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"], _refocus_target_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]],
  props: {
    value: {
      required: true,
      default: null
    },
    val: {},
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    indeterminateValue: {
      default: null
    },
    checkedIcon: String,
    uncheckedIcon: String,
    indeterminateIcon: String,
    toggleOrder: {
      type: String,
      validator: v => v === 'tf' || v === 'ft'
    },
    toggleIndeterminate: Boolean,
    label: String,
    leftLabel: Boolean,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [String, Number]
  },
  computed: {
    isTrue() {
      return this.modelIsArray === true ? this.index > -1 : this.value === this.trueValue;
    },
    isFalse() {
      return this.modelIsArray === true ? this.index === -1 : this.value === this.falseValue;
    },
    isIndeterminate() {
      return this.isTrue === false && this.isFalse === false;
    },
    index() {
      if (this.modelIsArray === true) {
        return this.value.indexOf(this.val);
      }
    },
    modelIsArray() {
      return this.val !== void 0 && Array.isArray(this.value);
    },
    computedTabindex() {
      return this.disable === true ? -1 : this.tabindex || 0;
    },
    classes() {
      return `q-${this.type} cursor-pointer no-outline row inline no-wrap items-center` + (this.disable === true ? ' disabled' : '') + (this.isDark === true ? ` q-${this.type}--dark` : '') + (this.dense === true ? ` q-${this.type}--dense` : '') + (this.leftLabel === true ? ' reverse' : '');
    },
    innerClass() {
      const state = this.isTrue === true ? 'truthy' : this.isFalse === true ? 'falsy' : 'indet';
      const color = this.color !== void 0 && (this.keepColor === true || (this.type === 'toggle' ? this.isTrue === true : this.isFalse !== true)) ? ` text-${this.color}` : '';
      return `q-${this.type}__inner--${state}${color}`;
    },
    formAttrs() {
      const prop = {
        type: 'checkbox'
      };
      this.name !== void 0 && Object.assign(prop, {
        checked: this.isTrue,
        name: this.name,
        value: this.modelIsArray === true ? this.val : this.trueValue
      });
      return prop;
    },
    attrs() {
      const attrs = {
        tabindex: this.computedTabindex,
        role: this.type === 'toggle' ? 'switch' : 'checkbox',
        'aria-label': this.label,
        'aria-checked': this.isIndeterminate === true ? 'mixed' : this.isTrue === true ? 'true' : 'false'
      };
      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      }
      return attrs;
    }
  },
  methods: {
    toggle(e) {
      if (e !== void 0) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* stopAndPrevent */ "l"])(e);
        this.__refocusTarget(e);
      }
      if (this.disable !== true) {
        this.$emit('input', this.__getNextValue(), e);
      }
    },
    __getNextValue() {
      if (this.modelIsArray === true) {
        if (this.isTrue === true) {
          const val = this.value.slice();
          val.splice(this.index, 1);
          return val;
        }
        return this.value.concat([this.val]);
      }
      if (this.isTrue === true) {
        if (this.toggleOrder !== 'ft' || this.toggleIndeterminate === false) {
          return this.falseValue;
        }
      } else if (this.isFalse === true) {
        if (this.toggleOrder === 'ft' || this.toggleIndeterminate === false) {
          return this.trueValue;
        }
      } else {
        return this.toggleOrder !== 'ft' ? this.trueValue : this.falseValue;
      }
      return this.indeterminateValue;
    },
    __onKeydown(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_1__[/* stopAndPrevent */ "l"])(e);
      }
    },
    __onKeyup(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.toggle(e);
      }
    }
  },
  render(h) {
    const inner = this.__getInner(h);
    this.disable !== true && this.__injectFormInput(inner, 'unshift', `q-${this.type}__native absolute q-ma-none q-pa-none`);
    const child = [h('div', {
      staticClass: `q-${this.type}__inner relative-position non-selectable`,
      class: this.innerClass,
      style: this.sizeStyle,
      attrs: {
        'aria-hidden': 'true'
      }
    }, inner)];
    if (this.__refocusTargetEl !== void 0) {
      child.push(this.__refocusTargetEl);
    }
    const label = this.label !== void 0 ? Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_5__[/* mergeSlot */ "a"])([this.label], this, 'default') : Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_5__[/* slot */ "c"])(this, 'default');
    label !== void 0 && child.push(h('div', {
      staticClass: `q-${this.type}__label q-anchor--skip`
    }, label));
    return h('div', {
      class: this.classes,
      attrs: this.attrs,
      on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(this, 'inpExt', {
        click: this.toggle,
        keydown: this.__onKeydown,
        keyup: this.__onKeyup
      })
    }, child);
  }
});

/***/ }),

/***/ "da18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_history_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("65a6");
/* harmony import */ var _mixins_timeout_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("f3c6");
/* harmony import */ var _mixins_model_toggle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1dd9");
/* harmony import */ var _mixins_prevent_scroll_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9a9f");
/* harmony import */ var _mixins_dark_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a583");
/* harmony import */ var _directives_TouchPan_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("f452");
/* harmony import */ var _utils_format_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("536b");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("feae");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("479b");
/* harmony import */ var _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ae5c");











const duration = 150;
const mouseEvents = ['mouseover', 'mouseout', 'mouseenter', 'mouseleave'];
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QDrawer',
  inject: {
    layout: {
      default() {
        console.error('QDrawer needs to be child of QLayout');
      }
    }
  },
  mixins: [_mixins_dark_js__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], _mixins_history_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_timeout_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _mixins_model_toggle_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _mixins_prevent_scroll_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]],
  directives: {
    TouchPan: _directives_TouchPan_js__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"]
  },
  props: {
    side: {
      type: String,
      default: 'left',
      validator: v => ['left', 'right'].includes(v)
    },
    width: {
      type: Number,
      default: 300
    },
    mini: Boolean,
    miniToOverlay: Boolean,
    miniWidth: {
      type: Number,
      default: 57
    },
    breakpoint: {
      type: Number,
      default: 1023
    },
    showIfAbove: Boolean,
    behavior: {
      type: String,
      validator: v => ['default', 'desktop', 'mobile'].includes(v),
      default: 'default'
    },
    bordered: Boolean,
    elevated: Boolean,
    contentStyle: [String, Object, Array],
    contentClass: [String, Object, Array],
    overlay: Boolean,
    persistent: Boolean,
    noSwipeOpen: Boolean,
    noSwipeClose: Boolean,
    noSwipeBackdrop: Boolean
  },
  data() {
    const belowBreakpoint = this.behavior === 'mobile' || this.behavior !== 'desktop' && this.layout.totalWidth <= this.breakpoint;
    return {
      belowBreakpoint,
      showing: this.showIfAbove === true && belowBreakpoint === false ? true : this.value === true
    };
  },
  watch: {
    belowBreakpoint(val) {
      if (val === true) {
        // from lg to xs
        this.lastDesktopState = this.showing;
        this.showing === true && this.hide(false);
      } else if (this.overlay === false && this.behavior !== 'mobile' && this.lastDesktopState !== false) {
        // from xs to lg
        if (this.showing === true) {
          this.__applyPosition(0);
          this.__applyBackdrop(0);
          this.__cleanup();
        } else {
          this.show(false);
        }
      }
    },
    'layout.totalWidth'() {
      if (this.layout.container === true || document.qScrollPrevented !== true) {
        this.__updateBelowBreakpoint();
      }
    },
    side(newSide, oldSide) {
      if (this.layout.instances[oldSide] === this) {
        this.layout.instances[oldSide] = void 0;
        this.layout[oldSide].space = false;
        this.layout[oldSide].offset = 0;
      }
      this.layout.instances[newSide] = this;
      this.layout[newSide].size = this.size;
      this.layout[newSide].space = this.onLayout;
      this.layout[newSide].offset = this.offset;
    },
    behavior() {
      this.__updateBelowBreakpoint();
    },
    breakpoint() {
      this.__updateBelowBreakpoint();
    },
    'layout.container'(val) {
      this.showing === true && this.__preventScroll(val !== true);
      val === true && this.__updateBelowBreakpoint();
    },
    'layout.scrollbarWidth'() {
      this.__applyPosition(this.showing === true ? 0 : void 0);
    },
    offset(val) {
      this.__update('offset', val);
    },
    onLayout(val) {
      this.$emit('on-layout', val);
      this.__update('space', val);
    },
    rightSide() {
      this.__applyPosition();
    },
    size(val) {
      this.__applyPosition();
      this.__updateSizeOnLayout(this.miniToOverlay, val);
    },
    miniToOverlay(val) {
      this.__updateSizeOnLayout(val, this.size);
    },
    '$q.lang.rtl'() {
      this.__applyPosition();
    },
    mini() {
      if (this.value === true) {
        this.__animateMini();
        this.layout.__animate();
      }
    },
    isMini(val) {
      this.$emit('mini-state', val);
    }
  },
  computed: {
    rightSide() {
      return this.side === 'right';
    },
    otherSide() {
      return this.rightSide === true ? 'left' : 'right';
    },
    offset() {
      return this.showing === true && this.belowBreakpoint === false && this.overlay === false ? this.miniToOverlay === true ? this.miniWidth : this.size : 0;
    },
    size() {
      return this.isMini === true ? this.miniWidth : this.width;
    },
    fixed() {
      return this.overlay === true || this.miniToOverlay === true || this.layout.view.indexOf(this.rightSide ? 'R' : 'L') > -1 || this.$q.platform.is.ios && this.layout.container === true;
    },
    onLayout() {
      return this.showing === true && this.belowBreakpoint === false && this.overlay === false;
    },
    onScreenOverlay() {
      return this.showing === true && this.belowBreakpoint === false && this.overlay === true;
    },
    backdropClass() {
      return this.showing === false ? 'hidden' : null;
    },
    headerSlot() {
      return this.rightSide === true ? this.layout.rows.top[2] === 'r' : this.layout.rows.top[0] === 'l';
    },
    footerSlot() {
      return this.rightSide === true ? this.layout.rows.bottom[2] === 'r' : this.layout.rows.bottom[0] === 'l';
    },
    aboveStyle() {
      const css = {};
      if (this.layout.header.space === true && this.headerSlot === false) {
        if (this.fixed === true) {
          css.top = `${this.layout.header.offset}px`;
        } else if (this.layout.header.space === true) {
          css.top = `${this.layout.header.size}px`;
        }
      }
      if (this.layout.footer.space === true && this.footerSlot === false) {
        if (this.fixed === true) {
          css.bottom = `${this.layout.footer.offset}px`;
        } else if (this.layout.footer.space === true) {
          css.bottom = `${this.layout.footer.size}px`;
        }
      }
      return css;
    },
    style() {
      const style = {
        width: `${this.size}px`
      };
      return this.belowBreakpoint === true ? style : Object.assign(style, this.aboveStyle);
    },
    classes() {
      return `q-drawer--${this.side}` + (this.bordered === true ? ' q-drawer--bordered' : '') + (this.isDark === true ? ' q-drawer--dark q-dark' : '') + (this.showing !== true ? ' q-layout--prevent-focus' : '') + (this.belowBreakpoint === true ? ' fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding' : ` q-drawer--${this.isMini === true ? 'mini' : 'standard'}` + (this.fixed === true || this.onLayout !== true ? ' fixed' : '') + (this.overlay === true || this.miniToOverlay === true ? ' q-drawer--on-top' : '') + (this.headerSlot === true ? ' q-drawer--top-padding' : ''));
    },
    stateDirection() {
      return (this.$q.lang.rtl === true ? -1 : 1) * (this.rightSide === true ? 1 : -1);
    },
    isMini() {
      return this.mini === true && this.belowBreakpoint !== true;
    },
    onNativeEvents() {
      if (this.belowBreakpoint !== true) {
        const evt = {
          '!click': e => {
            this.$emit('click', e);
          }
        };
        mouseEvents.forEach(name => {
          evt[name] = e => {
            this.qListeners[name] !== void 0 && this.$emit(name, e);
          };
        });
        return evt;
      }
    },
    hideOnRouteChange() {
      return this.persistent !== true && (this.belowBreakpoint === true || this.onScreenOverlay === true);
    },
    openDirective() {
      const dir = this.$q.lang.rtl === true ? this.side : this.otherSide;
      return [{
        name: 'touch-pan',
        value: this.__openByTouch,
        modifiers: {
          [dir]: true,
          mouse: true
        }
      }];
    },
    contentCloseDirective() {
      if (this.noSwipeClose !== true) {
        const dir = this.$q.lang.rtl === true ? this.otherSide : this.side;
        return [{
          name: 'touch-pan',
          value: this.__closeByTouch,
          modifiers: {
            [dir]: true,
            mouse: true
          }
        }];
      }
    },
    backdropCloseDirective() {
      if (this.noSwipeBackdrop !== true) {
        const dir = this.$q.lang.rtl === true ? this.otherSide : this.side;
        return [{
          name: 'touch-pan',
          value: this.__closeByTouch,
          modifiers: {
            [dir]: true,
            mouse: true,
            mouseAllDir: true
          }
        }];
      }
    }
  },
  methods: {
    __applyPosition(position) {
      if (position === void 0) {
        this.$nextTick(() => {
          position = this.showing === true ? 0 : this.size;
          this.__applyPosition(this.stateDirection * position);
        });
      } else if (this.$refs.content !== void 0) {
        if (this.layout.container === true && this.rightSide === true && (this.belowBreakpoint === true || Math.abs(position) === this.size)) {
          position += this.stateDirection * this.layout.scrollbarWidth;
        }
        if (this.__lastPosition !== position) {
          this.$refs.content.style.transform = `translateX(${position}px)`;
          this.__lastPosition = position;
        }
      }
    },
    __applyBackdrop(x, retry) {
      if (this.$refs.backdrop !== void 0) {
        this.$refs.backdrop.style.backgroundColor = this.lastBackdropBg = `rgba(0,0,0,${x * 0.4})`;
      } else {
        // rendered nodes might not have
        // picked up this.showing change yet,
        // so we need one retry
        retry !== true && this.$nextTick(() => {
          this.__applyBackdrop(x, true);
        });
      }
    },
    __setBackdropVisible(v) {
      if (this.$refs.backdrop !== void 0) {
        this.$refs.backdrop.classList[v === true ? 'remove' : 'add']('hidden');
      }
    },
    __setScrollable(v) {
      const action = v === true ? 'remove' : this.layout.container !== true ? 'add' : '';
      action !== '' && document.body.classList[action]('q-body--drawer-toggle');
    },
    __animateMini() {
      if (this.timerMini !== void 0) {
        clearTimeout(this.timerMini);
      } else if (this.$el !== void 0) {
        this.$el.classList.add('q-drawer--mini-animate');
      }
      this.timerMini = setTimeout(() => {
        this.$el !== void 0 && this.$el.classList.remove('q-drawer--mini-animate');
        this.timerMini = void 0;
      }, 150);
    },
    __openByTouch(evt) {
      if (this.showing !== false) {
        // some browsers might capture and trigger this
        // even if Drawer has just been opened (but animation is still pending)
        return;
      }
      const width = this.size,
        position = Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_7__[/* between */ "a"])(evt.distance.x, 0, width);
      if (evt.isFinal === true) {
        const el = this.$refs.content,
          opened = position >= Math.min(75, width);
        el.classList.remove('no-transition');
        if (opened === true) {
          this.show();
        } else {
          this.layout.__animate();
          this.__applyBackdrop(0);
          this.__applyPosition(this.stateDirection * width);
          el.classList.remove('q-drawer--delimiter');
          el.classList.add('q-layout--prevent-focus');
          this.__setBackdropVisible(false);
        }
        return;
      }
      this.__applyPosition((this.$q.lang.rtl === true ? this.rightSide !== true : this.rightSide) ? Math.max(width - position, 0) : Math.min(0, position - width));
      this.__applyBackdrop(Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_7__[/* between */ "a"])(position / width, 0, 1));
      if (evt.isFirst === true) {
        const el = this.$refs.content;
        el.classList.add('no-transition');
        el.classList.add('q-drawer--delimiter');
        el.classList.remove('q-layout--prevent-focus');
        this.__setBackdropVisible(true);
      }
    },
    __closeByTouch(evt) {
      if (this.showing !== true) {
        // some browsers might capture and trigger this
        // even if Drawer has just been closed (but animation is still pending)
        return;
      }
      const width = this.size,
        dir = evt.direction === this.side,
        position = (this.$q.lang.rtl === true ? dir !== true : dir) ? Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_7__[/* between */ "a"])(evt.distance.x, 0, width) : 0;
      if (evt.isFinal === true) {
        const opened = Math.abs(position) < Math.min(75, width);
        this.$refs.content.classList.remove('no-transition');
        if (opened === true) {
          this.layout.__animate();
          this.__applyBackdrop(1);
          this.__applyPosition(0);
        } else {
          this.hide();
        }
        return;
      }
      this.__applyPosition(this.stateDirection * position);
      this.__applyBackdrop(Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_7__[/* between */ "a"])(1 - position / width, 0, 1));
      if (evt.isFirst === true) {
        this.$refs.content.classList.add('no-transition');
      }
    },
    __show(evt, noEvent) {
      this.__addHistory();
      this.__setBackdropVisible(true);
      evt !== false && this.layout.__animate();
      this.__applyPosition(0);
      if (this.belowBreakpoint === true) {
        const otherSide = this.layout.instances[this.otherSide];
        if (otherSide !== void 0 && otherSide.belowBreakpoint === true) {
          otherSide.hide(false);
        }
        this.__applyBackdrop(1);
        this.layout.container !== true && this.__preventScroll(true);
      } else {
        this.__applyBackdrop(0);
        evt !== false && this.__setScrollable(false);
      }
      this.__registerTimeout(() => {
        evt !== false && this.__setScrollable(true);
        noEvent !== true && this.$emit('show', evt);
      }, duration);
    },
    __hide(evt, noEvent) {
      this.__removeHistory();
      evt !== false && this.layout.__animate();
      this.__applyBackdrop(0);
      this.__applyPosition(this.stateDirection * this.size);
      this.__setBackdropVisible(false);
      this.__cleanup();
      if (noEvent !== true) {
        this.__registerTimeout(() => {
          this.$emit('hide', evt);
        }, duration);
      } else {
        this.__removeTimeout();
      }
    },
    __cleanup() {
      this.__preventScroll(false);
      this.__setScrollable(true);
    },
    __update(prop, val) {
      if (this.layout[this.side][prop] !== val) {
        this.layout[this.side][prop] = val;
      }
    },
    __updateLocal(prop, val) {
      if (this[prop] !== val) {
        this[prop] = val;
      }
    },
    __updateSizeOnLayout(miniToOverlay, size) {
      this.__update('size', miniToOverlay === true ? this.miniWidth : size);
    },
    __updateBelowBreakpoint() {
      this.__updateLocal('belowBreakpoint', this.behavior === 'mobile' || this.behavior !== 'desktop' && this.layout.totalWidth <= this.breakpoint);
    }
  },
  created() {
    this.__useTimeout('__registerTimeout', '__removeTimeout');
    this.layout.instances[this.side] = this;
    this.__updateSizeOnLayout(this.miniToOverlay, this.size);
    this.__update('space', this.onLayout);
    this.__update('offset', this.offset);
    if (this.showIfAbove === true && this.value !== true && this.showing === true && this.qListeners.input !== void 0) {
      this.$emit('input', true);
    }
  },
  mounted() {
    this.$emit('on-layout', this.onLayout);
    this.$emit('mini-state', this.isMini);
    this.lastDesktopState = this.showIfAbove === true;
    const fn = () => {
      const action = this.showing === true ? 'show' : 'hide';
      this[`__${action}`](false, true);
    };
    if (this.layout.totalWidth !== 0) {
      // make sure that all computed properties
      // have been updated before calling __show/__hide()
      this.$nextTick(fn);
      return;
    }
    this.watcher = this.$watch('layout.totalWidth', () => {
      this.watcher();
      this.watcher = void 0;
      if (this.showing === false && this.showIfAbove === true && this.belowBreakpoint === false) {
        this.show(false);
      } else {
        fn();
      }
    });
  },
  beforeDestroy() {
    this.watcher !== void 0 && this.watcher();
    clearTimeout(this.timerMini);
    this.showing === true && this.__cleanup();
    if (this.layout.instances[this.side] === this) {
      this.layout.instances[this.side] = void 0;
      this.__update('size', 0);
      this.__update('offset', 0);
      this.__update('space', false);
    }
  },
  render(h) {
    const child = [];
    if (this.belowBreakpoint === true) {
      this.noSwipeOpen !== true && child.push(h('div', {
        staticClass: `q-drawer__opener fixed-${this.side}`,
        attrs: _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__[/* ariaHidden */ "a"],
        directives: this.openDirective
      }));
      child.push(h('div', {
        ref: 'backdrop',
        staticClass: 'fullscreen q-drawer__backdrop',
        class: this.backdropClass,
        attrs: _mixins_attrs__WEBPACK_IMPORTED_MODULE_10__[/* ariaHidden */ "a"],
        style: this.lastBackdropBg !== void 0 ? {
          backgroundColor: this.lastBackdropBg
        } : null,
        on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_9__[/* default */ "b"])(this, 'bkdrop', {
          click: this.hide
        }),
        directives: this.showing === false ? void 0 : this.backdropCloseDirective
      }));
    }
    const content = [h('div', {
      staticClass: 'q-drawer__content fit ' + (this.layout.container === true ? 'overflow-auto' : 'scroll'),
      class: this.contentClass,
      style: this.contentStyle
    }, this.isMini === true && this.$scopedSlots.mini !== void 0 ? this.$scopedSlots.mini() : Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_8__[/* slot */ "c"])(this, 'default'))];
    if (this.elevated === true && this.showing === true) {
      content.push(h('div', {
        staticClass: 'q-layout__shadow absolute-full overflow-hidden no-pointer-events'
      }));
    }
    child.push(h('aside', {
      ref: 'content',
      staticClass: 'q-drawer',
      class: this.classes,
      style: this.style,
      on: this.onNativeEvents,
      directives: this.belowBreakpoint === true ? this.contentCloseDirective : void 0
    }, content));
    return h('div', {
      staticClass: 'q-drawer-container'
    }, child);
  }
}));

/***/ }),

/***/ "dc96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _field_QField_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("135c");
/* harmony import */ var _icon_QIcon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a170");
/* harmony import */ var _chip_QChip_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5759");
/* harmony import */ var _item_QItem_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7e6f");
/* harmony import */ var _item_QItemSection_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0aaf");
/* harmony import */ var _item_QItemLabel_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("be86");
/* harmony import */ var _menu_QMenu_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("b7fa");
/* harmony import */ var _dialog_QDialog_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("66e6");
/* harmony import */ var _utils_is_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("553a");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_format_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("536b");
/* harmony import */ var _utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("116d");
/* harmony import */ var _utils_private_slot_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("feae");
/* harmony import */ var _utils_private_cache_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("479b");
/* harmony import */ var _mixins_form_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2750");
/* harmony import */ var _mixins_virtual_scroll_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("8077");
/* harmony import */ var _mixins_composition_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("4351");
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("a50a");



















const validateNewValueMode = v => ['add', 'add-unique', 'toggle'].includes(v);
const reEscapeList = '.*+?^${}()|[]\\';
/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QSelect',
  mixins: [_field_QField_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], _mixins_virtual_scroll_js__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"], _mixins_composition_js__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"], _mixins_form_js__WEBPACK_IMPORTED_MODULE_15__[/* FormFieldMixin */ "a"], _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"]],
  props: {
    value: {
      required: true
    },
    multiple: Boolean,
    displayValue: [String, Number],
    displayValueSanitize: Boolean,
    dropdownIcon: String,
    options: {
      type: Array,
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    hideSelected: Boolean,
    hideDropdownIcon: Boolean,
    fillInput: Boolean,
    maxValues: [Number, String],
    optionsDense: Boolean,
    optionsDark: {
      type: Boolean,
      default: null
    },
    optionsSelectedClass: String,
    optionsSanitize: Boolean,
    optionsCover: Boolean,
    menuShrink: Boolean,
    menuAnchor: String,
    menuSelf: String,
    menuOffset: Array,
    popupContentClass: String,
    popupContentStyle: [String, Array, Object],
    useInput: Boolean,
    useChips: Boolean,
    newValueMode: {
      type: String,
      validator: validateNewValueMode
    },
    mapOptions: Boolean,
    emitValue: Boolean,
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    autocomplete: String,
    transitionShow: String,
    transitionHide: String,
    behavior: {
      type: String,
      validator: v => ['default', 'menu', 'dialog'].includes(v),
      default: 'default'
    },
    virtualScrollItemSize: {
      type: [Number, String],
      default: void 0
    }
  },
  data() {
    return {
      menu: false,
      dialog: false,
      optionIndex: -1,
      inputValue: '',
      dialogFieldFocused: false
    };
  },
  watch: {
    innerValue: {
      handler(val) {
        this.innerValueCache = val;
        if (this.useInput === true && this.fillInput === true && this.multiple !== true &&
        // Prevent re-entering in filter while filtering
        // Also prevent clearing inputValue while filtering
        this.innerLoading !== true && (this.dialog !== true && this.menu !== true || this.hasValue !== true)) {
          this.userInputValue !== true && this.__resetInputValue();
          if (this.dialog === true || this.menu === true) {
            this.filter('');
          }
        }
      },
      immediate: true
    },
    fillInput() {
      this.__resetInputValue();
    },
    menu(show) {
      this.__updateMenu(show);
    },
    virtualScrollLength(newLength, oldLength) {
      if (this.menu === true && this.innerLoading === false) {
        this.__resetVirtualScroll(-1, true);
        this.$nextTick(() => {
          if (this.menu === true && this.innerLoading === false) {
            if (newLength > oldLength) {
              this.__resetVirtualScroll();
            } else {
              this.__updateMenu(true);
            }
          }
        });
      }
    }
  },
  computed: {
    isOptionsDark() {
      return this.optionsDark === null ? this.isDark : this.optionsDark;
    },
    virtualScrollLength() {
      return Array.isArray(this.options) ? this.options.length : 0;
    },
    fieldClass() {
      return `q-select q-field--auto-height q-select--with${this.useInput !== true ? 'out' : ''}-input` + ` q-select--with${this.useChips !== true ? 'out' : ''}-chips` + ` q-select--${this.multiple === true ? 'multiple' : 'single'}`;
    },
    computedInputClass() {
      if (this.hideSelected === true || this.innerValue.length === 0) {
        return this.inputClass;
      }
      return this.inputClass === void 0 ? 'q-field__input--padding' : [this.inputClass, 'q-field__input--padding'];
    },
    menuContentClass() {
      return (this.virtualScrollHorizontal === true ? 'q-virtual-scroll--horizontal' : '') + (this.popupContentClass ? ' ' + this.popupContentClass : '');
    },
    innerValue() {
      const mapNull = this.mapOptions === true && this.multiple !== true,
        val = this.value !== void 0 && (this.value !== null || mapNull === true) ? this.multiple === true && Array.isArray(this.value) ? this.value : [this.value] : [];
      if (this.mapOptions === true && Array.isArray(this.options) === true) {
        const cache = this.mapOptions === true && this.innerValueCache !== void 0 ? this.innerValueCache : [];
        const values = val.map(v => this.__getOption(v, cache));
        return this.value === null && mapNull === true ? values.filter(v => v !== null) : values;
      }
      return val;
    },
    noOptions() {
      return this.virtualScrollLength === 0;
    },
    selectedString() {
      return this.innerValue.map(opt => this.getOptionLabel(opt)).join(', ');
    },
    ariaCurrentValue() {
      return this.displayValue !== void 0 ? this.displayValue : this.selectedString;
    },
    sanitizeFn() {
      return this.optionsSanitize === true ? () => true : opt => opt !== void 0 && opt !== null && opt.sanitize === true;
    },
    displayAsText() {
      return this.displayValueSanitize === true || this.displayValue === void 0 && (this.optionsSanitize === true || this.innerValue.some(this.sanitizeFn));
    },
    computedTabindex() {
      return this.focused === true ? this.tabindex : -1;
    },
    selectedScope() {
      return this.innerValue.map((opt, i) => ({
        index: i,
        opt,
        sanitize: this.sanitizeFn(opt),
        selected: true,
        removeAtIndex: this.__removeAtIndexAndFocus,
        toggleOption: this.toggleOption,
        tabindex: this.computedTabindex
      }));
    },
    optionScope() {
      if (this.virtualScrollLength === 0) {
        return [];
      }
      const {
        from,
        to
      } = this.virtualScrollSliceRange;
      const {
        options,
        optionEls
      } = this.__optionScopeCache;
      return this.options.slice(from, to).map((opt, i) => {
        const disable = this.isOptionDisabled(opt);
        const index = from + i;
        const itemProps = {
          clickable: true,
          active: false,
          activeClass: this.computedOptionsSelectedClass,
          manualFocus: true,
          focused: false,
          disable,
          tabindex: -1,
          dense: this.optionsDense,
          dark: this.isOptionsDark
        };
        const itemAttrs = {
          role: 'option',
          id: `${this.targetUid}_${index}`
        };
        if (disable !== true) {
          this.isOptionSelected(opt) === true && (itemProps.active = true);
          itemAttrs['aria-selected'] = itemProps.active === true ? 'true' : 'false';
          this.optionIndex === index && (itemProps.focused = true);
        }
        const itemEvents = {
          click: () => {
            this.toggleOption(opt);
          }
        };
        if (this.$q.platform.is.desktop === true) {
          itemEvents.mousemove = () => {
            this.menu === true && this.setOptionIndex(index);
          };
        }
        const option = {
          index,
          opt,
          sanitize: this.sanitizeFn(opt),
          selected: itemProps.active,
          focused: itemProps.focused,
          toggleOption: this.toggleOption,
          setOptionIndex: this.setOptionIndex,
          itemProps,
          itemAttrs
        };
        if (options[i] === void 0 || Object(_utils_is_js__WEBPACK_IMPORTED_MODULE_9__[/* isDeepEqual */ "b"])(option, options[i]) !== true) {
          options[i] = option;
          optionEls[i] = void 0;
        }
        return {
          ...option,
          itemEvents
        };
      });
    },
    dropdownArrowIcon() {
      return this.dropdownIcon !== void 0 ? this.dropdownIcon : this.$q.iconSet.arrow.dropdown;
    },
    squaredMenu() {
      return this.optionsCover === false && this.outlined !== true && this.standout !== true && this.borderless !== true && this.rounded !== true;
    },
    computedOptionsSelectedClass() {
      return this.optionsSelectedClass !== void 0 ? this.optionsSelectedClass : this.color !== void 0 ? `text-${this.color}` : '';
    },
    innerOptionsValue() {
      return this.innerValue.map(opt => this.getOptionValue(opt));
    },
    // returns method to get value of an option;
    // takes into account 'option-value' prop
    getOptionValue() {
      return this.__getPropValueFn('optionValue', 'value');
    },
    // returns method to get label of an option;
    // takes into account 'option-label' prop
    getOptionLabel() {
      return this.__getPropValueFn('optionLabel', 'label');
    },
    // returns method to tell if an option is disabled;
    // takes into account 'option-disable' prop
    isOptionDisabled() {
      const fn = this.__getPropValueFn('optionDisable', 'disable');
      return (...args) => fn.apply(null, args) === true;
    },
    inputControlEvents() {
      const on = {
        input: this.__onInput,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        change: this.__onChange,
        keydown: this.__onTargetKeydown,
        keyup: this.__onTargetAutocomplete,
        keypress: this.__onTargetKeypress,
        focus: this.__selectInputText,
        click: e => {
          this.hasDialog === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stop */ "k"])(e);
        }
      };
      on.compositionstart = on.compositionupdate = on.compositionend = this.__onComposition;
      return on;
    },
    virtualScrollItemSizeComputed() {
      return this.virtualScrollItemSize === void 0 ? this.optionsDense === true ? 24 : 48 : this.virtualScrollItemSize;
    },
    comboboxAttrs() {
      const attrs = {
        tabindex: this.tabindex,
        role: 'combobox',
        'aria-label': this.label,
        'aria-readonly': this.readonly === true ? 'true' : 'false',
        'aria-autocomplete': this.useInput === true ? 'list' : 'none',
        'aria-expanded': this.menu === true ? 'true' : 'false',
        'aria-controls': `${this.targetUid}_lb`
      };
      if (this.optionIndex >= 0) {
        attrs['aria-activedescendant'] = `${this.targetUid}_${this.optionIndex}`;
      }
      return attrs;
    },
    listboxAttrs() {
      return {
        id: `${this.targetUid}_lb`,
        role: 'listbox',
        'aria-multiselectable': this.multiple === true ? 'true' : 'false'
      };
    }
  },
  methods: {
    getEmittingOptionValue(opt) {
      return this.emitValue === true ? this.getOptionValue(opt) : opt;
    },
    removeAtIndex(index) {
      if (index > -1 && index < this.innerValue.length) {
        if (this.multiple === true) {
          const model = this.value.slice();
          this.$emit('remove', {
            index,
            value: model.splice(index, 1)[0]
          });
          this.$emit('input', model);
        } else {
          this.$emit('input', null);
        }
      }
    },
    __removeAtIndexAndFocus(index) {
      this.removeAtIndex(index);
      this.__focus();
    },
    add(opt, unique) {
      const val = this.getEmittingOptionValue(opt);
      if (this.multiple !== true) {
        this.fillInput === true && this.updateInputValue(this.getOptionLabel(opt), true, true);
        this.$emit('input', val);
        return;
      }
      if (this.innerValue.length === 0) {
        this.$emit('add', {
          index: 0,
          value: val
        });
        this.$emit('input', this.multiple === true ? [val] : val);
        return;
      }
      if (unique === true && this.isOptionSelected(opt) === true) {
        return;
      }
      if (this.maxValues !== void 0 && this.value.length >= this.maxValues) {
        return;
      }
      const model = this.value.slice();
      this.$emit('add', {
        index: model.length,
        value: val
      });
      model.push(val);
      this.$emit('input', model);
    },
    toggleOption(opt, keepOpen) {
      if (this.editable !== true || opt === void 0 || this.isOptionDisabled(opt) === true) {
        return;
      }
      const optValue = this.getOptionValue(opt);
      if (this.multiple !== true) {
        if (keepOpen !== true) {
          this.updateInputValue(this.fillInput === true ? this.getOptionLabel(opt) : '', true, true);
          this.dialogFieldFocused = false;
          document.activeElement.blur();
          this.hidePopup();
        }
        this.$refs.target !== void 0 && this.$refs.target.focus();
        if (this.innerValue.length === 0 || Object(_utils_is_js__WEBPACK_IMPORTED_MODULE_9__[/* isDeepEqual */ "b"])(this.getOptionValue(this.innerValue[0]), optValue) !== true) {
          this.$emit('input', this.emitValue === true ? optValue : opt);
        }
        return;
      }
      (this.hasDialog !== true || this.dialogFieldFocused === true) && this.__focus();
      this.__selectInputText();
      if (this.innerValue.length === 0) {
        const val = this.emitValue === true ? optValue : opt;
        this.$emit('add', {
          index: 0,
          value: val
        });
        this.$emit('input', this.multiple === true ? [val] : val);
        return;
      }
      const model = this.value.slice(),
        index = this.innerOptionsValue.findIndex(v => Object(_utils_is_js__WEBPACK_IMPORTED_MODULE_9__[/* isDeepEqual */ "b"])(v, optValue));
      if (index > -1) {
        this.$emit('remove', {
          index,
          value: model.splice(index, 1)[0]
        });
      } else {
        if (this.maxValues !== void 0 && model.length >= this.maxValues) {
          return;
        }
        const val = this.emitValue === true ? optValue : opt;
        this.$emit('add', {
          index: model.length,
          value: val
        });
        model.push(val);
      }
      this.$emit('input', model);
    },
    setOptionIndex(index) {
      if (this.$q.platform.is.desktop !== true) {
        return;
      }
      const val = index > -1 && index < this.virtualScrollLength ? index : -1;
      if (this.optionIndex !== val) {
        this.optionIndex = val;
      }
    },
    moveOptionSelection(offset = 1, skipInputValue) {
      if (this.menu === true) {
        let index = this.optionIndex;
        do {
          index = Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_11__[/* normalizeToInterval */ "d"])(index + offset, -1, this.virtualScrollLength - 1);
        } while (index !== -1 && index !== this.optionIndex && this.isOptionDisabled(this.options[index]) === true);
        if (this.optionIndex !== index) {
          cancelAnimationFrame(this.moveAnimationFrame);
          this.moveAnimationFrame = requestAnimationFrame(() => {
            this.setOptionIndex(index);
            this.scrollTo(index);
            if (skipInputValue !== true && this.useInput === true && this.fillInput === true) {
              this.__setInputValue(index >= 0 ? this.getOptionLabel(this.options[index]) : this.defaultInputValue);
            }
          });
        }
      }
    },
    __getOption(value, innerValueCache) {
      const fn = opt => Object(_utils_is_js__WEBPACK_IMPORTED_MODULE_9__[/* isDeepEqual */ "b"])(this.getOptionValue(opt), value);
      return this.options.find(fn) || innerValueCache.find(fn) || value;
    },
    __getPropValueFn(propName, defaultVal) {
      const val = this[propName] !== void 0 ? this[propName] : defaultVal;
      return typeof val === 'function' ? val : opt => opt !== null && typeof opt === 'object' && val in opt ? opt[val] : opt;
    },
    isOptionSelected(opt) {
      const val = this.getOptionValue(opt);
      return this.innerOptionsValue.find(v => Object(_utils_is_js__WEBPACK_IMPORTED_MODULE_9__[/* isDeepEqual */ "b"])(v, val)) !== void 0;
    },
    __selectInputText(e) {
      if (this.useInput === true && this.$refs.target !== void 0 && (e === void 0 || this.$refs.target === e.target && e.target.value === this.selectedString)) {
        this.$refs.target.select();
      }
    },
    __onTargetKeyup(e) {
      // if ESC and we have an opened menu
      // then stop propagation (might be caught by a QDialog
      // and so it will also close the QDialog, which is wrong)
      if (Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_12__[/* isKeyCode */ "a"])(e, 27) === true && this.menu === true) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stop */ "k"])(e);
        // on ESC we need to close the dialog also
        this.hidePopup();
        this.__resetInputValue();
      }
      this.$emit('keyup', e);
    },
    __onTargetAutocomplete(e) {
      const {
        value
      } = e.target;
      if (e.keyCode !== void 0) {
        this.__onTargetKeyup(e);
        return;
      }
      e.target.value = '';
      clearTimeout(this.inputTimer);
      this.__resetInputValue();
      if (typeof value === 'string' && value.length > 0) {
        const needle = value.toLocaleLowerCase();
        const findFn = extractFn => {
          const option = this.options.find(opt => extractFn(opt).toLocaleLowerCase() === needle);
          if (option === void 0) {
            return false;
          }
          if (this.innerValue.indexOf(option) === -1) {
            this.toggleOption(option);
          } else {
            this.hidePopup();
          }
          return true;
        };
        const fillFn = afterFilter => {
          if (findFn(this.getOptionValue) === true) {
            return;
          }
          if (findFn(this.getOptionLabel) === true || afterFilter === true) {
            return;
          }
          this.filter(value, true, () => fillFn(true));
        };
        fillFn();
      } else {
        this.__clearValue(e);
      }
    },
    __onTargetKeypress(e) {
      this.$emit('keypress', e);
    },
    __onTargetKeydown(e) {
      this.$emit('keydown', e);
      if (Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_12__[/* shouldIgnoreKey */ "c"])(e) === true) {
        return;
      }
      const newValueModeValid = this.inputValue.length > 0 && (this.newValueMode !== void 0 || this.qListeners['new-value'] !== void 0);
      const tabShouldSelect = e.shiftKey !== true && this.multiple !== true && (this.optionIndex > -1 || newValueModeValid === true);

      // escape
      if (e.keyCode === 27) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* prevent */ "i"])(e); // prevent clearing the inputValue
        return;
      }

      // tab
      if (e.keyCode === 9 && tabShouldSelect === false) {
        this.__closeMenu();
        return;
      }
      if (e.target === void 0 || e.target.id !== this.targetUid) {
        return;
      }

      // down
      if (e.keyCode === 40 && this.innerLoading !== true && this.menu === false) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stopAndPrevent */ "l"])(e);
        this.showPopup();
        return;
      }

      // backspace
      if (e.keyCode === 8 && this.hideSelected !== true && this.inputValue.length === 0) {
        if (this.multiple === true && Array.isArray(this.value)) {
          this.removeAtIndex(this.value.length - 1);
        } else if (this.multiple !== true && this.value !== null) {
          this.$emit('input', null);
        }
        return;
      }

      // home, end - 36, 35
      if ((e.keyCode === 35 || e.keyCode === 36) && (typeof this.inputValue !== 'string' || this.inputValue.length === 0)) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stopAndPrevent */ "l"])(e);
        this.optionIndex = -1;
        this.moveOptionSelection(e.keyCode === 36 ? 1 : -1, this.multiple);
      }

      // pg up, pg down - 33, 34
      if ((e.keyCode === 33 || e.keyCode === 34) && this.virtualScrollSliceSizeComputed !== void 0) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stopAndPrevent */ "l"])(e);
        this.optionIndex = Math.max(-1, Math.min(this.virtualScrollLength, this.optionIndex + (e.keyCode === 33 ? -1 : 1) * this.virtualScrollSliceSizeComputed.view));
        this.moveOptionSelection(e.keyCode === 33 ? 1 : -1, this.multiple);
      }

      // up, down
      if (e.keyCode === 38 || e.keyCode === 40) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stopAndPrevent */ "l"])(e);
        this.moveOptionSelection(e.keyCode === 38 ? -1 : 1, this.multiple);
      }
      const optionsLength = this.virtualScrollLength;

      // clear search buffer if expired
      if (this.searchBuffer === void 0 || this.searchBufferExp < Date.now()) {
        this.searchBuffer = '';
      }

      // keyboard search when not having use-input
      if (optionsLength > 0 && this.useInput !== true && e.key !== void 0 && e.key.length === 1 &&
      // printable char
      e.altKey === false &&
      // not kbd shortcut
      e.ctrlKey === false &&
      // not kbd shortcut
      e.metaKey === false && (
      // not kbd shortcut, especially on macOS with Command key
      e.keyCode !== 32 || this.searchBuffer.length > 0) // space in middle of search
      ) {
        this.menu !== true && this.showPopup(e);
        const char = e.key.toLocaleLowerCase(),
          keyRepeat = this.searchBuffer.length === 1 && this.searchBuffer[0] === char;
        this.searchBufferExp = Date.now() + 1500;
        if (keyRepeat === false) {
          Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stopAndPrevent */ "l"])(e);
          this.searchBuffer += char;
        }
        const searchRe = new RegExp('^' + this.searchBuffer.split('').map(l => reEscapeList.indexOf(l) > -1 ? '\\' + l : l).join('.*'), 'i');
        let index = this.optionIndex;
        if (keyRepeat === true || index < 0 || searchRe.test(this.getOptionLabel(this.options[index])) !== true) {
          do {
            index = Object(_utils_format_js__WEBPACK_IMPORTED_MODULE_11__[/* normalizeToInterval */ "d"])(index + 1, -1, optionsLength - 1);
          } while (index !== this.optionIndex && (this.isOptionDisabled(this.options[index]) === true || searchRe.test(this.getOptionLabel(this.options[index])) !== true));
        }
        if (this.optionIndex !== index) {
          this.$nextTick(() => {
            this.setOptionIndex(index);
            this.scrollTo(index);
            if (index >= 0 && this.useInput === true && this.fillInput === true) {
              this.__setInputValue(this.getOptionLabel(this.options[index]));
            }
          });
        }
        return;
      }

      // enter, space (when not using use-input and not in search), or tab (when not using multiple and option selected)
      // same target is checked above
      if (e.keyCode !== 13 && (e.keyCode !== 32 || this.useInput === true || this.searchBuffer !== '') && (e.keyCode !== 9 || tabShouldSelect === false)) {
        return;
      }
      e.keyCode !== 9 && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stopAndPrevent */ "l"])(e);
      if (this.optionIndex > -1 && this.optionIndex < optionsLength) {
        this.toggleOption(this.options[this.optionIndex]);
        return;
      }
      if (newValueModeValid === true) {
        const done = (val, mode) => {
          if (mode) {
            if (validateNewValueMode(mode) !== true) {
              return;
            }
          } else {
            mode = this.newValueMode;
          }
          if (val === void 0 || val === null) {
            return;
          }
          this.updateInputValue('', this.multiple !== true, true);
          this[mode === 'toggle' ? 'toggleOption' : 'add'](val, mode === 'add-unique');
          if (this.multiple !== true) {
            this.$refs.target !== void 0 && this.$refs.target.focus();
            this.hidePopup();
          }
        };
        if (this.qListeners['new-value'] !== void 0) {
          this.$emit('new-value', this.inputValue, done);
        } else {
          done(this.inputValue);
        }
        if (this.multiple !== true) {
          return;
        }
      }
      if (this.menu === true) {
        this.__closeMenu();
      } else if (this.innerLoading !== true) {
        this.showPopup();
      }
    },
    __getVirtualScrollEl() {
      return this.hasDialog === true ? this.$refs.menuContent : this.$refs.menu !== void 0 && this.$refs.menu.__portal !== void 0 ? this.$refs.menu.__portal.$el : void 0;
    },
    __getVirtualScrollTarget() {
      return this.__getVirtualScrollEl();
    },
    __getSelection(h) {
      if (this.hideSelected === true) {
        return [];
      }
      if (this.$scopedSlots['selected-item'] !== void 0) {
        return this.selectedScope.map(scope => this.$scopedSlots['selected-item'](scope)).slice();
      }
      if (this.$scopedSlots.selected !== void 0) {
        return [].concat(this.$scopedSlots.selected());
      }
      if (this.useChips === true) {
        return this.selectedScope.map((scope, i) => h(_chip_QChip_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
          key: 'rem#' + i,
          props: {
            removable: this.editable === true && this.isOptionDisabled(scope.opt) !== true,
            dense: true,
            textColor: this.color,
            tabindex: this.computedTabindex
          },
          on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_14__[/* default */ "b"])(this, 'rem#' + i, {
            remove() {
              scope.removeAtIndex(i);
            }
          })
        }, [h('span', {
          staticClass: 'ellipsis',
          domProps: {
            [scope.sanitize === true ? 'textContent' : 'innerHTML']: this.getOptionLabel(scope.opt)
          }
        })]));
      }
      return [h('span', {
        domProps: {
          [this.displayAsText ? 'textContent' : 'innerHTML']: this.ariaCurrentValue
        }
      })];
    },
    __getControl(h, fromDialog) {
      const child = this.__getSelection(h);
      const isTarget = fromDialog === true || this.dialog !== true || this.hasDialog !== true;
      if (this.useInput === true) {
        child.push(this.__getInput(h, fromDialog, isTarget));
      }
      // there can be only one (when dialog is opened the control in dialog should be target)
      else if (this.editable === true) {
        const attrs = isTarget === true ? this.comboboxAttrs : void 0;
        child.push(h('input', {
          ref: isTarget === true ? 'target' : void 0,
          key: 'd_t',
          staticClass: 'q-select__focus-target',
          attrs: {
            id: isTarget === true ? this.targetUid : void 0,
            readonly: true,
            'data-autofocus': (fromDialog === true ? isTarget === true : this.autofocus) || void 0,
            ...attrs
          },
          on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_14__[/* default */ "b"])(this, 'f-tget', {
            keydown: this.__onTargetKeydown,
            keyup: this.__onTargetKeyup,
            keypress: this.__onTargetKeypress
          })
        }));
        if (isTarget === true && typeof this.autocomplete === 'string' && this.autocomplete.length > 0) {
          child.push(h('input', {
            key: 'autoinp',
            staticClass: 'q-select__autocomplete-input',
            domProps: {
              value: this.ariaCurrentValue
            },
            attrs: {
              autocomplete: this.autocomplete,
              tabindex: -1
            },
            on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_14__[/* default */ "b"])(this, 'autoinp', {
              keyup: this.__onTargetAutocomplete
            })
          }));
        }
      }
      if (this.nameProp !== void 0 && this.disable !== true && this.innerOptionsValue.length > 0) {
        const opts = this.innerOptionsValue.map(value => h('option', {
          attrs: {
            value,
            selected: true
          }
        }));
        child.push(h('select', {
          staticClass: 'hidden',
          attrs: {
            name: this.nameProp,
            multiple: this.multiple
          }
        }, opts));
      }
      const attrs = this.useInput === true || isTarget !== true ? void 0 : this.qAttrs;
      return h('div', {
        staticClass: 'q-field__native row items-center',
        attrs
      }, child);
    },
    __getOptions(h) {
      if (this.menu !== true) {
        return void 0;
      }
      if (this.noOptions === true) {
        return this.$scopedSlots['no-option'] !== void 0 ? this.$scopedSlots['no-option']({
          inputValue: this.inputValue
        }) : void 0;
      }
      if (this.$scopedSlots.option !== void 0 && this.__optionScopeCache.optionSlot !== this.$scopedSlots.option) {
        this.__optionScopeCache.optionSlot = this.$scopedSlots.option;
        this.__optionScopeCache.optionEls = [];
      }
      const fn = this.$scopedSlots.option !== void 0 ? this.$scopedSlots.option : scope => h(_item_QItem_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], {
        key: scope.index,
        props: scope.itemProps,
        attrs: scope.itemAttrs,
        on: scope.itemEvents
      }, [h(_item_QItemSection_js__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], [h(_item_QItemLabel_js__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], {
        domProps: {
          [scope.sanitize === true ? 'textContent' : 'innerHTML']: this.getOptionLabel(scope.opt)
        }
      })])]);
      const {
        optionEls
      } = this.__optionScopeCache;
      let options = this.__padVirtualScroll(h, 'div', this.optionScope.map((scope, i) => {
        if (optionEls[i] === void 0) {
          optionEls[i] = fn(scope);
        }
        return optionEls[i];
      }));
      if (this.$scopedSlots['before-options'] !== void 0) {
        options = this.$scopedSlots['before-options']().concat(options);
      }
      return Object(_utils_private_slot_js__WEBPACK_IMPORTED_MODULE_13__[/* mergeSlot */ "a"])(options, this, 'after-options');
    },
    __getInnerAppend(h) {
      return this.loading !== true && this.innerLoadingIndicator !== true && this.hideDropdownIcon !== true ? [h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
        staticClass: 'q-select__dropdown-icon' + (this.menu === true ? ' rotate-180' : ''),
        props: {
          name: this.dropdownArrowIcon
        }
      })] : null;
    },
    __getInput(h, fromDialog, isTarget) {
      const attrs = isTarget === true ? {
        ...this.comboboxAttrs,
        ...this.qAttrs
      } : void 0;
      const options = {
        ref: isTarget === true ? 'target' : void 0,
        key: 'i_t',
        staticClass: 'q-field__input q-placeholder col',
        style: this.inputStyle,
        class: this.computedInputClass,
        domProps: {
          value: this.inputValue !== void 0 ? this.inputValue : ''
        },
        attrs: {
          // required for Android in order to show ENTER key when in form
          type: 'search',
          ...attrs,
          id: isTarget === true ? this.targetUid : void 0,
          maxlength: this.maxlength,
          // this is converted to prop by QField
          autocomplete: this.autocomplete,
          'data-autofocus': (fromDialog === true ? isTarget === true : this.autofocus) || void 0,
          disabled: this.disable === true,
          readonly: this.readonly === true
        },
        on: this.inputControlEvents
      };
      if (fromDialog !== true && this.hasDialog === true) {
        options.staticClass += ' no-pointer-events';
      }
      return h('input', options);
    },
    __onChange(e) {
      this.__onComposition(e);
    },
    __onInput(e) {
      clearTimeout(this.inputTimer);
      if (e && e.target && e.target.qComposing === true) {
        return;
      }
      this.__setInputValue(e.target.value || '');
      // mark it here as user input so that if updateInputValue is called
      // before filter is called the indicator is reset
      this.userInputValue = true;
      this.defaultInputValue = this.inputValue;
      if (this.focused !== true && (this.hasDialog !== true || this.dialogFieldFocused === true)) {
        this.__focus();
      }
      if (this.qListeners.filter !== void 0) {
        this.inputTimer = setTimeout(() => {
          this.filter(this.inputValue);
        }, this.inputDebounce);
      }
    },
    __setInputValue(inputValue) {
      if (this.inputValue !== inputValue) {
        this.inputValue = inputValue;
        this.$emit('input-value', inputValue);
      }
    },
    updateInputValue(val, noFiltering, internal) {
      this.userInputValue = internal !== true;
      if (this.useInput === true) {
        this.__setInputValue(val);
        if (noFiltering === true || internal !== true) {
          this.defaultInputValue = val;
        }
        noFiltering !== true && this.filter(val);
      }
    },
    filter(val, keepClosed, afterUpdateFn) {
      if (this.qListeners.filter === void 0 || keepClosed !== true && this.focused !== true) {
        return;
      }
      if (this.innerLoading === true) {
        this.$emit('filter-abort');
      } else {
        this.innerLoading = true;
        this.innerLoadingIndicator = true;
      }
      if (val !== '' && this.multiple !== true && this.innerValue.length > 0 && this.userInputValue !== true && val === this.getOptionLabel(this.innerValue[0])) {
        val = '';
      }
      const filterId = setTimeout(() => {
        this.menu === true && (this.menu = false);
      }, 10);
      clearTimeout(this.filterId);
      this.filterId = filterId;
      this.$emit('filter', val, (fn, afterFn) => {
        if ((keepClosed === true || this.focused === true) && this.filterId === filterId) {
          clearTimeout(this.filterId);
          typeof fn === 'function' && fn();

          // hide indicator to allow arrow to animate
          this.innerLoadingIndicator = false;
          this.$nextTick(() => {
            this.innerLoading = false;
            if (this.editable === true) {
              if (keepClosed === true) {
                this.menu === true && this.hidePopup();
              } else if (this.menu === true) {
                this.__updateMenu(true);
              } else {
                this.menu = true;
                this.hasDialog === true && (this.dialog = true);
              }
            }
            typeof afterFn === 'function' && this.$nextTick(() => {
              afterFn(this);
            });
            typeof afterUpdateFn === 'function' && this.$nextTick(() => {
              afterUpdateFn(this);
            });
          });
        }
      }, () => {
        if (this.focused === true && this.filterId === filterId) {
          clearTimeout(this.filterId);
          this.innerLoading = false;
          this.innerLoadingIndicator = false;
        }
        this.menu === true && (this.menu = false);
      });
    },
    __getControlEvents() {
      const focusout = e => {
        this.__onControlFocusout(e, () => {
          this.__resetInputValue();
          this.__closeMenu();
        });
      };
      return {
        focusin: this.__onControlFocusin,
        focusout,
        'popup-show': this.__onControlPopupShow,
        'popup-hide': e => {
          e !== void 0 && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stop */ "k"])(e);
          this.$emit('popup-hide', e);
          this.hasPopupOpen = false;
          focusout(e);
        },
        click: e => {
          // label from QField will propagate click on the input (except IE)
          Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* prevent */ "i"])(e);
          if (this.hasDialog !== true && this.menu === true) {
            this.__closeMenu();
            this.$refs.target !== void 0 && this.$refs.target.focus();
            return;
          }
          this.showPopup(e);
        }
      };
    },
    __getControlChild(h) {
      if (this.editable !== false && (this.dialog === true ||
      // dialog always has menu displayed, so need to render it
      this.noOptions !== true || this.$scopedSlots['no-option'] !== void 0)) {
        return this[`__get${this.hasDialog === true ? 'Dialog' : 'Menu'}`](h);
      }
    },
    __getMenu(h) {
      return h(_menu_QMenu_js__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"], {
        key: 'menu',
        ref: 'menu',
        props: {
          value: this.menu,
          fit: this.menuShrink !== true,
          cover: this.optionsCover === true && this.noOptions !== true && this.useInput !== true,
          anchor: this.menuAnchor,
          self: this.menuSelf,
          offset: this.menuOffset,
          contentClass: this.menuContentClass,
          contentStyle: this.popupContentStyle,
          dark: this.isOptionsDark,
          noParentEvent: true,
          noRefocus: true,
          noFocus: true,
          square: this.squaredMenu,
          transitionShow: this.transitionShow,
          transitionHide: this.transitionHide,
          separateClosePopup: true
        },
        attrs: this.listboxAttrs,
        on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_14__[/* default */ "b"])(this, 'menu', {
          '&scroll': this.__onVirtualScrollEvt,
          'before-hide': this.__closeMenu,
          show: this.__onMenuShow
        })
      }, this.__getOptions(h));
    },
    __onMenuShow() {
      this.__setVirtualScrollSize();
    },
    __onDialogFieldFocus(e) {
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stop */ "k"])(e);
      this.$refs.target !== void 0 && this.$refs.target.focus();
      this.dialogFieldFocused = true;
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
    },
    __onDialogFieldBlur(e) {
      Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* stop */ "k"])(e);
      this.$nextTick(() => {
        this.dialogFieldFocused = false;
      });
    },
    __getDialog(h) {
      const content = [h(_field_QField_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
        staticClass: `col-auto ${this.fieldClass}`,
        props: {
          ...this.$props,
          for: this.targetUid,
          dark: this.isOptionsDark,
          square: true,
          filled: true,
          itemAligned: false,
          loading: this.innerLoadingIndicator,
          stackLabel: this.inputValue.length > 0
        },
        on: {
          ...this.qListeners,
          focus: this.__onDialogFieldFocus,
          blur: this.__onDialogFieldBlur
        },
        scopedSlots: {
          ...this.$scopedSlots,
          rawControl: () => this.__getControl(h, true),
          before: void 0,
          after: void 0
        }
      })];
      this.menu === true && content.push(h('div', {
        key: 'virtMenu',
        ref: 'menuContent',
        staticClass: 'col scroll',
        class: this.menuContentClass,
        style: this.popupContentStyle,
        attrs: this.listboxAttrs,
        on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_14__[/* default */ "b"])(this, 'virtMenu', {
          click: _utils_event_js__WEBPACK_IMPORTED_MODULE_10__[/* prevent */ "i"],
          '&scroll': this.__onVirtualScrollEvt
        })
      }, this.__getOptions(h)));
      return h(_dialog_QDialog_js__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
        key: 'dialog',
        ref: 'dialog',
        props: {
          value: this.dialog,
          dark: this.isOptionsDark,
          position: this.useInput === true ? 'top' : void 0,
          transitionShow: this.transitionShowComputed,
          transitionHide: this.transitionHide
        },
        on: Object(_utils_private_cache_js__WEBPACK_IMPORTED_MODULE_14__[/* default */ "b"])(this, 'dialog', {
          'before-hide': this.__onDialogBeforeHide,
          hide: this.__onDialogHide,
          show: this.__onDialogShow
        })
      }, [h('div', {
        staticClass: 'q-select__dialog' + (this.isOptionsDark === true ? ' q-select__dialog--dark q-dark' : '') + (this.dialogFieldFocused === true ? ' q-select__dialog--focused' : '')
      }, content)]);
    },
    __onDialogBeforeHide() {
      if (this.useInput !== true || this.$q.platform.is.desktop === true) {
        this.$refs.dialog.__refocusTarget = this.$el.querySelector('.q-field__native > [tabindex]:last-child');
      }
      this.focused = false;
      this.dialogFieldFocused = false;
    },
    __onDialogHide(e) {
      if (this.$q.platform.is.desktop !== true) {
        document.activeElement.blur();
      }
      this.hidePopup();
      this.focused === false && this.$emit('blur', e);
      this.__resetInputValue();
    },
    __onDialogShow() {
      const el = document.activeElement;
      // IE can have null document.activeElement
      if ((el === null || el.id !== this.targetUid) && this.$refs.target !== el && this.$refs.target !== void 0) {
        this.$refs.target.focus();
      }
      this.__setVirtualScrollSize();
    },
    __closeMenu() {
      if (this.__optionScopeCache !== void 0) {
        this.__optionScopeCache.optionEls = [];
      }
      if (this.dialog === true) {
        return;
      }
      this.optionIndex = -1;
      if (this.menu === true) {
        this.menu = false;
      }
      if (this.focused === false) {
        clearTimeout(this.filterId);
        this.filterId = void 0;
        if (this.innerLoading === true) {
          this.$emit('filter-abort');
          this.innerLoading = false;
          this.innerLoadingIndicator = false;
        }
      }
    },
    showPopup(e) {
      if (this.editable !== true) {
        return;
      }
      if (this.hasDialog === true) {
        this.__onControlFocusin(e);
        this.dialog = true;
        this.$nextTick(() => {
          this.__focus();
        });
      } else {
        this.__focus();
      }
      if (this.qListeners.filter !== void 0) {
        this.filter(this.inputValue);
      } else if (this.noOptions !== true || this.$scopedSlots['no-option'] !== void 0) {
        this.menu = true;
      }
    },
    hidePopup() {
      this.dialog = false;
      this.__closeMenu();
    },
    __resetInputValue() {
      this.useInput === true && this.updateInputValue(this.multiple !== true && this.fillInput === true && this.innerValue.length > 0 ? this.getOptionLabel(this.innerValue[0]) || '' : '', true, true);
    },
    __updateMenu(show) {
      let optionIndex = -1;
      if (show === true) {
        if (this.innerValue.length > 0) {
          const val = this.getOptionValue(this.innerValue[0]);
          optionIndex = this.options.findIndex(v => Object(_utils_is_js__WEBPACK_IMPORTED_MODULE_9__[/* isDeepEqual */ "b"])(this.getOptionValue(v), val));
        }
        this.__resetVirtualScroll(optionIndex);
      }
      this.setOptionIndex(optionIndex);
    },
    __onPreRender() {
      this.hasDialog = this.$q.platform.is.mobile !== true && this.behavior !== 'dialog' ? false : this.behavior !== 'menu' && (this.useInput === true ? this.$scopedSlots['no-option'] !== void 0 || this.qListeners.filter !== void 0 || this.noOptions === false : true);
      this.transitionShowComputed = this.hasDialog === true && this.useInput === true && this.$q.platform.is.ios === true ? 'fade' : this.transitionShow;
    },
    __onPostRender() {
      if (this.dialog === false && this.$refs.menu !== void 0) {
        this.$refs.menu.updatePosition();
      }
    },
    updateMenuPosition() {
      this.__onPostRender();
    }
  },
  beforeMount() {
    this.__optionScopeCache = {
      optionSlot: this.$scopedSlots.option,
      options: [],
      optionEls: []
    };
  },
  beforeDestroy() {
    this.__optionScopeCache = void 0;
    clearTimeout(this.inputTimer);
  }
}));

/***/ }),

/***/ "de60":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("9438");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".qc-image[data-v-7b4c9052]{transition:transform .2s ease-out;display:block;object-fit:contain}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "de96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a170");
/* harmony import */ var _mixins_checkbox_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d84a");



/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QToggle',
  mixins: [_mixins_checkbox_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]],
  props: {
    icon: String,
    iconColor: String
  },
  computed: {
    computedIcon() {
      return (this.isTrue === true ? this.checkedIcon : this.isIndeterminate === true ? this.indeterminateIcon : this.uncheckedIcon) || this.icon;
    },
    computedIconColor() {
      if (this.isTrue === true) {
        return this.iconColor;
      }
    }
  },
  methods: {
    __getInner(h) {
      return [h('div', {
        staticClass: 'q-toggle__track'
      }), h('div', {
        staticClass: 'q-toggle__thumb absolute flex flex-center no-wrap'
      }, this.computedIcon !== void 0 ? [h(_icon_QIcon_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], {
        props: {
          name: this.computedIcon,
          color: this.computedIconColor
        }
      })] : void 0)];
    }
  },
  created() {
    this.type = 'toggle';
  }
}));

/***/ }),

/***/ "defa":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("e7d7")))

/***/ }),

/***/ "dfbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "setAxios", function() { return /* reexport */ src_0["o" /* setAxios */]; });
__webpack_require__.d(__webpack_exports__, "ClassExpansion", function() { return /* reexport */ src_0["a" /* ClassExpansion */]; });
__webpack_require__.d(__webpack_exports__, "Image", function() { return /* reexport */ src_0["b" /* Image */]; });
__webpack_require__.d(__webpack_exports__, "ImageControl", function() { return /* reexport */ src_0["c" /* ImageControl */]; });
__webpack_require__.d(__webpack_exports__, "QCReview", function() { return /* reexport */ src_0["e" /* QCReview */]; });
__webpack_require__.d(__webpack_exports__, "ViewGrid", function() { return /* reexport */ src_0["f" /* ViewGrid */]; });
__webpack_require__.d(__webpack_exports__, "Worksheet", function() { return /* reexport */ src_0["g" /* Worksheet */]; });
__webpack_require__.d(__webpack_exports__, "ZoomControl", function() { return /* reexport */ src_0["h" /* ZoomControl */]; });
__webpack_require__.d(__webpack_exports__, "ZoomImage", function() { return /* reexport */ src_0["i" /* ZoomImage */]; });
__webpack_require__.d(__webpack_exports__, "enableFeatures", function() { return /* reexport */ src_0["j" /* enableFeatures */]; });
__webpack_require__.d(__webpack_exports__, "setApp", function() { return /* reexport */ src_0["n" /* setApp */]; });
__webpack_require__.d(__webpack_exports__, "getIcon", function() { return /* reexport */ src_0["k" /* getIcon */]; });
__webpack_require__.d(__webpack_exports__, "ImageStore", function() { return /* reexport */ src_0["d" /* ImageStore */]; });
__webpack_require__.d(__webpack_exports__, "route", function() { return /* reexport */ src_0["m" /* route */]; });
__webpack_require__.d(__webpack_exports__, "setThumbnailBucket", function() { return /* reexport */ src_0["p" /* setThumbnailBucket */]; });
__webpack_require__.d(__webpack_exports__, "getThumbnailBucket", function() { return /* reexport */ src_0["l" /* getThumbnailBucket */]; });

// CONCATENATED MODULE: /workspace/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/index.ts + 256 modules
var src_0 = __webpack_require__("ffb4");

// CONCATENATED MODULE: /workspace/node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "e074":
/***/ (function(module) {

module.exports = JSON.parse("{\"a\":\"1.22.10\"}");

/***/ }),

/***/ "e106":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mixins_portal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d485");
/* harmony import */ var _utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("116d");



/*
 * depth
 *   < 0  --> close all chain
 *   0    --> disabled
 *   > 0  --> close chain up to N parent
 */

function getDepth(value) {
  if (value === false) {
    return 0;
  }
  if (value === true || value === void 0) {
    return 1;
  }
  const depth = parseInt(value, 10);
  return isNaN(depth) ? 0 : depth;
}
function destroy(el) {
  const ctx = el.__qclosepopup;
  if (ctx !== void 0) {
    el.removeEventListener('click', ctx.handler);
    el.removeEventListener('keyup', ctx.handlerKey);
    delete el.__qclosepopup;
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'close-popup',
  bind(el, {
    value
  }, vnode) {
    if (el.__qclosepopup !== void 0) {
      destroy(el);
      el.__qclosepopup_destroyed = true;
    }
    const ctx = {
      depth: getDepth(value),
      handler(evt) {
        // allow @click to be emitted
        ctx.depth !== 0 && setTimeout(() => {
          Object(_mixins_portal_js__WEBPACK_IMPORTED_MODULE_0__[/* closePortals */ "b"])(vnode.componentInstance || vnode.context, evt, ctx.depth);
        });
      },
      handlerKey(evt) {
        Object(_utils_private_key_composition_js__WEBPACK_IMPORTED_MODULE_1__[/* isKeyCode */ "a"])(evt, 13) === true && ctx.handler(evt);
      }
    };
    el.__qclosepopup = ctx;
    el.addEventListener('click', ctx.handler);
    el.addEventListener('keyup', ctx.handlerKey);
  },
  update(el, {
    value,
    oldValue
  }) {
    if (el.__qclosepopup !== void 0 && value !== oldValue) {
      el.__qclosepopup.depth = getDepth(value);
    }
  },
  unbind(el) {
    if (el.__qclosepopup_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__qclosepopup_destroyed;
    }
  }
});

/***/ }),

/***/ "e230":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_Worksheet_vue_vue_type_style_index_0_id_4d0ef3ae_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9da5");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_Worksheet_vue_vue_type_style_index_0_id_4d0ef3ae_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_Worksheet_vue_vue_type_style_index_0_id_4d0ef3ae_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e278":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE = __webpack_require__("cd06");

var _CODE2 = __webpack_require__("6c83");

var _EAN_UPC = __webpack_require__("6b0e");

var _ITF = __webpack_require__("048c");

var _MSI = __webpack_require__("cdc9");

var _pharmacode = __webpack_require__("8ab9");

var _codabar = __webpack_require__("06fb");

var _GenericBarcode = __webpack_require__("5c27");

exports.default = {
	CODE39: _CODE.CODE39,
	CODE128: _CODE2.CODE128, CODE128A: _CODE2.CODE128A, CODE128B: _CODE2.CODE128B, CODE128C: _CODE2.CODE128C,
	EAN13: _EAN_UPC.EAN13, EAN8: _EAN_UPC.EAN8, EAN5: _EAN_UPC.EAN5, EAN2: _EAN_UPC.EAN2, UPC: _EAN_UPC.UPC, UPCE: _EAN_UPC.UPCE,
	ITF14: _ITF.ITF14,
	ITF: _ITF.ITF,
	MSI: _MSI.MSI, MSI10: _MSI.MSI10, MSI11: _MSI.MSI11, MSI1010: _MSI.MSI1010, MSI1110: _MSI.MSI1110,
	pharmacode: _pharmacode.pharmacode,
	codabar: _codabar.codabar,
	GenericBarcode: _GenericBarcode.GenericBarcode
};

/***/ }),

/***/ "e599":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_Image_vue_vue_type_style_index_0_id_4db7a124_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("79ca");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_Image_vue_vue_type_style_index_0_id_4db7a124_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_vue_cli_plugin_quasar_lib_loader_auto_import_js_kebab_node_modules_cache_loader_dist_cjs_js_ref_1_1_node_modules_vue_loader_lib_index_js_vue_loader_options_Image_vue_vue_type_style_index_0_id_4db7a124_prod_lang_stylus_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e795":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (old, replaceObj) {
  return _extends({}, old, replaceObj);
};

/***/ }),

/***/ "e7d7":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("defa");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "ee82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4ef2");

/* harmony default export */ __webpack_exports__["a"] = (Object(_size_js__WEBPACK_IMPORTED_MODULE_0__[/* getSizeMixin */ "b"])({
  xs: 30,
  sm: 35,
  md: 40,
  lg: 50,
  xl: 60
}));

/***/ }),

/***/ "f0a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = __webpack_require__("2c64");

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = __webpack_require__("f120");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128A = function (_CODE) {
	_inherits(CODE128A, _CODE);

	function CODE128A(string, options) {
		_classCallCheck(this, CODE128A);

		return _possibleConstructorReturn(this, (CODE128A.__proto__ || Object.getPrototypeOf(CODE128A)).call(this, _constants.A_START_CHAR + string, options));
	}

	_createClass(CODE128A, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.A_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128A;
}(_CODE3.default);

exports.default = CODE128A;

/***/ }),

/***/ "f120":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _SET_BY_CODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// constants for internal usage
var SET_A = exports.SET_A = 0;
var SET_B = exports.SET_B = 1;
var SET_C = exports.SET_C = 2;

// Special characters
var SHIFT = exports.SHIFT = 98;
var START_A = exports.START_A = 103;
var START_B = exports.START_B = 104;
var START_C = exports.START_C = 105;
var MODULO = exports.MODULO = 103;
var STOP = exports.STOP = 106;
var FNC1 = exports.FNC1 = 207;

// Get set by start code
var SET_BY_CODE = exports.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty(_SET_BY_CODE, START_A, SET_A), _defineProperty(_SET_BY_CODE, START_B, SET_B), _defineProperty(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);

// Get next set by code
var SWAP = exports.SWAP = {
	101: SET_A,
	100: SET_B,
	99: SET_C
};

var A_START_CHAR = exports.A_START_CHAR = String.fromCharCode(208); // START_A + 105
var B_START_CHAR = exports.B_START_CHAR = String.fromCharCode(209); // START_B + 105
var C_START_CHAR = exports.C_START_CHAR = String.fromCharCode(210); // START_C + 105

// 128A (Code Set A)
// ASCII characters 00 to 95 (0–9, A–Z and control codes), special characters, and FNC 1–4
var A_CHARS = exports.A_CHARS = "[\x00-\x5F\xC8-\xCF]";

// 128B (Code Set B)
// ASCII characters 32 to 127 (0–9, A–Z, a–z), special characters, and FNC 1–4
var B_CHARS = exports.B_CHARS = "[\x20-\x7F\xC8-\xCF]";

// 128C (Code Set C)
// 00–99 (encodes two digits with a single code point) and FNC1
var C_CHARS = exports.C_CHARS = "(\xCF*[0-9]{2}\xCF*)";

// CODE128 includes 107 symbols:
// 103 data symbols, 3 start symbols (A, B and C), and 1 stop symbol (the last one)
// Each symbol consist of three black bars (1) and three white spaces (0).
var BARS = exports.BARS = [11011001100, 11001101100, 11001100110, 10010011000, 10010001100, 10001001100, 10011001000, 10011000100, 10001100100, 11001001000, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011000, 11011000110, 11000110110, 10100011000, 10001011000, 10001000110, 10110001000, 10001101000, 10001100010, 11010001000, 11000101000, 11000100010, 10110111000, 10110001110, 10001101110, 10111011000, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101000, 11011100010, 11011101110, 11101011000, 11101000110, 11100010110, 11101101000, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 10100110000, 10100001100, 10010110000, 10010000110, 10000101100, 10000100110, 10110010000, 10110000100, 10011010000, 10011000010, 10000110100, 10000110010, 11000010010, 11001010000, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111000, 10100011110, 10001011110, 10111101000, 10111100010, 11110101000, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 11010010000, 11010011100, 1100011101011];

/***/ }),

/***/ "f1aa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = __webpack_require__("e795");

var _merge2 = _interopRequireDefault(_merge);

var _shared = __webpack_require__("d36b");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasRenderer = function () {
	function CanvasRenderer(canvas, encodings, options) {
		_classCallCheck(this, CanvasRenderer);

		this.canvas = canvas;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(CanvasRenderer, [{
		key: "render",
		value: function render() {
			// Abort if the browser does not support HTML5 canvas
			if (!this.canvas.getContext) {
				throw new Error('The browser does not support canvas.');
			}

			this.prepareCanvas();
			for (var i = 0; i < this.encodings.length; i++) {
				var encodingOptions = (0, _merge2.default)(this.options, this.encodings[i].options);

				this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
				this.drawCanvasText(encodingOptions, this.encodings[i]);

				this.moveCanvasDrawing(this.encodings[i]);
			}

			this.restoreCanvas();
		}
	}, {
		key: "prepareCanvas",
		value: function prepareCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.save();

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options, ctx);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;

			this.canvas.height = maxHeight;

			// Paint the canvas
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.options.background) {
				ctx.fillStyle = this.options.background;
				ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
			}

			ctx.translate(this.options.marginLeft, 0);
		}
	}, {
		key: "drawCanvasBarcode",
		value: function drawCanvasBarcode(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.marginTop + options.fontSize + options.textMargin;
			} else {
				yFrom = options.marginTop;
			}

			ctx.fillStyle = options.lineColor;

			for (var b = 0; b < binary.length; b++) {
				var x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					ctx.fillRect(x, yFrom, options.width, options.height);
				} else if (binary[b]) {
					ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
				}
			}
		}
	}, {
		key: "drawCanvasText",
		value: function drawCanvasText(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var font = options.fontOptions + " " + options.fontSize + "px " + options.font;

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				if (options.textPosition == "top") {
					y = options.marginTop + options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.marginTop + options.fontSize;
				}

				ctx.font = font;

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					ctx.textAlign = 'left';
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					ctx.textAlign = 'right';
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						ctx.textAlign = 'center';
					}

				ctx.fillText(encoding.text, x, y);
			}
		}
	}, {
		key: "moveCanvasDrawing",
		value: function moveCanvasDrawing(encoding) {
			var ctx = this.canvas.getContext("2d");

			ctx.translate(encoding.width, 0);
		}
	}, {
		key: "restoreCanvas",
		value: function restoreCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.restore();
		}
	}]);

	return CanvasRenderer;
}();

exports.default = CanvasRenderer;

/***/ }),

/***/ "f27e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b937");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("20a96665", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f3c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  created() {
    this.__tickFnList = [];
    this.__timeoutFnList = [];
  },
  deactivated() {
    this.__tickFnList.forEach(tick => {
      tick.removeTick();
    });
    this.__timeoutFnList.forEach(tick => {
      tick.removeTimeout();
    });
  },
  beforeDestroy() {
    this.__tickFnList.forEach(tick => {
      tick.removeTick();
    });
    this.__tickFnList = void 0;
    this.__timeoutFnList.forEach(tick => {
      tick.removeTimeout();
    });
    this.__timeoutFnList = void 0;
  },
  methods: {
    __useTick(registerFnName, removeFnName) {
      const tick = {
        removeTick() {
          tick.fn = void 0;
        },
        registerTick: fn => {
          tick.fn = fn;
          this.$nextTick(() => {
            if (tick.fn === fn) {
              // we also check if VM is destroyed, since if it
              // got to trigger one nextTick() we cannot stop it
              this._isDestroyed === false && tick.fn();
              tick.fn = void 0;
            }
          });
        }
      };
      this.__tickFnList.push(tick);
      this[registerFnName] = tick.registerTick;
      removeFnName !== void 0 && (this[removeFnName] = tick.removeTick);
    },
    __useTimeout(registerFnName, removeFnName) {
      const timeout = {
        removeTimeout() {
          clearTimeout(timeout.timer);
        },
        registerTimeout: (fn, delay) => {
          clearTimeout(timeout.timer);
          if (this._isDestroyed === false) {
            timeout.timer = setTimeout(fn, delay);
          }
        }
      };
      this.__timeoutFnList.push(timeout);
      this[registerFnName] = timeout.registerTimeout;
      removeFnName !== void 0 && (this[removeFnName] = timeout.removeTimeout);
    }
  }
});

/***/ }),

/***/ "f445":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = fixOptions;


function fixOptions(options) {
	// Fix the margins
	options.marginTop = options.marginTop || options.margin;
	options.marginBottom = options.marginBottom || options.margin;
	options.marginRight = options.marginRight || options.margin;
	options.marginLeft = options.marginLeft || options.margin;

	return options;
}

/***/ }),

/***/ "f452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ad69");
/* harmony import */ var _utils_private_touch_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("55ba");
/* harmony import */ var _utils_event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a8d5");
/* harmony import */ var _utils_private_selection_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ab5b");




function getChanges(evt, ctx, isFinal) {
  const pos = Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* position */ "h"])(evt);
  let dir,
    distX = pos.left - ctx.event.x,
    distY = pos.top - ctx.event.y,
    absX = Math.abs(distX),
    absY = Math.abs(distY);
  const direction = ctx.direction;
  if (direction.horizontal === true && direction.vertical !== true) {
    dir = distX < 0 ? 'left' : 'right';
  } else if (direction.horizontal !== true && direction.vertical === true) {
    dir = distY < 0 ? 'up' : 'down';
  } else if (direction.up === true && distY < 0) {
    dir = 'up';
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = 'left';
      } else if (direction.right === true && distX > 0) {
        dir = 'right';
      }
    }
  } else if (direction.down === true && distY > 0) {
    dir = 'down';
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = 'left';
      } else if (direction.right === true && distX > 0) {
        dir = 'right';
      }
    }
  } else if (direction.left === true && distX < 0) {
    dir = 'left';
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = 'up';
      } else if (direction.down === true && distY > 0) {
        dir = 'down';
      }
    }
  } else if (direction.right === true && distX > 0) {
    dir = 'right';
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = 'up';
      } else if (direction.down === true && distY > 0) {
        dir = 'down';
      }
    }
  }
  let synthetic = false;
  if (dir === void 0 && isFinal === false) {
    if (ctx.event.isFirst === true || ctx.event.lastDir === void 0) {
      return {};
    }
    dir = ctx.event.lastDir;
    synthetic = true;
    if (dir === 'left' || dir === 'right') {
      pos.left -= distX;
      absX = 0;
      distX = 0;
    } else {
      pos.top -= distY;
      absY = 0;
      distY = 0;
    }
  }
  return {
    synthetic,
    payload: {
      evt,
      touch: ctx.event.mouse !== true,
      mouse: ctx.event.mouse === true,
      position: pos,
      direction: dir,
      isFirst: ctx.event.isFirst,
      isFinal: isFinal === true,
      duration: Date.now() - ctx.event.time,
      distance: {
        x: absX,
        y: absY
      },
      offset: {
        x: distX,
        y: distY
      },
      delta: {
        x: pos.left - ctx.event.lastX,
        y: pos.top - ctx.event.lastY
      }
    }
  };
}
function destroy(el) {
  const ctx = el.__qtouchpan;
  if (ctx !== void 0) {
    // emit the end event when the directive is destroyed while active
    // this is only needed in TouchPan because the rest of the touch directives do not emit an end event
    // the condition is also checked in the start of function but we avoid the call
    ctx.event !== void 0 && ctx.end();
    Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* cleanEvt */ "b"])(ctx, 'main');
    Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* cleanEvt */ "b"])(ctx, 'temp');
    _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* client */ "a"].is.firefox === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* preventDraggable */ "j"])(el, false);
    ctx.styleCleanup !== void 0 && ctx.styleCleanup();
    delete el.__qtouchpan;
  }
}
let uid = 0;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'touch-pan',
  bind(el, {
    value,
    modifiers
  }) {
    if (el.__qtouchpan !== void 0) {
      destroy(el);
      el.__qtouchpan_destroyed = true;
    }

    // early return, we don't need to do anything
    if (modifiers.mouse !== true && _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* client */ "a"].has.touch !== true) {
      return;
    }
    function handleEvent(evt, mouseEvent) {
      if (modifiers.mouse === true && mouseEvent === true) {
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* stopAndPrevent */ "l"])(evt);
      } else {
        modifiers.stop === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* stop */ "k"])(evt);
        modifiers.prevent === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* prevent */ "i"])(evt);
      }
    }
    const ctx = {
      uid: 'qvtp_' + uid++,
      handler: value,
      modifiers,
      direction: Object(_utils_private_touch_js__WEBPACK_IMPORTED_MODULE_1__[/* getModifierDirections */ "a"])(modifiers),
      noop: _utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* noop */ "g"],
      mouseStart(evt) {
        if (Object(_utils_private_touch_js__WEBPACK_IMPORTED_MODULE_1__[/* shouldStart */ "b"])(evt, ctx) && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* leftClick */ "e"])(evt)) {
          Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* addEvt */ "a"])(ctx, 'temp', [[document, 'mousemove', 'move', 'notPassiveCapture'], [document, 'mouseup', 'end', 'passiveCapture']]);
          ctx.start(evt, true);
        }
      },
      touchStart(evt) {
        if (Object(_utils_private_touch_js__WEBPACK_IMPORTED_MODULE_1__[/* shouldStart */ "b"])(evt, ctx)) {
          const target = evt.target;
          Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* addEvt */ "a"])(ctx, 'temp', [[target, 'touchmove', 'move', 'notPassiveCapture'], [target, 'touchcancel', 'end', 'passiveCapture'], [target, 'touchend', 'end', 'passiveCapture']]);
          ctx.start(evt);
        }
      },
      start(evt, mouseEvent) {
        _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* client */ "a"].is.firefox === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* preventDraggable */ "j"])(el, true);
        ctx.lastEvt = evt;
        const pos = Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* position */ "h"])(evt);

        /*
         * Stop propagation so possible upper v-touch-pan don't catch this as well;
         * If we're not the target (based on modifiers), we'll re-emit the event later
         */
        if (mouseEvent === true || modifiers.stop === true) {
          /*
           * are we directly switching to detected state?
           * clone event only otherwise
           */
          if (ctx.direction.all !== true && (mouseEvent !== true || ctx.modifiers.mouseAllDir !== true && ctx.modifiers.mousealldir !== true)) {
            const clone = evt.type.indexOf('mouse') > -1 ? new MouseEvent(evt.type, evt) : new TouchEvent(evt.type, evt);
            evt.defaultPrevented === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* prevent */ "i"])(clone);
            evt.cancelBubble === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* stop */ "k"])(clone);
            clone.qClonedBy = evt.qClonedBy === void 0 ? [ctx.uid] : evt.qClonedBy.concat(ctx.uid);
            clone.qKeyEvent = evt.qKeyEvent;
            clone.qClickOutside = evt.qClickOutside;
            ctx.initialEvent = {
              target: evt.target,
              event: clone
            };
          }
          Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* stop */ "k"])(evt);
        }
        ctx.event = {
          x: pos.left,
          y: pos.top,
          time: Date.now(),
          mouse: mouseEvent === true,
          detected: false,
          isFirst: true,
          isFinal: false,
          lastX: pos.left,
          lastY: pos.top
        };
      },
      move(evt) {
        if (ctx.event === void 0) {
          return;
        }
        ctx.lastEvt = evt;
        const isMouseEvt = ctx.event.mouse === true;
        const start = () => {
          handleEvent(evt, isMouseEvt);
          let cursor;
          if (ctx.modifiers.preserveCursor !== true && ctx.modifiers.preservecursor !== true) {
            cursor = document.documentElement.style.cursor || '';
            document.documentElement.style.cursor = 'grabbing';
          }
          isMouseEvt === true && document.body.classList.add('no-pointer-events--children');
          document.body.classList.add('non-selectable');
          Object(_utils_private_selection_js__WEBPACK_IMPORTED_MODULE_3__[/* clearSelection */ "a"])();
          ctx.styleCleanup = withDelayedFn => {
            ctx.styleCleanup = void 0;
            if (cursor !== void 0) {
              document.documentElement.style.cursor = cursor;
            }
            document.body.classList.remove('non-selectable');
            if (isMouseEvt === true) {
              const remove = () => {
                document.body.classList.remove('no-pointer-events--children');
              };
              if (withDelayedFn !== void 0) {
                setTimeout(() => {
                  remove();
                  withDelayedFn();
                }, 50);
              } else {
                remove();
              }
            } else if (withDelayedFn !== void 0) {
              withDelayedFn();
            }
          };
        };
        if (ctx.event.detected === true) {
          ctx.event.isFirst !== true && handleEvent(evt, ctx.event.mouse);
          const {
            payload,
            synthetic
          } = getChanges(evt, ctx, false);
          if (payload !== void 0) {
            if (ctx.handler(payload) === false) {
              ctx.end(evt);
            } else {
              if (ctx.styleCleanup === void 0 && ctx.event.isFirst === true) {
                start();
              }
              ctx.event.lastX = payload.position.left;
              ctx.event.lastY = payload.position.top;
              ctx.event.lastDir = synthetic === true ? void 0 : payload.direction;
              ctx.event.isFirst = false;
            }
          }
          return;
        }
        if (ctx.direction.all === true || isMouseEvt === true && (ctx.modifiers.mouseAllDir === true || ctx.modifiers.mousealldir === true)) {
          start();
          ctx.event.detected = true;
          ctx.move(evt);
          return;
        }
        const pos = Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* position */ "h"])(evt),
          distX = pos.left - ctx.event.x,
          distY = pos.top - ctx.event.y,
          absX = Math.abs(distX),
          absY = Math.abs(distY);
        if (absX !== absY) {
          if (ctx.direction.horizontal === true && absX > absY || ctx.direction.vertical === true && absX < absY || ctx.direction.up === true && absX < absY && distY < 0 || ctx.direction.down === true && absX < absY && distY > 0 || ctx.direction.left === true && absX > absY && distX < 0 || ctx.direction.right === true && absX > absY && distX > 0) {
            ctx.event.detected = true;
            ctx.move(evt);
          } else {
            ctx.end(evt, true);
          }
        }
      },
      end(evt, abort) {
        if (ctx.event === void 0) {
          return;
        }
        Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* cleanEvt */ "b"])(ctx, 'temp');
        _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* client */ "a"].is.firefox === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* preventDraggable */ "j"])(el, false);
        if (abort === true) {
          ctx.styleCleanup !== void 0 && ctx.styleCleanup();
          if (ctx.event.detected !== true && ctx.initialEvent !== void 0) {
            ctx.initialEvent.target.dispatchEvent(ctx.initialEvent.event);
          }
        } else if (ctx.event.detected === true) {
          ctx.event.isFirst === true && ctx.handler(getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx).payload);
          const {
            payload
          } = getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx, true);
          const fn = () => {
            ctx.handler(payload);
          };
          if (ctx.styleCleanup !== void 0) {
            ctx.styleCleanup(fn);
          } else {
            fn();
          }
        }
        ctx.event = void 0;
        ctx.initialEvent = void 0;
        ctx.lastEvt = void 0;
      }
    };
    el.__qtouchpan = ctx;
    modifiers.mouse === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* addEvt */ "a"])(ctx, 'main', [[el, 'mousedown', 'mouseStart', `passive${modifiers.mouseCapture === true || modifiers.mousecapture === true ? 'Capture' : ''}`]]);
    _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_0__[/* client */ "a"].has.touch === true && Object(_utils_event_js__WEBPACK_IMPORTED_MODULE_2__[/* addEvt */ "a"])(ctx, 'main', [[el, 'touchstart', 'touchStart', `passive${modifiers.capture === true ? 'Capture' : ''}`], [el, 'touchmove', 'noop', 'notPassiveCapture'] // cannot be passive (ex: iOS scroll)
    ]);
  },
  update(el, {
    oldValue,
    value
  }) {
    const ctx = el.__qtouchpan;
    if (ctx !== void 0 && oldValue !== value) {
      typeof value !== 'function' && ctx.end();
      ctx.handler = value;
    }
  },
  unbind(el) {
    if (el.__qtouchpan_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__qtouchpan_destroyed;
    }
  }
});

/***/ }),

/***/ "f461":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3b4c");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("a44c").default
var update = add("095f8374", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f49e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _optionsFromStrings = __webpack_require__("6c52");

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _defaults = __webpack_require__("33a1");

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOptionsFromElement(element) {
	var options = {};
	for (var property in _defaults2.default) {
		if (_defaults2.default.hasOwnProperty(property)) {
			// jsbarcode-*
			if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
				options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
			}

			// data-*
			if (element.hasAttribute("data-" + property.toLowerCase())) {
				options[property] = element.getAttribute("data-" + property.toLowerCase());
			}
		}
	}

	options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");

	// Since all atributes are string they need to be converted to integers
	options = (0, _optionsFromStrings2.default)(options);

	return options;
}

exports.default = getOptionsFromElement;

/***/ }),

/***/ "f4c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validatePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validateOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parsePosition; });
/* unused harmony export getAnchorProps */
/* unused harmony export getTargetProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setPosition; });
/* harmony import */ var _scroll_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a820");
/* harmony import */ var _plugins_Platform_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ad69");


let vpLeft, vpTop;
function validatePosition(pos) {
  const parts = pos.split(' ');
  if (parts.length !== 2) {
    return false;
  }
  if (['top', 'center', 'bottom'].includes(parts[0]) !== true) {
    console.error('Anchor/Self position must start with one of top/center/bottom');
    return false;
  }
  if (['left', 'middle', 'right', 'start', 'end'].includes(parts[1]) !== true) {
    console.error('Anchor/Self position must end with one of left/middle/right/start/end');
    return false;
  }
  return true;
}
function validateOffset(val) {
  if (!val) {
    return true;
  }
  if (val.length !== 2) {
    return false;
  }
  if (typeof val[0] !== 'number' || typeof val[1] !== 'number') {
    return false;
  }
  return true;
}
const horizontalPos = {
  'start#ltr': 'left',
  'start#rtl': 'right',
  'end#ltr': 'right',
  'end#rtl': 'left'
};
['left', 'middle', 'right'].forEach(pos => {
  horizontalPos[`${pos}#ltr`] = pos;
  horizontalPos[`${pos}#rtl`] = pos;
});
function parsePosition(pos, rtl) {
  const parts = pos.split(' ');
  return {
    vertical: parts[0],
    horizontal: horizontalPos[`${parts[1]}#${rtl === true ? 'rtl' : 'ltr'}`]
  };
}
function getAnchorProps(el, offset) {
  let {
    top,
    left,
    right,
    bottom,
    width,
    height
  } = el.getBoundingClientRect();
  if (offset !== void 0) {
    top -= offset[1];
    left -= offset[0];
    bottom += offset[1];
    right += offset[0];
    width += offset[0];
    height += offset[1];
  }
  return {
    top,
    bottom,
    height,
    left,
    right,
    width,
    middle: left + (right - left) / 2,
    center: top + (bottom - top) / 2
  };
}
function getAbsoluteAnchorProps(el, absoluteOffset, offset) {
  let {
    top,
    left
  } = el.getBoundingClientRect();
  top += absoluteOffset.top;
  left += absoluteOffset.left;
  if (offset !== void 0) {
    top += offset[1];
    left += offset[0];
  }
  return {
    top,
    bottom: top + 1,
    height: 1,
    left,
    right: left + 1,
    width: 1,
    middle: left,
    center: top
  };
}
function getTargetProps(el) {
  return {
    top: 0,
    center: el.offsetHeight / 2,
    bottom: el.offsetHeight,
    left: 0,
    middle: el.offsetWidth / 2,
    right: el.offsetWidth
  };
}
function getTopLeftProps(anchorProps, targetProps, cfg) {
  return {
    top: anchorProps[cfg.anchorOrigin.vertical] - targetProps[cfg.selfOrigin.vertical],
    left: anchorProps[cfg.anchorOrigin.horizontal] - targetProps[cfg.selfOrigin.horizontal]
  };
}

// cfg: { el, anchorEl, anchorOrigin, selfOrigin, offset, absoluteOffset, cover, fit, maxHeight, maxWidth }
function setPosition(cfg) {
  if (_plugins_Platform_js__WEBPACK_IMPORTED_MODULE_1__[/* client */ "a"].is.ios === true && window.visualViewport !== void 0) {
    // uses the q-position-engine CSS class

    const el = document.body.style;
    const {
      offsetLeft: left,
      offsetTop: top
    } = window.visualViewport;
    if (left !== vpLeft) {
      el.setProperty('--q-pe-left', left + 'px');
      vpLeft = left;
    }
    if (top !== vpTop) {
      el.setProperty('--q-pe-top', top + 'px');
      vpTop = top;
    }
  }

  // scroll position might change
  // if max-height/-width changes, so we
  // need to restore it after we calculate
  // the new positioning
  const {
    scrollLeft,
    scrollTop
  } = cfg.el;
  const anchorProps = cfg.absoluteOffset === void 0 ? getAnchorProps(cfg.anchorEl, cfg.cover === true ? [0, 0] : cfg.offset) : getAbsoluteAnchorProps(cfg.anchorEl, cfg.absoluteOffset, cfg.offset);
  let elStyle = {
    maxHeight: cfg.maxHeight,
    maxWidth: cfg.maxWidth,
    visibility: 'visible'
  };
  if (cfg.fit === true || cfg.cover === true) {
    elStyle.minWidth = anchorProps.width + 'px';
    if (cfg.cover === true) {
      elStyle.minHeight = anchorProps.height + 'px';
    }
  }
  Object.assign(cfg.el.style, elStyle);
  const targetProps = getTargetProps(cfg.el);
  let props = getTopLeftProps(anchorProps, targetProps, cfg);
  if (cfg.absoluteOffset === void 0 || cfg.offset === void 0) {
    applyBoundaries(props, anchorProps, targetProps, cfg.anchorOrigin, cfg.selfOrigin);
  } else {
    // we have touch position or context menu with offset
    const {
      top,
      left
    } = props; // cache initial values

    // apply initial boundaries
    applyBoundaries(props, anchorProps, targetProps, cfg.anchorOrigin, cfg.selfOrigin);
    let hasChanged = false;

    // did it flip vertically?
    if (props.top !== top) {
      hasChanged = true;
      const offsetY = 2 * cfg.offset[1];
      anchorProps.center = anchorProps.top -= offsetY;
      anchorProps.bottom -= offsetY + 2;
    }

    // did it flip horizontally?
    if (props.left !== left) {
      hasChanged = true;
      const offsetX = 2 * cfg.offset[0];
      anchorProps.middle = anchorProps.left -= offsetX;
      anchorProps.right -= offsetX + 2;
    }
    if (hasChanged === true) {
      // re-calculate props with the new anchor
      props = getTopLeftProps(anchorProps, targetProps, cfg);

      // and re-apply boundaries
      applyBoundaries(props, anchorProps, targetProps, cfg.anchorOrigin, cfg.selfOrigin);
    }
  }
  elStyle = {
    top: props.top + 'px',
    left: props.left + 'px'
  };
  if (props.maxHeight !== void 0) {
    elStyle.maxHeight = props.maxHeight + 'px';
    if (anchorProps.height > props.maxHeight) {
      elStyle.minHeight = elStyle.maxHeight;
    }
  }
  if (props.maxWidth !== void 0) {
    elStyle.maxWidth = props.maxWidth + 'px';
    if (anchorProps.width > props.maxWidth) {
      elStyle.minWidth = elStyle.maxWidth;
    }
  }
  Object.assign(cfg.el.style, elStyle);

  // restore scroll position
  if (cfg.el.scrollTop !== scrollTop) {
    cfg.el.scrollTop = scrollTop;
  }
  if (cfg.el.scrollLeft !== scrollLeft) {
    cfg.el.scrollLeft = scrollLeft;
  }
}
function applyBoundaries(props, anchorProps, targetProps, anchorOrigin, selfOrigin) {
  const currentHeight = targetProps.bottom,
    currentWidth = targetProps.right,
    margin = Object(_scroll_js__WEBPACK_IMPORTED_MODULE_0__[/* getScrollbarWidth */ "e"])(),
    innerHeight = window.innerHeight - margin,
    innerWidth = document.body.clientWidth;
  if (props.top < 0 || props.top + currentHeight > innerHeight) {
    if (selfOrigin.vertical === 'center') {
      props.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2 ? Math.max(0, innerHeight - currentHeight) : 0;
      props.maxHeight = Math.min(currentHeight, innerHeight);
    } else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
      const anchorY = Math.min(innerHeight, anchorOrigin.vertical === 'center' ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top);
      props.maxHeight = Math.min(currentHeight, anchorY);
      props.top = Math.max(0, anchorY - currentHeight);
    } else {
      props.top = Math.max(0, anchorOrigin.vertical === 'center' ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom);
      props.maxHeight = Math.min(currentHeight, innerHeight - props.top);
    }
  }
  if (props.left < 0 || props.left + currentWidth > innerWidth) {
    props.maxWidth = Math.min(currentWidth, innerWidth);
    if (selfOrigin.horizontal === 'middle') {
      props.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2 ? Math.max(0, innerWidth - currentWidth) : 0;
    } else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
      const anchorX = Math.min(innerWidth, anchorOrigin.horizontal === 'middle' ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left);
      props.maxWidth = Math.min(currentWidth, anchorX);
      props.left = Math.max(0, anchorX - props.maxWidth);
    } else {
      props.left = Math.max(0, anchorOrigin.horizontal === 'middle' ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right);
      props.maxWidth = Math.min(currentWidth, innerWidth - props.left);
    }
  }
}

/***/ }),

/***/ "f532":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAxios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAxios; });
/* harmony import */ var _ht_lib_image_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("38a2");
/* harmony import */ var _ht_lib_image_util__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ht_lib_image_util__WEBPACK_IMPORTED_MODULE_0__);

let _axios;
function setAxios(axios) {
  _axios = axios;
  _ht_lib_image_util__WEBPACK_IMPORTED_MODULE_0__["setAxios"](axios);
}
function getAxios() {
  return _axios;
}

/***/ }),

/***/ "f63b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bbf");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a50a");


/* harmony default export */ __webpack_exports__["a"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
  name: 'QSpace',
  mixins: [_mixins_listeners_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  render(h) {
    return h('div', {
      staticClass: 'q-space',
      on: {
        ...this.qListeners
      }
    });
  }
}));

/***/ }),

/***/ "f9b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ZoomImage.vue?vue&type=template&id=76fbbbc5&scoped=true&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('q-card', {
    staticStyle: {
      "max-width": "unset"
    }
  }, [_c('div', {
    staticClass: "relative-position bg-blue shadow-2 image-size"
  }, [_vm.myUrl && !_vm.loading ? [_c('a', {
    attrs: {
      "href": _vm.newTabUrl,
      "target": _vm.image.ref
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "max-height": "80vh",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.myUrl,
      "title": "Click to enlarge in new tab"
    }
  })])] : !_vm.loading && !_vm.myUrl ? _c('div', {
    staticClass: "absolute-center"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _c('div', {
    staticClass: "absolute-center"
  }, [_c('q-spinner', {
    attrs: {
      "size": "4em"
    }
  })], 1), _c('image-control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }],
    attrs: {
      "isZoom": "",
      "showControls": "",
      "image": _vm.image
    },
    on: {
      "zoom": _vm.zoom
    }
  })], 2), _c('div', {
    staticClass: "full-width",
    staticStyle: {
      "justify-content": "center",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "justify-between row full-width flex-center q-gutter-sm no-wrap q-pa-md"
  }, [_c('q-btn', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.bottomText))]), _c('q-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Forward")])], 1)])]);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/ZoomImage.vue?vue&type=template&id=76fbbbc5&scoped=true&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: external "@ht-lib/image-util"
var image_util_ = __webpack_require__("38a2");

// EXTERNAL MODULE: ./src/components/ImageControl.vue + 9 modules
var ImageControl = __webpack_require__("8862");

// EXTERNAL MODULE: ./src/index.ts + 256 modules
var src = __webpack_require__("ffb4");

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ZoomImage.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let ZoomImagevue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  constructor() {
    super(...arguments);
    this.hover = false;
    this.myUrl = null;
    this.loading = true;
    this.newTabUrl = null;
  }
  async created() {
    await this.updateUrl();
    this.newTabUrl = this.image ? Object(image_util_["getPrepUrl"])(this.image.longRef, {}) : '#';
  }
  zoom(longRef) {
    return longRef;
  }
  get image() {
    return this.zoomImages.active;
  }
  next() {
    var _a, _b;
    this.updateZoom((_b = (_a = this.zoomImages.next) === null || _a === void 0 ? void 0 : _a.longRef) !== null && _b !== void 0 ? _b : null);
  }
  back() {
    var _a, _b;
    this.updateZoom((_b = (_a = this.zoomImages.prev) === null || _a === void 0 ? void 0 : _a.longRef) !== null && _b !== void 0 ? _b : null);
  }
  updateZoom(val) {
    return val;
  }
  get errorText() {
    return this.image === undefined || !this.image.uploaded ? 'Image is not uploaded' : 'Image not found';
  }
  get bottomText() {
    if (!this.image) return '';
    return this.image.ref + (this.image.pupilId ? ` -${this.image.pupilId}` : '');
  }
  async updateUrl() {
    this.myUrl = null;
    this.loading = true;
    if (!this.image || !this.image.url) {
      this.loading = false;
      return;
    }
    if (typeof this.image.url === 'string' && this.image.url.startsWith('blob')) {
      // THE IMAGE IS A LOCAL COPY SO IT SHOULD BE FULL SIZE
      this.myUrl = this.image.url;
    } else {
      this.myUrl = await Object(image_util_["getThumbnailObjectURL"])(Object(src["l" /* getThumbnailBucket */])(), this.image, false);
    }
    this.newTabUrl = Object(image_util_["getPrepUrl"])(this.image.longRef, {});
    this.loading = false;
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ZoomImagevue_type_script_lang_ts_default_1.prototype, "zoomImages", void 0);
__decorate([Object(external_vue_property_decorator_["Emit"])('update-zoom-id')], ZoomImagevue_type_script_lang_ts_default_1.prototype, "zoom", null);
__decorate([Object(external_vue_property_decorator_["Emit"])('update-zoom-id')], ZoomImagevue_type_script_lang_ts_default_1.prototype, "updateZoom", null);
__decorate([Object(external_vue_property_decorator_["Watch"])('image.longRef', {
  deep: true
})], ZoomImagevue_type_script_lang_ts_default_1.prototype, "updateUrl", null);
ZoomImagevue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'ZoomImage',
  components: {
    ImageControl: ImageControl["a" /* default */]
  }
})], ZoomImagevue_type_script_lang_ts_default_1);
/* harmony default export */ var ZoomImagevue_type_script_lang_ts = (ZoomImagevue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/ZoomImage.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_ZoomImagevue_type_script_lang_ts = (ZoomImagevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/ZoomImage.vue?vue&type=style&index=0&id=76fbbbc5&prod&lang=stylus&scoped=true
var ZoomImagevue_type_style_index_0_id_76fbbbc5_prod_lang_stylus_scoped_true = __webpack_require__("1323");

// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCard.js
var QCard = __webpack_require__("6ca9");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinner.js
var QSpinner = __webpack_require__("88a8");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/btn/QBtn.js
var QBtn = __webpack_require__("b20c");

// EXTERNAL MODULE: /workspace/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js
var runtime_auto_import = __webpack_require__("d447");
var runtime_auto_import_default = /*#__PURE__*/__webpack_require__.n(runtime_auto_import);

// CONCATENATED MODULE: ./src/components/ZoomImage.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_ZoomImagevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "76fbbbc5",
  null
  
)

/* harmony default export */ var ZoomImage = __webpack_exports__["a"] = (component.exports);




runtime_auto_import_default()(component, 'components', {QCard: QCard["a" /* default */],QSpinner: QSpinner["a" /* default */],QBtn: QBtn["a" /* default */]});


/***/ }),

/***/ "fa15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addFocusWaitFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeFocusWaitFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addFocusFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeFocusFn; });
let queue = [];
let waitFlags = [];
function clearFlag(flag) {
  waitFlags = waitFlags.filter(entry => entry !== flag);
}
function addFocusWaitFlag(flag) {
  clearFlag(flag);
  waitFlags.push(flag);
}
function removeFocusWaitFlag(flag) {
  clearFlag(flag);
  if (waitFlags.length === 0 && queue.length > 0) {
    // only call last focus handler (can't focus multiple things at once)
    queue[queue.length - 1]();
    queue = [];
  }
}
function addFocusFn(fn) {
  if (waitFlags.length === 0) {
    fn();
  } else {
    queue.push(fn);
  }
}
function removeFocusFn(fn) {
  queue = queue.filter(entry => entry !== fn);
}

/***/ }),

/***/ "feae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return slot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uniqueSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergeSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeSlotSafely; });
function slot(vm, slotName, otherwise) {
  return vm.$scopedSlots[slotName] !== void 0 ? vm.$scopedSlots[slotName]() : otherwise;
}
function uniqueSlot(vm, slotName, otherwise) {
  return vm.$scopedSlots[slotName] !== void 0 ? [].concat(vm.$scopedSlots[slotName]()) : otherwise;
}

/**
 * Source definitely exists,
 * so it's merged with the possible slot
 */
function mergeSlot(source, vm, slotName) {
  return vm.$scopedSlots[slotName] !== void 0 ? source.concat(vm.$scopedSlots[slotName]()) : source;
}

/**
 * Merge with possible slot,
 * even if source might not exist
 */
function mergeSlotSafely(source, vm, slotName) {
  if (vm.$scopedSlots[slotName] === void 0) {
    return source;
  }
  const slot = vm.$scopedSlots[slotName]();
  return source !== void 0 ? source.concat(slot) : slot;
}

/***/ }),

/***/ "ffb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "o", function() { return /* reexport */ axios["b" /* setAxios */]; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ ClassExpansion["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ components_Image["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ ImageControl["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ QCReview["default"]; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ ViewGrid["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ Worksheet["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ ZoomControl; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* reexport */ ZoomImage["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* reexport */ features["a" /* enableFeatures */]; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* reexport */ setApp; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* reexport */ imageStore["b" /* getIcon */]; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ imageStore["a" /* ImageStore */]; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* reexport */ route; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ setThumbnailBucket; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getThumbnailBucket; });

// NAMESPACE OBJECT: /workspace/node_modules/quasar/src/components.js
var components_namespaceObject = {};
__webpack_require__.r(components_namespaceObject);
__webpack_require__.d(components_namespaceObject, "QAjaxBar", function() { return QAjaxBar; });
__webpack_require__.d(components_namespaceObject, "QAvatar", function() { return QAvatar; });
__webpack_require__.d(components_namespaceObject, "QBadge", function() { return QBadge; });
__webpack_require__.d(components_namespaceObject, "QBanner", function() { return QBanner; });
__webpack_require__.d(components_namespaceObject, "QBar", function() { return QBar; });
__webpack_require__.d(components_namespaceObject, "QBreadcrumbs", function() { return QBreadcrumbs; });
__webpack_require__.d(components_namespaceObject, "QBreadcrumbsEl", function() { return QBreadcrumbsEl; });
__webpack_require__.d(components_namespaceObject, "QBtn", function() { return QBtn["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QBtnDropdown", function() { return QBtnDropdown; });
__webpack_require__.d(components_namespaceObject, "QBtnGroup", function() { return QBtnGroup; });
__webpack_require__.d(components_namespaceObject, "QBtnToggle", function() { return QBtnToggle; });
__webpack_require__.d(components_namespaceObject, "QCard", function() { return QCard["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QCardSection", function() { return QCardSection["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QCardActions", function() { return QCardActions["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QCarousel", function() { return QCarousel; });
__webpack_require__.d(components_namespaceObject, "QCarouselSlide", function() { return QCarouselSlide; });
__webpack_require__.d(components_namespaceObject, "QCarouselControl", function() { return QCarouselControl; });
__webpack_require__.d(components_namespaceObject, "QChatMessage", function() { return QChatMessage; });
__webpack_require__.d(components_namespaceObject, "QCheckbox", function() { return QCheckbox["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QChip", function() { return QChip["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QCircularProgress", function() { return QCircularProgress; });
__webpack_require__.d(components_namespaceObject, "QColor", function() { return QColor; });
__webpack_require__.d(components_namespaceObject, "QDate", function() { return QDate; });
__webpack_require__.d(components_namespaceObject, "QDialog", function() { return QDialog["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QDrawer", function() { return QDrawer["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QEditor", function() { return QEditor; });
__webpack_require__.d(components_namespaceObject, "QExpansionItem", function() { return QExpansionItem; });
__webpack_require__.d(components_namespaceObject, "QFab", function() { return QFab; });
__webpack_require__.d(components_namespaceObject, "QFabAction", function() { return QFabAction; });
__webpack_require__.d(components_namespaceObject, "QField", function() { return QField["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QFile", function() { return QFile; });
__webpack_require__.d(components_namespaceObject, "QFooter", function() { return QFooter; });
__webpack_require__.d(components_namespaceObject, "QForm", function() { return QForm; });
__webpack_require__.d(components_namespaceObject, "QHeader", function() { return QHeader; });
__webpack_require__.d(components_namespaceObject, "QIcon", function() { return QIcon["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QImg", function() { return QImg; });
__webpack_require__.d(components_namespaceObject, "QInfiniteScroll", function() { return QInfiniteScroll; });
__webpack_require__.d(components_namespaceObject, "QInnerLoading", function() { return QInnerLoading; });
__webpack_require__.d(components_namespaceObject, "QInput", function() { return QInput["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QIntersection", function() { return QIntersection; });
__webpack_require__.d(components_namespaceObject, "QList", function() { return QList["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QItem", function() { return QItem["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QItemSection", function() { return QItemSection["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QItemLabel", function() { return QItemLabel["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QKnob", function() { return QKnob; });
__webpack_require__.d(components_namespaceObject, "QLayout", function() { return QLayout["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QMarkupTable", function() { return QMarkupTable; });
__webpack_require__.d(components_namespaceObject, "QMenu", function() { return QMenu["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QNoSsr", function() { return QNoSsr; });
__webpack_require__.d(components_namespaceObject, "QOptionGroup", function() { return QOptionGroup; });
__webpack_require__.d(components_namespaceObject, "QPage", function() { return QPage["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QPageContainer", function() { return QPageContainer["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QPageScroller", function() { return QPageScroller; });
__webpack_require__.d(components_namespaceObject, "QPageSticky", function() { return QPageSticky; });
__webpack_require__.d(components_namespaceObject, "QPagination", function() { return QPagination; });
__webpack_require__.d(components_namespaceObject, "QParallax", function() { return QParallax; });
__webpack_require__.d(components_namespaceObject, "QPopupEdit", function() { return QPopupEdit; });
__webpack_require__.d(components_namespaceObject, "QPopupProxy", function() { return QPopupProxy; });
__webpack_require__.d(components_namespaceObject, "QLinearProgress", function() { return QLinearProgress; });
__webpack_require__.d(components_namespaceObject, "QPullToRefresh", function() { return QPullToRefresh; });
__webpack_require__.d(components_namespaceObject, "QRadio", function() { return QRadio; });
__webpack_require__.d(components_namespaceObject, "QRange", function() { return QRange; });
__webpack_require__.d(components_namespaceObject, "QRating", function() { return QRating; });
__webpack_require__.d(components_namespaceObject, "QResizeObserver", function() { return QResizeObserver["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QResponsive", function() { return QResponsive; });
__webpack_require__.d(components_namespaceObject, "QScrollArea", function() { return QScrollArea["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QScrollObserver", function() { return QScrollObserver["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QSelect", function() { return QSelect["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QSeparator", function() { return QSeparator["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QSkeleton", function() { return QSkeleton; });
__webpack_require__.d(components_namespaceObject, "QSlideItem", function() { return QSlideItem; });
__webpack_require__.d(components_namespaceObject, "QSlideTransition", function() { return QSlideTransition; });
__webpack_require__.d(components_namespaceObject, "QSlider", function() { return QSlider; });
__webpack_require__.d(components_namespaceObject, "QSpace", function() { return QSpace["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QSpinner", function() { return QSpinner["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QSpinnerAudio", function() { return QSpinnerAudio; });
__webpack_require__.d(components_namespaceObject, "QSpinnerBall", function() { return QSpinnerBall; });
__webpack_require__.d(components_namespaceObject, "QSpinnerBars", function() { return QSpinnerBars; });
__webpack_require__.d(components_namespaceObject, "QSpinnerBox", function() { return QSpinnerBox; });
__webpack_require__.d(components_namespaceObject, "QSpinnerClock", function() { return QSpinnerClock; });
__webpack_require__.d(components_namespaceObject, "QSpinnerComment", function() { return QSpinnerComment; });
__webpack_require__.d(components_namespaceObject, "QSpinnerCube", function() { return QSpinnerCube; });
__webpack_require__.d(components_namespaceObject, "QSpinnerDots", function() { return QSpinnerDots; });
__webpack_require__.d(components_namespaceObject, "QSpinnerFacebook", function() { return QSpinnerFacebook; });
__webpack_require__.d(components_namespaceObject, "QSpinnerGears", function() { return QSpinnerGears; });
__webpack_require__.d(components_namespaceObject, "QSpinnerGrid", function() { return QSpinnerGrid; });
__webpack_require__.d(components_namespaceObject, "QSpinnerHearts", function() { return QSpinnerHearts; });
__webpack_require__.d(components_namespaceObject, "QSpinnerHourglass", function() { return QSpinnerHourglass; });
__webpack_require__.d(components_namespaceObject, "QSpinnerInfinity", function() { return QSpinnerInfinity; });
__webpack_require__.d(components_namespaceObject, "QSpinnerIos", function() { return QSpinnerIos; });
__webpack_require__.d(components_namespaceObject, "QSpinnerOrbit", function() { return QSpinnerOrbit; });
__webpack_require__.d(components_namespaceObject, "QSpinnerOval", function() { return QSpinnerOval; });
__webpack_require__.d(components_namespaceObject, "QSpinnerPie", function() { return QSpinnerPie; });
__webpack_require__.d(components_namespaceObject, "QSpinnerPuff", function() { return QSpinnerPuff; });
__webpack_require__.d(components_namespaceObject, "QSpinnerRadio", function() { return QSpinnerRadio; });
__webpack_require__.d(components_namespaceObject, "QSpinnerRings", function() { return QSpinnerRings; });
__webpack_require__.d(components_namespaceObject, "QSpinnerTail", function() { return QSpinnerTail; });
__webpack_require__.d(components_namespaceObject, "QSplitter", function() { return QSplitter; });
__webpack_require__.d(components_namespaceObject, "QStep", function() { return QStep; });
__webpack_require__.d(components_namespaceObject, "QStepper", function() { return QStepper; });
__webpack_require__.d(components_namespaceObject, "QStepperNavigation", function() { return QStepperNavigation; });
__webpack_require__.d(components_namespaceObject, "QTabPanels", function() { return QTabPanels; });
__webpack_require__.d(components_namespaceObject, "QTabPanel", function() { return QTabPanel; });
__webpack_require__.d(components_namespaceObject, "QTable", function() { return QTable; });
__webpack_require__.d(components_namespaceObject, "QTh", function() { return QTh; });
__webpack_require__.d(components_namespaceObject, "QTr", function() { return QTr; });
__webpack_require__.d(components_namespaceObject, "QTd", function() { return QTd; });
__webpack_require__.d(components_namespaceObject, "QTabs", function() { return QTabs; });
__webpack_require__.d(components_namespaceObject, "QTab", function() { return QTab; });
__webpack_require__.d(components_namespaceObject, "QRouteTab", function() { return QRouteTab; });
__webpack_require__.d(components_namespaceObject, "QTime", function() { return QTime; });
__webpack_require__.d(components_namespaceObject, "QTimeline", function() { return QTimeline; });
__webpack_require__.d(components_namespaceObject, "QTimelineEntry", function() { return QTimelineEntry; });
__webpack_require__.d(components_namespaceObject, "QToggle", function() { return QToggle["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QToolbar", function() { return QToolbar; });
__webpack_require__.d(components_namespaceObject, "QToolbarTitle", function() { return QToolbarTitle; });
__webpack_require__.d(components_namespaceObject, "QTooltip", function() { return QTooltip["a" /* default */]; });
__webpack_require__.d(components_namespaceObject, "QTree", function() { return QTree; });
__webpack_require__.d(components_namespaceObject, "QUploader", function() { return QUploader; });
__webpack_require__.d(components_namespaceObject, "QUploaderBase", function() { return QUploaderBase; });
__webpack_require__.d(components_namespaceObject, "QUploaderAddTrigger", function() { return QUploaderAddTrigger; });
__webpack_require__.d(components_namespaceObject, "QVideo", function() { return QVideo; });
__webpack_require__.d(components_namespaceObject, "QVirtualScroll", function() { return QVirtualScroll; });

// NAMESPACE OBJECT: /workspace/node_modules/quasar/src/directives.js
var directives_namespaceObject = {};
__webpack_require__.r(directives_namespaceObject);
__webpack_require__.d(directives_namespaceObject, "ClosePopup", function() { return ClosePopup["a" /* default */]; });
__webpack_require__.d(directives_namespaceObject, "GoBack", function() { return GoBack; });
__webpack_require__.d(directives_namespaceObject, "Intersection", function() { return Intersection; });
__webpack_require__.d(directives_namespaceObject, "Morph", function() { return Morph; });
__webpack_require__.d(directives_namespaceObject, "Mutation", function() { return Mutation; });
__webpack_require__.d(directives_namespaceObject, "Ripple", function() { return Ripple["a" /* default */]; });
__webpack_require__.d(directives_namespaceObject, "ScrollFire", function() { return ScrollFire; });
__webpack_require__.d(directives_namespaceObject, "Scroll", function() { return Scroll; });
__webpack_require__.d(directives_namespaceObject, "TouchHold", function() { return TouchHold; });
__webpack_require__.d(directives_namespaceObject, "TouchPan", function() { return TouchPan["a" /* default */]; });
__webpack_require__.d(directives_namespaceObject, "TouchRepeat", function() { return TouchRepeat; });
__webpack_require__.d(directives_namespaceObject, "TouchSwipe", function() { return TouchSwipe; });

// NAMESPACE OBJECT: /workspace/node_modules/quasar/src/plugins.js
var plugins_namespaceObject = {};
__webpack_require__.r(plugins_namespaceObject);
__webpack_require__.d(plugins_namespaceObject, "AddressbarColor", function() { return AddressbarColor; });
__webpack_require__.d(plugins_namespaceObject, "AppFullscreen", function() { return AppFullscreen; });
__webpack_require__.d(plugins_namespaceObject, "AppVisibility", function() { return AppVisibility; });
__webpack_require__.d(plugins_namespaceObject, "BottomSheet", function() { return plugins_BottomSheet; });
__webpack_require__.d(plugins_namespaceObject, "Cookies", function() { return Cookies; });
__webpack_require__.d(plugins_namespaceObject, "Dark", function() { return Dark["a" /* default */]; });
__webpack_require__.d(plugins_namespaceObject, "Dialog", function() { return Dialog; });
__webpack_require__.d(plugins_namespaceObject, "LoadingBar", function() { return LoadingBar; });
__webpack_require__.d(plugins_namespaceObject, "Loading", function() { return plugins_Loading; });
__webpack_require__.d(plugins_namespaceObject, "Meta", function() { return Meta; });
__webpack_require__.d(plugins_namespaceObject, "Notify", function() { return Notify; });
__webpack_require__.d(plugins_namespaceObject, "Platform", function() { return Platform["b" /* default */]; });
__webpack_require__.d(plugins_namespaceObject, "Screen", function() { return Screen["a" /* default */]; });
__webpack_require__.d(plugins_namespaceObject, "LocalStorage", function() { return LocalStorage; });
__webpack_require__.d(plugins_namespaceObject, "SessionStorage", function() { return SessionStorage; });

// NAMESPACE OBJECT: /workspace/node_modules/@firebase/app/dist/esm/index.esm2017.js
var dist_esm_index_esm2017_namespaceObject = {};
__webpack_require__.r(dist_esm_index_esm2017_namespaceObject);
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "FirebaseError", function() { return index_esm2017["c" /* FirebaseError */]; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "SDK_VERSION", function() { return SDK_VERSION; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_DEFAULT_ENTRY_NAME", function() { return index_esm2017_DEFAULT_ENTRY_NAME; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_addComponent", function() { return _addComponent; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_addOrOverwriteComponent", function() { return _addOrOverwriteComponent; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_apps", function() { return _apps; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_clearComponents", function() { return _clearComponents; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_components", function() { return _components; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_getProvider", function() { return _getProvider; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_isFirebaseApp", function() { return _isFirebaseApp; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_isFirebaseServerApp", function() { return _isFirebaseServerApp; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_registerComponent", function() { return _registerComponent; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_removeServiceInstance", function() { return _removeServiceInstance; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "_serverApps", function() { return _serverApps; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "deleteApp", function() { return deleteApp; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "getApp", function() { return getApp; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "getApps", function() { return index_esm2017_getApps; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "initializeApp", function() { return initializeApp; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "initializeServerApp", function() { return initializeServerApp; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "onLog", function() { return onLog; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "registerVersion", function() { return registerVersion; });
__webpack_require__.d(dist_esm_index_esm2017_namespaceObject, "setLogLevel", function() { return index_esm2017_setLogLevel; });

// EXTERNAL MODULE: ./src/imageStore.ts
var imageStore = __webpack_require__("818c");

// EXTERNAL MODULE: /workspace/node_modules/@quasar/extras/material-icons/material-icons.css
var material_icons = __webpack_require__("f461");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/install.js + 1 modules
var install = __webpack_require__("63bb");

// EXTERNAL MODULE: /workspace/node_modules/quasar/package.json
var quasar_package = __webpack_require__("e074");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/lang.js + 1 modules
var lang = __webpack_require__("2a4b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/icon-set.js + 1 modules
var icon_set = __webpack_require__("0612");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/ssr-update.js

const mixin = {
  mounted() {
    install["c" /* queues */].takeover.forEach(run => {
      run(this.$q);
    });
  }
};
/* harmony default export */ var ssr_update = (function (ctx) {
  if (ctx.ssr) {
    const q = {
      ...install["a" /* $q */],
      ssrContext: ctx.ssr
    };
    Object.assign(ctx.ssr, {
      Q_HEAD_TAGS: '',
      Q_BODY_ATTRS: '',
      Q_BODY_TAGS: ''
    });
    ctx.app.$q = ctx.ssr.$q = q;
    install["c" /* queues */].server.forEach(run => {
      run(q, ctx);
    });
  } else {
    const mixins = ctx.app.mixins || [];
    if (mixins.includes(mixin) === false) {
      ctx.app.mixins = mixins.concat(mixin);
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/vue-plugin.js





/* harmony default export */ var vue_plugin = ({
  version: quasar_package["a" /* version */],
  install: install["b" /* default */],
  lang: lang["a" /* default */],
  iconSet: icon_set["a" /* default */],
  ssrUpdate: ssr_update
});
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/format.js
var format = __webpack_require__("536b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Platform.js
var Platform = __webpack_require__("ad69");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/attrs.js
var mixins_attrs = __webpack_require__("ae5c");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/ajax-bar/QAjaxBar.js




const xhr = Platform["e" /* isSSR */] ? null : XMLHttpRequest,
  QAjaxBar_open = Platform["e" /* isSSR */] ? null : xhr.prototype.open,
  positionValues = ['top', 'right', 'bottom', 'left'];
let stack = [];
let highjackCount = 0;
function translate({
  p,
  pos,
  active,
  horiz,
  reverse,
  dir
}) {
  let x = 1,
    y = 1;
  if (horiz === true) {
    if (reverse === true) {
      x = -1;
    }
    if (pos === 'bottom') {
      y = -1;
    }
    return {
      transform: `translate3d(${x * (p - 100)}%,${active ? 0 : y * -200}%,0)`
    };
  }
  if (reverse === true) {
    y = -1;
  }
  if (pos === 'right') {
    x = -1;
  }
  return {
    transform: `translate3d(${active ? 0 : dir * x * -200}%,${y * (p - 100)}%,0)`
  };
}
function inc(p, amount) {
  if (typeof amount !== 'number') {
    if (p < 25) {
      amount = Math.random() * 3 + 3;
    } else if (p < 65) {
      amount = Math.random() * 3;
    } else if (p < 85) {
      amount = Math.random() * 2;
    } else if (p < 99) {
      amount = 0.6;
    } else {
      amount = 0;
    }
  }
  return Object(format["a" /* between */])(p + amount, 0, 100);
}
function highjackAjax(stackEntry) {
  highjackCount++;
  stack.push(stackEntry);
  if (highjackCount > 1) {
    return;
  }
  xhr.prototype.open = function (_, url) {
    const stopStack = [];
    const loadStart = () => {
      stack.forEach(entry => {
        const hijackFilter = entry.getHijackFilter();
        if (hijackFilter === null || hijackFilter(url) === true) {
          entry.start();
          stopStack.push(entry.stop);
        }
      });
    };
    const loadEnd = () => {
      stopStack.forEach(stop => {
        stop();
      });
    };
    this.addEventListener('loadstart', loadStart, {
      once: true
    });
    this.addEventListener('loadend', loadEnd, {
      once: true
    });
    QAjaxBar_open.apply(this, arguments);
  };
}
function restoreAjax(start) {
  stack = stack.filter(entry => entry.start !== start);
  highjackCount = Math.max(0, highjackCount - 1);
  if (!highjackCount) {
    xhr.prototype.open = QAjaxBar_open;
  }
}
/* harmony default export */ var QAjaxBar = (external_vue_default.a.extend({
  name: 'QAjaxBar',
  props: {
    position: {
      type: String,
      default: 'top',
      validator: val => positionValues.includes(val)
    },
    size: {
      type: String,
      default: '2px'
    },
    color: String,
    reverse: Boolean,
    skipHijack: Boolean,
    hijackFilter: Function
  },
  data() {
    return {
      calls: 0,
      progress: 0,
      onScreen: false,
      animate: true
    };
  },
  computed: {
    classes() {
      return `q-loading-bar q-loading-bar--${this.position}` + (this.color !== void 0 ? ` bg-${this.color}` : '') + (this.animate === true ? '' : ' no-transition');
    },
    style() {
      const active = this.onScreen;
      const o = translate({
        p: this.progress,
        pos: this.position,
        active,
        horiz: this.horizontal,
        reverse: this.$q.lang.rtl === true && ['top', 'bottom'].includes(this.position) ? this.reverse === false : this.reverse,
        dir: this.$q.lang.rtl === true ? -1 : 1
      });
      o[this.sizeProp] = this.size;
      o.opacity = active ? 1 : 0;
      return o;
    },
    horizontal() {
      return this.position === 'top' || this.position === 'bottom';
    },
    sizeProp() {
      return this.horizontal ? 'height' : 'width';
    },
    attrs() {
      return this.onScreen === true ? {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'aria-valuenow': this.progress
      } : mixins_attrs["a" /* ariaHidden */];
    }
  },
  methods: {
    start(speed = 300) {
      const oldSpeed = this.speed;
      const newSpeed = this.speed = Math.max(0, speed) || 0;
      this.calls++;
      if (this.calls > 1) {
        if (oldSpeed === 0 && newSpeed > 0) {
          this.__work();
        } else if (oldSpeed > 0 && newSpeed <= 0) {
          clearTimeout(this.timer);
        }
        return this.calls;
      }
      clearTimeout(this.timer);
      this.$emit('start');
      this.progress = 0;
      this.timer = setTimeout(() => {
        this.animate = true;
        newSpeed > 0 && this.__work();
      }, this.onScreen === true ? 500 : 1);
      if (this.onScreen !== true) {
        this.onScreen = true;
        this.animate = false;
      }
      return this.calls;
    },
    increment(amount) {
      if (this.calls > 0) {
        this.progress = inc(this.progress, amount);
      }
      return this.calls;
    },
    stop() {
      this.calls = Math.max(0, this.calls - 1);
      if (this.calls > 0) {
        return this.calls;
      }
      clearTimeout(this.timer);
      this.$emit('stop');
      const end = () => {
        this.animate = true;
        this.progress = 100;
        this.timer = setTimeout(() => {
          this.onScreen = false;
        }, 1000);
      };
      if (this.progress === 0) {
        this.timer = setTimeout(end, 1);
      } else {
        end();
      }
      return this.calls;
    },
    __work() {
      if (this.progress < 100) {
        this.timer = setTimeout(() => {
          this.increment();
          this.__work();
        }, this.speed);
      }
    }
  },
  mounted() {
    if (this.skipHijack !== true) {
      this.hijacked = true;
      highjackAjax({
        start: this.start,
        stop: this.stop,
        getHijackFilter: () => this.hijackFilter || null
      });
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.hijacked === true && restoreAjax(this.start);
  },
  render(h) {
    return h('div', {
      class: this.classes,
      style: this.style,
      attrs: this.attrs
    });
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/ajax-bar/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/icon/QIcon.js
var QIcon = __webpack_require__("a170");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/size.js
var size = __webpack_require__("4ef2");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/listeners.js
var listeners = __webpack_require__("a50a");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/slot.js
var private_slot = __webpack_require__("feae");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/avatar/QAvatar.js





/* harmony default export */ var QAvatar = (external_vue_default.a.extend({
  name: 'QAvatar',
  mixins: [listeners["a" /* default */], size["a" /* default */]],
  props: {
    fontSize: String,
    color: String,
    textColor: String,
    icon: String,
    square: Boolean,
    rounded: Boolean
  },
  computed: {
    classes() {
      return {
        [`bg-${this.color}`]: this.color,
        [`text-${this.textColor} q-chip--colored`]: this.textColor,
        'q-avatar--square': this.square,
        'rounded-borders': this.rounded
      };
    },
    contentStyle() {
      if (this.fontSize) {
        return {
          fontSize: this.fontSize
        };
      }
    }
  },
  render(h) {
    const icon = this.icon !== void 0 ? [h(QIcon["a" /* default */], {
      props: {
        name: this.icon
      }
    })] : void 0;
    return h('div', {
      staticClass: 'q-avatar',
      style: this.sizeStyle,
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, [h('div', {
      staticClass: 'q-avatar__content row flex-center overflow-hidden',
      style: this.contentStyle
    }, Object(private_slot["b" /* mergeSlotSafely */])(icon, this, 'default'))]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/avatar/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/badge/QBadge.js



/* harmony default export */ var QBadge = (external_vue_default.a.extend({
  name: 'QBadge',
  mixins: [listeners["a" /* default */]],
  props: {
    color: String,
    textColor: String,
    floating: Boolean,
    transparent: Boolean,
    multiLine: Boolean,
    outline: Boolean,
    rounded: Boolean,
    label: [Number, String],
    align: {
      type: String,
      validator: v => ['top', 'middle', 'bottom'].includes(v)
    }
  },
  computed: {
    style() {
      if (this.align !== void 0) {
        return {
          verticalAlign: this.align
        };
      }
    },
    classes() {
      const text = this.outline === true ? this.color || this.textColor : this.textColor;
      return 'q-badge flex inline items-center no-wrap' + ` q-badge--${this.multiLine === true ? 'multi' : 'single'}-line` + (this.outline === true ? ' q-badge--outline' : this.color !== void 0 ? ` bg-${this.color}` : '') + (text !== void 0 ? ` text-${text}` : '') + (this.floating === true ? ' q-badge--floating' : '') + (this.rounded === true ? ' q-badge--rounded' : '') + (this.transparent === true ? ' q-badge--transparent' : '');
    },
    attrs() {
      return {
        role: 'status',
        'aria-label': this.label
      };
    }
  },
  render(h) {
    return h('div', {
      style: this.style,
      class: this.classes,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, this.label !== void 0 ? [this.label] : Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/badge/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/dark.js
var dark = __webpack_require__("a583");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/banner/QBanner.js




const QBanner_attrs = {
  role: 'alert'
};
/* harmony default export */ var QBanner = (external_vue_default.a.extend({
  name: 'QBanner',
  mixins: [listeners["a" /* default */], dark["a" /* default */]],
  props: {
    inlineActions: Boolean,
    dense: Boolean,
    rounded: Boolean
  },
  render(h) {
    const actions = Object(private_slot["c" /* slot */])(this, 'action');
    const child = [h('div', {
      staticClass: 'q-banner__avatar col-auto row items-center self-start'
    }, Object(private_slot["c" /* slot */])(this, 'avatar')), h('div', {
      staticClass: 'q-banner__content col text-body2'
    }, Object(private_slot["c" /* slot */])(this, 'default'))];
    actions !== void 0 && child.push(h('div', {
      staticClass: 'q-banner__actions row items-center justify-end',
      class: `col-${this.inlineActions === true ? 'auto' : 'all'}`
    }, actions));
    return h('div', {
      staticClass: 'q-banner row items-center',
      class: {
        'q-banner--top-padding': actions !== void 0 && !this.inlineActions,
        'q-banner--dense': this.dense,
        'q-banner--dark q-dark': this.isDark,
        'rounded-borders': this.rounded
      },
      attrs: QBanner_attrs,
      on: {
        ...this.qListeners
      }
    }, child);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/banner/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/bar/QBar.js




const QBar_attrs = {
  role: 'toolbar'
};
/* harmony default export */ var QBar = (external_vue_default.a.extend({
  name: 'QBar',
  mixins: [listeners["a" /* default */], dark["a" /* default */]],
  props: {
    dense: Boolean
  },
  computed: {
    classes() {
      return `q-bar--${this.dense === true ? 'dense' : 'standard'} ` + `q-bar--${this.isDark === true ? 'dark' : 'light'}`;
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-bar row no-wrap items-center',
      class: this.classes,
      attrs: QBar_attrs,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/bar/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/align.js
var align = __webpack_require__("4200");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/breadcrumbs/QBreadcrumbs.js




const disabledValues = [true, ''];
/* harmony default export */ var QBreadcrumbs = (external_vue_default.a.extend({
  name: 'QBreadcrumbs',
  mixins: [listeners["a" /* default */], align["a" /* default */]],
  props: {
    separator: {
      type: String,
      default: '/'
    },
    separatorColor: String,
    activeColor: {
      type: String,
      default: 'primary'
    },
    gutter: {
      type: String,
      validator: v => ['none', 'xs', 'sm', 'md', 'lg', 'xl'].includes(v),
      default: 'sm'
    }
  },
  computed: {
    classes() {
      return `${this.alignClass}${this.gutter === 'none' ? '' : ` q-gutter-${this.gutter}`}`;
    },
    sepClass() {
      return this.separatorColor ? ` text-${this.separatorColor}` : '';
    },
    activeClass() {
      return ` text-${this.activeColor}`;
    }
  },
  render(h) {
    const nodes = Object(private_slot["c" /* slot */])(this, 'default');
    if (nodes === void 0) {
      return;
    }
    let els = 1;
    const child = [],
      len = nodes.filter(c => c.tag !== void 0 && c.tag.endsWith('-QBreadcrumbsEl')).length,
      separator = this.$scopedSlots.separator !== void 0 ? this.$scopedSlots.separator : () => this.separator;
    nodes.forEach(comp => {
      if (comp.tag !== void 0 && comp.tag.endsWith('-QBreadcrumbsEl')) {
        const middle = els < len;
        const disabled = disabledValues.includes(comp.componentOptions.propsData.disable);
        const cls = middle === true ? disabled !== true ? this.activeClass : '' : ' q-breadcrumbs--last';
        els++;
        child.push(h('div', {
          staticClass: 'flex items-center' + cls
        }, [comp]));
        middle === true && child.push(h('div', {
          staticClass: 'q-breadcrumbs__separator' + this.sepClass
        }, separator()));
      } else {
        child.push(comp);
      }
    });
    return h('div', {
      staticClass: 'q-breadcrumbs',
      on: {
        ...this.qListeners
      }
    }, [h('div', {
      staticClass: 'flex items-center',
      class: this.classes
    }, child)]);
  }
}));
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/router-link.js
var router_link = __webpack_require__("adc0");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/breadcrumbs/QBreadcrumbsEl.js





/* harmony default export */ var QBreadcrumbsEl = (external_vue_default.a.extend({
  name: 'QBreadcrumbsEl',
  mixins: [listeners["a" /* default */], router_link["a" /* default */]],
  props: {
    label: String,
    icon: String
  },
  computed: {
    iconClass() {
      return 'q-breadcrumbs__el-icon' + (this.label !== void 0 ? ' q-breadcrumbs__el-icon--with-label' : '');
    },
    renderData() {
      return {
        staticClass: 'q-breadcrumbs__el q-link ' + 'flex inline items-center relative-position ' + (this.disable !== true ? 'q-link--focusable' + this.linkClass : 'q-breadcrumbs__el--disabled'),
        attrs: this.linkAttrs,
        on: {
          ...this.qListeners,
          click: this.__navigateOnClick
        }
      };
    }
  },
  beforeCreate() {
    this.fallbackTag = 'span';
  },
  render(h) {
    const child = [];
    this.icon !== void 0 && child.push(h(QIcon["a" /* default */], {
      class: this.iconClass,
      props: {
        name: this.icon
      }
    }));
    this.label !== void 0 && child.push(this.label);
    return h(this.linkTag, this.renderData, Object(private_slot["a" /* mergeSlot */])(child, this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/breadcrumbs/index.js



// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/btn/QBtn.js
var QBtn = __webpack_require__("b20c");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/btn/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/btn.js
var mixins_btn = __webpack_require__("3f03");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/transition.js
var transition = __webpack_require__("448b");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/btn-group/QBtnGroup.js



/* harmony default export */ var QBtnGroup = (external_vue_default.a.extend({
  name: 'QBtnGroup',
  mixin: [listeners["a" /* default */]],
  props: {
    unelevated: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    square: Boolean,
    push: Boolean,
    stretch: Boolean,
    glossy: Boolean,
    spread: Boolean
  },
  computed: {
    classes() {
      return ['unelevated', 'outline', 'flat', 'rounded', 'square', 'push', 'stretch', 'glossy'].filter(t => this[t] === true).map(t => `q-btn-group--${t}`).join(' ');
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-btn-group row no-wrap ' + (this.spread === true ? 'q-btn-group--spread' : 'inline'),
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/menu/QMenu.js + 2 modules
var QMenu = __webpack_require__("b7fa");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/event.js
var utils_event = __webpack_require__("a8d5");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/cache.js
var cache = __webpack_require__("479b");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/uid.js
var uid = __webpack_require__("c9c2");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/btn-dropdown/QBtnDropdown.js













// let's not duplicate type checking and prop validations
// so just specify the props here with no type description
const menuTransitionProps = Object.keys(transition["a" /* default */].props).reduce((acc, key) => (acc[key] = {}) && acc, {});
/* harmony default export */ var QBtnDropdown = (external_vue_default.a.extend({
  name: 'QBtnDropdown',
  mixins: [mixins_btn["b" /* default */], mixins_attrs["b" /* default */]],
  inheritAttrs: false,
  props: {
    value: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    menuAnchor: {
      type: String,
      default: 'bottom end'
    },
    menuSelf: {
      type: String,
      default: 'top end'
    },
    menuOffset: Array,
    ...menuTransitionProps,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean,
    toggleAriaLabel: String
  },
  data() {
    return {
      showing: this.value
    };
  },
  watch: {
    value(val) {
      this.$refs.menu !== void 0 && this.$refs.menu[val ? 'show' : 'hide']();
    },
    split() {
      this.hide();
    }
  },
  render(h) {
    const label = Object(private_slot["c" /* slot */])(this, 'label', []);
    const attrs = {
      'aria-expanded': this.showing === true ? 'true' : 'false',
      'aria-haspopup': 'true',
      'aria-controls': this.targetUid,
      'aria-label': this.toggleAriaLabel || this.$q.lang.label[this.showing === true ? 'collapse' : 'expand'](this.label)
    };
    if (this.disable === true || this.split === false && this.disableMainBtn === true || this.disableDropdown === true) {
      attrs['aria-disabled'] = 'true';
    }
    const Arrow = [h(QIcon["a" /* default */], {
      props: {
        name: this.dropdownIcon || this.$q.iconSet.arrow.dropdown
      },
      class: 'q-btn-dropdown__arrow' + (this.showing === true && this.noIconAnimation === false ? ' rotate-180' : '') + (this.split === false ? ' q-btn-dropdown__arrow-container' : '')
    })];
    this.disableDropdown !== true && Arrow.push(h(QMenu["a" /* default */], {
      ref: 'menu',
      attrs: {
        id: this.targetUid
      },
      props: {
        cover: this.cover,
        fit: true,
        persistent: this.persistent,
        noRouteDismiss: this.noRouteDismiss,
        autoClose: this.autoClose,
        anchor: this.menuAnchor,
        self: this.menuSelf,
        offset: this.menuOffset,
        contentClass: this.contentClass,
        contentStyle: this.contentStyle,
        separateClosePopup: true,
        transitionShow: this.transitionShow,
        transitionHide: this.transitionHide
      },
      on: Object(cache["b" /* default */])(this, 'menu', {
        'before-show': e => {
          this.showing = true;
          this.$emit('before-show', e);
        },
        show: e => {
          this.$emit('show', e);
          this.$emit('input', true);
        },
        'before-hide': e => {
          this.showing = false;
          this.$emit('before-hide', e);
        },
        hide: e => {
          this.$emit('hide', e);
          this.$emit('input', false);
        }
      })
    }, Object(private_slot["c" /* slot */])(this, 'default')));
    if (this.split === false) {
      return h(QBtn["a" /* default */], {
        class: 'q-btn-dropdown q-btn-dropdown--simple',
        props: {
          ...this.$props,
          disable: this.disable === true || this.disableMainBtn === true,
          noWrap: true,
          round: false
        },
        attrs: {
          ...attrs,
          ...this.qAttrs
        },
        on: Object(cache["b" /* default */])(this, 'nonSpl', {
          click: e => {
            this.$emit('click', e);
          }
        }),
        scopedSlots: {
          loading: this.$scopedSlots.loading
        }
      }, label.concat(Arrow));
    }
    const Btn = h(QBtn["a" /* default */], {
      class: 'q-btn-dropdown--current',
      props: {
        ...this.$props,
        disable: this.disable === true || this.disableMainBtn === true,
        noWrap: true,
        iconRight: this.iconRight,
        round: false
      },
      attrs: this.qAttrs,
      on: Object(cache["b" /* default */])(this, 'spl', {
        click: e => {
          Object(utils_event["k" /* stop */])(e); // prevent showing the menu on click
          this.hide();
          this.$emit('click', e);
        }
      }),
      scopedSlots: {
        loading: this.$scopedSlots.loading
      }
    }, label);
    return h(QBtnGroup, {
      props: {
        outline: this.outline,
        flat: this.flat,
        rounded: this.rounded,
        square: this.square,
        push: this.push,
        unelevated: this.unelevated,
        glossy: this.glossy,
        stretch: this.stretch
      },
      staticClass: 'q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item'
    }, [Btn, h(QBtn["a" /* default */], {
      staticClass: 'q-btn-dropdown__arrow-container q-anchor--skip',
      attrs,
      props: {
        disable: this.disable === true || this.disableDropdown === true,
        outline: this.outline,
        flat: this.flat,
        rounded: this.rounded,
        push: this.push,
        size: this.size,
        color: this.color,
        textColor: this.textColor,
        dense: this.dense,
        ripple: this.ripple
      }
    }, Arrow)]);
  },
  methods: {
    toggle(evt) {
      this.$refs.menu && this.$refs.menu.toggle(evt);
    },
    show(evt) {
      this.$refs.menu && this.$refs.menu.show(evt);
    },
    hide(evt) {
      this.$refs.menu && this.$refs.menu.hide(evt);
    }
  },
  created() {
    this.targetUid = `d_${Object(uid["a" /* default */])()}`;
  },
  mounted() {
    this.value === true && this.show();
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/btn-dropdown/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/btn-group/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/form.js
var mixins_form = __webpack_require__("2750");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/ripple.js
var ripple = __webpack_require__("1de7");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/btn-toggle/QBtnToggle.js







/* harmony default export */ var QBtnToggle = (external_vue_default.a.extend({
  name: 'QBtnToggle',
  mixins: [listeners["a" /* default */], ripple["a" /* default */], mixins_form["b" /* default */]],
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator: v => v.every(opt => ('label' in opt || 'icon' in opt || 'slot' in opt) && 'value' in opt)
    },
    // To avoid seeing the active raise shadow through the transparent button, give it a color (even white).
    color: String,
    textColor: String,
    toggleColor: {
      type: String,
      default: 'primary'
    },
    toggleTextColor: String,
    outline: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    rounded: Boolean,
    push: Boolean,
    glossy: Boolean,
    size: String,
    padding: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    readonly: Boolean,
    disable: Boolean,
    stack: Boolean,
    stretch: Boolean,
    spread: Boolean,
    clearable: Boolean
  },
  computed: {
    hasActiveValue() {
      return this.options.find(opt => opt.value === this.value) !== void 0;
    },
    formAttrs() {
      return {
        type: 'hidden',
        name: this.name,
        value: this.value
      };
    },
    btnOptions() {
      const mergeOption = (opt, key) => opt[key] === void 0 ? this[key] : opt[key];
      return this.options.map((opt, i) => ({
        slot: opt.slot,
        options: {
          key: i,
          class: opt.class,
          style: opt.style,
          on: {
            ...this.qListeners,
            click: e => this.__set(opt.value, opt, e)
          },
          attrs: {
            'aria-pressed': opt.value === this.value ? 'true' : 'false',
            ...opt.attrs
          },
          props: {
            ...opt,
            slot: void 0,
            class: void 0,
            style: void 0,
            value: void 0,
            attrs: void 0,
            outline: this.outline,
            flat: this.flat,
            rounded: this.rounded,
            push: this.push,
            unelevated: this.unelevated,
            dense: this.dense,
            disable: this.disable === true || opt.disable === true,
            // Options that come from the button specific options first, then from general props
            color: opt.value === this.value ? mergeOption(opt, 'toggleColor') : mergeOption(opt, 'color'),
            textColor: opt.value === this.value ? mergeOption(opt, 'toggleTextColor') : mergeOption(opt, 'textColor'),
            noCaps: mergeOption(opt, 'noCaps') === true,
            noWrap: mergeOption(opt, 'noWrap') === true,
            size: mergeOption(opt, 'size'),
            padding: mergeOption(opt, 'padding'),
            ripple: mergeOption(opt, 'ripple'),
            stack: mergeOption(opt, 'stack') === true,
            stretch: mergeOption(opt, 'stretch') === true
          }
        }
      }));
    }
  },
  methods: {
    __set(value, opt, e) {
      if (this.readonly !== true) {
        if (this.value === value) {
          if (this.clearable === true) {
            this.$emit('input', null, null);
            this.$emit('clear');
          }
        } else {
          this.$emit('input', value, opt);
        }
        this.$emit('click', e);
      }
    }
  },
  render(h) {
    const child = this.btnOptions.map(opt => {
      return h(QBtn["a" /* default */], {
        ...opt.options
      }, opt.slot !== void 0 ? Object(private_slot["c" /* slot */])(this, opt.slot) : void 0);
    });
    if (this.name !== void 0 && this.disable !== true && this.hasActiveValue === true) {
      this.__injectFormInput(child, 'push');
    }
    return h(QBtnGroup, {
      staticClass: 'q-btn-toggle',
      props: {
        outline: this.outline,
        flat: this.flat,
        rounded: this.rounded,
        push: this.push,
        stretch: this.stretch,
        unelevated: this.unelevated,
        glossy: this.glossy,
        spread: this.spread
      }
    }, Object(private_slot["a" /* mergeSlot */])(child, this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/btn-toggle/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCard.js
var QCard = __webpack_require__("6ca9");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCardSection.js
var QCardSection = __webpack_require__("7efe");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/card/QCardActions.js
var QCardActions = __webpack_require__("15cd");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/card/index.js




// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/touch.js
var touch = __webpack_require__("55ba");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/selection.js
var selection = __webpack_require__("ab5b");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/TouchSwipe.js




function parseArg(arg) {
  // delta (min velocity -- dist / time)
  // mobile min distance on first move
  // desktop min distance until deciding if it's a swipe or not
  const data = [0.06, 6, 50];
  if (typeof arg === 'string' && arg.length) {
    arg.split(':').forEach((val, index) => {
      const v = parseFloat(val);
      v && (data[index] = v);
    });
  }
  return data;
}
function destroy(el) {
  const ctx = el.__qtouchswipe;
  if (ctx !== void 0) {
    Object(utils_event["b" /* cleanEvt */])(ctx, 'main');
    Object(utils_event["b" /* cleanEvt */])(ctx, 'temp');
    Platform["a" /* client */].is.firefox === true && Object(utils_event["j" /* preventDraggable */])(el, false);
    ctx.styleCleanup !== void 0 && ctx.styleCleanup();
    delete el.__qtouchswipe;
  }
}
/* harmony default export */ var TouchSwipe = ({
  name: 'touch-swipe',
  bind(el, {
    value,
    arg,
    modifiers
  }) {
    if (el.__qtouchswipe !== void 0) {
      destroy(el);
      el.__qtouchswipe_destroyed = true;
    }

    // early return, we don't need to do anything
    if (modifiers.mouse !== true && Platform["a" /* client */].has.touch !== true) {
      return;
    }
    const mouseCapture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? 'Capture' : '';
    const ctx = {
      handler: value,
      sensitivity: parseArg(arg),
      modifiers: modifiers,
      direction: Object(touch["a" /* getModifierDirections */])(modifiers),
      noop: utils_event["g" /* noop */],
      mouseStart(evt) {
        if (Object(touch["b" /* shouldStart */])(evt, ctx) && Object(utils_event["e" /* leftClick */])(evt)) {
          Object(utils_event["a" /* addEvt */])(ctx, 'temp', [[document, 'mousemove', 'move', `notPassive${mouseCapture}`], [document, 'mouseup', 'end', 'notPassiveCapture']]);
          ctx.start(evt, true);
        }
      },
      touchStart(evt) {
        if (Object(touch["b" /* shouldStart */])(evt, ctx)) {
          const target = evt.target;
          Object(utils_event["a" /* addEvt */])(ctx, 'temp', [[target, 'touchmove', 'move', 'notPassiveCapture'], [target, 'touchcancel', 'end', 'notPassiveCapture'], [target, 'touchend', 'end', 'notPassiveCapture']]);
          ctx.start(evt);
        }
      },
      start(evt, mouseEvent) {
        Platform["a" /* client */].is.firefox === true && Object(utils_event["j" /* preventDraggable */])(el, true);
        const pos = Object(utils_event["h" /* position */])(evt);
        ctx.event = {
          x: pos.left,
          y: pos.top,
          time: Date.now(),
          mouse: mouseEvent === true,
          dir: false
        };
      },
      move(evt) {
        if (ctx.event === void 0) {
          return;
        }
        if (ctx.event.dir !== false) {
          Object(utils_event["l" /* stopAndPrevent */])(evt);
          return;
        }
        const time = Date.now() - ctx.event.time;
        if (time === 0) {
          return;
        }
        const pos = Object(utils_event["h" /* position */])(evt),
          distX = pos.left - ctx.event.x,
          absX = Math.abs(distX),
          distY = pos.top - ctx.event.y,
          absY = Math.abs(distY);
        if (ctx.event.mouse !== true) {
          if (absX < ctx.sensitivity[1] && absY < ctx.sensitivity[1]) {
            ctx.end(evt);
            return;
          }
        }
        // is user trying to select text?
        // if so, then something should be reported here
        // (previous selection, if any, was discarded when swipe started)
        else if (window.getSelection().toString() !== '') {
          ctx.end(evt);
          return;
        } else if (absX < ctx.sensitivity[2] && absY < ctx.sensitivity[2]) {
          return;
        }
        const velX = absX / time,
          velY = absY / time;
        if (ctx.direction.vertical === true && absX < absY && absX < 100 && velY > ctx.sensitivity[0]) {
          ctx.event.dir = distY < 0 ? 'up' : 'down';
        }
        if (ctx.direction.horizontal === true && absX > absY && absY < 100 && velX > ctx.sensitivity[0]) {
          ctx.event.dir = distX < 0 ? 'left' : 'right';
        }
        if (ctx.direction.up === true && absX < absY && distY < 0 && absX < 100 && velY > ctx.sensitivity[0]) {
          ctx.event.dir = 'up';
        }
        if (ctx.direction.down === true && absX < absY && distY > 0 && absX < 100 && velY > ctx.sensitivity[0]) {
          ctx.event.dir = 'down';
        }
        if (ctx.direction.left === true && absX > absY && distX < 0 && absY < 100 && velX > ctx.sensitivity[0]) {
          ctx.event.dir = 'left';
        }
        if (ctx.direction.right === true && absX > absY && distX > 0 && absY < 100 && velX > ctx.sensitivity[0]) {
          ctx.event.dir = 'right';
        }
        if (ctx.event.dir !== false) {
          Object(utils_event["l" /* stopAndPrevent */])(evt);
          if (ctx.event.mouse === true) {
            document.body.classList.add('no-pointer-events--children');
            document.body.classList.add('non-selectable');
            Object(selection["a" /* clearSelection */])();
            ctx.styleCleanup = withDelay => {
              ctx.styleCleanup = void 0;
              document.body.classList.remove('non-selectable');
              const remove = () => {
                document.body.classList.remove('no-pointer-events--children');
              };
              if (withDelay === true) {
                setTimeout(remove, 50);
              } else {
                remove();
              }
            };
          }
          ctx.handler({
            evt,
            touch: ctx.event.mouse !== true,
            mouse: ctx.event.mouse,
            direction: ctx.event.dir,
            duration: time,
            distance: {
              x: absX,
              y: absY
            }
          });
        } else {
          ctx.end(evt);
        }
      },
      end(evt) {
        if (ctx.event === void 0) {
          return;
        }
        Object(utils_event["b" /* cleanEvt */])(ctx, 'temp');
        Platform["a" /* client */].is.firefox === true && Object(utils_event["j" /* preventDraggable */])(el, false);
        ctx.styleCleanup !== void 0 && ctx.styleCleanup(true);
        evt !== void 0 && ctx.event.dir !== false && Object(utils_event["l" /* stopAndPrevent */])(evt);
        ctx.event = void 0;
      }
    };
    el.__qtouchswipe = ctx;
    modifiers.mouse === true && Object(utils_event["a" /* addEvt */])(ctx, 'main', [[el, 'mousedown', 'mouseStart', `passive${mouseCapture}`]]);
    Platform["a" /* client */].has.touch === true && Object(utils_event["a" /* addEvt */])(ctx, 'main', [[el, 'touchstart', 'touchStart', `passive${modifiers.capture === true ? 'Capture' : ''}`], [el, 'touchmove', 'noop', 'notPassiveCapture'] // cannot be passive (ex: iOS scroll)
    ]);
  },
  update(el, {
    oldValue,
    value
  }) {
    const ctx = el.__qtouchswipe;
    if (ctx !== void 0 && oldValue !== value) {
      typeof value !== 'function' && ctx.end();
      ctx.handler = value;
    }
  },
  unbind(el) {
    if (el.__qtouchswipe_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__qtouchswipe_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/mixins/panel.js






function getPanelWrapper(h) {
  return h('div', {
    staticClass: 'q-panel scroll',
    attrs: {
      role: 'tabpanel'
    },
    // stop propagation of content emitted @input
    // which would tamper with Panel's model
    on: Object(cache["b" /* default */])(this, 'stop', {
      input: utils_event["k" /* stop */]
    })
  }, Object(private_slot["c" /* slot */])(this, 'default'));
}
const PanelWrapper = external_vue_default.a.extend({
  render: getPanelWrapper
});
const PanelParentMixin = {
  mixins: [listeners["a" /* default */]],
  directives: {
    TouchSwipe: TouchSwipe
  },
  props: {
    value: {
      required: true
    },
    animated: Boolean,
    infinite: Boolean,
    swipeable: Boolean,
    vertical: Boolean,
    transitionPrev: String,
    transitionNext: String,
    keepAlive: Boolean,
    keepAliveInclude: [String, Array, RegExp],
    keepAliveExclude: [String, Array, RegExp],
    keepAliveMax: Number
  },
  data() {
    return {
      panelIndex: null,
      panelTransition: null
    };
  },
  computed: {
    panelDirectives() {
      if (this.swipeable === true) {
        return [{
          name: 'touch-swipe',
          value: this.__swipe,
          modifiers: {
            horizontal: this.vertical !== true,
            vertical: this.vertical,
            mouse: true
          }
        }];
      }
    },
    contentKey() {
      return typeof this.value === 'string' || typeof this.value === 'number' ? this.value : String(this.value);
    },
    transitionPrevComputed() {
      return this.transitionPrev || `slide-${this.vertical === true ? 'down' : 'right'}`;
    },
    transitionNextComputed() {
      return this.transitionNext || `slide-${this.vertical === true ? 'up' : 'left'}`;
    },
    keepAliveProps() {
      return {
        include: this.keepAliveInclude,
        exclude: this.keepAliveExclude,
        max: this.keepAliveMax
      };
    },
    needsUniqueWrapper() {
      return this.keepAliveInclude !== void 0 || this.keepAliveExclude !== void 0;
    }
  },
  watch: {
    value(newVal, oldVal) {
      const index = this.__isValidPanelName(newVal) === true ? this.__getPanelIndex(newVal) : -1;
      if (this.__forcedPanelTransition !== true) {
        this.__updatePanelTransition(index === -1 ? 0 : index < this.__getPanelIndex(oldVal) ? -1 : 1);
      }
      if (this.panelIndex !== index) {
        this.panelIndex = index;
        this.$emit('before-transition', newVal, oldVal);
        this.$nextTick(() => {
          this.$emit('transition', newVal, oldVal);
        });
      }
    }
  },
  methods: {
    next() {
      this.__go(1);
    },
    previous() {
      this.__go(-1);
    },
    goTo(name) {
      this.$emit('input', name);
    },
    __isValidPanelName(name) {
      return name !== void 0 && name !== null && name !== '';
    },
    __getPanelIndex(name) {
      return this.panels.findIndex(panel => {
        const opt = panel.componentOptions.propsData;
        return opt.name === name && opt.disable !== '' && opt.disable !== true;
      });
    },
    __getEnabledPanels() {
      return this.panels.filter(panel => {
        const opt = panel.componentOptions.propsData;
        return opt.disable !== '' && opt.disable !== true;
      });
    },
    __updatePanelTransition(direction) {
      const val = direction !== 0 && this.animated === true && this.panelIndex !== -1 ? 'q-transition--' + (direction === -1 ? this.transitionPrevComputed : this.transitionNextComputed) : null;
      if (this.panelTransition !== val) {
        this.panelTransition = val;
      }
    },
    __go(direction, startIndex = this.panelIndex) {
      let index = startIndex + direction;
      const slots = this.panels;
      while (index > -1 && index < slots.length) {
        const opt = slots[index].componentOptions;
        if (opt !== void 0 && opt.propsData.disable !== '' && opt.propsData.disable !== true) {
          this.__updatePanelTransition(direction);
          this.__forcedPanelTransition = true;
          this.$emit('input', slots[index].componentOptions.propsData.name);
          setTimeout(() => {
            this.__forcedPanelTransition = false;
          });
          return;
        }
        index += direction;
      }
      if (this.infinite === true && slots.length > 0 && startIndex !== -1 && startIndex !== slots.length) {
        this.__go(direction, direction === -1 ? slots.length : -1);
      }
    },
    __swipe(evt) {
      const dir = this.vertical === true ? 'up' : 'left';
      this.__go((this.$q.lang.rtl === true ? -1 : 1) * (evt.direction === dir ? 1 : -1));
    },
    __updatePanelIndex() {
      const index = this.__getPanelIndex(this.value);
      if (this.panelIndex !== index) {
        this.panelIndex = index;
      }
      return true;
    },
    __getPanelContent(h) {
      if (this.panels.length === 0) {
        return;
      }
      const panel = this.__isValidPanelName(this.value) && this.__updatePanelIndex() && this.panels[this.panelIndex];
      const content = this.keepAlive === true ? [h('keep-alive', {
        props: this.keepAliveProps
      }, [h(this.needsUniqueWrapper === true ? Object(cache["a" /* cacheWithFn */])(this, this.contentKey, () => external_vue_default.a.extend({
        name: this.contentKey,
        render: getPanelWrapper
      })) : PanelWrapper, {
        key: this.contentKey
      }, [panel])])] : [h('div', {
        staticClass: 'q-panel scroll',
        key: this.contentKey,
        attrs: {
          role: 'tabpanel'
        },
        // stop propagation of content emitted @input
        // which would tamper with Panel's model
        on: Object(cache["b" /* default */])(this, 'stop', {
          input: utils_event["k" /* stop */]
        })
      }, [panel])];
      return this.animated === true ? [h('transition', {
        props: {
          name: this.panelTransition
        }
      }, content)] : content;
    }
  },
  render(h) {
    this.panels = Object(private_slot["c" /* slot */])(this, 'default', []).filter(panel => panel !== void 0 && panel.componentOptions !== void 0 && panel.componentOptions.propsData !== void 0 && this.__isValidPanelName(panel.componentOptions.propsData.name));
    return this.__renderPanels(h);
  }
};
const PanelChildMixin = {
  mixins: [listeners["a" /* default */]],
  props: {
    name: {
      required: true
    },
    disable: Boolean
  }
};
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/history.js
var src_history = __webpack_require__("3f7f");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/mixins/fullscreen.js

let fullscreenCounter = 0;
/* harmony default export */ var fullscreen = ({
  props: {
    fullscreen: Boolean,
    noRouteFullscreenExit: Boolean
  },
  data() {
    return {
      inFullscreen: false
    };
  },
  watch: {
    $route() {
      this.noRouteFullscreenExit !== true && this.exitFullscreen();
    },
    fullscreen(v) {
      if (this.inFullscreen !== v) {
        this.toggleFullscreen();
      }
    },
    inFullscreen(v) {
      this.$emit('update:fullscreen', v);
      this.$emit('fullscreen', v);
    }
  },
  methods: {
    toggleFullscreen() {
      if (this.inFullscreen === true) {
        this.exitFullscreen();
      } else {
        this.setFullscreen();
      }
    },
    setFullscreen() {
      if (this.inFullscreen === true) {
        return;
      }
      this.inFullscreen = true;
      this.container = this.$el.parentNode;
      this.container.replaceChild(this.fullscreenFillerNode, this.$el);
      document.body.appendChild(this.$el);
      fullscreenCounter++;
      if (fullscreenCounter === 1) {
        document.body.classList.add('q-body--fullscreen-mixin');
      }
      this.__historyFullscreen = {
        handler: this.exitFullscreen
      };
      src_history["a" /* default */].add(this.__historyFullscreen);
    },
    exitFullscreen() {
      if (this.inFullscreen !== true) {
        return;
      }
      if (this.__historyFullscreen !== void 0) {
        src_history["a" /* default */].remove(this.__historyFullscreen);
        this.__historyFullscreen = void 0;
      }
      this.container.replaceChild(this.$el, this.fullscreenFillerNode);
      this.inFullscreen = false;
      fullscreenCounter = Math.max(0, fullscreenCounter - 1);
      if (fullscreenCounter === 0) {
        document.body.classList.remove('q-body--fullscreen-mixin');
        if (this.$el.scrollIntoView !== void 0) {
          setTimeout(() => {
            this.$el.scrollIntoView();
          });
        }
      }
    }
  },
  beforeMount() {
    this.fullscreenFillerNode = document.createElement('span');
  },
  mounted() {
    this.fullscreen === true && this.setFullscreen();
  },
  beforeDestroy() {
    this.exitFullscreen();
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/is.js
var is = __webpack_require__("553a");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/carousel/QCarousel.js








/* harmony default export */ var QCarousel = (external_vue_default.a.extend({
  name: 'QCarousel',
  mixins: [dark["a" /* default */], PanelParentMixin, fullscreen],
  props: {
    height: String,
    padding: Boolean,
    controlType: {
      type: String,
      validator: v => ['regular', 'flat', 'outline', 'push', 'unelevated'].includes(v),
      default: 'flat'
    },
    controlColor: String,
    controlTextColor: String,
    autoplay: [Number, Boolean],
    arrows: Boolean,
    prevIcon: String,
    nextIcon: String,
    navigation: Boolean,
    navigationPosition: {
      type: String,
      validator: v => ['top', 'right', 'bottom', 'left'].includes(v)
    },
    navigationIcon: String,
    navigationActiveIcon: String,
    thumbnails: Boolean
  },
  computed: {
    style() {
      if (this.inFullscreen !== true && this.height !== void 0) {
        return {
          height: this.height
        };
      }
    },
    direction() {
      return this.vertical === true ? 'vertical' : 'horizontal';
    },
    classes() {
      return `q-carousel q-panel-parent q-carousel--with${this.padding === true ? '' : 'out'}-padding` + (this.inFullscreen === true ? ' fullscreen' : '') + (this.isDark === true ? ' q-carousel--dark q-dark' : '') + (this.arrows === true ? ` q-carousel--arrows-${this.direction}` : '') + (this.navigation === true ? ` q-carousel--navigation-${this.navigationPositionComputed}` : '');
    },
    arrowIcons() {
      const ico = [this.prevIcon || this.$q.iconSet.carousel[this.vertical === true ? 'up' : 'left'], this.nextIcon || this.$q.iconSet.carousel[this.vertical === true ? 'down' : 'right']];
      return this.vertical === false && this.$q.lang.rtl === true ? ico.reverse() : ico;
    },
    navIcon() {
      return this.navigationIcon || this.$q.iconSet.carousel.navigationIcon;
    },
    navActiveIcon() {
      return this.navigationActiveIcon || this.navIcon;
    },
    navigationPositionComputed() {
      return this.navigationPosition || (this.vertical === true ? 'right' : 'bottom');
    },
    controlProps() {
      return {
        color: this.controlColor,
        textColor: this.controlTextColor,
        round: true,
        [this.controlType]: true,
        dense: true
      };
    },
    transitionPrevComputed() {
      return this.transitionPrev || 'fade';
    },
    transitionNextComputed() {
      return this.transitionNext || 'fade';
    }
  },
  watch: {
    value() {
      if (this.autoplay) {
        clearInterval(this.timer);
        this.__startTimer();
      }
    },
    autoplay(val) {
      if (val) {
        this.__startTimer();
      } else {
        clearInterval(this.timer);
      }
    }
  },
  methods: {
    __startTimer() {
      const duration = Object(is["c" /* isNumber */])(this.autoplay) === true ? this.autoplay : 5000;
      this.timer = setTimeout(duration >= 0 ? this.next : this.previous, Math.abs(duration));
    },
    __getNavigationContainer(h, type, mapping) {
      return h('div', {
        class: 'q-carousel__control q-carousel__navigation no-wrap absolute flex' + ` q-carousel__navigation--${type} q-carousel__navigation--${this.navigationPositionComputed}` + (this.controlColor !== void 0 ? ` text-${this.controlColor}` : '')
      }, [h('div', {
        staticClass: 'q-carousel__navigation-inner flex flex-center no-wrap'
      }, this.__getEnabledPanels().map(mapping))]);
    },
    __getContent(h) {
      const node = [];
      if (this.navigation === true) {
        const fn = this.$scopedSlots['navigation-icon'] !== void 0 ? this.$scopedSlots['navigation-icon'] : opts => h(QBtn["a" /* default */], {
          key: 'nav' + opts.name,
          class: `q-carousel__navigation-icon q-carousel__navigation-icon--${opts.active === true ? '' : 'in'}active`,
          props: opts.btnProps,
          on: Object(cache["b" /* default */])(this, 'nav#' + opts.name, {
            click: opts.onClick
          })
        });
        const maxIndex = this.panels.length - 1;
        node.push(this.__getNavigationContainer(h, 'buttons', (panel, index) => {
          const name = panel.componentOptions.propsData.name;
          const active = this.panelIndex === index;
          return fn({
            index,
            maxIndex,
            name,
            active,
            btnProps: {
              icon: active === true ? this.navActiveIcon : this.navIcon,
              size: 'sm',
              ...this.controlProps
            },
            onClick: () => {
              this.goTo(name);
            }
          });
        }));
      } else if (this.thumbnails === true) {
        const color = this.controlColor !== void 0 ? ` text-${this.controlColor}` : '';
        node.push(this.__getNavigationContainer(h, 'thumbnails', panel => {
          const slide = panel.componentOptions.propsData;
          return h('img', {
            class: `q-carousel__thumbnail q-carousel__thumbnail--${slide.name === this.value ? '' : 'in'}active` + color,
            attrs: {
              src: slide.imgSrc
            },
            key: 'tmb#' + slide.name,
            on: Object(cache["b" /* default */])(this, 'tmb#' + slide.name, {
              click: () => {
                this.goTo(slide.name);
              }
            })
          });
        }));
      }
      if (this.arrows === true && this.panelIndex >= 0) {
        if (this.infinite === true || this.panelIndex > 0) {
          node.push(h('div', {
            key: 'prev',
            staticClass: `q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--${this.direction} absolute flex flex-center`
          }, [h(QBtn["a" /* default */], {
            props: {
              icon: this.arrowIcons[0],
              ...this.controlProps
            },
            on: Object(cache["b" /* default */])(this, 'prev', {
              click: this.previous
            })
          })]));
        }
        if (this.infinite === true || this.panelIndex < this.panels.length - 1) {
          node.push(h('div', {
            key: 'next',
            staticClass: `q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--${this.direction} absolute flex flex-center`
          }, [h(QBtn["a" /* default */], {
            props: {
              icon: this.arrowIcons[1],
              ...this.controlProps
            },
            on: Object(cache["b" /* default */])(this, 'next', {
              click: this.next
            })
          })]));
        }
      }
      return Object(private_slot["a" /* mergeSlot */])(node, this, 'control');
    },
    __renderPanels(h) {
      return h('div', {
        style: this.style,
        class: this.classes,
        on: {
          ...this.qListeners
        }
      }, [h('div', {
        staticClass: 'q-carousel__slides-container',
        directives: this.panelDirectives
      }, this.__getPanelContent(h))].concat(this.__getContent(h)));
    }
  },
  mounted() {
    this.autoplay && this.__startTimer();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/carousel/QCarouselSlide.js



/* harmony default export */ var QCarouselSlide = (external_vue_default.a.extend({
  name: 'QCarouselSlide',
  mixins: [PanelChildMixin],
  props: {
    imgSrc: String
  },
  computed: {
    style() {
      if (this.imgSrc) {
        return {
          backgroundImage: `url("${this.imgSrc}")`
        };
      }
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-carousel__slide',
      style: this.style,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/carousel/QCarouselControl.js



/* harmony default export */ var QCarouselControl = (external_vue_default.a.extend({
  name: 'QCarouselControl',
  mixins: [listeners["a" /* default */]],
  props: {
    position: {
      type: String,
      default: 'bottom-right',
      validator: v => ['top-right', 'top-left', 'bottom-right', 'bottom-left', 'top', 'right', 'bottom', 'left'].includes(v)
    },
    offset: {
      type: Array,
      default: () => [18, 18],
      validator: v => v.length === 2
    }
  },
  computed: {
    classes() {
      return `absolute-${this.position}`;
    },
    style() {
      return {
        margin: `${this.offset[1]}px ${this.offset[0]}px`
      };
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-carousel__control absolute',
      style: this.style,
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/carousel/index.js




// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/chat/QChatMessage.js


/* harmony default export */ var QChatMessage = (external_vue_default.a.extend({
  name: 'QChatMessage',
  mixins: [listeners["a" /* default */]],
  props: {
    sent: Boolean,
    label: String,
    bgColor: String,
    textColor: String,
    name: String,
    avatar: String,
    text: Array,
    stamp: String,
    size: String,
    labelSanitize: Boolean,
    nameSanitize: Boolean,
    textSanitize: Boolean,
    stampSanitize: Boolean
  },
  computed: {
    textClass() {
      return `q-message-text-content q-message-text-content--${this.op}` + (this.textColor !== void 0 ? ` text-${this.textColor}` : '');
    },
    messageClass() {
      return `q-message-text q-message-text--${this.op}` + (this.bgColor !== void 0 ? ` text-${this.bgColor}` : '');
    },
    containerClass() {
      return 'q-message-container row items-end no-wrap' + (this.sent === true ? ' reverse' : '');
    },
    sizeClass() {
      if (this.size !== void 0) {
        return `col-${this.size}`;
      }
    },
    op() {
      return this.sent === true ? 'sent' : 'received';
    }
  },
  methods: {
    __wrapStamp(h, node) {
      if (this.$scopedSlots.stamp !== void 0) {
        return [node, h('div', {
          staticClass: 'q-message-stamp'
        }, this.$scopedSlots.stamp())];
      }
      if (this.stamp) {
        const domPropStamp = this.stampSanitize === true ? 'textContent' : 'innerHTML';
        return [node, h('div', {
          staticClass: 'q-message-stamp',
          domProps: {
            [domPropStamp]: this.stamp
          }
        })];
      }
      return [node];
    },
    __getText(h, contentList, withSlots) {
      const domPropText = this.textSanitize === true ? 'textContent' : 'innerHTML';
      if (withSlots === true && contentList.some(entry => entry.tag === void 0 && entry.text !== void 0) === true) {
        return [h('div', {
          class: this.messageClass
        }, [h('div', {
          class: this.textClass
        }, this.__wrapStamp(h, h('div', contentList)))])];
      }
      const content = withSlots !== true ? text => h('div', {
        domProps: {
          [domPropText]: text
        }
      }) : contentList.length > 1 ? text => text : text => h('div', [text]);
      return contentList.map((msg, index) => h('div', {
        key: index,
        class: this.messageClass
      }, [h('div', {
        class: this.textClass
      }, this.__wrapStamp(h, content(msg)))]));
    }
  },
  render(h) {
    const container = [];
    if (this.$scopedSlots.avatar !== void 0) {
      container.push(this.$scopedSlots.avatar());
    } else if (this.avatar !== void 0) {
      container.push(h('img', {
        class: `q-message-avatar q-message-avatar--${this.op}`,
        attrs: {
          src: this.avatar,
          'aria-hidden': 'true'
        }
      }));
    }
    const msg = [];
    if (this.$scopedSlots.name !== void 0) {
      msg.push(h('div', {
        class: `q-message-name q-message-name--${this.op}`
      }, this.$scopedSlots.name()));
    } else if (this.name !== void 0) {
      msg.push(h('div', {
        class: `q-message-name q-message-name--${this.op}`,
        domProps: {
          [this.nameSanitize === true ? 'textContent' : 'innerHTML']: this.name
        }
      }));
    }
    this.text !== void 0 && msg.push(this.__getText(h, this.text));
    this.$scopedSlots.default !== void 0 && msg.push(this.__getText(h, this.$scopedSlots.default(), true));
    container.push(h('div', {
      class: this.sizeClass
    }, msg));
    const child = [];
    if (this.$scopedSlots.label !== void 0) {
      child.push(h('div', {
        staticClass: 'q-message-label'
      }, this.$scopedSlots.label()));
    } else if (this.label !== void 0) {
      child.push(h('div', {
        staticClass: 'q-message-label',
        domProps: {
          [this.labelSanitize === true ? 'textContent' : 'innerHTML']: this.label
        }
      }));
    }
    child.push(h('div', {
      class: this.containerClass
    }, container));
    return h('div', {
      class: `q-message q-message-${this.op}`,
      on: {
        ...this.qListeners
      }
    }, child);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/chat/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/checkbox/QCheckbox.js
var QCheckbox = __webpack_require__("1919");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/checkbox/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/chip/QChip.js
var QChip = __webpack_require__("5759");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/chip/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/circular-progress/QCircularProgress.js





const radius = 50,
  diameter = 2 * radius,
  circumference = diameter * Math.PI,
  strokeDashArray = Math.round(circumference * 1000) / 1000;
/* harmony default export */ var QCircularProgress = (external_vue_default.a.extend({
  name: 'QCircularProgress',
  mixins: [listeners["a" /* default */], size["a" /* default */]],
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    color: String,
    centerColor: String,
    trackColor: String,
    fontSize: String,
    rounded: Boolean,
    // ratio
    thickness: {
      type: Number,
      default: 0.2,
      validator: v => v >= 0 && v <= 1
    },
    angle: {
      type: Number,
      default: 0
    },
    indeterminate: Boolean,
    showValue: Boolean,
    reverse: Boolean,
    instantFeedback: Boolean
  },
  computed: {
    normalizedValue() {
      return Object(format["a" /* between */])(this.value, this.min, this.max);
    },
    svgStyle() {
      const angle = this.$q.lang.rtl === true ? -this.angle : this.angle;
      return {
        transform: this.reverse !== (this.$q.lang.rtl === true) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - angle}deg)` : `rotate3d(0, 0, 1, ${angle - 90}deg)`
      };
    },
    circleStyle() {
      if (this.instantFeedback !== true && this.indeterminate !== true) {
        return {
          transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
        };
      }
    },
    viewBox() {
      return diameter / (1 - this.thickness / 2);
    },
    viewBoxAttr() {
      return `${this.viewBox / 2} ${this.viewBox / 2} ${this.viewBox} ${this.viewBox}`;
    },
    strokeDashOffset() {
      const progress = 1 - (this.normalizedValue - this.min) / (this.max - this.min);
      return progress * circumference;
    },
    strokeWidth() {
      return this.thickness / 2 * this.viewBox;
    },
    attrs() {
      return {
        role: 'progressbar',
        'aria-valuemin': this.min,
        'aria-valuemax': this.max,
        'aria-valuenow': this.indeterminate === true ? void 0 : this.normalizedValue
      };
    }
  },
  methods: {
    __getCircle(h, {
      thickness,
      offset,
      color,
      cls,
      rounded
    }) {
      return h('circle', {
        staticClass: 'q-circular-progress__' + cls,
        class: color !== void 0 ? `text-${color}` : null,
        style: this.circleStyle,
        attrs: {
          fill: 'transparent',
          stroke: 'currentColor',
          'stroke-width': thickness,
          'stroke-dasharray': strokeDashArray,
          'stroke-dashoffset': offset,
          'stroke-linecap': rounded,
          cx: this.viewBox,
          cy: this.viewBox,
          r: radius
        }
      });
    }
  },
  render(h) {
    const svgChild = [];
    this.centerColor !== void 0 && this.centerColor !== 'transparent' && svgChild.push(h('circle', {
      staticClass: 'q-circular-progress__center',
      class: `text-${this.centerColor}`,
      attrs: {
        fill: 'currentColor',
        r: radius - this.strokeWidth / 2,
        cx: this.viewBox,
        cy: this.viewBox
      }
    }));
    this.trackColor !== void 0 && this.trackColor !== 'transparent' && svgChild.push(this.__getCircle(h, {
      cls: 'track',
      thickness: this.strokeWidth,
      offset: 0,
      color: this.trackColor
    }));
    svgChild.push(this.__getCircle(h, {
      cls: 'circle',
      thickness: this.strokeWidth,
      offset: this.strokeDashOffset,
      color: this.color,
      rounded: this.rounded === true ? 'round' : void 0
    }));
    const child = [h('svg', {
      staticClass: 'q-circular-progress__svg',
      style: this.svgStyle,
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        viewBox: this.viewBoxAttr,
        'aria-hidden': 'true'
      }
    }, svgChild)];
    this.showValue === true && child.push(h('div', {
      staticClass: 'q-circular-progress__text absolute-full row flex-center content-center',
      style: {
        fontSize: this.fontSize
      }
    }, this.$scopedSlots.default !== void 0 ? this.$scopedSlots.default() : [h('div', [this.normalizedValue])]));
    return h('div', {
      staticClass: 'q-circular-progress',
      class: `q-circular-progress--${this.indeterminate === true ? 'in' : ''}determinate`,
      style: this.sizeStyle,
      on: {
        ...this.qListeners
      },
      attrs: this.attrs
    }, Object(private_slot["b" /* mergeSlotSafely */])(child, this, 'internal'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/circular-progress/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/patterns.js
var patterns = __webpack_require__("af68");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/throttle.js
var throttle = __webpack_require__("3867");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/colors.js
var colors = __webpack_require__("36c0");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/directives/TouchPan.js
var TouchPan = __webpack_require__("f452");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/slider/slider-utils.js






const markerPrefixClass = 'q-slider__marker-labels';
const defaultMarkerConvertFn = v => ({
  value: v
});

// PGDOWN, LEFT, DOWN, PGUP, RIGHT, UP
const keyCodes = [34, 37, 40, 33, 39, 38];
const SliderMixin = {
  mixins: [dark["a" /* default */], mixins_form["b" /* default */]],
  directives: {
    TouchPan: TouchPan["a" /* default */]
  },
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    innerMin: Number,
    innerMax: Number,
    step: {
      type: Number,
      default: 1,
      validator: v => v >= 0
    },
    snap: Boolean,
    vertical: Boolean,
    reverse: Boolean,
    hideSelection: Boolean,
    color: String,
    markerLabelsClass: String,
    label: Boolean,
    labelColor: String,
    labelTextColor: String,
    labelAlways: Boolean,
    switchLabelSide: Boolean,
    markers: [Boolean, Number],
    markerLabels: [Boolean, Array, Object, Function],
    switchMarkerLabelsSide: Boolean,
    trackImg: String,
    trackColor: String,
    innerTrackImg: String,
    innerTrackColor: String,
    selectionColor: String,
    selectionImg: String,
    thumbSize: {
      type: String,
      default: '20px'
    },
    trackSize: {
      type: String,
      default: '4px'
    },
    disable: Boolean,
    readonly: Boolean,
    dense: Boolean,
    tabindex: [String, Number],
    thumbColor: String,
    thumbPath: {
      type: String,
      default: 'M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0'
    }
  },
  data() {
    return {
      active: false,
      preventFocus: false,
      focus: false,
      dragging: false
    };
  },
  computed: {
    axis() {
      return this.vertical === true ? '--v' : '--h';
    },
    labelSide() {
      return '-' + (this.switchLabelSide === true ? 'switched' : 'standard');
    },
    isReversed() {
      return this.vertical === true ? this.reverse === true : this.reverse !== (this.$q.lang.rtl === true);
    },
    computedInnerMin() {
      return this.__getInnerMin(this.innerMin);
    },
    computedInnerMax() {
      return this.__getInnerMax(this.innerMax);
    },
    editable() {
      return this.disable !== true && this.readonly !== true && this.computedInnerMin < this.computedInnerMax;
    },
    computedDecimals() {
      return (String(this.step).trim('0').split('.')[1] || '').length;
    },
    computedStep() {
      return this.step === 0 ? 1 : this.step;
    },
    computedTabindex() {
      return this.editable === true ? this.tabindex || 0 : -1;
    },
    trackLen() {
      return this.max - this.min;
    },
    innerBarLen() {
      return this.computedInnerMax - this.computedInnerMin;
    },
    innerMinRatio() {
      return this.__convertModelToRatio(this.computedInnerMin);
    },
    innerMaxRatio() {
      return this.__convertModelToRatio(this.computedInnerMax);
    },
    positionProp() {
      return this.vertical === true ? this.isReversed === true ? 'bottom' : 'top' : this.isReversed === true ? 'right' : 'left';
    },
    sizeProp() {
      return this.vertical === true ? 'height' : 'width';
    },
    thicknessProp() {
      return this.vertical === true ? 'width' : 'height';
    },
    orientation() {
      return this.vertical === true ? 'vertical' : 'horizontal';
    },
    attributes() {
      const acc = {
        role: 'slider',
        'aria-valuemin': this.computedInnerMin,
        'aria-valuemax': this.computedInnerMax,
        'aria-orientation': this.orientation,
        'data-step': this.step
      };
      if (this.disable === true) {
        acc['aria-disabled'] = 'true';
      } else if (this.readonly === true) {
        acc['aria-readonly'] = 'true';
      }
      return acc;
    },
    classes() {
      return `q-slider q-slider${this.axis} q-slider--${this.active === true ? '' : 'in'}active inline no-wrap ` + (this.vertical === true ? 'row' : 'column') + (this.disable === true ? ' disabled' : ' q-slider--enabled' + (this.editable === true ? ' q-slider--editable' : '')) + (this.focus === 'both' ? ' q-slider--focus' : '') + (this.label || this.labelAlways === true ? ' q-slider--label' : '') + (this.labelAlways === true ? ' q-slider--label-always' : '') + (this.isDark === true ? ' q-slider--dark' : '') + (this.dense === true ? ' q-slider--dense q-slider--dense' + this.axis : '');
    },
    selectionBarClass() {
      const color = this.selectionColor || this.color;
      return 'q-slider__selection absolute' + (color !== void 0 ? ` text-${color}` : '');
    },
    markerClass() {
      return this.__getAxisClass('markers') + ' absolute overflow-hidden';
    },
    trackContainerClass() {
      return this.__getAxisClass('track-container');
    },
    pinClass() {
      return this.__getPositionClass('pin');
    },
    labelClass() {
      return this.__getPositionClass('label');
    },
    textContainerClass() {
      return this.__getPositionClass('text-container');
    },
    markerLabelsContainerClass() {
      return this.__getPositionClass('marker-labels-container') + (this.markerLabelsClass !== void 0 ? ` ${this.markerLabelsClass}` : '');
    },
    trackClass() {
      return 'q-slider__track relative-position no-outline' + (this.trackColor !== void 0 ? ` bg-${this.trackColor}` : '');
    },
    trackStyle() {
      const acc = {
        [this.thicknessProp]: this.trackSize
      };
      if (this.trackImg !== void 0) {
        acc.backgroundImage = `url(${this.trackImg}) !important`;
      }
      return acc;
    },
    innerBarClass() {
      return 'q-slider__inner absolute' + (this.innerTrackColor !== void 0 ? ` bg-${this.innerTrackColor}` : '');
    },
    innerBarStyle() {
      const acc = {
        [this.positionProp]: `${100 * this.innerMinRatio}%`,
        [this.sizeProp]: `${100 * (this.innerMaxRatio - this.innerMinRatio)}%`
      };
      if (this.innerTrackImg !== void 0) {
        acc.backgroundImage = `url(${this.innerTrackImg}) !important`;
      }
      return acc;
    },
    markerStep() {
      return Object(is["c" /* isNumber */])(this.markers) === true ? this.markers : this.computedStep;
    },
    markerTicks() {
      const acc = [];
      const step = this.markerStep;
      let value = this.min;
      do {
        acc.push(value);
        value += step;
      } while (value < this.max);
      acc.push(this.max);
      return acc;
    },
    markerLabelClass() {
      const prefix = ` ${markerPrefixClass}${this.axis}-`;
      return markerPrefixClass + `${prefix}${this.switchMarkerLabelsSide === true ? 'switched' : 'standard'}` + `${prefix}${this.isReversed === true ? 'rtl' : 'ltr'}`;
    },
    markerLabelsList() {
      if (this.markerLabels === false) {
        return null;
      }
      return this.__getMarkerList(this.markerLabels).map((entry, index) => ({
        index,
        value: entry.value,
        label: entry.label || entry.value,
        classes: this.markerLabelClass + (entry.classes !== void 0 ? ' ' + entry.classes : ''),
        style: {
          ...this.__getMarkerLabelStyle(entry.value),
          ...(entry.style || {})
        }
      }));
    },
    markerScope() {
      return {
        markerList: this.markerLabelsList,
        markerMap: this.markerLabelsMap,
        classes: this.markerLabelClass,
        getStyle: this.__getMarkerLabelStyle
      };
    },
    markerStyle() {
      if (this.innerBarLen !== 0) {
        const size = 100 * this.markerStep / this.innerBarLen;
        return {
          ...this.innerBarStyle,
          backgroundSize: this.vertical === true ? `2px ${size}%` : `${size}% 2px`
        };
      }
      return null;
    },
    markerLabelsMap() {
      if (this.markerLabels === false) {
        return null;
      }
      const acc = {};
      this.markerLabelsList.forEach(entry => {
        acc[entry.value] = entry;
      });
      return acc;
    },
    panDirectives() {
      return this.editable === true ? [{
        name: 'touch-pan',
        value: this.__onPan,
        modifiers: {
          [this.orientation]: true,
          prevent: true,
          stop: true,
          mouse: true,
          mouseAllDir: true
        }
      }] : null;
    }
  },
  methods: {
    __getInnerMin(val) {
      return isNaN(val) === true || this.innerMin < this.min ? this.min : this.innerMin;
    },
    __getInnerMax(val) {
      return isNaN(val) === true || val > this.max ? this.max : this.innerMax;
    },
    __getPositionClass(name) {
      const cls = 'q-slider__' + name;
      return `${cls} ${cls}${this.axis} ${cls}${this.axis}${this.labelSide}`;
    },
    __getAxisClass(name) {
      const cls = 'q-slider__' + name;
      return `${cls} ${cls}${this.axis}`;
    },
    __convertRatioToModel(ratio) {
      let model = this.min + ratio * (this.max - this.min);
      if (this.step > 0) {
        const modulo = (model - this.min) % this.step;
        model += (Math.abs(modulo) >= this.step / 2 ? (modulo < 0 ? -1 : 1) * this.step : 0) - modulo;
      }
      if (this.computedDecimals > 0) {
        model = parseFloat(model.toFixed(this.computedDecimals));
      }
      return Object(format["a" /* between */])(model, this.computedInnerMin, this.computedInnerMax);
    },
    __convertModelToRatio(model) {
      return this.trackLen === 0 ? 0 : (model - this.min) / this.trackLen;
    },
    __getDraggingRatio(evt, dragging) {
      const pos = Object(utils_event["h" /* position */])(evt),
        val = this.vertical === true ? Object(format["a" /* between */])((pos.top - dragging.top) / dragging.height, 0, 1) : Object(format["a" /* between */])((pos.left - dragging.left) / dragging.width, 0, 1);
      return Object(format["a" /* between */])(this.isReversed === true ? 1.0 - val : val, this.innerMinRatio, this.innerMaxRatio);
    },
    __getMarkerList(def) {
      if (def === false) {
        return null;
      }
      if (def === true) {
        return this.markerTicks.map(defaultMarkerConvertFn);
      }
      if (typeof def === 'function') {
        return this.markerTicks.map(value => {
          const item = def(value);
          return Object(is["d" /* isObject */])(item) === true ? {
            ...item,
            value
          } : {
            value,
            label: item
          };
        });
      }
      const filterFn = ({
        value
      }) => value >= this.min && value <= this.max;
      if (Array.isArray(def) === true) {
        return def.map(item => Object(is["d" /* isObject */])(item) === true ? item : {
          value: item
        }).filter(filterFn);
      }
      return Object.keys(def).map(key => {
        const item = def[key];
        const value = Number(key);
        return Object(is["d" /* isObject */])(item) === true ? {
          ...item,
          value
        } : {
          value,
          label: item
        };
      }).filter(filterFn);
    },
    __getMarkerLabelStyle(val) {
      return {
        [this.positionProp]: `${100 * (val - this.min) / this.trackLen}%`
      };
    },
    __getMarkerLabelsContent(h) {
      if (this.$scopedSlots['marker-label-group'] !== void 0) {
        return this.$scopedSlots['marker-label-group'](this.markerScope);
      }
      const fn = this.$scopedSlots['marker-label'];
      if (fn !== void 0) {
        return this.markerLabelsList.map(marker => fn({
          marker,
          ...this.markerScope
        }));
      }
      return this.markerLabelsList.map(marker => h('div', {
        key: marker.value,
        style: marker.style,
        class: marker.classes
      }, marker.label));
    },
    __onPan(event) {
      if (event.isFinal === true) {
        if (this.dragging !== void 0) {
          this.__updatePosition(event.evt);
          // only if touch, because we also have mousedown/up:
          event.touch === true && this.__updateValue(true);
          this.dragging = void 0;
          this.$emit('pan', 'end');
        }
        this.active = false;
        this.focus = false;
      } else if (event.isFirst === true) {
        this.dragging = this.__getDragging(event.evt);
        this.__updatePosition(event.evt);
        this.__updateValue();
        this.active = true;
        this.$emit('pan', 'start');
      } else {
        this.__updatePosition(event.evt);
        this.__updateValue();
      }
    },
    __onBlur() {
      this.focus = false;
    },
    __onActivate(evt) {
      this.__updatePosition(evt, this.__getDragging(evt));
      this.__updateValue();
      this.preventFocus = true;
      this.active = true;
      document.addEventListener('mouseup', this.__onDeactivate, true);
    },
    __onDeactivate() {
      this.preventFocus = false;
      this.active = false;
      this.__updateValue(true);
      this.__onBlur();
      document.removeEventListener('mouseup', this.__onDeactivate, true);
    },
    __onMobileClick(evt) {
      this.__updatePosition(evt, this.__getDragging(evt));
      this.__updateValue(true);
    },
    __onKeyup(evt) {
      if (keyCodes.includes(evt.keyCode)) {
        this.__updateValue(true);
      }
    },
    __getTextContainerStyle(ratio) {
      if (this.vertical === true) {
        return null;
      }
      const p = this.$q.lang.rtl !== this.reverse ? 1 - ratio : ratio;
      return {
        transform: `translateX(calc(${2 * p - 1} * ${this.thumbSize} / 2 + ${50 - 100 * p}%))`
      };
    },
    __getThumb(h, thumb) {
      const thumbContent = [h('svg', {
        class: 'q-slider__thumb-shape absolute-full',
        attrs: {
          viewBox: '0 0 20 20',
          'aria-hidden': 'true'
        }
      }, [h('path', {
        attrs: {
          d: this.thumbPath
        }
      })]), h('div', {
        class: 'q-slider__focus-ring fit'
      })];
      if (this.label === true || this.labelAlways === true) {
        thumbContent.push(h('div', {
          class: this.pinClass + ' absolute fit no-pointer-events' + thumb.pinColor
        }, [h('div', {
          class: this.labelClass,
          style: {
            minWidth: this.thumbSize
          }
        }, [h('div', {
          class: this.textContainerClass,
          style: thumb.textContainerStyle
        }, [h('span', {
          class: thumb.textClass
        }, thumb.label)])])]));
        if (this.name !== void 0 && this.disable !== true) {
          this.__injectFormInput(thumbContent, 'push');
        }
      }
      return h('div', {
        class: thumb.classes,
        style: thumb.style,
        ...thumb.nodeData
      }, thumbContent);
    },
    __getContent(h, injectThumb) {
      const trackContent = [];
      this.innerTrackColor !== 'transparent' && trackContent.push(h('div', {
        key: 'inner',
        class: this.innerBarClass,
        style: this.innerBarStyle
      }));
      this.selectionColor !== 'transparent' && trackContent.push(h('div', {
        key: 'selection',
        class: this.selectionBarClass,
        style: this.selectionBarStyle
      }));
      this.markers !== false && trackContent.push(h('div', {
        key: 'marker',
        class: this.markerClass,
        style: this.markerStyle
      }));
      injectThumb(trackContent);
      const content = [h('div', {
        key: 'trackC',
        class: this.trackContainerClass,
        attrs: this.trackContainerAttrs,
        on: this.trackContainerEvents,
        directives: this.panDirectives
      }, [h('div', {
        class: this.trackClass,
        style: this.trackStyle
      }, trackContent)])];
      if (this.markerLabels !== false) {
        const action = this.switchMarkerLabelsSide === true ? 'unshift' : 'push';
        content[action](h('div', {
          key: 'markerL',
          class: this.markerLabelsContainerClass
        }, this.__getMarkerLabelsContent(h)));
      }
      return content;
    }
  },
  beforeDestroy() {
    document.removeEventListener('mouseup', this.__onDeactivate, true);
  }
};
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/slider/QSlider.js




/* harmony default export */ var QSlider = (external_vue_default.a.extend({
  name: 'QSlider',
  mixins: [SliderMixin],
  props: {
    value: {
      required: true,
      default: null,
      validator: v => typeof v === 'number' || v === null
    },
    labelValue: [String, Number]
  },
  data() {
    const innerMin = this.__getInnerMin(this.innerMin);
    const innerMax = this.__getInnerMax(this.innerMax);
    return {
      model: this.value === null ? innerMin : Object(format["a" /* between */])(this.value, innerMin, innerMax),
      curRatio: 0
    };
  },
  computed: {
    modelRatio() {
      return this.__convertModelToRatio(this.model);
    },
    ratio() {
      return this.active === true ? this.curRatio : this.modelRatio;
    },
    selectionBarStyle() {
      const acc = {
        [this.positionProp]: `${100 * this.innerMinRatio}%`,
        [this.sizeProp]: `${100 * (this.ratio - this.innerMinRatio)}%`
      };
      if (this.selectionImg !== void 0) {
        acc.backgroundImage = `url(${this.selectionImg}) !important`;
      }
      return acc;
    },
    thumbLabel() {
      return this.labelValue !== void 0 ? this.labelValue : this.model;
    },
    thumbClasses() {
      const color = this.thumbColor || this.color;
      return `q-slider__thumb q-slider__thumb${this.axis} q-slider__thumb${this.axis}-${this.isReversed === true ? 'rtl' : 'ltr'} absolute non-selectable` + (this.preventFocus === false && this.focus === true ? ' q-slider--focus' : '') + (color !== void 0 ? ` text-${color}` : '');
    },
    thumbStyle() {
      return {
        width: this.thumbSize,
        height: this.thumbSize,
        [this.positionProp]: `${100 * this.ratio}%`
      };
    },
    thumbPinColor() {
      return this.labelColor !== void 0 ? ` text-${this.labelColor}` : '';
    },
    thumbTextContainerStyle() {
      return this.__getTextContainerStyle(this.ratio);
    },
    thumbTextClass() {
      return 'q-slider__text' + (this.labelTextColor !== void 0 ? ` text-${this.labelTextColor}` : '');
    },
    trackContainerEvents() {
      if (this.editable !== true) {
        return {};
      }
      return this.$q.platform.is.mobile === true ? {
        click: this.__onMobileClick
      } : {
        mousedown: this.__onActivate,
        focus: this.__onFocus,
        blur: this.__onBlur,
        keydown: this.__onKeydown,
        keyup: this.__onKeyup
      };
    },
    trackContainerAttrs() {
      return {
        tabindex: this.$q.platform.is.mobile !== true ? this.computedTabindex : null
      };
    },
    modelUpdate() {
      return `${this.value}|${this.computedInnerMin}|${this.computedInnerMax}`;
    }
  },
  watch: {
    modelUpdate() {
      this.model = this.value === null ? this.computedInnerMin : Object(format["a" /* between */])(this.value, this.computedInnerMin, this.computedInnerMax);
    }
  },
  methods: {
    __updateValue(change) {
      if (this.model !== this.value) {
        this.$emit('input', this.model);
      }
      change === true && this.$emit('change', this.model);
    },
    __getDragging() {
      return this.$el.getBoundingClientRect();
    },
    __updatePosition(event, dragging = this.dragging) {
      const ratio = this.__getDraggingRatio(event, dragging);
      this.model = this.__convertRatioToModel(ratio);
      this.curRatio = this.snap !== true || this.computedStep === 0 ? ratio : this.__convertModelToRatio(this.model);
    },
    __onFocus() {
      this.focus = true;
    },
    __onKeydown(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }
      Object(utils_event["l" /* stopAndPrevent */])(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * this.computedStep,
        offset = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (this.isReversed === true ? -1 : 1) * (this.vertical === true ? -1 : 1) * stepVal;
      this.model = Object(format["a" /* between */])(parseFloat((this.model + offset).toFixed(this.computedDecimals)), this.computedInnerMin, this.computedInnerMax);
      this.__updateValue();
    }
  },
  render(h) {
    const content = this.__getContent(h, node => {
      node.push(this.__getThumb(h, {
        pinColor: this.thumbPinColor,
        textContainerStyle: this.thumbTextContainerStyle,
        textClass: this.thumbTextClass,
        label: this.thumbLabel,
        classes: this.thumbClasses,
        style: this.thumbStyle,
        nodeData: {}
      }));
    });
    return h('div', {
      class: this.classes + (this.value === null ? ' q-slider--no-value' : ''),
      attrs: {
        ...this.attributes,
        'aria-valuenow': this.value
      }
    }, content);
  }
}));
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/resize-observer/QResizeObserver.js
var QResizeObserver = __webpack_require__("6e27");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/timeout.js
var timeout = __webpack_require__("f3c6");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/scroll.js
var utils_scroll = __webpack_require__("a820");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/private/inject-obj-prop.js
function injectProp(target, propName, get, set) {
  Object.defineProperty(target, propName, {
    get,
    set,
    enumerable: true
  });
  return target;
}
function injectMultipleProps(target, props) {
  Object.keys(props).forEach(key => {
    injectProp(target, key, props[key]);
  });
  return target;
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tabs/QTabs.js










function getIndicatorClass(color, top, vertical) {
  const pos = vertical === true ? ['left', 'right'] : ['top', 'bottom'];
  return `absolute-${top === true ? pos[0] : pos[1]}${color ? ` text-${color}` : ''}`;
}
const alignValues = ['left', 'center', 'right', 'justify'];
const getDefaultBestScore = () => ({
  matchedLen: 0,
  queryDiff: 9999,
  hrefLen: 0,
  exact: false,
  redirected: true
});
function hasQueryIncluded(targetQuery, matchingQuery) {
  for (const key in targetQuery) {
    if (targetQuery[key] !== matchingQuery[key]) {
      return false;
    }
  }
  return true;
}
/* harmony default export */ var QTabs = (external_vue_default.a.extend({
  name: 'QTabs',
  mixins: [timeout["a" /* default */], listeners["a" /* default */]],
  provide() {
    return {
      $tabs: this
    };
  },
  props: {
    value: [Number, String],
    align: {
      type: String,
      default: 'center',
      validator: v => alignValues.includes(v)
    },
    breakpoint: {
      type: [String, Number],
      default: 600
    },
    vertical: Boolean,
    shrink: Boolean,
    stretch: Boolean,
    activeClass: String,
    activeColor: String,
    activeBgColor: String,
    indicatorColor: String,
    leftIcon: String,
    rightIcon: String,
    outsideArrows: Boolean,
    mobileArrows: Boolean,
    switchIndicator: Boolean,
    narrowIndicator: Boolean,
    inlineLabel: Boolean,
    noCaps: Boolean,
    dense: Boolean,
    contentClass: String
  },
  data() {
    return {
      scrollable: false,
      leftArrow: true,
      rightArrow: false,
      justify: false,
      tabNameList: [],
      // used by children
      currentModel: this.value,
      hasFocus: false,
      avoidRouteWatcher: false // false | string (uid)
    };
  },
  watch: {
    isRTL() {
      this.__localUpdateArrows();
    },
    value(name) {
      this.__updateModel({
        name,
        setCurrent: true,
        skipEmit: true
      });
    },
    outsideArrows() {
      this.__recalculateScroll();
    },
    arrowsEnabled(v) {
      this.__localUpdateArrows = v === true ? this.__updateArrowsFn : utils_event["g" /* noop */];
      this.__recalculateScroll();
    }
  },
  computed: {
    // used by children
    tabProps() {
      return {
        activeClass: this.activeClass,
        activeColor: this.activeColor,
        activeBgColor: this.activeBgColor,
        indicatorClass: getIndicatorClass(this.indicatorColor, this.switchIndicator, this.vertical),
        narrowIndicator: this.narrowIndicator,
        inlineLabel: this.inlineLabel,
        noCaps: this.noCaps
      };
    },
    // used by children
    hasActiveTab() {
      return this.tabNameList.some(entry => entry.name === this.currentModel);
    },
    arrowsEnabled() {
      return this.$q.platform.is.desktop === true || this.mobileArrows === true;
    },
    alignClass() {
      const align = this.scrollable === true ? 'left' : this.justify === true ? 'justify' : this.align;
      return `q-tabs__content--align-${align}`;
    },
    classes() {
      return 'q-tabs row no-wrap items-center' + ` q-tabs--${this.scrollable === true ? '' : 'not-'}scrollable` + ` q-tabs--${this.vertical === true ? 'vertical' : 'horizontal'}` + ` q-tabs__arrows--${this.arrowsEnabled === true && this.outsideArrows === true ? 'outside' : 'inside'}` + (this.dense === true ? ' q-tabs--dense' : '') + (this.shrink === true ? ' col-shrink' : '') + (this.stretch === true ? ' self-stretch' : '');
    },
    innerClass() {
      return 'q-tabs__content row no-wrap items-center self-stretch hide-scrollbar relative-position ' + this.alignClass + (this.contentClass !== void 0 ? ` ${this.contentClass}` : '') + (this.$q.platform.is.mobile === true ? ' scroll' : '');
    },
    domProps() {
      return this.vertical === true ? {
        container: 'height',
        content: 'offsetHeight',
        scroll: 'scrollHeight'
      } : {
        container: 'width',
        content: 'offsetWidth',
        scroll: 'scrollWidth'
      };
    },
    isRTL() {
      return this.vertical !== true && this.$q.lang.rtl === true;
    },
    rtlPosCorrection() {
      return Object(utils_scroll["h" /* rtlHasScrollBug */])() === false && this.isRTL === true;
    },
    // let's speed up execution of time-sensitive scrollTowards()
    // with a computed variable by directly applying the minimal
    // number of instructions on get/set functions
    posFn() {
      return this.rtlPosCorrection === true ? {
        get: content => Math.abs(content.scrollLeft),
        set: (content, pos) => {
          content.scrollLeft = -pos;
        }
      } : this.vertical === true ? {
        get: content => content.scrollTop,
        set: (content, pos) => {
          content.scrollTop = pos;
        }
      } : {
        get: content => content.scrollLeft,
        set: (content, pos) => {
          content.scrollLeft = pos;
        }
      };
    },
    onEvents() {
      return {
        input: utils_event["k" /* stop */],
        ...this.qListeners,
        focusin: this.__onFocusin,
        focusout: this.__onFocusout
      };
    }
  },
  methods: {
    // used by children too
    __updateModel({
      name,
      setCurrent,
      skipEmit
    }) {
      if (this.currentModel !== name) {
        if (skipEmit !== true && this.qListeners.input !== void 0) {
          this.$emit('input', name);
        }
        if (setCurrent === true || this.qListeners.input === void 0) {
          this.__animate(this.currentModel, name);
          this.currentModel = name;
        }
      }
    },
    __recalculateScroll() {
      this.__registerScrollTick(() => {
        this.__updateContainer({
          width: this.$el.offsetWidth,
          height: this.$el.offsetHeight
        });
      });
    },
    __updateContainer(domSize) {
      // it can be called faster than component being initialized
      // so we need to protect against that case
      // (one example of such case is the docs release notes page)
      if (this.domProps === void 0 || !this.$refs.content) {
        return;
      }
      const size = domSize[this.domProps.container],
        scrollSize = Math.min(this.$refs.content[this.domProps.scroll], Array.prototype.reduce.call(this.$refs.content.children, (acc, el) => acc + (el[this.domProps.content] || 0), 0)),
        scroll = size > 0 && scrollSize > size; // when there is no tab, in Chrome, size === 0 and scrollSize === 1

      if (this.scrollable !== scroll) {
        this.scrollable = scroll;
      }

      // Arrows need to be updated even if the scroll status was already true
      scroll === true && this.__registerUpdateArrowsTick(this.__localUpdateArrows);
      const localJustify = size < parseInt(this.breakpoint, 10);
      if (this.justify !== localJustify) {
        this.justify = localJustify;
      }
    },
    __animate(oldName, newName) {
      const oldTab = oldName !== void 0 && oldName !== null && oldName !== '' ? this.tabVmList.find(tab => tab.name === oldName) : null,
        newTab = newName !== void 0 && newName !== null && newName !== '' ? this.tabVmList.find(tab => tab.name === newName) : null;
      if (oldTab && newTab) {
        const oldEl = oldTab.$refs.tabIndicator,
          newEl = newTab.$refs.tabIndicator;
        clearTimeout(this.animateTimer);
        oldEl.style.transition = 'none';
        oldEl.style.transform = 'none';
        newEl.style.transition = 'none';
        newEl.style.transform = 'none';
        const oldPos = oldEl.getBoundingClientRect(),
          newPos = newEl.getBoundingClientRect();
        newEl.style.transform = this.vertical === true ? `translate3d(0,${oldPos.top - newPos.top}px,0) scale3d(1,${newPos.height ? oldPos.height / newPos.height : 1},1)` : `translate3d(${oldPos.left - newPos.left}px,0,0) scale3d(${newPos.width ? oldPos.width / newPos.width : 1},1,1)`;

        // allow scope updates to kick in (QRouteTab needs more time)
        this.__registerAnimateTick(() => {
          this.animateTimer = setTimeout(() => {
            newEl.style.transition = 'transform .25s cubic-bezier(.4, 0, .2, 1)';
            newEl.style.transform = 'none';
          }, 70);
        });
      }
      if (newTab && this.scrollable === true) {
        this.__scrollToTabEl(newTab.$el);
      }
    },
    __scrollToTabEl(el) {
      const contentRef = this.$refs.content,
        {
          left,
          width,
          top,
          height
        } = contentRef.getBoundingClientRect(),
        newPos = el.getBoundingClientRect();
      let offset = this.vertical === true ? newPos.top - top : newPos.left - left;
      if (offset < 0) {
        contentRef[this.vertical === true ? 'scrollTop' : 'scrollLeft'] += Math.floor(offset);
        this.__localUpdateArrows();
        return;
      }
      offset += this.vertical === true ? newPos.height - height : newPos.width - width;
      if (offset > 0) {
        contentRef[this.vertical === true ? 'scrollTop' : 'scrollLeft'] += Math.ceil(offset);
        this.__localUpdateArrows();
      }
    },
    __updateArrowsFn() {
      const content = this.$refs.content;
      if (content !== null) {
        const rect = content.getBoundingClientRect(),
          pos = this.vertical === true ? content.scrollTop : Math.abs(content.scrollLeft);
        if (this.isRTL === true) {
          this.leftArrow = Math.ceil(pos + rect.width) < content.scrollWidth - 1;
          this.rightArrow = pos > 0;
        } else {
          this.leftArrow = pos > 0;
          this.rightArrow = this.vertical === true ? Math.ceil(pos + rect.height) < content.scrollHeight : Math.ceil(pos + rect.width) < content.scrollWidth;
        }
      }
    },
    __animScrollTo(value) {
      this.__stopAnimScroll();
      this.scrollTimer = setInterval(() => {
        if (this.__scrollTowards(value) === true) {
          this.__stopAnimScroll();
        }
      }, 5);
    },
    __scrollToStart() {
      this.__animScrollTo(this.rtlPosCorrection === true ? Number.MAX_SAFE_INTEGER : 0);
    },
    __scrollToEnd() {
      this.__animScrollTo(this.rtlPosCorrection === true ? 0 : Number.MAX_SAFE_INTEGER);
    },
    __stopAnimScroll() {
      clearInterval(this.scrollTimer);
    },
    // used by children
    __onKbdNavigate(keyCode, fromEl) {
      const tabs = Array.prototype.filter.call(this.$refs.content.children, el => el === fromEl || el.matches && el.matches('.q-tab.q-focusable') === true);
      const len = tabs.length;
      if (len === 0) {
        return;
      }
      if (keyCode === 36) {
        // Home
        this.__scrollToTabEl(tabs[0]);
        tabs[0].focus();
        return true;
      }
      if (keyCode === 35) {
        // End
        this.__scrollToTabEl(tabs[len - 1]);
        tabs[len - 1].focus();
        return true;
      }
      const dirPrev = keyCode === (this.vertical === true ? 38 /* ArrowUp */ : 37 /* ArrowLeft */);
      const dirNext = keyCode === (this.vertical === true ? 40 /* ArrowDown */ : 39 /* ArrowRight */);
      const dir = dirPrev === true ? -1 : dirNext === true ? 1 : void 0;
      if (dir !== void 0) {
        const rtlDir = this.isRTL === true ? -1 : 1;
        const index = tabs.indexOf(fromEl) + dir * rtlDir;
        if (index >= 0 && index < len) {
          this.__scrollToTabEl(tabs[index]);
          tabs[index].focus({
            preventScroll: true
          });
        }
        return true;
      }
    },
    __scrollTowards(value) {
      const content = this.$refs.content,
        {
          get,
          set
        } = this.posFn;
      let done = false,
        pos = get(content);
      const direction = value < pos ? -1 : 1;
      pos += direction * 5;
      if (pos < 0) {
        done = true;
        pos = 0;
      } else if (direction === -1 && pos <= value || direction === 1 && pos >= value) {
        done = true;
        pos = value;
      }
      set(content, pos);
      this.__localUpdateArrows();
      return done;
    },
    // do not use directly; use __verifyRouteModel() instead
    __updateActiveRoute() {
      let name = null,
        bestScore = getDefaultBestScore();
      const vmList = this.tabVmList.filter(tab => tab.hasRouterLink === true);
      const vmLen = vmList.length;
      const {
        query: currentQuery
      } = this.$route;
      const currentQueryLen = Object.keys(currentQuery).length;
      for (let tabIndex = 0; tabIndex < vmLen; tabIndex++) {
        const tab = vmList[tabIndex];
        const exact = tab.exact === true;

        // if a) it doesn't respect the active/exact active status
        // or b) we already found an exact match and this one isn't set as exact
        // then we don't deal with it
        if (tab[exact === true ? 'linkIsExactActive' : 'linkIsActive'] !== true || bestScore.exact === true && exact !== true) {
          continue;
        }
        const {
          route,
          href
        } = tab.resolvedLink;
        const {
          matched,
          query,
          hash
        } = route;
        const redirected = route.redirectedFrom !== void 0;
        if (exact === true) {
          // hey, we found the perfect match; no more searching!
          if (redirected === false) {
            name = tab.name;
            break;
          }
          if (bestScore.exact === false) {
            // we reset values so we can discard previous non-exact matches
            // and so we can register this exact one below
            bestScore = getDefaultBestScore();
          }
        }

        // if best is non-redirected and this one is redirected
        // then this one is inferior so we don't care about it
        if (bestScore.redirected === false && redirected === true) {
          continue;
        }
        const queryLen = Object.keys(query).length;
        if (
        // if it's exact it already perfectly includes current query
        // so no point in computing it
        exact === false && queryLen !== 0 && hasQueryIncluded(query, currentQuery) === false) {
          // it has query and it doesn't includes the current one
          continue;
        }
        const newScore = {
          exact,
          redirected,
          matchedLen: matched.length,
          queryDiff: exact === true ? 0 // avoid computing as it's 0 anyway
          : currentQueryLen - queryLen,
          hrefLen: href.length - hash.length
        };
        if (newScore.matchedLen > bestScore.matchedLen) {
          // it matches more routes so it's more specific so we set it as current champion
          name = tab.name;
          bestScore = newScore;
          continue;
        } else if (newScore.matchedLen !== bestScore.matchedLen) {
          // it matches less routes than the current champion so we discard it
          continue;
        }
        if (newScore.queryDiff < bestScore.queryDiff) {
          // query is closer to the current one so we set it as current champion
          name = tab.name;
          bestScore = newScore;
          continue;
        } else if (newScore.queryDiff !== bestScore.queryDiff) {
          continue;
        }
        if (newScore.hrefLen > bestScore.hrefLen) {
          // href is lengthier so it's more specific so we set it as current champion
          name = tab.name;
          bestScore = newScore;
        }
      }
      if (name === null && this.tabVmList.some(tab => tab.hasRouterLink === void 0 && tab.name === this.currentModel) === true) {
        // we shouldn't interfere if non-route tab is active
        return;
      }
      this.__updateModel({
        name,
        setCurrent: true
      });
    },
    __onFocusin(e) {
      this.__removeFocusTimeout();
      if (this.hasFocus !== true && this.$el && e.target && typeof e.target.closest === 'function') {
        const tab = e.target.closest('.q-tab');

        // if the target is contained by a QTab/QRouteTab
        // (it might be other elements focused, like additional QBtn)
        if (tab && this.$el.contains(tab) === true) {
          this.hasFocus = true;
          if (this.scrollable === true) {
            this.__scrollToTabEl(tab);
          }
        }
      }
      this.qListeners.focusin !== void 0 && this.$emit('focusin', e);
    },
    __onFocusout(e) {
      this.__registerFocusTimeout(() => {
        this.hasFocus = false;
      }, 30);
      this.qListeners.focusout !== void 0 && this.$emit('focusout', e);
    },
    // used by children
    __verifyRouteModel() {
      if (this.avoidRouteWatcher === false) {
        this.__registerScrollToTabTimeout(this.__updateActiveRoute);
      } else {
        this.__removeScrollToTabTimeout();
      }
    },
    __watchRoute() {
      if (this.unwatchRoute === void 0) {
        const unwatch = this.$watch(() => this.$route.fullPath, this.__verifyRouteModel);
        this.unwatchRoute = () => {
          unwatch();
          this.unwatchRoute = void 0;
        };
      }
    },
    // used by children
    __registerTab(tabVm) {
      // we avoid setting tabVmList in data() as this would
      // make the whole vm reactive
      this.tabVmList.push(tabVm);
      // ...so we extract only the needed stuff out of it
      // into data() defined tabNameList
      this.tabNameList.push(injectProp({}, 'name', () => tabVm.name));
      this.__recalculateScroll();

      // if it's a QTab
      if (tabVm.hasRouterLink === void 0 || this.$route === void 0) {
        // we should position to the currently active tab (if any)
        this.__registerScrollToTabTimeout(() => {
          if (this.scrollable === true) {
            const value = this.currentModel;
            const newTab = value !== void 0 && value !== null && value !== '' ? this.tabVmList.find(tab => tab.name === value) : null;
            newTab && this.__scrollToTabEl(newTab.$el);
          }
        });
      }
      // else if it's a QRouteTab with a valid link
      else {
        this.__watchRoute();
        if (tabVm.hasRouterLink === true) {
          this.__verifyRouteModel();
        }
      }
    },
    // used by children
    __unregisterTab(tabVm) {
      const index = this.tabVmList.indexOf(tabVm);
      this.tabVmList.splice(index, 1);
      this.tabNameList.splice(index, 1);
      this.__recalculateScroll();

      // if we're watching route and this tab is a QRouteTab
      if (this.unwatchRoute !== void 0 && tabVm.hasRouterLink !== void 0) {
        // unwatch route if we don't have any QRouteTabs left
        if (this.tabVmList.every(tab => tab.hasRouterLink === void 0) === true) {
          this.unwatchRoute();
        }

        // then update model
        this.__verifyRouteModel();
      }
    },
    __cleanup() {
      clearTimeout(this.animateTimer);
      this.__stopAnimScroll();
      this.unwatchRoute !== void 0 && this.unwatchRoute();
    }
  },
  created() {
    this.__useTick('__registerScrollTick');
    this.__useTick('__registerUpdateArrowsTick');
    this.__useTick('__registerAnimateTick');
    this.__useTimeout('__registerFocusTimeout', '__removeFocusTimeout');
    this.__useTimeout('__registerScrollToTabTimeout', '__removeScrollToTabTimeout');
    Object.assign(this, {
      tabVmList: [],
      __localUpdateArrows: this.arrowsEnabled === true ? this.__updateArrowsFn : utils_event["g" /* noop */]
    });
  },
  activated() {
    this.hadRouteWatcher === true && this.__watchRoute();
    this.__recalculateScroll();
  },
  deactivated() {
    this.hadRouteWatcher = this.unwatchRoute !== void 0;
    this.__cleanup();
  },
  beforeDestroy() {
    this.__cleanup();
  },
  render(h) {
    const child = [h(QResizeObserver["a" /* default */], {
      on: Object(cache["b" /* default */])(this, 'resize', {
        resize: this.__updateContainer
      })
    }), h('div', {
      ref: 'content',
      class: this.innerClass,
      on: this.arrowsEnabled === true ? Object(cache["b" /* default */])(this, 'scroll', {
        scroll: this.__updateArrowsFn
      }) : void 0
    }, Object(private_slot["c" /* slot */])(this, 'default'))];
    this.arrowsEnabled === true && child.push(h(QIcon["a" /* default */], {
      class: 'q-tabs__arrow q-tabs__arrow--start absolute q-tab__icon' + (this.leftArrow === true ? '' : ' q-tabs__arrow--faded'),
      props: {
        name: this.leftIcon || this.$q.iconSet.tabs[this.vertical === true ? 'up' : 'left']
      },
      on: Object(cache["b" /* default */])(this, 'onS', {
        '&mousedown': this.__scrollToStart,
        '&touchstart': this.__scrollToStart,
        '&mouseup': this.__stopAnimScroll,
        '&mouseleave': this.__stopAnimScroll,
        '&touchend': this.__stopAnimScroll
      })
    }), h(QIcon["a" /* default */], {
      class: 'q-tabs__arrow q-tabs__arrow--end absolute q-tab__icon' + (this.rightArrow === true ? '' : ' q-tabs__arrow--faded'),
      props: {
        name: this.rightIcon || this.$q.iconSet.tabs[this.vertical === true ? 'down' : 'right']
      },
      on: Object(cache["b" /* default */])(this, 'onE', {
        '&mousedown': this.__scrollToEnd,
        '&touchstart': this.__scrollToEnd,
        '&mouseup': this.__stopAnimScroll,
        '&mouseleave': this.__stopAnimScroll,
        '&touchend': this.__stopAnimScroll
      })
    }));
    return h('div', {
      class: this.classes,
      on: this.onEvents,
      attrs: {
        role: 'tablist'
      }
    }, child);
  }
}));
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/key-composition.js
var key_composition = __webpack_require__("116d");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tabs/QTab.js









let id = 0;
/* harmony default export */ var QTab = (external_vue_default.a.extend({
  name: 'QTab',
  mixins: [ripple["a" /* default */], listeners["a" /* default */]],
  inject: {
    $tabs: {
      default() {
        console.error('QTab/QRouteTab components need to be child of QTabs');
      }
    }
  },
  props: {
    icon: String,
    label: [Number, String],
    alert: [Boolean, String],
    alertIcon: String,
    name: {
      type: [Number, String],
      default: () => `t_${id++}`
    },
    noCaps: Boolean,
    tabindex: [String, Number],
    disable: Boolean,
    contentClass: String
  },
  computed: {
    isActive() {
      return this.$tabs.currentModel === this.name;
    },
    classes() {
      return 'q-tab relative-position self-stretch flex flex-center text-center' + (this.isActive === true ? ' q-tab--active' + (this.$tabs.tabProps.activeClass ? ' ' + this.$tabs.tabProps.activeClass : '') + (this.$tabs.tabProps.activeColor ? ` text-${this.$tabs.tabProps.activeColor}` : '') + (this.$tabs.tabProps.activeBgColor ? ` bg-${this.$tabs.tabProps.activeBgColor}` : '') : ' q-tab--inactive') + (this.icon && this.label && this.$tabs.tabProps.inlineLabel === false ? ' q-tab--full' : '') + (this.noCaps === true || this.$tabs.tabProps.noCaps === true ? ' q-tab--no-caps' : '') + (this.disable === true ? ' disabled' : ' q-focusable q-hoverable cursor-pointer') + (this.hasRouterLinkProps !== void 0 ? this.linkClass : '');
    },
    innerClass() {
      return 'q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable ' + (this.$tabs.tabProps.inlineLabel === true ? 'row no-wrap q-tab__content--inline' : 'column') + (this.contentClass !== void 0 ? ` ${this.contentClass}` : '');
    },
    computedTabIndex() {
      return this.disable === true || this.$tabs.hasFocus === true || this.isActive === false && this.$tabs.hasActiveTab === true ? -1 : this.tabindex || 0;
    },
    computedRipple() {
      return this.ripple === false ? false : Object.assign({
        keyCodes: [13, 32],
        early: true
      }, this.ripple === true ? {} : this.ripple);
    },
    onEvents() {
      return {
        input: utils_event["k" /* stop */],
        ...this.qListeners,
        click: this.__onClick,
        keydown: this.__onKeydown
      };
    },
    attrs() {
      const attrs = {
        ...this.linkAttrs,
        tabindex: this.computedTabIndex,
        role: 'tab',
        'aria-selected': this.isActive === true ? 'true' : 'false'
      };
      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      }
      return attrs;
    }
  },
  methods: {
    __onClick(e, keyboard) {
      if (keyboard !== true && this.$refs.blurTarget !== void 0) {
        this.$refs.blurTarget.focus({
          preventScroll: true
        });
      }
      if (this.disable === true) {
        // we should hinder native navigation though
        this.hasRouterLink === true && Object(utils_event["l" /* stopAndPrevent */])(e);
        return;
      }

      // do we have a QTab?
      if (this.hasRouterLinkProps === void 0) {
        this.$tabs.__updateModel({
          name: this.name
        });
        this.qListeners.click !== void 0 && this.$emit('click', e);
        return;
      }
      if (this.hasRouterLink === true) {
        const go = (first, second, third) => {
          // for backwards compatibility
          const {
            to,
            replace,
            append,
            returnRouterError
          } = e.navigate === false ? {
            to: first,
            replace: second,
            append: third
          } : first || {};

          // if requiring to go to another route, then we
          // let the QTabs route watcher do its job,
          // otherwise directly select this
          let hardError;
          const reqId = to === void 0 || append === this.append && Object(is["b" /* isDeepEqual */])(to, this.to) === true ? this.$tabs.avoidRouteWatcher = Object(uid["a" /* default */])() : null;
          return this.__navigateToRouterLink(e, {
            to,
            replace,
            append,
            returnRouterError: true
          }).catch(err => {
            hardError = err;
          }).then(result => {
            if (reqId === this.$tabs.avoidRouteWatcher) {
              this.$tabs.avoidRouteWatcher = false;

              // if we don't have any hard errors, except for
              // when navigating to the same route (on all other errors,
              // like when navigation was aborted in a nav guard, we don't activate this tab)
              if (hardError === void 0 || hardError.message.startsWith('Avoided redundant navigation') === true) {
                this.$tabs.__updateModel({
                  name: this.name
                });
              }
            }
            return hardError !== void 0 && returnRouterError === true ? Promise.reject(hardError) : result;
          });
        };
        this.qListeners.click !== void 0 && this.$emit('click', e, go);

        // for backwards compatibility
        e.navigate === false && e.preventDefault();
        e.defaultPrevented !== true && go();
        return;
      }
      this.qListeners.click !== void 0 && this.$emit('click', e);
    },
    __onKeydown(e) {
      if (Object(key_composition["a" /* isKeyCode */])(e, [13, 32])) {
        this.__onClick(e, true);
      } else if (Object(key_composition["c" /* shouldIgnoreKey */])(e) !== true && e.keyCode >= 35 && e.keyCode <= 40 && e.altKey !== true && e.metaKey !== true) {
        this.$tabs.__onKbdNavigate(e.keyCode, this.$el) === true && Object(utils_event["l" /* stopAndPrevent */])(e);
      }
      this.qListeners.keydown !== void 0 && this.$emit('keydown', e);
    },
    __getContent(h) {
      const narrow = this.$tabs.tabProps.narrowIndicator,
        content = [],
        indicator = h('div', {
          ref: 'tabIndicator',
          staticClass: 'q-tab__indicator',
          class: this.$tabs.tabProps.indicatorClass
        });
      this.icon !== void 0 && content.push(h(QIcon["a" /* default */], {
        staticClass: 'q-tab__icon',
        props: {
          name: this.icon
        }
      }));
      this.label !== void 0 && content.push(h('div', {
        staticClass: 'q-tab__label'
      }, [this.label]));
      this.alert !== false && content.push(this.alertIcon !== void 0 ? h(QIcon["a" /* default */], {
        staticClass: 'q-tab__alert-icon',
        props: {
          color: this.alert !== true ? this.alert : void 0,
          name: this.alertIcon
        }
      }) : h('div', {
        staticClass: 'q-tab__alert',
        class: this.alert !== true ? `text-${this.alert}` : null
      }));
      narrow === true && content.push(indicator);
      const node = [h('div', {
        staticClass: 'q-focus-helper',
        attrs: {
          tabindex: -1
        },
        ref: 'blurTarget'
      }), h('div', {
        class: this.innerClass
      }, Object(private_slot["a" /* mergeSlot */])(content, this, 'default'))];
      narrow === false && node.push(indicator);
      return node;
    },
    __renderTab(h, tag) {
      const data = {
        class: this.classes,
        attrs: this.attrs,
        on: this.onEvents,
        directives: this.ripple === false || this.disable === true ? null : [{
          name: 'ripple',
          value: this.computedRipple
        }]
      };
      return h(tag, data, this.__getContent(h));
    }
  },
  mounted() {
    this.$tabs.__registerTab(this);
  },
  beforeDestroy() {
    this.$tabs.__unregisterTab(this);
  },
  render(h) {
    return this.__renderTab(h, 'div');
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tab-panels/QTabPanels.js



/* harmony default export */ var QTabPanels = (external_vue_default.a.extend({
  name: 'QTabPanels',
  mixins: [dark["a" /* default */], PanelParentMixin],
  computed: {
    classes() {
      return 'q-tab-panels q-panel-parent' + (this.isDark === true ? ' q-tab-panels--dark q-dark' : '');
    }
  },
  methods: {
    __renderPanels(h) {
      return h('div', {
        class: this.classes,
        directives: this.panelDirectives,
        on: {
          ...this.qListeners
        }
      }, this.__getPanelContent(h));
    }
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tab-panels/QTabPanel.js



const QTabPanel_attrs = {
  role: 'tabpanel'
};
/* harmony default export */ var QTabPanel = (external_vue_default.a.extend({
  name: 'QTabPanel',
  mixins: [PanelChildMixin],
  render(h) {
    return h('div', {
      staticClass: 'q-tab-panel',
      attrs: QTabPanel_attrs,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/color/QColor.js
















const palette = ['rgb(255,204,204)', 'rgb(255,230,204)', 'rgb(255,255,204)', 'rgb(204,255,204)', 'rgb(204,255,230)', 'rgb(204,255,255)', 'rgb(204,230,255)', 'rgb(204,204,255)', 'rgb(230,204,255)', 'rgb(255,204,255)', 'rgb(255,153,153)', 'rgb(255,204,153)', 'rgb(255,255,153)', 'rgb(153,255,153)', 'rgb(153,255,204)', 'rgb(153,255,255)', 'rgb(153,204,255)', 'rgb(153,153,255)', 'rgb(204,153,255)', 'rgb(255,153,255)', 'rgb(255,102,102)', 'rgb(255,179,102)', 'rgb(255,255,102)', 'rgb(102,255,102)', 'rgb(102,255,179)', 'rgb(102,255,255)', 'rgb(102,179,255)', 'rgb(102,102,255)', 'rgb(179,102,255)', 'rgb(255,102,255)', 'rgb(255,51,51)', 'rgb(255,153,51)', 'rgb(255,255,51)', 'rgb(51,255,51)', 'rgb(51,255,153)', 'rgb(51,255,255)', 'rgb(51,153,255)', 'rgb(51,51,255)', 'rgb(153,51,255)', 'rgb(255,51,255)', 'rgb(255,0,0)', 'rgb(255,128,0)', 'rgb(255,255,0)', 'rgb(0,255,0)', 'rgb(0,255,128)', 'rgb(0,255,255)', 'rgb(0,128,255)', 'rgb(0,0,255)', 'rgb(128,0,255)', 'rgb(255,0,255)', 'rgb(245,0,0)', 'rgb(245,123,0)', 'rgb(245,245,0)', 'rgb(0,245,0)', 'rgb(0,245,123)', 'rgb(0,245,245)', 'rgb(0,123,245)', 'rgb(0,0,245)', 'rgb(123,0,245)', 'rgb(245,0,245)', 'rgb(214,0,0)', 'rgb(214,108,0)', 'rgb(214,214,0)', 'rgb(0,214,0)', 'rgb(0,214,108)', 'rgb(0,214,214)', 'rgb(0,108,214)', 'rgb(0,0,214)', 'rgb(108,0,214)', 'rgb(214,0,214)', 'rgb(163,0,0)', 'rgb(163,82,0)', 'rgb(163,163,0)', 'rgb(0,163,0)', 'rgb(0,163,82)', 'rgb(0,163,163)', 'rgb(0,82,163)', 'rgb(0,0,163)', 'rgb(82,0,163)', 'rgb(163,0,163)', 'rgb(92,0,0)', 'rgb(92,46,0)', 'rgb(92,92,0)', 'rgb(0,92,0)', 'rgb(0,92,46)', 'rgb(0,92,92)', 'rgb(0,46,92)', 'rgb(0,0,92)', 'rgb(46,0,92)', 'rgb(92,0,92)', 'rgb(255,255,255)', 'rgb(205,205,205)', 'rgb(178,178,178)', 'rgb(153,153,153)', 'rgb(127,127,127)', 'rgb(102,102,102)', 'rgb(76,76,76)', 'rgb(51,51,51)', 'rgb(25,25,25)', 'rgb(0,0,0)'];
const thumbPath = 'M5 5 h10 v10 h-10 v-10 z';
const alphaTrackImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==';
/* harmony default export */ var QColor = (external_vue_default.a.extend({
  name: 'QColor',
  mixins: [listeners["a" /* default */], dark["a" /* default */], mixins_form["b" /* default */]],
  directives: {
    TouchPan: TouchPan["a" /* default */]
  },
  props: {
    value: String,
    defaultValue: String,
    defaultView: {
      type: String,
      default: 'spectrum',
      validator: v => ['spectrum', 'tune', 'palette'].includes(v)
    },
    formatModel: {
      type: String,
      default: 'auto',
      validator: v => ['auto', 'hex', 'rgb', 'hexa', 'rgba'].includes(v)
    },
    palette: Array,
    noHeader: Boolean,
    noHeaderTabs: Boolean,
    noFooter: Boolean,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    disable: Boolean,
    readonly: Boolean
  },
  data() {
    return {
      topView: this.formatModel === 'auto' ? this.value === void 0 || this.value === null || this.value === '' || this.value.startsWith('#') ? 'hex' : 'rgb' : this.formatModel.startsWith('hex') ? 'hex' : 'rgb',
      view: this.defaultView,
      model: this.__parseModel(this.value || this.defaultValue)
    };
  },
  watch: {
    value(v) {
      const model = this.__parseModel(v || this.defaultValue);
      if (model.hex !== this.model.hex) {
        this.model = model;
      }
    },
    defaultValue(v) {
      if (!this.value && v) {
        const model = this.__parseModel(v);
        if (model.hex !== this.model.hex) {
          this.model = model;
        }
      }
    }
  },
  computed: {
    editable() {
      return this.disable !== true && this.readonly !== true;
    },
    forceHex() {
      return this.formatModel === 'auto' ? null : this.formatModel.indexOf('hex') > -1;
    },
    forceAlpha() {
      return this.formatModel === 'auto' ? null : this.formatModel.indexOf('a') > -1;
    },
    isHex() {
      return this.value === void 0 || this.value === null || this.value === '' || this.value.startsWith('#');
    },
    isOutputHex() {
      return this.forceHex !== null ? this.forceHex : this.isHex;
    },
    formAttrs() {
      return {
        type: 'hidden',
        name: this.name,
        value: this.model[this.isOutputHex === true ? 'hex' : 'rgb']
      };
    },
    hasAlpha() {
      if (this.forceAlpha !== null) {
        return this.forceAlpha;
      }
      return this.model.a !== void 0;
    },
    currentBgColor() {
      return {
        backgroundColor: this.model.rgb || '#000'
      };
    },
    headerClass() {
      const light = this.model.a !== void 0 && this.model.a < 65 ? true : Object(colors["d" /* luminosity */])(this.model) > 0.4;
      return `q-color-picker__header-content--${light ? 'light' : 'dark'}`;
    },
    spectrumStyle() {
      return {
        background: `hsl(${this.model.h},100%,50%)`
      };
    },
    spectrumPointerStyle() {
      return {
        top: `${100 - this.model.v}%`,
        [this.$q.lang.rtl === true ? 'right' : 'left']: `${this.model.s}%`
      };
    },
    computedPalette() {
      return this.palette !== void 0 && this.palette.length > 0 ? this.palette : palette;
    },
    classes() {
      return 'q-color-picker' + (this.bordered === true ? ' q-color-picker--bordered' : '') + (this.square === true ? ' q-color-picker--square no-border-radius' : '') + (this.flat === true ? ' q-color-picker--flat no-shadow' : '') + (this.disable === true ? ' disabled' : '') + (this.isDark === true ? ' q-color-picker--dark q-dark' : '');
    },
    attrs() {
      if (this.disable === true) {
        return {
          'aria-disabled': 'true'
        };
      }
      if (this.readonly === true) {
        return {
          'aria-readonly': 'true'
        };
      }
    }
  },
  created() {
    this.__spectrumChange = Object(throttle["a" /* default */])(this.__spectrumChange, 20);
  },
  render(h) {
    const child = [this.__getContent(h)];
    if (this.name !== void 0 && this.disable !== true) {
      this.__injectFormInput(child, 'push');
    }
    this.noHeader !== true && child.unshift(this.__getHeader(h));
    this.noFooter !== true && child.push(this.__getFooter(h));
    return h('div', {
      class: this.classes,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, child);
  },
  methods: {
    __getHeader(h) {
      const child = [];
      this.noHeaderTabs !== true && child.push(h(QTabs, {
        class: 'q-color-picker__header-tabs',
        props: {
          value: this.topView,
          dense: true,
          align: 'justify'
        },
        on: Object(cache["b" /* default */])(this, 'topVTab', {
          input: val => {
            this.topView = val;
          }
        })
      }, [h(QTab, {
        props: {
          label: 'HEX' + (this.hasAlpha === true ? 'A' : ''),
          name: 'hex',
          ripple: false
        }
      }), h(QTab, {
        props: {
          label: 'RGB' + (this.hasAlpha === true ? 'A' : ''),
          name: 'rgb',
          ripple: false
        }
      })]));
      child.push(h('div', {
        staticClass: 'q-color-picker__header-banner row flex-center no-wrap'
      }, [h('input', {
        staticClass: 'fit',
        domProps: {
          value: this.model[this.topView]
        },
        attrs: this.editable !== true ? {
          readonly: true
        } : null,
        on: Object(cache["b" /* default */])(this, 'topIn', {
          input: evt => {
            this.__updateErrorIcon(this.__onEditorChange(evt) === true);
          },
          change: utils_event["k" /* stop */],
          blur: evt => {
            this.__onEditorChange(evt, true) === true && this.$forceUpdate();
            this.__updateErrorIcon(false);
          }
        })
      }), h(QIcon["a" /* default */], {
        ref: 'errorIcon',
        staticClass: 'q-color-picker__error-icon absolute no-pointer-events',
        props: {
          name: this.$q.iconSet.type.negative
        }
      })]));
      return h('div', {
        staticClass: 'q-color-picker__header relative-position overflow-hidden'
      }, [h('div', {
        staticClass: 'q-color-picker__header-bg absolute-full'
      }), h('div', {
        staticClass: 'q-color-picker__header-content',
        class: this.headerClass,
        style: this.currentBgColor
      }, child)]);
    },
    __getContent(h) {
      return h(QTabPanels, {
        props: {
          value: this.view,
          animated: true
        }
      }, [h(QTabPanel, {
        staticClass: 'q-color-picker__spectrum-tab overflow-hidden',
        props: {
          name: 'spectrum'
        }
      }, this.__getSpectrumTab(h)), h(QTabPanel, {
        staticClass: 'q-pa-md q-color-picker__tune-tab',
        props: {
          name: 'tune'
        }
      }, this.__getTuneTab(h)), h(QTabPanel, {
        staticClass: 'q-color-picker__palette-tab',
        props: {
          name: 'palette'
        }
      }, this.__getPaletteTab(h))]);
    },
    __getFooter(h) {
      return h('div', {
        staticClass: 'q-color-picker__footer relative-position overflow-hidden'
      }, [h(QTabs, {
        staticClass: 'absolute-full',
        props: {
          value: this.view,
          dense: true,
          align: 'justify'
        },
        on: Object(cache["b" /* default */])(this, 'ftIn', {
          input: val => {
            this.view = val;
          }
        })
      }, [h(QTab, {
        props: {
          icon: this.$q.iconSet.colorPicker.spectrum,
          name: 'spectrum',
          ripple: false
        }
      }), h(QTab, {
        props: {
          icon: this.$q.iconSet.colorPicker.tune,
          name: 'tune',
          ripple: false
        }
      }), h(QTab, {
        props: {
          icon: this.$q.iconSet.colorPicker.palette,
          name: 'palette',
          ripple: false
        }
      })])]);
    },
    __getSpectrumTab(h) {
      return [h('div', {
        ref: 'spectrum',
        staticClass: 'q-color-picker__spectrum non-selectable relative-position cursor-pointer',
        style: this.spectrumStyle,
        class: {
          readonly: this.editable !== true
        },
        on: this.editable === true ? Object(cache["b" /* default */])(this, 'spectrT', {
          click: this.__spectrumClick,
          mousedown: this.__activate
        }) : null,
        directives: this.editable === true ? Object(cache["b" /* default */])(this, 'spectrDir', [{
          name: 'touch-pan',
          modifiers: {
            prevent: true,
            stop: true,
            mouse: true
          },
          value: this.__spectrumPan
        }]) : null
      }, [h('div', {
        style: {
          paddingBottom: '100%'
        }
      }), h('div', {
        staticClass: 'q-color-picker__spectrum-white absolute-full'
      }), h('div', {
        staticClass: 'q-color-picker__spectrum-black absolute-full'
      }), h('div', {
        staticClass: 'absolute',
        style: this.spectrumPointerStyle
      }, [this.model.hex !== void 0 ? h('div', {
        staticClass: 'q-color-picker__spectrum-circle'
      }) : null])]), h('div', {
        staticClass: 'q-color-picker__sliders'
      }, [h(QSlider, {
        staticClass: 'q-color-picker__hue non-selectable',
        props: {
          value: this.model.h,
          min: 0,
          max: 360,
          trackSize: '8px',
          innerTrackColor: 'transparent',
          selectionColor: 'transparent',
          readonly: this.editable !== true,
          thumbPath
        },
        on: Object(cache["b" /* default */])(this, 'hueSlide', {
          input: this.__onHueChange,
          change: val => this.__onHueChange(val, true)
        })
      }), this.hasAlpha === true ? h(QSlider, {
        staticClass: 'q-color-picker__alpha non-selectable',
        props: {
          value: this.model.a,
          min: 0,
          max: 100,
          trackSize: '8px',
          trackColor: 'white',
          innerTrackColor: 'transparent',
          selectionColor: 'transparent',
          trackImg: alphaTrackImg,
          readonly: this.editable !== true,
          hideSelection: true,
          thumbPath
        },
        on: Object(cache["b" /* default */])(this, 'alphaSlide', {
          input: value => this.__onNumericChange(value, 'a', 100),
          change: value => this.__onNumericChange(value, 'a', 100, void 0, true)
        })
      }) : null])];
    },
    __getTuneTab(h) {
      const attrs = {
        inputmode: 'numeric',
        maxlength: 3,
        readonly: this.editable !== true
      };
      return [h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['R']), h(QSlider, {
        props: {
          value: this.model.r,
          min: 0,
          max: 255,
          color: 'red',
          dark: this.isDark,
          readonly: this.editable !== true
        },
        on: Object(cache["b" /* default */])(this, 'rSlide', {
          input: value => this.__onNumericChange(value, 'r', 255),
          change: value => this.__onNumericChange(value, 'r', 255, void 0, true)
        })
      }), h('input', {
        domProps: {
          value: this.model.r
        },
        attrs,
        on: Object(cache["b" /* default */])(this, 'rIn', {
          input: evt => this.__onNumericChange(evt.target.value, 'r', 255, evt),
          change: utils_event["k" /* stop */],
          blur: evt => this.__onNumericChange(evt.target.value, 'r', 255, evt, true)
        })
      })]), h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['G']), h(QSlider, {
        props: {
          value: this.model.g,
          min: 0,
          max: 255,
          color: 'green',
          dark: this.isDark,
          readonly: this.editable !== true
        },
        on: Object(cache["b" /* default */])(this, 'gSlide', {
          input: value => this.__onNumericChange(value, 'g', 255),
          change: value => this.__onNumericChange(value, 'g', 255, void 0, true)
        })
      }), h('input', {
        domProps: {
          value: this.model.g
        },
        attrs,
        on: Object(cache["b" /* default */])(this, 'gIn', {
          input: evt => this.__onNumericChange(evt.target.value, 'g', 255, evt),
          change: utils_event["k" /* stop */],
          blur: evt => this.__onNumericChange(evt.target.value, 'g', 255, evt, true)
        })
      })]), h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['B']), h(QSlider, {
        props: {
          value: this.model.b,
          min: 0,
          max: 255,
          color: 'blue',
          readonly: this.editable !== true,
          dark: this.isDark
        },
        on: Object(cache["b" /* default */])(this, 'bSlide', {
          input: value => this.__onNumericChange(value, 'b', 255),
          change: value => this.__onNumericChange(value, 'b', 255, void 0, true)
        })
      }), h('input', {
        domProps: {
          value: this.model.b
        },
        attrs,
        on: Object(cache["b" /* default */])(this, 'bIn', {
          input: evt => this.__onNumericChange(evt.target.value, 'b', 255, evt),
          change: utils_event["k" /* stop */],
          blur: evt => this.__onNumericChange(evt.target.value, 'b', 255, evt, true)
        })
      })]), this.hasAlpha === true ? h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['A']), h(QSlider, {
        props: {
          value: this.model.a,
          color: 'grey',
          readonly: this.editable !== true,
          dark: this.isDark
        },
        on: Object(cache["b" /* default */])(this, 'aSlide', {
          input: value => this.__onNumericChange(value, 'a', 100),
          change: value => this.__onNumericChange(value, 'a', 100, void 0, true)
        })
      }), h('input', {
        domProps: {
          value: this.model.a
        },
        attrs,
        on: Object(cache["b" /* default */])(this, 'aIn', {
          input: evt => this.__onNumericChange(evt.target.value, 'a', 100, evt),
          change: utils_event["k" /* stop */],
          blur: evt => this.__onNumericChange(evt.target.value, 'a', 100, evt, true)
        })
      })]) : null];
    },
    __getPaletteTab(h) {
      return [h('div', {
        staticClass: 'row items-center q-color-picker__palette-rows',
        class: this.editable === true ? 'q-color-picker__palette-rows--editable' : ''
      }, this.computedPalette.map(color => h('div', {
        staticClass: 'q-color-picker__cube col-auto',
        style: {
          backgroundColor: color
        },
        on: this.editable === true ? Object(cache["b" /* default */])(this, 'palette#' + color, {
          click: () => {
            this.__onPalettePick(color);
          }
        }) : null
      })))];
    },
    __onSpectrumChange(left, top, change) {
      const panel = this.$refs.spectrum;
      if (panel === void 0) {
        return;
      }
      const width = panel.clientWidth,
        height = panel.clientHeight,
        rect = panel.getBoundingClientRect();
      let x = Math.min(width, Math.max(0, left - rect.left));
      if (this.$q.lang.rtl === true) {
        x = width - x;
      }
      const y = Math.min(height, Math.max(0, top - rect.top)),
        s = Math.round(100 * x / width),
        v = Math.round(100 * Math.max(0, Math.min(1, -(y / height) + 1))),
        rgb = Object(colors["c" /* hsvToRgb */])({
          h: this.model.h,
          s,
          v,
          a: this.hasAlpha === true ? this.model.a : void 0
        });
      this.model.s = s;
      this.model.v = v;
      this.__update(rgb, change);
    },
    __onHueChange(h, change) {
      h = Math.round(h);
      const rgb = Object(colors["c" /* hsvToRgb */])({
        h,
        s: this.model.s,
        v: this.model.v,
        a: this.hasAlpha === true ? this.model.a : void 0
      });
      this.model.h = h;
      this.__update(rgb, change);
    },
    __onNumericChange(value, formatModel, max, evt, change) {
      evt !== void 0 && Object(utils_event["k" /* stop */])(evt);
      if (!/^[0-9]+$/.test(value)) {
        change === true && this.$forceUpdate();
        return;
      }
      const val = Math.floor(Number(value));
      if (val < 0 || val > max) {
        change === true && this.$forceUpdate();
        return;
      }
      const rgb = {
        r: formatModel === 'r' ? val : this.model.r,
        g: formatModel === 'g' ? val : this.model.g,
        b: formatModel === 'b' ? val : this.model.b,
        a: this.hasAlpha === true ? formatModel === 'a' ? val : this.model.a : void 0
      };
      if (formatModel !== 'a') {
        const hsv = Object(colors["f" /* rgbToHsv */])(rgb);
        this.model.h = hsv.h;
        this.model.s = hsv.s;
        this.model.v = hsv.v;
      }
      this.__update(rgb, change);
      if (evt !== void 0 && change !== true && evt.target.selectionEnd !== void 0) {
        const index = evt.target.selectionEnd;
        this.$nextTick(() => {
          evt.target.setSelectionRange(index, index);
        });
      }
    },
    __onEditorChange(evt, change) {
      let rgb;
      const inp = evt.target.value;
      Object(utils_event["k" /* stop */])(evt);
      if (this.topView === 'hex') {
        if (inp.length !== (this.hasAlpha === true ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(inp)) {
          return true;
        }
        rgb = Object(colors["b" /* hexToRgb */])(inp);
      } else {
        let model;
        if (!inp.endsWith(')')) {
          return true;
        } else if (this.hasAlpha !== true && inp.startsWith('rgb(')) {
          model = inp.substring(4, inp.length - 1).split(',').map(n => parseInt(n, 10));
          if (model.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(inp)) {
            return true;
          }
        } else if (this.hasAlpha === true && inp.startsWith('rgba(')) {
          model = inp.substring(5, inp.length - 1).split(',');
          if (model.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(inp)) {
            return true;
          }
          for (let i = 0; i < 3; i++) {
            const v = parseInt(model[i], 10);
            if (v < 0 || v > 255) {
              return true;
            }
            model[i] = v;
          }
          const v = parseFloat(model[3]);
          if (v < 0 || v > 1) {
            return true;
          }
          model[3] = v;
        } else {
          return true;
        }
        if (model[0] < 0 || model[0] > 255 || model[1] < 0 || model[1] > 255 || model[2] < 0 || model[2] > 255 || this.hasAlpha === true && (model[3] < 0 || model[3] > 1)) {
          return true;
        }
        rgb = {
          r: model[0],
          g: model[1],
          b: model[2],
          a: this.hasAlpha === true ? model[3] * 100 : void 0
        };
      }
      const hsv = Object(colors["f" /* rgbToHsv */])(rgb);
      this.model.h = hsv.h;
      this.model.s = hsv.s;
      this.model.v = hsv.v;
      this.__update(rgb, change);
      if (change !== true) {
        const index = evt.target.selectionEnd;
        this.$nextTick(() => {
          evt.target.setSelectionRange(index, index);
        });
      }
    },
    __onPalettePick(color) {
      const def = this.__parseModel(color);
      const rgb = {
        r: def.r,
        g: def.g,
        b: def.b,
        a: def.a
      };
      if (rgb.a === void 0) {
        rgb.a = this.model.a;
      }
      this.model.h = def.h;
      this.model.s = def.s;
      this.model.v = def.v;
      this.__update(rgb, true);
    },
    __update(rgb, change) {
      // update internally
      this.model.hex = Object(colors["e" /* rgbToHex */])(rgb);
      this.model.rgb = Object(colors["g" /* rgbToString */])(rgb);
      this.model.r = rgb.r;
      this.model.g = rgb.g;
      this.model.b = rgb.b;
      this.model.a = rgb.a;
      const value = this.model[this.isOutputHex === true ? 'hex' : 'rgb'];

      // emit new value
      this.$emit('input', value);
      change === true && this.$emit('change', value);
    },
    __updateErrorIcon(val) {
      // we MUST avoid vue triggering a render,
      // so manually changing this
      if (this.$refs.errorIcon !== void 0) {
        this.$refs.errorIcon.$el.style.opacity = val ? 1 : 0;
      }
    },
    __parseModel(v) {
      const forceAlpha = this.forceAlpha !== void 0 ? this.forceAlpha : this.formatModel === 'auto' ? null : this.formatModel.indexOf('a') > -1;
      if (typeof v !== 'string' || v.length === 0 || patterns["a" /* testPattern */].anyColor(v.replace(/ /g, '')) !== true) {
        return {
          h: 0,
          s: 0,
          v: 0,
          r: 0,
          g: 0,
          b: 0,
          a: forceAlpha === true ? 100 : void 0,
          hex: void 0,
          rgb: void 0
        };
      }
      const model = Object(colors["i" /* textToRgb */])(v);
      if (forceAlpha === true && model.a === void 0) {
        model.a = 100;
      }
      model.hex = Object(colors["e" /* rgbToHex */])(model);
      model.rgb = Object(colors["g" /* rgbToString */])(model);
      return Object.assign(model, Object(colors["f" /* rgbToHsv */])(model));
    },
    __spectrumPan(evt) {
      if (evt.isFinal) {
        this.__onSpectrumChange(evt.position.left, evt.position.top, true);
      } else {
        this.__spectrumChange(evt);
      }
    },
    // throttled in created()
    __spectrumChange(evt) {
      this.__onSpectrumChange(evt.position.left, evt.position.top);
    },
    __spectrumClick(evt) {
      this.__onSpectrumChange(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset, true);
    },
    __activate(evt) {
      this.__onSpectrumChange(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset);
    }
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/color/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/private/date-persian.js
// taken from https://github.com/jalaali/jalaali-js

/*
  Jalaali years starting the 33-year rule.
*/
const breaks = [-61, 9, 38, 199, 426, 686, 756, 818, 1111, 1181, 1210, 1635, 2060, 2097, 2192, 2262, 2324, 2394, 2456, 3178];

/*
  Converts a Gregorian date to Jalaali.
*/
function toJalaali(gy, gm, gd) {
  if (Object.prototype.toString.call(gy) === '[object Date]') {
    gd = gy.getDate();
    gm = gy.getMonth() + 1;
    gy = gy.getFullYear();
  }
  return d2j(g2d(gy, gm, gd));
}

/*
  Converts a Jalaali date to Gregorian.
*/
function toGregorian(jy, jm, jd) {
  return d2g(j2d(jy, jm, jd));
}

/*
  Checks whether a Jalaali date is valid or not.
*/
function isValidJalaaliDate(jy, jm, jd) {
  return jy >= -61 && jy <= 3177 && jm >= 1 && jm <= 12 && jd >= 1 && jd <= jalaaliMonthLength(jy, jm);
}

/*
  Is this a leap year or not?
*/
function isLeapJalaaliYear(jy) {
  return jalCalLeap(jy) === 0;
}

/*
  Number of days in a given month in a Jalaali year.
*/
function jalaaliMonthLength(jy, jm) {
  if (jm <= 6) return 31;
  if (jm <= 11) return 30;
  if (isLeapJalaaliYear(jy)) return 30;
  return 29;
}

/*
    This function determines if the Jalaali (Persian) year is
    leap (366-day long) or is the common year (365 days)

    @param jy Jalaali calendar year (-61 to 3177)
    @returns number of years since the last leap year (0 to 4)
 */
function jalCalLeap(jy) {
  const bl = breaks.length;
  let jp = breaks[0],
    jm,
    jump,
    leap,
    n,
    i;
  if (jy < jp || jy >= breaks[bl - 1]) {
    throw new Error('Invalid Jalaali year ' + jy);
  }
  for (i = 1; i < bl; i += 1) {
    jm = breaks[i];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    jp = jm;
  }
  n = jy - jp;
  if (jump - n < 6) {
    n = n - jump + div(jump + 4, 33) * 33;
  }
  leap = date_persian_mod(date_persian_mod(n + 1, 33) - 1, 4);
  if (leap === -1) {
    leap = 4;
  }
  return leap;
}

/*
  This function determines if the Jalaali (Persian) year is
  leap (366-day long) or is the common year (365 days), and
  finds the day in March (Gregorian calendar) of the first
  day of the Jalaali year (jy).

  @param jy Jalaali calendar year (-61 to 3177)
  @param withoutLeap when don't need leap (true or false) default is false
  @return
    leap: number of years since the last leap year (0 to 4)
    gy: Gregorian year of the beginning of Jalaali year
    march: the March day of Farvardin the 1st (1st day of jy)
  @see: http://www.astro.uni.torun.pl/~kb/Papers/EMP/PersianC-EMP.htm
  @see: http://www.fourmilab.ch/documents/calendar/
*/
function jalCal(jy, withoutLeap) {
  const bl = breaks.length,
    gy = jy + 621;
  let leapJ = -14,
    jp = breaks[0],
    jm,
    jump,
    leap,
    n,
    i;
  if (jy < jp || jy >= breaks[bl - 1]) {
    throw new Error('Invalid Jalaali year ' + jy);
  }

  // Find the limiting years for the Jalaali year jy.
  for (i = 1; i < bl; i += 1) {
    jm = breaks[i];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    leapJ = leapJ + div(jump, 33) * 8 + div(date_persian_mod(jump, 33), 4);
    jp = jm;
  }
  n = jy - jp;

  // Find the number of leap years from AD 621 to the beginning
  // of the current Jalaali year in the Persian calendar.
  leapJ = leapJ + div(n, 33) * 8 + div(date_persian_mod(n, 33) + 3, 4);
  if (date_persian_mod(jump, 33) === 4 && jump - n === 4) {
    leapJ += 1;
  }

  // And the same in the Gregorian calendar (until the year gy).
  const leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;

  // Determine the Gregorian date of Farvardin the 1st.
  const march = 20 + leapJ - leapG;

  // Find how many years have passed since the last leap year.
  if (!withoutLeap) {
    if (jump - n < 6) {
      n = n - jump + div(jump + 4, 33) * 33;
    }
    leap = date_persian_mod(date_persian_mod(n + 1, 33) - 1, 4);
    if (leap === -1) {
      leap = 4;
    }
  }
  return {
    leap: leap,
    gy: gy,
    march: march
  };
}

/*
  Converts a date of the Jalaali calendar to the Julian Day number.

  @param jy Jalaali year (1 to 3100)
  @param jm Jalaali month (1 to 12)
  @param jd Jalaali day (1 to 29/31)
  @return Julian Day number
*/
function j2d(jy, jm, jd) {
  const r = jalCal(jy, true);
  return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1;
}

/*
  Converts the Julian Day number to a date in the Jalaali calendar.

  @param jdn Julian Day number
  @return
    jy: Jalaali year (1 to 3100)
    jm: Jalaali month (1 to 12)
    jd: Jalaali day (1 to 29/31)
*/
function d2j(jdn) {
  const gy = d2g(jdn).gy; // Calculate Gregorian year (gy).
  let jy = gy - 621,
    jd,
    jm,
    k;
  const r = jalCal(jy, false),
    jdn1f = g2d(gy, 3, r.march);

  // Find number of days that passed since 1 Farvardin.
  k = jdn - jdn1f;
  if (k >= 0) {
    if (k <= 185) {
      // The first 6 months.
      jm = 1 + div(k, 31);
      jd = date_persian_mod(k, 31) + 1;
      return {
        jy: jy,
        jm: jm,
        jd: jd
      };
    } else {
      // The remaining months.
      k -= 186;
    }
  } else {
    // Previous Jalaali year.
    jy -= 1;
    k += 179;
    if (r.leap === 1) {
      k += 1;
    }
  }
  jm = 7 + div(k, 30);
  jd = date_persian_mod(k, 30) + 1;
  return {
    jy: jy,
    jm: jm,
    jd: jd
  };
}

/*
  Calculates the Julian Day number from Gregorian or Julian
  calendar dates. This integer number corresponds to the noon of
  the date (i.e. 12 hours of Universal Time).
  The procedure was tested to be good since 1 March, -100100 (of both
  calendars) up to a few million years into the future.

  @param gy Calendar year (years BC numbered 0, -1, -2, ...)
  @param gm Calendar month (1 to 12)
  @param gd Calendar day of the month (1 to 28/29/30/31)
  @return Julian Day number
*/
function g2d(gy, gm, gd) {
  let d = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * date_persian_mod(gm + 9, 12) + 2, 5) + gd - 34840408;
  d = d - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752;
  return d;
}

/*
  Calculates Gregorian and Julian calendar dates from the Julian Day number
  (jdn) for the period since jdn=-34839655 (i.e. the year -100100 of both
  calendars) to some millions years ahead of the present.

  @param jdn Julian Day number
  @return
    gy: Calendar year (years BC numbered 0, -1, -2, ...)
    gm: Calendar month (1 to 12)
    gd: Calendar day of the month M (1 to 28/29/30/31)
*/
function d2g(jdn) {
  let j = 4 * jdn + 139361631;
  j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
  const i = div(date_persian_mod(j, 1461), 4) * 5 + 308,
    gd = div(date_persian_mod(i, 153), 5) + 1,
    gm = date_persian_mod(div(i, 153), 12) + 1,
    gy = div(j, 1461) - 100100 + div(8 - gm, 6);
  return {
    gy: gy,
    gm: gm,
    gd: gd
  };
}

/*
  Utility helper functions.
*/

function div(a, b) {
  return ~~(a / b);
}
function date_persian_mod(a, b) {
  return a - ~~(a / b) * b;
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/mixins/datetime.js





const calendars = ['gregorian', 'persian'];
/* harmony default export */ var datetime = ({
  mixins: [dark["a" /* default */], mixins_form["b" /* default */], listeners["a" /* default */]],
  props: {
    value: {
      required: true
    },
    mask: {
      type: String
    },
    locale: Object,
    calendar: {
      type: String,
      validator: v => calendars.includes(v),
      default: 'gregorian'
    },
    landscape: Boolean,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    readonly: Boolean,
    disable: Boolean
  },
  computed: {
    computedMask() {
      return this.__getMask();
    },
    computedLocale() {
      return this.__getLocale();
    },
    editable() {
      return this.disable !== true && this.readonly !== true;
    },
    computedColor() {
      return this.color || 'primary';
    },
    computedTextColor() {
      return this.textColor || 'white';
    },
    computedTabindex() {
      return this.editable === true ? 0 : -1;
    },
    headerClass() {
      const cls = [];
      this.color !== void 0 && cls.push(`bg-${this.color}`);
      this.textColor !== void 0 && cls.push(`text-${this.textColor}`);
      return cls.join(' ');
    }
  },
  methods: {
    __getLocale() {
      return this.locale !== void 0 ? {
        ...this.$q.lang.date,
        ...this.locale
      } : this.$q.lang.date;
    },
    __getCurrentDate(dateOnly) {
      const d = new Date();
      const timeFill = dateOnly === true ? null : 0;
      if (this.calendar === 'persian') {
        const jDate = toJalaali(d);
        return {
          year: jDate.jy,
          month: jDate.jm,
          day: jDate.jd
        };
      }
      return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate(),
        hour: timeFill,
        minute: timeFill,
        second: timeFill,
        millisecond: timeFill
      };
    },
    __getCurrentTime() {
      const d = new Date();
      return {
        hour: d.getHours(),
        minute: d.getMinutes(),
        second: d.getSeconds(),
        millisecond: d.getMilliseconds()
      };
    },
    __getDayHash(date) {
      return date.year + '/' + Object(format["e" /* pad */])(date.month) + '/' + Object(format["e" /* pad */])(date.day);
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/date.js
/* eslint no-fallthrough: 0 */





const MILLISECONDS_IN_DAY = 86400000,
  MILLISECONDS_IN_HOUR = 3600000,
  MILLISECONDS_IN_MINUTE = 60000,
  defaultMask = 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  token = /\[((?:[^\]\\]|\\]|\\)*)\]|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g,
  reverseToken = /(\[[^\]]*\])|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g,
  regexStore = {};
function getRegexData(mask, dateLocale) {
  const days = '(' + dateLocale.days.join('|') + ')',
    key = mask + days;
  if (regexStore[key] !== void 0) {
    return regexStore[key];
  }
  const daysShort = '(' + dateLocale.daysShort.join('|') + ')',
    months = '(' + dateLocale.months.join('|') + ')',
    monthsShort = '(' + dateLocale.monthsShort.join('|') + ')';
  const map = {};
  let index = 0;
  const regexText = mask.replace(reverseToken, match => {
    index++;
    switch (match) {
      case 'YY':
        map.YY = index;
        return '(-?\\d{1,2})';
      case 'YYYY':
        map.YYYY = index;
        return '(-?\\d{1,4})';
      case 'M':
        map.M = index;
        return '(\\d{1,2})';
      case 'MM':
        map.M = index; // bumping to M
        return '(\\d{2})';
      case 'MMM':
        map.MMM = index;
        return monthsShort;
      case 'MMMM':
        map.MMMM = index;
        return months;
      case 'D':
        map.D = index;
        return '(\\d{1,2})';
      case 'Do':
        map.D = index++; // bumping to D
        return '(\\d{1,2}(st|nd|rd|th))';
      case 'DD':
        map.D = index; // bumping to D
        return '(\\d{2})';
      case 'H':
        map.H = index;
        return '(\\d{1,2})';
      case 'HH':
        map.H = index; // bumping to H
        return '(\\d{2})';
      case 'h':
        map.h = index;
        return '(\\d{1,2})';
      case 'hh':
        map.h = index; // bumping to h
        return '(\\d{2})';
      case 'm':
        map.m = index;
        return '(\\d{1,2})';
      case 'mm':
        map.m = index; // bumping to m
        return '(\\d{2})';
      case 's':
        map.s = index;
        return '(\\d{1,2})';
      case 'ss':
        map.s = index; // bumping to s
        return '(\\d{2})';
      case 'S':
        map.S = index;
        return '(\\d{1})';
      case 'SS':
        map.S = index; // bump to S
        return '(\\d{2})';
      case 'SSS':
        map.S = index; // bump to S
        return '(\\d{3})';
      case 'A':
        map.A = index;
        return '(AM|PM)';
      case 'a':
        map.a = index;
        return '(am|pm)';
      case 'aa':
        map.aa = index;
        return '(a\\.m\\.|p\\.m\\.)';
      case 'ddd':
        return daysShort;
      case 'dddd':
        return days;
      case 'Q':
      case 'd':
      case 'E':
        return '(\\d{1})';
      case 'Qo':
        return '(1st|2nd|3rd|4th)';
      case 'DDD':
      case 'DDDD':
        return '(\\d{1,3})';
      case 'w':
        return '(\\d{1,2})';
      case 'ww':
        return '(\\d{2})';
      case 'Z':
        // to split: (?:(Z)()()|([+-])?(\\d{2}):?(\\d{2}))
        map.Z = index;
        return '(Z|[+-]\\d{2}:\\d{2})';
      case 'ZZ':
        map.ZZ = index;
        return '(Z|[+-]\\d{2}\\d{2})';
      case 'X':
        map.X = index;
        return '(-?\\d+)';
      case 'x':
        map.x = index;
        return '(-?\\d{4,})';
      default:
        index--;
        if (match[0] === '[') {
          match = match.substring(1, match.length - 1);
        }
        return match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  });
  const res = {
    map,
    regex: new RegExp('^' + regexText)
  };
  regexStore[key] = res;
  return res;
}
function getDateLocale(paramDateLocale, langProps) {
  return paramDateLocale !== void 0 ? paramDateLocale : langProps !== void 0 ? langProps.date : lang["b" /* defaultLang */].date;
}
function formatTimezone(offset, delimeter = '') {
  const sign = offset > 0 ? '-' : '+',
    absOffset = Math.abs(offset),
    hours = Math.floor(absOffset / 60),
    minutes = absOffset % 60;
  return sign + Object(format["e" /* pad */])(hours) + delimeter + Object(format["e" /* pad */])(minutes);
}
function applyYearMonthDayChange(date, mod, sign) {
  let year = date.getFullYear(),
    month = date.getMonth();
  const day = date.getDate();
  if (mod.year !== void 0) {
    year += sign * mod.year;
    delete mod.year;
  }
  if (mod.month !== void 0) {
    month += sign * mod.month;
    delete mod.month;
  }
  date.setDate(1);
  date.setMonth(2);
  date.setFullYear(year);
  date.setMonth(month);
  date.setDate(Math.min(day, daysInMonth(date)));
  if (mod.date !== void 0) {
    date.setDate(date.getDate() + sign * mod.date);
    delete mod.date;
  }
  return date;
}
function applyYearMonthDay(date, mod, middle) {
  const year = mod.year !== void 0 ? mod.year : date[`get${middle}FullYear`](),
    month = mod.month !== void 0 ? mod.month - 1 : date[`get${middle}Month`](),
    maxDay = new Date(year, month + 1, 0).getDate(),
    day = Math.min(maxDay, mod.date !== void 0 ? mod.date : date[`get${middle}Date`]());
  date[`set${middle}Date`](1);
  date[`set${middle}Month`](2);
  date[`set${middle}FullYear`](year);
  date[`set${middle}Month`](month);
  date[`set${middle}Date`](day);
  delete mod.year;
  delete mod.month;
  delete mod.date;
  return date;
}
function getChange(date, rawMod, sign) {
  const mod = normalizeMod(rawMod),
    d = new Date(date),
    t = mod.year !== void 0 || mod.month !== void 0 || mod.date !== void 0 ? applyYearMonthDayChange(d, mod, sign) // removes year/month/day
    : d;
  for (const key in mod) {
    const op = Object(format["b" /* capitalize */])(key);
    t[`set${op}`](t[`get${op}`]() + sign * mod[key]);
  }
  return t;
}
function normalizeMod(mod) {
  const acc = {
    ...mod
  };
  if (mod.years !== void 0) {
    acc.year = mod.years;
    delete acc.years;
  }
  if (mod.months !== void 0) {
    acc.month = mod.months;
    delete acc.months;
  }
  if (mod.days !== void 0) {
    acc.date = mod.days;
    delete acc.days;
  }
  if (mod.day !== void 0) {
    acc.date = mod.day;
    delete acc.day;
  }
  if (mod.hour !== void 0) {
    acc.hours = mod.hour;
    delete acc.hour;
  }
  if (mod.minute !== void 0) {
    acc.minutes = mod.minute;
    delete acc.minute;
  }
  if (mod.second !== void 0) {
    acc.seconds = mod.second;
    delete acc.second;
  }
  if (mod.millisecond !== void 0) {
    acc.milliseconds = mod.millisecond;
    delete acc.millisecond;
  }
  return acc;
}
function adjustDate(date, rawMod, utc) {
  const mod = normalizeMod(rawMod),
    middle = utc === true ? 'UTC' : '',
    d = new Date(date),
    t = mod.year !== void 0 || mod.month !== void 0 || mod.date !== void 0 ? applyYearMonthDay(d, mod, middle) // removes year/month/day
    : d;
  for (const key in mod) {
    const op = key.charAt(0).toUpperCase() + key.slice(1);
    t[`set${middle}${op}`](mod[key]);
  }
  return t;
}
function extractDate(str, mask, dateLocale) {
  const d = __splitDate(str, mask, dateLocale);
  const date = new Date(d.year, d.month === null ? null : d.month - 1, d.day === null ? 1 : d.day, d.hour, d.minute, d.second, d.millisecond);
  const tzOffset = date.getTimezoneOffset();
  return d.timezoneOffset === null || d.timezoneOffset === tzOffset ? date : getChange(date, {
    minutes: d.timezoneOffset - tzOffset
  }, 1);
}
function __splitDate(str, mask, dateLocale, calendar, defaultModel) {
  const date = {
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
    second: null,
    millisecond: null,
    timezoneOffset: null,
    dateHash: null,
    timeHash: null
  };
  defaultModel !== void 0 && Object.assign(date, defaultModel);
  if (str === void 0 || str === null || str === '' || typeof str !== 'string') {
    return date;
  }
  if (mask === void 0) {
    mask = defaultMask;
  }
  const langOpts = getDateLocale(dateLocale, lang["a" /* default */].props),
    months = langOpts.months,
    monthsShort = langOpts.monthsShort;
  const {
    regex,
    map
  } = getRegexData(mask, langOpts);
  const match = str.match(regex);
  if (match === null) {
    return date;
  }
  let tzString = '';
  if (map.X !== void 0 || map.x !== void 0) {
    const stamp = parseInt(match[map.X !== void 0 ? map.X : map.x], 10);
    if (isNaN(stamp) === true || stamp < 0) {
      return date;
    }
    const d = new Date(stamp * (map.X !== void 0 ? 1000 : 1));
    date.year = d.getFullYear();
    date.month = d.getMonth() + 1;
    date.day = d.getDate();
    date.hour = d.getHours();
    date.minute = d.getMinutes();
    date.second = d.getSeconds();
    date.millisecond = d.getMilliseconds();
  } else {
    if (map.YYYY !== void 0) {
      date.year = parseInt(match[map.YYYY], 10);
    } else if (map.YY !== void 0) {
      const y = parseInt(match[map.YY], 10);
      date.year = y < 0 ? y : 2000 + y;
    }
    if (map.M !== void 0) {
      date.month = parseInt(match[map.M], 10);
      if (date.month < 1 || date.month > 12) {
        return date;
      }
    } else if (map.MMM !== void 0) {
      date.month = monthsShort.indexOf(match[map.MMM]) + 1;
    } else if (map.MMMM !== void 0) {
      date.month = months.indexOf(match[map.MMMM]) + 1;
    }
    if (map.D !== void 0) {
      date.day = parseInt(match[map.D], 10);
      if (date.year === null || date.month === null || date.day < 1) {
        return date;
      }
      const maxDay = calendar !== 'persian' ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
      if (date.day > maxDay) {
        return date;
      }
    }
    if (map.H !== void 0) {
      date.hour = parseInt(match[map.H], 10) % 24;
    } else if (map.h !== void 0) {
      date.hour = parseInt(match[map.h], 10) % 12;
      if (map.A && match[map.A] === 'PM' || map.a && match[map.a] === 'pm' || map.aa && match[map.aa] === 'p.m.') {
        date.hour += 12;
      }
      date.hour = date.hour % 24;
    }
    if (map.m !== void 0) {
      date.minute = parseInt(match[map.m], 10) % 60;
    }
    if (map.s !== void 0) {
      date.second = parseInt(match[map.s], 10) % 60;
    }
    if (map.S !== void 0) {
      date.millisecond = parseInt(match[map.S], 10) * 10 ** (3 - match[map.S].length);
    }
    if (map.Z !== void 0 || map.ZZ !== void 0) {
      tzString = map.Z !== void 0 ? match[map.Z].replace(':', '') : match[map.ZZ];
      date.timezoneOffset = (tzString[0] === '+' ? -1 : 1) * (60 * tzString.slice(1, 3) + 1 * tzString.slice(3, 5));
    }
  }
  date.dateHash = Object(format["e" /* pad */])(date.year, 6) + '/' + Object(format["e" /* pad */])(date.month) + '/' + Object(format["e" /* pad */])(date.day);
  date.timeHash = Object(format["e" /* pad */])(date.hour) + ':' + Object(format["e" /* pad */])(date.minute) + ':' + Object(format["e" /* pad */])(date.second) + tzString;
  return date;
}
function isValid(date) {
  return typeof date === 'number' ? true : isNaN(Date.parse(date)) === false;
}
function buildDate(mod, utc) {
  return adjustDate(new Date(), mod, utc);
}
function getDayOfWeek(date) {
  const dow = new Date(date).getDay();
  return dow === 0 ? 7 : dow;
}
function getWeekOfYear(date) {
  // Remove time components of date
  const thursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  // Change date to Thursday same week
  thursday.setDate(thursday.getDate() - (thursday.getDay() + 6) % 7 + 3);

  // Take January 4th as it is always in week 1 (see ISO 8601)
  const firstThursday = new Date(thursday.getFullYear(), 0, 4);

  // Change date to Thursday same week
  firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);

  // Check if daylight-saving-time-switch occurred and correct for it
  const ds = thursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  thursday.setHours(thursday.getHours() - ds);

  // Number of weeks between target Thursday and first Thursday
  const weekDiff = (thursday - firstThursday) / (MILLISECONDS_IN_DAY * 7);
  return 1 + Math.floor(weekDiff);
}
function getDayIdentifier(date) {
  return date.getFullYear() * 10000 + date.getMonth() * 100 + date.getDate();
}
function getDateIdentifier(date, onlyDate /* = false */) {
  const d = new Date(date);
  return onlyDate === true ? getDayIdentifier(d) : d.getTime();
}
function isBetweenDates(date, from, to, opts = {}) {
  const d1 = getDateIdentifier(from, opts.onlyDate),
    d2 = getDateIdentifier(to, opts.onlyDate),
    cur = getDateIdentifier(date, opts.onlyDate);
  return (cur > d1 || opts.inclusiveFrom === true && cur === d1) && (cur < d2 || opts.inclusiveTo === true && cur === d2);
}
function addToDate(date, mod) {
  return getChange(date, mod, 1);
}
function subtractFromDate(date, mod) {
  return getChange(date, mod, -1);
}
function startOfDate(date, unit, utc) {
  const t = new Date(date),
    prefix = `set${utc === true ? 'UTC' : ''}`;
  switch (unit) {
    case 'year':
    case 'years':
      t[`${prefix}Month`](0);
    case 'month':
    case 'months':
      t[`${prefix}Date`](1);
    case 'day':
    case 'days':
    case 'date':
      t[`${prefix}Hours`](0);
    case 'hour':
    case 'hours':
      t[`${prefix}Minutes`](0);
    case 'minute':
    case 'minutes':
      t[`${prefix}Seconds`](0);
    case 'second':
    case 'seconds':
      t[`${prefix}Milliseconds`](0);
  }
  return t;
}
function endOfDate(date, unit, utc) {
  const t = new Date(date),
    prefix = `set${utc === true ? 'UTC' : ''}`;
  switch (unit) {
    case 'year':
    case 'years':
      t[`${prefix}Month`](11);
    case 'month':
    case 'months':
      t[`${prefix}Date`](daysInMonth(t));
    case 'day':
    case 'days':
    case 'date':
      t[`${prefix}Hours`](23);
    case 'hour':
    case 'hours':
      t[`${prefix}Minutes`](59);
    case 'minute':
    case 'minutes':
      t[`${prefix}Seconds`](59);
    case 'second':
    case 'seconds':
      t[`${prefix}Milliseconds`](999);
  }
  return t;
}
function getMaxDate(date /* , ...args */) {
  let t = new Date(date);
  Array.prototype.slice.call(arguments, 1).forEach(d => {
    t = Math.max(t, new Date(d));
  });
  return t;
}
function getMinDate(date /*, ...args */) {
  let t = new Date(date);
  Array.prototype.slice.call(arguments, 1).forEach(d => {
    t = Math.min(t, new Date(d));
  });
  return t;
}
function getDiff(t, sub, interval) {
  return (t.getTime() - t.getTimezoneOffset() * MILLISECONDS_IN_MINUTE - (sub.getTime() - sub.getTimezoneOffset() * MILLISECONDS_IN_MINUTE)) / interval;
}
function getDateDiff(date, subtract, unit = 'days') {
  const t = new Date(date),
    sub = new Date(subtract);
  switch (unit) {
    case 'years':
    case 'year':
      return t.getFullYear() - sub.getFullYear();
    case 'months':
    case 'month':
      return (t.getFullYear() - sub.getFullYear()) * 12 + t.getMonth() - sub.getMonth();
    case 'days':
    case 'day':
    case 'date':
      return getDiff(startOfDate(t, 'day'), startOfDate(sub, 'day'), MILLISECONDS_IN_DAY);
    case 'hours':
    case 'hour':
      return getDiff(startOfDate(t, 'hour'), startOfDate(sub, 'hour'), MILLISECONDS_IN_HOUR);
    case 'minutes':
    case 'minute':
      return getDiff(startOfDate(t, 'minute'), startOfDate(sub, 'minute'), MILLISECONDS_IN_MINUTE);
    case 'seconds':
    case 'second':
      return getDiff(startOfDate(t, 'second'), startOfDate(sub, 'second'), 1000);
  }
}
function getDayOfYear(date) {
  return getDateDiff(date, startOfDate(date, 'year'), 'days') + 1;
}
function inferDateFormat(date) {
  return Object(is["a" /* isDate */])(date) === true ? 'date' : typeof date === 'number' ? 'number' : 'string';
}
function getDateBetween(date, min, max) {
  const t = new Date(date);
  if (min) {
    const low = new Date(min);
    if (t < low) {
      return low;
    }
  }
  if (max) {
    const high = new Date(max);
    if (t > high) {
      return high;
    }
  }
  return t;
}
function isSameDate(date, date2, unit) {
  const t = new Date(date),
    d = new Date(date2);
  if (unit === void 0) {
    return t.getTime() === d.getTime();
  }
  switch (unit) {
    case 'second':
    case 'seconds':
      if (t.getSeconds() !== d.getSeconds()) {
        return false;
      }
    case 'minute': // intentional fall-through
    case 'minutes':
      if (t.getMinutes() !== d.getMinutes()) {
        return false;
      }
    case 'hour': // intentional fall-through
    case 'hours':
      if (t.getHours() !== d.getHours()) {
        return false;
      }
    case 'day': // intentional fall-through
    case 'days':
    case 'date':
      if (t.getDate() !== d.getDate()) {
        return false;
      }
    case 'month': // intentional fall-through
    case 'months':
      if (t.getMonth() !== d.getMonth()) {
        return false;
      }
    case 'year': // intentional fall-through
    case 'years':
      if (t.getFullYear() !== d.getFullYear()) {
        return false;
      }
      break;
    default:
      throw new Error(`date isSameDate unknown unit ${unit}`);
  }
  return true;
}
function daysInMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}
function getOrdinal(n) {
  if (n >= 11 && n <= 13) {
    return `${n}th`;
  }
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
  }
  return `${n}th`;
}
const formatter = {
  // Year: 00, 01, ..., 99
  YY(date, _, forcedYear) {
    // workaround for < 1900 with new Date()
    const y = this.YYYY(date, _, forcedYear) % 100;
    return y >= 0 ? Object(format["e" /* pad */])(y) : '-' + Object(format["e" /* pad */])(Math.abs(y));
  },
  // Year: 1900, 1901, ..., 2099
  YYYY(date, _, forcedYear) {
    // workaround for < 1900 with new Date()
    return forcedYear !== void 0 && forcedYear !== null ? forcedYear : date.getFullYear();
  },
  // Month: 1, 2, ..., 12
  M(date) {
    return date.getMonth() + 1;
  },
  // Month: 01, 02, ..., 12
  MM(date) {
    return Object(format["e" /* pad */])(date.getMonth() + 1);
  },
  // Month Short Name: Jan, Feb, ...
  MMM(date, dateLocale) {
    return dateLocale.monthsShort[date.getMonth()];
  },
  // Month Name: January, February, ...
  MMMM(date, dateLocale) {
    return dateLocale.months[date.getMonth()];
  },
  // Quarter: 1, 2, 3, 4
  Q(date) {
    return Math.ceil((date.getMonth() + 1) / 3);
  },
  // Quarter: 1st, 2nd, 3rd, 4th
  Qo(date) {
    return getOrdinal(this.Q(date));
  },
  // Day of month: 1, 2, ..., 31
  D(date) {
    return date.getDate();
  },
  // Day of month: 1st, 2nd, ..., 31st
  Do(date) {
    return getOrdinal(date.getDate());
  },
  // Day of month: 01, 02, ..., 31
  DD(date) {
    return Object(format["e" /* pad */])(date.getDate());
  },
  // Day of year: 1, 2, ..., 366
  DDD(date) {
    return getDayOfYear(date);
  },
  // Day of year: 001, 002, ..., 366
  DDDD(date) {
    return Object(format["e" /* pad */])(getDayOfYear(date), 3);
  },
  // Day of week: 0, 1, ..., 6
  d(date) {
    return date.getDay();
  },
  // Day of week: Su, Mo, ...
  dd(date, dateLocale) {
    return this.dddd(date, dateLocale).slice(0, 2);
  },
  // Day of week: Sun, Mon, ...
  ddd(date, dateLocale) {
    return dateLocale.daysShort[date.getDay()];
  },
  // Day of week: Sunday, Monday, ...
  dddd(date, dateLocale) {
    return dateLocale.days[date.getDay()];
  },
  // Day of ISO week: 1, 2, ..., 7
  E(date) {
    return date.getDay() || 7;
  },
  // Week of Year: 1 2 ... 52 53
  w(date) {
    return getWeekOfYear(date);
  },
  // Week of Year: 01 02 ... 52 53
  ww(date) {
    return Object(format["e" /* pad */])(getWeekOfYear(date));
  },
  // Hour: 0, 1, ... 23
  H(date) {
    return date.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH(date) {
    return Object(format["e" /* pad */])(date.getHours());
  },
  // Hour: 1, 2, ..., 12
  h(date) {
    const hours = date.getHours();
    if (hours === 0) {
      return 12;
    }
    if (hours > 12) {
      return hours % 12;
    }
    return hours;
  },
  // Hour: 01, 02, ..., 12
  hh(date) {
    return Object(format["e" /* pad */])(this.h(date));
  },
  // Minute: 0, 1, ..., 59
  m(date) {
    return date.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm(date) {
    return Object(format["e" /* pad */])(date.getMinutes());
  },
  // Second: 0, 1, ..., 59
  s(date) {
    return date.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss(date) {
    return Object(format["e" /* pad */])(date.getSeconds());
  },
  // 1/10 of second: 0, 1, ..., 9
  S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS(date) {
    return Object(format["e" /* pad */])(Math.floor(date.getMilliseconds() / 10));
  },
  // Millisecond: 000, 001, ..., 999
  SSS(date) {
    return Object(format["e" /* pad */])(date.getMilliseconds(), 3);
  },
  // Meridiem: AM, PM
  A(date) {
    return this.H(date) < 12 ? 'AM' : 'PM';
  },
  // Meridiem: am, pm
  a(date) {
    return this.H(date) < 12 ? 'am' : 'pm';
  },
  // Meridiem: a.m., p.m.
  aa(date) {
    return this.H(date) < 12 ? 'a.m.' : 'p.m.';
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z(date, dateLocale, forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone(tzOffset, ':');
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ(date, dateLocale, forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone(tzOffset);
  },
  // Seconds timestamp: 512969520
  X(date) {
    return Math.floor(date.getTime() / 1000);
  },
  // Milliseconds timestamp: 512969520900
  x(date) {
    return date.getTime();
  }
};
function formatDate(val, mask, dateLocale, __forcedYear, __forcedTimezoneOffset) {
  if (val !== 0 && !val || val === Infinity || val === -Infinity) {
    return;
  }
  const date = new Date(val);
  if (isNaN(date)) {
    return;
  }
  if (mask === void 0) {
    mask = defaultMask;
  }
  const locale = getDateLocale(dateLocale, lang["a" /* default */].props);
  return mask.replace(token, (match, text) => match in formatter ? formatter[match](date, locale, __forcedYear, __forcedTimezoneOffset) : text === void 0 ? match : text.split('\\]').join(']'));
}
function clone(date) {
  return Object(is["a" /* isDate */])(date) === true ? new Date(date.getTime()) : date;
}
/* harmony default export */ var utils_date = ({
  isValid,
  extractDate,
  buildDate,
  getDayOfWeek,
  getWeekOfYear,
  isBetweenDates,
  addToDate,
  subtractFromDate,
  adjustDate,
  startOfDate,
  endOfDate,
  getMaxDate,
  getMinDate,
  getDateDiff,
  getDayOfYear,
  inferDateFormat,
  getDateBetween,
  isSameDate,
  daysInMonth,
  formatDate,
  clone
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/date/QDate.js









const yearsInterval = 20;
const views = ['Calendar', 'Years', 'Months'];
const viewIsValid = v => views.includes(v);
const yearMonthValidator = v => /^-?[\d]+\/[0-1]\d$/.test(v);
const lineStr = ' \u2014 ';
/* harmony default export */ var QDate = (external_vue_default.a.extend({
  name: 'QDate',
  mixins: [datetime],
  props: {
    multiple: Boolean,
    range: Boolean,
    title: String,
    subtitle: String,
    mask: {
      // this mask is forced
      // when using persian calendar
      default: 'YYYY/MM/DD'
    },
    defaultYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    yearsInMonthView: Boolean,
    events: [Array, Function],
    eventColor: [String, Function],
    emitImmediately: Boolean,
    options: [Array, Function],
    navigationMinYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    navigationMaxYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    noUnset: Boolean,
    firstDayOfWeek: [String, Number],
    todayBtn: Boolean,
    minimal: Boolean,
    defaultView: {
      type: String,
      default: 'Calendar',
      validator: viewIsValid
    }
  },
  data() {
    const innerMask = this.__getMask(),
      innerLocale = this.__getLocale(),
      viewModel = this.__getViewModel(innerMask, innerLocale),
      year = viewModel.year,
      direction = this.$q.lang.rtl === true ? 'right' : 'left';
    return {
      view: this.defaultView,
      monthDirection: direction,
      yearDirection: direction,
      startYear: year - year % yearsInterval - (year < 0 ? yearsInterval : 0),
      editRange: void 0,
      innerMask,
      innerLocale,
      viewModel // model of current calendar view
    };
  },
  watch: {
    value(v) {
      if (this.lastEmitValue === v) {
        this.lastEmitValue = 0;
      } else {
        const model = this.__getViewModel(this.innerMask, this.innerLocale);
        this.__updateViewModel(model.year, model.month, model);
      }
    },
    view() {
      if (this.$refs.blurTarget !== void 0 && this.$el.contains(document.activeElement) === true) {
        this.$refs.blurTarget.focus();
      }
    },
    'viewModel.year'(year) {
      this.$emit('navigation', {
        year,
        month: this.viewModel.month
      });
    },
    'viewModel.month'(month) {
      this.$emit('navigation', {
        year: this.viewModel.year,
        month
      });
    },
    computedMask(val) {
      this.__updateValue(val, this.innerLocale, 'mask');
      this.innerMask = val;
    },
    computedLocale(val) {
      this.__updateValue(this.innerMask, val, 'locale');
      this.innerLocale = val;
    }
  },
  computed: {
    classes() {
      const type = this.landscape === true ? 'landscape' : 'portrait';
      return `q-date q-date--${type} q-date--${type}-${this.minimal === true ? 'minimal' : 'standard'}` + (this.isDark === true ? ' q-date--dark q-dark' : '') + (this.bordered === true ? ' q-date--bordered' : '') + (this.square === true ? ' q-date--square no-border-radius' : '') + (this.flat === true ? ' q-date--flat no-shadow' : '') + (this.disable === true ? ' disabled' : this.readonly === true ? ' q-date--readonly' : '');
    },
    isImmediate() {
      return this.emitImmediately === true && this.multiple !== true && this.range !== true;
    },
    normalizedModel() {
      return Array.isArray(this.value) === true ? this.value : this.value !== null && this.value !== void 0 ? [this.value] : [];
    },
    daysModel() {
      return this.normalizedModel.filter(date => typeof date === 'string').map(date => this.__decodeString(date, this.innerMask, this.innerLocale)).filter(date => date.dateHash !== null && date.day !== null && date.month !== null && date.year !== null);
    },
    rangeModel() {
      const fn = date => this.__decodeString(date, this.innerMask, this.innerLocale);
      return this.normalizedModel.filter(date => Object(is["d" /* isObject */])(date) === true && date.from !== void 0 && date.to !== void 0).map(range => ({
        from: fn(range.from),
        to: fn(range.to)
      })).filter(range => range.from.dateHash !== null && range.to.dateHash !== null && range.from.dateHash < range.to.dateHash);
    },
    getNativeDateFn() {
      return this.calendar !== 'persian' ? model => new Date(model.year, model.month - 1, model.day) : model => {
        const gDate = toGregorian(model.year, model.month, model.day);
        return new Date(gDate.gy, gDate.gm - 1, gDate.gd);
      };
    },
    encodeObjectFn() {
      return this.calendar === 'persian' ? this.__getDayHash : (date, mask, locale) => formatDate(new Date(date.year, date.month - 1, date.day, date.hour, date.minute, date.second, date.millisecond), mask === void 0 ? this.innerMask : mask, locale === void 0 ? this.innerLocale : locale, date.year, date.timezoneOffset);
    },
    daysInModel() {
      return this.daysModel.length + this.rangeModel.reduce((acc, range) => acc + 1 + getDateDiff(this.getNativeDateFn(range.to), this.getNativeDateFn(range.from)), 0);
    },
    headerTitle() {
      if (this.title !== void 0 && this.title !== null && this.title.length > 0) {
        return this.title;
      }
      if (this.editRange !== void 0) {
        const model = this.editRange.init;
        const date = this.getNativeDateFn(model);
        return this.innerLocale.daysShort[date.getDay()] + ', ' + this.innerLocale.monthsShort[model.month - 1] + ' ' + model.day + lineStr + '?';
      }
      if (this.daysInModel === 0) {
        return lineStr;
      }
      if (this.daysInModel > 1) {
        return `${this.daysInModel} ${this.innerLocale.pluralDay}`;
      }
      const model = this.daysModel[0];
      const date = this.getNativeDateFn(model);
      if (isNaN(date.valueOf()) === true) {
        return lineStr;
      }
      if (this.innerLocale.headerTitle !== void 0) {
        return this.innerLocale.headerTitle(date, model);
      }
      return this.innerLocale.daysShort[date.getDay()] + ', ' + this.innerLocale.monthsShort[model.month - 1] + ' ' + model.day;
    },
    headerSubtitle() {
      if (this.subtitle !== void 0 && this.subtitle !== null && this.subtitle.length > 0) {
        return this.subtitle;
      }
      if (this.daysInModel === 0) {
        return lineStr;
      }
      if (this.daysInModel > 1) {
        const from = this.minSelectedModel;
        const to = this.maxSelectedModel;
        const month = this.innerLocale.monthsShort;
        return month[from.month - 1] + (from.year !== to.year ? ' ' + from.year + lineStr + month[to.month - 1] + ' ' : from.month !== to.month ? lineStr + month[to.month - 1] : '') + ' ' + to.year;
      }
      return this.daysModel[0].year;
    },
    minSelectedModel() {
      const model = this.daysModel.concat(this.rangeModel.map(range => range.from)).sort((a, b) => a.year - b.year || a.month - b.month);
      return model[0];
    },
    maxSelectedModel() {
      const model = this.daysModel.concat(this.rangeModel.map(range => range.to)).sort((a, b) => b.year - a.year || b.month - a.month);
      return model[0];
    },
    dateArrow() {
      const val = [this.$q.iconSet.datetime.arrowLeft, this.$q.iconSet.datetime.arrowRight];
      return this.$q.lang.rtl === true ? val.reverse() : val;
    },
    computedFirstDayOfWeek() {
      return this.firstDayOfWeek !== void 0 ? Number(this.firstDayOfWeek) : this.innerLocale.firstDayOfWeek;
    },
    daysOfWeek() {
      const days = this.innerLocale.daysShort,
        first = this.computedFirstDayOfWeek;
      return first > 0 ? days.slice(first, 7).concat(days.slice(0, first)) : days;
    },
    daysInMonth() {
      const date = this.viewModel;
      return this.calendar !== 'persian' ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
    },
    today() {
      return this.__getCurrentDate();
    },
    evtColor() {
      return typeof this.eventColor === 'function' ? this.eventColor : () => this.eventColor;
    },
    minNav() {
      if (this.navigationMinYearMonth !== void 0) {
        const data = this.navigationMinYearMonth.split('/');
        return {
          year: parseInt(data[0], 10),
          month: parseInt(data[1], 10)
        };
      }
    },
    maxNav() {
      if (this.navigationMaxYearMonth !== void 0) {
        const data = this.navigationMaxYearMonth.split('/');
        return {
          year: parseInt(data[0], 10),
          month: parseInt(data[1], 10)
        };
      }
    },
    navBoundaries() {
      const data = {
        month: {
          prev: true,
          next: true
        },
        year: {
          prev: true,
          next: true
        }
      };
      if (this.minNav !== void 0 && this.minNav.year >= this.viewModel.year) {
        data.year.prev = false;
        if (this.minNav.year === this.viewModel.year && this.minNav.month >= this.viewModel.month) {
          data.month.prev = false;
        }
      }
      if (this.maxNav !== void 0 && this.maxNav.year <= this.viewModel.year) {
        data.year.next = false;
        if (this.maxNav.year === this.viewModel.year && this.maxNav.month <= this.viewModel.month) {
          data.month.next = false;
        }
      }
      return data;
    },
    daysMap() {
      const map = {};
      this.daysModel.forEach(entry => {
        const hash = this.__getMonthHash(entry);
        if (map[hash] === void 0) {
          map[hash] = [];
        }
        map[hash].push(entry.day);
      });
      return map;
    },
    rangeMap() {
      const map = {};
      this.rangeModel.forEach(entry => {
        const hashFrom = this.__getMonthHash(entry.from);
        const hashTo = this.__getMonthHash(entry.to);
        if (map[hashFrom] === void 0) {
          map[hashFrom] = [];
        }
        map[hashFrom].push({
          from: entry.from.day,
          to: hashFrom === hashTo ? entry.to.day : void 0,
          range: entry
        });
        if (hashFrom < hashTo) {
          let hash;
          const {
            year,
            month
          } = entry.from;
          const cur = month < 12 ? {
            year,
            month: month + 1
          } : {
            year: year + 1,
            month: 1
          };
          while ((hash = this.__getMonthHash(cur)) <= hashTo) {
            if (map[hash] === void 0) {
              map[hash] = [];
            }
            map[hash].push({
              from: void 0,
              to: hash === hashTo ? entry.to.day : void 0,
              range: entry
            });
            cur.month++;
            if (cur.month > 12) {
              cur.year++;
              cur.month = 1;
            }
          }
        }
      });
      return map;
    },
    rangeView() {
      if (this.editRange === void 0) {
        return;
      }
      const {
        init,
        initHash,
        final,
        finalHash
      } = this.editRange;
      const [from, to] = initHash <= finalHash ? [init, final] : [final, init];
      const fromHash = this.__getMonthHash(from);
      const toHash = this.__getMonthHash(to);
      if (fromHash !== this.viewMonthHash && toHash !== this.viewMonthHash) {
        return;
      }
      const view = {};
      if (fromHash === this.viewMonthHash) {
        view.from = from.day;
        view.includeFrom = true;
      } else {
        view.from = 1;
      }
      if (toHash === this.viewMonthHash) {
        view.to = to.day;
        view.includeTo = true;
      } else {
        view.to = this.daysInMonth;
      }
      return view;
    },
    viewMonthHash() {
      return this.__getMonthHash(this.viewModel);
    },
    selectionDaysMap() {
      const map = {};
      if (this.options === void 0) {
        for (let i = 1; i <= this.daysInMonth; i++) {
          map[i] = true;
        }
        return map;
      }
      const fn = typeof this.options === 'function' ? this.options : date => this.options.includes(date);
      for (let i = 1; i <= this.daysInMonth; i++) {
        const dayHash = this.viewMonthHash + '/' + Object(format["e" /* pad */])(i);
        map[i] = fn(dayHash);
      }
      return map;
    },
    eventDaysMap() {
      const map = {};
      if (this.events === void 0) {
        for (let i = 1; i <= this.daysInMonth; i++) {
          map[i] = false;
        }
      } else {
        const fn = typeof this.events === 'function' ? this.events : date => this.events.includes(date);
        for (let i = 1; i <= this.daysInMonth; i++) {
          const dayHash = this.viewMonthHash + '/' + Object(format["e" /* pad */])(i);
          map[i] = fn(dayHash) === true && this.evtColor(dayHash);
        }
      }
      return map;
    },
    viewDays() {
      let date, endDay;
      const {
        year,
        month
      } = this.viewModel;
      if (this.calendar !== 'persian') {
        date = new Date(year, month - 1, 1);
        endDay = new Date(year, month - 1, 0).getDate();
      } else {
        const gDate = toGregorian(year, month, 1);
        date = new Date(gDate.gy, gDate.gm - 1, gDate.gd);
        let prevJM = month - 1;
        let prevJY = year;
        if (prevJM === 0) {
          prevJM = 12;
          prevJY--;
        }
        endDay = jalaaliMonthLength(prevJY, prevJM);
      }
      return {
        days: date.getDay() - this.computedFirstDayOfWeek - 1,
        endDay
      };
    },
    days() {
      const res = [];
      const {
        days,
        endDay
      } = this.viewDays;
      const len = days < 0 ? days + 7 : days;
      if (len < 6) {
        for (let i = endDay - len; i <= endDay; i++) {
          res.push({
            i,
            fill: true
          });
        }
      }
      const index = res.length;
      for (let i = 1; i <= this.daysInMonth; i++) {
        const day = {
          i,
          event: this.eventDaysMap[i],
          classes: []
        };
        if (this.selectionDaysMap[i] === true) {
          day.in = true;
          day.flat = true;
        }
        res.push(day);
      }

      // if current view has days in model
      if (this.daysMap[this.viewMonthHash] !== void 0) {
        this.daysMap[this.viewMonthHash].forEach(day => {
          const i = index + day - 1;
          Object.assign(res[i], {
            selected: true,
            unelevated: true,
            flat: false,
            color: this.computedColor,
            textColor: this.computedTextColor
          });
        });
      }

      // if current view has ranges in model
      if (this.rangeMap[this.viewMonthHash] !== void 0) {
        this.rangeMap[this.viewMonthHash].forEach(entry => {
          if (entry.from !== void 0) {
            const from = index + entry.from - 1;
            const to = index + (entry.to || this.daysInMonth) - 1;
            for (let day = from; day <= to; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: this.computedColor,
                textColor: this.computedTextColor
              });
            }
            Object.assign(res[from], {
              rangeFrom: true,
              flat: false
            });
            entry.to !== void 0 && Object.assign(res[to], {
              rangeTo: true,
              flat: false
            });
          } else if (entry.to !== void 0) {
            const to = index + entry.to - 1;
            for (let day = index; day <= to; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: this.computedColor,
                textColor: this.computedTextColor
              });
            }
            Object.assign(res[to], {
              flat: false,
              rangeTo: true
            });
          } else {
            const to = index + this.daysInMonth - 1;
            for (let day = index; day <= to; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: this.computedColor,
                textColor: this.computedTextColor
              });
            }
          }
        });
      }
      if (this.rangeView !== void 0) {
        const from = index + this.rangeView.from - 1;
        const to = index + this.rangeView.to - 1;
        for (let day = from; day <= to; day++) {
          res[day].color = this.computedColor;
          res[day].editRange = true;
        }
        if (this.rangeView.includeFrom === true) {
          res[from].editRangeFrom = true;
        }
        if (this.rangeView.includeTo === true) {
          res[to].editRangeTo = true;
        }
      }
      if (this.viewModel.year === this.today.year && this.viewModel.month === this.today.month) {
        res[index + this.today.day - 1].today = true;
      }
      const left = res.length % 7;
      if (left > 0) {
        const afterDays = 7 - left;
        for (let i = 1; i <= afterDays; i++) {
          res.push({
            i,
            fill: true
          });
        }
      }
      res.forEach(day => {
        let cls = 'q-date__calendar-item ';
        if (day.fill === true) {
          cls += 'q-date__calendar-item--fill';
        } else {
          cls += `q-date__calendar-item--${day.in === true ? 'in' : 'out'}`;
          if (day.range !== void 0) {
            cls += ` q-date__range${day.rangeTo === true ? '-to' : day.rangeFrom === true ? '-from' : ''}`;
          }
          if (day.editRange === true) {
            cls += ` q-date__edit-range${day.editRangeFrom === true ? '-from' : ''}${day.editRangeTo === true ? '-to' : ''}`;
          }
          if (day.range !== void 0 || day.editRange === true) {
            cls += ` text-${day.color}`;
          }
        }
        day.classes = cls;
      });
      return res;
    },
    attrs() {
      if (this.disable === true) {
        return {
          'aria-disabled': 'true'
        };
      }
      if (this.readonly === true) {
        return {
          'aria-readonly': 'true'
        };
      }
    }
  },
  methods: {
    setToday() {
      const date = this.today;
      const month = this.daysMap[this.__getMonthHash(date)];
      if (month === void 0 || month.includes(date.day) === false) {
        this.__addToModel(date);
      }
      this.setCalendarTo(this.today.year, this.today.month);
    },
    setView(view) {
      if (viewIsValid(view) === true) {
        this.view = view;
      }
    },
    offsetCalendar(type, descending) {
      if (['month', 'year'].includes(type)) {
        this[`__goTo${type === 'month' ? 'Month' : 'Year'}`](descending === true ? -1 : 1);
      }
    },
    setCalendarTo(year, month) {
      this.view = 'Calendar';
      this.__updateViewModel(year, month);
    },
    setEditingRange(from, to) {
      if (this.range === false || !from) {
        this.editRange = void 0;
        return;
      }
      const init = Object.assign({
        ...this.viewModel
      }, from);
      const final = to !== void 0 ? Object.assign({
        ...this.viewModel
      }, to) : init;
      this.editRange = {
        init,
        initHash: this.__getDayHash(init),
        final,
        finalHash: this.__getDayHash(final)
      };
      this.setCalendarTo(init.year, init.month);
    },
    __getMask() {
      return this.calendar === 'persian' ? 'YYYY/MM/DD' : this.mask;
    },
    __decodeString(date, mask, locale) {
      return __splitDate(date, mask, locale, this.calendar, {
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      });
    },
    __getViewModel(mask, locale) {
      const model = Array.isArray(this.value) === true ? this.value : this.value ? [this.value] : [];
      if (model.length === 0) {
        return this.__getDefaultViewModel();
      }
      const decoded = this.__decodeString(model[0].from !== void 0 ? model[0].from : model[0], mask, locale);
      return decoded.dateHash === null ? this.__getDefaultViewModel() : decoded;
    },
    __getDefaultViewModel() {
      let year, month;
      if (this.defaultYearMonth !== void 0) {
        const d = this.defaultYearMonth.split('/');
        year = parseInt(d[0], 10);
        month = parseInt(d[1], 10);
      } else {
        // may come from data() where computed
        // props are not yet available
        const d = this.today !== void 0 ? this.today : this.__getCurrentDate();
        year = d.year;
        month = d.month;
      }
      return {
        year,
        month,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        dateHash: year + '/' + Object(format["e" /* pad */])(month) + '/01'
      };
    },
    __getHeader(h) {
      if (this.minimal === true) {
        return;
      }
      return h('div', {
        staticClass: 'q-date__header',
        class: this.headerClass
      }, [h('div', {
        staticClass: 'relative-position'
      }, [h('transition', {
        props: {
          name: 'q-transition--fade'
        }
      }, [h('div', {
        key: 'h-yr-' + this.headerSubtitle,
        staticClass: 'q-date__header-subtitle q-date__header-link',
        class: this.view === 'Years' ? 'q-date__header-link--active' : 'cursor-pointer',
        attrs: {
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'vY', {
          click: () => {
            this.view = 'Years';
          },
          keyup: e => {
            e.keyCode === 13 && (this.view = 'Years');
          }
        })
      }, [this.headerSubtitle])])]), h('div', {
        staticClass: 'q-date__header-title relative-position flex no-wrap'
      }, [h('div', {
        staticClass: 'relative-position col'
      }, [h('transition', {
        props: {
          name: 'q-transition--fade'
        }
      }, [h('div', {
        key: 'h-sub' + this.headerTitle,
        staticClass: 'q-date__header-title-label q-date__header-link',
        class: this.view === 'Calendar' ? 'q-date__header-link--active' : 'cursor-pointer',
        attrs: {
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'vC', {
          click: () => {
            this.view = 'Calendar';
          },
          keyup: e => {
            e.keyCode === 13 && (this.view = 'Calendar');
          }
        })
      }, [this.headerTitle])])]), this.todayBtn === true ? h(QBtn["a" /* default */], {
        staticClass: 'q-date__header-today self-start',
        props: {
          icon: this.$q.iconSet.datetime.today,
          flat: true,
          size: 'sm',
          round: true,
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'today', {
          click: this.setToday
        })
      }) : null])]);
    },
    __getNavigation(h, {
      label,
      view,
      key,
      dir,
      goTo,
      boundaries,
      cls
    }) {
      return [h('div', {
        staticClass: 'row items-center q-date__arrow'
      }, [h(QBtn["a" /* default */], {
        props: {
          round: true,
          dense: true,
          size: 'sm',
          flat: true,
          icon: this.dateArrow[0],
          tabindex: this.computedTabindex,
          disable: boundaries.prev === false
        },
        on: Object(cache["b" /* default */])(this, 'go-#' + view, {
          click() {
            goTo(-1);
          }
        })
      })]), h('div', {
        staticClass: 'relative-position overflow-hidden flex flex-center' + cls
      }, [h('transition', {
        props: {
          name: 'q-transition--jump-' + dir
        }
      }, [h('div', {
        key
      }, [h(QBtn["a" /* default */], {
        props: {
          flat: true,
          dense: true,
          noCaps: true,
          label,
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'view#' + view, {
          click: () => {
            this.view = view;
          }
        })
      })])])]), h('div', {
        staticClass: 'row items-center q-date__arrow'
      }, [h(QBtn["a" /* default */], {
        props: {
          round: true,
          dense: true,
          size: 'sm',
          flat: true,
          icon: this.dateArrow[1],
          tabindex: this.computedTabindex,
          disable: boundaries.next === false
        },
        on: Object(cache["b" /* default */])(this, 'go+#' + view, {
          click() {
            goTo(1);
          }
        })
      })])];
    },
    __getCalendarView(h) {
      return [h('div', {
        key: 'calendar-view',
        staticClass: 'q-date__view q-date__calendar'
      }, [h('div', {
        staticClass: 'q-date__navigation row items-center no-wrap'
      }, this.__getNavigation(h, {
        label: this.innerLocale.months[this.viewModel.month - 1],
        view: 'Months',
        key: this.viewModel.month,
        dir: this.monthDirection,
        goTo: this.__goToMonth,
        boundaries: this.navBoundaries.month,
        cls: ' col'
      }).concat(this.__getNavigation(h, {
        label: this.viewModel.year,
        view: 'Years',
        key: this.viewModel.year,
        dir: this.yearDirection,
        goTo: this.__goToYear,
        boundaries: this.navBoundaries.year,
        cls: ''
      }))), h('div', {
        staticClass: 'q-date__calendar-weekdays row items-center no-wrap'
      }, this.daysOfWeek.map(day => h('div', {
        staticClass: 'q-date__calendar-item'
      }, [h('div', [day])]))), h('div', {
        staticClass: 'q-date__calendar-days-container relative-position overflow-hidden'
      }, [h('transition', {
        props: {
          name: 'q-transition--slide-' + this.monthDirection
        }
      }, [h('div', {
        key: this.viewMonthHash,
        staticClass: 'q-date__calendar-days fit'
      }, this.days.map(day => h('div', {
        staticClass: day.classes
      }, [day.in === true ? h(QBtn["a" /* default */], {
        staticClass: day.today === true ? 'q-date__today' : null,
        props: {
          dense: true,
          flat: day.flat,
          unelevated: day.unelevated,
          color: day.color,
          textColor: day.textColor,
          label: day.i,
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'day#' + day.i, {
          click: () => {
            this.__onDayClick(day.i);
          },
          mouseover: () => {
            this.__onDayMouseover(day.i);
          }
        })
      }, day.event !== false ? [h('div', {
        staticClass: 'q-date__event bg-' + day.event
      })] : null) : h('div', [day.i])])))])])])];
    },
    __getMonthsView(h) {
      const currentYear = this.viewModel.year === this.today.year;
      const isDisabled = month => {
        return this.minNav !== void 0 && this.viewModel.year === this.minNav.year && this.minNav.month > month || this.maxNav !== void 0 && this.viewModel.year === this.maxNav.year && this.maxNav.month < month;
      };
      const content = this.innerLocale.monthsShort.map((month, i) => {
        const active = this.viewModel.month === i + 1;
        return h('div', {
          staticClass: 'q-date__months-item flex flex-center'
        }, [h(QBtn["a" /* default */], {
          staticClass: currentYear === true && this.today.month === i + 1 ? 'q-date__today' : null,
          props: {
            flat: active !== true,
            label: month,
            unelevated: active,
            color: active === true ? this.computedColor : null,
            textColor: active === true ? this.computedTextColor : null,
            tabindex: this.computedTabindex,
            disable: isDisabled(i + 1)
          },
          on: Object(cache["b" /* default */])(this, 'month#' + i, {
            click: () => {
              this.__setMonth(i + 1);
            }
          })
        })]);
      });
      this.yearsInMonthView === true && content.unshift(h('div', {
        staticClass: 'row no-wrap full-width'
      }, [this.__getNavigation(h, {
        label: this.viewModel.year,
        view: 'Years',
        key: this.viewModel.year,
        dir: this.yearDirection,
        goTo: this.__goToYear,
        boundaries: this.navBoundaries.year,
        cls: ' col'
      })]));
      return h('div', {
        key: 'months-view',
        staticClass: 'q-date__view q-date__months flex flex-center'
      }, content);
    },
    __getYearsView(h) {
      const start = this.startYear,
        stop = start + yearsInterval,
        years = [];
      const isDisabled = year => {
        return this.minNav !== void 0 && this.minNav.year > year || this.maxNav !== void 0 && this.maxNav.year < year;
      };
      for (let i = start; i <= stop; i++) {
        const active = this.viewModel.year === i;
        years.push(h('div', {
          staticClass: 'q-date__years-item flex flex-center'
        }, [h(QBtn["a" /* default */], {
          key: 'yr' + i,
          staticClass: this.today.year === i ? 'q-date__today' : null,
          props: {
            flat: !active,
            label: i,
            dense: true,
            unelevated: active,
            color: active === true ? this.computedColor : null,
            textColor: active === true ? this.computedTextColor : null,
            tabindex: this.computedTabindex,
            disable: isDisabled(i)
          },
          on: Object(cache["b" /* default */])(this, 'yr#' + i, {
            click: () => {
              this.__setYear(i);
            }
          })
        })]));
      }
      return h('div', {
        staticClass: 'q-date__view q-date__years flex flex-center'
      }, [h('div', {
        staticClass: 'col-auto'
      }, [h(QBtn["a" /* default */], {
        props: {
          round: true,
          dense: true,
          flat: true,
          icon: this.dateArrow[0],
          tabindex: this.computedTabindex,
          disable: isDisabled(start)
        },
        on: Object(cache["b" /* default */])(this, 'y-', {
          click: () => {
            this.startYear -= yearsInterval;
          }
        })
      })]), h('div', {
        staticClass: 'q-date__years-content col self-stretch row items-center'
      }, years), h('div', {
        staticClass: 'col-auto'
      }, [h(QBtn["a" /* default */], {
        props: {
          round: true,
          dense: true,
          flat: true,
          icon: this.dateArrow[1],
          tabindex: this.computedTabindex,
          disable: isDisabled(stop)
        },
        on: Object(cache["b" /* default */])(this, 'y+', {
          click: () => {
            this.startYear += yearsInterval;
          }
        })
      })])]);
    },
    __goToMonth(offset) {
      let year = this.viewModel.year;
      let month = Number(this.viewModel.month) + offset;
      if (month === 13) {
        month = 1;
        year++;
      } else if (month === 0) {
        month = 12;
        year--;
      }
      this.__updateViewModel(year, month);
      this.isImmediate === true && this.__emitImmediately('month');
    },
    __goToYear(offset) {
      const year = Number(this.viewModel.year) + offset;
      this.__updateViewModel(year, this.viewModel.month);
      this.isImmediate === true && this.__emitImmediately('year');
    },
    __setYear(year) {
      this.__updateViewModel(year, this.viewModel.month);
      this.view = this.defaultView === 'Years' ? 'Months' : 'Calendar';
      this.isImmediate === true && this.__emitImmediately('year');
    },
    __setMonth(month) {
      this.__updateViewModel(this.viewModel.year, month);
      this.view = 'Calendar';
      this.isImmediate === true && this.__emitImmediately('month');
    },
    __getMonthHash(date) {
      return date.year + '/' + Object(format["e" /* pad */])(date.month);
    },
    __toggleDate(date, monthHash) {
      const month = this.daysMap[monthHash];
      const fn = month !== void 0 && month.includes(date.day) === true ? this.__removeFromModel : this.__addToModel;
      fn(date);
    },
    __getShortDate(date) {
      return {
        year: date.year,
        month: date.month,
        day: date.day
      };
    },
    __onDayClick(dayIndex) {
      const day = {
        ...this.viewModel,
        day: dayIndex
      };
      if (this.range === false) {
        this.__toggleDate(day, this.viewMonthHash);
        return;
      }
      if (this.editRange === void 0) {
        const dayProps = this.days.find(day => day.fill !== true && day.i === dayIndex);
        if (dayProps.range !== void 0) {
          this.__removeFromModel({
            target: day,
            from: dayProps.range.from,
            to: dayProps.range.to
          });
          return;
        }
        if (dayProps.selected === true) {
          this.__removeFromModel(day);
          return;
        }
        const initHash = this.__getDayHash(day);
        this.editRange = {
          init: day,
          initHash,
          final: day,
          finalHash: initHash
        };
        this.$emit('range-start', this.__getShortDate(day));
      } else {
        const initHash = this.editRange.initHash,
          finalHash = this.__getDayHash(day),
          payload = initHash <= finalHash ? {
            from: this.editRange.init,
            to: day
          } : {
            from: day,
            to: this.editRange.init
          };
        this.editRange = void 0;
        this.__addToModel(initHash === finalHash ? day : {
          target: day,
          ...payload
        });
        this.$emit('range-end', {
          from: this.__getShortDate(payload.from),
          to: this.__getShortDate(payload.to)
        });
      }
    },
    __onDayMouseover(dayIndex) {
      if (this.editRange !== void 0) {
        const final = {
          ...this.viewModel,
          day: dayIndex
        };
        Object.assign(this.editRange, {
          final,
          finalHash: this.__getDayHash(final)
        });
      }
    },
    __updateViewModel(year, month, time) {
      if (this.minNav !== void 0 && year <= this.minNav.year) {
        year = this.minNav.year;
        if (month < this.minNav.month) {
          month = this.minNav.month;
        }
      }
      if (this.maxNav !== void 0 && year >= this.maxNav.year) {
        year = this.maxNav.year;
        if (month > this.maxNav.month) {
          month = this.maxNav.month;
        }
      }
      if (time !== void 0) {
        const {
          hour,
          minute,
          second,
          millisecond,
          timezoneOffset,
          timeHash
        } = time;
        Object.assign(this.viewModel, {
          hour,
          minute,
          second,
          millisecond,
          timezoneOffset,
          timeHash
        });
      }
      const newHash = year + '/' + Object(format["e" /* pad */])(month) + '/01';
      if (newHash !== this.viewModel.dateHash) {
        this.monthDirection = this.viewModel.dateHash < newHash === (this.$q.lang.rtl !== true) ? 'left' : 'right';
        if (year !== this.viewModel.year) {
          this.yearDirection = this.monthDirection;
        }
        this.$nextTick(() => {
          this.startYear = year - year % yearsInterval - (year < 0 ? yearsInterval : 0);
          Object.assign(this.viewModel, {
            year,
            month,
            day: 1,
            dateHash: newHash
          });
        });
      }
    },
    __emitValue(val, action, date) {
      const value = val !== null && val.length === 1 && this.multiple === false ? val[0] : val;
      this.lastEmitValue = value;
      const {
        reason,
        details
      } = this.__getEmitParams(action, date);
      this.$emit('input', value, reason, details);
    },
    __emitImmediately(reason) {
      const date = this.daysModel[0] !== void 0 && this.daysModel[0].dateHash !== null ? {
        ...this.daysModel[0]
      } : {
        ...this.viewModel
      }; // inherit day, hours, minutes, milliseconds...

      // nextTick required because of animation delay in viewModel
      this.$nextTick(() => {
        date.year = this.viewModel.year;
        date.month = this.viewModel.month;
        const maxDay = this.calendar !== 'persian' ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
        date.day = Math.min(Math.max(1, date.day), maxDay);
        const value = this.__encodeEntry(date);
        this.lastEmitValue = value;
        const {
          details
        } = this.__getEmitParams('', date);
        this.$emit('input', value, reason, details);
      });
    },
    __getEmitParams(action, date) {
      return date.from !== void 0 ? {
        reason: `${action}-range`,
        details: {
          ...this.__getShortDate(date.target),
          from: this.__getShortDate(date.from),
          to: this.__getShortDate(date.to),
          changed: true // TODO remove in v2; legacy purposes
        }
      } : {
        reason: `${action}-day`,
        details: {
          ...this.__getShortDate(date),
          changed: true // TODO remove in v2; legacy purposes
        }
      };
    },
    __encodeEntry(date, mask, locale) {
      return date.from !== void 0 ? {
        from: this.encodeObjectFn(date.from, mask, locale),
        to: this.encodeObjectFn(date.to, mask, locale)
      } : this.encodeObjectFn(date, mask, locale);
    },
    __addToModel(date) {
      let value;
      if (this.multiple === true) {
        if (date.from !== void 0) {
          // we also need to filter out intersections

          const fromHash = this.__getDayHash(date.from);
          const toHash = this.__getDayHash(date.to);
          const days = this.daysModel.filter(day => day.dateHash < fromHash || day.dateHash > toHash);
          const ranges = this.rangeModel.filter(({
            from,
            to
          }) => to.dateHash < fromHash || from.dateHash > toHash);
          value = days.concat(ranges).concat(date).map(entry => this.__encodeEntry(entry));
        } else {
          const model = this.normalizedModel.slice();
          model.push(this.__encodeEntry(date));
          value = model;
        }
      } else {
        value = this.__encodeEntry(date);
      }
      this.__emitValue(value, 'add', date);
    },
    __removeFromModel(date) {
      if (this.noUnset === true) {
        return;
      }
      let model = null;
      if (this.multiple === true && Array.isArray(this.value) === true) {
        const val = this.__encodeEntry(date);
        if (date.from !== void 0) {
          model = this.value.filter(date => date.from !== void 0 ? date.from !== val.from && date.to !== val.to : true);
        } else {
          model = this.value.filter(date => date !== val);
        }
        if (model.length === 0) {
          model = null;
        }
      }
      this.__emitValue(model, 'remove', date);
    },
    __updateValue(mask, locale, reason) {
      const model = this.daysModel.concat(this.rangeModel).map(entry => this.__encodeEntry(entry, mask, locale)).filter(entry => {
        return entry.from !== void 0 ? entry.from.dateHash !== null && entry.to.dateHash !== null : entry.dateHash !== null;
      });
      this.$emit('input', (this.multiple === true ? model : model[0]) || null, reason);
    }
  },
  render(h) {
    const content = [h('div', {
      staticClass: 'q-date__content col relative-position'
    }, [h('transition', {
      props: {
        name: 'q-transition--fade'
      }
    }, [this[`__get${this.view}View`](h)])])];
    const def = Object(private_slot["c" /* slot */])(this, 'default');
    def !== void 0 && content.push(h('div', {
      staticClass: 'q-date__actions'
    }, def));
    if (this.name !== void 0 && this.disable !== true) {
      this.__injectFormInput(content, 'push');
    }
    return h('div', {
      class: this.classes,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, [this.__getHeader(h), h('div', {
      staticClass: 'q-date__main col column',
      attrs: {
        tabindex: -1
      },
      ref: 'blurTarget'
    }, content)]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/date/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/dialog/QDialog.js
var QDialog = __webpack_require__("66e6");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/dialog/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/drawer/QDrawer.js
var QDrawer = __webpack_require__("da18");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/drawer/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/tooltip/QTooltip.js
var QTooltip = __webpack_require__("8030");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QList.js
var QList = __webpack_require__("c588");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItem.js
var QItem = __webpack_require__("7e6f");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItemSection.js
var QItemSection = __webpack_require__("0aaf");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/editor/editor-utils.js










function run(e, btn, vm) {
  if (btn.handler) {
    btn.handler(e, vm, vm.caret);
  } else {
    vm.runCmd(btn.cmd, btn.param);
  }
}
function __getGroup(h, children) {
  return h('div', {
    staticClass: 'q-editor__toolbar-group'
  }, children);
}
function getBtn(h, vm, btn, clickHandler, active = false) {
  const toggled = active || (btn.type === 'toggle' ? btn.toggled ? btn.toggled(vm) : btn.cmd && vm.caret.is(btn.cmd, btn.param) : false),
    child = [],
    events = {
      click(e) {
        clickHandler && clickHandler();
        run(e, btn, vm);
      }
    };
  if (btn.tip && vm.$q.platform.is.desktop) {
    const Key = btn.key ? h('div', [h('small', `(CTRL + ${String.fromCharCode(btn.key)})`)]) : null;
    child.push(h(QTooltip["a" /* default */], {
      props: {
        delay: 1000
      }
    }, [h('div', {
      domProps: {
        innerHTML: btn.tip
      }
    }), Key]));
  }
  return h(QBtn["a" /* default */], {
    props: {
      ...vm.buttonProps,
      icon: btn.icon !== null ? btn.icon : void 0,
      color: toggled ? btn.toggleColor || vm.toolbarToggleColor : btn.color || vm.toolbarColor,
      textColor: toggled && !vm.toolbarPush ? null : btn.textColor || vm.toolbarTextColor,
      label: btn.label,
      disable: btn.disable ? typeof btn.disable === 'function' ? btn.disable(vm) : true : false,
      size: 'sm'
    },
    on: events
  }, child);
}
function getDropdown(h, vm, btn) {
  const onlyIcons = btn.list === 'only-icons';
  let label = btn.label,
    icon = btn.icon !== null ? btn.icon : void 0,
    contentClass,
    Items;
  function closeDropdown() {
    Dropdown.componentInstance.hide();
  }
  if (onlyIcons) {
    Items = btn.options.map(btn => {
      const active = btn.type === void 0 ? vm.caret.is(btn.cmd, btn.param) : false;
      if (active) {
        label = btn.tip;
        icon = btn.icon !== null ? btn.icon : void 0;
      }
      return getBtn(h, vm, btn, closeDropdown, active);
    });
    contentClass = vm.toolbarBackgroundClass;
    Items = [__getGroup(h, Items)];
  } else {
    const activeClass = vm.toolbarToggleColor !== void 0 ? `text-${vm.toolbarToggleColor}` : null;
    const inactiveClass = vm.toolbarTextColor !== void 0 ? `text-${vm.toolbarTextColor}` : null;
    const noIcons = btn.list === 'no-icons';
    Items = btn.options.map(btn => {
      const disable = btn.disable ? btn.disable(vm) : false;
      const active = btn.type === void 0 ? vm.caret.is(btn.cmd, btn.param) : false;
      if (active) {
        label = btn.tip;
        icon = btn.icon !== null ? btn.icon : void 0;
      }
      const htmlTip = btn.htmlTip;
      return h(QItem["a" /* default */], {
        props: {
          active,
          activeClass,
          clickable: true,
          disable: disable,
          dense: true
        },
        on: {
          click(e) {
            closeDropdown();
            vm.$refs.content && vm.$refs.content.focus();
            vm.caret.restore();
            run(e, btn, vm);
          }
        }
      }, [noIcons === true ? null : h(QItemSection["a" /* default */], {
        class: active ? activeClass : inactiveClass,
        props: {
          side: true
        }
      }, [h(QIcon["a" /* default */], {
        props: {
          name: btn.icon !== null ? btn.icon : void 0
        }
      })]), h(QItemSection["a" /* default */], [htmlTip ? h('div', {
        staticClass: 'text-no-wrap',
        domProps: {
          innerHTML: btn.htmlTip
        }
      }) : btn.tip ? h('div', {
        staticClass: 'text-no-wrap'
      }, [btn.tip]) : null])]);
    });
    contentClass = [vm.toolbarBackgroundClass, inactiveClass];
    Items = [h(QList["a" /* default */], [Items])];
  }
  const highlight = btn.highlight && label !== btn.label;
  const Dropdown = h(QBtnDropdown, {
    props: {
      ...vm.buttonProps,
      noCaps: true,
      noWrap: true,
      color: highlight ? vm.toolbarToggleColor : vm.toolbarColor,
      textColor: highlight && !vm.toolbarPush ? null : vm.toolbarTextColor,
      label: btn.fixedLabel ? btn.label : label,
      icon: btn.fixedIcon ? btn.icon !== null ? btn.icon : void 0 : icon,
      contentClass
    }
  }, Items);
  return Dropdown;
}
function getToolbar(h, vm) {
  if (vm.caret) {
    return vm.buttons.filter(f => {
      return !vm.isViewingSource || f.find(fb => fb.cmd === 'viewsource');
    }).map(group => __getGroup(h, group.map(btn => {
      if (vm.isViewingSource && btn.cmd !== 'viewsource') {
        return false;
      }
      if (btn.type === 'slot') {
        return Object(private_slot["c" /* slot */])(vm, btn.slot);
      }
      if (btn.type === 'dropdown') {
        return getDropdown(h, vm, btn);
      }
      return getBtn(h, vm, btn);
    })));
  }
}
function getFonts(defaultFont, defaultFontLabel, defaultFontIcon, fonts = {}) {
  const aliases = Object.keys(fonts);
  if (aliases.length === 0) {
    return {};
  }
  const def = {
    default_font: {
      cmd: 'fontName',
      param: defaultFont,
      icon: defaultFontIcon,
      tip: defaultFontLabel
    }
  };
  aliases.forEach(alias => {
    const name = fonts[alias];
    def[alias] = {
      cmd: 'fontName',
      param: name,
      icon: defaultFontIcon,
      tip: name,
      htmlTip: `<font face="${name}">${name}</font>`
    };
  });
  return def;
}
function getLinkEditor(h, vm, ie11) {
  if (vm.caret) {
    const color = vm.toolbarColor || vm.toolbarTextColor;
    let link = vm.editLinkUrl;
    const updateLink = () => {
      vm.caret.restore();
      if (link !== vm.editLinkUrl) {
        document.execCommand('createLink', false, link === '' ? ' ' : link);
      }
      vm.editLinkUrl = null;
      ie11 === true && vm.$nextTick(vm.__onInput);
    };
    return [h('div', {
      staticClass: 'q-mx-xs',
      'class': `text-${color}`
    }, [`${vm.$q.lang.editor.url}: `]), h('input', {
      key: 'qedt_btm_input',
      staticClass: 'col q-editor__link-input',
      domProps: {
        value: link
      },
      on: {
        input: e => {
          Object(utils_event["k" /* stop */])(e);
          link = e.target.value;
        },
        keydown: event => {
          if (Object(key_composition["c" /* shouldIgnoreKey */])(event) === true) {
            return;
          }
          switch (event.keyCode) {
            case 13:
              // ENTER key
              Object(utils_event["i" /* prevent */])(event);
              return updateLink();
            case 27:
              // ESCAPE key
              Object(utils_event["i" /* prevent */])(event);
              vm.caret.restore();
              if (!vm.editLinkUrl || vm.editLinkUrl === 'https://') {
                document.execCommand('unlink');
              }
              vm.editLinkUrl = null;
              break;
          }
        }
      }
    }), __getGroup(h, [h(QBtn["a" /* default */], {
      key: 'qedt_btm_rem',
      attrs: {
        tabindex: -1
      },
      props: {
        ...vm.buttonProps,
        label: vm.$q.lang.label.remove,
        noCaps: true
      },
      on: {
        click: () => {
          vm.caret.restore();
          document.execCommand('unlink');
          vm.editLinkUrl = null;
          ie11 === true && vm.$nextTick(vm.__onInput);
        }
      }
    }), h(QBtn["a" /* default */], {
      key: 'qedt_btm_upd',
      props: {
        ...vm.buttonProps,
        label: vm.$q.lang.label.update,
        noCaps: true
      },
      on: {
        click: updateLink
      }
    })])];
  }
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/editor/editor-caret.js

function getBlockElement(el, parent) {
  if (parent && el === parent) {
    return null;
  }
  const nodeName = el.nodeName.toLowerCase();
  if (['div', 'li', 'ul', 'ol', 'blockquote'].includes(nodeName) === true) {
    return el;
  }
  const style = window.getComputedStyle ? window.getComputedStyle(el) : el.currentStyle,
    display = style.display;
  if (display === 'block' || display === 'table') {
    return el;
  }
  return getBlockElement(el.parentNode);
}
function isChildOf(el, parent, orSame) {
  return !el || el === document.body ? false : orSame === true && el === parent || (parent === document ? document.body : parent).contains(el.parentNode);
}
function createRange(node, chars, range) {
  if (!range) {
    range = document.createRange();
    range.selectNode(node);
    range.setStart(node, 0);
  }
  if (chars.count === 0) {
    range.setEnd(node, chars.count);
  } else if (chars.count > 0) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.length < chars.count) {
        chars.count -= node.textContent.length;
      } else {
        range.setEnd(node, chars.count);
        chars.count = 0;
      }
    } else {
      for (let lp = 0; chars.count !== 0 && lp < node.childNodes.length; lp++) {
        range = createRange(node.childNodes[lp], chars, range);
      }
    }
  }
  return range;
}
const urlRegex = /^https?:\/\//;
class editor_caret_Caret {
  constructor(el, vm) {
    this.el = el;
    this.vm = vm;
    this._range = null;
  }
  get selection() {
    if (this.el) {
      const sel = document.getSelection();

      // only when the selection in element
      if (isChildOf(sel.anchorNode, this.el, true) && isChildOf(sel.focusNode, this.el, true)) {
        return sel;
      }
    }
    return null;
  }
  get hasSelection() {
    return this.selection !== null ? this.selection.toString().length > 0 : false;
  }
  get range() {
    const sel = this.selection;
    if (sel !== null && sel.rangeCount) {
      return sel.getRangeAt(0);
    }
    return this._range;
  }
  get parent() {
    const range = this.range;
    if (range !== null) {
      const node = range.startContainer;
      return node.nodeType === document.ELEMENT_NODE ? node : node.parentNode;
    }
    return null;
  }
  get blockParent() {
    const parent = this.parent;
    if (parent !== null) {
      return getBlockElement(parent, this.el);
    }
    return null;
  }
  save(range = this.range) {
    if (range !== null) {
      this._range = range;
    }
  }
  restore(range = this._range) {
    const r = document.createRange(),
      sel = document.getSelection();
    if (range !== null) {
      r.setStart(range.startContainer, range.startOffset);
      r.setEnd(range.endContainer, range.endOffset);
      sel.removeAllRanges();
      sel.addRange(r);
    } else {
      sel.selectAllChildren(this.el);
      sel.collapseToEnd();
    }
  }
  savePosition() {
    let charCount = -1,
      node;
    const selection = document.getSelection(),
      parentEl = this.el.parentNode;
    if (selection.focusNode && isChildOf(selection.focusNode, parentEl)) {
      node = selection.focusNode;
      charCount = selection.focusOffset;
      while (node && node !== parentEl) {
        if (node !== this.el && node.previousSibling) {
          node = node.previousSibling;
          charCount += node.textContent.length;
        } else {
          node = node.parentNode;
        }
      }
    }
    this.savedPos = charCount;
  }
  restorePosition(length = 0) {
    if (this.savedPos > 0 && this.savedPos < length) {
      const selection = window.getSelection(),
        range = createRange(this.el, {
          count: this.savedPos
        });
      if (range) {
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }
  hasParent(name, spanLevel) {
    const el = spanLevel ? this.parent : this.blockParent;
    return el !== null ? el.nodeName.toLowerCase() === name.toLowerCase() : false;
  }
  hasParents(list, recursive, el = this.parent) {
    if (el === null) {
      return false;
    }
    if (list.includes(el.nodeName.toLowerCase()) === true) {
      return true;
    }
    return recursive === true ? this.hasParents(list, recursive, el.parentNode) : false;
  }
  is(cmd, param) {
    if (this.selection === null) {
      return false;
    }
    switch (cmd) {
      case 'formatBlock':
        if (param === 'DIV' && this.parent === this.el) {
          return true;
        }
        return this.hasParent(param, param === 'PRE');
      case 'link':
        return this.hasParent('A', true);
      case 'fontSize':
        return document.queryCommandValue(cmd) === param;
      case 'fontName':
        const res = document.queryCommandValue(cmd);
        return res === `"${param}"` || res === param;
      case 'fullscreen':
        return this.vm.inFullscreen;
      case 'viewsource':
        return this.vm.isViewingSource;
      case void 0:
        return false;
      default:
        const state = document.queryCommandState(cmd);
        return param !== void 0 ? state === param : state;
    }
  }
  getParentAttribute(attrib) {
    if (this.parent !== null) {
      return this.parent.getAttribute(attrib);
    }
    return null;
  }
  can(name) {
    if (name === 'outdent') {
      return this.hasParents(['blockquote', 'li'], true);
    }
    if (name === 'indent') {
      return this.hasParents(['li'], true);
    }
    if (name === 'link') {
      return this.selection !== null || this.is('link');
    }
  }
  apply(cmd, param, done = utils_event["g" /* noop */]) {
    if (cmd === 'formatBlock') {
      if (['BLOCKQUOTE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(param) && this.is(cmd, param)) {
        cmd = 'outdent';
        param = null;
      }
      if (param === 'PRE' && this.is(cmd, 'PRE')) {
        param = 'P';
      }
    } else if (cmd === 'print') {
      done();
      const win = window.open();
      win.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>Print - ${document.title}</title>
          </head>
          <body>
            <div>${this.el.innerHTML}</div>
          </body>
        </html>
      `);
      win.print();
      win.close();
      return;
    } else if (cmd === 'link') {
      const link = this.getParentAttribute('href');
      if (link === null) {
        const selection = this.selectWord(this.selection);
        const url = selection ? selection.toString() : '';
        if (!url.length) {
          if (!this.range || !this.range.cloneContents().querySelector('img')) {
            return;
          }
        }
        this.vm.editLinkUrl = urlRegex.test(url) ? url : 'https://';
        document.execCommand('createLink', false, this.vm.editLinkUrl);
        this.save(selection.getRangeAt(0));
      } else {
        this.vm.editLinkUrl = link;
        this.range.selectNodeContents(this.parent);
        this.save();
      }
      return;
    } else if (cmd === 'fullscreen') {
      this.vm.toggleFullscreen();
      done();
      return;
    } else if (cmd === 'viewsource') {
      this.vm.isViewingSource = this.vm.isViewingSource === false;
      this.vm.__setContent(this.vm.value);
      done();
      return;
    }
    document.execCommand(cmd, false, param);
    done();
  }
  selectWord(sel) {
    if (sel === null || sel.isCollapsed !== true || /* IE 11 */sel.modify === void 0) {
      return sel;
    }

    // Detect if selection is backwards
    const range = document.createRange();
    range.setStart(sel.anchorNode, sel.anchorOffset);
    range.setEnd(sel.focusNode, sel.focusOffset);
    const direction = range.collapsed ? ['backward', 'forward'] : ['forward', 'backward'];
    range.detach();

    // modify() works on the focus of the selection
    const endNode = sel.focusNode,
      endOffset = sel.focusOffset;
    sel.collapse(sel.anchorNode, sel.anchorOffset);
    sel.modify('move', direction[0], 'character');
    sel.modify('move', direction[1], 'word');
    sel.extend(endNode, endOffset);
    sel.modify('extend', direction[1], 'character');
    sel.modify('extend', direction[0], 'word');
    return sel;
  }
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/extend.js
const extend_toString = Object.prototype.toString,
  hasOwn = Object.prototype.hasOwnProperty,
  notPlainObject = new Set(['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp'].map(name => '[object ' + name + ']'));
function isPlainObject(obj) {
  if (obj !== Object(obj) || notPlainObject.has(extend_toString.call(obj)) === true) {
    return false;
  }
  if (obj.constructor && hasOwn.call(obj, 'constructor') === false && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf') === false) {
    return false;
  }
  let key;
  for (key in obj) {}
  return key === void 0 || hasOwn.call(obj, key);
}
function extend() {
  let options,
    name,
    src,
    copy,
    copyIsArray,
    clone,
    target = arguments[0] || {},
    i = 1,
    deep = false;
  const length = arguments.length;
  if (typeof target === 'boolean') {
    deep = target;
    target = arguments[1] || {};
    i = 2;
  }
  if (Object(target) !== target && typeof target !== 'function') {
    target = {};
  }
  if (length === i) {
    target = this;
    i--;
  }
  for (; i < length; i++) {
    if ((options = arguments[i]) !== null) {
      for (name in options) {
        src = target[name];
        copy = options[name];
        if (target === copy) {
          continue;
        }
        if (deep === true && copy && ((copyIsArray = Array.isArray(copy)) || isPlainObject(copy) === true)) {
          if (copyIsArray === true) {
            clone = Array.isArray(src) === true ? src : [];
          } else {
            clone = isPlainObject(src) === true ? src : {};
          }
          target[name] = extend(deep, clone, copy);
        } else if (copy !== void 0) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/private/focus-manager.js
var focus_manager = __webpack_require__("fa15");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/editor/QEditor.js











/* harmony default export */ var QEditor = (external_vue_default.a.extend({
  name: 'QEditor',
  mixins: [listeners["a" /* default */], fullscreen, dark["a" /* default */]],
  props: {
    value: {
      type: String,
      required: true
    },
    readonly: Boolean,
    disable: Boolean,
    minHeight: {
      type: String,
      default: '10rem'
    },
    maxHeight: String,
    height: String,
    definitions: Object,
    fonts: Object,
    placeholder: String,
    toolbar: {
      type: Array,
      validator: v => v.length === 0 || v.every(group => group.length),
      default() {
        return [['left', 'center', 'right', 'justify'], ['bold', 'italic', 'underline', 'strike'], ['undo', 'redo']];
      }
    },
    toolbarColor: String,
    toolbarBg: String,
    toolbarTextColor: String,
    toolbarToggleColor: {
      type: String,
      default: 'primary'
    },
    toolbarOutline: Boolean,
    toolbarPush: Boolean,
    toolbarRounded: Boolean,
    paragraphTag: {
      type: String,
      validator: v => ['div', 'p'].includes(v),
      default: 'div'
    },
    contentStyle: Object,
    contentClass: [Object, Array, String],
    square: Boolean,
    flat: Boolean,
    dense: Boolean
  },
  computed: {
    editable() {
      return !this.readonly && !this.disable;
    },
    hasToolbar() {
      return this.toolbar && this.toolbar.length > 0;
    },
    toolbarBackgroundClass() {
      if (this.toolbarBg) {
        return `bg-${this.toolbarBg}`;
      }
    },
    buttonProps() {
      const flat = this.toolbarOutline !== true && this.toolbarPush !== true;
      return {
        type: 'a',
        flat,
        noWrap: true,
        outline: this.toolbarOutline,
        push: this.toolbarPush,
        rounded: this.toolbarRounded,
        dense: true,
        color: this.toolbarColor,
        disable: !this.editable,
        size: 'sm'
      };
    },
    buttonDef() {
      const e = this.$q.lang.editor,
        i = this.$q.iconSet.editor;
      return {
        bold: {
          cmd: 'bold',
          icon: i.bold,
          tip: e.bold,
          key: 66
        },
        italic: {
          cmd: 'italic',
          icon: i.italic,
          tip: e.italic,
          key: 73
        },
        strike: {
          cmd: 'strikeThrough',
          icon: i.strikethrough,
          tip: e.strikethrough,
          key: 83
        },
        underline: {
          cmd: 'underline',
          icon: i.underline,
          tip: e.underline,
          key: 85
        },
        unordered: {
          cmd: 'insertUnorderedList',
          icon: i.unorderedList,
          tip: e.unorderedList
        },
        ordered: {
          cmd: 'insertOrderedList',
          icon: i.orderedList,
          tip: e.orderedList
        },
        subscript: {
          cmd: 'subscript',
          icon: i.subscript,
          tip: e.subscript,
          htmlTip: 'x<subscript>2</subscript>'
        },
        superscript: {
          cmd: 'superscript',
          icon: i.superscript,
          tip: e.superscript,
          htmlTip: 'x<superscript>2</superscript>'
        },
        link: {
          cmd: 'link',
          disable: vm => vm.caret && !vm.caret.can('link'),
          icon: i.hyperlink,
          tip: e.hyperlink,
          key: 76
        },
        fullscreen: {
          cmd: 'fullscreen',
          icon: i.toggleFullscreen,
          tip: e.toggleFullscreen,
          key: 70
        },
        viewsource: {
          cmd: 'viewsource',
          icon: i.viewSource,
          tip: e.viewSource
        },
        quote: {
          cmd: 'formatBlock',
          param: 'BLOCKQUOTE',
          icon: i.quote,
          tip: e.quote,
          key: 81
        },
        left: {
          cmd: 'justifyLeft',
          icon: i.left,
          tip: e.left
        },
        center: {
          cmd: 'justifyCenter',
          icon: i.center,
          tip: e.center
        },
        right: {
          cmd: 'justifyRight',
          icon: i.right,
          tip: e.right
        },
        justify: {
          cmd: 'justifyFull',
          icon: i.justify,
          tip: e.justify
        },
        print: {
          type: 'no-state',
          cmd: 'print',
          icon: i.print,
          tip: e.print,
          key: 80
        },
        outdent: {
          type: 'no-state',
          disable: vm => vm.caret && !vm.caret.can('outdent'),
          cmd: 'outdent',
          icon: i.outdent,
          tip: e.outdent
        },
        indent: {
          type: 'no-state',
          disable: vm => vm.caret && !vm.caret.can('indent'),
          cmd: 'indent',
          icon: i.indent,
          tip: e.indent
        },
        removeFormat: {
          type: 'no-state',
          cmd: 'removeFormat',
          icon: i.removeFormat,
          tip: e.removeFormat
        },
        hr: {
          type: 'no-state',
          cmd: 'insertHorizontalRule',
          icon: i.hr,
          tip: e.hr
        },
        undo: {
          type: 'no-state',
          cmd: 'undo',
          icon: i.undo,
          tip: e.undo,
          key: 90
        },
        redo: {
          type: 'no-state',
          cmd: 'redo',
          icon: i.redo,
          tip: e.redo,
          key: 89
        },
        h1: {
          cmd: 'formatBlock',
          param: 'H1',
          icon: i.heading1 || i.heading,
          tip: e.heading1,
          htmlTip: `<h1 class="q-ma-none">${e.heading1}</h1>`
        },
        h2: {
          cmd: 'formatBlock',
          param: 'H2',
          icon: i.heading2 || i.heading,
          tip: e.heading2,
          htmlTip: `<h2 class="q-ma-none">${e.heading2}</h2>`
        },
        h3: {
          cmd: 'formatBlock',
          param: 'H3',
          icon: i.heading3 || i.heading,
          tip: e.heading3,
          htmlTip: `<h3 class="q-ma-none">${e.heading3}</h3>`
        },
        h4: {
          cmd: 'formatBlock',
          param: 'H4',
          icon: i.heading4 || i.heading,
          tip: e.heading4,
          htmlTip: `<h4 class="q-ma-none">${e.heading4}</h4>`
        },
        h5: {
          cmd: 'formatBlock',
          param: 'H5',
          icon: i.heading5 || i.heading,
          tip: e.heading5,
          htmlTip: `<h5 class="q-ma-none">${e.heading5}</h5>`
        },
        h6: {
          cmd: 'formatBlock',
          param: 'H6',
          icon: i.heading6 || i.heading,
          tip: e.heading6,
          htmlTip: `<h6 class="q-ma-none">${e.heading6}</h6>`
        },
        p: {
          cmd: 'formatBlock',
          param: this.paragraphTag.toUpperCase(),
          icon: i.heading,
          tip: e.paragraph
        },
        code: {
          cmd: 'formatBlock',
          param: 'PRE',
          icon: i.code,
          htmlTip: `<code>${e.code}</code>`
        },
        'size-1': {
          cmd: 'fontSize',
          param: '1',
          icon: i.size1 || i.size,
          tip: e.size1,
          htmlTip: `<font size="1">${e.size1}</font>`
        },
        'size-2': {
          cmd: 'fontSize',
          param: '2',
          icon: i.size2 || i.size,
          tip: e.size2,
          htmlTip: `<font size="2">${e.size2}</font>`
        },
        'size-3': {
          cmd: 'fontSize',
          param: '3',
          icon: i.size3 || i.size,
          tip: e.size3,
          htmlTip: `<font size="3">${e.size3}</font>`
        },
        'size-4': {
          cmd: 'fontSize',
          param: '4',
          icon: i.size4 || i.size,
          tip: e.size4,
          htmlTip: `<font size="4">${e.size4}</font>`
        },
        'size-5': {
          cmd: 'fontSize',
          param: '5',
          icon: i.size5 || i.size,
          tip: e.size5,
          htmlTip: `<font size="5">${e.size5}</font>`
        },
        'size-6': {
          cmd: 'fontSize',
          param: '6',
          icon: i.size6 || i.size,
          tip: e.size6,
          htmlTip: `<font size="6">${e.size6}</font>`
        },
        'size-7': {
          cmd: 'fontSize',
          param: '7',
          icon: i.size7 || i.size,
          tip: e.size7,
          htmlTip: `<font size="7">${e.size7}</font>`
        }
      };
    },
    buttons() {
      const userDef = this.definitions || {};
      const def = this.definitions || this.fonts ? extend(true, {}, this.buttonDef, userDef, getFonts(this.defaultFont, this.$q.lang.editor.defaultFont, this.$q.iconSet.editor.font, this.fonts)) : this.buttonDef;
      return this.toolbar.map(group => group.map(token => {
        if (token.options) {
          return {
            type: 'dropdown',
            icon: token.icon,
            label: token.label,
            size: 'sm',
            dense: true,
            fixedLabel: token.fixedLabel,
            fixedIcon: token.fixedIcon,
            highlight: token.highlight,
            list: token.list,
            options: token.options.map(item => def[item])
          };
        }
        const obj = def[token];
        if (obj) {
          return obj.type === 'no-state' || userDef[token] && (obj.cmd === void 0 || this.buttonDef[obj.cmd] && this.buttonDef[obj.cmd].type === 'no-state') ? obj : Object.assign({
            type: 'toggle'
          }, obj);
        } else {
          return {
            type: 'slot',
            slot: token
          };
        }
      }));
    },
    keys() {
      const k = {},
        add = btn => {
          if (btn.key) {
            k[btn.key] = {
              cmd: btn.cmd,
              param: btn.param
            };
          }
        };
      this.buttons.forEach(group => {
        group.forEach(token => {
          if (token.options) {
            token.options.forEach(add);
          } else {
            add(token);
          }
        });
      });
      return k;
    },
    innerStyle() {
      return this.inFullscreen ? this.contentStyle : [{
        minHeight: this.minHeight,
        height: this.height,
        maxHeight: this.maxHeight
      }, this.contentStyle];
    },
    classes() {
      return `q-editor q-editor--${this.isViewingSource === true ? 'source' : 'default'}` + (this.disable === true ? ' disabled' : '') + (this.inFullscreen === true ? ' fullscreen column' : '') + (this.square === true ? ' q-editor--square no-border-radius' : '') + (this.flat === true ? ' q-editor--flat' : '') + (this.dense === true ? ' q-editor--dense' : '') + (this.isDark === true ? ' q-editor--dark q-dark' : '');
    },
    innerClass() {
      return [this.contentClass, {
        col: this.inFullscreen,
        'overflow-auto': this.inFullscreen || this.maxHeight
      }];
    },
    attrs() {
      if (this.disable === true) {
        return {
          'aria-disabled': 'true'
        };
      }
      if (this.readonly === true) {
        return {
          'aria-readonly': 'true'
        };
      }
    },
    onEditor() {
      return {
        focusin: this.__onFocusin,
        focusout: this.__onFocusout
      };
    }
  },
  data() {
    return {
      lastEmit: this.value,
      editLinkUrl: null,
      isViewingSource: false
    };
  },
  watch: {
    value(v) {
      if (this.lastEmit !== v) {
        this.lastEmit = v;
        this.__setContent(v, true);
      }
    }
  },
  methods: {
    __onInput() {
      if (this.$refs.content !== void 0) {
        const val = this.isViewingSource === true ? this.$refs.content.innerText : this.$refs.content.innerHTML;
        if (val !== this.value) {
          this.lastEmit = val;
          this.$emit('input', val);
        }
      }
    },
    __onKeydown(e) {
      this.$emit('keydown', e);
      if (e.ctrlKey !== true || Object(key_composition["c" /* shouldIgnoreKey */])(e) === true) {
        this.refreshToolbar();
        this.$q.platform.is.ie && this.$nextTick(this.__onInput);
        return;
      }
      const key = e.keyCode;
      const target = this.keys[key];
      if (target !== void 0) {
        const {
          cmd,
          param
        } = target;
        Object(utils_event["l" /* stopAndPrevent */])(e);
        this.runCmd(cmd, param, false);
      }
    },
    __onClick(e) {
      this.refreshToolbar();
      this.$emit('click', e);
    },
    __onBlur(e) {
      if (this.$refs.content !== void 0) {
        const {
          scrollTop,
          scrollHeight
        } = this.$refs.content;
        this.__offsetBottom = scrollHeight - scrollTop;
      }
      this.$q.platform.is.ie !== true && this.caret.save();
      this.$emit('blur', e);
    },
    __onFocus(e) {
      this.$nextTick(() => {
        if (this.$refs.content !== void 0 && this.__offsetBottom !== void 0) {
          this.$refs.content.scrollTop = this.$refs.content.scrollHeight - this.__offsetBottom;
        }
      });
      this.$emit('focus', e);
    },
    __onFocusin(e) {
      if (this.$el.contains(e.target) === true && (e.relatedTarget === null || this.$el.contains(e.relatedTarget) !== true)) {
        const prop = `inner${this.isViewingSource === true ? 'Text' : 'HTML'}`;
        this.caret.restorePosition(this.$refs.content[prop].length);
        this.refreshToolbar();
      }
    },
    __onFocusout(e) {
      if (this.$el.contains(e.target) === true && (e.relatedTarget === null || this.$el.contains(e.relatedTarget) !== true)) {
        this.caret.savePosition();
        this.refreshToolbar();
      }
    },
    // mousedown, touchstart
    __onPointerStart(e) {
      this.__offsetBottom = void 0;
      this.qListeners[e.type] !== void 0 && this.$emit(e.type, e);
    },
    __onSelectionchange() {
      this.caret.save();
    },
    runCmd(cmd, param, update = true) {
      this.focus();
      this.caret.restore();
      this.caret.apply(cmd, param, () => {
        this.focus();
        this.caret.save();
        if (this.$q.platform.is.ie === true || this.$q.platform.is.edge === true) {
          this.$nextTick(this.__onInput);
        }
        if (update) {
          this.refreshToolbar();
        }
      });
    },
    refreshToolbar() {
      setTimeout(() => {
        this.editLinkUrl = null;
        this.$forceUpdate();
      }, 1);
    },
    focus() {
      Object(focus_manager["a" /* addFocusFn */])(() => {
        this.$refs.content !== void 0 && this.$refs.content.focus({
          preventScroll: true
        });
      });
    },
    getContentEl() {
      return this.$refs.content;
    },
    __setContent(v, restorePosition) {
      if (this.$refs.content !== void 0) {
        if (restorePosition === true) {
          this.caret.savePosition();
        }
        const prop = `inner${this.isViewingSource === true ? 'Text' : 'HTML'}`;
        this.$refs.content[prop] = v;
        if (restorePosition === true) {
          this.caret.restorePosition(this.$refs.content[prop].length);
          this.refreshToolbar();
        }
      }
    }
  },
  created() {
    if (Platform["e" /* isSSR */] === false) {
      document.execCommand('defaultParagraphSeparator', false, this.paragraphTag);
      this.defaultFont = window.getComputedStyle(document.body).fontFamily;
    }
  },
  mounted() {
    this.caret = new editor_caret_Caret(this.$refs.content, this);
    this.__setContent(this.value);
    this.refreshToolbar();
    document.addEventListener('selectionchange', this.__onSelectionchange);
  },
  beforeDestroy() {
    document.removeEventListener('selectionchange', this.__onSelectionchange);
  },
  render(h) {
    let toolbars;
    if (this.hasToolbar) {
      const bars = [h('div', {
        key: 'qedt_top',
        staticClass: 'q-editor__toolbar row no-wrap scroll-x',
        class: this.toolbarBackgroundClass
      }, getToolbar(h, this))];
      this.editLinkUrl !== null && bars.push(h('div', {
        key: 'qedt_btm',
        staticClass: 'q-editor__toolbar row no-wrap items-center scroll-x',
        class: this.toolbarBackgroundClass
      }, getLinkEditor(h, this, this.$q.platform.is.ie)));
      toolbars = h('div', {
        key: 'toolbar_ctainer',
        staticClass: 'q-editor__toolbars-container'
      }, bars);
    }
    const on = {
      ...this.qListeners,
      input: this.__onInput,
      keydown: this.__onKeydown,
      click: this.__onClick,
      blur: this.__onBlur,
      focus: this.__onFocus,
      // clean saved scroll position
      mousedown: this.__onPointerStart,
      touchstart: this.__onPointerStart
    };
    return h('div', {
      style: {
        height: this.inFullscreen === true ? '100%' : null
      },
      class: this.classes,
      attrs: this.attrs,
      on: this.onEditor
    }, [toolbars, h('div', {
      ref: 'content',
      staticClass: 'q-editor__content',
      style: this.innerStyle,
      class: this.innerClass,
      attrs: {
        contenteditable: this.editable,
        placeholder: this.placeholder
      },
      domProps: Platform["e" /* isSSR */] ? {
        innerHTML: this.value
      } : void 0,
      on
    })]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/editor/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/item/QItemLabel.js
var QItemLabel = __webpack_require__("be86");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/slide-transition/QSlideTransition.js



/* harmony default export */ var QSlideTransition = (external_vue_default.a.extend({
  name: 'QSlideTransition',
  props: {
    appear: Boolean,
    duration: {
      type: Number,
      default: 300
    }
  },
  methods: {
    __begin(el, height, done) {
      // here overflowY is 'hidden'
      if (height !== void 0) {
        el.style.height = `${height}px`;
      }
      el.style.transition = `height ${this.duration}ms cubic-bezier(.25, .8, .50, 1)`;
      this.animating = true;
      this.done = done;
    },
    __end(el, event) {
      el.style.overflowY = null;
      el.style.height = null;
      el.style.transition = null;
      this.__cleanup();
      event !== this.lastEvent && this.$emit(event);
    },
    __cleanup() {
      this.done && this.done();
      this.done = null;
      this.animating = false;
      clearTimeout(this.timer);
      clearTimeout(this.timerFallback);
      this.el !== void 0 && this.el.removeEventListener('transitionend', this.animListener);
      this.animListener = null;
    }
  },
  beforeDestroy() {
    this.animating && this.__cleanup();
  },
  render(h) {
    return h('transition', {
      props: {
        css: false,
        appear: this.appear
      },
      on: Object(cache["b" /* default */])(this, 'tr', {
        enter: (el, done) => {
          let pos = 0;
          this.el = el;

          // if animationg overflowY is already 'hidden'
          if (this.animating === true) {
            this.__cleanup();
            pos = el.offsetHeight === el.scrollHeight ? 0 : void 0;
          } else {
            this.lastEvent = 'hide';
            el.style.overflowY = 'hidden';
          }
          this.__begin(el, pos, done);
          this.timer = setTimeout(() => {
            el.style.height = `${el.scrollHeight}px`;
            this.animListener = evt => {
              if (Object(evt) !== evt || evt.target === el) {
                this.__end(el, 'show');
              }
            };
            el.addEventListener('transitionend', this.animListener);
            this.timerFallback = setTimeout(this.animListener, this.duration * 1.1);
          }, 100);
        },
        leave: (el, done) => {
          let pos;
          this.el = el;
          if (this.animating === true) {
            this.__cleanup();
          } else {
            this.lastEvent = 'show';
            // we need to set overflowY 'hidden' before calculating the height
            // or else we get small differences
            el.style.overflowY = 'hidden';
            pos = el.scrollHeight;
          }
          this.__begin(el, pos, done);
          this.timer = setTimeout(() => {
            el.style.height = 0;
            this.animListener = evt => {
              if (Object(evt) !== evt || evt.target === el) {
                this.__end(el, 'hide');
              }
            };
            el.addEventListener('transitionend', this.animListener);
            this.timerFallback = setTimeout(this.animListener, this.duration * 1.1);
          }, 100);
        }
      })
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/separator/QSeparator.js
var QSeparator = __webpack_require__("6485");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/model-toggle.js
var model_toggle = __webpack_require__("1dd9");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/expansion-item/QExpansionItem.js















const eventName = 'q:expansion-item:close';
const LINK_PROPS = Object.keys(router_link["b" /* routerLinkProps */]);
/* harmony default export */ var QExpansionItem = (external_vue_default.a.extend({
  name: 'QExpansionItem',
  mixins: [dark["a" /* default */], timeout["a" /* default */], model_toggle["a" /* default */]],
  props: {
    ...router_link["b" /* routerLinkProps */],
    icon: String,
    label: String,
    labelLines: [Number, String],
    caption: String,
    captionLines: [Number, String],
    dense: Boolean,
    toggleAriaLabel: String,
    expandIcon: String,
    expandedIcon: String,
    expandIconClass: [Array, String, Object],
    duration: Number,
    headerInsetLevel: Number,
    contentInsetLevel: Number,
    expandSeparator: Boolean,
    defaultOpened: Boolean,
    hideExpandIcon: Boolean,
    expandIconToggle: Boolean,
    switchToggleSide: Boolean,
    denseToggle: Boolean,
    group: String,
    popup: Boolean,
    headerStyle: [Array, String, Object],
    headerClass: [Array, String, Object]
  },
  data() {
    return {
      showing: this.value !== void 0 ? this.value : this.defaultOpened
    };
  },
  watch: {
    showing(val) {
      val === true && this.group !== void 0 && this.$root.$emit(eventName, this);
    },
    group(newVal, oldVal) {
      if (newVal !== void 0 && oldVal === void 0) {
        this.$root.$on(eventName, this.__eventHandler);
      } else if (newVal === void 0 && oldVal !== void 0) {
        this.$root.$off(eventName, this.__eventHandler);
      }
    }
  },
  computed: {
    classes() {
      return `q-expansion-item--${this.showing === true ? 'expanded' : 'collapsed'}` + ` q-expansion-item--${this.popup === true ? 'popup' : 'standard'}`;
    },
    contentStyle() {
      if (this.contentInsetLevel !== void 0) {
        const dir = this.$q.lang.rtl === true ? 'Right' : 'Left';
        return {
          ['padding' + dir]: this.contentInsetLevel * 56 + 'px'
        };
      }
    },
    hasLink() {
      return this.disable !== true && (this.href !== void 0 || this.to !== void 0 && this.to !== null && this.to !== '');
    },
    linkProps() {
      const acc = {};
      LINK_PROPS.forEach(key => {
        acc[key] = this[key];
      });
      return acc;
    },
    isClickable() {
      return this.hasLink === true || this.expandIconToggle !== true;
    },
    expansionIcon() {
      return this.expandedIcon !== void 0 && this.showing === true ? this.expandedIcon : this.expandIcon || this.$q.iconSet.expansionItem[this.denseToggle === true ? 'denseIcon' : 'icon'];
    },
    activeToggleIcon() {
      return this.disable !== true && (this.hasLink === true || this.expandIconToggle === true);
    },
    headerSlotScope() {
      return {
        expanded: this.showing === true,
        detailsId: this.targetUid,
        toggle: this.toggle,
        show: this.show,
        hide: this.hide
      };
    },
    toggleAriaAttrs() {
      const toggleAriaLabel = this.toggleAriaLabel !== void 0 ? this.toggleAriaLabel : this.$q.lang.label[this.showing === true ? 'collapse' : 'expand'](this.label);
      return {
        role: 'button',
        'aria-expanded': this.showing === true ? 'true' : 'false',
        'aria-controls': this.targetUid,
        'aria-label': toggleAriaLabel
      };
    }
  },
  methods: {
    __onHeaderClick(e) {
      this.hasLink !== true && this.toggle(e);
      this.$emit('click', e);
    },
    __toggleIconKeyboard(e) {
      e.keyCode === 13 && this.__toggleIcon(e, true);
    },
    __toggleIcon(e, keyboard) {
      keyboard !== true && this.$refs.blurTarget !== void 0 && this.$refs.blurTarget.focus();
      this.toggle(e);
      Object(utils_event["l" /* stopAndPrevent */])(e);
    },
    __eventHandler(comp) {
      this !== comp && this.group === comp.group && this.hide();
    },
    __getToggleIcon(h) {
      const data = {
        staticClass: `q-focusable relative-position cursor-pointer${this.denseToggle === true && this.switchToggleSide === true ? ' items-end' : ''}`,
        class: this.expandIconClass,
        props: {
          side: this.switchToggleSide !== true,
          avatar: this.switchToggleSide
        }
      };
      const child = [h(QIcon["a" /* default */], {
        staticClass: 'q-expansion-item__toggle-icon',
        class: this.expandedIcon === void 0 && this.showing === true ? 'q-expansion-item__toggle-icon--rotated' : void 0,
        props: {
          name: this.expansionIcon
        }
      })];
      if (this.activeToggleIcon === true) {
        Object.assign(data, {
          attrs: {
            tabindex: 0,
            ...this.toggleAriaAttrs
          },
          on: Object(cache["b" /* default */])(this, 'inpExt', {
            click: this.__toggleIcon,
            keyup: this.__toggleIconKeyboard
          })
        });
        child.unshift(h('div', {
          ref: 'blurTarget',
          staticClass: 'q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded',
          attrs: {
            tabindex: -1
          }
        }));
      }
      return h(QItemSection["a" /* default */], data, child);
    },
    __getHeader(h) {
      let child;
      if (this.$scopedSlots.header !== void 0) {
        child = [].concat(this.$scopedSlots.header(this.headerSlotScope));
      } else {
        child = [h(QItemSection["a" /* default */], [h(QItemLabel["a" /* default */], {
          props: {
            lines: this.labelLines
          }
        }, [this.label || '']), this.caption ? h(QItemLabel["a" /* default */], {
          props: {
            lines: this.captionLines,
            caption: true
          }
        }, [this.caption]) : null])];
        this.icon && child[this.switchToggleSide === true ? 'push' : 'unshift'](h(QItemSection["a" /* default */], {
          props: {
            side: this.switchToggleSide === true,
            avatar: this.switchToggleSide !== true
          }
        }, [h(QIcon["a" /* default */], {
          props: {
            name: this.icon
          }
        })]));
      }
      this.disable !== true && this.hideExpandIcon !== true && child[this.switchToggleSide === true ? 'unshift' : 'push'](this.__getToggleIcon(h));
      const data = {
        ref: 'item',
        style: this.headerStyle,
        class: this.headerClass,
        props: {
          dark: this.isDark,
          disable: this.disable,
          dense: this.dense,
          insetLevel: this.headerInsetLevel
        }
      };
      if (this.isClickable === true) {
        data.props.clickable = true;
        if (this.hasLink === true) {
          Object.assign(data.props, this.linkProps);
        } else {
          data.attrs = this.toggleAriaAttrs;
        }
        data.on = {
          ...this.qListeners,
          click: this.__onHeaderClick
        };
      }
      return h(QItem["a" /* default */], data, child);
    },
    __getContent(h) {
      const node = [this.__getHeader(h), h(QSlideTransition, {
        props: {
          duration: this.duration
        },
        on: Object(cache["b" /* default */])(this, 'slide', {
          show: () => {
            this.$emit('after-show');
          },
          hide: () => {
            this.$emit('after-hide');
          }
        })
      }, [h('div', {
        staticClass: 'q-expansion-item__content relative-position',
        style: this.contentStyle,
        attrs: {
          id: this.targetUid
        },
        directives: [{
          name: 'show',
          value: this.showing
        }]
      }, Object(private_slot["c" /* slot */])(this, 'default'))])];
      if (this.expandSeparator) {
        node.push(h(QSeparator["a" /* default */], {
          staticClass: 'q-expansion-item__border q-expansion-item__border--top absolute-top',
          props: {
            dark: this.isDark
          }
        }), h(QSeparator["a" /* default */], {
          staticClass: 'q-expansion-item__border q-expansion-item__border--bottom absolute-bottom',
          props: {
            dark: this.isDark
          }
        }));
      }
      return node;
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-expansion-item q-item-type',
      class: this.classes
    }, [h('div', {
      staticClass: 'q-expansion-item__container relative-position'
    }, this.__getContent(h))]);
  },
  created() {
    this.group !== void 0 && this.$root.$on(eventName, this.__eventHandler);
    this.targetUid = `e_${Object(uid["a" /* default */])()}`;
  },
  beforeDestroy() {
    this.group !== void 0 && this.$root.$off(eventName, this.__eventHandler);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/expansion-item/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/mixins/fab.js

const labelPositions = ['top', 'right', 'bottom', 'left'];
/* harmony default export */ var fab = ({
  mixins: [listeners["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'a'
    },
    outline: Boolean,
    push: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    color: String,
    textColor: String,
    glossy: Boolean,
    square: Boolean,
    padding: String,
    label: {
      type: [String, Number],
      default: ''
    },
    labelPosition: {
      type: String,
      default: 'right',
      validator: v => labelPositions.includes(v)
    },
    externalLabel: Boolean,
    hideLabel: {
      type: Boolean
    },
    labelClass: [Array, String, Object],
    labelStyle: [Array, String, Object],
    disable: Boolean,
    tabindex: [Number, String]
  },
  computed: {
    formClass() {
      return `q-fab--form-${this.square === true ? 'square' : 'rounded'}`;
    },
    stacked() {
      return this.externalLabel === false && ['top', 'bottom'].includes(this.labelPosition);
    },
    labelProps() {
      if (this.externalLabel === true) {
        const hideLabel = this.hideLabel === null ? this.showing === false : this.hideLabel;
        return {
          action: 'push',
          data: {
            staticClass: 'q-fab__label q-tooltip--style q-fab__label--external' + ` q-fab__label--external-${this.labelPosition}` + (hideLabel === true ? ' q-fab__label--external-hidden' : ''),
            style: this.labelStyle,
            class: this.labelClass
          }
        };
      }
      return {
        action: ['left', 'top'].includes(this.labelPosition) ? 'unshift' : 'push',
        data: {
          staticClass: `q-fab__label q-fab__label--internal q-fab__label--internal-${this.labelPosition}` + (this.hideLabel === true ? ' q-fab__label--internal-hidden' : ''),
          style: this.labelStyle,
          class: this.labelClass
        }
      };
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/fab/QFab.js









const directions = ['up', 'right', 'down', 'left'];
const QFab_alignValues = ['left', 'center', 'right'];
/* harmony default export */ var QFab = (external_vue_default.a.extend({
  name: 'QFab',
  inheritAttrs: false,
  mixins: [fab, mixins_attrs["b" /* default */], model_toggle["a" /* default */]],
  provide() {
    return {
      __qFab: this
    };
  },
  props: {
    icon: String,
    activeIcon: String,
    hideIcon: Boolean,
    hideLabel: {
      default: null
    },
    direction: {
      type: String,
      default: 'right',
      validator: v => directions.includes(v)
    },
    persistent: Boolean,
    verticalActionsAlign: {
      type: String,
      default: 'center',
      validator: v => QFab_alignValues.includes(v)
    }
  },
  data() {
    return {
      showing: this.value === true
    };
  },
  computed: {
    hideOnRouteChange() {
      return this.persistent !== true;
    },
    classes() {
      return `q-fab--align-${this.verticalActionsAlign} ${this.formClass}` + (this.showing === true ? ' q-fab--opened' : '');
    },
    actionsClasses() {
      return `q-fab__actions--${this.direction}` + (this.showing === true ? ' q-fab__actions--opened' : '');
    },
    actionsAttrs() {
      const attrs = {
        id: this.targetUid,
        role: 'menu'
      };
      if (this.showing !== true) {
        attrs['aria-hidden'] = 'true';
      }
      return attrs;
    },
    iconHolderClasses() {
      return this.showing === true ? 'q-fab__icon-holder--opened' : '';
    },
    attrs() {
      return {
        'aria-expanded': this.showing === true ? 'true' : 'false',
        'aria-haspopup': 'true',
        'aria-controls': this.targetUid,
        ...this.qAttrs
      };
    },
    slotScope() {
      return {
        opened: this.showing
      };
    }
  },
  methods: {
    __onChildClick(evt) {
      this.hide(evt);
      if (this.$refs.trigger && this.$refs.trigger.$el) {
        this.$refs.trigger.$el.focus();
      }
    },
    __getIcon(h, kebab, camel) {
      const slotFn = this.$scopedSlots[kebab];
      const staticClass = `q-fab__${kebab} absolute-full`;
      return slotFn === void 0 ? h(QIcon["a" /* default */], {
        staticClass,
        props: {
          name: this[camel] || this.$q.iconSet.fab[camel]
        }
      }) : h('div', {
        staticClass
      }, slotFn(this.slotScope));
    }
  },
  render(h) {
    const child = [];
    this.hideIcon !== true && child.push(h('div', {
      staticClass: 'q-fab__icon-holder',
      class: this.iconHolderClasses
    }, [this.__getIcon(h, 'icon', 'icon'), this.__getIcon(h, 'active-icon', 'activeIcon')]));
    if (this.label !== '' || this.$scopedSlots.label !== void 0) {
      child[this.labelProps.action](h('div', this.labelProps.data, this.$scopedSlots.label !== void 0 ? this.$scopedSlots.label(this.slotScope) : [this.label]));
    }
    return h('div', {
      staticClass: 'q-fab z-fab row inline justify-center',
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, [h(QBtn["a" /* default */], {
      ref: 'trigger',
      class: this.formClass,
      props: {
        ...this.$props,
        noWrap: true,
        stack: this.stacked,
        align: void 0,
        icon: void 0,
        label: void 0,
        noCaps: true,
        fab: true
      },
      attrs: this.attrs,
      on: Object(cache["b" /* default */])(this, 'tog', {
        click: this.toggle
      })
    }, Object(private_slot["a" /* mergeSlot */])(child, this, 'tooltip')), h('div', {
      staticClass: 'q-fab__actions flex no-wrap inline',
      class: this.actionsClasses,
      attrs: this.actionsAttrs
    }, Object(private_slot["c" /* slot */])(this, 'default'))]);
  },
  created() {
    this.targetUid = `fb_${Object(uid["a" /* default */])()}`;
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/fab/QFabAction.js






const anchorMap = {
  start: 'self-end',
  center: 'self-center',
  end: 'self-start'
};
const anchorValues = Object.keys(anchorMap);
/* harmony default export */ var QFabAction = (external_vue_default.a.extend({
  name: 'QFabAction',
  mixins: [fab],
  props: {
    icon: {
      type: String,
      default: ''
    },
    anchor: {
      type: String,
      validator: v => anchorValues.includes(v)
    },
    to: [String, Object],
    replace: Boolean
  },
  inject: {
    __qFab: {
      default() {
        return {
          showing: true,
          __onChildClick: utils_event["g" /* noop */]
        };
      }
    }
  },
  computed: {
    classes() {
      const align = anchorMap[this.anchor];
      return this.formClass + (align !== void 0 ? ` ${align}` : '');
    },
    onEvents() {
      return {
        ...this.qListeners,
        click: this.click
      };
    },
    isDisabled() {
      return this.__qFab.showing !== true || this.disable === true;
    }
  },
  methods: {
    click(e) {
      this.__qFab.__onChildClick(e);
      this.$emit('click', e);
    }
  },
  render(h) {
    const child = [];
    if (this.$scopedSlots.icon !== void 0) {
      child.push(this.$scopedSlots.icon());
    } else if (this.icon !== '') {
      child.push(h(QIcon["a" /* default */], {
        props: {
          name: this.icon
        }
      }));
    }
    if (this.label !== '' || this.$scopedSlots.label !== void 0) {
      child[this.labelProps.action](h('div', this.labelProps.data, this.$scopedSlots.label !== void 0 ? this.$scopedSlots.label() : [this.label]));
    }
    return h(QBtn["a" /* default */], {
      class: this.classes,
      props: {
        ...this.$props,
        noWrap: true,
        stack: this.stacked,
        icon: void 0,
        label: void 0,
        noCaps: true,
        fabMini: true,
        disable: this.isDisabled
      },
      on: this.onEvents
    }, Object(private_slot["a" /* mergeSlot */])(child, this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/fab/index.js



// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/field/QField.js + 1 modules
var QField = __webpack_require__("135c");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/field/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/file.js
var mixins_file = __webpack_require__("a439");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/file/QFile.js









/* harmony default export */ var QFile = (external_vue_default.a.extend({
  name: 'QFile',
  mixins: [QField["a" /* default */], mixins_file["b" /* default */], mixins_form["a" /* FormFieldMixin */], mixins_file["a" /* FileValueMixin */]],
  props: {
    /* SSR does not know about File & FileList */
    value: Platform["e" /* isSSR */] === true ? {} : [File, FileList, Array],
    append: Boolean,
    useChips: Boolean,
    displayValue: [String, Number],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    counterLabel: Function,
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  data() {
    return {
      dnd: false
    };
  },
  computed: {
    innerValue() {
      return Object(this.value) === this.value ? 'length' in this.value ? Array.from(this.value) : [this.value] : [];
    },
    selectedString() {
      return this.innerValue.map(file => file.name).join(', ');
    },
    totalSize() {
      return Object(format["c" /* humanStorageSize */])(this.innerValue.reduce((acc, file) => acc + file.size, 0));
    },
    counterProps() {
      return {
        totalSize: this.totalSize,
        filesNumber: this.innerValue.length,
        maxFiles: this.maxFiles
      };
    },
    computedCounter() {
      if (this.counterLabel !== void 0) {
        return this.counterLabel(this.counterProps);
      }
      const max = this.maxFiles;
      return `${this.innerValue.length}${max !== void 0 ? ' / ' + max : ''} (${this.totalSize})`;
    },
    inputAttrs() {
      return {
        tabindex: -1,
        type: 'file',
        title: '',
        // try to remove default tooltip,
        accept: this.accept,
        capture: this.capture,
        name: this.nameProp,
        ...this.qAttrs,
        id: this.targetUid,
        disabled: this.editable !== true
      };
    },
    isAppending() {
      return this.multiple === true && this.append === true;
    },
    fieldClass() {
      return 'q-file q-field--auto-height' + (this.dnd === true ? ' q-file--dnd' : '');
    }
  },
  methods: {
    removeAtIndex(index) {
      const files = this.innerValue.slice();
      files.splice(index, 1);
      this.__emitValue(files);
    },
    removeFile(file) {
      const index = this.innerValue.indexOf(file);
      if (index > -1) {
        this.removeAtIndex(index);
      }
    },
    __emitValue(files) {
      this.$emit('input', this.multiple === true ? files : files[0]);
    },
    __onKeydown(e) {
      // prevent form submit if ENTER is pressed
      e.keyCode === 13 && Object(utils_event["i" /* prevent */])(e);
    },
    __onKeyup(e) {
      // only on ENTER and SPACE to match native input field
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.pickFiles(e);
      }
    },
    __getFileInput() {
      return this.$refs.input;
    },
    __addFiles(e, fileList) {
      const files = this.__processFiles(e, fileList, this.innerValue, this.isAppending);
      const fileInput = this.__getFileInput();
      if (fileInput !== void 0) {
        fileInput.value = '';
      }

      // if nothing to do...
      if (files === void 0) {
        return;
      }

      // protect against input @change being called in a loop
      // like it happens on Safari, so don't emit same thing:
      if (this.multiple === true ? this.value && files.every(f => this.innerValue.includes(f)) : this.value === files[0]) {
        return;
      }
      this.__emitValue(this.isAppending === true ? this.innerValue.concat(files) : files);
    },
    __getControl(h) {
      const data = {
        ref: 'target',
        staticClass: 'q-field__native row items-center cursor-pointer',
        attrs: {
          tabindex: this.tabindex
        }
      };
      if (this.editable === true) {
        data.on = Object(cache["b" /* default */])(this, 'native', {
          dragover: this.__onDragOver,
          dragleave: this.__onDragLeave,
          keydown: this.__onKeydown,
          keyup: this.__onKeyup
        });
      }
      return h('div', data, [this.__getInput(h)].concat(this.__getSelection(h)));
    },
    __getControlChild(h) {
      return this.__getDnd(h, 'file');
    },
    __getFiller(h) {
      return [h('input', {
        class: [this.inputClass, 'q-file__filler'],
        style: this.inputStyle
      })];
    },
    __getSelection(h) {
      if (this.$scopedSlots.file !== void 0) {
        return this.innerValue.length === 0 ? this.__getFiller(h) : this.innerValue.map((file, index) => this.$scopedSlots.file({
          index,
          file,
          ref: this
        }));
      }
      if (this.$scopedSlots.selected !== void 0) {
        return this.innerValue.length === 0 ? this.__getFiller(h) : this.$scopedSlots.selected({
          files: this.innerValue,
          ref: this
        });
      }
      if (this.useChips === true) {
        return this.innerValue.length === 0 ? this.__getFiller(h) : this.innerValue.map((file, i) => h(QChip["a" /* default */], {
          key: 'file-' + i,
          props: {
            removable: this.editable,
            dense: true,
            textColor: this.color,
            tabindex: this.tabindex
          },
          on: Object(cache["b" /* default */])(this, 'rem#' + i, {
            remove: () => {
              this.removeAtIndex(i);
            }
          })
        }, [h('span', {
          staticClass: 'ellipsis',
          domProps: {
            textContent: file.name
          }
        })]));
      }
      const textContent = this.displayValue !== void 0 ? this.displayValue : this.selectedString;
      return textContent.length > 0 ? [h('div', {
        style: this.inputStyle,
        class: this.inputClass,
        domProps: {
          textContent
        }
      })] : this.__getFiller(h);
    },
    __getInput(h) {
      const data = {
        ref: 'input',
        staticClass: 'q-field__input fit absolute-full cursor-pointer',
        attrs: this.inputAttrs,
        domProps: this.formDomProps,
        on: Object(cache["b" /* default */])(this, 'input', {
          change: this.__addFiles
        })
      };
      if (this.multiple === true) {
        data.attrs.multiple = true;
      }
      return h('input', data);
    }
  },
  created() {
    // necessary for QField's clearable
    // and FileValueMixin
    this.type = 'file';
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/file/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/footer/QFooter.js







/* harmony default export */ var QFooter = (external_vue_default.a.extend({
  name: 'QFooter',
  mixins: [listeners["a" /* default */]],
  inject: {
    layout: {
      default() {
        console.error('QFooter needs to be child of QLayout');
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  data() {
    return {
      size: parseInt(this.heightHint, 10),
      revealed: true,
      windowHeight: Platform["f" /* onSSR */] || this.layout.container ? 0 : window.innerHeight
    };
  },
  watch: {
    value(val) {
      this.__update('space', val);
      this.__updateLocal('revealed', true);
      this.layout.__animate();
    },
    offset(val) {
      this.__update('offset', val);
    },
    reveal(val) {
      val === false && this.__updateLocal('revealed', this.value);
    },
    revealed(val) {
      this.layout.__animate();
      this.$emit('reveal', val);
    },
    'layout.scroll'() {
      this.__updateRevealed();
    },
    'layout.height'() {
      this.__updateRevealed();
    },
    size() {
      this.__updateRevealed();
    },
    '$q.screen.height'(val) {
      this.layout.container !== true && this.__updateLocal('windowHeight', val);
    }
  },
  computed: {
    fixed() {
      return this.reveal === true || this.layout.view.indexOf('F') > -1 || this.$q.platform.is.ios && this.layout.container === true;
    },
    containerHeight() {
      return this.layout.container === true ? this.layout.containerHeight : this.windowHeight;
    },
    offset() {
      if (this.value !== true) {
        return 0;
      }
      if (this.fixed === true) {
        return this.revealed === true ? this.size : 0;
      }
      const offset = this.layout.scroll.position + this.containerHeight + this.size - this.layout.height;
      return offset > 0 ? offset : 0;
    },
    hidden() {
      return this.value !== true || this.fixed === true && this.revealed !== true;
    },
    revealOnFocus() {
      return this.value === true && this.hidden === true && this.reveal === true;
    },
    classes() {
      return (this.fixed === true ? 'fixed' : 'absolute') + '-bottom' + (this.bordered === true ? ' q-footer--bordered' : '') + (this.hidden === true ? ' q-footer--hidden' : '') + (this.value !== true ? ' q-layout--prevent-focus' : '') + (this.value !== true && this.fixed !== true ? ' hidden' : '');
    },
    style() {
      const view = this.layout.rows.bottom,
        css = {};
      if (view[0] === 'l' && this.layout.left.space === true) {
        css[this.$q.lang.rtl === true ? 'right' : 'left'] = `${this.layout.left.size}px`;
      }
      if (view[2] === 'r' && this.layout.right.space === true) {
        css[this.$q.lang.rtl === true ? 'left' : 'right'] = `${this.layout.right.size}px`;
      }
      return css;
    },
    onEvents() {
      return {
        ...this.qListeners,
        focusin: this.__onFocusin,
        input: utils_event["k" /* stop */]
      };
    }
  },
  render(h) {
    const child = Object(private_slot["a" /* mergeSlot */])([h(QResizeObserver["a" /* default */], {
      props: {
        debounce: 0
      },
      on: Object(cache["b" /* default */])(this, 'resize', {
        resize: this.__onResize
      })
    })], this, 'default');
    this.elevated === true && child.push(h('div', {
      staticClass: 'q-layout__shadow absolute-full overflow-hidden no-pointer-events'
    }));
    return h('footer', {
      staticClass: 'q-footer q-layout__section--marginal',
      class: this.classes,
      style: this.style,
      on: this.onEvents
    }, child);
  },
  created() {
    this.layout.instances.footer = this;
    this.value === true && this.__update('size', this.size);
    this.__update('space', this.value);
    this.__update('offset', this.offset);
  },
  beforeDestroy() {
    if (this.layout.instances.footer === this) {
      this.layout.instances.footer = void 0;
      this.__update('size', 0);
      this.__update('offset', 0);
      this.__update('space', false);
    }
  },
  methods: {
    __onResize({
      height
    }) {
      this.__updateLocal('size', height);
      this.__update('size', height);
    },
    __update(prop, val) {
      if (this.layout.footer[prop] !== val) {
        this.layout.footer[prop] = val;
      }
    },
    __updateLocal(prop, val) {
      if (this[prop] !== val) {
        this[prop] = val;
      }
    },
    __updateRevealed() {
      if (this.reveal !== true) {
        return;
      }
      const {
        direction,
        position,
        inflexionPosition
      } = this.layout.scroll;
      this.__updateLocal('revealed', direction === 'up' || position - inflexionPosition < 100 || this.layout.height - this.containerHeight - position - this.size < 300);
    },
    __onFocusin(evt) {
      if (this.revealOnFocus === true) {
        this.__updateLocal('revealed', true);
      }
      this.$emit('focusin', evt);
    }
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/footer/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/form/QForm.js





/* harmony default export */ var QForm = (external_vue_default.a.extend({
  name: 'QForm',
  mixins: [listeners["a" /* default */]],
  props: {
    autofocus: Boolean,
    noErrorFocus: Boolean,
    noResetFocus: Boolean,
    greedy: Boolean
  },
  computed: {
    onEvents() {
      return {
        ...this.qListeners,
        submit: this.submit,
        reset: this.reset
      };
    }
  },
  mounted() {
    this.validateIndex = 0;
    this.autofocus === true && this.focus();
  },
  activated() {
    if (this.shouldActivate !== true) {
      return;
    }
    this.autofocus === true && this.focus();
  },
  deactivated() {
    this.shouldActivate = true;
  },
  methods: {
    validate(shouldFocus) {
      const focus = typeof shouldFocus === 'boolean' ? shouldFocus : this.noErrorFocus !== true;
      const index = ++this.validateIndex;
      const registeredComponents = this.getValidationComponents().filter(c => c.disable !== true);
      const emit = (res, ref) => {
        this.$emit('validation-' + (res === true ? 'success' : 'error'), ref);
      };
      const validateComponent = comp => {
        const valid = comp.validate();
        return typeof valid.then === 'function' ? valid.then(valid => ({
          valid,
          comp
        }), err => ({
          valid: false,
          comp,
          err
        })) : Promise.resolve({
          valid,
          comp
        });
      };
      const errorsPromise = this.greedy === true ? Promise.all(registeredComponents.map(validateComponent)).then(res => res.filter(r => r.valid !== true)) : registeredComponents.reduce((acc, comp) => acc.then(() => {
        return validateComponent(comp).then(r => {
          if (r.valid === false) {
            return Promise.reject(r);
          }
        });
      }), Promise.resolve()).catch(error => [error]);
      return errorsPromise.then(errors => {
        if (errors === void 0 || errors.length === 0) {
          index === this.validateIndex && emit(true);
          return true;
        }
        if (index === this.validateIndex) {
          const {
            comp,
            err
          } = errors[0];
          err !== void 0 && console.error(err);
          emit(false, comp);
          if (focus === true) {
            // Try to focus first mounted and active component
            const activeError = errors.find(({
              comp
            }) => typeof comp.focus === 'function' && comp._isBeingDestroyed !== true && comp._isDestroyed !== true && comp._inactive !== true);
            if (activeError !== void 0) {
              activeError.comp.focus();
            }
          }
        }
        return false;
      });
    },
    resetValidation() {
      this.validateIndex++;
      this.getValidationComponents().forEach(comp => {
        typeof comp.resetValidation === 'function' && comp.resetValidation();
      });
    },
    submit(evt) {
      evt !== void 0 && Object(utils_event["l" /* stopAndPrevent */])(evt);
      const index = this.validateIndex + 1;
      this.validate().then(val => {
        // if not outdated && validation succeeded
        if (index === this.validateIndex && val === true) {
          if (this.qListeners.submit !== void 0) {
            this.$emit('submit', evt);
          } else if (evt !== void 0 && evt.target !== void 0 && typeof evt.target.submit === 'function') {
            evt.target.submit();
          }
        }
      });
    },
    reset(evt) {
      evt !== void 0 && Object(utils_event["l" /* stopAndPrevent */])(evt);
      this.$emit('reset');
      this.$nextTick(() => {
        // allow userland to reset values before
        this.resetValidation();
        if (this.autofocus === true && this.noResetFocus !== true) {
          this.focus();
        }
      });
    },
    focus() {
      Object(focus_manager["a" /* addFocusFn */])(() => {
        if (!this.$el) {
          return;
        }
        const target = this.$el.querySelector('[autofocus][tabindex], [data-autofocus][tabindex]') || this.$el.querySelector('[autofocus] [tabindex], [data-autofocus] [tabindex]') || this.$el.querySelector('[autofocus], [data-autofocus]') || Array.prototype.find.call(this.$el.querySelectorAll('[tabindex]'), el => el.tabIndex > -1);
        target !== null && target !== void 0 && target.focus({
          preventScroll: true
        });
      });
    },
    getValidationComponents() {
      return Array.prototype.map.call(this.$el.getElementsByClassName('q-validation-component'), field => field.__vue__).filter(c => c !== void 0 && typeof c.validate === 'function');
    }
  },
  render(h) {
    return h('form', {
      staticClass: 'q-form',
      on: this.onEvents
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/form/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/header/QHeader.js






/* harmony default export */ var QHeader = (external_vue_default.a.extend({
  name: 'QHeader',
  mixins: [listeners["a" /* default */]],
  inject: {
    layout: {
      default() {
        console.error('QHeader needs to be child of QLayout');
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    revealOffset: {
      type: Number,
      default: 250
    },
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  data() {
    return {
      size: parseInt(this.heightHint, 10),
      revealed: true
    };
  },
  watch: {
    value(val) {
      this.__update('space', val);
      this.__updateLocal('revealed', true);
      this.layout.__animate();
    },
    offset(val) {
      this.__update('offset', val);
    },
    reveal(val) {
      val === false && this.__updateLocal('revealed', this.value);
    },
    revealed(val) {
      this.layout.__animate();
      this.$emit('reveal', val);
    },
    'layout.scroll'(scroll) {
      this.reveal === true && this.__updateLocal('revealed', scroll.direction === 'up' || scroll.position <= this.revealOffset || scroll.position - scroll.inflexionPosition < 100);
    }
  },
  computed: {
    fixed() {
      return this.reveal === true || this.layout.view.indexOf('H') > -1 || this.$q.platform.is.ios && this.layout.container === true;
    },
    offset() {
      if (this.value !== true) {
        return 0;
      }
      if (this.fixed === true) {
        return this.revealed === true ? this.size : 0;
      }
      const offset = this.size - this.layout.scroll.position;
      return offset > 0 ? offset : 0;
    },
    hidden() {
      return this.value !== true || this.fixed === true && this.revealed !== true;
    },
    revealOnFocus() {
      return this.value === true && this.hidden === true && this.reveal === true;
    },
    classes() {
      return (this.fixed === true ? 'fixed' : 'absolute') + '-top' + (this.bordered === true ? ' q-header--bordered' : '') + (this.hidden === true ? ' q-header--hidden' : '') + (this.value !== true ? ' q-layout--prevent-focus' : '');
    },
    style() {
      const view = this.layout.rows.top,
        css = {};
      if (view[0] === 'l' && this.layout.left.space === true) {
        css[this.$q.lang.rtl === true ? 'right' : 'left'] = `${this.layout.left.size}px`;
      }
      if (view[2] === 'r' && this.layout.right.space === true) {
        css[this.$q.lang.rtl === true ? 'left' : 'right'] = `${this.layout.right.size}px`;
      }
      return css;
    },
    onEvents() {
      return {
        ...this.qListeners,
        focusin: this.__onFocusin,
        input: utils_event["k" /* stop */]
      };
    }
  },
  render(h) {
    const child = Object(private_slot["d" /* uniqueSlot */])(this, 'default', []);
    this.elevated === true && child.push(h('div', {
      staticClass: 'q-layout__shadow absolute-full overflow-hidden no-pointer-events'
    }));
    child.push(h(QResizeObserver["a" /* default */], {
      props: {
        debounce: 0
      },
      on: Object(cache["b" /* default */])(this, 'resize', {
        resize: this.__onResize
      })
    }));
    return h('header', {
      staticClass: 'q-header q-layout__section--marginal',
      class: this.classes,
      style: this.style,
      on: this.onEvents
    }, child);
  },
  created() {
    this.layout.instances.header = this;
    this.value === true && this.__update('size', this.size);
    this.__update('space', this.value);
    this.__update('offset', this.offset);
  },
  beforeDestroy() {
    if (this.layout.instances.header === this) {
      this.layout.instances.header = void 0;
      this.__update('size', 0);
      this.__update('offset', 0);
      this.__update('space', false);
    }
  },
  methods: {
    __onResize({
      height
    }) {
      this.__updateLocal('size', height);
      this.__update('size', height);
    },
    __update(prop, val) {
      if (this.layout.header[prop] !== val) {
        this.layout.header[prop] = val;
      }
    },
    __updateLocal(prop, val) {
      if (this[prop] !== val) {
        this[prop] = val;
      }
    },
    __onFocusin(evt) {
      if (this.revealOnFocus === true) {
        this.__updateLocal('revealed', true);
      }
      this.$emit('focusin', evt);
    }
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/header/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/icon/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinner.js
var QSpinner = __webpack_require__("88a8");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/mixins/ratio.js
/* harmony default export */ var mixins_ratio = ({
  props: {
    ratio: [String, Number]
  },
  computed: {
    ratioStyle() {
      const ratio = this.ratio || this.naturalRatio;
      if (ratio !== void 0) {
        return {
          paddingBottom: `${100 / ratio}%`
        };
      }
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/img/QImg.js





/* harmony default export */ var QImg = (external_vue_default.a.extend({
  name: 'QImg',
  mixins: [listeners["a" /* default */], mixins_ratio],
  props: {
    src: String,
    srcset: String,
    sizes: String,
    alt: String,
    width: String,
    height: String,
    placeholderSrc: String,
    basic: Boolean,
    contain: Boolean,
    position: {
      type: String,
      default: '50% 50%'
    },
    transition: {
      type: String,
      default: 'fade'
    },
    imgClass: [Array, String, Object],
    imgStyle: Object,
    nativeContextMenu: Boolean,
    notDraggable: Boolean,
    noDefaultSpinner: Boolean,
    spinnerColor: String,
    spinnerSize: String
  },
  data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: !!this.src,
      hasError: false,
      naturalRatio: void 0
    };
  },
  watch: {
    src() {
      this.__load();
    },
    srcset(val) {
      this.__updateWatcher(val);
    }
  },
  computed: {
    url() {
      return this.currentSrc || this.placeholderSrc || void 0;
    },
    attrs() {
      const att = {
        role: 'img'
      };
      if (this.alt !== void 0) {
        att['aria-label'] = this.alt;
      }
      return att;
    },
    imgAttrs() {
      const att = {
        src: this.url,
        'aria-hidden': 'true'
      };
      if (this.notDraggable === true) {
        att.draggable = false;
      }
      return att;
    },
    imgContainerStyle() {
      return Object.assign({
        backgroundSize: this.contain === true ? 'contain' : 'cover',
        backgroundPosition: this.position
      }, this.imgStyle, {
        backgroundImage: `url("${this.url}")`
      });
    },
    style() {
      return {
        width: this.width,
        height: this.height
      };
    },
    classes() {
      return 'q-img overflow-hidden' + (this.nativeContextMenu === true ? ' q-img--menu' : '');
    }
  },
  methods: {
    __onLoad(img) {
      this.isLoading = false;
      this.hasError = false;
      this.__computeRatio(img);
      this.__updateSrc();
      this.__updateWatcher(this.srcset);
      this.$emit('load', this.currentSrc);
    },
    __onError(err) {
      clearTimeout(this.ratioTimer);
      this.isLoading = false;
      this.hasError = true;
      this.currentSrc = '';
      this.$emit('error', err);
    },
    __updateSrc() {
      if (this.image !== void 0 && this.isLoading === false) {
        const src = this.image.currentSrc || this.image.src;
        if (this.currentSrc !== src) {
          this.currentSrc = src;
        }
      }
    },
    __updateWatcher(srcset) {
      if (srcset) {
        if (this.unwatch === void 0) {
          this.unwatch = this.$watch('$q.screen.width', this.__updateSrc);
        }
      } else if (this.unwatch !== void 0) {
        this.unwatch();
        this.unwatch = void 0;
      }
    },
    __load() {
      clearTimeout(this.ratioTimer);
      this.hasError = false;
      if (!this.src) {
        this.isLoading = false;
        this.image = void 0;
        this.currentSrc = '';
        return;
      }
      this.isLoading = true;
      const img = new Image();
      this.image = img;
      img.onerror = err => {
        // if we are still rendering same image
        if (this.image === img && this.destroyed !== true) {
          this.__onError(err);
        }
      };
      img.onload = () => {
        if (this.destroyed === true) {
          return;
        }

        // if we are still rendering same image
        if (this.image === img) {
          if (img.decode !== void 0) {
            img.decode().catch(err => {
              if (this.image === img && this.destroyed !== true) {
                this.__onError(err);
              }
            }).then(() => {
              if (this.image === img && this.destroyed !== true) {
                this.__onLoad(img);
              }
            });
          } else {
            this.__onLoad(img);
          }
        }
      };
      img.src = this.src;
      if (this.srcset) {
        img.srcset = this.srcset;
      }
      if (this.sizes !== void 0) {
        img.sizes = this.sizes;
      } else {
        Object.assign(img, {
          height: this.height,
          width: this.width
        });
      }
    },
    __computeRatio(img) {
      const {
        naturalHeight,
        naturalWidth
      } = img;
      if (naturalHeight || naturalWidth) {
        this.naturalRatio = naturalHeight === 0 ? 1 : naturalWidth / naturalHeight;
      } else {
        this.ratioTimer = setTimeout(() => {
          if (this.image === img && this.destroyed !== true) {
            this.__computeRatio(img);
          }
        }, 100);
      }
    },
    __getImage(h) {
      const nativeImg = this.nativeContextMenu === true ? [h('img', {
        staticClass: 'absolute-full fit',
        attrs: this.imgAttrs
      })] : void 0;
      const content = this.url !== void 0 ? h('div', {
        key: this.url,
        staticClass: 'q-img__image absolute-full',
        class: this.imgClass,
        style: this.imgContainerStyle
      }, nativeImg) : null;
      return this.basic === true ? content : h('transition', {
        props: {
          name: 'q-transition--' + this.transition
        }
      }, [content]);
    },
    __getContent(h) {
      const slotVm = Object(private_slot["c" /* slot */])(this, this.hasError === true ? 'error' : 'default');
      if (this.basic === true) {
        return h('div', {
          key: 'content',
          staticClass: 'q-img__content absolute-full'
        }, slotVm);
      }
      const content = this.isLoading === true ? h('div', {
        key: 'placeholder',
        staticClass: 'q-img__loading absolute-full flex flex-center'
      }, this.$scopedSlots.loading !== void 0 ? this.$scopedSlots.loading() : this.noDefaultSpinner === false ? [h(QSpinner["a" /* default */], {
        props: {
          color: this.spinnerColor,
          size: this.spinnerSize
        }
      })] : void 0) : h('div', {
        key: 'content',
        staticClass: 'q-img__content absolute-full'
      }, slotVm);
      return h('transition', {
        props: {
          name: 'q-transition--fade'
        }
      }, [content]);
    }
  },
  render(h) {
    return h('div', {
      class: this.classes,
      style: this.style,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, [h('div', {
      style: this.ratioStyle
    }), this.__getImage(h), this.__getContent(h)]);
  },
  beforeMount() {
    if (this.placeholderSrc !== void 0 && this.ratio === void 0) {
      const img = new Image();
      img.src = this.placeholderSrc;
      this.__computeRatio(img);
    }
    this.isLoading === true && this.__load();
  },
  beforeDestroy() {
    this.destroyed = true;
    clearTimeout(this.ratioTimer);
    this.unwatch !== void 0 && this.unwatch();
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/img/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/debounce.js
var debounce = __webpack_require__("c3c5");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/utils/dom.js
var dom = __webpack_require__("d818");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/infinite-scroll/QInfiniteScroll.js







const {
  passive
} = utils_event["f" /* listenOpts */];
/* harmony default export */ var QInfiniteScroll = (external_vue_default.a.extend({
  name: 'QInfiniteScroll',
  mixins: [listeners["a" /* default */]],
  props: {
    offset: {
      type: Number,
      default: 500
    },
    debounce: {
      type: [String, Number],
      default: 100
    },
    scrollTarget: {
      default: void 0
    },
    initialIndex: Number,
    disable: Boolean,
    reverse: Boolean
  },
  data() {
    return {
      index: this.initialIndex || 0,
      isFetching: false,
      isWorking: true
    };
  },
  computed: {
    renderLoadingSlot() {
      return this.disable !== true && this.isWorking === true;
    }
  },
  watch: {
    disable(val) {
      if (val === true) {
        this.stop();
      } else {
        this.resume();
      }
    },
    reverse() {
      if (this.isFetching === false && this.isWorking === true) {
        this.immediatePoll();
      }
    },
    scrollTarget() {
      this.updateScrollTarget();
    },
    debounce(val) {
      this.__setDebounce(val);
    },
    isFetching() {
      this.__updateSvgAnimations();
    },
    renderLoadingSlot() {
      this.__updateSvgAnimations();
    }
  },
  methods: {
    poll() {
      if (this.disable === true || this.isFetching === true || this.isWorking === false) {
        return;
      }
      const scrollHeight = Object(utils_scroll["b" /* getScrollHeight */])(this.__scrollTarget),
        scrollPosition = Object(utils_scroll["c" /* getScrollPosition */])(this.__scrollTarget),
        containerHeight = Object(dom["e" /* height */])(this.__scrollTarget);
      if (this.reverse === false) {
        if (Math.round(scrollPosition + containerHeight + this.offset) >= Math.round(scrollHeight)) {
          this.trigger();
        }
      } else if (Math.round(scrollPosition) < this.offset) {
        this.trigger();
      }
    },
    trigger() {
      if (this.disable === true || this.isFetching === true || this.isWorking === false) {
        return;
      }
      this.index++;
      this.isFetching = true;
      const heightBefore = Object(utils_scroll["b" /* getScrollHeight */])(this.__scrollTarget);
      this.$emit('load', this.index, stop => {
        if (this.isWorking === true) {
          this.isFetching = false;
          this.$nextTick(() => {
            if (this.reverse === true) {
              const heightAfter = Object(utils_scroll["b" /* getScrollHeight */])(this.__scrollTarget),
                scrollPosition = Object(utils_scroll["c" /* getScrollPosition */])(this.__scrollTarget),
                heightDifference = heightAfter - heightBefore;
              Object(utils_scroll["j" /* setScrollPosition */])(this.__scrollTarget, scrollPosition + heightDifference);
            }
            if (stop === true) {
              this.stop();
            } else {
              this.$el.closest('body') && this.poll();
            }
          });
        }
      });
    },
    reset() {
      this.index = 0;
    },
    resume() {
      if (this.isWorking === false) {
        this.isWorking = true;
        this.__scrollTarget.addEventListener('scroll', this.poll, passive);
      }
      this.immediatePoll();
    },
    stop() {
      if (this.isWorking === true) {
        this.isWorking = false;
        this.isFetching = false;
        this.__scrollTarget.removeEventListener('scroll', this.poll, passive);
        typeof this.poll.cancel === 'function' && this.poll.cancel();
      }
    },
    updateScrollTarget() {
      if (this.__scrollTarget && this.isWorking === true) {
        this.__scrollTarget.removeEventListener('scroll', this.poll, passive);
      }
      this.__scrollTarget = Object(utils_scroll["d" /* getScrollTarget */])(this.$el, this.scrollTarget);
      if (this.isWorking === true) {
        this.__scrollTarget.addEventListener('scroll', this.poll, passive);
        if (this.reverse === true) {
          const scrollHeight = Object(utils_scroll["b" /* getScrollHeight */])(this.__scrollTarget),
            containerHeight = Object(dom["e" /* height */])(this.__scrollTarget);
          Object(utils_scroll["j" /* setScrollPosition */])(this.__scrollTarget, scrollHeight - containerHeight);
        }
        this.immediatePoll();
      }
    },
    setIndex(index) {
      this.index = index;
    },
    __setDebounce(val) {
      val = parseInt(val, 10);
      const oldPoll = this.poll;
      this.poll = val <= 0 ? this.immediatePoll : Object(debounce["a" /* default */])(this.immediatePoll, isNaN(val) === true ? 100 : val);
      if (this.__scrollTarget && this.isWorking === true) {
        if (oldPoll !== void 0) {
          this.__scrollTarget.removeEventListener('scroll', oldPoll, passive);
        }
        this.__scrollTarget.addEventListener('scroll', this.poll, passive);
      }
    },
    __updateSvgAnimations(isRetry) {
      if (this.renderLoadingSlot === true) {
        const el = this.$refs.loading;
        if (!el) {
          isRetry !== true && this.$nextTick(() => {
            this.__updateSvgAnimations(true);
          });
          return;
        }

        // we need to pause svg animations (if any) when hiding
        // otherwise the browser will keep on recalculating the style
        const action = `${this.isFetching === true ? 'un' : ''}pauseAnimations`;
        Array.from(el.getElementsByTagName('svg')).forEach(el => {
          el[action]();
        });
      }
    }
  },
  mounted() {
    this.immediatePoll = this.poll;
    this.__setDebounce(this.debounce);
    this.updateScrollTarget();
    this.isFetching === false && this.__updateSvgAnimations();
  },
  activated() {
    if (this.__scrollPosition !== void 0 && this.__scrollTarget) {
      Object(utils_scroll["j" /* setScrollPosition */])(this.__scrollTarget, this.__scrollPosition);
    }
  },
  deactivated() {
    this.__scrollPosition = this.__scrollTarget ? Object(utils_scroll["c" /* getScrollPosition */])(this.__scrollTarget) : void 0;
  },
  beforeDestroy() {
    this.stop();
  },
  render(h) {
    const child = Object(private_slot["d" /* uniqueSlot */])(this, 'default', []);
    if (this.renderLoadingSlot === true) {
      child[this.reverse === false ? 'push' : 'unshift'](h('div', {
        ref: 'loading',
        staticClass: 'q-infinite-scroll__loading',
        class: this.isFetching === true ? '' : 'invisible'
      }, Object(private_slot["c" /* slot */])(this, 'loading')));
    }
    return h('div', {
      staticClass: 'q-infinite-scroll',
      on: {
        ...this.qListeners
      }
    }, child);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/infinite-scroll/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/inner-loading/QInnerLoading.js





/* harmony default export */ var QInnerLoading = (external_vue_default.a.extend({
  name: 'QInnerLoading',
  mixins: [listeners["a" /* default */], dark["a" /* default */], transition["a" /* default */]],
  props: {
    showing: Boolean,
    color: String,
    size: {
      type: [String, Number],
      default: 42
    },
    label: String,
    labelClass: String,
    labelStyle: [String, Array, Object]
  },
  computed: {
    classes() {
      return 'q-inner-loading absolute-full column flex-center' + (this.isDark === true ? ' q-inner-loading--dark' : '');
    },
    labelClasses() {
      return 'q-inner-loading__label' + (this.labelClass !== void 0 ? ` ${this.labelClass}` : '');
    }
  },
  methods: {
    __getInner(h) {
      const child = [h(QSpinner["a" /* default */], {
        props: {
          size: this.size,
          color: this.color
        }
      })];
      if (this.label !== void 0) {
        child.push(h('div', {
          class: this.labelClasses,
          style: this.labelStyle
        }, [this.label]));
      }
      return child;
    },
    __getContent(h) {
      return this.showing === true ? [h('div', {
        staticClass: this.classes,
        on: {
          ...this.qListeners
        }
      }, this.$scopedSlots.default !== void 0 ? this.$scopedSlots.default() : this.__getInner(h))] : void 0;
    }
  },
  render(h) {
    return h('transition', {
      props: {
        ...this.transitionProps
      }
    }, this.__getContent(h));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/inner-loading/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/input/QInput.js + 1 modules
var QInput = __webpack_require__("d114");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/input/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/Intersection.js

const defaultCfg = {
  threshold: 0,
  root: null,
  rootMargin: '0px'
};
function Intersection_update(el, ctx, value) {
  let handler, cfg, changed;
  if (typeof value === 'function') {
    handler = value;
    cfg = defaultCfg;
    changed = ctx.cfg === void 0;
  } else {
    handler = value.handler;
    cfg = Object.assign({}, defaultCfg, value.cfg);
    changed = ctx.cfg === void 0 || Object(is["b" /* isDeepEqual */])(ctx.cfg, cfg) === false;
  }
  if (ctx.handler !== handler) {
    ctx.handler = handler;
  }
  if (changed === true) {
    ctx.cfg = cfg;
    ctx.observer !== void 0 && ctx.observer.unobserve(el);
    ctx.observer = new IntersectionObserver(([entry]) => {
      if (typeof ctx.handler === 'function') {
        // if observed element is part of a vue transition
        // then we need to be careful...
        if (entry.rootBounds === null && (el.__vue__ !== void 0 ? el.__vue__._inactive !== true : document.body.contains(el) === true)) {
          ctx.observer.unobserve(el);
          ctx.observer.observe(el);
          return;
        }
        const res = ctx.handler(entry, ctx.observer);
        if (res === false || ctx.once === true && entry.isIntersecting === true) {
          Intersection_destroy(el);
        }
      }
    }, cfg);
    ctx.observer.observe(el);
  }
}
function Intersection_destroy(el) {
  const ctx = el.__qvisible;
  if (ctx !== void 0) {
    ctx.observer !== void 0 && ctx.observer.unobserve(el);
    delete el.__qvisible;
  }
}
/* harmony default export */ var Intersection = ({
  name: 'intersection',
  inserted(el, {
    modifiers,
    value
  }) {
    if (el.__qvisible !== void 0) {
      Intersection_destroy(el);
      el.__qvisible_destroyed = true;
    }
    const ctx = {
      once: modifiers.once === true
    };
    Intersection_update(el, ctx, value);
    el.__qvisible = ctx;
  },
  update(el, binding) {
    const ctx = el.__qvisible;
    ctx !== void 0 && Intersection_update(el, ctx, binding.value);
  },
  unbind(el) {
    if (el.__qvisible_destroyed === void 0) {
      Intersection_destroy(el);
    } else {
      delete el.__qvisible_destroyed;
    }
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/tag.js
var tag = __webpack_require__("4025");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/intersection/QIntersection.js






/* harmony default export */ var QIntersection = (external_vue_default.a.extend({
  name: 'QIntersection',
  mixins: [tag["a" /* default */], listeners["a" /* default */]],
  directives: {
    Intersection: Intersection
  },
  props: {
    once: Boolean,
    transition: String,
    ssrPrerender: Boolean,
    margin: String,
    threshold: [Number, Array],
    root: {
      default: null
    },
    disable: Boolean
  },
  data() {
    return {
      showing: Platform["f" /* onSSR */] === true ? this.ssrPrerender : false
    };
  },
  computed: {
    value() {
      return this.root !== void 0 || this.margin !== void 0 || this.threshold !== void 0 ? {
        handler: this.__trigger,
        cfg: {
          root: this.root,
          rootMargin: this.margin,
          threshold: this.threshold
        }
      } : this.__trigger;
    },
    directives() {
      if (this.disable !== true && (Platform["f" /* onSSR */] !== true || this.once !== true || this.ssrPrerender !== true)) {
        return [{
          name: 'intersection',
          value: this.value,
          modifiers: {
            once: this.once
          }
        }];
      }
    }
  },
  methods: {
    __trigger(entry) {
      if (this.showing !== entry.isIntersecting) {
        this.showing = entry.isIntersecting;
        if (this.qListeners.visibility !== void 0) {
          this.$emit('visibility', this.showing);
        }
      }
    }
  },
  render(h) {
    const content = this.showing === true ? [h('div', {
      key: 'content'
    }, Object(private_slot["c" /* slot */])(this, 'default'))] : this.$scopedSlots.hidden !== void 0 ? [h('div', {
      key: 'hidden'
    }, this.$scopedSlots.hidden())] : void 0;
    return h(this.tag, {
      staticClass: 'q-intersection',
      on: {
        ...this.qListeners
      },
      directives: this.directives
    }, this.transition ? [h('transition', {
      props: {
        name: 'q-transition--' + this.transition
      }
    }, content)] : content);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/intersection/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/item/index.js





// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/knob/QKnob.js









// PGDOWN, LEFT, DOWN, PGUP, RIGHT, UP
const QKnob_keyCodes = [34, 37, 40, 33, 39, 38];
/* harmony default export */ var QKnob = (external_vue_default.a.extend({
  name: 'QKnob',
  mixins: [{
    props: QCircularProgress.options.props
  }, mixins_form["b" /* default */]],
  directives: {
    TouchPan: TouchPan["a" /* default */]
  },
  props: {
    innerMin: Number,
    innerMax: Number,
    step: {
      type: Number,
      default: 1,
      validator: v => v >= 0
    },
    tabindex: {
      type: [Number, String],
      default: 0
    },
    disable: Boolean,
    readonly: Boolean
  },
  data() {
    const innerMin = this.__getInnerMin(this.innerMin);
    const innerMax = this.__getInnerMax(this.innerMax);
    return {
      model: this.value === null ? innerMin : Object(format["a" /* between */])(this.value, innerMin, innerMax),
      dragging: false
    };
  },
  watch: {
    modelUpdate() {
      this.model = this.value === null ? this.computedInnerMin : Object(format["a" /* between */])(this.value, this.computedInnerMin, this.computedInnerMax);
      this.__updateValue(true);
    }
  },
  computed: {
    classes() {
      return 'q-knob non-selectable' + (this.editable === true ? ' q-knob--editable' : this.disable === true ? ' disabled' : '');
    },
    computedInnerMin() {
      return this.__getInnerMin(this.innerMin);
    },
    computedInnerMax() {
      return this.__getInnerMax(this.innerMax);
    },
    modelUpdate() {
      return `${this.value}|${this.computedInnerMin}|${this.computedInnerMax}`;
    },
    editable() {
      return this.disable === false && this.readonly === false;
    },
    decimals() {
      return (String(this.step).trim('0').split('.')[1] || '').length;
    },
    computedStep() {
      return this.step === 0 ? 1 : this.step;
    },
    computedInstantFeedback() {
      return this.instantFeedback === true || this.dragging === true;
    },
    onEvents() {
      return this.$q.platform.is.mobile === true ? {
        click: this.__click
      } : {
        mousedown: this.__activate,
        click: this.__click,
        keydown: this.__keydown,
        keyup: this.__keyup
      };
    },
    attrs() {
      const attrs = {
        role: 'slider',
        'aria-valuemin': this.computedInnerMin,
        'aria-valuemax': this.computedInnerMax,
        'aria-valuenow': this.value
      };
      if (this.editable === true) {
        attrs.tabindex = this.tabindex;
      } else {
        attrs[`aria-${this.disable === true ? 'disabled' : 'readonly'}`] = '';
      }
      return attrs;
    }
  },
  methods: {
    __getInnerMin(val) {
      return isNaN(val) === true || this.innerMin < this.min ? this.min : this.innerMin;
    },
    __getInnerMax(val) {
      return isNaN(val) === true || val > this.max ? this.max : this.innerMax;
    },
    __updateCenterPosition() {
      const {
        top,
        left,
        width,
        height
      } = this.$el.getBoundingClientRect();
      this.centerPosition = {
        top: top + height / 2,
        left: left + width / 2
      };
    },
    __pan(event) {
      if (event.isFinal) {
        this.__updatePosition(event.evt, true);
        this.dragging = false;
      } else if (event.isFirst) {
        this.__updateCenterPosition();
        this.dragging = true;
        this.__updatePosition(event.evt);
      } else {
        this.__updatePosition(event.evt);
      }
    },
    __click(evt) {
      this.__updateCenterPosition();
      this.__updatePosition(evt, true);
    },
    __keydown(evt) {
      if (!QKnob_keyCodes.includes(evt.keyCode)) {
        return;
      }
      Object(utils_event["l" /* stopAndPrevent */])(evt);
      const step = ([34, 33].includes(evt.keyCode) ? 10 : 1) * this.computedStep,
        offset = [34, 37, 40].includes(evt.keyCode) ? -step : step;
      this.model = Object(format["a" /* between */])(parseFloat((this.model + offset).toFixed(this.decimals)), this.computedInnerMin, this.computedInnerMax);
      this.__updateValue();
    },
    __keyup(evt) {
      if (QKnob_keyCodes.includes(evt.keyCode)) {
        this.__updateValue(true);
      }
    },
    __activate(evt) {
      this.__updateCenterPosition();
      this.__updatePosition(evt);
    },
    __updatePosition(evt, change) {
      const center = this.centerPosition,
        pos = Object(utils_event["h" /* position */])(evt),
        height = Math.abs(pos.top - center.top),
        distance = Math.sqrt(height ** 2 + Math.abs(pos.left - center.left) ** 2);
      let angle = Math.asin(height / distance) * (180 / Math.PI);
      if (pos.top < center.top) {
        angle = center.left < pos.left ? 90 - angle : 270 + angle;
      } else {
        angle = center.left < pos.left ? angle + 90 : 270 - angle;
      }
      if (this.$q.lang.rtl === true) {
        angle = Object(format["d" /* normalizeToInterval */])(-angle - this.angle, 0, 360);
      } else if (this.angle) {
        angle = Object(format["d" /* normalizeToInterval */])(angle - this.angle, 0, 360);
      }
      if (this.reverse === true) {
        angle = 360 - angle;
      }
      let model = this.min + angle / 360 * (this.max - this.min);
      if (this.step !== 0) {
        const step = this.computedStep,
          modulo = model % step;
        model = model - modulo + (Math.abs(modulo) >= step / 2 ? (modulo < 0 ? -1 : 1) * step : 0);
        model = parseFloat(model.toFixed(this.decimals));
      }
      model = Object(format["a" /* between */])(model, this.computedInnerMin, this.computedInnerMax);
      this.$emit('drag-value', model);
      if (this.model !== model) {
        this.model = model;
      }
      this.__updateValue(change);
    },
    __updateValue(change) {
      this.value !== this.model && this.$emit('input', this.model);
      change === true && this.$emit('change', this.model);
    },
    __getNameInput() {
      return this.$createElement('input', {
        attrs: this.formAttrs
      });
    }
  },
  render(h) {
    const data = {
      class: this.classes,
      attrs: this.attrs,
      props: {
        ...this.$props,
        value: this.model,
        instantFeedback: this.computedInstantFeedback
      }
    };
    if (this.editable === true) {
      data.on = this.onEvents;
      data.directives = Object(cache["b" /* default */])(this, 'dir', [{
        name: 'touch-pan',
        value: this.__pan,
        modifiers: {
          prevent: true,
          stop: true,
          mouse: true
        }
      }]);
      if (this.name !== void 0) {
        data.scopedSlots = {
          internal: this.__getNameInput
        };
      }
    }
    return h(QCircularProgress, data, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/knob/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/layout/QLayout.js
var QLayout = __webpack_require__("a511");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/layout/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/markup-table/QMarkupTable.js




/* harmony default export */ var QMarkupTable = (external_vue_default.a.extend({
  name: 'QMarkupTable',
  mixins: [dark["a" /* default */], listeners["a" /* default */]],
  props: {
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    separator: {
      type: String,
      default: 'horizontal',
      validator: v => ['horizontal', 'vertical', 'cell', 'none'].includes(v)
    },
    wrapCells: Boolean
  },
  computed: {
    classes() {
      return `q-table--${this.separator}-separator` + (this.isDark === true ? ' q-table--dark q-table__card--dark q-dark' : '') + (this.dense === true ? ' q-table--dense' : '') + (this.flat === true ? ' q-table--flat' : '') + (this.bordered === true ? ' q-table--bordered' : '') + (this.square === true ? ' q-table--square' : '') + (this.wrapCells === false ? ' q-table--no-wrap' : '');
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-markup-table q-table__container q-table__card',
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, [h('table', {
      staticClass: 'q-table'
    }, Object(private_slot["c" /* slot */])(this, 'default'))]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/markup-table/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/menu/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/can-render.js
var can_render = __webpack_require__("b181");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/no-ssr/QNoSsr.js





/* harmony default export */ var QNoSsr = (external_vue_default.a.extend({
  name: 'QNoSsr',
  mixins: [can_render["a" /* default */], tag["a" /* default */], listeners["a" /* default */]],
  props: {
    placeholder: String
  },
  render(h) {
    const data = {
      on: {
        ...this.qListeners
      }
    };
    if (this.canRender === true) {
      const node = Object(private_slot["c" /* slot */])(this, 'default');
      return node === void 0 ? node : node.length > 1 ? h(this.tag, data, node) : node[0];
    }
    data.staticClass = 'q-no-ssr-placeholder';
    const node = Object(private_slot["c" /* slot */])(this, 'placeholder');
    if (node !== void 0) {
      return node.length > 1 ? h(this.tag, data, node) : node[0];
    }
    if (this.placeholder !== void 0) {
      return h(this.tag, data, [this.placeholder]);
    }
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/no-ssr/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/option-size.js
var option_size = __webpack_require__("ee82");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/refocus-target.js
var refocus_target = __webpack_require__("a7f3");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/radio/QRadio.js









/* harmony default export */ var QRadio = (external_vue_default.a.extend({
  name: 'QRadio',
  mixins: [dark["a" /* default */], option_size["a" /* default */], mixins_form["b" /* default */], refocus_target["a" /* default */]],
  props: {
    value: {
      required: true
    },
    val: {
      required: true
    },
    label: String,
    leftLabel: Boolean,
    checkedIcon: String,
    uncheckedIcon: String,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [String, Number]
  },
  computed: {
    isTrue() {
      return this.value === this.val;
    },
    classes() {
      return 'q-radio cursor-pointer no-outline row inline no-wrap items-center' + (this.disable === true ? ' disabled' : '') + (this.isDark === true ? ' q-radio--dark' : '') + (this.dense === true ? ' q-radio--dense' : '') + (this.leftLabel === true ? ' reverse' : '');
    },
    innerClass() {
      const color = this.color !== void 0 && (this.keepColor === true || this.isTrue === true) ? ` text-${this.color}` : '';
      return `q-radio__inner--${this.isTrue === true ? 'truthy' : 'falsy'}${color}`;
    },
    computedIcon() {
      return this.isTrue === true ? this.checkedIcon : this.uncheckedIcon;
    },
    computedTabindex() {
      return this.disable === true ? -1 : this.tabindex || 0;
    },
    formAttrs() {
      const prop = {
        type: 'radio'
      };
      this.name !== void 0 && Object.assign(prop, {
        name: this.name,
        value: this.val
      });
      return prop;
    },
    formDomProps() {
      if (this.name !== void 0 && this.isTrue === true) {
        return {
          checked: true
        };
      }
    },
    attrs() {
      const attrs = {
        tabindex: this.computedTabindex,
        role: 'radio',
        'aria-label': this.label,
        'aria-checked': this.isTrue === true ? 'true' : 'false'
      };
      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      }
      return attrs;
    }
  },
  methods: {
    set(e) {
      if (e !== void 0) {
        Object(utils_event["l" /* stopAndPrevent */])(e);
        this.__refocusTarget(e);
      }
      if (this.disable !== true && this.isTrue !== true) {
        this.$emit('input', this.val, e);
      }
    }
  },
  render(h) {
    const content = this.computedIcon !== void 0 ? [h('div', {
      key: 'icon',
      staticClass: 'q-radio__icon-container absolute-full flex flex-center no-wrap'
    }, [h(QIcon["a" /* default */], {
      staticClass: 'q-radio__icon',
      props: {
        name: this.computedIcon
      }
    })])] : [h('svg', {
      key: 'svg',
      staticClass: 'q-radio__bg absolute non-selectable',
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        viewBox: '0 0 24 24'
      }
    }, [h('path', {
      attrs: {
        d: 'M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12'
      }
    }), h('path', {
      staticClass: 'q-radio__check',
      attrs: {
        d: 'M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6'
      }
    })])];
    this.disable !== true && this.__injectFormInput(content, 'unshift', 'q-radio__native q-ma-none q-pa-none');
    const child = [h('div', {
      staticClass: 'q-radio__inner relative-position',
      class: this.innerClass,
      style: this.sizeStyle,
      attrs: {
        'aria-hidden': 'true'
      }
    }, content)];
    if (this.__refocusTargetEl !== void 0) {
      child.push(this.__refocusTargetEl);
    }
    const label = this.label !== void 0 ? Object(private_slot["a" /* mergeSlot */])([this.label], this, 'default') : Object(private_slot["c" /* slot */])(this, 'default');
    label !== void 0 && child.push(h('div', {
      staticClass: 'q-radio__label q-anchor--skip'
    }, label));
    return h('div', {
      class: this.classes,
      attrs: this.attrs,
      on: Object(cache["b" /* default */])(this, 'inpExt', {
        click: this.set,
        keydown: e => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            Object(utils_event["l" /* stopAndPrevent */])(e);
          }
        },
        keyup: e => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            this.set(e);
          }
        }
      })
    }, child);
  }
}));
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/toggle/QToggle.js
var QToggle = __webpack_require__("de96");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/option-group/QOptionGroup.js







const components = {
  radio: QRadio,
  checkbox: QCheckbox["a" /* default */],
  toggle: QToggle["a" /* default */]
};
const typeValues = Object.keys(components);
/* harmony default export */ var QOptionGroup = (external_vue_default.a.extend({
  name: 'QOptionGroup',
  mixins: [dark["a" /* default */], listeners["a" /* default */]],
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      validator(opts) {
        return opts.every(opt => 'value' in opt && 'label' in opt);
      }
    },
    name: String,
    type: {
      default: 'radio',
      validator: v => typeValues.includes(v)
    },
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    size: String,
    leftLabel: Boolean,
    inline: Boolean,
    disable: Boolean
  },
  computed: {
    component() {
      return components[this.type];
    },
    model() {
      return Array.isArray(this.value) ? this.value.slice() : this.value;
    },
    classes() {
      return 'q-option-group q-gutter-x-sm' + (this.inline === true ? ' q-option-group--inline' : '');
    },
    attrs() {
      if (this.type === 'radio') {
        const attrs = {
          role: 'radiogroup'
        };
        if (this.disable === true) {
          attrs['aria-disabled'] = 'true';
        }
        return attrs;
      }
      return {
        role: 'group'
      };
    }
  },
  methods: {
    __update(value) {
      this.$emit('input', value);
    }
  },
  created() {
    const isArray = Array.isArray(this.value);
    if (this.type === 'radio') {
      if (isArray) {
        console.error('q-option-group: model should not be array');
      }
    } else if (isArray === false) {
      console.error('q-option-group: model should be array in your case');
    }
  },
  render(h) {
    return h('div', {
      class: this.classes,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, this.options.map((opt, i) => {
      const child = this.$scopedSlots['label-' + i] !== void 0 ? this.$scopedSlots['label-' + i](opt) : this.$scopedSlots.label !== void 0 ? this.$scopedSlots.label(opt) : void 0;
      return h('div', [h(this.component, {
        props: {
          value: this.value,
          val: opt.value,
          name: opt.name === void 0 ? this.name : opt.name,
          disable: this.disable || opt.disable,
          label: child === void 0 ? opt.label : void 0,
          leftLabel: opt.leftLabel === void 0 ? this.leftLabel : opt.leftLabel,
          color: opt.color === void 0 ? this.color : opt.color,
          checkedIcon: opt.checkedIcon,
          uncheckedIcon: opt.uncheckedIcon,
          dark: opt.dark || this.isDark,
          size: opt.size === void 0 ? this.size : opt.size,
          dense: this.dense,
          keepColor: opt.keepColor === void 0 ? this.keepColor : opt.keepColor
        },
        on: Object(cache["b" /* default */])(this, 'inp', {
          input: this.__update
        })
      }, child)]);
    }));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/option-group/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/page/QPage.js
var QPage = __webpack_require__("74c0");

// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/page/QPageContainer.js
var QPageContainer = __webpack_require__("2b36");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/page/index.js



// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/page-sticky/QPageSticky.js



/* harmony default export */ var QPageSticky = (external_vue_default.a.extend({
  name: 'QPageSticky',
  mixins: [listeners["a" /* default */]],
  inject: {
    layout: {
      default() {
        console.error('QPageSticky needs to be child of QLayout');
      }
    }
  },
  props: {
    position: {
      type: String,
      default: 'bottom-right',
      validator: v => ['top-right', 'top-left', 'bottom-right', 'bottom-left', 'top', 'right', 'bottom', 'left'].includes(v)
    },
    offset: {
      type: Array,
      validator: v => v.length === 2
    },
    expand: Boolean
  },
  computed: {
    attach() {
      const pos = this.position;
      return {
        top: pos.indexOf('top') > -1,
        right: pos.indexOf('right') > -1,
        bottom: pos.indexOf('bottom') > -1,
        left: pos.indexOf('left') > -1,
        vertical: pos === 'top' || pos === 'bottom',
        horizontal: pos === 'left' || pos === 'right'
      };
    },
    top() {
      return this.layout.header.offset;
    },
    right() {
      return this.layout.right.offset;
    },
    bottom() {
      return this.layout.footer.offset;
    },
    left() {
      return this.layout.left.offset;
    },
    style() {
      let posX = 0,
        posY = 0;
      const attach = this.attach,
        dir = this.$q.lang.rtl === true ? -1 : 1;
      if (attach.top === true && this.top !== 0) {
        posY = `${this.top}px`;
      } else if (attach.bottom === true && this.bottom !== 0) {
        posY = `${-this.bottom}px`;
      }
      if (attach.left === true && this.left !== 0) {
        posX = `${dir * this.left}px`;
      } else if (attach.right === true && this.right !== 0) {
        posX = `${-dir * this.right}px`;
      }
      const css = {
        transform: `translate(${posX}, ${posY})`
      };
      if (this.offset) {
        css.margin = `${this.offset[1]}px ${this.offset[0]}px`;
      }
      if (attach.vertical === true) {
        if (this.left !== 0) {
          css[this.$q.lang.rtl === true ? 'right' : 'left'] = `${this.left}px`;
        }
        if (this.right !== 0) {
          css[this.$q.lang.rtl === true ? 'left' : 'right'] = `${this.right}px`;
        }
      } else if (attach.horizontal === true) {
        if (this.top !== 0) {
          css.top = `${this.top}px`;
        }
        if (this.bottom !== 0) {
          css.bottom = `${this.bottom}px`;
        }
      }
      return css;
    },
    classes() {
      return `fixed-${this.position} q-page-sticky--${this.expand === true ? 'expand' : 'shrink'}`;
    }
  },
  render(h) {
    const content = Object(private_slot["c" /* slot */])(this, 'default');
    return h('div', {
      staticClass: 'q-page-sticky row flex-center',
      class: this.classes,
      style: this.style,
      on: {
        ...this.qListeners
      }
    }, this.expand === true ? content : [h('div', content)]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/page-scroller/QPageScroller.js



/* harmony default export */ var QPageScroller = (external_vue_default.a.extend({
  name: 'QPageScroller',
  mixins: [QPageSticky],
  props: {
    scrollOffset: {
      type: Number,
      default: 1000
    },
    reverse: Boolean,
    duration: {
      type: Number,
      default: 300
    },
    offset: {
      default: () => [18, 18]
    }
  },
  inject: {
    layout: {
      default() {
        console.error('QPageScroller needs to be used within a QLayout');
      }
    }
  },
  data() {
    return {
      showing: this.__isVisible()
    };
  },
  computed: {
    scrollHeight() {
      return this.layout.height - (this.layout.container === true ? this.layout.containerHeight : this.$q.screen.height);
    },
    onEvents() {
      return {
        ...this.qListeners,
        click: this.__onClick
      };
    }
  },
  watch: {
    'layout.scroll.position'() {
      this.__updateVisibility();
    },
    reverse: {
      handler(val) {
        if (val === true) {
          if (this.heightWatcher === void 0) {
            this.heightWatcher = this.$watch('scrollHeight', this.__updateVisibility);
          }
        } else if (this.heightWatcher !== void 0) {
          this.__cleanup();
        }
      },
      immediate: true
    }
  },
  methods: {
    __isVisible() {
      return this.reverse === true ? this.scrollHeight - this.layout.scroll.position > this.scrollOffset : this.layout.scroll.position > this.scrollOffset;
    },
    __onClick(e) {
      const target = Object(utils_scroll["d" /* getScrollTarget */])(this.layout.container === true ? this.$el : this.layout.$el);
      Object(utils_scroll["j" /* setScrollPosition */])(target, this.reverse === true ? this.layout.height : 0, this.duration);
      this.$emit('click', e);
    },
    __updateVisibility() {
      const newVal = this.__isVisible();
      if (this.showing !== newVal) {
        this.showing = newVal;
      }
    },
    __cleanup() {
      this.heightWatcher();
      this.heightWatcher = void 0;
    }
  },
  render(h) {
    return h('transition', {
      props: {
        name: 'q-transition--fade'
      }
    }, this.showing === true ? [h('div', {
      staticClass: 'q-page-scroller',
      on: this.onEvents
    }, [QPageSticky.options.render.call(this, h)])] : null);
  },
  beforeDestroy() {
    this.heightWatcher !== void 0 && this.__cleanup();
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/page-scroller/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/page-sticky/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/pagination/QPagination.js










function getBool(val, otherwise) {
  return [true, false].includes(val) ? val : otherwise;
}
/* harmony default export */ var QPagination = (external_vue_default.a.extend({
  name: 'QPagination',
  mixins: [dark["a" /* default */], listeners["a" /* default */]],
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      required: true
    },
    maxPages: {
      type: [Number, String],
      default: 0,
      validator: v => (typeof v === 'string' ? parseInt(v, 10) : v) >= 0
    },
    inputStyle: [Array, String, Object],
    inputClass: [Array, String, Object],
    size: String,
    disable: Boolean,
    input: Boolean,
    iconPrev: String,
    iconNext: String,
    iconFirst: String,
    iconLast: String,
    toFn: Function,
    boundaryLinks: {
      type: Boolean,
      default: null
    },
    boundaryNumbers: {
      type: Boolean,
      default: null
    },
    directionLinks: {
      type: Boolean,
      default: null
    },
    ellipses: {
      type: Boolean,
      default: null
    },
    ripple: {
      type: [Boolean, Object],
      default: null
    },
    round: Boolean,
    rounded: Boolean,
    flat: Boolean,
    outline: Boolean,
    unelevated: Boolean,
    push: Boolean,
    glossy: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    textColor: String,
    activeDesign: {
      type: String,
      default: '',
      values: v => v === '' || mixins_btn["a" /* btnDesignOptions */].includes(v)
    },
    activeColor: String,
    activeTextColor: String,
    padding: {
      type: String,
      default: '3px 2px'
    }
  },
  data() {
    return {
      newPage: null
    };
  },
  watch: {
    min() {
      this.model = this.value;
    },
    max() {
      this.model = this.value;
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        val = parseInt(val, 10);
        if (this.disable || isNaN(val)) {
          return;
        }
        const value = Object(format["a" /* between */])(val, this.__min, this.__max);
        this.$emit('input', value);
      }
    },
    inputPlaceholder() {
      return this.model + ' / ' + this.__max;
    },
    __min() {
      return parseInt(this.min, 10);
    },
    __max() {
      return parseInt(this.max, 10);
    },
    __maxPages() {
      return parseInt(this.maxPages, 10);
    },
    __boundaryLinks() {
      return getBool(this.boundaryLinks, this.input);
    },
    __boundaryNumbers() {
      return getBool(this.boundaryNumbers, !this.input);
    },
    __directionLinks() {
      return getBool(this.directionLinks, this.input);
    },
    __ellipses() {
      return getBool(this.ellipses, !this.input);
    },
    __btnDesign() {
      return Object(mixins_btn["c" /* getBtnDesign */])(this, 'flat');
    },
    __btnActiveDesign() {
      // we also reset non-active design
      const acc = {
        [this.__btnDesign]: false
      };
      if (this.activeDesign !== '') {
        acc[this.activeDesign] = true;
      }
      return acc;
    },
    icons() {
      const ico = [this.iconFirst || this.$q.iconSet.pagination.first, this.iconPrev || this.$q.iconSet.pagination.prev, this.iconNext || this.$q.iconSet.pagination.next, this.iconLast || this.$q.iconSet.pagination.last];
      return this.$q.lang.rtl === true ? ico.reverse() : ico;
    },
    attrs() {
      const attrs = {
        role: 'navigation'
      };
      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      }
      return attrs;
    },
    btnProps() {
      return {
        [this.__btnDesign]: true,
        round: this.round,
        rounded: this.rounded,
        padding: this.padding,
        color: this.color,
        textColor: this.textColor,
        size: this.size,
        ripple: this.ripple !== null ? this.ripple : true
      };
    },
    activeBtnProps() {
      return {
        ...this.__btnActiveDesign,
        color: this.activeColor || this.color,
        textColor: this.activeTextColor || this.textColor
      };
    },
    btnConfig() {
      let maxPages = Math.max(this.__maxPages, 1 + (this.__ellipses ? 2 : 0) + (this.__boundaryNumbers ? 2 : 0));
      const acc = {
        pgFrom: this.__min,
        pgTo: this.__max,
        ellipsesStart: false,
        ellipsesEnd: false,
        boundaryStart: false,
        boundaryEnd: false,
        marginalStyle: {
          minWidth: `${Math.max(2, String(this.__max).length)}em`
        }
      };
      if (this.__maxPages && maxPages < this.__max - this.__min + 1) {
        maxPages = 1 + Math.floor(maxPages / 2) * 2;
        acc.pgFrom = Math.max(this.__min, Math.min(this.__max - maxPages + 1, this.value - Math.floor(maxPages / 2)));
        acc.pgTo = Math.min(this.__max, acc.pgFrom + maxPages - 1);
        if (this.__boundaryNumbers) {
          acc.boundaryStart = true;
          acc.pgFrom++;
        }
        if (this.__ellipses && acc.pgFrom > this.__min + (this.__boundaryNumbers ? 1 : 0)) {
          acc.ellipsesStart = true;
          acc.pgFrom++;
        }
        if (this.__boundaryNumbers) {
          acc.boundaryEnd = true;
          acc.pgTo--;
        }
        if (this.__ellipses && acc.pgTo < this.__max - (this.__boundaryNumbers ? 1 : 0)) {
          acc.ellipsesEnd = true;
          acc.pgTo--;
        }
      }
      return acc;
    },
    inputEvents() {
      const updateModel = () => {
        this.model = this.newPage;
        this.newPage = null;
      };
      return {
        input: val => {
          this.newPage = val;
        },
        keyup: e => {
          Object(key_composition["a" /* isKeyCode */])(e, 13) === true && updateModel();
        },
        blur: updateModel
      };
    }
  },
  methods: {
    set(value) {
      this.model = value;
    },
    setByOffset(offset) {
      this.model = this.model + offset;
    },
    __getBtn(h, data, props, page, active) {
      data.props = {
        ...this.btnProps,
        ...props
      };
      data.attrs = {
        'aria-label': page,
        'aria-current': 'false',
        ...data.attrs
      };
      if (active === true) {
        Object.assign(data.props, this.activeBtnProps);
        data.attrs['aria-current'] = 'true';
      }
      if (page !== void 0) {
        if (this.toFn !== void 0) {
          data.props.to = this.toFn(page);
        } else {
          data.on = {
            click: () => {
              this.set(page);
            }
          };
        }
      }
      return h(QBtn["a" /* default */], data);
    }
  },
  render(h) {
    const contentStart = [];
    const contentEnd = [];
    let contentMiddle;
    if (this.__boundaryLinks === true) {
      contentStart.push(this.__getBtn(h, {
        key: 'bls'
      }, {
        disable: this.disable || this.value <= this.__min,
        icon: this.icons[0]
      }, this.__min));
      contentEnd.unshift(this.__getBtn(h, {
        key: 'ble'
      }, {
        disable: this.disable || this.value >= this.__max,
        icon: this.icons[3]
      }, this.__max));
    }
    if (this.__directionLinks === true) {
      contentStart.push(this.__getBtn(h, {
        key: 'bdp'
      }, {
        disable: this.disable || this.value <= this.__min,
        icon: this.icons[1]
      }, this.value - 1));
      contentEnd.unshift(this.__getBtn(h, {
        key: 'bdn'
      }, {
        disable: this.disable || this.value >= this.__max,
        icon: this.icons[2]
      }, this.value + 1));
    }
    if (this.input !== true) {
      // has buttons instead of inputbox
      contentMiddle = [];
      const {
        pgFrom,
        pgTo,
        marginalStyle: style
      } = this.btnConfig;
      if (this.btnConfig.boundaryStart === true) {
        const active = this.__min === this.value;
        contentStart.push(this.__getBtn(h, {
          key: 'bns',
          style
        }, {
          disable: this.disable,
          label: this.__min
        }, this.__min, active));
      }
      if (this.btnConfig.boundaryEnd === true) {
        const active = this.__max === this.value;
        contentEnd.unshift(this.__getBtn(h, {
          key: 'bne',
          style
        }, {
          disable: this.disable,
          label: this.__max
        }, this.__max, active));
      }
      if (this.btnConfig.ellipsesStart === true) {
        contentStart.push(this.__getBtn(h, {
          key: 'bes',
          style
        }, {
          disable: this.disable,
          label: '…',
          ripple: false
        }, pgFrom - 1));
      }
      if (this.btnConfig.ellipsesEnd === true) {
        contentEnd.unshift(this.__getBtn(h, {
          key: 'bee',
          style
        }, {
          disable: this.disable,
          label: '…',
          ripple: false
        }, pgTo + 1));
      }
      for (let i = pgFrom; i <= pgTo; i++) {
        contentMiddle.push(this.__getBtn(h, {
          key: `bpg${i}`,
          style
        }, {
          disable: this.disable,
          label: i
        }, i, i === this.value));
      }
    }
    return h('div', {
      staticClass: 'q-pagination row no-wrap items-center',
      class: {
        disabled: this.disable
      },
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, [h('div', {
      staticClass: 'q-pagination__content row no-wrap items-center'
    }, [...contentStart, h('div', {
      staticClass: 'q-pagination__middle row justify-center',
      on: this.input === true ? Object(cache["b" /* default */])(this, 'stop', {
        input: utils_event["k" /* stop */]
      }) : null
    }, this.input === true ? [h(QInput["a" /* default */], {
      staticClass: 'inline',
      style: {
        width: `${this.inputPlaceholder.length / 1.5}em`
      },
      props: {
        type: 'number',
        dense: true,
        value: this.newPage,
        disable: this.disable,
        dark: this.isDark,
        borderless: true,
        inputClass: this.inputClass,
        inputStyle: this.inputStyle
      },
      attrs: {
        placeholder: this.inputPlaceholder,
        min: this.__min,
        max: this.__max
      },
      on: {
        ...this.inputEvents
      }
    })] : contentMiddle), ...contentEnd])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/pagination/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/frame-debounce.js
/* harmony default export */ var frame_debounce = (function (fn) {
  let wait = false,
    frame,
    callArgs;
  function debounced( /* ...args */
  ) {
    callArgs = arguments;
    if (wait === true) {
      return;
    }
    wait = true;
    frame = requestAnimationFrame(() => {
      fn.apply(this, callArgs);
      callArgs = void 0;
      wait = false;
    });
  }
  debounced.cancel = () => {
    window.cancelAnimationFrame(frame);
    wait = false;
  };
  return debounced;
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/parallax/QParallax.js







const {
  passive: QParallax_passive
} = utils_event["f" /* listenOpts */];
/* harmony default export */ var QParallax = (external_vue_default.a.extend({
  name: 'QParallax',
  mixins: [listeners["a" /* default */]],
  props: {
    src: String,
    height: {
      type: Number,
      default: 500
    },
    speed: {
      type: Number,
      default: 1,
      validator: v => v >= 0 && v <= 1
    },
    scrollTarget: {
      default: void 0
    }
  },
  data() {
    return {
      scrolling: false,
      percentScrolled: 0
    };
  },
  watch: {
    height() {
      this.working === true && this.__updatePos();
    },
    scrollTarget() {
      if (this.working === true) {
        this.__stop();
        this.__start();
      }
    }
  },
  methods: {
    __update(percentage) {
      this.percentScrolled = percentage;
      this.qListeners.scroll !== void 0 && this.$emit('scroll', percentage);
    },
    __updatePos() {
      let containerTop, containerHeight, containerBottom;
      if (this.__scrollTarget === window) {
        containerTop = 0;
        containerHeight = window.innerHeight;
        containerBottom = containerHeight;
      } else {
        containerTop = Object(dom["f" /* offset */])(this.__scrollTarget).top;
        containerHeight = Object(dom["e" /* height */])(this.__scrollTarget);
        containerBottom = containerTop + containerHeight;
      }
      const top = Object(dom["f" /* offset */])(this.$el).top;
      const bottom = top + this.height;
      if (this.observer !== void 0 || bottom > containerTop && top < containerBottom) {
        const percent = (containerBottom - top) / (this.height + containerHeight);
        this.__setPos((this.mediaHeight - this.height) * percent * this.speed);
        this.__update(percent);
      }
    },
    __setPos(offset) {
      // apply it immediately without any delay
      this.media.style.transform = `translate3d(-50%,${Math.round(offset)}px,0)`;
    },
    __onResize() {
      this.mediaHeight = this.media.naturalHeight || this.media.videoHeight || Object(dom["e" /* height */])(this.media);
      this.working === true && this.__updatePos();
    },
    __start() {
      this.working = true;
      this.__scrollTarget = Object(utils_scroll["d" /* getScrollTarget */])(this.$el, this.scrollTarget);
      this.__scrollTarget.addEventListener('scroll', this.__updatePos, QParallax_passive);
      window.addEventListener('resize', this.__resizeHandler, QParallax_passive);
      this.__updatePos();
    },
    __stop() {
      if (this.working === true) {
        this.working = false;
        this.__setPos.cancel();
        this.__update.cancel();
        this.__resizeHandler.cancel();
        this.__scrollTarget.removeEventListener('scroll', this.__updatePos, QParallax_passive);
        window.removeEventListener('resize', this.__resizeHandler, QParallax_passive);
        this.__scrollTarget = void 0;
      }
    }
  },
  render(h) {
    return h('div', {
      staticClass: 'q-parallax',
      style: {
        height: `${this.height}px`
      },
      on: {
        ...this.qListeners
      }
    }, [h('div', {
      ref: 'mediaParent',
      staticClass: 'q-parallax__media absolute-full'
    }, this.$scopedSlots.media !== void 0 ? this.$scopedSlots.media() : [h('img', {
      ref: 'media',
      attrs: {
        src: this.src
      }
    })]), h('div', {
      staticClass: 'q-parallax__content absolute-full column flex-center'
    }, this.$scopedSlots.content !== void 0 ? this.$scopedSlots.content({
      percentScrolled: this.percentScrolled
    }) : Object(private_slot["c" /* slot */])(this, 'default'))]);
  },
  mounted() {
    this.__setPos = frame_debounce(this.__setPos);
    this.__update = frame_debounce(this.__update);
    this.__resizeHandler = frame_debounce(this.__onResize);
    this.media = this.$scopedSlots.media !== void 0 ? this.$refs.mediaParent.children[0] : this.$refs.media;
    this.media.onload = this.media.onloadstart = this.media.loadedmetadata = this.__onResize;
    this.__onResize();
    this.media.style.display = 'initial';
    if (window.IntersectionObserver !== void 0) {
      this.observer = new IntersectionObserver(entries => {
        this[entries[0].isIntersecting === true ? '__start' : '__stop']();
      });
      this.observer.observe(this.$el);
    } else {
      this.__start();
    }
  },
  beforeDestroy() {
    this.__stop();
    this.observer !== void 0 && this.observer.disconnect();
    this.media.onload = this.media.onloadstart = this.media.loadedmetadata = null;
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/parallax/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/clone.js
// adapted from https://stackoverflow.com/a/40294058

function cloneDeep(data, hash = new WeakMap()) {
  if (Object(data) !== data) return data;
  if (hash.has(data)) return hash.get(data);
  const result = data instanceof Date ? new Date(data) : data instanceof RegExp ? new RegExp(data.source, data.flags) : data instanceof Set ? new Set() : data instanceof Map ? new Map() : typeof data.constructor !== 'function' ? Object.create(null) : data.prototype !== void 0 && typeof data.prototype.constructor === 'function' ? data : new data.constructor();
  if (typeof data.constructor === 'function' && typeof data.valueOf === 'function') {
    const val = data.valueOf();
    if (Object(val) !== val) {
      const result = new data.constructor(val);
      hash.set(data, result);
      return result;
    }
  }
  hash.set(data, result);
  if (data instanceof Set) {
    data.forEach(val => {
      result.add(cloneDeep(val, hash));
    });
  } else if (data instanceof Map) {
    data.forEach((val, key) => {
      result.set(key, cloneDeep(val, hash));
    });
  }
  return Object.assign(result, ...Object.keys(data).map(key => ({
    [key]: cloneDeep(data[key], hash)
  })));
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/popup-edit/QPopupEdit.js










/* harmony default export */ var QPopupEdit = (external_vue_default.a.extend({
  name: 'QPopupEdit',
  mixins: [mixins_attrs["b" /* default */]],
  props: {
    value: {
      required: true
    },
    title: String,
    buttons: Boolean,
    labelSet: String,
    labelCancel: String,
    color: {
      type: String,
      default: 'primary'
    },
    validate: {
      type: Function,
      default: () => true
    },
    autoSave: Boolean,
    /* menu props overrides */
    cover: {
      type: Boolean,
      default: true
    },
    contentClass: String,
    /* end of menu props */

    disable: Boolean
  },
  data() {
    return {
      modelChanged: false,
      model: null
    };
  },
  computed: {
    classes() {
      return 'q-popup-edit' + (this.contentClass !== void 0 ? ` ${this.contentClass}` : '');
    },
    modelValue() {
      return this.modelChanged === true ? this.model : this.value;
    },
    initialValue() {
      return this.modelChanged !== true ? this.model : this.value;
    },
    defaultSlotScope() {
      return injectProp({
        initialValue: this.initialValue,
        updatePosition: this.__reposition,
        emitValue: this.__changeModel,
        validate: this.validate,
        set: this.set,
        cancel: this.cancel
      }, 'value', () => this.modelValue, this.__changeModel);
    },
    menuProps() {
      return {
        ...this.qAttrs,
        cover: this.cover,
        contentClass: this.classes
      };
    }
  },
  methods: {
    set() {
      if (this.validate(this.modelValue) !== true) {
        return;
      }
      if (this.__hasChanged() === true) {
        this.$emit('save', this.modelValue, this.initialValue);
        this.modelChanged === true && this.$emit('input', this.modelValue);
      }
      this.__close();
    },
    cancel() {
      if (this.__hasChanged() === true) {
        this.$emit('cancel', this.modelValue, this.initialValue);
        this.modelChanged !== true && this.$emit('input', this.initialValue);
      }
      this.__close();
    },
    show(e) {
      this.$refs.menu !== void 0 && this.$refs.menu.show(e);
    },
    hide(e) {
      this.$refs.menu !== void 0 && this.$refs.menu.hide(e);
    },
    __hasChanged() {
      return Object(is["b" /* isDeepEqual */])(this.modelValue, this.initialValue) === false;
    },
    __changeModel(val) {
      if (this.disable !== true) {
        this.model = val;
        this.modelChanged = true;
      }
    },
    __close() {
      this.validated = true;
      this.$refs.menu.showing === true && this.$refs.menu.hide();
    },
    __reposition() {
      this.$nextTick(() => {
        this.$refs.menu.updatePosition();
      });
    },
    __getContent(h) {
      const title = Object(private_slot["c" /* slot */])(this, 'title', this.title),
        child = this.$scopedSlots.default === void 0 ? [] : [].concat(this.$scopedSlots.default(this.defaultSlotScope));
      title && child.unshift(h('div', {
        staticClass: 'q-dialog__title q-mt-sm q-mb-sm'
      }, [title]));
      this.buttons === true && child.push(h('div', {
        staticClass: 'q-popup-edit__buttons row justify-center no-wrap'
      }, [h(QBtn["a" /* default */], {
        props: {
          flat: true,
          color: this.color,
          label: this.labelCancel || this.$q.lang.label.cancel
        },
        on: Object(cache["b" /* default */])(this, 'cancel', {
          click: this.cancel
        })
      }), h(QBtn["a" /* default */], {
        props: {
          flat: true,
          color: this.color,
          label: this.labelSet || this.$q.lang.label.set
        },
        on: Object(cache["b" /* default */])(this, 'ok', {
          click: this.set
        })
      })]));
      return child;
    }
  },
  render(h) {
    if (this.disable === true) {
      return;
    }
    return h(QMenu["a" /* default */], {
      ref: 'menu',
      props: this.menuProps,
      on: Object(cache["b" /* default */])(this, 'menu', {
        'before-show': () => {
          this.validated = false;
          this.modelChanged = false;
          this.model = cloneDeep(this.value);
          this.watcher = this.$watch('value', this.__reposition);
          this.$emit('before-show');
        },
        show: () => {
          this.$emit('show');
        },
        'escape-key': this.cancel,
        'before-hide': () => {
          this.watcher();
          if (this.validated === false && this.__hasChanged() === true) {
            if (this.autoSave === true && this.validate(this.model) === true) {
              this.$emit('save', this.modelValue, this.initialValue);
              this.modelChanged === true && this.$emit('input', this.modelValue);
            } else {
              this.$emit('cancel', this.modelValue, this.initialValue);
              this.modelChanged !== true && this.$emit('input', this.initialValue);
            }
          }
          this.$emit('before-hide');
        },
        hide: () => {
          this.$emit('hide');
        },
        keyup: e => {
          Object(key_composition["a" /* isKeyCode */])(e, 13) === true && this.set();
        }
      })
    }, this.__getContent(h));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/popup-edit/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/anchor.js
var mixins_anchor = __webpack_require__("a62b");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/popup-proxy/QPopupProxy.js







/* harmony default export */ var QPopupProxy = (external_vue_default.a.extend({
  name: 'QPopupProxy',
  mixins: [mixins_attrs["b" /* default */], listeners["a" /* default */], mixins_anchor["a" /* default */]],
  props: {
    breakpoint: {
      type: [String, Number],
      default: 450
    }
  },
  data() {
    const breakpoint = parseInt(this.breakpoint, 10);
    return {
      type: this.$q.screen.width < breakpoint || this.$q.screen.height < breakpoint ? 'dialog' : 'menu'
    };
  },
  computed: {
    parsedBreakpoint() {
      return parseInt(this.breakpoint, 10);
    },
    onEvents() {
      return {
        ...this.qListeners,
        hide: this.__onHide
      };
    }
  },
  watch: {
    '$q.screen.width'(width) {
      if (this.$refs.popup.showing !== true) {
        this.__updateType(width, this.$q.screen.height, this.parsedBreakpoint);
      }
    },
    '$q.screen.height'(height) {
      if (this.$refs.popup.showing !== true) {
        this.__updateType(this.$q.screen.width, height, this.parsedBreakpoint);
      }
    },
    breakpoint(breakpoint) {
      if (this.$refs.popup.showing !== true) {
        this.__updateType(this.$q.screen.width, this.$q.screen.height, parseInt(breakpoint, 10));
      }
    }
  },
  methods: {
    toggle(evt) {
      this.$refs.popup.toggle(evt);
    },
    show(evt) {
      this.$refs.popup.show(evt);
    },
    hide(evt) {
      this.$refs.popup.hide(evt);
    },
    __onHide(evt) {
      this.__updateType(this.$q.screen.width, this.$q.screen.height, this.parsedBreakpoint);
      this.$emit('hide', evt);
    },
    __updateType(width, height, breakpoint) {
      const type = width < breakpoint || height < breakpoint ? 'dialog' : 'menu';
      if (this.type !== type) {
        this.type = type;
      }
    }
  },
  render(h) {
    const def = Object(private_slot["c" /* slot */])(this, 'default');
    const props = this.type === 'menu' && def !== void 0 && def[0] !== void 0 && def[0].componentOptions !== void 0 && def[0].componentOptions.Ctor !== void 0 && def[0].componentOptions.Ctor.sealedOptions !== void 0 && ['QDate', 'QTime', 'QCarousel', 'QColor'].includes(def[0].componentOptions.Ctor.sealedOptions.name) ? {
      cover: true,
      maxHeight: '99vh'
    } : {};
    const data = {
      ref: 'popup',
      props: {
        ...props,
        ...this.qAttrs
      },
      on: this.onEvents
    };
    let component;
    if (this.type === 'dialog') {
      component = QDialog["a" /* default */];
    } else {
      component = QMenu["a" /* default */];
      data.props.target = this.target;
      data.props.contextMenu = this.contextMenu;
      data.props.noParentEvent = true;
      data.props.separateClosePopup = true;
    }
    return h(component, data, def);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/popup-proxy/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/linear-progress/QLinearProgress.js





function QLinearProgress_width(val, reverse, $q) {
  return {
    transform: reverse === true ? `translateX(${$q.lang.rtl === true ? '-' : ''}100%) scale3d(${-val},1,1)` : `scale3d(${val},1,1)`
  };
}
/* harmony default export */ var QLinearProgress = (external_vue_default.a.extend({
  name: 'QLinearProgress',
  mixins: [listeners["a" /* default */], dark["a" /* default */], Object(size["b" /* getSizeMixin */])({
    xs: 2,
    sm: 4,
    md: 6,
    lg: 10,
    xl: 14
  })],
  props: {
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    instantFeedback: Boolean
  },
  computed: {
    motion() {
      return this.indeterminate === true || this.query === true;
    },
    widthReverse() {
      return this.reverse !== this.query;
    },
    classes() {
      return 'q-linear-progress' + (this.color !== void 0 ? ` text-${this.color}` : '') + (this.reverse === true || this.query === true ? ' q-linear-progress--reverse' : '') + (this.rounded === true ? ' rounded-borders' : '');
    },
    trackStyle() {
      return QLinearProgress_width(this.buffer !== void 0 ? this.buffer : 1, this.widthReverse, this.$q);
    },
    transitionSuffix() {
      return `with${this.instantFeedback === true ? 'out' : ''}-transition`;
    },
    trackClass() {
      return `q-linear-progress__track absolute-full q-linear-progress__track--${this.transitionSuffix}` + ` q-linear-progress__track--${this.isDark === true ? 'dark' : 'light'}` + (this.trackColor !== void 0 ? ` bg-${this.trackColor}` : '');
    },
    modelStyle() {
      return QLinearProgress_width(this.motion === true ? 1 : this.value, this.widthReverse, this.$q);
    },
    modelClasses() {
      return `q-linear-progress__model absolute-full q-linear-progress__model--${this.transitionSuffix}` + ` q-linear-progress__model--${this.motion === true ? 'in' : ''}determinate`;
    },
    stripeStyle() {
      return {
        width: this.value * 100 + '%'
      };
    },
    stripeClass() {
      return `q-linear-progress__stripe q-linear-progress__stripe--${this.transitionSuffix}` + ` absolute-${this.reverse === true ? 'right' : 'left'}`;
    },
    attrs() {
      return {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuemax': 1,
        'aria-valuenow': this.indeterminate === true ? void 0 : this.value
      };
    }
  },
  render(h) {
    const child = [h('div', {
      style: this.trackStyle,
      class: this.trackClass
    }), h('div', {
      style: this.modelStyle,
      class: this.modelClasses
    })];
    this.stripe === true && this.motion === false && child.push(h('div', {
      style: this.stripeStyle,
      class: this.stripeClass
    }));
    return h('div', {
      style: this.sizeStyle,
      class: this.classes,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["a" /* mergeSlot */])(child, this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/linear-progress/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/pull-to-refresh/QPullToRefresh.js









const PULLER_HEIGHT = 40,
  OFFSET_TOP = 20;
/* harmony default export */ var QPullToRefresh = (external_vue_default.a.extend({
  name: 'QPullToRefresh',
  mixins: [listeners["a" /* default */]],
  directives: {
    TouchPan: TouchPan["a" /* default */]
  },
  props: {
    color: String,
    bgColor: String,
    icon: String,
    noMouse: Boolean,
    disable: Boolean,
    scrollTarget: {
      default: void 0
    }
  },
  data() {
    return {
      state: 'pull',
      pullRatio: 0,
      pulling: false,
      pullPosition: -PULLER_HEIGHT,
      animating: false,
      positionCSS: {}
    };
  },
  computed: {
    style() {
      return {
        opacity: this.pullRatio,
        transform: `translateY(${this.pullPosition}px) rotate(${this.pullRatio * 360}deg)`
      };
    },
    classes() {
      return 'q-pull-to-refresh__puller row flex-center' + (this.animating === true ? ' q-pull-to-refresh__puller--animating' : '') + (this.bgColor !== void 0 ? ` bg-${this.bgColor}` : '');
    },
    directives() {
      if (this.disable !== true) {
        const modifiers = {
          down: true
        };
        if (this.noMouse !== true) {
          modifiers.mouse = true;
        }
        return [{
          name: 'touch-pan',
          modifiers,
          value: this.__pull
        }];
      }
    },
    contentClass() {
      return `q-pull-to-refresh__content${this.pulling === true ? ' no-pointer-events' : ''}`;
    }
  },
  watch: {
    scrollTarget() {
      this.updateScrollTarget();
    }
  },
  methods: {
    trigger() {
      this.$emit('refresh', () => {
        this.__animateTo({
          pos: -PULLER_HEIGHT,
          ratio: 0
        }, () => {
          this.state = 'pull';
        });
      });
    },
    updateScrollTarget() {
      this.__scrollTarget = Object(utils_scroll["d" /* getScrollTarget */])(this.$el, this.scrollTarget);
    },
    __pull(event) {
      if (event.isFinal === true) {
        if (this.pulling === true) {
          this.pulling = false;
          if (this.state === 'pulled') {
            this.state = 'refreshing';
            this.__animateTo({
              pos: OFFSET_TOP
            });
            this.trigger();
          } else if (this.state === 'pull') {
            this.__animateTo({
              pos: -PULLER_HEIGHT,
              ratio: 0
            });
          }
        }
        return;
      }
      if (this.animating === true || this.state === 'refreshing') {
        return false;
      }
      if (event.isFirst === true) {
        if (Object(utils_scroll["c" /* getScrollPosition */])(this.__scrollTarget) !== 0 || event.direction !== 'down') {
          if (this.pulling === true) {
            this.pulling = false;
            this.state = 'pull';
            this.__animateTo({
              pos: -PULLER_HEIGHT,
              ratio: 0
            });
          }
          return false;
        }
        this.pulling = true;
        const {
          top,
          left
        } = this.$el.getBoundingClientRect();
        this.positionCSS = {
          top: top + 'px',
          left: left + 'px',
          width: window.getComputedStyle(this.$el).getPropertyValue('width')
        };
      }
      Object(utils_event["i" /* prevent */])(event.evt);
      const distance = Math.min(140, Math.max(0, event.distance.y));
      this.pullPosition = distance - PULLER_HEIGHT;
      this.pullRatio = Object(format["a" /* between */])(distance / (OFFSET_TOP + PULLER_HEIGHT), 0, 1);
      const state = this.pullPosition > OFFSET_TOP ? 'pulled' : 'pull';
      if (this.state !== state) {
        this.state = state;
      }
    },
    __animateTo({
      pos,
      ratio
    }, done) {
      this.animating = true;
      this.pullPosition = pos;
      if (ratio !== void 0) {
        this.pullRatio = ratio;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.animating = false;
        done && done();
      }, 300);
    }
  },
  mounted() {
    this.updateScrollTarget();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  render(h) {
    return h('div', {
      staticClass: 'q-pull-to-refresh',
      on: {
        ...this.qListeners
      },
      directives: this.directives
    }, [h('div', {
      class: this.contentClass
    }, Object(private_slot["c" /* slot */])(this, 'default')), h('div', {
      staticClass: 'q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top',
      style: this.positionCSS
    }, [h('div', {
      style: this.style,
      class: this.classes
    }, [this.state !== 'refreshing' ? h(QIcon["a" /* default */], {
      props: {
        name: this.icon || this.$q.iconSet.pullToRefresh.icon,
        color: this.color,
        size: '32px'
      }
    }) : h(QSpinner["a" /* default */], {
      props: {
        size: '24px',
        color: this.color
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/pull-to-refresh/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/radio/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/range/QRange.js




const dragType = {
  MIN: 0,
  RANGE: 1,
  MAX: 2
};
/* harmony default export */ var QRange = (external_vue_default.a.extend({
  name: 'QRange',
  mixins: [SliderMixin],
  props: {
    value: {
      type: Object,
      default: () => ({
        min: null,
        max: null
      }),
      validator: v => 'min' in v && 'max' in v
    },
    dragRange: Boolean,
    dragOnlyRange: Boolean,
    leftLabelColor: String,
    leftLabelTextColor: String,
    rightLabelColor: String,
    rightLabelTextColor: String,
    leftLabelValue: [String, Number],
    rightLabelValue: [String, Number],
    leftThumbColor: String,
    rightThumbColor: String
  },
  data() {
    const innerMin = this.__getInnerMin(this.innerMin);
    const innerMax = this.__getInnerMax(this.innerMax);
    return {
      model: {
        min: this.value.min === null ? innerMin : Object(format["a" /* between */])(this.value.min, innerMin, innerMax),
        max: this.value.max === null ? innerMax : Object(format["a" /* between */])(this.value.max, innerMin, innerMax)
      },
      curMinRatio: 0,
      curMaxRatio: 0
    };
  },
  computed: {
    modelMinRatio() {
      return this.__convertModelToRatio(this.model.min);
    },
    modelMaxRatio() {
      return this.__convertModelToRatio(this.model.max);
    },
    ratioMin() {
      return this.active === true ? this.curMinRatio : this.modelMinRatio;
    },
    ratioMax() {
      return this.active === true ? this.curMaxRatio : this.modelMaxRatio;
    },
    selectionBarStyle() {
      const acc = {
        [this.positionProp]: `${100 * this.ratioMin}%`,
        [this.sizeProp]: `${100 * (this.ratioMax - this.ratioMin)}%`
      };
      if (this.selectionImg !== void 0) {
        acc.backgroundImage = `url(${this.selectionImg}) !important`;
      }
      return acc;
    },
    trackContainerEvents() {
      if (this.editable !== true) {
        return {};
      }
      if (this.$q.platform.is.mobile === true) {
        return {
          click: this.__onMobileClick
        };
      }
      const evt = {
        mousedown: this.__onActivate
      };
      if (this.dragRange === true || this.dragOnlyRange === true) {
        Object.assign(evt, {
          focus: () => {
            this.focus = 'both';
          },
          blur: this.__onBlur,
          keydown: this.__onKeydown,
          keyup: this.__onKeyup
        });
      }
      return evt;
    },
    trackContainerAttrs() {
      return {
        tabindex: this.$q.platform.is.mobile !== true && (this.dragRange || this.dragOnlyRange === true) ? this.computedTabindex : null
      };
    },
    thumbAttrs() {
      return {
        tabindex: this.dragOnlyRange !== true ? this.computedTabindex : null
      };
    },
    thumbMinEvents() {
      return this.__getEvents('min');
    },
    thumbMaxEvents() {
      return this.__getEvents('max');
    },
    thumbMinLabel() {
      return this.leftLabelValue !== void 0 ? this.leftLabelValue : this.model.min;
    },
    thumbMaxLabel() {
      return this.rightLabelValue !== void 0 ? this.rightLabelValue : this.model.max;
    },
    thumbMinClasses() {
      const color = this.leftThumbColor || this.thumbColor || this.color;
      return `q-slider__thumb q-slider__thumb${this.axis} q-slider__thumb${this.axis}-${this.isReversed === true ? 'rtl' : 'ltr'} absolute non-selectable` + (this.preventFocus === false && (this.focus === 'min' || this.focus === 'both') ? ' q-slider--focus' : '') + (color !== void 0 ? ` text-${color}` : '');
    },
    thumbMaxClasses() {
      const color = this.rightThumbColor || this.thumbColor || this.color;
      return `q-slider__thumb q-slider__thumb${this.axis} q-slider__thumb${this.axis}-${this.isReversed === true ? 'rtl' : 'ltr'} absolute non-selectable` + (this.preventFocus === false && (this.focus === 'max' || this.focus === 'both') ? ' q-slider--focus' : '') + (color !== void 0 ? ` text-${color}` : '');
    },
    thumbMinStyle() {
      return {
        width: this.thumbSize,
        height: this.thumbSize,
        [this.positionProp]: `${100 * this.ratioMin}%`,
        zIndex: this.focus === 'min' ? 2 : void 0
      };
    },
    thumbMaxStyle() {
      return {
        width: this.thumbSize,
        height: this.thumbSize,
        [this.positionProp]: `${100 * this.ratioMax}%`,
        zIndex: this.focus === 'max' ? 2 : void 0
      };
    },
    thumbMinPinColor() {
      const color = this.leftLabelColor || this.labelColor;
      return color !== void 0 ? ` text-${color}` : '';
    },
    thumbMaxPinColor() {
      const color = this.rightLabelColor || this.labelColor;
      return color !== void 0 ? ` text-${color}` : '';
    },
    thumbMinTextContainerStyle() {
      return this.__getTextContainerStyle(this.ratioMin);
    },
    thumbMaxTextContainerStyle() {
      return this.__getTextContainerStyle(this.ratioMax);
    },
    thumbMinTextClass() {
      const color = this.leftLabelTextColor || this.labelTextColor;
      return 'q-slider__text' + (color !== void 0 ? ` text-${color}` : '');
    },
    thumbMaxTextClass() {
      const color = this.rightLabelTextColor || this.labelTextColor;
      return 'q-slider__text' + (color !== void 0 ? ` text-${color}` : '');
    },
    formAttrs() {
      return {
        type: 'hidden',
        name: this.name,
        value: `${this.value.min}|${this.value.max}`
      };
    },
    modelUpdate() {
      return `${this.value.min}|${this.value.max}|${this.computedInnerMin}|${this.computedInnerMax}`;
    }
  },
  watch: {
    modelUpdate() {
      this.model.min = this.value.min === null ? this.computedInnerMin : Object(format["a" /* between */])(this.value.min, this.computedInnerMin, this.computedInnerMax);
      this.model.max = this.value.max === null ? this.computedInnerMax : Object(format["a" /* between */])(this.value.max, this.computedInnerMin, this.computedInnerMax);
    }
  },
  methods: {
    __updateValue(change) {
      if (this.model.min !== this.value.min || this.model.max !== this.value.max) {
        this.$emit('input', {
          ...this.model
        });
      }
      change === true && this.$emit('change', {
        ...this.model
      });
    },
    __getDragging(event) {
      const {
          left,
          top,
          width,
          height
        } = this.$el.getBoundingClientRect(),
        sensitivity = this.dragOnlyRange === true ? 0 : this.vertical === true ? this.$refs.minThumb.offsetHeight / (2 * height) : this.$refs.minThumb.offsetWidth / (2 * width);
      const dragging = {
        left,
        top,
        width,
        height,
        valueMin: this.model.min,
        valueMax: this.model.max,
        ratioMin: this.modelMinRatio,
        ratioMax: this.modelMaxRatio
      };
      const ratio = this.__getDraggingRatio(event, dragging);
      if (this.dragOnlyRange !== true && ratio < dragging.ratioMin + sensitivity) {
        dragging.type = dragType.MIN;
      } else if (this.dragOnlyRange === true || ratio < dragging.ratioMax - sensitivity) {
        if (this.dragRange === true || this.dragOnlyRange === true) {
          dragging.type = dragType.RANGE;
          Object.assign(dragging, {
            offsetRatio: ratio,
            offsetModel: this.__convertRatioToModel(ratio),
            rangeValue: dragging.valueMax - dragging.valueMin,
            rangeRatio: dragging.ratioMax - dragging.ratioMin
          });
        } else {
          dragging.type = dragging.ratioMax - ratio < ratio - dragging.ratioMin ? dragType.MAX : dragType.MIN;
        }
      } else {
        dragging.type = dragType.MAX;
      }
      return dragging;
    },
    __updatePosition(event, dragging = this.dragging) {
      let pos;
      const ratio = this.__getDraggingRatio(event, dragging);
      const localModel = this.__convertRatioToModel(ratio);
      switch (dragging.type) {
        case dragType.MIN:
          if (ratio <= dragging.ratioMax) {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMax,
              min: localModel,
              max: dragging.valueMax
            };
            this.focus = 'min';
          } else {
            pos = {
              minR: dragging.ratioMax,
              maxR: ratio,
              min: dragging.valueMax,
              max: localModel
            };
            this.focus = 'max';
          }
          break;
        case dragType.MAX:
          if (ratio >= dragging.ratioMin) {
            pos = {
              minR: dragging.ratioMin,
              maxR: ratio,
              min: dragging.valueMin,
              max: localModel
            };
            this.focus = 'max';
          } else {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMin,
              min: localModel,
              max: dragging.valueMin
            };
            this.focus = 'min';
          }
          break;
        case dragType.RANGE:
          const ratioDelta = ratio - dragging.offsetRatio,
            minR = Object(format["a" /* between */])(dragging.ratioMin + ratioDelta, 0, 1 - dragging.rangeRatio),
            modelDelta = localModel - dragging.offsetModel,
            min = Object(format["a" /* between */])(dragging.valueMin + modelDelta, this.min, this.max - dragging.rangeValue);
          pos = {
            minR,
            maxR: minR + dragging.rangeRatio,
            min: parseFloat(min.toFixed(this.computedDecimals)),
            max: parseFloat((min + dragging.rangeValue).toFixed(this.computedDecimals))
          };
          this.focus = 'both';
          break;
      }

      // If either of the values to be emitted are null, set them to the defaults the user has entered.
      this.model = this.model.min === null || this.model.max === null ? {
        min: pos.min || this.min,
        max: pos.max || this.max
      } : {
        min: pos.min,
        max: pos.max
      };
      if (this.snap !== true || this.step === 0) {
        this.curMinRatio = pos.minR;
        this.curMaxRatio = pos.maxR;
      } else {
        this.curMinRatio = this.__convertModelToRatio(this.model.min);
        this.curMaxRatio = this.__convertModelToRatio(this.model.max);
      }
    },
    __getEvents(side) {
      return this.$q.platform.is.mobile !== true && this.editable === true && this.dragOnlyRange !== true ? {
        focus: () => {
          this.focus = side;
        },
        blur: this.__onBlur,
        keydown: this.__onKeydown,
        keyup: this.__onKeyup
      } : {};
    },
    __onKeydown(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }
      Object(utils_event["l" /* stopAndPrevent */])(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * this.computedStep,
        offset = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (this.isReversed === true ? -1 : 1) * (this.vertical === true ? -1 : 1) * stepVal;
      if (this.focus === 'both') {
        const interval = this.model.max - this.model.min;
        const min = Object(format["a" /* between */])(parseFloat((this.model.min + offset).toFixed(this.computedDecimals)), this.computedInnerMin, this.computedInnerMax - interval);
        this.model = {
          min,
          max: parseFloat((min + interval).toFixed(this.computedDecimals))
        };
      } else if (this.focus === false) {
        return;
      } else {
        const which = this.focus;
        this.model = {
          ...this.model,
          [which]: Object(format["a" /* between */])(parseFloat((this.model[which] + offset).toFixed(this.computedDecimals)), which === 'min' ? this.computedInnerMin : this.model.min, which === 'max' ? this.computedInnerMax : this.model.max)
        };
      }
      this.__updateValue();
    }
  },
  render(h) {
    const content = this.__getContent(h, node => {
      node.push(this.__getThumb(h, {
        pinColor: this.thumbMinPinColor,
        textContainerStyle: this.thumbMinTextContainerStyle,
        textClass: this.thumbMinTextClass,
        label: this.thumbMinLabel,
        classes: this.thumbMinClasses,
        style: this.thumbMinStyle,
        nodeData: {
          ref: 'minThumb',
          key: 'tmin',
          on: this.thumbMinEvents,
          attrs: this.thumbAttrs
        }
      }), this.__getThumb(h, {
        pinColor: this.thumbMaxPinColor,
        textContainerStyle: this.thumbMaxTextContainerStyle,
        textClass: this.thumbMaxTextClass,
        label: this.thumbMaxLabel,
        classes: this.thumbMaxClasses,
        style: this.thumbMaxStyle,
        nodeData: {
          key: 'tmax',
          on: this.thumbMaxEvents,
          attrs: this.thumbAttrs
        }
      }));
    });
    return h('div', {
      class: 'q-range ' + this.classes + (this.value.min === null || this.value.max === null ? ' q-slider--no-value' : ''),
      attrs: {
        ...this.attributes,
        'aria-valuenow': this.value.min + '|' + this.value.max
      }
    }, content);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/range/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/rating/QRating.js









/* harmony default export */ var QRating = (external_vue_default.a.extend({
  name: 'QRating',
  mixins: [size["a" /* default */], mixins_form["b" /* default */], listeners["a" /* default */]],
  props: {
    value: {
      type: Number,
      required: true
    },
    max: {
      type: [String, Number],
      default: 5
    },
    icon: [String, Array],
    iconHalf: [String, Array],
    iconSelected: [String, Array],
    iconAriaLabel: [String, Array],
    color: [String, Array],
    colorHalf: [String, Array],
    colorSelected: [String, Array],
    noReset: Boolean,
    noDimming: Boolean,
    readonly: Boolean,
    disable: Boolean
  },
  data() {
    return {
      mouseModel: 0
    };
  },
  computed: {
    editable() {
      return this.readonly !== true && this.disable !== true;
    },
    classes() {
      return `q-rating--${this.editable === true ? '' : 'non-'}editable` + (this.noDimming === true ? ' q-rating--no-dimming' : '') + (this.disable === true ? ' disabled' : '') + (this.color !== void 0 && Array.isArray(this.color) === false ? ` text-${this.color}` : '');
    },
    iconData() {
      const iconLen = Array.isArray(this.icon) === true ? this.icon.length : 0,
        selIconLen = Array.isArray(this.iconSelected) === true ? this.iconSelected.length : 0,
        halfIconLen = Array.isArray(this.iconHalf) === true ? this.iconHalf.length : 0,
        colorLen = Array.isArray(this.color) === true ? this.color.length : 0,
        selColorLen = Array.isArray(this.colorSelected) === true ? this.colorSelected.length : 0,
        halfColorLen = Array.isArray(this.colorHalf) === true ? this.colorHalf.length : 0;
      return {
        iconLen,
        icon: iconLen > 0 ? this.icon[iconLen - 1] : this.icon,
        selIconLen,
        selIcon: selIconLen > 0 ? this.iconSelected[selIconLen - 1] : this.iconSelected,
        halfIconLen,
        halfIcon: halfIconLen > 0 ? this.iconHalf[selIconLen - 1] : this.iconHalf,
        colorLen,
        color: colorLen > 0 ? this.color[colorLen - 1] : this.color,
        selColorLen,
        selColor: selColorLen > 0 ? this.colorSelected[selColorLen - 1] : this.colorSelected,
        halfColorLen,
        halfColor: halfColorLen > 0 ? this.colorHalf[halfColorLen - 1] : this.colorHalf
      };
    },
    iconLabel() {
      if (typeof this.iconAriaLabel === 'string') {
        const label = this.iconAriaLabel.length > 0 ? `${this.iconAriaLabel} ` : '';
        return i => `${label}${i}`;
      }
      if (Array.isArray(this.iconAriaLabel) === true) {
        const iMax = this.iconAriaLabel.length;
        if (iMax > 0) {
          return i => this.iconAriaLabel[Math.min(i, iMax) - 1];
        }
      }
      return (i, label) => `${label} ${i}`;
    },
    stars() {
      const acc = [],
        icons = this.iconData,
        ceil = Math.ceil(this.value),
        tabindex = this.editable === true ? 0 : null;
      const halfIndex = this.iconHalf === void 0 || ceil === this.value ? -1 : ceil;
      for (let i = 1; i <= this.max; i++) {
        const active = this.mouseModel === 0 && this.value >= i || this.mouseModel > 0 && this.mouseModel >= i,
          half = halfIndex === i && this.mouseModel < i,
          exSelected = this.mouseModel > 0 && (half === true ? ceil : this.value) >= i && this.mouseModel < i,
          color = half === true ? i <= icons.halfColorLen ? this.colorHalf[i - 1] : icons.halfColor : icons.selColor !== void 0 && active === true ? i <= icons.selColorLen ? this.colorSelected[i - 1] : icons.selColor : i <= icons.colorLen ? this.color[i - 1] : icons.color,
          name = (half === true ? i <= icons.halfIconLen ? this.iconHalf[i - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i <= icons.selIconLen ? this.iconSelected[i - 1] : icons.selIcon : i <= icons.iconLen ? this.icon[i - 1] : icons.icon) || this.$q.iconSet.rating.icon;
        acc.push({
          name,
          attrs: {
            tabindex,
            role: 'radio',
            'aria-checked': this.value === i ? 'true' : 'false',
            'aria-label': this.iconLabel(i, name)
          },
          classes: 'q-rating__icon' + (active === true || half === true ? ' q-rating__icon--active' : '') + (exSelected === true ? ' q-rating__icon--exselected' : '') + (this.mouseModel === i ? ' q-rating__icon--hovered' : '') + (color !== void 0 ? ` text-${color}` : '')
        });
      }
      return acc;
    },
    attrs() {
      const attrs = {
        role: 'radiogroup'
      };
      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      }
      if (this.readonly === true) {
        attrs['aria-readonly'] = 'true';
      }
      return attrs;
    }
  },
  methods: {
    __set(value) {
      if (this.editable === true) {
        const model = Object(format["a" /* between */])(parseInt(value, 10), 1, parseInt(this.max, 10)),
          newVal = this.noReset !== true && this.value === model ? 0 : model;
        newVal !== this.value && this.$emit('input', newVal);
        this.mouseModel = 0;
      }
    },
    __setHoverValue(value) {
      if (this.editable === true) {
        this.mouseModel = value;
      }
    },
    __keyup(e, i) {
      switch (e.keyCode) {
        case 13:
        case 32:
          this.__set(i);
          return Object(utils_event["l" /* stopAndPrevent */])(e);
        case 37: // LEFT ARROW
        case 40:
          // DOWN ARROW
          if (this.$refs[`rt${i - 1}`]) {
            this.$refs[`rt${i - 1}`].focus();
          }
          return Object(utils_event["l" /* stopAndPrevent */])(e);
        case 39: // RIGHT ARROW
        case 38:
          // UP ARROW
          if (this.$refs[`rt${i + 1}`]) {
            this.$refs[`rt${i + 1}`].focus();
          }
          return Object(utils_event["l" /* stopAndPrevent */])(e);
      }
    }
  },
  render(h) {
    const child = [];
    this.stars.forEach(({
      classes,
      name,
      attrs
    }, index) => {
      const i = index + 1;
      child.push(h('div', {
        key: i,
        ref: `rt${i}`,
        class: 'q-rating__icon-container flex flex-center',
        attrs,
        on: Object(cache["b" /* default */])(this, 'i#' + i, {
          click: () => {
            this.__set(i);
          },
          mouseover: () => {
            this.__setHoverValue(i);
          },
          mouseout: () => {
            this.mouseModel = 0;
          },
          focus: () => {
            this.__setHoverValue(i);
          },
          blur: () => {
            this.mouseModel = 0;
          },
          keyup: e => {
            this.__keyup(e, i);
          }
        })
      }, Object(private_slot["a" /* mergeSlot */])([h(QIcon["a" /* default */], {
        class: classes,
        props: {
          name
        }
      })], this, `tip-${i}`)));
    });
    if (this.name !== void 0 && this.disable !== true) {
      this.__injectFormInput(child, 'push');
    }
    return h('div', {
      staticClass: 'q-rating row inline items-center',
      class: this.classes,
      style: this.sizeStyle,
      attrs: this.attrs,
      on: {
        ...this.qListeners
      }
    }, child);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/rating/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/resize-observer/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/responsive/QResponsive.js




/* harmony default export */ var QResponsive = (external_vue_default.a.extend({
  name: 'QResponsive',
  mixins: [mixins_ratio, listeners["a" /* default */]],
  render(h) {
    return h('div', {
      staticClass: 'q-responsive',
      on: {
        ...this.qListeners
      }
    }, [h('div', {
      staticClass: 'q-responsive__filler overflow-hidden'
    }, [h('div', {
      style: this.ratioStyle
    })]), h('div', {
      staticClass: 'q-responsive__content absolute-full fit'
    }, Object(private_slot["c" /* slot */])(this, 'default'))]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/responsive/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/scroll-area/QScrollArea.js
var QScrollArea = __webpack_require__("2747");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/scroll-area/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/scroll-observer/QScrollObserver.js
var QScrollObserver = __webpack_require__("1496");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/scroll-observer/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/select/QSelect.js
var QSelect = __webpack_require__("dc96");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/select/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/separator/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/skeleton/QSkeleton.js





const skeletonTypes = ['text', 'rect', 'circle', 'QBtn', 'QBadge', 'QChip', 'QToolbar', 'QCheckbox', 'QRadio', 'QToggle', 'QSlider', 'QRange', 'QInput', 'QAvatar'];
const skeletonAnimations = ['wave', 'pulse', 'pulse-x', 'pulse-y', 'fade', 'blink', 'none'];
/* harmony default export */ var QSkeleton = (external_vue_default.a.extend({
  name: 'QSkeleton',
  mixins: [dark["a" /* default */], tag["a" /* default */], listeners["a" /* default */]],
  props: {
    type: {
      type: String,
      validator: v => skeletonTypes.includes(v),
      default: 'rect'
    },
    animation: {
      type: String,
      validator: v => skeletonAnimations.includes(v),
      default: 'wave'
    },
    square: Boolean,
    bordered: Boolean,
    size: String,
    width: String,
    height: String
  },
  computed: {
    style() {
      return this.size !== void 0 ? {
        width: this.size,
        height: this.size
      } : {
        width: this.width,
        height: this.height
      };
    },
    classes() {
      return `q-skeleton--${this.isDark === true ? 'dark' : 'light'} q-skeleton--type-${this.type}` + (this.animation !== 'none' ? ` q-skeleton--anim q-skeleton--anim-${this.animation}` : '') + (this.square === true ? ' q-skeleton--square' : '') + (this.bordered === true ? ' q-skeleton--bordered' : '');
    }
  },
  render(h) {
    return h(this.tag, {
      staticClass: 'q-skeleton',
      class: this.classes,
      style: this.style,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/skeleton/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/slide-item/QSlideItem.js






const slotsDef = [['left', 'center', 'start', 'width'], ['right', 'center', 'end', 'width'], ['top', 'start', 'center', 'height'], ['bottom', 'end', 'center', 'height']];
/* harmony default export */ var QSlideItem = (external_vue_default.a.extend({
  name: 'QSlideItem',
  mixins: [dark["a" /* default */], listeners["a" /* default */]],
  props: {
    leftColor: String,
    rightColor: String,
    topColor: String,
    bottomColor: String
  },
  directives: {
    TouchPan: TouchPan["a" /* default */]
  },
  computed: {
    langDir() {
      return this.$q.lang.rtl === true ? {
        left: 'right',
        right: 'left'
      } : {
        left: 'left',
        right: 'right'
      };
    }
  },
  methods: {
    reset() {
      this.$refs.content.style.transform = 'translate(0,0)';
      this.__emitSlide(this.__showing, 0, true);
    },
    __emitSlide(side, ratio, isReset) {
      this.qListeners.slide !== void 0 && this.$emit('slide', {
        side,
        ratio,
        isReset
      });
    },
    __pan(evt) {
      const node = this.$refs.content;
      if (evt.isFirst) {
        this.__dir = null;
        this.__size = {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        };
        this.__scale = 0;
        node.classList.add('no-transition');
        slotsDef.forEach(slot => {
          if (this.$scopedSlots[slot[0]] !== void 0) {
            const node = this.$refs[slot[0] + 'Content'];
            node.style.transform = 'scale(1)';
            this.__size[slot[0]] = node.getBoundingClientRect()[slot[3]];
          }
        });
        this.__axis = evt.direction === 'up' || evt.direction === 'down' ? 'Y' : 'X';
      } else if (evt.isFinal) {
        node.classList.remove('no-transition');
        if (this.__scale === 1) {
          node.style.transform = `translate${this.__axis}(${this.__dir * 100}%)`;
          this.timer = setTimeout(() => {
            this.$emit(this.__showing, {
              reset: this.reset
            });
            this.$emit('action', {
              side: this.__showing,
              reset: this.reset
            });
          }, 230);
        } else {
          node.style.transform = 'translate(0,0)';
          this.__emitSlide(this.__showing, 0, true);
        }
        return;
      } else {
        evt.direction = this.__axis === 'X' ? evt.offset.x < 0 ? 'left' : 'right' : evt.offset.y < 0 ? 'up' : 'down';
      }
      if (this.$scopedSlots.left === void 0 && evt.direction === this.langDir.right || this.$scopedSlots.right === void 0 && evt.direction === this.langDir.left || this.$scopedSlots.top === void 0 && evt.direction === 'down' || this.$scopedSlots.bottom === void 0 && evt.direction === 'up') {
        node.style.transform = 'translate(0,0)';
        return;
      }
      let showing, dir, dist;
      if (this.__axis === 'X') {
        dir = evt.direction === 'left' ? -1 : 1;
        showing = dir === 1 ? this.langDir.left : this.langDir.right;
        dist = evt.distance.x;
      } else {
        dir = evt.direction === 'up' ? -2 : 2;
        showing = dir === 2 ? 'top' : 'bottom';
        dist = evt.distance.y;
      }
      if (this.__dir !== null && Math.abs(dir) !== Math.abs(this.__dir)) {
        return;
      }
      if (this.__dir !== dir) {
        ['left', 'right', 'top', 'bottom'].forEach(d => {
          if (this.$refs[d] !== void 0) {
            this.$refs[d].style.visibility = showing === d ? 'visible' : 'hidden';
          }
        });
        this.__showing = showing;
        this.__dir = dir;
      }
      this.__scale = Math.max(0, Math.min(1, (dist - 40) / this.__size[showing]));
      node.style.transform = `translate${this.__axis}(${dist * dir / Math.abs(dir)}px)`;
      this.$refs[`${showing}Content`].style.transform = `scale(${this.__scale})`;
      this.__emitSlide(showing, this.__scale, false);
    }
  },
  render(h) {
    const content = [],
      slots = {
        left: this.$scopedSlots[this.langDir.right] !== void 0,
        right: this.$scopedSlots[this.langDir.left] !== void 0,
        up: this.$scopedSlots.bottom !== void 0,
        down: this.$scopedSlots.top !== void 0
      },
      dirs = Object.keys(slots).filter(key => slots[key] === true);
    slotsDef.forEach(slot => {
      const dir = slot[0];
      if (this.$scopedSlots[dir] !== void 0) {
        content.push(h('div', {
          ref: dir,
          class: `q-slide-item__${dir} absolute-full row no-wrap items-${slot[1]} justify-${slot[2]}` + (this[dir + 'Color'] !== void 0 ? ` bg-${this[dir + 'Color']}` : '')
        }, [h('div', {
          ref: dir + 'Content'
        }, this.$scopedSlots[dir]())]));
      }
    });
    content.push(h('div', {
      ref: 'content',
      key: 'content',
      staticClass: 'q-slide-item__content',
      directives: dirs.length > 0 ? Object(cache["a" /* cacheWithFn */])(this, 'dir#' + dirs.join(''), () => {
        const modifiers = {
          prevent: true,
          stop: true,
          mouse: true
        };
        dirs.forEach(dir => {
          modifiers[dir] = true;
        });
        return [{
          name: 'touch-pan',
          value: this.__pan,
          modifiers
        }];
      }) : null
    }, Object(private_slot["c" /* slot */])(this, 'default')));
    return h('div', {
      staticClass: 'q-slide-item q-item-type overflow-hidden',
      class: this.isDark === true ? 'q-slide-item--dark q-dark' : '',
      on: {
        ...this.qListeners
      }
    }, content);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/slide-item/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/slide-transition/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/slider/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/space/QSpace.js
var QSpace = __webpack_require__("f63b");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/space/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/components/spinner/spinner-mixin.js
var spinner_mixin = __webpack_require__("ab6b");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerAudio.js


/* harmony default export */ var QSpinnerAudio = (external_vue_default.a.extend({
  name: 'QSpinnerAudio',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'fill': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 55 80',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', {
      attrs: {
        'transform': 'matrix(1 0 0 -1 0 80)'
      }
    }, [h('rect', {
      attrs: {
        'width': '10',
        'height': '20',
        'rx': '3'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0s',
        'dur': '4.3s',
        'values': '20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('rect', {
      attrs: {
        'x': '15',
        'width': '10',
        'height': '80',
        'rx': '3'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0s',
        'dur': '2s',
        'values': '80;55;33;5;75;23;73;33;12;14;60;80',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('rect', {
      attrs: {
        'x': '30',
        'width': '10',
        'height': '50',
        'rx': '3'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0s',
        'dur': '1.4s',
        'values': '50;34;78;23;56;23;34;76;80;54;21;50',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('rect', {
      attrs: {
        'x': '45',
        'width': '10',
        'height': '30',
        'rx': '3'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0s',
        'dur': '2s',
        'values': '30;45;13;80;56;72;45;76;34;23;67;30',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerBall.js


/* harmony default export */ var QSpinnerBall = (external_vue_default.a.extend({
  name: 'QSpinnerBall',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'stroke': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 57 57',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', {
      attrs: {
        'transform': 'translate(1 1)',
        'stroke-width': '2',
        'fill': 'none',
        'fill-rule': 'evenodd'
      }
    }, [h('circle', {
      attrs: {
        'cx': '5',
        'cy': '50',
        'r': '5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'cy',
        'begin': '0s',
        'dur': '2.2s',
        'values': '50;5;50;50',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'cx',
        'begin': '0s',
        'dur': '2.2s',
        'values': '5;27;49;5',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '27',
        'cy': '5',
        'r': '5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'cy',
        'begin': '0s',
        'dur': '2.2s',
        'from': '5',
        'to': '5',
        'values': '5;50;50;5',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'cx',
        'begin': '0s',
        'dur': '2.2s',
        'from': '27',
        'to': '27',
        'values': '27;49;5;27',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '49',
        'cy': '50',
        'r': '5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'cy',
        'begin': '0s',
        'dur': '2.2s',
        'values': '50;50;5;50',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'cx',
        'from': '49',
        'to': '49',
        'begin': '0s',
        'dur': '2.2s',
        'values': '49;5;27;49',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerBars.js


/* harmony default export */ var QSpinnerBars = (external_vue_default.a.extend({
  name: 'QSpinnerBars',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'fill': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 135 140',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('rect', {
      attrs: {
        'y': '10',
        'width': '15',
        'height': '120',
        'rx': '6'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0.5s',
        'dur': '1s',
        'values': '120;110;100;90;80;70;60;50;40;140;120',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'y',
        'begin': '0.5s',
        'dur': '1s',
        'values': '10;15;20;25;30;35;40;45;50;0;10',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('rect', {
      attrs: {
        'x': '30',
        'y': '10',
        'width': '15',
        'height': '120',
        'rx': '6'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0.25s',
        'dur': '1s',
        'values': '120;110;100;90;80;70;60;50;40;140;120',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'y',
        'begin': '0.25s',
        'dur': '1s',
        'values': '10;15;20;25;30;35;40;45;50;0;10',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('rect', {
      attrs: {
        'x': '60',
        'width': '15',
        'height': '140',
        'rx': '6'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0s',
        'dur': '1s',
        'values': '120;110;100;90;80;70;60;50;40;140;120',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'y',
        'begin': '0s',
        'dur': '1s',
        'values': '10;15;20;25;30;35;40;45;50;0;10',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('rect', {
      attrs: {
        'x': '90',
        'y': '10',
        'width': '15',
        'height': '120',
        'rx': '6'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0.25s',
        'dur': '1s',
        'values': '120;110;100;90;80;70;60;50;40;140;120',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'y',
        'begin': '0.25s',
        'dur': '1s',
        'values': '10;15;20;25;30;35;40;45;50;0;10',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('rect', {
      attrs: {
        'x': '120',
        'y': '10',
        'width': '15',
        'height': '120',
        'rx': '6'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'begin': '0.5s',
        'dur': '1s',
        'values': '120;110;100;90;80;70;60;50;40;140;120',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'y',
        'begin': '0.5s',
        'dur': '1s',
        'values': '10;15;20;25;30;35;40;45;50;0;10',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerBox.js


/* harmony default export */ var QSpinnerBox = (external_vue_default.a.extend({
  name: 'QSpinnerBox',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid'
      }
    }, [h('rect', {
      attrs: {
        'x': '25',
        'y': '25',
        'width': '50',
        'height': '50',
        'fill': 'none',
        'stroke-width': '4',
        'stroke': 'currentColor'
      }
    }, [h('animateTransform', {
      attrs: {
        'id': 'spinnerBox',
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '180 50 50',
        'dur': '0.5s',
        'begin': 'rectBox.end'
      }
    })]), h('rect', {
      attrs: {
        'x': '27',
        'y': '27',
        'width': '46',
        'height': '50',
        'fill': 'currentColor'
      }
    }, [h('animate', {
      attrs: {
        'id': 'rectBox',
        'attributeName': 'height',
        'begin': '0s;spinnerBox.end',
        'dur': '1.3s',
        'from': '50',
        'to': '0',
        'fill': 'freeze'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerClock.js


/* harmony default export */ var QSpinnerClock = (external_vue_default.a.extend({
  name: 'QSpinnerClock',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid'
      }
    }, [h('circle', {
      attrs: {
        'cx': '50',
        'cy': '50',
        'r': '48',
        'fill': 'none',
        'stroke-width': '4',
        'stroke-miterlimit': '10',
        'stroke': 'currentColor'
      }
    }), h('line', {
      attrs: {
        'stroke-linecap': 'round',
        'stroke-width': '4',
        'stroke-miterlimit': '10',
        'stroke': 'currentColor',
        'x1': '50',
        'y1': '50',
        'x2': '85',
        'y2': '50.5'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '360 50 50',
        'dur': '2s',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'stroke-linecap': 'round',
        'stroke-width': '4',
        'stroke-miterlimit': '10',
        'stroke': 'currentColor',
        'x1': '50',
        'y1': '50',
        'x2': '49.5',
        'y2': '74'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '360 50 50',
        'dur': '15s',
        'repeatCount': 'indefinite'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerComment.js


/* harmony default export */ var QSpinnerComment = (external_vue_default.a.extend({
  name: 'QSpinnerComment',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid'
      }
    }, [h('rect', {
      attrs: {
        'x': '0',
        'y': '0',
        'width': '100',
        'height': '100',
        'fill': 'none'
      }
    }), h('path', {
      attrs: {
        'd': 'M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z',
        'fill': 'currentColor'
      }
    }), h('circle', {
      attrs: {
        'cx': '30',
        'cy': '47',
        'r': '5',
        'fill': '#fff'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'opacity',
        'from': '0',
        'to': '1',
        'values': '0;1;1',
        'keyTimes': '0;0.2;1',
        'dur': '1s',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '50',
        'cy': '47',
        'r': '5',
        'fill': '#fff'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'opacity',
        'from': '0',
        'to': '1',
        'values': '0;0;1;1',
        'keyTimes': '0;0.2;0.4;1',
        'dur': '1s',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '70',
        'cy': '47',
        'r': '5',
        'fill': '#fff'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'opacity',
        'from': '0',
        'to': '1',
        'values': '0;0;1;1',
        'keyTimes': '0;0.4;0.6;1',
        'dur': '1s',
        'repeatCount': 'indefinite'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerCube.js


/* harmony default export */ var QSpinnerCube = (external_vue_default.a.extend({
  name: 'QSpinnerCube',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid'
      }
    }, [h('rect', {
      attrs: {
        'x': '0',
        'y': '0',
        'width': '100',
        'height': '100',
        'fill': 'none'
      }
    }), h('g', {
      attrs: {
        'transform': 'translate(25 25)'
      }
    }, [h('rect', {
      attrs: {
        'x': '-20',
        'y': '-20',
        'width': '40',
        'height': '40',
        'fill': 'currentColor',
        'opacity': '0.9'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'scale',
        'from': '1.5',
        'to': '1',
        'repeatCount': 'indefinite',
        'begin': '0s',
        'dur': '1s',
        'calcMode': 'spline',
        'keySplines': '0.2 0.8 0.2 0.8',
        'keyTimes': '0;1'
      }
    })])]), h('g', {
      attrs: {
        'transform': 'translate(75 25)'
      }
    }, [h('rect', {
      attrs: {
        'x': '-20',
        'y': '-20',
        'width': '40',
        'height': '40',
        'fill': 'currentColor',
        'opacity': '0.8'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'scale',
        'from': '1.5',
        'to': '1',
        'repeatCount': 'indefinite',
        'begin': '0.1s',
        'dur': '1s',
        'calcMode': 'spline',
        'keySplines': '0.2 0.8 0.2 0.8',
        'keyTimes': '0;1'
      }
    })])]), h('g', {
      attrs: {
        'transform': 'translate(25 75)'
      }
    }, [h('rect', {
      staticClass: 'cube',
      attrs: {
        'x': '-20',
        'y': '-20',
        'width': '40',
        'height': '40',
        'fill': 'currentColor',
        'opacity': '0.7'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'scale',
        'from': '1.5',
        'to': '1',
        'repeatCount': 'indefinite',
        'begin': '0.3s',
        'dur': '1s',
        'calcMode': 'spline',
        'keySplines': '0.2 0.8 0.2 0.8',
        'keyTimes': '0;1'
      }
    })])]), h('g', {
      attrs: {
        'transform': 'translate(75 75)'
      }
    }, [h('rect', {
      staticClass: 'cube',
      attrs: {
        'x': '-20',
        'y': '-20',
        'width': '40',
        'height': '40',
        'fill': 'currentColor',
        'opacity': '0.6'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'scale',
        'from': '1.5',
        'to': '1',
        'repeatCount': 'indefinite',
        'begin': '0.2s',
        'dur': '1s',
        'calcMode': 'spline',
        'keySplines': '0.2 0.8 0.2 0.8',
        'keyTimes': '0;1'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerDots.js


/* harmony default export */ var QSpinnerDots = (external_vue_default.a.extend({
  name: 'QSpinnerDots',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'fill': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 120 30',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('circle', {
      attrs: {
        'cx': '15',
        'cy': '15',
        'r': '15'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'from': '15',
        'to': '15',
        'begin': '0s',
        'dur': '0.8s',
        'values': '15;9;15',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'from': '1',
        'to': '1',
        'begin': '0s',
        'dur': '0.8s',
        'values': '1;.5;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '60',
        'cy': '15',
        'r': '9',
        'fill-opacity': '.3'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'from': '9',
        'to': '9',
        'begin': '0s',
        'dur': '0.8s',
        'values': '9;15;9',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'from': '.5',
        'to': '.5',
        'begin': '0s',
        'dur': '0.8s',
        'values': '.5;1;.5',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '105',
        'cy': '15',
        'r': '15'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'from': '15',
        'to': '15',
        'begin': '0s',
        'dur': '0.8s',
        'values': '15;9;15',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'from': '1',
        'to': '1',
        'begin': '0s',
        'dur': '0.8s',
        'values': '1;.5;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerFacebook.js


/* harmony default export */ var QSpinnerFacebook = (external_vue_default.a.extend({
  name: 'QSpinnerFacebook',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 100 100',
        'xmlns': 'http://www.w3.org/2000/svg',
        'preserveAspectRatio': 'xMidYMid'
      }
    }, [h('g', {
      attrs: {
        'transform': 'translate(20 50)'
      }
    }, [h('rect', {
      attrs: {
        'x': '-10',
        'y': '-30',
        'width': '20',
        'height': '60',
        'fill': 'currentColor',
        'opacity': '0.6'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'scale',
        'from': '2',
        'to': '1',
        'begin': '0s',
        'repeatCount': 'indefinite',
        'dur': '1s',
        'calcMode': 'spline',
        'keySplines': '0.1 0.9 0.4 1',
        'keyTimes': '0;1',
        'values': '2;1'
      }
    })])]), h('g', {
      attrs: {
        'transform': 'translate(50 50)'
      }
    }, [h('rect', {
      attrs: {
        'x': '-10',
        'y': '-30',
        'width': '20',
        'height': '60',
        'fill': 'currentColor',
        'opacity': '0.8'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'scale',
        'from': '2',
        'to': '1',
        'begin': '0.1s',
        'repeatCount': 'indefinite',
        'dur': '1s',
        'calcMode': 'spline',
        'keySplines': '0.1 0.9 0.4 1',
        'keyTimes': '0;1',
        'values': '2;1'
      }
    })])]), h('g', {
      attrs: {
        'transform': 'translate(80 50)'
      }
    }, [h('rect', {
      attrs: {
        'x': '-10',
        'y': '-30',
        'width': '20',
        'height': '60',
        'fill': 'currentColor',
        'opacity': '0.9'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'scale',
        'from': '2',
        'to': '1',
        'begin': '0.2s',
        'repeatCount': 'indefinite',
        'dur': '1s',
        'calcMode': 'spline',
        'keySplines': '0.1 0.9 0.4 1',
        'keyTimes': '0;1',
        'values': '2;1'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerGears.js


/* harmony default export */ var QSpinnerGears = (external_vue_default.a.extend({
  name: 'QSpinnerGears',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', {
      attrs: {
        'transform': 'translate(-20,-20)'
      }
    }, [h('path', {
      attrs: {
        'd': 'M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z',
        'fill': 'currentColor'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '90 50 50',
        'to': '0 50 50',
        'dur': '1s',
        'repeatCount': 'indefinite'
      }
    })])]), h('g', {
      attrs: {
        'transform': 'translate(20,20) rotate(15 50 50)'
      }
    }, [h('path', {
      attrs: {
        'd': 'M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z',
        'fill': 'currentColor'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '90 50 50',
        'dur': '1s',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerGrid.js


/* harmony default export */ var QSpinnerGrid = (external_vue_default.a.extend({
  name: 'QSpinnerGrid',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'fill': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 105 105',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('circle', {
      attrs: {
        'cx': '12.5',
        'cy': '12.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '0s',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '12.5',
        'cy': '52.5',
        'r': '12.5',
        'fill-opacity': '.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '100ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '52.5',
        'cy': '12.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '300ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '52.5',
        'cy': '52.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '600ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '92.5',
        'cy': '12.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '800ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '92.5',
        'cy': '52.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '400ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '12.5',
        'cy': '92.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '700ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '52.5',
        'cy': '92.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '500ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '92.5',
        'cy': '92.5',
        'r': '12.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '200ms',
        'dur': '1s',
        'values': '1;.2;1',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerHearts.js


/* harmony default export */ var QSpinnerHearts = (external_vue_default.a.extend({
  name: 'QSpinnerHearts',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'fill': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 140 64',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('path', {
      attrs: {
        'd': 'M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z',
        'fill-opacity': '.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '0s',
        'dur': '1.4s',
        'values': '0.5;1;0.5',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('path', {
      attrs: {
        'd': 'M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z',
        'fill-opacity': '.5'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'fill-opacity',
        'begin': '0.7s',
        'dur': '1.4s',
        'values': '0.5;1;0.5',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('path', {
      attrs: {
        'd': 'M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z'
      }
    })]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerHourglass.js


/* harmony default export */ var QSpinnerHourglass = (external_vue_default.a.extend({
  name: 'QSpinnerHourglass',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', [h('path', {
      staticClass: 'glass',
      attrs: {
        'fill': 'none',
        'stroke': 'currentColor',
        'stroke-width': '5',
        'stroke-miterlimit': '10',
        'd': 'M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z'
      }
    }), h('clipPath', {
      attrs: {
        'id': 'uil-hourglass-clip1'
      }
    }, [h('rect', {
      staticClass: 'clip',
      attrs: {
        'x': '15',
        'y': '20',
        'width': '70',
        'height': '25'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'from': '25',
        'to': '0',
        'dur': '1s',
        'repeatCount': 'indefinite',
        'values': '25;0;0',
        'keyTimes': '0;0.5;1'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'y',
        'from': '20',
        'to': '45',
        'dur': '1s',
        'repeatCount': 'indefinite',
        'values': '20;45;45',
        'keyTimes': '0;0.5;1'
      }
    })])]), h('clipPath', {
      attrs: {
        'id': 'uil-hourglass-clip2'
      }
    }, [h('rect', {
      staticClass: 'clip',
      attrs: {
        'x': '15',
        'y': '55',
        'width': '70',
        'height': '25'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'height',
        'from': '0',
        'to': '25',
        'dur': '1s',
        'repeatCount': 'indefinite',
        'values': '0;25;25',
        'keyTimes': '0;0.5;1'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'y',
        'from': '80',
        'to': '55',
        'dur': '1s',
        'repeatCount': 'indefinite',
        'values': '80;55;55',
        'keyTimes': '0;0.5;1'
      }
    })])]), h('path', {
      staticClass: 'sand',
      attrs: {
        'd': 'M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z',
        'clip-path': 'url(#uil-hourglass-clip1)',
        'fill': 'currentColor'
      }
    }), h('path', {
      staticClass: 'sand',
      attrs: {
        'd': 'M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z',
        'clip-path': 'url(#uil-hourglass-clip2)',
        'fill': 'currentColor'
      }
    }), h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '180 50 50',
        'repeatCount': 'indefinite',
        'dur': '1s',
        'values': '0 50 50;0 50 50;180 50 50',
        'keyTimes': '0;0.7;1'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerInfinity.js


/* harmony default export */ var QSpinnerInfinity = (external_vue_default.a.extend({
  name: 'QSpinnerInfinity',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid'
      }
    }, [h('path', {
      attrs: {
        'd': 'M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z',
        'fill': 'none',
        'stroke': 'currentColor',
        'stroke-width': '8',
        'stroke-dasharray': '10.691205342610678 10.691205342610678',
        'stroke-dashoffset': '0'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-dashoffset',
        'from': '0',
        'to': '21.382410685221355',
        'begin': '0',
        'dur': '2s',
        'repeatCount': 'indefinite',
        'fill': 'freeze'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerIos.js


/* harmony default export */ var QSpinnerIos = (external_vue_default.a.extend({
  name: 'QSpinnerIos',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'stroke': 'currentColor',
        'fill': 'currentColor',
        'viewBox': '0 0 64 64'
      }
    }, [h('g', {
      attrs: {
        'stroke-width': '4',
        'stroke-linecap': 'round'
      }
    }, [h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(180)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(210)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(240)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(270)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(300)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(330)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(0)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(30)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(60)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(90)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(120)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85',
        'repeatCount': 'indefinite'
      }
    })]), h('line', {
      attrs: {
        'y1': '17',
        'y2': '29',
        'transform': 'translate(32,32) rotate(150)'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'dur': '750ms',
        'values': '1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerOrbit.js


/* harmony default export */ var QSpinnerOrbit = (external_vue_default.a.extend({
  name: 'QSpinnerOrbit',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid'
      }
    }, [h('circle', {
      attrs: {
        'cx': '50',
        'cy': '50',
        'r': '44',
        'fill': 'none',
        'stroke-width': '4',
        'stroke-opacity': '.5',
        'stroke': 'currentColor'
      }
    }), h('circle', {
      attrs: {
        'cx': '8',
        'cy': '54',
        'r': '6',
        'fill': 'currentColor',
        'stroke-width': '3',
        'stroke': 'currentColor'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 48',
        'to': '360 50 52',
        'dur': '2s',
        'repeatCount': 'indefinite'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerOval.js


/* harmony default export */ var QSpinnerOval = (external_vue_default.a.extend({
  name: 'QSpinnerOval',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'stroke': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 38 38',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', {
      attrs: {
        'transform': 'translate(1 1)',
        'stroke-width': '2',
        'fill': 'none',
        'fill-rule': 'evenodd'
      }
    }, [h('circle', {
      attrs: {
        'stroke-opacity': '.5',
        'cx': '18',
        'cy': '18',
        'r': '18'
      }
    }), h('path', {
      attrs: {
        'd': 'M36 18c0-9.94-8.06-18-18-18'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 18 18',
        'to': '360 18 18',
        'dur': '1s',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerPie.js


/* harmony default export */ var QSpinnerPie = (external_vue_default.a.extend({
  name: 'QSpinnerPie',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('path', {
      attrs: {
        'd': 'M0 50A50 50 0 0 1 50 0L50 50L0 50',
        'fill': 'currentColor',
        'opacity': '0.5'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '360 50 50',
        'dur': '0.8s',
        'repeatCount': 'indefinite'
      }
    })]), h('path', {
      attrs: {
        'd': 'M50 0A50 50 0 0 1 100 50L50 50L50 0',
        'fill': 'currentColor',
        'opacity': '0.5'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '360 50 50',
        'dur': '1.6s',
        'repeatCount': 'indefinite'
      }
    })]), h('path', {
      attrs: {
        'd': 'M100 50A50 50 0 0 1 50 100L50 50L100 50',
        'fill': 'currentColor',
        'opacity': '0.5'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '360 50 50',
        'dur': '2.4s',
        'repeatCount': 'indefinite'
      }
    })]), h('path', {
      attrs: {
        'd': 'M50 100A50 50 0 0 1 0 50L50 50L50 100',
        'fill': 'currentColor',
        'opacity': '0.5'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 50 50',
        'to': '360 50 50',
        'dur': '3.2s',
        'repeatCount': 'indefinite'
      }
    })])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerPuff.js


/* harmony default export */ var QSpinnerPuff = (external_vue_default.a.extend({
  name: 'QSpinnerPuff',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'stroke': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 44 44',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', {
      attrs: {
        'fill': 'none',
        'fill-rule': 'evenodd',
        'stroke-width': '2'
      }
    }, [h('circle', {
      attrs: {
        'cx': '22',
        'cy': '22',
        'r': '1'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'begin': '0s',
        'dur': '1.8s',
        'values': '1; 20',
        'calcMode': 'spline',
        'keyTimes': '0; 1',
        'keySplines': '0.165, 0.84, 0.44, 1',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'begin': '0s',
        'dur': '1.8s',
        'values': '1; 0',
        'calcMode': 'spline',
        'keyTimes': '0; 1',
        'keySplines': '0.3, 0.61, 0.355, 1',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '22',
        'cy': '22',
        'r': '1'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'begin': '-0.9s',
        'dur': '1.8s',
        'values': '1; 20',
        'calcMode': 'spline',
        'keyTimes': '0; 1',
        'keySplines': '0.165, 0.84, 0.44, 1',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'begin': '-0.9s',
        'dur': '1.8s',
        'values': '1; 0',
        'calcMode': 'spline',
        'keyTimes': '0; 1',
        'keySplines': '0.3, 0.61, 0.355, 1',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerRadio.js


/* harmony default export */ var QSpinnerRadio = (external_vue_default.a.extend({
  name: 'QSpinnerRadio',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 100 100',
        'preserveAspectRatio': 'xMidYMid',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', {
      attrs: {
        'transform': 'scale(0.55)'
      }
    }, [h('circle', {
      attrs: {
        'cx': '30',
        'cy': '150',
        'r': '30',
        'fill': 'currentColor'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'opacity',
        'from': '0',
        'to': '1',
        'dur': '1s',
        'begin': '0',
        'repeatCount': 'indefinite',
        'keyTimes': '0;0.5;1',
        'values': '0;1;1'
      }
    })]), h('path', {
      attrs: {
        'd': 'M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z',
        'fill': 'currentColor'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'opacity',
        'from': '0',
        'to': '1',
        'dur': '1s',
        'begin': '0.1',
        'repeatCount': 'indefinite',
        'keyTimes': '0;0.5;1',
        'values': '0;1;1'
      }
    })]), h('path', {
      attrs: {
        'd': 'M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z',
        'fill': 'currentColor'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'opacity',
        'from': '0',
        'to': '1',
        'dur': '1s',
        'begin': '0.2',
        'repeatCount': 'indefinite',
        'keyTimes': '0;0.5;1',
        'values': '0;1;1'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerRings.js


/* harmony default export */ var QSpinnerRings = (external_vue_default.a.extend({
  name: 'QSpinnerRings',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'stroke': 'currentColor',
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 45 45',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('g', {
      attrs: {
        'fill': 'none',
        'fill-rule': 'evenodd',
        'transform': 'translate(1 1)',
        'stroke-width': '2'
      }
    }, [h('circle', {
      attrs: {
        'cx': '22',
        'cy': '22',
        'r': '6'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'begin': '1.5s',
        'dur': '3s',
        'values': '6;22',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'begin': '1.5s',
        'dur': '3s',
        'values': '1;0',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'stroke-width',
        'begin': '1.5s',
        'dur': '3s',
        'values': '2;0',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '22',
        'cy': '22',
        'r': '6'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'begin': '3s',
        'dur': '3s',
        'values': '6;22',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'stroke-opacity',
        'begin': '3s',
        'dur': '3s',
        'values': '1;0',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    }), h('animate', {
      attrs: {
        'attributeName': 'stroke-width',
        'begin': '3s',
        'dur': '3s',
        'values': '2;0',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'cx': '22',
        'cy': '22',
        'r': '8'
      }
    }, [h('animate', {
      attrs: {
        'attributeName': 'r',
        'begin': '0s',
        'dur': '1.5s',
        'values': '6;1;2;3;4;5;6',
        'calcMode': 'linear',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/QSpinnerTail.js


/* harmony default export */ var QSpinnerTail = (external_vue_default.a.extend({
  name: 'QSpinnerTail',
  mixins: [spinner_mixin["a" /* default */]],
  render(h) {
    return h('svg', {
      staticClass: 'q-spinner',
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        focusable: 'false' /* needed for IE11 */,
        'width': this.cSize,
        'height': this.cSize,
        'viewBox': '0 0 38 38',
        'xmlns': 'http://www.w3.org/2000/svg'
      }
    }, [h('defs', [h('linearGradient', {
      attrs: {
        'x1': '8.042%',
        'y1': '0%',
        'x2': '65.682%',
        'y2': '23.865%',
        'id': 'a'
      }
    }, [h('stop', {
      attrs: {
        'stop-color': 'currentColor',
        'stop-opacity': '0',
        'offset': '0%'
      }
    }), h('stop', {
      attrs: {
        'stop-color': 'currentColor',
        'stop-opacity': '.631',
        'offset': '63.146%'
      }
    }), h('stop', {
      attrs: {
        'stop-color': 'currentColor',
        'offset': '100%'
      }
    })])]), h('g', {
      attrs: {
        'transform': 'translate(1 1)',
        'fill': 'none',
        'fill-rule': 'evenodd'
      }
    }, [h('path', {
      attrs: {
        'd': 'M36 18c0-9.94-8.06-18-18-18',
        'stroke': 'url(#a)',
        'stroke-width': '2'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 18 18',
        'to': '360 18 18',
        'dur': '0.9s',
        'repeatCount': 'indefinite'
      }
    })]), h('circle', {
      attrs: {
        'fill': 'currentColor',
        'cx': '36',
        'cy': '18',
        'r': '1'
      }
    }, [h('animateTransform', {
      attrs: {
        'attributeName': 'transform',
        'type': 'rotate',
        'from': '0 18 18',
        'to': '360 18 18',
        'dur': '0.9s',
        'repeatCount': 'indefinite'
      }
    })])])]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/spinner/index.js
























// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/splitter/QSplitter.js







/* harmony default export */ var QSplitter = (external_vue_default.a.extend({
  name: 'QSplitter',
  mixins: [dark["a" /* default */], listeners["a" /* default */]],
  directives: {
    TouchPan: TouchPan["a" /* default */]
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    reverse: Boolean,
    unit: {
      type: String,
      default: '%',
      validator: v => ['%', 'px'].includes(v)
    },
    limits: {
      type: Array,
      validator: v => {
        if (v.length !== 2) return false;
        if (typeof v[0] !== 'number' || typeof v[1] !== 'number') return false;
        return v[0] >= 0 && v[0] <= v[1];
      }
    },
    emitImmediately: Boolean,
    horizontal: Boolean,
    disable: Boolean,
    beforeClass: [Array, String, Object],
    afterClass: [Array, String, Object],
    separatorClass: [Array, String, Object],
    separatorStyle: [Array, String, Object]
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.__normalize(v, this.computedLimits);
      }
    },
    limits: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.__normalize(this.value, this.computedLimits);
        });
      }
    }
  },
  computed: {
    classes() {
      return (this.horizontal === true ? 'column' : 'row') + ` q-splitter--${this.horizontal === true ? 'horizontal' : 'vertical'}` + ` q-splitter--${this.disable === true ? 'disabled' : 'workable'}` + (this.isDark === true ? ' q-splitter--dark' : '');
    },
    prop() {
      return this.horizontal === true ? 'height' : 'width';
    },
    side() {
      return this.reverse !== true ? 'before' : 'after';
    },
    computedLimits() {
      return this.limits !== void 0 ? this.limits : this.unit === '%' ? [10, 90] : [50, Infinity];
    },
    styles() {
      return {
        [this.side]: {
          [this.prop]: this.__getCSSValue(this.value)
        }
      };
    },
    separatorDirectives() {
      if (this.disable !== true) {
        return [{
          name: 'touch-pan',
          value: this.__pan,
          modifiers: {
            [this.horizontal === true ? 'vertical' : 'horizontal']: true,
            prevent: true,
            stop: true,
            mouse: true,
            mouseAllDir: true
          }
        }];
      }
    }
  },
  methods: {
    __pan(evt) {
      if (evt.isFirst === true) {
        const size = this.$el.getBoundingClientRect()[this.prop];
        this.__dir = this.horizontal === true ? 'up' : 'left';
        this.__maxValue = this.unit === '%' ? 100 : size;
        this.__value = Math.min(this.__maxValue, this.computedLimits[1], Math.max(this.computedLimits[0], this.value));
        this.__multiplier = (this.reverse !== true ? 1 : -1) * (this.horizontal === true ? 1 : this.$q.lang.rtl === true ? -1 : 1) * (this.unit === '%' ? size === 0 ? 0 : 100 / size : 1);
        this.$el.classList.add('q-splitter--active');
        return;
      }
      if (evt.isFinal === true) {
        if (this.__normalized !== this.value) {
          this.$emit('input', this.__normalized);
        }
        this.$el.classList.remove('q-splitter--active');
        return;
      }
      const val = this.__value + this.__multiplier * (evt.direction === this.__dir ? -1 : 1) * evt.distance[this.horizontal === true ? 'y' : 'x'];
      this.__normalized = Math.min(this.__maxValue, this.computedLimits[1], Math.max(this.computedLimits[0], val));
      this.$refs[this.side].style[this.prop] = this.__getCSSValue(this.__normalized);
      if (this.emitImmediately === true && this.value !== this.__normalized) {
        this.$emit('input', this.__normalized);
      }
    },
    __normalize(val, limits) {
      if (val < limits[0]) {
        this.$emit('input', limits[0]);
      } else if (val > limits[1]) {
        this.$emit('input', limits[1]);
      }
    },
    __getCSSValue(value) {
      return (this.unit === '%' ? value : Math.round(value)) + this.unit;
    }
  },
  render(h) {
    const attrs = this.disable === true ? {
      'aria-disabled': 'true'
    } : void 0;
    const child = [h('div', {
      ref: 'before',
      staticClass: 'q-splitter__panel q-splitter__before' + (this.reverse === true ? ' col' : ''),
      style: this.styles.before,
      class: this.beforeClass,
      on: Object(cache["b" /* default */])(this, 'stop', {
        input: utils_event["k" /* stop */]
      })
    }, Object(private_slot["c" /* slot */])(this, 'before')), h('div', {
      staticClass: 'q-splitter__separator',
      style: this.separatorStyle,
      class: this.separatorClass,
      attrs
    }, [h('div', {
      staticClass: 'absolute-full q-splitter__separator-area',
      directives: this.separatorDirectives
    }, Object(private_slot["c" /* slot */])(this, 'separator'))]), h('div', {
      ref: 'after',
      staticClass: 'q-splitter__panel q-splitter__after' + (this.reverse === true ? '' : ' col'),
      style: this.styles.after,
      class: this.afterClass,
      on: Object(cache["b" /* default */])(this, 'stop', {
        input: utils_event["k" /* stop */]
      })
    }, Object(private_slot["c" /* slot */])(this, 'after'))];
    return h('div', {
      staticClass: 'q-splitter no-wrap',
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["a" /* mergeSlot */])(child, this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/splitter/index.js


// EXTERNAL MODULE: /workspace/node_modules/quasar/src/directives/Ripple.js
var Ripple = __webpack_require__("1f73");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/stepper/StepHeader.js





/* harmony default export */ var StepHeader = (external_vue_default.a.extend({
  name: 'StepHeader',
  mixins: [mixins_attrs["b" /* default */]],
  directives: {
    Ripple: Ripple["a" /* default */]
  },
  props: {
    stepper: {},
    step: {}
  },
  computed: {
    isActive() {
      return this.stepper.value === this.step.name;
    },
    isDisable() {
      const opt = this.step.disable;
      return opt === true || opt === '';
    },
    isError() {
      const opt = this.step.error;
      return opt === true || opt === '';
    },
    isDone() {
      const opt = this.step.done;
      return this.isDisable === false && (opt === true || opt === '');
    },
    headerNav() {
      const opt = this.step.headerNav,
        nav = opt === true || opt === '' || opt === void 0;
      return this.isDisable === false && this.stepper.headerNav && nav;
    },
    hasPrefix() {
      return this.step.prefix && (this.isActive === false || this.stepper.activeIcon === 'none') && (this.isError === false || this.stepper.errorIcon === 'none') && (this.isDone === false || this.stepper.doneIcon === 'none');
    },
    icon() {
      const defaultIcon = this.step.icon || this.stepper.inactiveIcon;
      if (this.isActive === true) {
        const icon = this.step.activeIcon || this.stepper.activeIcon;
        return icon === 'none' ? defaultIcon : icon || this.$q.iconSet.stepper.active;
      }
      if (this.isError === true) {
        const icon = this.step.errorIcon || this.stepper.errorIcon;
        return icon === 'none' ? defaultIcon : icon || this.$q.iconSet.stepper.error;
      }
      if (this.isDisable === false && this.isDone === true) {
        const icon = this.step.doneIcon || this.stepper.doneIcon;
        return icon === 'none' ? defaultIcon : icon || this.$q.iconSet.stepper.done;
      }
      return defaultIcon;
    },
    color() {
      const errorColor = this.isError === true ? this.step.errorColor || this.stepper.errorColor : void 0;
      if (this.isActive === true) {
        const color = this.step.activeColor || this.stepper.activeColor || this.step.color;
        return color !== void 0 ? color : errorColor;
      }
      if (errorColor !== void 0) {
        return errorColor;
      }
      if (this.isDisable === false && this.isDone === true) {
        return this.step.doneColor || this.stepper.doneColor || this.step.color || this.stepper.inactiveColor;
      }
      return this.step.color || this.stepper.inactiveColor;
    },
    classes() {
      return 'q-stepper__tab col-grow flex items-center no-wrap relative-position' + (this.color !== void 0 ? ` text-${this.color}` : '') + (this.isError === true ? ' q-stepper__tab--error q-stepper__tab--error-with-' + (this.hasPrefix === true ? 'prefix' : 'icon') : '') + (this.isActive === true ? ' q-stepper__tab--active' : '') + (this.isDone === true ? ' q-stepper__tab--done' : '') + (this.headerNav === true ? ' q-stepper__tab--navigation q-focusable q-hoverable' : '') + (this.isDisable === true ? ' q-stepper__tab--disabled' : '');
    }
  },
  methods: {
    activate() {
      this.$refs.blurTarget !== void 0 && this.$refs.blurTarget.focus();
      this.isActive === false && this.stepper.goTo(this.step.name);
    },
    keyup(e) {
      if (e.keyCode === 13 && this.isActive === false) {
        this.stepper.goTo(this.step.name);
      }
    }
  },
  render(h) {
    const data = {
      class: this.classes
    };
    if (this.stepper.headerNav === true) {
      data.directives = [{
        name: 'ripple',
        value: this.headerNav
      }];
    }
    this.headerNav === true && Object.assign(data, {
      on: Object(cache["b" /* default */])(this, 'headnavon', {
        click: this.activate,
        keyup: this.keyup
      }),
      attrs: this.isDisable === true ? {
        tabindex: -1,
        'aria-disabled': 'true'
      } : {
        tabindex: this.qAttrs.tabindex || 0
      }
    });
    const child = [h('div', {
      staticClass: 'q-focus-helper',
      attrs: {
        tabindex: -1
      },
      ref: 'blurTarget'
    }), h('div', {
      staticClass: 'q-stepper__dot row flex-center q-stepper__line relative-position'
    }, [h('span', {
      staticClass: 'row flex-center'
    }, [this.hasPrefix === true ? this.step.prefix : h(QIcon["a" /* default */], {
      props: {
        name: this.icon
      }
    })])])];
    if (this.step.title !== void 0 && this.step.title !== null) {
      const content = [h('div', {
        staticClass: 'q-stepper__title'
      }, [this.step.title])];
      if (this.step.caption !== void 0 && this.step.caption !== null) {
        content.push(h('div', {
          staticClass: 'q-stepper__caption'
        }, [this.step.caption]));
      }
      child.push(h('div', {
        staticClass: 'q-stepper__label q-stepper__line relative-position'
      }, content));
    }
    return h('div', data, child);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/stepper/QStep.js





const QStep_attrs = {
  role: 'tabpanel'
};
const StepWrapper = external_vue_default.a.extend({
  name: 'QStepWrapper',
  render(h) {
    return h('div', {
      staticClass: 'q-stepper__step-content'
    }, [h('div', {
      staticClass: 'q-stepper__step-inner'
    }, Object(private_slot["c" /* slot */])(this, 'default'))]);
  }
});
/* harmony default export */ var QStep = (external_vue_default.a.extend({
  name: 'QStep',
  inject: {
    stepper: {
      default() {
        console.error('QStep needs to be child of QStepper');
      }
    }
  },
  mixins: [PanelChildMixin],
  props: {
    icon: String,
    color: String,
    title: {
      type: String,
      required: true
    },
    caption: String,
    prefix: [String, Number],
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String,
    headerNav: {
      type: Boolean,
      default: true
    },
    done: Boolean,
    error: Boolean
  },
  computed: {
    isActive() {
      return this.stepper.value === this.name;
    },
    onEvents() {
      return this.isActive !== true || this.stepper.vertical !== true || this.$q.platform.is.ios !== true && this.$q.platform.is.chrome === true ? {
        ...this.qListeners
      } : {
        ...this.qListeners,
        scroll: this.__keepScroll
      };
    }
  },
  methods: {
    __keepScroll(ev) {
      const {
        target
      } = ev;
      if (target.scrollTop > 0) {
        target.scrollTop = 0;
      }
      this.qListeners.scroll !== void 0 && this.$emit('scroll', ev);
    }
  },
  render(h) {
    const vertical = this.stepper.vertical;
    const content = vertical === true && this.stepper.keepAlive === true ? h('keep-alive', this.isActive === true ? [h(StepWrapper, {
      key: this.name
    }, Object(private_slot["c" /* slot */])(this, 'default'))] : void 0) : vertical !== true || this.isActive === true ? StepWrapper.options.render.call(this, h) : void 0;
    return h('div', {
      staticClass: 'q-stepper__step',
      attrs: QStep_attrs,
      on: this.onEvents
    }, vertical === true ? [h(StepHeader, {
      props: {
        stepper: this.stepper,
        step: this
      }
    }), this.stepper.animated === true ? h(QSlideTransition, [content]) : content] : [content]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/stepper/QStepper.js







/* harmony default export */ var QStepper = (external_vue_default.a.extend({
  name: 'QStepper',
  provide() {
    return {
      stepper: this
    };
  },
  mixins: [dark["a" /* default */], PanelParentMixin],
  props: {
    flat: Boolean,
    bordered: Boolean,
    alternativeLabels: Boolean,
    headerNav: Boolean,
    contracted: Boolean,
    headerClass: String,
    inactiveColor: String,
    inactiveIcon: String,
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String
  },
  computed: {
    classes() {
      return `q-stepper q-stepper--${this.vertical === true ? 'vertical' : 'horizontal'}` + (this.flat === true || this.isDark === true ? ' q-stepper--flat no-shadow' : '') + (this.bordered === true || this.isDark === true && this.flat === false ? ' q-stepper--bordered' : '') + (this.isDark === true ? ' q-stepper--dark q-dark' : '');
    },
    headerClasses() {
      return 'q-stepper__header row items-stretch justify-between' + ` q-stepper__header--${this.alternativeLabels === true ? 'alternative' : 'standard'}-labels` + (this.flat === false || this.bordered === true ? ' q-stepper__header--border' : '') + (this.contracted === true ? ' q-stepper__header--contracted' : '') + (this.headerClass !== void 0 ? ` ${this.headerClass}` : '');
    }
  },
  methods: {
    __getContent(h) {
      const top = Object(private_slot["c" /* slot */])(this, 'message', []);
      if (this.vertical === true) {
        this.__isValidPanelName(this.value) && this.__updatePanelIndex();
        const content = h('div', {
          staticClass: 'q-stepper__content',
          // stop propagation of content emitted @input
          // which would tamper with Panel's model
          on: Object(cache["b" /* default */])(this, 'stop', {
            input: utils_event["k" /* stop */]
          })
        }, Object(private_slot["c" /* slot */])(this, 'default'));
        return top === void 0 ? [content] : top.concat(content);
      }
      return [h('div', {
        class: this.headerClasses
      }, this.panels.map(panel => {
        const step = panel.componentOptions.propsData;
        return h(StepHeader, {
          key: step.name,
          props: {
            stepper: this,
            step
          }
        });
      }))].concat(top, h('div', {
        staticClass: 'q-stepper__content q-panel-parent',
        directives: this.panelDirectives
      }, this.__getPanelContent(h)));
    },
    __renderPanels(h) {
      return h('div', {
        class: this.classes,
        on: {
          ...this.qListeners
        }
      }, Object(private_slot["a" /* mergeSlot */])(this.__getContent(h), this, 'navigation'));
    }
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/stepper/QStepperNavigation.js



/* harmony default export */ var QStepperNavigation = (external_vue_default.a.extend({
  name: 'QStepperNavigation',
  mixins: [listeners["a" /* default */]],
  render(h) {
    return h('div', {
      staticClass: 'q-stepper__nav',
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/stepper/index.js




// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tab-panels/index.js



// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-top.js
/* harmony default export */ var table_top = ({
  computed: {
    marginalsScope() {
      return {
        pagination: this.computedPagination,
        pagesNumber: this.pagesNumber,
        isFirstPage: this.isFirstPage,
        isLastPage: this.isLastPage,
        firstPage: this.firstPage,
        prevPage: this.prevPage,
        nextPage: this.nextPage,
        lastPage: this.lastPage,
        inFullscreen: this.inFullscreen,
        toggleFullscreen: this.toggleFullscreen
      };
    }
  },
  methods: {
    __getTopDiv(h) {
      const top = this.$scopedSlots.top,
        topLeft = this.$scopedSlots['top-left'],
        topRight = this.$scopedSlots['top-right'],
        topSelection = this.$scopedSlots['top-selection'],
        hasSelection = this.hasSelectionMode === true && topSelection !== void 0 && this.rowsSelectedNumber > 0,
        staticClass = 'q-table__top relative-position row items-center';
      if (top !== void 0) {
        return h('div', {
          staticClass
        }, [top(this.marginalsScope)]);
      }
      let child;
      if (hasSelection === true) {
        child = topSelection(this.marginalsScope).slice();
      } else {
        child = [];
        if (topLeft !== void 0) {
          child.push(h('div', {
            staticClass: 'q-table__control'
          }, [topLeft(this.marginalsScope)]));
        } else if (this.title) {
          child.push(h('div', {
            staticClass: 'q-table__control'
          }, [h('div', {
            staticClass: 'q-table__title',
            class: this.titleClass
          }, this.title)]));
        }
      }
      if (topRight !== void 0) {
        child.push(h('div', {
          staticClass: 'q-table__separator col'
        }));
        child.push(h('div', {
          staticClass: 'q-table__control'
        }, [topRight(this.marginalsScope)]));
      }
      if (child.length === 0) {
        return;
      }
      return h('div', {
        staticClass
      }, child);
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/QTh.js




/* harmony default export */ var QTh = (external_vue_default.a.extend({
  name: 'QTh',
  mixins: [listeners["a" /* default */]],
  props: {
    props: Object,
    autoWidth: Boolean
  },
  render(h) {
    const on = {
      ...this.qListeners
    };
    if (this.props === void 0) {
      return h('th', {
        on,
        class: this.autoWidth === true ? 'q-table--col-auto-width' : null
      }, Object(private_slot["c" /* slot */])(this, 'default'));
    }
    let col, child;
    const name = this.$vnode.key;
    if (name) {
      col = this.props.colsMap[name];
      if (col === void 0) {
        return;
      }
    } else {
      col = this.props.col;
    }
    if (col.sortable === true) {
      const action = col.align === 'right' ? 'unshift' : 'push';
      child = Object(private_slot["d" /* uniqueSlot */])(this, 'default', []);
      child[action](h(QIcon["a" /* default */], {
        props: {
          name: this.$q.iconSet.table.arrowUp
        },
        staticClass: col.__iconClass
      }));
    } else {
      child = Object(private_slot["c" /* slot */])(this, 'default');
    }
    const evt = col.sortable === true ? {
      click: evt => {
        this.props.sort(col);
        this.$emit('click', evt);
      }
    } : {};
    return h('th', {
      on: {
        ...on,
        ...evt
      },
      style: col.headerStyle,
      class: col.__thClass + (this.autoWidth === true ? ' q-table--col-auto-width' : '')
    }, child);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-header.js




/* harmony default export */ var table_header = ({
  computed: {
    headerSelectedValue() {
      return this.someRowsSelected === true ? null : this.allRowsSelected;
    }
  },
  methods: {
    __getTHead(h) {
      const child = this.__getTHeadTR(h);
      if (this.loading === true && this.$scopedSlots.loading === void 0) {
        child.push(h('tr', {
          staticClass: 'q-table__progress'
        }, [h('th', {
          staticClass: 'relative-position',
          attrs: {
            colspan: this.computedColspan
          }
        }, this.__getProgress(h))]));
      }
      return h('thead', child);
    },
    __getTHeadTR(h) {
      const header = this.$scopedSlots.header,
        headerCell = this.$scopedSlots['header-cell'];
      if (header !== void 0) {
        return header(this.__getHeaderScope({
          header: true
        })).slice();
      }
      const child = this.computedCols.map(col => {
        const headerCellCol = this.$scopedSlots[`header-cell-${col.name}`],
          slot = headerCellCol !== void 0 ? headerCellCol : headerCell,
          props = this.__getHeaderScope({
            col
          });
        return slot !== void 0 ? slot(props) : h(QTh, {
          key: col.name,
          props: {
            props
          }
        }, col.label);
      });
      if (this.singleSelection === true && this.grid !== true) {
        child.unshift(h('th', {
          staticClass: 'q-table--col-auto-width'
        }, [' ']));
      } else if (this.multipleSelection === true) {
        const slot = this.$scopedSlots['header-selection'];
        const content = slot !== void 0 ? slot(this.__getHeaderScope({})) : [h(QCheckbox["a" /* default */], {
          props: {
            color: this.color,
            value: this.headerSelectedValue,
            dark: this.isDark,
            dense: this.dense
          },
          on: Object(cache["b" /* default */])(this, 'inp', {
            input: this.__onMultipleSelectionSet
          })
        })];
        child.unshift(h('th', {
          staticClass: 'q-table--col-auto-width'
        }, content));
      }
      return [h('tr', {
        style: this.tableHeaderStyle,
        class: this.tableHeaderClass
      }, child)];
    },
    __getHeaderScope(data) {
      Object.assign(data, {
        cols: this.computedCols,
        sort: this.sort,
        colsMap: this.computedColsMap,
        color: this.color,
        dark: this.isDark,
        dense: this.dense
      });
      if (this.multipleSelection === true) {
        injectProp(data, 'selected', () => this.headerSelectedValue, this.__onMultipleSelectionSet);
        data.partialSelected = this.someRowsSelected;
        data.multipleSelect = true;
      }
      return data;
    },
    __onMultipleSelectionSet(val) {
      if (this.someRowsSelected === true) {
        val = false;
      }
      this.__updateSelection(this.computedRows.map(this.getRowKey), this.computedRows, val);
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-body.js


/* harmony default export */ var table_body = ({
  methods: {
    __getTBodyTR(h, row, bodySlot, pageIndex) {
      const key = this.getRowKey(row),
        selected = this.isRowSelected(key);
      if (bodySlot !== void 0) {
        return bodySlot(this.__getBodyScope({
          key,
          row,
          pageIndex,
          __trClass: selected ? 'selected' : ''
        }));
      }
      const bodyCell = this.$scopedSlots['body-cell'],
        child = this.computedCols.map(col => {
          const bodyCellCol = this.$scopedSlots[`body-cell-${col.name}`],
            slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell;
          return slot !== void 0 ? slot(this.__getBodyCellScope({
            key,
            row,
            pageIndex,
            col
          })) : h('td', {
            class: col.__tdClass(row),
            style: col.__tdStyle(row)
          }, this.getCellValue(col, row));
        });
      if (this.hasSelectionMode === true) {
        const slot = this.$scopedSlots['body-selection'];
        const content = slot !== void 0 ? slot(this.__getBodySelectionScope({
          key,
          row,
          pageIndex
        })) : [h(QCheckbox["a" /* default */], {
          props: {
            value: selected,
            color: this.color,
            dark: this.isDark,
            dense: this.dense
          },
          on: {
            input: (adding, evt) => {
              this.__updateSelection([key], [row], adding, evt);
            }
          }
        })];
        child.unshift(h('td', {
          staticClass: 'q-table--col-auto-width'
        }, content));
      }
      const data = {
        key,
        class: {
          selected
        },
        on: {}
      };
      if (this.qListeners['row-click'] !== void 0) {
        data.class['cursor-pointer'] = true;
        data.on.click = evt => {
          this.$emit('row-click', evt, row, pageIndex);
        };
      }
      if (this.qListeners['row-dblclick'] !== void 0) {
        data.class['cursor-pointer'] = true;
        data.on.dblclick = evt => {
          this.$emit('row-dblclick', evt, row, pageIndex);
        };
      }
      if (this.qListeners['row-contextmenu'] !== void 0) {
        data.class['cursor-pointer'] = true;
        data.on.contextmenu = evt => {
          this.$emit('row-contextmenu', evt, row, pageIndex);
        };
      }
      return h('tr', data, child);
    },
    __getTBody(h) {
      const body = this.$scopedSlots.body,
        topRow = this.$scopedSlots['top-row'],
        bottomRow = this.$scopedSlots['bottom-row'];
      let child = this.computedRows.map((row, pageIndex) => this.__getTBodyTR(h, row, body, pageIndex));
      if (topRow !== void 0) {
        child = topRow({
          cols: this.computedCols
        }).concat(child);
      }
      if (bottomRow !== void 0) {
        child = child.concat(bottomRow({
          cols: this.computedCols
        }));
      }
      return h('tbody', child);
    },
    __getVirtualTBodyTR(h) {
      const body = this.$scopedSlots.body;
      return props => this.__getTBodyTR(h, props.item, body, props.index);
    },
    __getBodyScope(data) {
      this.__injectBodyCommonScope(data);
      data.cols = data.cols.map(col => injectProp({
        ...col
      }, 'value', () => this.getCellValue(col, data.row)));
      return data;
    },
    __getBodyCellScope(data) {
      this.__injectBodyCommonScope(data);
      return injectProp(data, 'value', () => this.getCellValue(data.col, data.row));
    },
    __getBodySelectionScope(data) {
      this.__injectBodyCommonScope(data);
      return data;
    },
    __injectBodyCommonScope(data) {
      Object.assign(data, {
        cols: this.computedCols,
        colsMap: this.computedColsMap,
        sort: this.sort,
        rowIndex: this.firstRowIndex + data.pageIndex,
        color: this.color,
        dark: this.isDark,
        dense: this.dense
      });
      this.hasSelectionMode === true && injectProp(data, 'selected', () => this.isRowSelected(data.key), (adding, evt) => {
        this.__updateSelection([data.key], [data.row], adding, evt);
      });
      injectProp(data, 'expand', () => this.isRowExpanded(data.key), adding => {
        this.__updateExpanded(data.key, adding);
      });
    },
    getCellValue(col, row) {
      const val = typeof col.field === 'function' ? col.field(row) : row[col.field];
      return col.format !== void 0 ? col.format(val, row) : val;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-bottom.js




const table_bottom_staticClass = 'q-table__bottom row items-center';
/* harmony default export */ var table_bottom = ({
  props: {
    hideBottom: Boolean,
    hideSelectedBanner: Boolean,
    hideNoData: Boolean,
    hidePagination: Boolean
  },
  computed: {
    navIcon() {
      const ico = [this.iconFirstPage || this.$q.iconSet.table.firstPage, this.iconPrevPage || this.$q.iconSet.table.prevPage, this.iconNextPage || this.$q.iconSet.table.nextPage, this.iconLastPage || this.$q.iconSet.table.lastPage];
      return this.$q.lang.rtl === true ? ico.reverse() : ico;
    }
  },
  methods: {
    __getBottomDiv(h) {
      if (this.hideBottom === true) {
        return;
      }
      if (this.nothingToDisplay === true) {
        if (this.hideNoData === true) {
          return;
        }
        const message = this.loading === true ? this.loadingLabel || this.$q.lang.table.loading : this.filter ? this.noResultsLabel || this.$q.lang.table.noResults : this.noDataLabel || this.$q.lang.table.noData;
        const noData = this.$scopedSlots['no-data'];
        const children = noData !== void 0 ? [noData({
          message,
          icon: this.$q.iconSet.table.warning,
          filter: this.filter
        })] : [h(QIcon["a" /* default */], {
          staticClass: 'q-table__bottom-nodata-icon',
          props: {
            name: this.$q.iconSet.table.warning
          }
        }), message];
        return h('div', {
          staticClass: table_bottom_staticClass + ' q-table__bottom--nodata'
        }, children);
      }
      const bottom = this.$scopedSlots.bottom;
      if (bottom !== void 0) {
        return h('div', {
          staticClass: table_bottom_staticClass
        }, [bottom(this.marginalsScope)]);
      }
      const child = this.hideSelectedBanner !== true && this.hasSelectionMode === true && this.rowsSelectedNumber > 0 ? [h('div', {
        staticClass: 'q-table__control'
      }, [h('div', [(this.selectedRowsLabel || this.$q.lang.table.selectedRecords)(this.rowsSelectedNumber)])])] : [];
      if (this.hidePagination !== true) {
        return h('div', {
          staticClass: table_bottom_staticClass + ' justify-end'
        }, this.__getPaginationDiv(h, child));
      }
      if (child.length > 0) {
        return h('div', {
          staticClass: table_bottom_staticClass
        }, child);
      }
    },
    __getPaginationDiv(h, child) {
      let control;
      const {
          rowsPerPage
        } = this.computedPagination,
        paginationLabel = this.paginationLabel || this.$q.lang.table.pagination,
        paginationSlot = this.$scopedSlots.pagination,
        hasOpts = this.rowsPerPageOptions.length > 1;
      child.push(h('div', {
        staticClass: 'q-table__separator col'
      }));
      if (hasOpts === true) {
        child.push(h('div', {
          staticClass: 'q-table__control'
        }, [h('span', {
          staticClass: 'q-table__bottom-item'
        }, [this.rowsPerPageLabel || this.$q.lang.table.recordsPerPage]), h(QSelect["a" /* default */], {
          staticClass: 'q-table__select inline q-table__bottom-item',
          props: {
            color: this.color,
            value: rowsPerPage,
            options: this.computedRowsPerPageOptions,
            displayValue: rowsPerPage === 0 ? this.$q.lang.table.allRows : rowsPerPage,
            dark: this.isDark,
            borderless: true,
            dense: true,
            optionsDense: true,
            optionsCover: true
          },
          on: Object(cache["b" /* default */])(this, 'pgSize', {
            input: pag => {
              this.setPagination({
                page: 1,
                rowsPerPage: pag.value
              });
            }
          })
        })]));
      }
      if (paginationSlot !== void 0) {
        control = paginationSlot(this.marginalsScope);
      } else {
        control = [h('span', rowsPerPage !== 0 ? {
          staticClass: 'q-table__bottom-item'
        } : {}, [rowsPerPage ? paginationLabel(this.firstRowIndex + 1, Math.min(this.lastRowIndex, this.computedRowsNumber), this.computedRowsNumber) : paginationLabel(1, this.filteredSortedRowsNumber, this.computedRowsNumber)])];
        if (rowsPerPage !== 0 && this.pagesNumber > 1) {
          const btnProps = {
            color: this.color,
            round: true,
            dense: true,
            flat: true
          };
          if (this.dense === true) {
            btnProps.size = 'sm';
          }
          this.pagesNumber > 2 && control.push(h(QBtn["a" /* default */], {
            key: 'pgFirst',
            props: {
              ...btnProps,
              icon: this.navIcon[0],
              disable: this.isFirstPage
            },
            on: Object(cache["b" /* default */])(this, 'pgFirst', {
              click: this.firstPage
            })
          }));
          control.push(h(QBtn["a" /* default */], {
            key: 'pgPrev',
            props: {
              ...btnProps,
              icon: this.navIcon[1],
              disable: this.isFirstPage
            },
            on: Object(cache["b" /* default */])(this, 'pgPrev', {
              click: this.prevPage
            })
          }), h(QBtn["a" /* default */], {
            key: 'pgNext',
            props: {
              ...btnProps,
              icon: this.navIcon[2],
              disable: this.isLastPage
            },
            on: Object(cache["b" /* default */])(this, 'pgNext', {
              click: this.nextPage
            })
          }));
          this.pagesNumber > 2 && control.push(h(QBtn["a" /* default */], {
            key: 'pgLast',
            props: {
              ...btnProps,
              icon: this.navIcon[3],
              disable: this.isLastPage
            },
            on: Object(cache["b" /* default */])(this, 'pgLast', {
              click: this.lastPage
            })
          }));
        }
      }
      child.push(h('div', {
        staticClass: 'q-table__control'
      }, control));
      return child;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-grid.js


/* harmony default export */ var table_grid = ({
  methods: {
    __getGridHeader(h) {
      const child = this.gridHeader === true ? [h('table', {
        staticClass: 'q-table'
      }, [this.__getTHead(h)])] : this.loading === true && this.$scopedSlots.loading === void 0 ? this.__getProgress(h) : void 0;
      return h('div', {
        staticClass: 'q-table__middle'
      }, child);
    },
    __getGridBody(h) {
      const item = this.$scopedSlots.item !== void 0 ? this.$scopedSlots.item : scope => {
        const child = scope.cols.map(col => h('div', {
          staticClass: 'q-table__grid-item-row'
        }, [h('div', {
          staticClass: 'q-table__grid-item-title'
        }, [col.label]), h('div', {
          staticClass: 'q-table__grid-item-value'
        }, [col.value])]));
        if (this.hasSelectionMode === true) {
          const slot = this.$scopedSlots['body-selection'];
          const content = slot !== void 0 ? slot(scope) : [h(QCheckbox["a" /* default */], {
            props: {
              value: scope.selected,
              color: this.color,
              dark: this.isDark,
              dense: this.dense
            },
            on: {
              input: (adding, evt) => {
                this.__updateSelection([scope.key], [scope.row], adding, evt);
              }
            }
          })];
          child.unshift(h('div', {
            staticClass: 'q-table__grid-item-row'
          }, content), h(QSeparator["a" /* default */], {
            props: {
              dark: this.isDark
            }
          }));
        }
        const data = {
          staticClass: 'q-table__grid-item-card' + this.cardDefaultClass,
          class: this.cardClass,
          style: this.cardStyle,
          on: {}
        };
        if (this.qListeners['row-click'] !== void 0 || this.qListeners['row-dblclick'] !== void 0) {
          data.staticClass += ' cursor-pointer';
        }
        if (this.qListeners['row-click'] !== void 0) {
          data.on.click = evt => {
            this.$emit('row-click', evt, scope.row, scope.pageIndex);
          };
        }
        if (this.qListeners['row-dblclick'] !== void 0) {
          data.on.dblclick = evt => {
            this.$emit('row-dblclick', evt, scope.row, scope.pageIndex);
          };
        }
        return h('div', {
          staticClass: 'q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3',
          class: scope.selected === true ? 'q-table__grid-item--selected' : ''
        }, [h('div', data, child)]);
      };
      return h('div', {
        staticClass: 'q-table__grid-content row',
        class: this.cardContainerClass,
        style: this.cardContainerStyle
      }, this.computedRows.map((row, pageIndex) => {
        return item(this.__getBodyScope({
          key: this.getRowKey(row),
          row,
          pageIndex
        }));
      }));
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/get-table-middle.js
/* harmony default export */ var get_table_middle = (function (h, conf, content) {
  return h('div', {
    ...conf,
    staticClass: 'q-table__middle' + (conf.staticClass !== void 0 ? ' ' + conf.staticClass : '')
  }, [h('table', {
    staticClass: 'q-table'
  }, content)]);
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/virtual-scroll.js
var virtual_scroll = __webpack_require__("8077");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/virtual-scroll/QVirtualScroll.js










const comps = {
  list: QList["a" /* default */],
  table: QMarkupTable
};
/* harmony default export */ var QVirtualScroll = (external_vue_default.a.extend({
  name: 'QVirtualScroll',
  mixins: [mixins_attrs["b" /* default */], listeners["a" /* default */], virtual_scroll["b" /* default */]],
  props: {
    type: {
      type: String,
      default: 'list',
      validator: v => ['list', 'table', '__qtable'].includes(v)
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsFn: Function,
    itemsSize: Number,
    scrollTarget: {
      default: void 0
    }
  },
  computed: {
    virtualScrollLength() {
      return this.itemsSize >= 0 && this.itemsFn !== void 0 ? parseInt(this.itemsSize, 10) : Array.isArray(this.items) ? this.items.length : 0;
    },
    virtualScrollScope() {
      if (this.virtualScrollLength === 0) {
        return [];
      }
      const mapFn = (item, i) => ({
        index: this.virtualScrollSliceRange.from + i,
        item
      });
      if (this.itemsFn === void 0) {
        return this.items.slice(this.virtualScrollSliceRange.from, this.virtualScrollSliceRange.to).map(mapFn);
      }
      return this.itemsFn(this.virtualScrollSliceRange.from, this.virtualScrollSliceRange.to - this.virtualScrollSliceRange.from).map(mapFn);
    },
    classes() {
      return 'q-virtual-scroll q-virtual-scroll' + (this.virtualScrollHorizontal === true ? '--horizontal' : '--vertical') + (this.scrollTarget !== void 0 ? '' : ' scroll');
    },
    attrs() {
      return this.scrollTarget !== void 0 ? void 0 : {
        tabindex: 0
      };
    }
  },
  watch: {
    virtualScrollLength() {
      this.__resetVirtualScroll();
    },
    scrollTarget() {
      this.__unconfigureScrollTarget();
      this.__configureScrollTarget();
    }
  },
  methods: {
    __getVirtualScrollEl() {
      return this.$el;
    },
    __getVirtualScrollTarget() {
      return this.__scrollTarget;
    },
    __configureScrollTarget() {
      this.__scrollTarget = Object(utils_scroll["d" /* getScrollTarget */])(this.$el, this.scrollTarget);
      this.__scrollTarget.addEventListener('scroll', this.__onVirtualScrollEvt, utils_event["f" /* listenOpts */].passive);
    },
    __unconfigureScrollTarget() {
      if (this.__scrollTarget !== void 0) {
        this.__scrollTarget.removeEventListener('scroll', this.__onVirtualScrollEvt, utils_event["f" /* listenOpts */].passive);
        this.__scrollTarget = void 0;
      }
    }
  },
  beforeMount() {
    this.__resetVirtualScroll();
  },
  mounted() {
    this.__configureScrollTarget();
  },
  activated() {
    this.__configureScrollTarget();
  },
  deactivated() {
    this.__unconfigureScrollTarget();
  },
  beforeDestroy() {
    this.__unconfigureScrollTarget();
  },
  render(h) {
    if (this.$scopedSlots.default === void 0) {
      console.error('QVirtualScroll: default scoped slot is required for rendering', this);
      return;
    }
    let child = this.__padVirtualScroll(h, this.type === 'list' ? 'div' : 'tbody', this.virtualScrollScope.map(this.$scopedSlots.default));
    if (this.$scopedSlots.before !== void 0) {
      child = this.$scopedSlots.before().concat(child);
    }
    child = Object(private_slot["a" /* mergeSlot */])(child, this, 'after');
    return this.type === '__qtable' ? get_table_middle(h, {
      staticClass: this.classes
    }, child) : h(comps[this.type], {
      class: this.classes,
      attrs: this.attrs,
      props: this.qAttrs,
      on: {
        ...this.qListeners
      }
    }, child);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/private/sort.js
function sortString(a, b) {
  if (typeof a !== 'string') {
    throw new TypeError('The value for sorting must be a String');
  }
  return a.localeCompare(b);
}
function sortNumber(a, b) {
  return a - b;
}
function sortDate(a, b) {
  return new Date(a) - new Date(b);
}
function sortBoolean(a, b) {
  return a && !b ? -1 : !a && b ? 1 : 0;
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-sort.js


/* harmony default export */ var table_sort = ({
  props: {
    sortMethod: {
      type: Function,
      default(data, sortBy, descending) {
        const col = this.colList.find(def => def.name === sortBy);
        if (col === void 0 || col.field === void 0) {
          return data;
        }
        const dir = descending === true ? -1 : 1,
          val = typeof col.field === 'function' ? v => col.field(v) : v => v[col.field];
        return data.sort((a, b) => {
          let A = val(a),
            B = val(b);
          if (A === null || A === void 0) {
            return -1 * dir;
          }
          if (B === null || B === void 0) {
            return 1 * dir;
          }
          if (col.sort !== void 0) {
            return col.sort(A, B, a, b) * dir;
          }
          if (Object(is["c" /* isNumber */])(A) === true && Object(is["c" /* isNumber */])(B) === true) {
            return (A - B) * dir;
          }
          if (Object(is["a" /* isDate */])(A) === true && Object(is["a" /* isDate */])(B) === true) {
            return sortDate(A, B) * dir;
          }
          if (typeof A === 'boolean' && typeof B === 'boolean') {
            return (A - B) * dir;
          }
          [A, B] = [A, B].map(s => (s + '').toLocaleString().toLowerCase());
          return A < B ? -1 * dir : A === B ? 0 : dir;
        });
      }
    },
    columnSortOrder: {
      type: String,
      validator: v => v === 'ad' || v === 'da',
      default: 'ad'
    }
  },
  computed: {
    columnToSort() {
      const {
        sortBy
      } = this.computedPagination;
      if (sortBy) {
        return this.colList.find(def => def.name === sortBy) || null;
      }
    }
  },
  methods: {
    sort(col /* String(col name) or Object(col definition) */) {
      let sortOrder = this.columnSortOrder;
      if (Object(is["d" /* isObject */])(col) === true) {
        if (col.sortOrder) {
          sortOrder = col.sortOrder;
        }
        col = col.name;
      } else {
        const def = this.colList.find(def => def.name === col);
        if (def !== void 0 && def.sortOrder) {
          sortOrder = def.sortOrder;
        }
      }
      let {
        sortBy,
        descending
      } = this.computedPagination;
      if (sortBy !== col) {
        sortBy = col;
        descending = sortOrder === 'da';
      } else if (this.binaryStateSort === true) {
        descending = !descending;
      } else if (descending === true) {
        if (sortOrder === 'ad') {
          sortBy = null;
        } else {
          descending = false;
        }
      } else {
        // ascending
        if (sortOrder === 'ad') {
          descending = true;
        } else {
          sortBy = null;
        }
      }
      this.setPagination({
        sortBy,
        descending,
        page: 1
      });
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-filter.js
/* harmony default export */ var table_filter = ({
  props: {
    filter: [String, Object],
    filterMethod: {
      type: Function,
      default(rows, terms, cols = this.computedCols, cellValue = this.getCellValue) {
        const lowerTerms = terms ? terms.toLowerCase() : '';
        return rows.filter(row => cols.some(col => {
          const val = cellValue(col, row) + '';
          const haystack = val === 'undefined' || val === 'null' ? '' : val.toLowerCase();
          return haystack.indexOf(lowerTerms) !== -1;
        }));
      }
    }
  },
  watch: {
    filter: {
      handler() {
        this.$nextTick(() => {
          this.setPagination({
            page: 1
          }, true);
        });
      },
      deep: true
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-pagination.js
function samePagination(oldPag, newPag) {
  for (const prop in newPag) {
    if (newPag[prop] !== oldPag[prop]) {
      return false;
    }
  }
  return true;
}
function fixPagination(p) {
  if (p.page < 1) {
    p.page = 1;
  }
  if (p.rowsPerPage !== void 0 && p.rowsPerPage < 1) {
    p.rowsPerPage = 0;
  }
  return p;
}
/* harmony default export */ var table_pagination = ({
  props: {
    pagination: Object,
    rowsPerPageOptions: {
      type: Array,
      default: () => [5, 7, 10, 15, 20, 25, 50, 0]
    }
  },
  computed: {
    computedPagination() {
      const pag = this.qListeners['update:pagination'] !== void 0 ? {
        ...this.innerPagination,
        ...this.pagination
      } : this.innerPagination;
      return fixPagination(pag);
    },
    firstRowIndex() {
      const {
        page,
        rowsPerPage
      } = this.computedPagination;
      return (page - 1) * rowsPerPage;
    },
    lastRowIndex() {
      const {
        page,
        rowsPerPage
      } = this.computedPagination;
      return page * rowsPerPage;
    },
    isFirstPage() {
      return this.computedPagination.page === 1;
    },
    pagesNumber() {
      return this.computedPagination.rowsPerPage === 0 ? 1 : Math.max(1, Math.ceil(this.computedRowsNumber / this.computedPagination.rowsPerPage));
    },
    isLastPage() {
      return this.lastRowIndex === 0 ? true : this.computedPagination.page >= this.pagesNumber;
    },
    computedRowsPerPageOptions() {
      const opts = this.rowsPerPageOptions.includes(this.innerPagination.rowsPerPage) ? this.rowsPerPageOptions : [this.innerPagination.rowsPerPage].concat(this.rowsPerPageOptions);
      return opts.map(count => ({
        label: count === 0 ? this.$q.lang.table.allRows : '' + count,
        value: count
      }));
    }
  },
  watch: {
    pagesNumber(lastPage, oldLastPage) {
      if (lastPage === oldLastPage) {
        return;
      }
      const currentPage = this.computedPagination.page;
      if (lastPage && !currentPage) {
        this.setPagination({
          page: 1
        });
      } else if (lastPage < currentPage) {
        this.setPagination({
          page: lastPage
        });
      }
    }
  },
  methods: {
    __sendServerRequest(pagination) {
      this.requestServerInteraction({
        pagination,
        filter: this.filter
      });
    },
    setPagination(val, forceServerRequest) {
      const newPagination = fixPagination({
        ...this.computedPagination,
        ...val
      });
      if (samePagination(this.computedPagination, newPagination)) {
        if (this.isServerSide === true && forceServerRequest === true) {
          this.__sendServerRequest(newPagination);
        }
        return;
      }
      if (this.isServerSide === true) {
        this.__sendServerRequest(newPagination);
        return;
      }
      if (this.pagination !== void 0 && this.qListeners['update:pagination'] !== void 0) {
        this.$emit('update:pagination', newPagination);
      } else {
        this.innerPagination = newPagination;
      }
    },
    firstPage() {
      this.setPagination({
        page: 1
      });
    },
    prevPage() {
      const {
        page
      } = this.computedPagination;
      if (page > 1) {
        this.setPagination({
          page: page - 1
        });
      }
    },
    nextPage() {
      const {
        page,
        rowsPerPage
      } = this.computedPagination;
      if (this.lastRowIndex > 0 && page * rowsPerPage < this.computedRowsNumber) {
        this.setPagination({
          page: page + 1
        });
      }
    },
    lastPage() {
      this.setPagination({
        page: this.pagesNumber
      });
    }
  },
  created() {
    if (this.qListeners['update:pagination'] !== void 0) {
      this.$emit('update:pagination', {
        ...this.computedPagination
      });
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-row-selection.js
/* harmony default export */ var table_row_selection = ({
  props: {
    selection: {
      type: String,
      default: 'none',
      validator: v => ['single', 'multiple', 'none'].includes(v)
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selectedKeys() {
      const keys = {};
      this.selected.map(this.getRowKey).forEach(key => {
        keys[key] = true;
      });
      return keys;
    },
    hasSelectionMode() {
      return this.selection !== 'none';
    },
    singleSelection() {
      return this.selection === 'single';
    },
    multipleSelection() {
      return this.selection === 'multiple';
    },
    allRowsSelected() {
      return this.computedRows.length > 0 && this.computedRows.every(row => this.selectedKeys[this.getRowKey(row)] === true);
    },
    someRowsSelected() {
      return this.allRowsSelected !== true && this.computedRows.some(row => this.selectedKeys[this.getRowKey(row)] === true);
    },
    rowsSelectedNumber() {
      return this.selected.length;
    }
  },
  methods: {
    isRowSelected(key) {
      return this.selectedKeys[key] === true;
    },
    clearSelection() {
      this.$emit('update:selected', []);
    },
    __updateSelection(keys, rows, added, evt) {
      this.$emit('selection', {
        rows,
        added,
        keys,
        evt
      });
      const payload = this.singleSelection === true ? added === true ? rows : [] : added === true ? this.selected.concat(rows) : this.selected.filter(row => keys.includes(this.getRowKey(row)) === false);
      this.$emit('update:selected', payload);
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-row-expand.js
function table_row_expand_getVal(val) {
  return Array.isArray(val) ? val.slice() : [];
}
/* harmony default export */ var table_row_expand = ({
  props: {
    expanded: Array // sync
  },
  data() {
    return {
      innerExpanded: table_row_expand_getVal(this.expanded)
    };
  },
  watch: {
    expanded(val) {
      this.innerExpanded = table_row_expand_getVal(val);
    }
  },
  methods: {
    isRowExpanded(key) {
      return this.innerExpanded.includes(key);
    },
    setExpanded(val) {
      if (this.expanded !== void 0) {
        this.$emit('update:expanded', val);
      } else {
        this.innerExpanded = val;
      }
    },
    __updateExpanded(key, add) {
      const target = this.innerExpanded.slice();
      const index = target.indexOf(key);
      if (add === true) {
        if (index === -1) {
          target.push(key);
          this.setExpanded(target);
        }
      } else if (index !== -1) {
        target.splice(index, 1);
        this.setExpanded(target);
      }
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/table-column-selection.js

/* harmony default export */ var table_column_selection = ({
  props: {
    visibleColumns: Array
  },
  computed: {
    colList() {
      if (this.columns !== void 0) {
        return this.columns;
      }

      // we infer columns from first row
      const row = this.data[0];
      return row !== void 0 ? Object.keys(row).map(name => ({
        name,
        label: name.toUpperCase(),
        field: name,
        align: Object(is["c" /* isNumber */])(row[name]) ? 'right' : 'left',
        sortable: true
      })) : [];
    },
    computedCols() {
      const {
        sortBy,
        descending
      } = this.computedPagination;
      const cols = this.visibleColumns !== void 0 ? this.colList.filter(col => col.required === true || this.visibleColumns.includes(col.name) === true) : this.colList;
      return cols.map(col => {
        const align = col.align || 'right';
        const alignClass = `text-${align}`;
        return {
          ...col,
          align,
          __iconClass: `q-table__sort-icon q-table__sort-icon--${align}`,
          __thClass: alignClass + (col.headerClasses !== void 0 ? ' ' + col.headerClasses : '') + (col.sortable === true ? ' sortable' : '') + (col.name === sortBy ? ` sorted ${descending === true ? 'sort-desc' : ''}` : ''),
          __tdStyle: col.style !== void 0 ? typeof col.style !== 'function' ? () => col.style : col.style : () => null,
          __tdClass: col.classes !== void 0 ? typeof col.classes !== 'function' ? () => alignClass + ' ' + col.classes : row => alignClass + ' ' + col.classes(row) : () => alignClass
        };
      });
    },
    computedColsMap() {
      const names = {};
      this.computedCols.forEach(col => {
        names[col.name] = col;
      });
      return names;
    },
    computedColspan() {
      return this.tableColspan !== void 0 ? this.tableColspan : this.computedCols.length + (this.hasSelectionMode === true ? 1 : 0);
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/QTable.js




















const commonVirtPropsObj = {};
virtual_scroll["a" /* commonVirtPropsList */].forEach(p => {
  commonVirtPropsObj[p] = {};
});
/* harmony default export */ var QTable = (external_vue_default.a.extend({
  name: 'QTable',
  mixins: [dark["a" /* default */], listeners["a" /* default */], fullscreen, table_top, table_header, table_body, table_bottom, table_grid, table_sort, table_filter, table_pagination, table_row_selection, table_row_expand, table_column_selection],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    rowKey: {
      type: [String, Function],
      default: 'id'
    },
    columns: Array,
    loading: Boolean,
    binaryStateSort: Boolean,
    iconFirstPage: String,
    iconPrevPage: String,
    iconNextPage: String,
    iconLastPage: String,
    title: String,
    hideHeader: Boolean,
    grid: Boolean,
    gridHeader: Boolean,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    separator: {
      type: String,
      default: 'horizontal',
      validator: v => ['horizontal', 'vertical', 'cell', 'none'].includes(v)
    },
    wrapCells: Boolean,
    virtualScroll: Boolean,
    ...commonVirtPropsObj,
    noDataLabel: String,
    noResultsLabel: String,
    loadingLabel: String,
    selectedRowsLabel: Function,
    rowsPerPageLabel: String,
    paginationLabel: Function,
    color: {
      type: String,
      default: 'grey-8'
    },
    titleClass: [String, Array, Object],
    tableStyle: [String, Array, Object],
    tableClass: [String, Array, Object],
    tableHeaderStyle: [String, Array, Object],
    tableHeaderClass: [String, Array, Object],
    cardContainerClass: [String, Array, Object],
    cardContainerStyle: [String, Array, Object],
    cardStyle: [String, Array, Object],
    cardClass: [String, Array, Object]
  },
  data() {
    return {
      innerPagination: Object.assign({
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: this.rowsPerPageOptions.length > 0 ? this.rowsPerPageOptions[0] : 5
      }, this.pagination)
    };
  },
  watch: {
    needsReset() {
      this.hasVirtScroll === true && this.$refs.virtScroll !== void 0 && this.$refs.virtScroll.reset();
    }
  },
  computed: {
    getRowKey() {
      return typeof this.rowKey === 'function' ? this.rowKey : row => row[this.rowKey];
    },
    hasVirtScroll() {
      return this.grid !== true && this.virtualScroll === true;
    },
    needsReset() {
      return ['tableStyle', 'tableClass', 'tableHeaderStyle', 'tableHeaderClass', '__containerClass'].map(p => this[p]).join(';');
    },
    filteredSortedRows() {
      let rows = this.data;
      if (this.isServerSide === true || rows.length === 0) {
        return rows;
      }
      const {
        sortBy,
        descending
      } = this.computedPagination;
      if (this.filter) {
        rows = this.filterMethod(rows, this.filter, this.computedCols, this.getCellValue);
      }
      if (this.columnToSort !== void 0) {
        rows = this.sortMethod(this.data === rows ? rows.slice() : rows, sortBy, descending);
      }
      return rows;
    },
    filteredSortedRowsNumber() {
      return this.filteredSortedRows.length;
    },
    computedRows() {
      let rows = this.filteredSortedRows;
      if (this.isServerSide === true) {
        return rows;
      }
      const {
        rowsPerPage
      } = this.computedPagination;
      if (rowsPerPage !== 0) {
        if (this.firstRowIndex === 0 && this.data !== rows) {
          if (rows.length > this.lastRowIndex) {
            rows = rows.slice(0, this.lastRowIndex);
          }
        } else {
          rows = rows.slice(this.firstRowIndex, this.lastRowIndex);
        }
      }
      return rows;
    },
    computedRowsNumber() {
      return this.isServerSide === true ? this.computedPagination.rowsNumber || 0 : this.filteredSortedRowsNumber;
    },
    nothingToDisplay() {
      return this.computedRows.length === 0;
    },
    isServerSide() {
      return this.computedPagination.rowsNumber !== void 0;
    },
    cardDefaultClass() {
      return ' q-table__card' + (this.isDark === true ? ' q-table__card--dark q-dark' : '') + (this.square === true ? ' q-table--square' : '') + (this.flat === true ? ' q-table--flat' : '') + (this.bordered === true ? ' q-table--bordered' : '');
    },
    __containerClass() {
      return `q-table__container q-table--${this.separator}-separator column no-wrap` + (this.grid === true ? ' q-table--grid' : this.cardDefaultClass) + (this.isDark === true ? ' q-table--dark' : '') + (this.dense === true ? ' q-table--dense' : '') + (this.wrapCells === false ? ' q-table--no-wrap' : '') + (this.inFullscreen === true ? ' fullscreen scroll' : '');
    },
    containerClass() {
      // do not trigger a refresh of the table when the loading status is changed
      return this.__containerClass + (this.loading === true ? ' q-table--loading' : '');
    },
    virtProps() {
      const props = {};
      virtual_scroll["a" /* commonVirtPropsList */].forEach(p => {
        props[p] = this[p];
      });
      if (props.virtualScrollItemSize === void 0) {
        props.virtualScrollItemSize = this.dense === true ? 28 : 48;
      }
      return props;
    }
  },
  render(h) {
    const child = [this.__getTopDiv(h)];
    const data = {
      staticClass: this.containerClass
    };
    if (this.grid === true) {
      child.push(this.__getGridHeader(h));
    } else {
      Object.assign(data, {
        class: this.cardClass,
        style: this.cardStyle
      });
    }
    child.push(this.__getBody(h), this.__getBottomDiv(h));
    if (this.loading === true && this.$scopedSlots.loading !== void 0) {
      child.push(this.$scopedSlots.loading());
    }
    return h('div', data, child);
  },
  methods: {
    requestServerInteraction(prop = {}) {
      this.$nextTick(() => {
        this.$emit('request', {
          pagination: prop.pagination || this.computedPagination,
          filter: prop.filter || this.filter,
          getCellValue: this.getCellValue
        });
      });
    },
    resetVirtualScroll() {
      this.hasVirtScroll === true && this.$refs.virtScroll.reset();
    },
    __getBody(h) {
      if (this.grid === true) {
        return this.__getGridBody(h);
      }
      const header = this.hideHeader !== true ? this.__getTHead(h) : null;
      if (this.hasVirtScroll === true) {
        const topRow = this.$scopedSlots['top-row'];
        const bottomRow = this.$scopedSlots['bottom-row'];
        const virtSlots = {
          default: this.__getVirtualTBodyTR(h)
        };
        if (topRow !== void 0) {
          const topContent = h('tbody', topRow({
            cols: this.computedCols
          }));
          virtSlots.before = header === null ? () => [topContent] : () => [header].concat(topContent);
        } else if (header !== null) {
          virtSlots.before = () => header;
        }
        if (bottomRow !== void 0) {
          virtSlots.after = () => h('tbody', bottomRow({
            cols: this.computedCols
          }));
        }
        return h(QVirtualScroll, {
          ref: 'virtScroll',
          props: {
            ...this.virtProps,
            items: this.computedRows,
            type: '__qtable',
            tableColspan: this.computedColspan
          },
          on: Object(cache["b" /* default */])(this, 'vs', {
            'virtual-scroll': this.__onVScroll
          }),
          class: this.tableClass,
          style: this.tableStyle,
          scopedSlots: virtSlots
        });
      }
      return get_table_middle(h, {
        staticClass: 'scroll',
        class: this.tableClass,
        style: this.tableStyle
      }, [header, this.__getTBody(h)]);
    },
    scrollTo(toIndex, edge) {
      if (this.$refs.virtScroll !== void 0) {
        this.$refs.virtScroll.scrollTo(toIndex, edge);
        return;
      }
      toIndex = parseInt(toIndex, 10);
      const rowEl = this.$el.querySelector(`tbody tr:nth-of-type(${toIndex + 1})`);
      if (rowEl !== null) {
        const scrollTarget = this.$el.querySelector('.q-table__middle.scroll');
        const offsetTop = rowEl.offsetTop - this.virtualScrollStickySizeStart;
        const direction = offsetTop < scrollTarget.scrollTop ? 'decrease' : 'increase';
        scrollTarget.scrollTop = offsetTop;
        this.$emit('virtual-scroll', {
          index: toIndex,
          from: 0,
          to: this.pagination.rowsPerPage - 1,
          direction
        });
      }
    },
    __onVScroll(info) {
      this.$emit('virtual-scroll', info);
    },
    __getProgress(h) {
      return [h(QLinearProgress, {
        staticClass: 'q-table__linear-progress',
        props: {
          color: this.color,
          dark: this.isDark,
          indeterminate: true,
          trackColor: 'transparent'
        }
      })];
    }
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/QTr.js



/* harmony default export */ var QTr = (external_vue_default.a.extend({
  name: 'QTr',
  mixins: [listeners["a" /* default */]],
  props: {
    props: Object,
    noHover: Boolean
  },
  computed: {
    classes() {
      return 'q-tr' + (this.props === void 0 || this.props.header === true ? '' : ' ' + this.props.__trClass) + (this.noHover === true ? ' q-tr--no-hover' : '');
    }
  },
  render(h) {
    return h('tr', {
      on: {
        ...this.qListeners
      },
      class: this.classes
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/QTd.js



/* harmony default export */ var QTd = (external_vue_default.a.extend({
  name: 'QTd',
  mixins: [listeners["a" /* default */]],
  props: {
    props: Object,
    autoWidth: Boolean,
    noHover: Boolean
  },
  computed: {
    classes() {
      return 'q-td' + (this.autoWidth === true ? ' q-table--col-auto-width' : '') + (this.noHover === true ? ' q-td--no-hover' : '') + ' ';
    }
  },
  render(h) {
    const on = this.qListeners;
    if (this.props === void 0) {
      return h('td', {
        on,
        class: this.classes
      }, Object(private_slot["c" /* slot */])(this, 'default'));
    }
    const name = this.$vnode.key;
    const col = this.props.colsMap !== void 0 && name ? this.props.colsMap[name] : this.props.col;
    if (col === void 0) {
      return;
    }
    const row = this.props.row;
    return h('td', {
      on,
      style: col.__tdStyle(row),
      class: this.classes + col.__tdClass(row)
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/table/index.js





// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tabs/QRouteTab.js



/* harmony default export */ var QRouteTab = (external_vue_default.a.extend({
  name: 'QRouteTab',
  mixins: [QTab, router_link["a" /* default */]],
  watch: {
    routeModel() {
      this.$tabs.__verifyRouteModel();
    }
  },
  computed: {
    routeModel() {
      return `${this.name} | ${this.exact} | ${(this.resolvedLink || {}).href}`;
    },
    // overwritten from RouterLinkMixin
    // because we want to discard the "disable" state
    hasRouterLinkProps() {
      return this.$router !== void 0 && this.hasHrefLink !== true && this.to !== void 0 && this.to !== null && this.to !== '';
    }
  },
  render(h) {
    return this.__renderTab(h, this.linkTag);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tabs/index.js




// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/time/QTime.js









/* harmony default export */ var QTime = (external_vue_default.a.extend({
  name: 'QTime',
  mixins: [datetime],
  directives: {
    TouchPan: TouchPan["a" /* default */]
  },
  props: {
    mask: {
      default: null
    },
    format24h: {
      type: Boolean,
      default: null
    },
    defaultDate: {
      type: String,
      validator: v => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v)
    },
    options: Function,
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    withSeconds: Boolean,
    nowBtn: Boolean
  },
  data() {
    const model = __splitDate(this.value, this.__getMask(), this.__getLocale(), this.calendar, this.__getDefaultDateModel());
    let view = 'Hour';
    if (model.hour !== null) {
      if (model.minute === null) {
        view = 'Minute';
      } else if (this.withSeconds === true && model.second === null) {
        view = 'Second';
      }
    }
    return {
      view,
      isAM: model.hour === null || model.hour < 12,
      innerModel: model
    };
  },
  watch: {
    value(v) {
      const model = __splitDate(v, this.computedMask, this.computedLocale, this.calendar, this.defaultDateModel);
      if (model.dateHash !== this.innerModel.dateHash || model.timeHash !== this.innerModel.timeHash) {
        this.innerModel = model;
        if (model.hour === null) {
          this.view = 'Hour';
        } else {
          this.isAM = model.hour < 12;
        }
      }
    },
    computedMask() {
      this.$nextTick(() => {
        this.__updateValue();
      });
    },
    computedLocale() {
      this.$nextTick(() => {
        this.__updateValue();
      });
    }
  },
  computed: {
    classes() {
      return `q-time q-time--${this.landscape === true ? 'landscape' : 'portrait'}` + (this.isDark === true ? ' q-time--dark q-dark' : '') + (this.disable === true ? ' disabled' : this.readonly === true ? ' q-time--readonly' : '') + (this.bordered === true ? ' q-time--bordered' : '') + (this.square === true ? ' q-time--square no-border-radius' : '') + (this.flat === true ? ' q-time--flat no-shadow' : '');
    },
    stringModel() {
      const time = this.innerModel;
      return {
        hour: time.hour === null ? '--' : this.computedFormat24h === true ? Object(format["e" /* pad */])(time.hour) : String(this.isAM === true ? time.hour === 0 ? 12 : time.hour : time.hour > 12 ? time.hour - 12 : time.hour),
        minute: time.minute === null ? '--' : Object(format["e" /* pad */])(time.minute),
        second: time.second === null ? '--' : Object(format["e" /* pad */])(time.second)
      };
    },
    defaultDateModel() {
      return this.__getDefaultDateModel();
    },
    computedFormat24h() {
      return this.format24h !== null ? this.format24h : this.$q.lang.date.format24h;
    },
    pointerStyle() {
      const forHour = this.view === 'Hour',
        divider = forHour === true ? 12 : 60,
        amount = this.innerModel[this.view.toLowerCase()],
        degrees = Math.round(amount * (360 / divider)) - 180;
      let transform = `rotate(${degrees}deg) translateX(-50%)`;
      if (forHour === true && this.computedFormat24h === true && this.innerModel.hour >= 12) {
        transform += ' scale(.7)';
      }
      return {
        transform
      };
    },
    minLink() {
      return this.innerModel.hour !== null;
    },
    secLink() {
      return this.minLink === true && this.innerModel.minute !== null;
    },
    hourInSelection() {
      return this.hourOptions !== void 0 ? val => this.hourOptions.includes(val) : this.options !== void 0 ? val => this.options(val, null, null) : void 0;
    },
    minuteInSelection() {
      return this.minuteOptions !== void 0 ? val => this.minuteOptions.includes(val) : this.options !== void 0 ? val => this.options(this.innerModel.hour, val, null) : void 0;
    },
    secondInSelection() {
      return this.secondOptions !== void 0 ? val => this.secondOptions.includes(val) : this.options !== void 0 ? val => this.options(this.innerModel.hour, this.innerModel.minute, val) : void 0;
    },
    validHours() {
      if (this.hourInSelection !== void 0) {
        const am = this.__getValidValues(0, 11, this.hourInSelection);
        const pm = this.__getValidValues(12, 11, this.hourInSelection);
        return {
          am,
          pm,
          values: am.values.concat(pm.values)
        };
      }
    },
    validMinutes() {
      if (this.minuteInSelection !== void 0) {
        return this.__getValidValues(0, 59, this.minuteInSelection);
      }
    },
    validSeconds() {
      if (this.secondInSelection !== void 0) {
        return this.__getValidValues(0, 59, this.secondInSelection);
      }
    },
    viewValidOptions() {
      switch (this.view) {
        case 'Hour':
          return this.validHours;
        case 'Minute':
          return this.validMinutes;
        case 'Second':
          return this.validSeconds;
      }
    },
    positions() {
      let start,
        end,
        offset = 0,
        step = 1;
      const values = this.viewValidOptions !== void 0 ? this.viewValidOptions.values : void 0;
      if (this.view === 'Hour') {
        if (this.computedFormat24h === true) {
          start = 0;
          end = 23;
        } else {
          start = 0;
          end = 11;
          if (this.isAM === false) {
            offset = 12;
          }
        }
      } else {
        start = 0;
        end = 55;
        step = 5;
      }
      const pos = [];
      for (let val = start, index = start; val <= end; val += step, index++) {
        const actualVal = val + offset,
          disable = values !== void 0 && values.includes(actualVal) === false,
          label = this.view === 'Hour' && val === 0 ? this.computedFormat24h === true ? '00' : '12' : val;
        pos.push({
          val: actualVal,
          index,
          disable,
          label
        });
      }
      return pos;
    }
  },
  methods: {
    setNow() {
      const date = {
        ...this.__getCurrentDate(),
        ...this.__getCurrentTime()
      };
      this.__updateValue(date);
      Object.assign(this.innerModel, date); // reset any pending changes to innerModel

      this.view = 'Hour';
    },
    __getValidValues(start, count, testFn) {
      const values = Array.apply(null, {
        length: count + 1
      }).map((_, index) => {
        const i = index + start;
        return {
          index: i,
          val: testFn(i) === true // force boolean
        };
      }).filter(v => v.val === true).map(v => v.index);
      return {
        min: values[0],
        max: values[values.length - 1],
        values,
        threshold: count + 1
      };
    },
    __getWheelDist(a, b, threshold) {
      const diff = Math.abs(a - b);
      return Math.min(diff, threshold - diff);
    },
    __getNormalizedClockValue(val, {
      min,
      max,
      values,
      threshold
    }) {
      if (val === min) {
        return min;
      }
      if (val < min || val > max) {
        return this.__getWheelDist(val, min, threshold) <= this.__getWheelDist(val, max, threshold) ? min : max;
      }
      const index = values.findIndex(v => val <= v),
        before = values[index - 1],
        after = values[index];
      return val - before <= after - val ? before : after;
    },
    __getMask() {
      return this.calendar !== 'persian' && this.mask !== null ? this.mask : `HH:mm${this.withSeconds === true ? ':ss' : ''}`;
    },
    __getDefaultDateModel() {
      if (typeof this.defaultDate !== 'string') {
        const date = this.__getCurrentDate(true);
        date.dateHash = this.__getDayHash(date);
        return date;
      }
      return __splitDate(this.defaultDate, 'YYYY/MM/DD', void 0, this.calendar);
    },
    __click(evt) {
      if (this.__shouldAbortInteraction() !== true) {
        // __activate() has already updated the offset
        // (on desktop only, through mousedown event)
        if (this.$q.platform.is.desktop !== true) {
          this.__updateClock(evt, this.__getClockRect());
        }
        this.__goToNextView();
      }
    },
    __activate(evt) {
      if (this.__shouldAbortInteraction() !== true) {
        this.__updateClock(evt, this.__getClockRect());
      }
    },
    __shouldAbortInteraction() {
      return this._isBeingDestroyed === true || this._isDestroyed === true ||
      // if we have limited options, can we actually set any?

      this.viewValidOptions !== void 0 && (this.viewValidOptions.values.length === 0 || this.view === 'Hour' && this.computedFormat24h !== true && this.validHours[this.isAM === true ? 'am' : 'pm'].values.length === 0);
    },
    __getClockRect() {
      const clock = this.$refs.clock,
        {
          top,
          left,
          width
        } = clock.getBoundingClientRect(),
        dist = width / 2;
      return {
        top: top + dist,
        left: left + dist,
        dist: dist * 0.7
      };
    },
    __goToNextView() {
      if (this.view === 'Hour') {
        this.view = 'Minute';
      } else if (this.withSeconds && this.view === 'Minute') {
        this.view = 'Second';
      }
    },
    __drag(event) {
      if (this.__shouldAbortInteraction() === true) {
        return;
      }
      if (event.isFirst === true) {
        this.draggingClockRect = this.__getClockRect();
        this.dragCache = this.__updateClock(event.evt, this.draggingClockRect);
        return;
      }
      this.dragCache = this.__updateClock(event.evt, this.draggingClockRect, this.dragCache);
      if (event.isFinal === true) {
        this.draggingClockRect = false;
        this.dragCache = null;
        this.__goToNextView();
      }
    },
    __updateClock(evt, clockRect, cacheVal) {
      const pos = Object(utils_event["h" /* position */])(evt),
        height = Math.abs(pos.top - clockRect.top),
        distance = Math.sqrt(Math.pow(Math.abs(pos.top - clockRect.top), 2) + Math.pow(Math.abs(pos.left - clockRect.left), 2));
      let val,
        angle = Math.asin(height / distance) * (180 / Math.PI);
      if (pos.top < clockRect.top) {
        angle = clockRect.left < pos.left ? 90 - angle : 270 + angle;
      } else {
        angle = clockRect.left < pos.left ? angle + 90 : 270 - angle;
      }
      if (this.view === 'Hour') {
        val = angle / 30;
        if (this.validHours !== void 0) {
          const am = this.computedFormat24h !== true ? this.isAM === true : this.validHours.am.values.length > 0 && this.validHours.pm.values.length > 0 ? distance >= clockRect.dist : this.validHours.am.values.length > 0;
          val = this.__getNormalizedClockValue(val + (am === true ? 0 : 12), this.validHours[am === true ? 'am' : 'pm']);
        } else {
          val = Math.round(val);
          if (this.computedFormat24h === true) {
            if (distance < clockRect.dist) {
              if (val < 12) {
                val += 12;
              }
            } else if (val === 12) {
              val = 0;
            }
          } else if (this.isAM === true && val === 12) {
            val = 0;
          } else if (this.isAM === false && val !== 12) {
            val += 12;
          }
        }
        if (this.computedFormat24h === true) {
          this.isAM = val < 12;
        }
      } else {
        val = Math.round(angle / 6) % 60;
        if (this.view === 'Minute' && this.validMinutes !== void 0) {
          val = this.__getNormalizedClockValue(val, this.validMinutes);
        } else if (this.view === 'Second' && this.validSeconds !== void 0) {
          val = this.__getNormalizedClockValue(val, this.validSeconds);
        }
      }
      if (cacheVal !== val) {
        this[`__set${this.view}`](val);
      }
      return val;
    },
    __onKeyupHour(e) {
      if (e.keyCode === 13) {
        // ENTER
        this.view = 'Hour';
      } else if ([37, 39].includes(e.keyCode)) {
        const payload = e.keyCode === 37 ? -1 : 1;
        if (this.validHours !== void 0) {
          const values = this.computedFormat24h === true ? this.validHours.values : this.validHours[this.isAM === true ? 'am' : 'pm'].values;
          if (values.length === 0) {
            return;
          }
          if (this.innerModel.hour === null) {
            this.__setHour(values[0]);
          } else {
            const index = (values.length + values.indexOf(this.innerModel.hour) + payload) % values.length;
            this.__setHour(values[index]);
          }
        } else {
          const wrap = this.computedFormat24h === true ? 24 : 12,
            offset = this.computedFormat24h !== true && this.isAM === false ? 12 : 0,
            val = this.innerModel.hour === null ? -payload : this.innerModel.hour;
          this.__setHour(offset + (24 + val + payload) % wrap);
        }
      }
    },
    __onKeyupMinute(e) {
      if (e.keyCode === 13) {
        // ENTER
        this.view = 'Minute';
      } else if ([37, 39].includes(e.keyCode)) {
        const payload = e.keyCode === 37 ? -1 : 1;
        if (this.validMinutes !== void 0) {
          const values = this.validMinutes.values;
          if (values.length === 0) {
            return;
          }
          if (this.innerModel.minute === null) {
            this.__setMinute(values[0]);
          } else {
            const index = (values.length + values.indexOf(this.innerModel.minute) + payload) % values.length;
            this.__setMinute(values[index]);
          }
        } else {
          const val = this.innerModel.minute === null ? -payload : this.innerModel.minute;
          this.__setMinute((60 + val + payload) % 60);
        }
      }
    },
    __onKeyupSecond(e) {
      if (e.keyCode === 13) {
        // ENTER
        this.view = 'Second';
      } else if ([37, 39].includes(e.keyCode)) {
        const payload = e.keyCode === 37 ? -1 : 1;
        if (this.validSeconds !== void 0) {
          const values = this.validSeconds.values;
          if (values.length === 0) {
            return;
          }
          if (this.innerModel.seconds === null) {
            this.__setSecond(values[0]);
          } else {
            const index = (values.length + values.indexOf(this.innerModel.second) + payload) % values.length;
            this.__setSecond(values[index]);
          }
        } else {
          const val = this.innerModel.second === null ? -payload : this.innerModel.second;
          this.__setSecond((60 + val + payload) % 60);
        }
      }
    },
    __getHeader(h) {
      const label = [h('div', {
        staticClass: 'q-time__link',
        class: this.view === 'Hour' ? 'q-time__link--active' : 'cursor-pointer',
        attrs: {
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'vH', {
          click: () => {
            this.view = 'Hour';
          },
          keyup: this.__onKeyupHour
        })
      }, [this.stringModel.hour]), h('div', [':']), h('div', this.minLink === true ? {
        staticClass: 'q-time__link',
        class: this.view === 'Minute' ? 'q-time__link--active' : 'cursor-pointer',
        attrs: {
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'vM', {
          click: () => {
            this.view = 'Minute';
          },
          keyup: this.__onKeyupMinute
        })
      } : {
        staticClass: 'q-time__link'
      }, [this.stringModel.minute])];
      if (this.withSeconds === true) {
        label.push(h('div', [':']), h('div', this.secLink === true ? {
          staticClass: 'q-time__link',
          class: this.view === 'Second' ? 'q-time__link--active' : 'cursor-pointer',
          attrs: {
            tabindex: this.computedTabindex
          },
          on: Object(cache["b" /* default */])(this, 'vS', {
            click: () => {
              this.view = 'Second';
            },
            keyup: this.__onKeyupSecond
          })
        } : {
          staticClass: 'q-time__link'
        }, [this.stringModel.second]));
      }
      return h('div', {
        staticClass: 'q-time__header flex flex-center no-wrap',
        class: this.headerClass
      }, [h('div', {
        staticClass: 'q-time__header-label row items-center no-wrap',
        attrs: {
          dir: 'ltr'
        }
      }, label), this.computedFormat24h === false ? h('div', {
        staticClass: 'q-time__header-ampm column items-between no-wrap'
      }, [h('div', {
        staticClass: 'q-time__link',
        class: this.isAM === true ? 'q-time__link--active' : 'cursor-pointer',
        attrs: {
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'AM', {
          click: this.__setAm,
          keyup: e => {
            e.keyCode === 13 && this.__setAm();
          }
        })
      }, ['AM']), h('div', {
        staticClass: 'q-time__link',
        class: this.isAM !== true ? 'q-time__link--active' : 'cursor-pointer',
        attrs: {
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'PM', {
          click: this.__setPm,
          keyup: e => {
            e.keyCode === 13 && this.__setPm();
          }
        })
      }, ['PM'])]) : null]);
    },
    __getClock(h) {
      const view = this.view.toLowerCase(),
        current = this.innerModel[view];
      return h('div', {
        staticClass: 'q-time__content col relative-position'
      }, [h('transition', {
        props: {
          name: 'q-transition--scale'
        }
      }, [h('div', {
        key: 'clock' + this.view,
        staticClass: 'q-time__container-parent absolute-full'
      }, [h('div', {
        ref: 'clock',
        staticClass: 'q-time__container-child fit overflow-hidden'
      }, [h('div', {
        staticClass: 'q-time__clock cursor-pointer non-selectable',
        on: Object(cache["b" /* default */])(this, 'click', {
          click: this.__click,
          mousedown: this.__activate
        }),
        directives: Object(cache["b" /* default */])(this, 'touch', [{
          name: 'touch-pan',
          value: this.__drag,
          modifiers: {
            stop: true,
            prevent: true,
            mouse: true
          }
        }])
      }, [h('div', {
        staticClass: 'q-time__clock-circle fit'
      }, [h('div', {
        staticClass: 'q-time__clock-pointer',
        style: this.pointerStyle,
        class: this.innerModel[view] === null ? 'hidden' : this.color !== void 0 ? `text-${this.color}` : ''
      }), this.positions.map(pos => h('div', {
        staticClass: `q-time__clock-position row flex-center q-time__clock-pos-${pos.index}`,
        class: pos.val === current ? this.headerClass.concat(' q-time__clock-position--active') : pos.disable === true ? 'q-time__clock-position--disable' : null
      }, [h('span', [pos.label])]))])])])])]), this.nowBtn === true ? h(QBtn["a" /* default */], {
        staticClass: 'q-time__now-button absolute',
        props: {
          icon: this.$q.iconSet.datetime.now,
          unelevated: true,
          size: 'sm',
          round: true,
          color: this.color,
          textColor: this.textColor,
          tabindex: this.computedTabindex
        },
        on: Object(cache["b" /* default */])(this, 'now', {
          click: this.setNow
        })
      }) : null]);
    },
    __setHour(hour) {
      if (this.innerModel.hour !== hour) {
        this.innerModel.hour = hour;
        this.innerModel.minute = null;
        this.innerModel.second = null;
      }
    },
    __setMinute(minute) {
      if (this.innerModel.minute !== minute) {
        this.innerModel.minute = minute;
        this.innerModel.second = null;
        this.withSeconds !== true && this.__updateValue({
          minute
        });
      }
    },
    __setSecond(second) {
      this.innerModel.second !== second && this.__updateValue({
        second
      });
    },
    __setAm() {
      if (this.isAM === false) {
        this.isAM = true;
        if (this.innerModel.hour !== null) {
          this.innerModel.hour -= 12;
          this.__verifyAndUpdate();
        }
      }
    },
    __setPm() {
      if (this.isAM === true) {
        this.isAM = false;
        if (this.innerModel.hour !== null) {
          this.innerModel.hour += 12;
          this.__verifyAndUpdate();
        }
      }
    },
    __verifyAndUpdate() {
      if (this.hourInSelection !== void 0 && this.hourInSelection(this.innerModel.hour) !== true) {
        this.innerModel = __splitDate();
        this.view = 'Hour';
        return;
      }
      if (this.minuteInSelection !== void 0 && this.minuteInSelection(this.innerModel.minute) !== true) {
        this.innerModel.minute = null;
        this.innerModel.second = null;
        this.view = 'Minute';
        return;
      }
      if (this.withSeconds === true && this.secondInSelection !== void 0 && this.secondInSelection(this.innerModel.second) !== true) {
        this.innerModel.second = null;
        this.view = 'Second';
        return;
      }
      if (this.innerModel.hour === null || this.innerModel.minute === null || this.withSeconds === true && this.innerModel.second === null) {
        return;
      }
      this.__updateValue();
    },
    __updateValue(obj) {
      const date = Object.assign({
        ...this.innerModel
      }, obj);
      const val = this.calendar === 'persian' ? Object(format["e" /* pad */])(date.hour) + ':' + Object(format["e" /* pad */])(date.minute) + (this.withSeconds === true ? ':' + Object(format["e" /* pad */])(date.second) : '') : formatDate(new Date(date.year, date.month === null ? null : date.month - 1, date.day, date.hour, date.minute, date.second, date.millisecond), this.computedMask, this.computedLocale, date.year, date.timezoneOffset);
      date.changed = val !== this.value;
      this.$emit('input', val, date);
    }
  },
  render(h) {
    const child = [this.__getClock(h)];
    const def = Object(private_slot["c" /* slot */])(this, 'default');
    def !== void 0 && child.push(h('div', {
      staticClass: 'q-time__actions'
    }, def));
    if (this.name !== void 0 && this.disable !== true) {
      this.__injectFormInput(child, 'push');
    }
    return h('div', {
      class: this.classes,
      on: {
        ...this.qListeners
      },
      attrs: {
        tabindex: -1
      }
    }, [this.__getHeader(h), h('div', {
      staticClass: 'q-time__main col overflow-auto'
    }, child)]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/time/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/timeline/QTimeline.js




/* harmony default export */ var QTimeline = (external_vue_default.a.extend({
  name: 'QTimeline',
  mixins: [dark["a" /* default */], listeners["a" /* default */]],
  provide() {
    return {
      __timeline: this
    };
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    side: {
      type: String,
      default: 'right',
      validator: v => ['left', 'right'].includes(v)
    },
    layout: {
      type: String,
      default: 'dense',
      validator: v => ['dense', 'comfortable', 'loose'].includes(v)
    }
  },
  computed: {
    classes() {
      return `q-timeline--${this.layout} q-timeline--${this.layout}--${this.side}` + (this.isDark === true ? ' q-timeline--dark' : '');
    }
  },
  render(h) {
    return h('ul', {
      staticClass: 'q-timeline',
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/timeline/QTimelineEntry.js




/* harmony default export */ var QTimelineEntry = (external_vue_default.a.extend({
  name: 'QTimelineEntry',
  inject: {
    __timeline: {
      default() {
        console.error('QTimelineEntry needs to be child of QTimeline');
      }
    }
  },
  mixins: [listeners["a" /* default */]],
  props: {
    heading: Boolean,
    tag: {
      type: String,
      default: 'h3'
    },
    side: {
      type: String,
      default: 'right',
      validator: v => ['left', 'right'].includes(v)
    },
    icon: String,
    avatar: String,
    color: String,
    title: String,
    subtitle: String,
    body: String
  },
  computed: {
    colorClass() {
      return `text-${this.color || this.__timeline.color}`;
    },
    classes() {
      return `q-timeline__entry--${this.side}` + (this.icon !== void 0 || this.avatar !== void 0 ? ' q-timeline__entry--icon' : '');
    },
    reverse() {
      return this.__timeline.layout === 'comfortable' && this.__timeline.side === 'left';
    }
  },
  render(h) {
    const child = Object(private_slot["d" /* uniqueSlot */])(this, 'default', []);
    if (this.body !== void 0) {
      child.unshift(this.body);
    }
    if (this.heading === true) {
      const content = [h('div'), h('div'), h(this.tag, {
        staticClass: 'q-timeline__heading-title'
      }, child)];
      return h('div', {
        staticClass: 'q-timeline__heading',
        on: {
          ...this.qListeners
        }
      }, this.reverse === true ? content.reverse() : content);
    }
    let dot;
    if (this.icon !== void 0) {
      dot = [h(QIcon["a" /* default */], {
        staticClass: 'row items-center justify-center',
        props: {
          name: this.icon
        }
      })];
    } else if (this.avatar !== void 0) {
      dot = [h('img', {
        staticClass: 'q-timeline__dot-img',
        domProps: {
          src: this.avatar
        }
      })];
    }
    const content = [h('div', {
      staticClass: 'q-timeline__subtitle'
    }, [h('span', Object(private_slot["c" /* slot */])(this, 'subtitle', [this.subtitle]))]), h('div', {
      staticClass: 'q-timeline__dot',
      class: this.colorClass
    }, dot), h('div', {
      staticClass: 'q-timeline__content'
    }, [h('h6', {
      staticClass: 'q-timeline__title'
    }, Object(private_slot["c" /* slot */])(this, 'title', [this.title]))].concat(child))];
    return h('li', {
      staticClass: 'q-timeline__entry',
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, this.reverse === true ? content.reverse() : content);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/timeline/index.js



// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/toggle/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/toolbar/QToolbar.js



const QToolbar_attrs = {
  role: 'toolbar'
};
/* harmony default export */ var QToolbar = (external_vue_default.a.extend({
  name: 'QToolbar',
  mixins: [listeners["a" /* default */]],
  props: {
    inset: Boolean
  },
  render(h) {
    return h('div', {
      staticClass: 'q-toolbar row no-wrap items-center',
      class: this.inset ? 'q-toolbar--inset' : null,
      attrs: QToolbar_attrs,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/toolbar/QToolbarTitle.js



/* harmony default export */ var QToolbarTitle = (external_vue_default.a.extend({
  name: 'QToolbarTitle',
  mixins: [listeners["a" /* default */]],
  props: {
    shrink: Boolean
  },
  computed: {
    classes() {
      return 'q-toolbar__title ellipsis' + (this.shrink === true ? ' col-shrink' : '');
    }
  },
  render(h) {
    return h('div', {
      class: this.classes,
      on: {
        ...this.qListeners
      }
    }, Object(private_slot["c" /* slot */])(this, 'default'));
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/toolbar/index.js



// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tooltip/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tree/QTree.js










const tickStrategyOptions = ['none', 'strict', 'leaf', 'leaf-filtered'];
/* harmony default export */ var QTree = (external_vue_default.a.extend({
  name: 'QTree',
  mixins: [dark["a" /* default */]],
  props: {
    nodes: {
      type: Array,
      required: true
    },
    nodeKey: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    childrenKey: {
      type: String,
      default: 'children'
    },
    dense: Boolean,
    color: String,
    controlColor: String,
    textColor: String,
    selectedColor: String,
    icon: String,
    tickStrategy: {
      type: String,
      default: 'none',
      validator: v => tickStrategyOptions.includes(v)
    },
    ticked: Array,
    // sync
    expanded: Array,
    // sync
    selected: {},
    // sync

    noSelectionUnset: Boolean,
    defaultExpandAll: Boolean,
    accordion: Boolean,
    filter: String,
    filterMethod: {
      type: Function,
      default(node, filter) {
        const filt = filter.toLowerCase();
        return node[this.labelKey] && node[this.labelKey].toLowerCase().indexOf(filt) > -1;
      }
    },
    duration: Number,
    noConnectors: Boolean,
    noTransition: Boolean,
    noNodesLabel: String,
    noResultsLabel: String
  },
  computed: {
    classes() {
      return `q-tree q-tree--${this.dense === true ? 'dense' : 'standard'}` + (this.noConnectors === true ? ' q-tree--no-connectors' : '') + (this.isDark === true ? ' q-tree--dark' : '') + (this.color !== void 0 ? ` text-${this.color}` : '');
    },
    hasSelection() {
      return this.selected !== void 0;
    },
    computedIcon() {
      return this.icon || this.$q.iconSet.tree.icon;
    },
    computedControlColor() {
      return this.controlColor || this.color;
    },
    textColorClass() {
      if (this.textColor !== void 0) {
        return `text-${this.textColor}`;
      }
    },
    selectedColorClass() {
      const color = this.selectedColor || this.color;
      if (color) {
        return `text-${color}`;
      }
    },
    meta() {
      const meta = {};
      const travel = (node, parent) => {
        const tickStrategy = node.tickStrategy || (parent ? parent.tickStrategy : this.tickStrategy);
        const key = node[this.nodeKey],
          isParent = node[this.childrenKey] && node[this.childrenKey].length > 0,
          selectable = node.disabled !== true && this.hasSelection === true && node.selectable !== false,
          expandable = node.disabled !== true && node.expandable !== false,
          hasTicking = tickStrategy !== 'none',
          strictTicking = tickStrategy === 'strict',
          leafFilteredTicking = tickStrategy === 'leaf-filtered',
          leafTicking = tickStrategy === 'leaf' || tickStrategy === 'leaf-filtered';
        let tickable = node.disabled !== true && node.tickable !== false;
        if (leafTicking === true && tickable === true && parent && parent.tickable !== true) {
          tickable = false;
        }
        let lazy = node.lazy;
        if (lazy === true && this.lazy[key] !== void 0 && Array.isArray(node[this.childrenKey]) === true) {
          lazy = this.lazy[key];
        }
        const m = {
          key,
          parent,
          isParent,
          lazy,
          disabled: node.disabled,
          link: node.disabled !== true && (selectable === true || expandable === true && (isParent === true || lazy === true)),
          children: [],
          matchesFilter: this.filter ? this.filterMethod(node, this.filter) : true,
          selected: key === this.selected && selectable === true,
          selectable,
          expanded: isParent === true ? this.innerExpanded.includes(key) : false,
          expandable,
          noTick: node.noTick === true || strictTicking !== true && lazy && lazy !== 'loaded',
          tickable,
          tickStrategy,
          hasTicking,
          strictTicking,
          leafFilteredTicking,
          leafTicking,
          ticked: strictTicking === true ? this.innerTicked.includes(key) : isParent === true ? false : this.innerTicked.includes(key)
        };
        meta[key] = m;
        if (isParent === true) {
          m.children = node[this.childrenKey].map(n => travel(n, m));
          if (this.filter) {
            if (m.matchesFilter !== true) {
              m.matchesFilter = m.children.some(n => n.matchesFilter);
            } else if (m.noTick !== true && m.disabled !== true && m.tickable === true && leafFilteredTicking === true && m.children.every(n => n.matchesFilter !== true || n.noTick === true || n.tickable !== true) === true) {
              m.tickable = false;
            }
          }
          if (m.matchesFilter === true) {
            if (m.noTick !== true && strictTicking !== true && m.children.every(n => n.noTick) === true) {
              m.noTick = true;
            }
            if (leafTicking) {
              m.ticked = false;
              m.indeterminate = m.children.some(node => node.indeterminate === true);
              m.tickable = m.tickable === true && m.children.some(node => node.tickable);
              if (m.indeterminate !== true) {
                const sel = m.children.reduce((acc, meta) => meta.ticked === true ? acc + 1 : acc, 0);
                if (sel === m.children.length) {
                  m.ticked = true;
                } else if (sel > 0) {
                  m.indeterminate = true;
                }
              }
              if (m.indeterminate === true) {
                m.indeterminateNextState = m.children.every(meta => meta.tickable !== true || meta.ticked !== true);
              }
            }
          }
        }
        return m;
      };
      this.nodes.forEach(node => travel(node, null));
      return meta;
    }
  },
  data() {
    return {
      lazy: {},
      innerTicked: this.ticked || [],
      innerExpanded: this.expanded || []
    };
  },
  watch: {
    ticked(val) {
      this.innerTicked = val;
    },
    expanded(val) {
      this.innerExpanded = val;
    }
  },
  methods: {
    getNodeByKey(key) {
      const reduce = [].reduce;
      const find = (result, node) => {
        if (result || !node) {
          return result;
        }
        if (Array.isArray(node) === true) {
          return reduce.call(Object(node), find, result);
        }
        if (node[this.nodeKey] === key) {
          return node;
        }
        if (node[this.childrenKey]) {
          return find(null, node[this.childrenKey]);
        }
      };
      return find(null, this.nodes);
    },
    getTickedNodes() {
      return this.innerTicked.map(key => this.getNodeByKey(key));
    },
    getExpandedNodes() {
      return this.innerExpanded.map(key => this.getNodeByKey(key));
    },
    isExpanded(key) {
      return key && this.meta[key] ? this.meta[key].expanded : false;
    },
    collapseAll() {
      if (this.expanded !== void 0) {
        this.$emit('update:expanded', []);
      } else {
        this.innerExpanded = [];
      }
    },
    expandAll() {
      const expanded = [];
      const travel = node => {
        if (node[this.childrenKey] && node[this.childrenKey].length > 0) {
          if (node.expandable !== false && node.disabled !== true) {
            expanded.push(node[this.nodeKey]);
            node[this.childrenKey].forEach(travel);
          }
        }
      };
      this.nodes.forEach(travel);
      if (this.expanded !== void 0) {
        this.$emit('update:expanded', expanded);
      } else {
        this.innerExpanded = expanded;
      }
    },
    setExpanded(key, state, node = this.getNodeByKey(key), meta = this.meta[key]) {
      if (meta.lazy && meta.lazy !== 'loaded') {
        if (meta.lazy === 'loading') {
          return;
        }
        this.$set(this.lazy, key, 'loading');
        if (Array.isArray(node[this.childrenKey]) !== true) {
          this.$set(node, this.childrenKey, []);
        }
        this.$emit('lazy-load', {
          node,
          key,
          done: children => {
            this.lazy[key] = 'loaded';
            this.$set(node, this.childrenKey, Array.isArray(children) === true ? children : []);
            this.$nextTick(() => {
              const m = this.meta[key];
              if (m && m.isParent === true) {
                this.__setExpanded(key, true);
              }
            });
          },
          fail: () => {
            this.$delete(this.lazy, key);
            if (node[this.childrenKey].length === 0) {
              this.$delete(node, this.childrenKey);
            }
          }
        });
      } else if (meta.isParent === true && meta.expandable === true) {
        this.__setExpanded(key, state);
      }
    },
    __setExpanded(key, state) {
      let target = this.innerExpanded;
      const emit = this.expanded !== void 0;
      if (emit === true) {
        target = target.slice();
      }
      if (state) {
        if (this.accordion) {
          if (this.meta[key]) {
            const collapse = [];
            if (this.meta[key].parent) {
              this.meta[key].parent.children.forEach(m => {
                if (m.key !== key && m.expandable === true) {
                  collapse.push(m.key);
                }
              });
            } else {
              this.nodes.forEach(node => {
                const k = node[this.nodeKey];
                if (k !== key) {
                  collapse.push(k);
                }
              });
            }
            if (collapse.length > 0) {
              target = target.filter(k => collapse.includes(k) === false);
            }
          }
        }
        target = target.concat([key]).filter((key, index, self) => self.indexOf(key) === index);
      } else {
        target = target.filter(k => k !== key);
      }
      if (emit === true) {
        this.$emit('update:expanded', target);
      } else {
        this.innerExpanded = target;
      }
    },
    isTicked(key) {
      return key && this.meta[key] ? this.meta[key].ticked : false;
    },
    setTicked(keys, state) {
      let target = this.innerTicked;
      const emit = this.ticked !== void 0;
      if (emit === true) {
        target = target.slice();
      }
      if (state) {
        target = target.concat(keys).filter((key, index, self) => self.indexOf(key) === index);
      } else {
        target = target.filter(k => keys.includes(k) === false);
      }
      if (emit === true) {
        this.$emit('update:ticked', target);
      }
    },
    __getSlotScope(node, meta, key) {
      const scope = {
        tree: this,
        node,
        key,
        color: this.color,
        dark: this.isDark
      };
      injectProp(scope, 'expanded', () => {
        return meta.expanded;
      }, val => {
        val !== meta.expanded && this.setExpanded(key, val);
      });
      injectProp(scope, 'ticked', () => {
        return meta.ticked;
      }, val => {
        val !== meta.ticked && this.setTicked([key], val);
      });
      return scope;
    },
    __getChildren(h, nodes) {
      return (this.filter ? nodes.filter(n => this.meta[n[this.nodeKey]].matchesFilter) : nodes).map(child => this.__getNode(h, child));
    },
    __getNodeMedia(h, node) {
      if (node.icon !== void 0) {
        return h(QIcon["a" /* default */], {
          staticClass: 'q-tree__icon q-mr-sm',
          props: {
            name: node.icon,
            color: node.iconColor
          }
        });
      }
      const src = node.img || node.avatar;
      if (src) {
        return h('img', {
          staticClass: `q-tree__${node.img ? 'img' : 'avatar'} q-mr-sm`,
          attrs: {
            src
          }
        });
      }
    },
    __getNode(h, node) {
      const key = node[this.nodeKey],
        meta = this.meta[key],
        header = node.header ? this.$scopedSlots[`header-${node.header}`] || this.$scopedSlots['default-header'] : this.$scopedSlots['default-header'];
      const children = meta.isParent === true ? this.__getChildren(h, node[this.childrenKey]) : [];
      const isParent = children.length > 0 || meta.lazy && meta.lazy !== 'loaded';
      let body = node.body ? this.$scopedSlots[`body-${node.body}`] || this.$scopedSlots['default-body'] : this.$scopedSlots['default-body'];
      const slotScope = header !== void 0 || body !== void 0 ? this.__getSlotScope(node, meta, key) : null;
      if (body !== void 0) {
        body = h('div', {
          staticClass: 'q-tree__node-body relative-position'
        }, [h('div', {
          class: this.textColorClass
        }, [body(slotScope)])]);
      }
      return h('div', {
        key,
        staticClass: 'q-tree__node relative-position',
        class: {
          'q-tree__node--parent': isParent,
          'q-tree__node--child': !isParent
        }
      }, [h('div', {
        staticClass: 'q-tree__node-header relative-position row no-wrap items-center',
        class: {
          'q-tree__node--link q-hoverable q-focusable': meta.link,
          'q-tree__node--selected': meta.selected,
          'q-tree__node--disabled': meta.disabled
        },
        attrs: {
          tabindex: meta.link ? 0 : -1
        },
        on: {
          click: e => {
            this.__onClick(node, meta, e);
          },
          keypress: e => {
            if (Object(key_composition["c" /* shouldIgnoreKey */])(e) !== true) {
              if (e.keyCode === 13) {
                this.__onClick(node, meta, e, true);
              } else if (e.keyCode === 32) {
                this.__onExpandClick(node, meta, e, true);
              }
            }
          }
        }
      }, [h('div', {
        staticClass: 'q-focus-helper',
        attrs: {
          tabindex: -1
        },
        ref: `blurTarget_${meta.key}`
      }), meta.lazy === 'loading' ? h(QSpinner["a" /* default */], {
        staticClass: 'q-tree__spinner',
        props: {
          color: this.computedControlColor
        }
      }) : isParent === true ? h(QIcon["a" /* default */], {
        staticClass: 'q-tree__arrow',
        class: {
          'q-tree__arrow--rotate': meta.expanded
        },
        props: {
          name: this.computedIcon
        },
        on: {
          click: e => {
            this.__onExpandClick(node, meta, e);
          }
        }
      }) : null, meta.hasTicking === true && meta.noTick !== true ? h(QCheckbox["a" /* default */], {
        staticClass: 'q-tree__tickbox',
        props: {
          value: meta.indeterminate === true ? null : meta.ticked,
          color: this.computedControlColor,
          dark: this.isDark,
          dense: true,
          keepColor: true,
          disable: meta.tickable !== true
        },
        on: {
          keydown: utils_event["l" /* stopAndPrevent */],
          input: v => {
            this.__onTickedClick(meta, v);
          }
        }
      }) : null, h('div', {
        'staticClass': 'q-tree__node-header-content col row no-wrap items-center',
        class: meta.selected ? this.selectedColorClass : this.textColorClass
      }, [header ? header(slotScope) : [this.__getNodeMedia(h, node), h('div', node[this.labelKey])]])]), isParent === true ? this.noTransition === true ? h('div', {
        staticClass: 'q-tree__node-collapsible',
        class: this.textColorClass,
        directives: [{
          name: 'show',
          value: meta.expanded
        }]
      }, [body, h('div', {
        staticClass: 'q-tree__children',
        class: {
          'q-tree__node--disabled': meta.disabled
        }
      }, children)]) : h(QSlideTransition, {
        props: {
          duration: this.duration
        },
        on: Object(cache["b" /* default */])(this, 'slide', {
          show: () => {
            this.$emit('after-show');
          },
          hide: () => {
            this.$emit('after-hide');
          }
        })
      }, [h('div', {
        staticClass: 'q-tree__node-collapsible',
        class: this.textColorClass,
        directives: [{
          name: 'show',
          value: meta.expanded
        }]
      }, [body, h('div', {
        staticClass: 'q-tree__children',
        class: {
          'q-tree__node--disabled': meta.disabled
        }
      }, children)])]) : body]);
    },
    __blur(key) {
      const blurTarget = this.$refs[`blurTarget_${key}`];
      blurTarget !== void 0 && blurTarget.focus();
    },
    __onClick(node, meta, e, keyboard) {
      keyboard !== true && this.__blur(meta.key);
      if (this.hasSelection && meta.selectable) {
        if (this.noSelectionUnset === false) {
          this.$emit('update:selected', meta.key !== this.selected ? meta.key : null);
        } else if (meta.key !== this.selected) {
          this.$emit('update:selected', meta.key === void 0 ? null : meta.key);
        }
      } else {
        this.__onExpandClick(node, meta, e, keyboard);
      }
      if (typeof node.handler === 'function') {
        node.handler(node);
      }
    },
    __onExpandClick(node, meta, e, keyboard) {
      if (e !== void 0) {
        Object(utils_event["l" /* stopAndPrevent */])(e);
      }
      keyboard !== true && this.__blur(meta.key);
      this.setExpanded(meta.key, !meta.expanded, node, meta);
    },
    __onTickedClick(meta, state) {
      if (meta.indeterminate === true) {
        state = meta.indeterminateNextState;
      }
      if (meta.strictTicking) {
        this.setTicked([meta.key], state);
      } else if (meta.leafTicking) {
        const keys = [];
        const travel = meta => {
          if (meta.isParent) {
            if (state !== true && meta.noTick !== true && meta.tickable === true) {
              keys.push(meta.key);
            }
            if (meta.leafTicking === true) {
              meta.children.forEach(travel);
            }
          } else if (meta.noTick !== true && meta.tickable === true && (meta.leafFilteredTicking !== true || meta.matchesFilter === true)) {
            keys.push(meta.key);
          }
        };
        travel(meta);
        this.setTicked(keys, state);
      }
    }
  },
  render(h) {
    const children = this.__getChildren(h, this.nodes);
    return h('div', {
      class: this.classes
    }, children.length === 0 ? this.filter ? this.noResultsLabel || this.$q.lang.tree.noResults : this.noNodesLabel || this.$q.lang.tree.noNodes : children);
  },
  created() {
    this.defaultExpandAll === true && this.expandAll();
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/tree/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/uploader/QUploaderBase.js










/* harmony default export */ var QUploaderBase = (external_vue_default.a.extend({
  name: 'QUploaderBase',
  mixins: [dark["a" /* default */], mixins_file["b" /* default */]],
  props: {
    label: String,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    noThumbnails: Boolean,
    autoUpload: Boolean,
    hideUploadBtn: Boolean,
    disable: Boolean,
    readonly: Boolean
  },
  provide() {
    return {
      __qUploaderGetInput: this.__getInputControl
    };
  },
  data() {
    return {
      files: [],
      queuedFiles: [],
      uploadedFiles: [],
      dnd: false,
      expanded: false,
      uploadSize: 0,
      uploadedSize: 0
    };
  },
  watch: {
    isUploading(newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.$emit('start');
      } else if (oldVal === true && newVal === false) {
        this.$emit('finish');
      }
    }
  },
  computed: {
    /*
     * When extending:
     *   Required : isUploading
     *   Optional: isBusy
     */

    canUpload() {
      return this.editable === true && this.isBusy !== true && this.isUploading !== true && this.queuedFiles.length > 0;
    },
    canAddFiles() {
      return this.editable === true && this.isUploading !== true && (
      // if single selection and no files are queued:
      this.multiple === true || this.queuedFiles.length === 0) && (
      // if max-files is set and current number of files does not exceeds it:
      this.maxFiles === void 0 || this.files.length < this.maxFilesNumber) && (
      // if max-total-size is set and current upload size does not exceeds it:
      this.maxTotalSize === void 0 || this.uploadSize < this.maxTotalSizeNumber);
    },
    uploadProgress() {
      return this.uploadSize === 0 ? 0 : this.uploadedSize / this.uploadSize;
    },
    uploadProgressLabel() {
      return this.__getProgressLabel(this.uploadProgress);
    },
    uploadedSizeLabel() {
      return Object(format["c" /* humanStorageSize */])(this.uploadedSize);
    },
    uploadSizeLabel() {
      return Object(format["c" /* humanStorageSize */])(this.uploadSize);
    },
    colorClass() {
      const cls = [];
      this.color !== void 0 && cls.push(`bg-${this.color}`);
      this.textColor !== void 0 && cls.push(`text-${this.textColor}`);
      return cls.join(' ');
    },
    editable() {
      return this.disable !== true && this.readonly !== true;
    }
  },
  methods: {
    reset() {
      if (!this.disable) {
        this.abort();
        this.uploadedSize = 0;
        this.uploadSize = 0;
        this.__revokeImgURLs();
        this.files = [];
        this.queuedFiles = [];
        this.uploadedFiles = [];
      }
    },
    removeUploadedFiles() {
      this.__removeFiles(['uploaded'], () => {
        this.uploadedFiles = [];
      });
    },
    removeQueuedFiles() {
      this.__removeFiles(['idle', 'failed'], ({
        size
      }) => {
        this.uploadSize -= size;
        this.queuedFiles = [];
      });
    },
    __removeFiles(statusList, cb) {
      if (this.disable === true) {
        return;
      }
      const removed = {
        files: [],
        size: 0
      };
      const files = this.files.filter(f => {
        if (statusList.indexOf(f.__status) === -1) {
          return true;
        }
        removed.size += f.size;
        removed.files.push(f);
        f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
        return false;
      });
      if (removed.files.length > 0) {
        this.files = files;
        cb !== void 0 && cb(removed);
        this.$emit('removed', removed.files);
      }
    },
    removeFile(file) {
      if (this.disable) {
        return;
      }
      if (file.__status === 'uploaded') {
        this.uploadedFiles = this.uploadedFiles.filter(f => f.__key !== file.__key);
      } else if (file.__status === 'uploading') {
        file.__abort();
      } else {
        this.uploadSize -= file.size;
      }
      this.files = this.files.filter(f => {
        if (f.__key !== file.__key) {
          return true;
        }
        f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
        return false;
      });
      this.queuedFiles = this.queuedFiles.filter(f => f.__key !== file.__key);
      this.$emit('removed', [file]);
    },
    __revokeImgURLs() {
      this.files.forEach(f => {
        f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
      });
    },
    __getFileInput() {
      return this.$refs.input || this.$el.getElementsByClassName('q-uploader__input')[0];
    },
    __getProgressLabel(p) {
      return (p * 100).toFixed(2) + '%';
    },
    __updateFile(file, status, uploadedSize) {
      file.__status = status;
      if (status === 'idle') {
        file.__uploaded = 0;
        file.__progress = 0;
        file.__sizeLabel = Object(format["c" /* humanStorageSize */])(file.size);
        file.__progressLabel = '0.00%';
        return;
      }
      if (status === 'failed') {
        this.$forceUpdate();
        return;
      }
      file.__uploaded = status === 'uploaded' ? file.size : uploadedSize;
      file.__progress = status === 'uploaded' ? 1 : Math.min(0.9999, file.__uploaded / file.size);
      file.__progressLabel = this.__getProgressLabel(file.__progress);
      this.$forceUpdate();
    },
    __addFiles(e, fileList) {
      const localFiles = this.__processFiles(e, fileList, this.files, true);
      const fileInput = this.__getFileInput();
      if (fileInput !== void 0) {
        fileInput.value = '';
      }
      if (localFiles === void 0) {
        return;
      }
      localFiles.forEach(file => {
        this.__updateFile(file, 'idle');
        this.uploadSize += file.size;
        if (this.noThumbnails !== true && file.type.toUpperCase().startsWith('IMAGE')) {
          const img = new Image();
          img.src = window.URL.createObjectURL(file);
          file.__img = img;
        }
      });
      this.files = this.files.concat(localFiles);
      this.queuedFiles = this.queuedFiles.concat(localFiles);
      this.$emit('added', localFiles);
      this.autoUpload === true && this.upload();
    },
    __getBtn(h, show, icon, fn) {
      if (show === true) {
        return h(QBtn["a" /* default */], {
          props: {
            type: 'a',
            icon: this.$q.iconSet.uploader[icon],
            flat: true,
            dense: true
          },
          on: {
            click: icon === 'add' ? this.pickFiles : fn
          }
        }, icon === 'add' ? this.__getInputControl(h) : null);
      }
    },
    __getInputControl(h) {
      return [h('input', {
        ref: 'input',
        staticClass: 'q-uploader__input overflow-hidden absolute-full',
        attrs: {
          tabindex: -1,
          type: 'file',
          title: '',
          // try to remove default tooltip
          accept: this.accept,
          capture: this.capture,
          ...(this.multiple === true ? {
            multiple: true
          } : {})
        },
        on: Object(cache["b" /* default */])(this, 'input', {
          mousedown: utils_event["k" /* stop */],
          // need to stop refocus from QBtn
          click: this.pickFiles,
          change: this.__addFiles
        })
      })];
    },
    __getHeader(h) {
      if (this.$scopedSlots.header !== void 0) {
        return this.$scopedSlots.header(this);
      }
      return [h('div', {
        staticClass: 'q-uploader__header-content column'
      }, [h('div', {
        staticClass: 'flex flex-center no-wrap q-gutter-xs'
      }, [this.__getBtn(h, this.queuedFiles.length > 0, 'removeQueue', this.removeQueuedFiles), this.__getBtn(h, this.uploadedFiles.length > 0, 'removeUploaded', this.removeUploadedFiles), this.isUploading === true ? h(QSpinner["a" /* default */], {
        staticClass: 'q-uploader__spinner'
      }) : null, h('div', {
        staticClass: 'col column justify-center'
      }, [this.label !== void 0 ? h('div', {
        staticClass: 'q-uploader__title'
      }, [this.label]) : null, h('div', {
        staticClass: 'q-uploader__subtitle'
      }, [this.uploadSizeLabel + ' / ' + this.uploadProgressLabel])]), this.__getBtn(h, this.canAddFiles, 'add', this.pickFiles), this.__getBtn(h, this.hideUploadBtn === false && this.canUpload === true, 'upload', this.upload), this.__getBtn(h, this.isUploading, 'clear', this.abort)])])];
    },
    __getList(h) {
      if (this.$scopedSlots.list !== void 0) {
        return this.$scopedSlots.list(this);
      }
      return this.files.map(file => h('div', {
        key: file.__key,
        staticClass: 'q-uploader__file relative-position',
        class: {
          'q-uploader__file--img': this.noThumbnails !== true && file.__img !== void 0,
          'q-uploader__file--failed': file.__status === 'failed',
          'q-uploader__file--uploaded': file.__status === 'uploaded'
        },
        style: this.noThumbnails !== true && file.__img !== void 0 ? {
          backgroundImage: 'url("' + file.__img.src + '")'
        } : null
      }, [h('div', {
        staticClass: 'q-uploader__file-header row flex-center no-wrap'
      }, [file.__status === 'failed' ? h(QIcon["a" /* default */], {
        staticClass: 'q-uploader__file-status',
        props: {
          name: this.$q.iconSet.type.negative,
          color: 'negative'
        }
      }) : null, h('div', {
        staticClass: 'q-uploader__file-header-content col'
      }, [h('div', {
        staticClass: 'q-uploader__title'
      }, [file.name]), h('div', {
        staticClass: 'q-uploader__subtitle row items-center no-wrap'
      }, [file.__sizeLabel + ' / ' + file.__progressLabel])]), file.__status === 'uploading' ? h(QCircularProgress, {
        props: {
          value: file.__progress,
          min: 0,
          max: 1,
          indeterminate: file.__progress === 0
        }
      }) : h(QBtn["a" /* default */], {
        props: {
          round: true,
          dense: true,
          flat: true,
          icon: this.$q.iconSet.uploader[file.__status === 'uploaded' ? 'done' : 'clear']
        },
        on: {
          click: () => {
            this.removeFile(file);
          }
        }
      })])]));
    }
  },
  beforeDestroy() {
    this.isUploading === true && this.abort();
    this.files.length > 0 && this.__revokeImgURLs();
  },
  render(h) {
    const children = [h('div', {
      staticClass: 'q-uploader__header',
      class: this.colorClass
    }, this.__getHeader(h)), h('div', {
      staticClass: 'q-uploader__list scroll'
    }, this.__getList(h)), this.__getDnd(h, 'uploader')];
    this.isBusy === true && children.push(h('div', {
      staticClass: 'q-uploader__overlay absolute-full flex flex-center'
    }, [h(QSpinner["a" /* default */])]));
    return h('div', {
      staticClass: 'q-uploader column no-wrap',
      class: {
        'q-uploader--dark q-dark': this.isDark,
        'q-uploader--bordered': this.bordered,
        'q-uploader--square no-border-radius': this.square,
        'q-uploader--flat no-shadow': this.flat,
        'disabled q-uploader--disable': this.disable,
        'q-uploader--dnd': this.dnd
      },
      on: this.canAddFiles === true ? Object(cache["b" /* default */])(this, 'drag', {
        dragover: this.__onDragOver,
        dragleave: this.__onDragLeave
      }) : null
    }, children);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/uploader/uploader-xhr-mixin.js
function getFn(prop) {
  return typeof prop === 'function' ? prop : () => prop;
}
/* harmony default export */ var uploader_xhr_mixin = ({
  props: {
    url: [Function, String],
    method: {
      type: [Function, String],
      default: 'POST'
    },
    fieldName: {
      type: [Function, String],
      default: file => file.name
    },
    headers: [Function, Array],
    formFields: [Function, Array],
    withCredentials: [Function, Boolean],
    sendRaw: [Function, Boolean],
    batch: [Function, Boolean],
    factory: Function
  },
  data() {
    return {
      xhrs: [],
      promises: [],
      workingThreads: 0
    };
  },
  computed: {
    xhrProps() {
      return {
        url: getFn(this.url),
        method: getFn(this.method),
        headers: getFn(this.headers),
        formFields: getFn(this.formFields),
        fieldName: getFn(this.fieldName),
        withCredentials: getFn(this.withCredentials),
        sendRaw: getFn(this.sendRaw),
        batch: getFn(this.batch)
      };
    },
    isUploading() {
      return this.workingThreads > 0;
    },
    isBusy() {
      return this.promises.length > 0;
    }
  },
  methods: {
    abort() {
      this.xhrs.forEach(x => {
        x.abort();
      });
      if (this.promises.length > 0) {
        this.abortPromises = true;
      }
    },
    upload() {
      if (this.canUpload === false) {
        return;
      }
      const queue = this.queuedFiles.slice(0);
      this.queuedFiles = [];
      if (this.xhrProps.batch(queue)) {
        this.__runFactory(queue);
      } else {
        queue.forEach(file => {
          this.__runFactory([file]);
        });
      }
    },
    __runFactory(files) {
      this.workingThreads++;
      if (typeof this.factory !== 'function') {
        this.__uploadFiles(files, {});
        return;
      }
      const res = this.factory(files);
      if (!res) {
        this.$emit('factory-failed', new Error('QUploader: factory() does not return properly'), files);
        this.workingThreads--;
      } else if (typeof res.catch === 'function' && typeof res.then === 'function') {
        this.promises.push(res);
        const failed = err => {
          if (this._isBeingDestroyed !== true && this._isDestroyed !== true) {
            this.promises = this.promises.filter(p => p !== res);
            if (this.promises.length === 0) {
              this.abortPromises = false;
            }
            this.queuedFiles = this.queuedFiles.concat(files);
            files.forEach(f => {
              this.__updateFile(f, 'failed');
            });
            this.$emit('factory-failed', err, files);
            this.workingThreads--;
          }
        };
        res.then(factory => {
          if (this.abortPromises === true) {
            failed(new Error('Aborted'));
          } else if (this._isBeingDestroyed !== true && this._isDestroyed !== true) {
            this.promises = this.promises.filter(p => p !== res);
            this.__uploadFiles(files, factory);
          }
        }).catch(failed);
      } else {
        this.__uploadFiles(files, res || {});
      }
    },
    __uploadFiles(files, factory) {
      const form = new FormData(),
        xhr = new XMLHttpRequest();
      const getProp = (name, arg) => {
        return factory[name] !== void 0 ? getFn(factory[name])(arg) : this.xhrProps[name](arg);
      };
      const url = getProp('url', files);
      if (!url) {
        console.error('q-uploader: invalid or no URL specified');
        this.workingThreads--;
        return;
      }
      const fields = getProp('formFields', files);
      fields !== void 0 && fields.forEach(field => {
        form.append(field.name, field.value);
      });
      let uploadIndex = 0,
        uploadIndexSize = 0,
        uploadedSize = 0,
        maxUploadSize = 0,
        aborted;
      xhr.upload.addEventListener('progress', e => {
        if (aborted === true) {
          return;
        }
        const loaded = Math.min(maxUploadSize, e.loaded);
        this.uploadedSize += loaded - uploadedSize;
        uploadedSize = loaded;
        let size = uploadedSize - uploadIndexSize;
        for (let i = uploadIndex; size > 0 && i < files.length; i++) {
          const file = files[i],
            uploaded = size > file.size;
          if (uploaded) {
            size -= file.size;
            uploadIndex++;
            uploadIndexSize += file.size;
            this.__updateFile(file, 'uploading', file.size);
          } else {
            this.__updateFile(file, 'uploading', size);
            return;
          }
        }
      }, false);
      xhr.onreadystatechange = () => {
        if (xhr.readyState < 4) {
          return;
        }
        if (xhr.status && xhr.status < 400) {
          this.uploadedFiles = this.uploadedFiles.concat(files);
          files.forEach(f => {
            this.__updateFile(f, 'uploaded');
          });
          this.$emit('uploaded', {
            files,
            xhr
          });
        } else {
          aborted = true;
          this.uploadedSize -= uploadedSize;
          this.queuedFiles = this.queuedFiles.concat(files);
          files.forEach(f => {
            this.__updateFile(f, 'failed');
          });
          this.$emit('failed', {
            files,
            xhr
          });
        }
        this.workingThreads--;
        this.xhrs = this.xhrs.filter(x => x !== xhr);
      };
      xhr.open(getProp('method', files), url);
      if (getProp('withCredentials', files) === true) {
        xhr.withCredentials = true;
      }
      const headers = getProp('headers', files);
      headers !== void 0 && headers.forEach(head => {
        xhr.setRequestHeader(head.name, head.value);
      });
      const sendRaw = getProp('sendRaw', files);
      files.forEach(file => {
        this.__updateFile(file, 'uploading', 0);
        if (sendRaw !== true) {
          form.append(getProp('fieldName', file), file, file.name);
        }
        file.xhr = xhr;
        file.__abort = () => {
          xhr.abort();
        };
        maxUploadSize += file.size;
      });
      this.$emit('uploading', {
        files,
        xhr
      });
      this.xhrs.push(xhr);
      if (sendRaw === true) {
        xhr.send(new Blob(files));
      } else {
        xhr.send(form);
      }
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/uploader/QUploader.js



/* harmony default export */ var QUploader = (external_vue_default.a.extend({
  name: 'QUploader',
  mixins: [QUploaderBase, uploader_xhr_mixin]
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/uploader/QUploaderAddTrigger.js

/* harmony default export */ var QUploaderAddTrigger = (external_vue_default.a.extend({
  name: 'QUploaderAddTrigger',
  inject: {
    __qUploaderGetInput: {
      default() {
        console.error('QUploaderAddTrigger needs to be child of QUploader');
      }
    }
  },
  render(h) {
    return this.__qUploaderGetInput(h);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/uploader/index.js




// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/video/QVideo.js



/* harmony default export */ var QVideo = (external_vue_default.a.extend({
  name: 'QVideo',
  mixins: [mixins_ratio, listeners["a" /* default */]],
  props: {
    src: {
      type: String,
      required: true
    },
    title: String,
    fetchpriority: {
      type: String,
      default: 'auto'
    },
    loading: {
      type: String,
      default: 'eager'
    },
    referrerpolicy: {
      type: String,
      default: 'strict-origin-when-cross-origin'
    }
  },
  computed: {
    iframeData() {
      return {
        attrs: {
          src: this.src,
          frameborder: '0',
          title: this.title,
          allowfullscreen: true,
          fetchpriority: this.fetchpriority,
          loading: this.loading,
          referrerpolicy: this.referrerpolicy
        }
      };
    },
    classes() {
      return 'q-video' + (this.ratio !== void 0 ? ' q-video--responsive' : '');
    }
  },
  render(h) {
    return h('div', {
      class: this.classes,
      style: this.ratioStyle,
      on: {
        ...this.qListeners
      }
    }, [h('iframe', this.iframeData)]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/video/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/virtual-scroll/index.js


// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components.js















































































// EXTERNAL MODULE: /workspace/node_modules/quasar/src/directives/ClosePopup.js
var ClosePopup = __webpack_require__("e106");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/GoBack.js


function GoBack_destroy(el) {
  const ctx = el.__qgoback;
  if (ctx !== void 0) {
    el.removeEventListener('click', ctx.goBack);
    el.removeEventListener('keyup', ctx.goBackKey);
    delete el.__qgoback;
  }
}
/* harmony default export */ var GoBack = ({
  name: 'go-back',
  bind(el, {
    value,
    modifiers
  }, vnode) {
    if (el.__qgoback !== void 0) {
      GoBack_destroy(el);
      el.__qgoback_destroyed = true;
    }
    const ctx = {
      value,
      position: window.history.length - 1,
      single: modifiers.single,
      goBack() {
        const router = vnode.context.$router;
        if (ctx.single === true) {
          router.go(-1);
        } else if (Platform["a" /* client */].is.nativeMobile === true) {
          router.go(ctx.position - window.history.length);
        } else {
          router.replace(ctx.value);
        }
      },
      goBackKey(e) {
        // if ENTER key
        Object(key_composition["a" /* isKeyCode */])(e, 13) === true && ctx.goBack();
      }
    };
    el.__qgoback = ctx;
    el.addEventListener('click', ctx.goBack);
    el.addEventListener('keyup', ctx.goBackKey);
  },
  update(el, {
    value,
    oldValue
  }) {
    const ctx = el.__qgoback;
    if (ctx !== void 0 && value !== oldValue) {
      ctx.value = value;
    }
  },
  unbind(el) {
    if (el.__qgoback_destroyed === void 0) {
      GoBack_destroy(el);
    } else {
      delete el.__qgoback_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/morph.js


let morph_id = 0;
let offsetBase = void 0;
function getAbsolutePosition(el, resize) {
  if (offsetBase === void 0) {
    offsetBase = document.createElement('div');
    offsetBase.style.cssText = 'position: absolute; left: 0; top: 0';
    document.body.appendChild(offsetBase);
  }
  const boundingRect = el.getBoundingClientRect();
  const baseRect = offsetBase.getBoundingClientRect();
  const {
    marginLeft,
    marginRight,
    marginTop,
    marginBottom
  } = window.getComputedStyle(el);
  const marginH = parseInt(marginLeft, 10) + parseInt(marginRight, 10);
  const marginV = parseInt(marginTop, 10) + parseInt(marginBottom, 10);
  return {
    left: boundingRect.left - baseRect.left,
    top: boundingRect.top - baseRect.top,
    width: boundingRect.right - boundingRect.left,
    height: boundingRect.bottom - boundingRect.top,
    widthM: boundingRect.right - boundingRect.left + (resize === true ? 0 : marginH),
    heightM: boundingRect.bottom - boundingRect.top + (resize === true ? 0 : marginV),
    marginH: resize === true ? marginH : 0,
    marginV: resize === true ? marginV : 0
  };
}
function getAbsoluteSize(el) {
  return {
    width: el.scrollWidth,
    height: el.scrollHeight
  };
}

// firefox rulez
const styleEdges = ['Top', 'Right', 'Bottom', 'Left'];
const styleBorderRadiuses = ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'];
const reStyleSkipKey = /-block|-inline|block-|inline-/;
const reStyleSkipRule = /(-block|-inline|block-|inline-).*:/;
function morph_getComputedStyle(el, props) {
  const style = window.getComputedStyle(el);
  const fixed = {};
  for (let i = 0; i < props.length; i++) {
    const prop = props[i];
    if (style[prop] === '') {
      if (prop === 'cssText') {
        const styleLen = style.length;
        let val = '';
        for (let i = 0; i < styleLen; i++) {
          if (reStyleSkipKey.test(style[i]) !== true) {
            val += style[i] + ': ' + style[style[i]] + '; ';
          }
        }
        fixed[prop] = val;
      } else if (['borderWidth', 'borderStyle', 'borderColor'].indexOf(prop) > -1) {
        const suffix = prop.replace('border', '');
        let val = '';
        for (let j = 0; j < styleEdges.length; j++) {
          const subProp = 'border' + styleEdges[j] + suffix;
          val += style[subProp] + ' ';
        }
        fixed[prop] = val;
      } else if (prop === 'borderRadius') {
        let val1 = '';
        let val2 = '';
        for (let j = 0; j < styleBorderRadiuses.length; j++) {
          const val = style[styleBorderRadiuses[j]].split(' ');
          val1 += val[0] + ' ';
          val2 += (val[1] === void 0 ? val[0] : val[1]) + ' ';
        }
        fixed[prop] = val1 + '/ ' + val2;
      } else {
        fixed[prop] = style[prop];
      }
    } else {
      if (prop === 'cssText') {
        fixed[prop] = style[prop].split(';').filter(val => reStyleSkipRule.test(val) !== true).join(';');
      } else {
        fixed[prop] = style[prop];
      }
    }
  }
  return fixed;
}
const zIndexPositions = ['absolute', 'fixed', 'relative', 'sticky'];
function getMaxZIndex(elStart) {
  let el = elStart;
  let maxIndex = 0;
  while (el !== null && el !== document) {
    const {
      position,
      zIndex
    } = window.getComputedStyle(el);
    const zIndexNum = Number(zIndex);
    if (zIndexNum > maxIndex && (el === elStart || zIndexPositions.includes(position) === true)) {
      maxIndex = zIndexNum;
    }
    el = el.parentNode;
  }
  return maxIndex;
}
function normalizeElements(opts) {
  return {
    from: opts.from,
    to: opts.to !== void 0 ? opts.to : opts.from
  };
}
function normalizeOptions(options) {
  if (typeof options === 'number') {
    options = {
      duration: options
    };
  } else if (typeof options === 'function') {
    options = {
      onEnd: options
    };
  }
  return {
    ...options,
    waitFor: options.waitFor === void 0 ? 0 : options.waitFor,
    duration: isNaN(options.duration) === true ? 300 : parseInt(options.duration, 10),
    easing: typeof options.easing === 'string' && options.easing.length > 0 ? options.easing : 'ease-in-out',
    delay: isNaN(options.delay) === true ? 0 : parseInt(options.delay, 10),
    fill: typeof options.fill === 'string' && options.fill.length > 0 ? options.fill : 'none',
    resize: options.resize === true,
    useCSS: options.useCSS === true || options.usecss === true,
    hideFromClone: options.hideFromClone === true || options.hidefromclone === true,
    keepToClone: options.keepToClone === true || options.keeptoclone === true,
    tween: options.tween === true,
    tweenFromOpacity: isNaN(options.tweenFromOpacity) === true ? 0.6 : parseFloat(options.tweenFromOpacity),
    tweenToOpacity: isNaN(options.tweenToOpacity) === true ? 0.5 : parseFloat(options.tweenToOpacity)
  };
}
function isValidElement(element) {
  return element && element.ownerDocument === document && element.parentNode !== null;
}
function morph(_options) {
  let cancel = () => false;
  let cancelStatus = false;
  let endElementTo = true;
  const elements = normalizeElements(_options);
  const options = normalizeOptions(_options);
  const elFrom = Object(dom["d" /* getElement */])(elements.from);
  if (isValidElement(elFrom) !== true) {
    // we return a cancel function that return false, meaning the cancel function failed
    return cancel;
  }
  // we clean other morphs running on this element
  typeof elFrom.qMorphCancel === 'function' && elFrom.qMorphCancel();
  let animationFromClone = void 0;
  let animationFromTween = void 0;
  let animationToClone = void 0;
  let animationTo = void 0;
  const elFromParent = elFrom.parentNode;
  const elFromNext = elFrom.nextElementSibling;

  // we get the dimensions and characteristics
  // of the parent of the initial element before changes
  const elFromPosition = getAbsolutePosition(elFrom, options.resize);
  const {
    width: elFromParentWidthBefore,
    height: elFromParentHeightBefore
  } = getAbsoluteSize(elFromParent);
  const {
    borderWidth: elFromBorderWidth,
    borderStyle: elFromBorderStyle,
    borderColor: elFromBorderColor,
    borderRadius: elFromBorderRadius,
    backgroundColor: elFromBackground,
    transform: elFromTransform,
    position: elFromPositioningType,
    cssText: elFromCssText
  } = morph_getComputedStyle(elFrom, ['borderWidth', 'borderStyle', 'borderColor', 'borderRadius', 'backgroundColor', 'transform', 'position', 'cssText']);
  const elFromClassSaved = elFrom.classList.toString();
  const elFromStyleSaved = elFrom.style.cssText;

  // we make a clone of the initial element and
  // use it to display until the final element is ready
  // and to change the occupied space during animation
  const elFromClone = elFrom.cloneNode(true);
  const elFromTween = options.tween === true ? elFrom.cloneNode(true) : void 0;
  if (elFromTween !== void 0) {
    elFromTween.className = elFromTween.classList.toString().split(' ').filter(c => /^bg-/.test(c) === false).join(' ');
  }

  // if the initial element is not going to be removed do not show the placeholder
  options.hideFromClone === true && elFromClone.classList.add('q-morph--internal');

  // prevent interaction with placeholder
  elFromClone.setAttribute('aria-hidden', 'true');
  elFromClone.style.transition = 'none';
  elFromClone.style.animation = 'none';
  elFromClone.style.pointerEvents = 'none';
  elFromParent.insertBefore(elFromClone, elFromNext);

  // we mark the element with its cleanup function
  elFrom.qMorphCancel = () => {
    cancelStatus = true;

    // we clean the clone of the initial element
    elFromClone.remove();
    elFromTween !== void 0 && elFromTween.remove();
    options.hideFromClone === true && elFromClone.classList.remove('q-morph--internal');

    // we remove the cleanup function from the element
    elFrom.qMorphCancel = void 0;
  };

  // will be called after Vue catches up with the changes done by _options.onToggle() function
  const calculateFinalState = () => {
    const elTo = Object(dom["d" /* getElement */])(elements.to);
    if (cancelStatus === true || isValidElement(elTo) !== true) {
      typeof elFrom.qMorphCancel === 'function' && elFrom.qMorphCancel();
      return;
    }
    // we clean other morphs running on this element
    elFrom !== elTo && typeof elTo.qMorphCancel === 'function' && elTo.qMorphCancel();

    // we hide the final element and the clone of the initial element
    // we don't hide the final element if we want both it and the animated one visible
    options.keepToClone !== true && elTo.classList.add('q-morph--internal');
    elFromClone.classList.add('q-morph--internal');

    // we get the dimensions of the parent of the initial element after changes
    // the difference is how much we should animate the clone
    const {
      width: elFromParentWidthAfter,
      height: elFromParentHeightAfter
    } = getAbsoluteSize(elFromParent);

    // we get the dimensions of the parent of the final element before changes
    const {
      width: elToParentWidthBefore,
      height: elToParentHeightBefore
    } = getAbsoluteSize(elTo.parentNode);

    // then we show the clone of the initial element if we don't want it hidden
    options.hideFromClone !== true && elFromClone.classList.remove('q-morph--internal');

    // we mark the element with its cleanup function
    elTo.qMorphCancel = () => {
      cancelStatus = true;

      // we clean the clone of the initial element
      elFromClone.remove();
      elFromTween !== void 0 && elFromTween.remove();
      options.hideFromClone === true && elFromClone.classList.remove('q-morph--internal');

      // we show the final element
      options.keepToClone !== true && elTo.classList.remove('q-morph--internal');

      // we remove the cleanup function from the elements
      elFrom.qMorphCancel = void 0;
      elTo.qMorphCancel = void 0;
    };

    // will be called after waitFor (give time to render the final element)
    const animate = () => {
      if (cancelStatus === true) {
        typeof elTo.qMorphCancel === 'function' && elTo.qMorphCancel();
        return;
      }

      // now the animation starts, so we only need the clone
      // of the initial element as a spacer
      // we also hide it to calculate the dimensions of the
      // parent of the final element after the changes
      if (options.hideFromClone !== true) {
        elFromClone.classList.add('q-morph--internal');
        elFromClone.innerHTML = '';
        elFromClone.style.left = 0;
        elFromClone.style.right = 'unset';
        elFromClone.style.top = 0;
        elFromClone.style.bottom = 'unset';
        elFromClone.style.transform = 'none';
      }

      // we show the final element
      if (options.keepToClone !== true) {
        elTo.classList.remove('q-morph--internal');
      }

      // we get the dimensions of the parent of the final element after changes
      // the difference is how much we should animate the clone
      const elToParent = elTo.parentNode;
      const {
        width: elToParentWidthAfter,
        height: elToParentHeightAfter
      } = getAbsoluteSize(elToParent);
      const elToClone = elTo.cloneNode(options.keepToClone);
      elToClone.setAttribute('aria-hidden', 'true');
      if (options.keepToClone !== true) {
        elToClone.style.left = 0;
        elToClone.style.right = 'unset';
        elToClone.style.top = 0;
        elToClone.style.bottom = 'unset';
        elToClone.style.transform = 'none';
        elToClone.style.pointerEvents = 'none';
      }
      elToClone.classList.add('q-morph--internal');

      // if elFrom is the same as elTo the next element is elFromClone
      const elToNext = elTo === elFrom && elFromParent === elToParent ? elFromClone : elTo.nextElementSibling;
      elToParent.insertBefore(elToClone, elToNext);
      const {
        borderWidth: elToBorderWidth,
        borderStyle: elToBorderStyle,
        borderColor: elToBorderColor,
        borderRadius: elToBorderRadius,
        backgroundColor: elToBackground,
        transform: elToTransform,
        position: elToPositioningType,
        cssText: elToCssText
      } = morph_getComputedStyle(elTo, ['borderWidth', 'borderStyle', 'borderColor', 'borderRadius', 'backgroundColor', 'transform', 'position', 'cssText']);
      const elToClassSaved = elTo.classList.toString();
      const elToStyleSaved = elTo.style.cssText;

      // we set the computed styles on the element (to be able to remove classes)
      elTo.style.cssText = elToCssText;
      elTo.style.transform = 'none';
      elTo.style.animation = 'none';
      elTo.style.transition = 'none';
      // we strip the background classes (background color can no longer be animated if !important is used)
      elTo.className = elToClassSaved.split(' ').filter(c => /^bg-/.test(c) === false).join(' ');
      const elToPosition = getAbsolutePosition(elTo, options.resize);
      const deltaX = elFromPosition.left - elToPosition.left;
      const deltaY = elFromPosition.top - elToPosition.top;
      const scaleX = elFromPosition.width / (elToPosition.width > 0 ? elToPosition.width : 10);
      const scaleY = elFromPosition.height / (elToPosition.height > 0 ? elToPosition.height : 100);
      const elFromParentWidthDiff = elFromParentWidthBefore - elFromParentWidthAfter;
      const elFromParentHeightDiff = elFromParentHeightBefore - elFromParentHeightAfter;
      const elToParentWidthDiff = elToParentWidthAfter - elToParentWidthBefore;
      const elToParentHeightDiff = elToParentHeightAfter - elToParentHeightBefore;
      const elFromCloneWidth = Math.max(elFromPosition.widthM, elFromParentWidthDiff);
      const elFromCloneHeight = Math.max(elFromPosition.heightM, elFromParentHeightDiff);
      const elToCloneWidth = Math.max(elToPosition.widthM, elToParentWidthDiff);
      const elToCloneHeight = Math.max(elToPosition.heightM, elToParentHeightDiff);
      const elSharedSize = elFrom === elTo && ['absolute', 'fixed'].includes(elToPositioningType) === false && ['absolute', 'fixed'].includes(elFromPositioningType) === false;

      // if the final element has fixed position or if a parent
      // has fixed position we need to animate it as fixed
      let elToNeedsFixedPosition = elToPositioningType === 'fixed';
      let parent = elToParent;
      while (elToNeedsFixedPosition !== true && parent !== document) {
        elToNeedsFixedPosition = window.getComputedStyle(parent).position === 'fixed';
        parent = parent.parentNode;
      }

      // we show the spacer for the initial element
      if (options.hideFromClone !== true) {
        elFromClone.style.display = 'block';
        elFromClone.style.flex = '0 0 auto';
        elFromClone.style.opacity = 0;
        elFromClone.style.minWidth = 'unset';
        elFromClone.style.maxWidth = 'unset';
        elFromClone.style.minHeight = 'unset';
        elFromClone.style.maxHeight = 'unset';
        elFromClone.classList.remove('q-morph--internal');
      }

      // we show the spacer for the final element
      if (options.keepToClone !== true) {
        elToClone.style.display = 'block';
        elToClone.style.flex = '0 0 auto';
        elToClone.style.opacity = 0;
        elToClone.style.minWidth = 'unset';
        elToClone.style.maxWidth = 'unset';
        elToClone.style.minHeight = 'unset';
        elToClone.style.maxHeight = 'unset';
      }
      elToClone.classList.remove('q-morph--internal');

      // we apply classes specified by user
      if (typeof options.classes === 'string') {
        elTo.className += ' ' + options.classes;
      }

      // we apply styles specified by user
      if (typeof options.style === 'string') {
        elTo.style.cssText += ' ' + options.style;
      } else if (Object(is["d" /* isObject */])(options.style) === true) {
        for (const prop in options.style) {
          elTo.style[prop] = options.style[prop];
        }
      }
      const elFromZIndex = getMaxZIndex(elFromClone);
      const elToZIndex = getMaxZIndex(elTo);

      // we position the morphing element
      // if we use fixed position for the final element we need to adjust for scroll
      const documentScroll = elToNeedsFixedPosition === true ? document.documentElement : {
        scrollLeft: 0,
        scrollTop: 0
      };
      elTo.style.position = elToNeedsFixedPosition === true ? 'fixed' : 'absolute';
      elTo.style.left = `${elToPosition.left - documentScroll.scrollLeft}px`;
      elTo.style.right = 'unset';
      elTo.style.top = `${elToPosition.top - documentScroll.scrollTop}px`;
      elTo.style.margin = 0;
      if (options.resize === true) {
        elTo.style.minWidth = 'unset';
        elTo.style.maxWidth = 'unset';
        elTo.style.minHeight = 'unset';
        elTo.style.maxHeight = 'unset';
        elTo.style.overflow = 'hidden';
        elTo.style.overflowX = 'hidden';
        elTo.style.overflowY = 'hidden';
      }
      document.body.appendChild(elTo);
      if (elFromTween !== void 0) {
        elFromTween.style.cssText = elFromCssText;
        elFromTween.style.transform = 'none';
        elFromTween.style.animation = 'none';
        elFromTween.style.transition = 'none';
        elFromTween.style.position = elTo.style.position;
        elFromTween.style.left = `${elFromPosition.left - documentScroll.scrollLeft}px`;
        elFromTween.style.right = 'unset';
        elFromTween.style.top = `${elFromPosition.top - documentScroll.scrollTop}px`;
        elFromTween.style.margin = 0;
        elFromTween.style.pointerEvents = 'none';
        if (options.resize === true) {
          elFromTween.style.minWidth = 'unset';
          elFromTween.style.maxWidth = 'unset';
          elFromTween.style.minHeight = 'unset';
          elFromTween.style.maxHeight = 'unset';
          elFromTween.style.overflow = 'hidden';
          elFromTween.style.overflowX = 'hidden';
          elFromTween.style.overflowY = 'hidden';
        }
        document.body.appendChild(elFromTween);
      }
      const commonCleanup = aborted => {
        // we put the element back in it's place
        // and restore the styles and classes
        if (elFrom === elTo && endElementTo !== true) {
          elTo.style.cssText = elFromStyleSaved;
          elTo.className = elFromClassSaved;
        } else {
          elTo.style.cssText = elToStyleSaved;
          elTo.className = elToClassSaved;
        }
        elToClone.parentNode === elToParent && elToParent.insertBefore(elTo, elToClone);

        // we clean the spacers
        elFromClone.remove();
        elToClone.remove();
        elFromTween !== void 0 && elFromTween.remove();

        // cancel will be no longer available
        cancel = () => false;
        elFrom.qMorphCancel = void 0;
        elTo.qMorphCancel = void 0;

        // we are ready
        if (typeof options.onEnd === 'function') {
          options.onEnd(endElementTo === true ? 'to' : 'from', aborted === true);
        }
      };
      if (options.useCSS !== true && typeof elTo.animate === 'function') {
        const resizeFrom = options.resize === true ? {
          transform: `translate(${deltaX}px, ${deltaY}px)`,
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {
          transform: `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`
        };
        const resizeTo = options.resize === true ? {
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {};
        const resizeFromTween = options.resize === true ? {
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {};
        const resizeToTween = options.resize === true ? {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px)`,
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY})`
        };
        const tweenFrom = elFromTween !== void 0 ? {
          opacity: options.tweenToOpacity
        } : {
          backgroundColor: elFromBackground
        };
        const tweenTo = elFromTween !== void 0 ? {
          opacity: 1
        } : {
          backgroundColor: elToBackground
        };
        animationTo = elTo.animate([{
          margin: 0,
          borderWidth: elFromBorderWidth,
          borderStyle: elFromBorderStyle,
          borderColor: elFromBorderColor,
          borderRadius: elFromBorderRadius,
          zIndex: elFromZIndex,
          transformOrigin: '0 0',
          ...resizeFrom,
          ...tweenFrom
        }, {
          margin: 0,
          borderWidth: elToBorderWidth,
          borderStyle: elToBorderStyle,
          borderColor: elToBorderColor,
          borderRadius: elToBorderRadius,
          zIndex: elToZIndex,
          transformOrigin: '0 0',
          transform: elToTransform,
          ...resizeTo,
          ...tweenTo
        }], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromTween = elFromTween === void 0 ? void 0 : elFromTween.animate([{
          opacity: options.tweenFromOpacity,
          margin: 0,
          borderWidth: elFromBorderWidth,
          borderStyle: elFromBorderStyle,
          borderColor: elFromBorderColor,
          borderRadius: elFromBorderRadius,
          zIndex: elFromZIndex,
          transformOrigin: '0 0',
          transform: elFromTransform,
          ...resizeFromTween
        }, {
          opacity: 0,
          margin: 0,
          borderWidth: elToBorderWidth,
          borderStyle: elToBorderStyle,
          borderColor: elToBorderColor,
          borderRadius: elToBorderRadius,
          zIndex: elToZIndex,
          transformOrigin: '0 0',
          ...resizeToTween
        }], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromClone = options.hideFromClone === true || elSharedSize === true ? void 0 : elFromClone.animate([{
          margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
          width: `${elFromCloneWidth + elFromPosition.marginH}px`,
          height: `${elFromCloneHeight + elFromPosition.marginV}px`
        }, {
          margin: 0,
          width: 0,
          height: 0
        }], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationToClone = options.keepToClone === true ? void 0 : elToClone.animate([elSharedSize === true ? {
          margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
          width: `${elFromCloneWidth + elFromPosition.marginH}px`,
          height: `${elFromCloneHeight + elFromPosition.marginV}px`
        } : {
          margin: 0,
          width: 0,
          height: 0
        }, {
          margin: `${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px`,
          width: `${elToCloneWidth + elToPosition.marginH}px`,
          height: `${elToCloneHeight + elToPosition.marginV}px`
        }], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        const cleanup = abort => {
          animationFromClone !== void 0 && animationFromClone.cancel();
          animationFromTween !== void 0 && animationFromTween.cancel();
          animationToClone !== void 0 && animationToClone.cancel();
          animationTo.cancel();
          animationTo.removeEventListener('finish', cleanup);
          animationTo.removeEventListener('cancel', cleanup);
          commonCleanup(abort);

          // we clean the animations
          animationFromClone = void 0;
          animationFromTween = void 0;
          animationToClone = void 0;
          animationTo = void 0;
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        animationTo.addEventListener('finish', cleanup);
        animationTo.addEventListener('cancel', cleanup);
        cancel = abort => {
          // we are not in a morph that we can cancel
          if (cancelStatus === true || animationTo === void 0) {
            return false;
          }
          if (abort === true) {
            cleanup(true);
            return true;
          }
          endElementTo = endElementTo !== true;
          animationFromClone !== void 0 && animationFromClone.reverse();
          animationFromTween !== void 0 && animationFromTween.reverse();
          animationToClone !== void 0 && animationToClone.reverse();
          animationTo.reverse();
          return true;
        };
      } else {
        const qAnimId = `q-morph-anim-${++morph_id}`;
        const style = document.createElement('style');
        const resizeFrom = options.resize === true ? `
            transform: translate(${deltaX}px, ${deltaY}px);
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : `transform: translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY});`;
        const resizeTo = options.resize === true ? `
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : '';
        const resizeFromTween = options.resize === true ? `
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : '';
        const resizeToTween = options.resize === true ? `
            transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px);
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : `transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY});`;
        const tweenFrom = elFromTween !== void 0 ? `opacity: ${options.tweenToOpacity};` : `background-color: ${elFromBackground};`;
        const tweenTo = elFromTween !== void 0 ? 'opacity: 1;' : `background-color: ${elToBackground};`;
        const keyframesFromTween = elFromTween === void 0 ? '' : `
            @keyframes ${qAnimId}-from-tween {
              0% {
                opacity: ${options.tweenFromOpacity};
                margin: 0;
                border-width: ${elFromBorderWidth};
                border-style: ${elFromBorderStyle};
                border-color: ${elFromBorderColor};
                border-radius: ${elFromBorderRadius};
                z-index: ${elFromZIndex};
                transform-origin: 0 0;
                transform: ${elFromTransform};
                ${resizeFromTween}
              }

              100% {
                opacity: 0;
                margin: 0;
                border-width: ${elToBorderWidth};
                border-style: ${elToBorderStyle};
                border-color: ${elToBorderColor};
                border-radius: ${elToBorderRadius};
                z-index: ${elToZIndex};
                transform-origin: 0 0;
                ${resizeToTween}
              }
            }
          `;
        const keyframesFrom = options.hideFromClone === true || elSharedSize === true ? '' : `
            @keyframes ${qAnimId}-from {
              0% {
                margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
                width: ${elFromCloneWidth + elFromPosition.marginH}px;
                height: ${elFromCloneHeight + elFromPosition.marginV}px;
              }

              100% {
                margin: 0;
                width: 0;
                height: 0;
              }
            }
          `;
        const keyframeToStart = elSharedSize === true ? `
            margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
            width: ${elFromCloneWidth + elFromPosition.marginH}px;
            height: ${elFromCloneHeight + elFromPosition.marginV}px;
          ` : `
            margin: 0;
            width: 0;
            height: 0;
          `;
        const keyframesTo = options.keepToClone === true ? '' : `
            @keyframes ${qAnimId}-to {
              0% {
                ${keyframeToStart}
              }

              100% {
                margin: ${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px;
                width: ${elToCloneWidth + elToPosition.marginH}px;
                height: ${elToCloneHeight + elToPosition.marginV}px;
              }
            }
          `;
        style.innerHTML = `
          @keyframes ${qAnimId} {
            0% {
              margin: 0;
              border-width: ${elFromBorderWidth};
              border-style: ${elFromBorderStyle};
              border-color: ${elFromBorderColor};
              border-radius: ${elFromBorderRadius};
              background-color: ${elFromBackground};
              z-index: ${elFromZIndex};
              transform-origin: 0 0;
              ${resizeFrom}
              ${tweenFrom}
            }

            100% {
              margin: 0;
              border-width: ${elToBorderWidth};
              border-style: ${elToBorderStyle};
              border-color: ${elToBorderColor};
              border-radius: ${elToBorderRadius};
              background-color: ${elToBackground};
              z-index: ${elToZIndex};
              transform-origin: 0 0;
              transform: ${elToTransform};
              ${resizeTo}
              ${tweenTo}
            }
          }

          ${keyframesFrom}

          ${keyframesFromTween}

          ${keyframesTo}
        `;
        document.head.appendChild(style);
        let animationDirection = 'normal';
        elFromClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from`;
        if (elFromTween !== void 0) {
          elFromTween.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from-tween`;
        }
        elToClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-to`;
        elTo.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}`;
        const cleanup = evt => {
          if (evt === Object(evt) && evt.animationName !== qAnimId) {
            return;
          }
          elTo.removeEventListener('animationend', cleanup);
          elTo.removeEventListener('animationcancel', cleanup);
          commonCleanup();

          // we clean the animations
          style.remove();
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.addEventListener('animationend', cleanup);
        elTo.addEventListener('animationcancel', cleanup);
        cancel = abort => {
          // we are not in a morph that we can cancel
          if (cancelStatus === true || !elTo || !elFromClone || !elToClone) {
            return false;
          }
          if (abort === true) {
            cleanup();
            return true;
          }
          endElementTo = endElementTo !== true;
          animationDirection = animationDirection === 'normal' ? 'reverse' : 'normal';
          elFromClone.style.animationDirection = animationDirection;
          elFromTween.style.animationDirection = animationDirection;
          elToClone.style.animationDirection = animationDirection;
          elTo.style.animationDirection = animationDirection;
          return true;
        };
      }
    };
    if (options.waitFor > 0 || options.waitFor === 'transitionend' || options.waitFor === Object(options.waitFor) && typeof options.waitFor.then === 'function') {
      const delayPromise = options.waitFor > 0 ? new Promise(resolve => setTimeout(resolve, options.waitFor)) : options.waitFor === 'transitionend' ? new Promise(resolve => {
        const timer = setTimeout(() => {
          endFn();
        }, 400);
        const endFn = ev => {
          clearTimeout(timer);
          if (elTo) {
            elTo.removeEventListener('transitionend', endFn);
            elTo.removeEventListener('transitioncancel', endFn);
          }
          resolve();
        };
        elTo.addEventListener('transitionend', endFn);
        elTo.addEventListener('transitioncancel', endFn);
      }) : options.waitFor;
      delayPromise.then(animate).catch(() => {
        typeof elTo.qMorphCancel === 'function' && elTo.qMorphCancel();
      });
    } else {
      animate();
    }
  };
  typeof _options.onToggle === 'function' && _options.onToggle();
  requestAnimationFrame(calculateFinalState);

  // we return the cancel function
  // returns:
  //   false if the cancel cannot be performed (the morph ended already or has not started)
  //   true else
  return abort => cancel(abort);
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/Morph.js

const morphGroups = {};
const Morph_props = ['duration', 'delay', 'easing', 'fill', 'classes', 'style', 'duration', 'resize', 'useCSS', 'hideFromClone', 'keepToClone', 'tween', 'tweenFromOpacity', 'tweenToOpacity', 'waitFor', 'onEnd'];
const mods = ['resize', 'useCSS', 'hideFromClone', 'keepToClone', 'tween'];
function changeClass(ctx, action) {
  if (ctx.clsAction !== action) {
    ctx.clsAction = action;
    ctx.el.classList[action]('q-morph--invisible');
  }
}
function trigger(group) {
  if (group.animating === true || group.queue.length < 2) {
    return;
  }
  const [from, to] = group.queue;
  group.animating = true;
  from.animating = true;
  to.animating = true;
  changeClass(from, 'remove');
  changeClass(to, 'remove');
  const cancelFn = morph({
    from: from.el,
    to: to.el,
    onToggle() {
      changeClass(from, 'add');
      changeClass(to, 'remove');
    },
    ...to.opts,
    onEnd(dir, aborted) {
      to.opts.onEnd !== void 0 && to.opts.onEnd(dir, aborted);
      if (aborted === true) {
        return;
      }
      from.animating = false;
      to.animating = false;
      group.animating = false;
      group.cancel = void 0;
      group.queue.shift();
      trigger(group);
    }
  });
  group.cancel = () => {
    cancelFn(true); // abort
    group.cancel = void 0;
  };
}
function updateModifiers(mod, ctx) {
  const opts = ctx.opts;
  mods.forEach(name => {
    opts[name] = mod[name] === true;
  });
}
function insertArgs(arg, ctx) {
  const opts = typeof arg === 'string' && arg.length > 0 ? arg.split(':') : [];
  ctx.name = opts[0];
  ctx.group = opts[1];
  Object.assign(ctx.opts, {
    duration: isNaN(opts[2]) === true ? 300 : parseFloat(opts[2]),
    waitFor: opts[3]
  });
}
function updateArgs(arg, ctx) {
  if (arg.group !== void 0) {
    ctx.group = arg.group;
  }
  if (arg.name !== void 0) {
    ctx.name = arg.name;
  }
  const opts = ctx.opts;
  Morph_props.forEach(name => {
    if (arg[name] !== void 0) {
      opts[name] = arg[name];
    }
  });
}
function Morph_updateModel(name, ctx) {
  if (ctx.name === name) {
    const group = morphGroups[ctx.group];

    // if group is not registered
    if (group === void 0) {
      morphGroups[ctx.group] = {
        name: ctx.group,
        model: name,
        queue: [ctx],
        animating: false
      };
      changeClass(ctx, 'remove');
    }
    // if model changed
    else if (group.model !== name) {
      group.model = name;
      group.queue.push(ctx);
      if (group.animating === false && group.queue.length === 2) {
        trigger(group);
      }
    }
    return;
  }
  if (ctx.animating === false) {
    changeClass(ctx, 'add');
  }
}
function updateValue(ctx, value) {
  let model;
  if (Object(value) === value) {
    model = '' + value.model;
    updateArgs(value, ctx);
    updateModifiers(value, ctx);
  } else {
    model = '' + value;
  }
  if (model !== ctx.model) {
    ctx.model = model;
    Morph_updateModel(model, ctx);
  } else if (ctx.animating === false && ctx.clsAction !== void 0) {
    // ensure HMR
    ctx.el.classList[ctx.clsAction]('q-morph--invisible');
  }
}
function Morph_destroy(el) {
  const ctx = el.__qmorph;
  if (ctx !== void 0) {
    const group = morphGroups[ctx.group];
    if (group !== void 0) {
      const index = group.queue.indexOf(ctx);
      if (index !== -1) {
        group.queue = group.queue.filter(item => item !== ctx);
        if (group.queue.length === 0) {
          group.cancel !== void 0 && group.cancel();
          delete morphGroups[ctx.group];
        }
      }
    }
    if (ctx.clsAction === 'add') {
      el.classList.remove('q-morph--invisible');
    }
    delete el.__qmorph;
  }
}
/* harmony default export */ var Morph = ({
  name: 'morph',
  inserted(el, binding) {
    if (el.__qmorph !== void 0) {
      Morph_destroy(el);
      el.__qmorph_destroyed = true;
    }
    const ctx = {
      el,
      animating: false,
      opts: {}
    };
    updateModifiers(binding.modifiers, ctx);
    insertArgs(binding.arg, ctx);
    updateValue(ctx, binding.value);
    el.__qmorph = ctx;
  },
  update(el, binding) {
    const ctx = el.__qmorph;
    ctx !== void 0 && updateValue(ctx, binding.value);
  },
  unbind(el) {
    if (el.__qmorph_destroyed === void 0) {
      Morph_destroy(el);
    } else {
      delete el.__qmorph_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/Mutation.js
const Mutation_defaultCfg = {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true,
  attributeOldValue: true,
  characterDataOldValue: true
};
function Mutation_update(el, ctx, value) {
  ctx.handler = value;
  ctx.observer !== void 0 && ctx.observer.disconnect();
  ctx.observer = new MutationObserver(list => {
    if (typeof ctx.handler === 'function') {
      const res = ctx.handler(list);
      if (res === false || ctx.once === true) {
        Mutation_destroy(el);
      }
    }
  });
  ctx.observer.observe(el, ctx.opts);
}
function Mutation_destroy(el) {
  const ctx = el.__qmutation;
  if (ctx !== void 0) {
    ctx.observer !== void 0 && ctx.observer.disconnect();
    delete el.__qmutation;
  }
}
/* harmony default export */ var Mutation = ({
  name: 'mutation',
  inserted(el, {
    modifiers: {
      once,
      ...mod
    },
    value
  }) {
    if (el.__qmutation !== void 0) {
      Mutation_destroy(el);
      el.__qmutation_destroyed = true;
    }
    const ctx = {
      once,
      opts: Object.keys(mod).length === 0 ? Mutation_defaultCfg : mod
    };
    Mutation_update(el, ctx, value);
    el.__qmutation = ctx;
  },
  update(el, {
    oldValue,
    value
  }) {
    const ctx = el.__qmutation;
    if (ctx !== void 0 && oldValue !== value) {
      Mutation_update(el, ctx, value);
    }
  },
  unbind(el) {
    if (el.__qmutation_destroyed === void 0) {
      Mutation_destroy(el);
    } else {
      delete el.__qmutation_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/ScrollFire.js




function ScrollFire_update(ctx, {
  value,
  oldValue
}) {
  if (typeof value !== 'function') {
    ctx.scrollTarget.removeEventListener('scroll', ctx.scroll, utils_event["f" /* listenOpts */].passive);
    return;
  }
  ctx.handler = value;
  if (typeof oldValue !== 'function') {
    ctx.scrollTarget.addEventListener('scroll', ctx.scroll, utils_event["f" /* listenOpts */].passive);
    ctx.scroll();
  }
}
function ScrollFire_destroy(el) {
  const ctx = el.__qscrollfire;
  if (ctx !== void 0) {
    ctx.scrollTarget.removeEventListener('scroll', ctx.scroll, utils_event["f" /* listenOpts */].passive);
    ctx.scroll.cancel();
    delete el.__qscrollfire;
  }
}
/* harmony default export */ var ScrollFire = ({
  name: 'scroll-fire',
  inserted(el, binding) {
    if (el.__qscrollfire !== void 0) {
      ScrollFire_destroy(el);
      el.__qscrollfire_destroyed = true;
    }
    const ctx = {
      scrollTarget: Object(utils_scroll["d" /* getScrollTarget */])(el),
      scroll: Object(debounce["a" /* default */])(() => {
        let containerBottom, elBottom;
        if (ctx.scrollTarget === window) {
          elBottom = el.getBoundingClientRect().bottom;
          containerBottom = window.innerHeight;
        } else {
          elBottom = Object(dom["f" /* offset */])(el).top + Object(dom["e" /* height */])(el);
          containerBottom = Object(dom["f" /* offset */])(ctx.scrollTarget).top + Object(dom["e" /* height */])(ctx.scrollTarget);
        }
        if (elBottom > 0 && elBottom < containerBottom) {
          ctx.scrollTarget.removeEventListener('scroll', ctx.scroll, utils_event["f" /* listenOpts */].passive);
          ctx.handler(el);
        }
      }, 25)
    };
    ScrollFire_update(ctx, binding);
    el.__qscrollfire = ctx;
  },
  update(el, binding) {
    if (el.__qscrollfire !== void 0 && binding.value !== binding.oldValue) {
      ScrollFire_update(el.__qscrollfire, binding);
    }
  },
  unbind(el) {
    if (el.__qscrollfire_destroyed === void 0) {
      ScrollFire_destroy(el);
    } else {
      delete el.__qscrollfire_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/Scroll.js


function Scroll_update(ctx, {
  value,
  oldValue
}) {
  if (typeof value !== 'function') {
    ctx.scrollTarget.removeEventListener('scroll', ctx.scroll, utils_event["f" /* listenOpts */].passive);
    return;
  }
  ctx.handler = value;
  if (typeof oldValue !== 'function') {
    ctx.scrollTarget.addEventListener('scroll', ctx.scroll, utils_event["f" /* listenOpts */].passive);
  }
}
function Scroll_destroy(el) {
  const ctx = el.__qscroll;
  if (ctx !== void 0) {
    ctx.scrollTarget.removeEventListener('scroll', ctx.scroll, utils_event["f" /* listenOpts */].passive);
    delete el.__qscroll;
  }
}
/* harmony default export */ var Scroll = ({
  name: 'scroll',
  inserted(el, binding) {
    if (el.__qscroll !== void 0) {
      Scroll_destroy(el);
      el.__qscroll_destroyed = true;
    }
    const ctx = {
      scrollTarget: Object(utils_scroll["d" /* getScrollTarget */])(el),
      scroll() {
        ctx.handler(Object(utils_scroll["f" /* getVerticalScrollPosition */])(ctx.scrollTarget), Object(utils_scroll["a" /* getHorizontalScrollPosition */])(ctx.scrollTarget));
      }
    };
    Scroll_update(ctx, binding);
    el.__qscroll = ctx;
  },
  update(el, binding) {
    if (el.__qscroll !== void 0 && binding.oldValue !== binding.value) {
      Scroll_update(el.__qscroll, binding);
    }
  },
  unbind(el) {
    if (el.__qscroll_destroyed === void 0) {
      Scroll_destroy(el);
    } else {
      delete el.__qscroll_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/TouchHold.js



function TouchHold_destroy(el) {
  const ctx = el.__qtouchhold;
  if (ctx !== void 0) {
    Object(utils_event["b" /* cleanEvt */])(ctx, 'main');
    Object(utils_event["b" /* cleanEvt */])(ctx, 'temp');
    clearTimeout(ctx.timer);
    ctx.styleCleanup !== void 0 && ctx.styleCleanup();
    delete el.__qtouchhold;
  }
}
/* harmony default export */ var TouchHold = ({
  name: 'touch-hold',
  bind(el, binding) {
    if (el.__qtouchhold !== void 0) {
      TouchHold_destroy(el);
      el.__qtouchhold_destroyed = true;
    }
    const {
      modifiers
    } = binding;

    // early return, we don't need to do anything
    if (modifiers.mouse !== true && Platform["a" /* client */].has.touch !== true) {
      return;
    }
    const ctx = {
      handler: binding.value,
      noop: utils_event["g" /* noop */],
      mouseStart(evt) {
        if (typeof ctx.handler === 'function' && Object(utils_event["e" /* leftClick */])(evt) === true) {
          Object(utils_event["a" /* addEvt */])(ctx, 'temp', [[document, 'mousemove', 'move', 'passiveCapture'], [document, 'click', 'end', 'notPassiveCapture']]);
          ctx.start(evt, true);
        }
      },
      touchStart(evt) {
        if (evt.target !== void 0 && typeof ctx.handler === 'function') {
          const target = evt.target;
          Object(utils_event["a" /* addEvt */])(ctx, 'temp', [[target, 'touchmove', 'move', 'passiveCapture'], [target, 'touchcancel', 'end', 'notPassiveCapture'], [target, 'touchend', 'end', 'notPassiveCapture']]);
          ctx.start(evt);
        }
      },
      start(evt, mouseEvent) {
        ctx.origin = Object(utils_event["h" /* position */])(evt);
        const startTime = Date.now();
        if (Platform["a" /* client */].is.mobile === true) {
          document.body.classList.add('non-selectable');
          Object(selection["a" /* clearSelection */])();
          ctx.styleCleanup = withDelay => {
            ctx.styleCleanup = void 0;
            const remove = () => {
              document.body.classList.remove('non-selectable');
            };
            if (withDelay === true) {
              Object(selection["a" /* clearSelection */])();
              setTimeout(remove, 10);
            } else {
              remove();
            }
          };
        }
        ctx.triggered = false;
        ctx.sensitivity = mouseEvent === true ? ctx.mouseSensitivity : ctx.touchSensitivity;
        ctx.timer = setTimeout(() => {
          Object(selection["a" /* clearSelection */])();
          ctx.triggered = true;
          ctx.handler({
            evt,
            touch: mouseEvent !== true,
            mouse: mouseEvent === true,
            position: ctx.origin,
            duration: Date.now() - startTime
          });
        }, ctx.duration);
      },
      move(evt) {
        const {
          top,
          left
        } = Object(utils_event["h" /* position */])(evt);
        if (Math.abs(left - ctx.origin.left) >= ctx.sensitivity || Math.abs(top - ctx.origin.top) >= ctx.sensitivity) {
          clearTimeout(ctx.timer);
        }
      },
      end(evt) {
        Object(utils_event["b" /* cleanEvt */])(ctx, 'temp');

        // delay needed otherwise selection still occurs
        ctx.styleCleanup !== void 0 && ctx.styleCleanup(ctx.triggered);
        if (ctx.triggered === true) {
          evt !== void 0 && Object(utils_event["l" /* stopAndPrevent */])(evt);
        } else {
          clearTimeout(ctx.timer);
        }
      }
    };

    // duration in ms, touch in pixels, mouse in pixels
    const data = [600, 5, 7];
    if (typeof binding.arg === 'string' && binding.arg.length > 0) {
      binding.arg.split(':').forEach((val, index) => {
        const v = parseInt(val, 10);
        v && (data[index] = v);
      });
    }
    [ctx.duration, ctx.touchSensitivity, ctx.mouseSensitivity] = data;
    el.__qtouchhold = ctx;
    modifiers.mouse === true && Object(utils_event["a" /* addEvt */])(ctx, 'main', [[el, 'mousedown', 'mouseStart', `passive${modifiers.mouseCapture === true || modifiers.mousecapture === true ? 'Capture' : ''}`]]);
    Platform["a" /* client */].has.touch === true && Object(utils_event["a" /* addEvt */])(ctx, 'main', [[el, 'touchstart', 'touchStart', `passive${modifiers.capture === true ? 'Capture' : ''}`], [el, 'touchend', 'noop', 'passiveCapture']]);
  },
  update(el, binding) {
    const ctx = el.__qtouchhold;
    if (ctx !== void 0 && binding.oldValue !== binding.value) {
      typeof binding.value !== 'function' && ctx.end();
      ctx.handler = binding.value;
    }
  },
  unbind(el) {
    if (el.__qtouchhold_destroyed === void 0) {
      TouchHold_destroy(el);
    } else {
      delete el.__qtouchhold_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives/TouchRepeat.js




const TouchRepeat_keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    'delete': [8, 46]
  },
  keyRegex = new RegExp(`^([\\d+]+|${Object.keys(TouchRepeat_keyCodes).join('|')})$`, 'i');
function shouldEnd(evt, origin) {
  const {
    top,
    left
  } = Object(utils_event["h" /* position */])(evt);
  return Math.abs(left - origin.left) >= 7 || Math.abs(top - origin.top) >= 7;
}
function TouchRepeat_destroy(el) {
  const ctx = el.__qtouchrepeat;
  if (ctx !== void 0) {
    clearTimeout(ctx.timer);
    Object(utils_event["b" /* cleanEvt */])(ctx, 'main');
    Object(utils_event["b" /* cleanEvt */])(ctx, 'temp');
    ctx.styleCleanup !== void 0 && ctx.styleCleanup();
    delete el.__qtouchrepeat;
  }
}
/* harmony default export */ var TouchRepeat = ({
  name: 'touch-repeat',
  bind(el, {
    modifiers,
    value,
    arg
  }) {
    if (el.__qtouchrepeat !== void 0) {
      TouchRepeat_destroy(el);
      el.__qtouchrepeat_destroyed = true;
    }
    const keyboard = Object.keys(modifiers).reduce((acc, key) => {
      if (keyRegex.test(key) === true) {
        const keyCode = isNaN(parseInt(key, 10)) ? TouchRepeat_keyCodes[key.toLowerCase()] : parseInt(key, 10);
        keyCode >= 0 && acc.push(keyCode);
      }
      return acc;
    }, []);

    // early return, we don't need to do anything
    if (modifiers.mouse !== true && Platform["a" /* client */].has.touch !== true && keyboard.length === 0) {
      return;
    }
    const durations = typeof arg === 'string' && arg.length > 0 ? arg.split(':').map(val => parseInt(val, 10)) : [0, 600, 300];
    const durationsLast = durations.length - 1;
    const ctx = {
      keyboard,
      handler: value,
      noop: utils_event["g" /* noop */],
      mouseStart(evt) {
        if (ctx.event === void 0 && typeof ctx.handler === 'function' && Object(utils_event["e" /* leftClick */])(evt) === true) {
          Object(utils_event["a" /* addEvt */])(ctx, 'temp', [[document, 'mousemove', 'move', 'passiveCapture'], [document, 'click', 'end', 'notPassiveCapture']]);
          ctx.start(evt, true);
        }
      },
      keyboardStart(evt) {
        if (typeof ctx.handler === 'function' && Object(key_composition["a" /* isKeyCode */])(evt, keyboard) === true) {
          if (durations[0] === 0 || ctx.event !== void 0) {
            Object(utils_event["l" /* stopAndPrevent */])(evt);
            el.focus();
            if (ctx.event !== void 0) {
              return;
            }
          }
          Object(utils_event["a" /* addEvt */])(ctx, 'temp', [[document, 'keyup', 'end', 'notPassiveCapture'], [document, 'click', 'end', 'notPassiveCapture']]);
          ctx.start(evt, false, true);
        }
      },
      touchStart(evt) {
        if (evt.target !== void 0 && typeof ctx.handler === 'function') {
          const target = evt.target;
          Object(utils_event["a" /* addEvt */])(ctx, 'temp', [[target, 'touchmove', 'move', 'passiveCapture'], [target, 'touchcancel', 'end', 'notPassiveCapture'], [target, 'touchend', 'end', 'notPassiveCapture']]);
          ctx.start(evt);
        }
      },
      start(evt, mouseEvent, keyboardEvent) {
        if (keyboardEvent !== true) {
          ctx.origin = Object(utils_event["h" /* position */])(evt);
        }
        function styleCleanup(withDelay) {
          ctx.styleCleanup = void 0;
          document.documentElement.style.cursor = '';
          const remove = () => {
            document.body.classList.remove('non-selectable');
          };
          if (withDelay === true) {
            Object(selection["a" /* clearSelection */])();
            setTimeout(remove, 10);
          } else {
            remove();
          }
        }
        if (Platform["a" /* client */].is.mobile === true) {
          document.body.classList.add('non-selectable');
          Object(selection["a" /* clearSelection */])();
          ctx.styleCleanup = styleCleanup;
        }
        ctx.event = {
          touch: mouseEvent !== true && keyboardEvent !== true,
          mouse: mouseEvent === true,
          keyboard: keyboardEvent === true,
          startTime: Date.now(),
          repeatCount: 0
        };
        const fn = () => {
          if (ctx.event === void 0) {
            return;
          }
          if (ctx.event.repeatCount === 0) {
            ctx.event.evt = evt;
            if (keyboardEvent === true) {
              ctx.event.keyCode = evt.keyCode;
            } else {
              ctx.event.position = Object(utils_event["h" /* position */])(evt);
            }
            if (Platform["a" /* client */].is.mobile !== true) {
              document.documentElement.style.cursor = 'pointer';
              document.body.classList.add('non-selectable');
              Object(selection["a" /* clearSelection */])();
              ctx.styleCleanup = styleCleanup;
            }
          }
          ctx.event.duration = Date.now() - ctx.event.startTime;
          ctx.event.repeatCount += 1;
          ctx.handler(ctx.event);
          const index = durationsLast < ctx.event.repeatCount ? durationsLast : ctx.event.repeatCount;
          ctx.timer = setTimeout(fn, durations[index]);
        };
        if (durations[0] === 0) {
          fn();
        } else {
          ctx.timer = setTimeout(fn, durations[0]);
        }
      },
      move(evt) {
        if (ctx.event !== void 0 && shouldEnd(evt, ctx.origin) === true) {
          clearTimeout(ctx.timer);
        }
      },
      end(evt) {
        if (ctx.event === void 0) {
          return;
        }
        ctx.styleCleanup !== void 0 && ctx.styleCleanup(true);
        evt !== void 0 && ctx.event.repeatCount > 0 && Object(utils_event["l" /* stopAndPrevent */])(evt);
        Object(utils_event["b" /* cleanEvt */])(ctx, 'temp');
        clearTimeout(ctx.timer);
        ctx.event = void 0;
      }
    };
    el.__qtouchrepeat = ctx;
    modifiers.mouse === true && Object(utils_event["a" /* addEvt */])(ctx, 'main', [[el, 'mousedown', 'mouseStart', `passive${modifiers.mouseCapture === true || modifiers.mousecapture === true ? 'Capture' : ''}`]]);
    Platform["a" /* client */].has.touch === true && Object(utils_event["a" /* addEvt */])(ctx, 'main', [[el, 'touchstart', 'touchStart', `passive${modifiers.capture === true ? 'Capture' : ''}`], [el, 'touchend', 'noop', 'passiveCapture']]);
    keyboard.length > 0 && Object(utils_event["a" /* addEvt */])(ctx, 'main', [[el, 'keydown', 'keyboardStart', `notPassive${modifiers.keyCapture === true || modifiers.keycapture === true ? 'Capture' : ''}`]]);
  },
  update(el, {
    oldValue,
    value
  }) {
    const ctx = el.__qtouchrepeat;
    if (ctx !== void 0 && oldValue !== value) {
      typeof value !== 'function' && ctx.end();
      ctx.handler = value;
    }
  },
  unbind(el) {
    if (el.__qtouchrepeat_destroyed === void 0) {
      TouchRepeat_destroy(el);
    } else {
      delete el.__qtouchrepeat_destroyed;
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/directives.js













// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/AddressbarColor.js



let metaValue;
function getProp() {
  if (Platform["b" /* default */].is.winphone) {
    return 'msapplication-navbutton-color';
  }
  if (Platform["b" /* default */].is.safari) {
    return 'apple-mobile-web-app-status-bar-style';
  }
  // Chrome, Firefox OS, Opera, Vivaldi
  return 'theme-color';
}
function getMetaTag(v) {
  const els = document.getElementsByTagName('META');
  for (const i in els) {
    if (els[i].name === v) {
      return els[i];
    }
  }
}
function setColor(hexColor) {
  if (metaValue === void 0) {
    // cache it
    metaValue = getProp();
  }
  let metaTag = getMetaTag(metaValue);
  const newTag = metaTag === void 0;
  if (newTag) {
    metaTag = document.createElement('meta');
    metaTag.setAttribute('name', metaValue);
  }
  metaTag.setAttribute('content', hexColor);
  if (newTag) {
    document.head.appendChild(metaTag);
  }
}
/* harmony default export */ var AddressbarColor = ({
  install({
    $q,
    cfg
  }) {
    this.set = Platform["e" /* isSSR */] === false && Platform["b" /* default */].is.mobile === true && (Platform["b" /* default */].is.nativeMobile === true || Platform["b" /* default */].is.winphone === true || Platform["b" /* default */].is.safari === true || Platform["b" /* default */].is.webkit === true || Platform["b" /* default */].is.vivaldi === true) ? hexColor => {
      const val = hexColor || Object(colors["a" /* getBrand */])('primary');
      if (Platform["b" /* default */].is.nativeMobile === true && window.StatusBar) {
        window.StatusBar.backgroundColorByHexString(val);
      } else {
        setColor(val);
      }
    } : utils_event["g" /* noop */];
    $q.addressbarColor = this;
    cfg.addressbarColor && this.set(cfg.addressbarColor);
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/AppFullscreen.js


const prefixes = {};

// needed for consistency across browsers,
// including IE11 which does not return anything
function promisify(target, fn) {
  try {
    const res = target[fn]();
    return res === void 0 ? Promise.resolve() : res;
  } catch (err) {
    return Promise.reject(err);
  }
}
function checkActive(plugin) {
  plugin.activeEl = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
  plugin.isActive = plugin.activeEl !== null;
}
/* harmony default export */ var AppFullscreen = ({
  isCapable: false,
  isActive: false,
  activeEl: null,
  request(target) {
    if (this.isCapable === true) {
      const el = target || document.documentElement;
      if (el !== this.activeEl) {
        const q = Platform["a" /* client */].is.ie === true && this.activeEl !== null && el.contains(this.activeEl) ? this.exit() : Promise.resolve();
        return q.then(() => promisify(el, prefixes.request)).catch(error => this.activeEl !== null ? this.exit().then(() => promisify(el, prefixes.request)) : Promise.reject(error)).then(res => {
          checkActive(this);
          return res;
        });
      }
    }
    return this.__getErr();
  },
  exit() {
    return this.isCapable === true && this.isActive === true ? promisify(document, prefixes.exit).then(res => {
      checkActive(this);
      return this.isActive ? this.exit() : res;
    }) : this.__getErr();
  },
  toggle(target) {
    const el = target || document.documentElement;
    return this.activeEl === el ? this.exit() : this.request(el);
  },
  install({
    $q
  }) {
    $q.fullscreen = this;
    this.__getErr = () => Promise.resolve();
    if (Platform["e" /* isSSR */] === true) {
      return;
    }
    prefixes.request = ['requestFullscreen', 'msRequestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullscreen'].find(request => document.documentElement[request] !== void 0);
    this.isCapable = prefixes.request !== void 0;
    if (this.isCapable === false) {
      // it means the browser does NOT support it
      this.__getErr = () => Promise.reject('Not capable');
      return;
    }
    prefixes.exit = ['exitFullscreen', 'msExitFullscreen', 'mozCancelFullScreen', 'webkitExitFullscreen'].find(exit => document[exit]);
    checkActive(this);
    ['onfullscreenchange', 'onmsfullscreenchange', 'onwebkitfullscreenchange'].forEach(evt => {
      document[evt] = () => {
        checkActive(this);
      };
    });
    external_vue_default.a.util.defineReactive(this, 'isActive', this.isActive);
    external_vue_default.a.util.defineReactive(this, 'activeEl', this.activeEl);
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/AppVisibility.js


/* harmony default export */ var AppVisibility = ({
  appVisible: false,
  install({
    $q
  }) {
    if (Platform["e" /* isSSR */] === true) {
      this.appVisible = $q.appVisible = true;
      return;
    }
    let prop, evt;
    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      prop = 'hidden';
      evt = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      prop = 'msHidden';
      evt = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      prop = 'webkitHidden';
      evt = 'webkitvisibilitychange';
    }
    const update = () => {
      this.appVisible = $q.appVisible = !document[prop];
    };
    update();
    if (evt && typeof document[prop] !== 'undefined') {
      external_vue_default.a.util.defineReactive($q, 'appVisible', this.appVisible);
      document.addEventListener(evt, update, false);
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/dialog-bottom-sheet/BottomSheet.js











const optsGrid = {
  staticClass: 'row items-stretch justify-start',
  attrs: {
    role: 'list'
  }
};
const optsList = {
  attrs: {
    role: 'list'
  }
};
const attrsGridItem = {
  tabindex: 0,
  role: 'listitem'
};
/* harmony default export */ var BottomSheet = (external_vue_default.a.extend({
  name: 'BottomSheetPlugin',
  mixins: [dark["a" /* default */], mixins_attrs["b" /* default */]],
  inheritAttrs: false,
  props: {
    title: String,
    message: String,
    actions: Array,
    grid: Boolean,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  computed: {
    dialogProps() {
      return {
        ...this.qAttrs,
        position: 'bottom'
      };
    }
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onOk(action) {
      this.$emit('ok', action);
      this.hide();
    },
    __getGrid(h) {
      return this.actions.map(action => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator["a" /* default */], {
          staticClass: 'col-all',
          props: {
            dark: this.isDark
          }
        }) : h('div', {
          staticClass: 'q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position',
          class: action.classes,
          style: action.style,
          attrs: attrsGridItem,
          on: {
            click: () => {
              this.onOk(action);
            },
            keyup: e => {
              e.keyCode === 13 && this.onOk(action);
            }
          }
        }, [h('div', {
          staticClass: 'q-focus-helper'
        }), action.icon ? h(QIcon["a" /* default */], {
          props: {
            name: action.icon,
            color: action.color
          }
        }) : img ? h('img', {
          attrs: {
            src: img
          },
          staticClass: action.avatar ? 'q-bottom-sheet__avatar' : null
        }) : h('div', {
          staticClass: 'q-bottom-sheet__empty-icon'
        }), h('div', [action.label])]);
      });
    },
    __getList(h) {
      return this.actions.map(action => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator["a" /* default */], {
          props: {
            spaced: true,
            dark: this.isDark
          }
        }) : h(QItem["a" /* default */], {
          staticClass: 'q-bottom-sheet__item',
          class: action.classes,
          style: action.style,
          props: {
            tabindex: 0,
            clickable: true,
            dark: this.isDark
          },
          on: {
            click: () => {
              this.onOk(action);
            }
          }
        }, [h(QItemSection["a" /* default */], {
          props: {
            avatar: true
          }
        }, [action.icon ? h(QIcon["a" /* default */], {
          props: {
            name: action.icon,
            color: action.color
          }
        }) : img ? h('img', {
          attrs: {
            src: img
          },
          staticClass: action.avatar ? 'q-bottom-sheet__avatar' : null
        }) : null]), h(QItemSection["a" /* default */], [action.label])]);
      });
    }
  },
  render(h) {
    const child = [];
    this.title && child.push(h(QCardSection["a" /* default */], {
      staticClass: 'q-dialog__title'
    }, [this.title]));
    this.message && child.push(h(QCardSection["a" /* default */], {
      staticClass: 'q-dialog__message'
    }, [this.message]));
    child.push(this.grid === true ? h('div', optsGrid, this.__getGrid(h)) : h('div', optsList, this.__getList(h)));
    return h(QDialog["a" /* default */], {
      ref: 'dialog',
      props: this.dialogProps,
      on: Object(cache["b" /* default */])(this, 'hide', {
        hide: () => {
          this.$emit('hide');
        }
      })
    }, [h(QCard["a" /* default */], {
      staticClass: `q-bottom-sheet q-bottom-sheet--${this.grid === true ? 'grid' : 'list'}` + (this.isDark === true ? ' q-bottom-sheet--dark q-dark' : ''),
      style: this.cardStyle,
      class: this.cardClass
    }, child)]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/private/global-dialog.js


const ssrAPI = {
  onOk: () => ssrAPI,
  okCancel: () => ssrAPI,
  hide: () => ssrAPI,
  update: () => ssrAPI
};
function merge(target, source) {
  for (const key in source) {
    if (key !== 'spinner' && Object(source[key]) === source[key]) {
      target[key] = Object(target[key]) !== target[key] ? {} : {
        ...target[key]
      };
      merge(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
}
let appRoot;
function getDialogParent(parent, root) {
  if (parent !== void 0) {
    return parent;
  }
  if (root !== void 0) {
    return root;
  }
  if (appRoot === void 0) {
    const elRoot = document.getElementById('q-app');
    if (elRoot && elRoot.__vue__) {
      appRoot = elRoot.__vue__.$root;
    }
  }
  return appRoot;
}
/* harmony default export */ var global_dialog = (function (DefaultComponent) {
  return ({
    className,
    class: klass,
    style,
    component,
    root,
    parent,
    ...props
  }) => {
    if (Platform["e" /* isSSR */] === true) {
      return ssrAPI;
    }
    klass !== void 0 && (props.cardClass = klass);
    style !== void 0 && (props.cardStyle = style);
    const isCustom = component !== void 0;
    let DialogComponent, attrs;
    if (isCustom === true) {
      DialogComponent = component;
    } else {
      DialogComponent = DefaultComponent;
      attrs = props;
    }
    const okFns = [],
      cancelFns = [],
      API = {
        onOk(fn) {
          okFns.push(fn);
          return API;
        },
        onCancel(fn) {
          cancelFns.push(fn);
          return API;
        },
        onDismiss(fn) {
          okFns.push(fn);
          cancelFns.push(fn);
          return API;
        },
        hide() {
          vm.$refs.dialog.hide();
          return API;
        },
        update({
          className,
          class: klass,
          style,
          component,
          root,
          parent,
          ...cfg
        }) {
          if (vm !== null) {
            klass !== void 0 && (cfg.cardClass = klass);
            style !== void 0 && (cfg.cardStyle = style);
            if (isCustom === true) {
              Object.assign(props, cfg);
            } else {
              merge(props, cfg);

              // need to change "attrs" reference to
              // actually reflect it in underlying component
              // when we force update it
              attrs = {
                ...props
              };
            }
            vm.$forceUpdate();
          }
          return API;
        }
      };
    const node = document.createElement('div');
    document.body.appendChild(node);
    let emittedOK = false;
    const on = {
      ok: data => {
        emittedOK = true;
        okFns.forEach(fn => {
          fn(data);
        });
      },
      hide: () => {
        vm.$destroy();
        vm.$el.remove();
        vm = null;
        if (emittedOK !== true) {
          cancelFns.forEach(fn => {
            fn();
          });
        }
      }
    };
    let vm = new external_vue_default.a({
      name: 'QGlobalDialog',
      el: node,
      parent: getDialogParent(parent, root),
      render(h) {
        return h(DialogComponent, {
          ref: 'dialog',
          props,
          attrs,
          on
        });
      },
      mounted() {
        if (this.$refs.dialog !== void 0) {
          this.$refs.dialog.show();
        } else {
          on['hook:mounted'] = () => {
            this.$refs.dialog !== void 0 && this.$refs.dialog.show();
          };
        }
      }
    });
    return API;
  };
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/BottomSheet.js


/* harmony default export */ var plugins_BottomSheet = ({
  install({
    $q
  }) {
    this.create = $q.bottomSheet = global_dialog(BottomSheet);
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/Cookies.js

function encode(string) {
  return encodeURIComponent(string);
}
function decode(string) {
  return decodeURIComponent(string);
}
function stringifyCookieValue(value) {
  return encode(value === Object(value) ? JSON.stringify(value) : '' + value);
}
function read(string) {
  if (string === '') {
    return string;
  }
  if (string.indexOf('"') === 0) {
    // This is a quoted cookie as according to RFC2068, unescape...
    string = string.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
  }

  // Replace server-side written pluses with spaces.
  // If we can't decode the cookie, ignore it, it's unusable.
  // If we can't parse the cookie, ignore it, it's unusable.
  string = decode(string.replace(/\+/g, ' '));
  try {
    string = JSON.parse(string);
  } catch (e) {}
  return string;
}
function getString(msOffset) {
  const time = new Date();
  time.setMilliseconds(time.getMilliseconds() + msOffset);
  return time.toUTCString();
}
function parseExpireString(str) {
  let timestamp = 0;
  const days = str.match(/(\d+)d/);
  const hours = str.match(/(\d+)h/);
  const minutes = str.match(/(\d+)m/);
  const seconds = str.match(/(\d+)s/);
  if (days) {
    timestamp += days[1] * 864e+5;
  }
  if (hours) {
    timestamp += hours[1] * 36e+5;
  }
  if (minutes) {
    timestamp += minutes[1] * 6e+4;
  }
  if (seconds) {
    timestamp += seconds[1] * 1000;
  }
  return timestamp === 0 ? str : getString(timestamp);
}
function set(key, val, opts = {}, ssr) {
  let expire, expireValue;
  if (opts.expires !== void 0) {
    // if it's a Date Object
    if (Object.prototype.toString.call(opts.expires) === '[object Date]') {
      expire = opts.expires.toUTCString();
    }
    // if it's a String (eg. "15m", "1h", "13d", "1d 15m", "31s")
    // possible units: d (days), h (hours), m (minutes), s (seconds)
    else if (typeof opts.expires === 'string') {
      expire = parseExpireString(opts.expires);
    }
    // otherwise it must be a Number (defined in days)
    else {
      expireValue = parseFloat(opts.expires);
      expire = isNaN(expireValue) === false ? getString(expireValue * 864e+5) : opts.expires;
    }
  }
  const keyValue = `${encode(key)}=${stringifyCookieValue(val)}`;
  const cookie = [keyValue, expire !== void 0 ? '; Expires=' + expire : '',
  // use expires attribute, max-age is not supported by IE
  opts.path ? '; Path=' + opts.path : '', opts.domain ? '; Domain=' + opts.domain : '', opts.sameSite ? '; SameSite=' + opts.sameSite : '', opts.httpOnly ? '; HttpOnly' : '', opts.secure ? '; Secure' : '', opts.other ? '; ' + opts.other : ''].join('');
  if (ssr) {
    if (ssr.req.qCookies) {
      ssr.req.qCookies.push(cookie);
    } else {
      ssr.req.qCookies = [cookie];
    }
    ssr.res.setHeader('Set-Cookie', ssr.req.qCookies);

    // make temporary update so future get()
    // within same SSR timeframe would return the set value

    let all = ssr.req.headers.cookie || '';
    if (expire !== void 0 && expireValue < 0) {
      const val = get(key, ssr);
      if (val !== void 0) {
        all = all.replace(`${key}=${val}; `, '').replace(`; ${key}=${val}`, '').replace(`${key}=${val}`, '');
      }
    } else {
      all = all ? `${keyValue}; ${all}` : cookie;
    }
    ssr.req.headers.cookie = all;
  } else {
    document.cookie = cookie;
  }
}
function get(key, ssr) {
  const cookieSource = ssr ? ssr.req.headers : document,
    cookies = cookieSource.cookie ? cookieSource.cookie.split('; ') : [],
    l = cookies.length;
  let result = key ? null : {},
    i = 0,
    parts,
    name,
    cookie;
  for (; i < l; i++) {
    parts = cookies[i].split('=');
    name = decode(parts.shift());
    cookie = parts.join('=');
    if (!key) {
      result[name] = cookie;
    } else if (key === name) {
      result = read(cookie);
      break;
    }
  }
  return result;
}
function Cookies_remove(key, options, ssr) {
  set(key, '', {
    expires: -1,
    ...options
  }, ssr);
}
function has(key, ssr) {
  return get(key, ssr) !== null;
}
function getObject(ssr) {
  return {
    get: key => get(key, ssr),
    set: (key, val, opts) => set(key, val, opts, ssr),
    has: key => has(key, ssr),
    remove: (key, options) => Cookies_remove(key, options, ssr),
    getAll: () => get(null, ssr)
  };
}
/* harmony default export */ var Cookies = ({
  parseSSR(ssrContext) {
    return ssrContext !== void 0 ? getObject(ssrContext) : this;
  },
  install({
    $q,
    queues
  }) {
    if (Platform["e" /* isSSR */] === true) {
      queues.server.push((q, ctx) => {
        q.cookies = getObject(ctx.ssr);
      });
    } else {
      Object.assign(this, getObject());
      $q.cookies = this;
    }
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Dark.js
var Dark = __webpack_require__("d3a0");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/components/dialog-plugin/DialogPlugin.js
















/* harmony default export */ var DialogPlugin = (external_vue_default.a.extend({
  name: 'DialogPlugin',
  mixins: [dark["a" /* default */], mixins_attrs["b" /* default */]],
  inheritAttrs: false,
  props: {
    title: String,
    message: String,
    prompt: Object,
    options: Object,
    progress: [Boolean, Object],
    html: Boolean,
    ok: {
      type: [String, Object, Boolean],
      default: true
    },
    cancel: [String, Object, Boolean],
    focus: {
      type: String,
      default: 'ok',
      validator: v => ['ok', 'cancel', 'none'].includes(v)
    },
    stackButtons: Boolean,
    color: String,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  computed: {
    classes() {
      return 'q-dialog-plugin' + (this.isDark === true ? ' q-dialog-plugin--dark q-dark' : '') + (this.progress !== false ? ' q-dialog-plugin--progress' : '');
    },
    spinner() {
      if (this.progress !== false) {
        return Object(is["d" /* isObject */])(this.progress) === true ? {
          component: this.progress.spinner || QSpinner["a" /* default */],
          props: {
            color: this.progress.color || this.vmColor
          }
        } : {
          component: QSpinner["a" /* default */],
          props: {
            color: this.vmColor
          }
        };
      }
    },
    hasForm() {
      return this.prompt !== void 0 || this.options !== void 0;
    },
    okLabel() {
      return Object(is["d" /* isObject */])(this.ok) === true ? this.$q.lang.label.ok : this.ok === true ? this.$q.lang.label.ok : this.ok;
    },
    cancelLabel() {
      return Object(is["d" /* isObject */])(this.cancel) === true ? this.$q.lang.label.cancel : this.cancel === true ? this.$q.lang.label.cancel : this.cancel;
    },
    vmColor() {
      return this.color || (this.isDark === true ? 'amber' : 'primary');
    },
    okDisabled() {
      if (this.prompt !== void 0) {
        return this.prompt.isValid !== void 0 && this.prompt.isValid(this.prompt.model) !== true;
      }
      if (this.options !== void 0) {
        return this.options.isValid !== void 0 && this.options.isValid(this.options.model) !== true;
      }
    },
    okProps() {
      return {
        color: this.vmColor,
        label: this.okLabel,
        ripple: false,
        disable: this.okDisabled,
        ...(Object(is["d" /* isObject */])(this.ok) === true ? this.ok : {
          flat: true
        })
      };
    },
    cancelProps() {
      return {
        color: this.vmColor,
        label: this.cancelLabel,
        ripple: false,
        ...(Object(is["d" /* isObject */])(this.cancel) === true ? this.cancel : {
          flat: true
        })
      };
    }
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    getPrompt(h) {
      return [h(QInput["a" /* default */], {
        props: {
          value: this.prompt.model,
          type: this.prompt.type,
          label: this.prompt.label,
          stackLabel: this.prompt.stackLabel,
          outlined: this.prompt.outlined,
          filled: this.prompt.filled,
          standout: this.prompt.standout,
          rounded: this.prompt.rounded,
          square: this.prompt.square,
          counter: this.prompt.counter,
          maxlength: this.prompt.maxlength,
          prefix: this.prompt.prefix,
          suffix: this.prompt.suffix,
          color: this.vmColor,
          dense: true,
          autofocus: true,
          dark: this.isDark
        },
        attrs: this.prompt.attrs,
        on: Object(cache["b" /* default */])(this, 'prompt', {
          input: v => {
            this.prompt.model = v;
          },
          keyup: evt => {
            // if ENTER key
            if (this.okDisabled !== true && this.prompt.type !== 'textarea' && Object(key_composition["a" /* isKeyCode */])(evt, 13) === true) {
              this.onOk();
            }
          }
        })
      })];
    },
    getOptions(h) {
      return [h(QOptionGroup, {
        props: {
          value: this.options.model,
          type: this.options.type,
          color: this.vmColor,
          inline: this.options.inline,
          options: this.options.items,
          dark: this.isDark
        },
        on: Object(cache["b" /* default */])(this, 'opts', {
          input: v => {
            this.options.model = v;
          }
        })
      })];
    },
    getButtons(h) {
      const child = [];
      this.cancel && child.push(h(QBtn["a" /* default */], {
        props: this.cancelProps,
        attrs: {
          'data-autofocus': this.focus === 'cancel' && this.hasForm !== true
        },
        on: Object(cache["b" /* default */])(this, 'cancel', {
          click: this.onCancel
        })
      }));
      this.ok && child.push(h(QBtn["a" /* default */], {
        props: this.okProps,
        attrs: {
          'data-autofocus': this.focus === 'ok' && this.hasForm !== true
        },
        on: Object(cache["b" /* default */])(this, 'ok', {
          click: this.onOk
        })
      }));
      if (child.length > 0) {
        return h(QCardActions["a" /* default */], {
          staticClass: this.stackButtons === true ? 'items-end' : null,
          props: {
            vertical: this.stackButtons,
            align: 'right'
          }
        }, child);
      }
    },
    onOk() {
      this.$emit('ok', cloneDeep(this.getData()));
      this.hide();
    },
    onCancel() {
      this.hide();
    },
    getData() {
      return this.prompt !== void 0 ? this.prompt.model : this.options !== void 0 ? this.options.model : void 0;
    },
    getSection(h, staticClass, text) {
      return this.html === true ? h(QCardSection["a" /* default */], {
        staticClass,
        domProps: {
          innerHTML: text
        }
      }) : h(QCardSection["a" /* default */], {
        staticClass
      }, [text]);
    }
  },
  render(h) {
    const child = [];
    this.title && child.push(this.getSection(h, 'q-dialog__title', this.title));
    this.progress !== false && child.push(h(QCardSection["a" /* default */], {
      staticClass: 'q-dialog__progress'
    }, [h(this.spinner.component, {
      props: this.spinner.props
    })]));
    this.message && child.push(this.getSection(h, 'q-dialog__message', this.message));
    if (this.prompt !== void 0) {
      child.push(h(QCardSection["a" /* default */], {
        staticClass: 'scroll q-dialog-plugin__form'
      }, this.getPrompt(h)));
    } else if (this.options !== void 0) {
      child.push(h(QSeparator["a" /* default */], {
        props: {
          dark: this.isDark
        }
      }), h(QCardSection["a" /* default */], {
        staticClass: 'scroll q-dialog-plugin__form'
      }, this.getOptions(h)), h(QSeparator["a" /* default */], {
        props: {
          dark: this.isDark
        }
      }));
    }
    if (this.ok || this.cancel) {
      child.push(this.getButtons(h));
    }
    return h(QDialog["a" /* default */], {
      ref: 'dialog',
      props: {
        ...this.qAttrs,
        value: this.value
      },
      on: Object(cache["b" /* default */])(this, 'hide', {
        hide: () => {
          this.$emit('hide');
        }
      })
    }, [h(QCard["a" /* default */], {
      staticClass: this.classes,
      style: this.cardStyle,
      class: this.cardClass,
      props: {
        dark: this.isDark
      }
    }, child)]);
  }
}));
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/Dialog.js


/* harmony default export */ var Dialog = ({
  install({
    $q
  }) {
    this.create = $q.dialog = global_dialog(DialogPlugin);
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/LoadingBar.js





/* harmony default export */ var LoadingBar = ({
  isActive: false,
  start: utils_event["g" /* noop */],
  stop: utils_event["g" /* noop */],
  increment: utils_event["g" /* noop */],
  setDefaults: utils_event["g" /* noop */],
  install({
    $q,
    cfg
  }) {
    $q.loadingBar = this;
    if (Platform["e" /* isSSR */] === true) {
      return;
    }
    const props = cfg.loadingBar !== void 0 ? {
      ...cfg.loadingBar
    } : {};
    const on = {
      start: () => {
        this.isActive = true;
      },
      stop: () => {
        this.isActive = false;
      }
    };
    const bar = new external_vue_default.a({
      name: 'LoadingBar',
      // hide App from Vue devtools
      devtools: {
        hide: true
      },
      beforeCreate() {
        // prevent error in Vue devtools
        this._routerRoot === void 0 && (this._routerRoot = {});
      },
      render: h => h(QAjaxBar, {
        ref: 'bar',
        props,
        on
      })
    }).$mount().$refs.bar;
    Object.assign(this, {
      start: bar.start,
      stop: bar.stop,
      increment: bar.increment,
      setDefaults: opts => {
        Object(is["d" /* isObject */])(opts) === true && Object.assign(props, opts);
        bar.$parent.$forceUpdate();
      }
    });
    external_vue_default.a.util.defineReactive(this, 'isActive', this.isActive);
    external_vue_default.a.util.defineReactive(bar, 'isActive', this.isActive);
    bar.setDefaults = this.setDefaults;
    document.body.appendChild(bar.$parent.$el);
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/mixins/prevent-scroll.js
var prevent_scroll = __webpack_require__("9a9f");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/Loading.js






let Loading_vm,
  Loading_uid = 0,
  Loading_timeout,
  Loading_props = {},
  activeGroups = {};
const originalDefaults = {
  group: '__default_quasar_group__',
  delay: 0,
  message: false,
  spinnerSize: 80,
  spinnerColor: 'white',
  messageColor: 'white',
  backgroundColor: 'black',
  spinner: QSpinner["a" /* default */],
  customClass: ''
};
const defaults = {
  ...originalDefaults
};
function registerProps(opts) {
  if (opts && opts.group !== void 0 && activeGroups[opts.group] !== void 0) {
    return Object.assign(activeGroups[opts.group], opts);
  }
  const newProps = Object(is["d" /* isObject */])(opts) === true && opts.ignoreDefaults === true ? {
    ...originalDefaults,
    ...opts
  } : {
    ...defaults,
    ...opts
  };
  activeGroups[newProps.group] = newProps;
  return newProps;
}
const Loading = {
  isActive: false,
  show(opts) {
    if (Platform["e" /* isSSR */] === true) {
      return;
    }
    Loading_props = registerProps(opts);
    const {
      group
    } = Loading_props;
    Loading_props.customClass += ` text-${Loading_props.backgroundColor}`;
    this.isActive = true;
    if (Loading_vm !== void 0) {
      Loading_props.uid = Loading_uid;
      Loading_vm.$forceUpdate();
    } else {
      Loading_props.uid = ++Loading_uid;
      clearTimeout(Loading_timeout);
      Loading_timeout = setTimeout(() => {
        Loading_timeout = void 0;
        const node = document.createElement('div');
        document.body.appendChild(node);
        Loading_vm = new external_vue_default.a({
          name: 'QLoading',
          // hide App from Vue devtools
          devtools: {
            hide: true
          },
          beforeCreate() {
            // prevent error in Vue devtools
            this._routerRoot === void 0 && (this._routerRoot = {});
          },
          el: node,
          mounted() {
            Object(prevent_scroll["b" /* preventScroll */])(true);
          },
          render: h => {
            return h('transition', {
              props: {
                name: 'q-transition--fade',
                appear: true
              },
              on: Object(cache["b" /* default */])(this, 'tr', {
                'after-leave': () => {
                  // might be called to finalize
                  // previous leave, even if it was cancelled
                  if (this.isActive !== true && Loading_vm !== void 0) {
                    Object(prevent_scroll["b" /* preventScroll */])(false);
                    Loading_vm.$destroy();
                    Loading_vm.$el.remove();
                    Loading_vm = void 0;
                  }
                }
              })
            }, [this.isActive === true ? h('div', {
              staticClass: 'q-loading fullscreen column flex-center z-max',
              key: Loading_props.uid,
              class: Loading_props.customClass.trim()
            }, [h(Loading_props.spinner, {
              props: {
                color: Loading_props.spinnerColor,
                size: Loading_props.spinnerSize
              }
            }), Loading_props.message && h('div', {
              class: `text-${Loading_props.messageColor}`,
              domProps: {
                [Loading_props.sanitize === true ? 'textContent' : 'innerHTML']: Loading_props.message
              }
            }) || void 0]) : null]);
          }
        });
      }, Loading_props.delay);
    }
    return paramProps => {
      // if we don't have params (or not an Object param) then we need to hide this group
      if (paramProps === void 0 || Object(paramProps) !== paramProps) {
        this.hide(group);
        return;
      }

      // else we have params so we need to update this group
      this.show({
        ...paramProps,
        group
      });
    };
  },
  hide(group) {
    if (this.isActive === true) {
      if (group === void 0) {
        // clear out any active groups
        activeGroups = {};
      } else if (activeGroups[group] === void 0) {
        // we've already hidden it so nothing to do
        return;
      } else {
        // remove active group
        delete activeGroups[group];
        const keys = Object.keys(activeGroups);

        // if there are other groups registered then
        // show last registered one since that one is still active
        if (keys.length !== 0) {
          // get last registered group
          const lastGroup = keys[keys.length - 1];
          this.show({
            group: lastGroup
          });
          return;
        }
      }
      if (Loading_timeout !== void 0) {
        clearTimeout(Loading_timeout);
        Loading_timeout = void 0;
      }
      this.isActive = false;
    }
  },
  setDefaults(opts) {
    Object(is["d" /* isObject */])(opts) === true && Object.assign(defaults, opts);
  },
  install({
    $q,
    cfg: {
      loading
    }
  }) {
    this.setDefaults(loading);
    $q.loading = this;
  }
};
if (Platform["e" /* isSSR */] === false) {
  external_vue_default.a.util.defineReactive(Loading, 'isActive', Loading.isActive);
}
/* harmony default export */ var plugins_Loading = (Loading);
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/Meta.js



let updateId, ssrTakeover;
function normalize(meta) {
  if (meta.title) {
    meta.title = meta.titleTemplate ? meta.titleTemplate(meta.title) : meta.title;
    delete meta.titleTemplate;
  }
  ;
  [['meta', 'content'], ['link', 'href']].forEach(type => {
    const metaType = meta[type[0]],
      metaProp = type[1];
    for (const name in metaType) {
      const metaLink = metaType[name];
      if (metaLink.template) {
        if (Object.keys(metaLink).length === 1) {
          delete metaType[name];
        } else {
          metaLink[metaProp] = metaLink.template(metaLink[metaProp] || '');
          delete metaLink.template;
        }
      }
    }
  });
}
function Meta_changed(old, def) {
  if (Object.keys(old).length !== Object.keys(def).length) {
    return true;
  }
  for (const key in old) {
    if (old[key] !== def[key]) {
      return true;
    }
  }
}
function bodyFilter(name) {
  return ['class', 'style'].includes(name) === false;
}
function htmlFilter(name) {
  return ['lang', 'dir'].includes(name) === false;
}
function diff(meta, other) {
  const add = {},
    remove = {};
  if (meta === void 0) {
    return {
      add: other,
      remove
    };
  }
  if (meta.title !== other.title) {
    add.title = other.title;
  }
  ;
  ['meta', 'link', 'script', 'htmlAttr', 'bodyAttr'].forEach(type => {
    const old = meta[type],
      cur = other[type];
    remove[type] = [];
    if (old === void 0 || old === null) {
      add[type] = cur;
      return;
    }
    add[type] = {};
    for (const key in old) {
      if (cur.hasOwnProperty(key) === false) {
        remove[type].push(key);
      }
    }
    for (const key in cur) {
      if (old.hasOwnProperty(key) === false) {
        add[type][key] = cur[key];
      } else if (Meta_changed(old[key], cur[key]) === true) {
        remove[type].push(key);
        add[type][key] = cur[key];
      }
    }
  });
  return {
    add,
    remove
  };
}
function apply({
  add,
  remove
}) {
  if (add.title) {
    document.title = add.title;
  }
  if (Object.keys(remove).length > 0) {
    ['meta', 'link', 'script'].forEach(type => {
      remove[type].forEach(name => {
        document.head.querySelector(`${type}[data-qmeta="${name}"]`).remove();
      });
    });
    remove.htmlAttr.filter(htmlFilter).forEach(name => {
      document.documentElement.removeAttribute(name);
    });
    remove.bodyAttr.filter(bodyFilter).forEach(name => {
      document.body.removeAttribute(name);
    });
  }
  ;
  ['meta', 'link', 'script'].forEach(type => {
    const metaType = add[type];
    for (const name in metaType) {
      const tag = document.createElement(type);
      for (const att in metaType[name]) {
        if (att !== 'innerHTML') {
          tag.setAttribute(att, metaType[name][att]);
        }
      }
      tag.setAttribute('data-qmeta', name);
      if (type === 'script') {
        tag.innerHTML = metaType[name].innerHTML || '';
      }
      document.head.appendChild(tag);
    }
  });
  Object.keys(add.htmlAttr).filter(htmlFilter).forEach(name => {
    document.documentElement.setAttribute(name, add.htmlAttr[name] || '');
  });
  Object.keys(add.bodyAttr).filter(bodyFilter).forEach(name => {
    document.body.setAttribute(name, add.bodyAttr[name] || '');
  });
}
function parseMeta(component, meta) {
  if (component._inactive === true) {
    return;
  }

  // if it has meta
  if (hasMeta(component) === true) {
    extend(true, meta, component.__qMeta);
    if (component.$options.meta.stopPropagation === true) {
      return;
    }
  }
  component.$children.forEach(child => {
    parseMeta(child, meta);
  });
}
function updateClient() {
  if (ssrTakeover === true) {
    ssrTakeover = false;
    this.$root.__currentMeta = window.__Q_META__;
  }
  const meta = {
    title: '',
    titleTemplate: null,
    meta: {},
    link: {},
    script: {},
    htmlAttr: {},
    bodyAttr: {}
  };
  parseMeta(this.$root, meta);
  normalize(meta);
  apply(diff(this.$root.__currentMeta, meta));
  this.$root.__currentMeta = meta;
}
function getAttr(seed) {
  return att => {
    const val = seed[att];
    return att + (val !== true && val !== void 0 ? `="${val}"` : '');
  };
}
function getHead(meta) {
  let output = '';
  if (meta.title) {
    output += `<title>${meta.title}</title>`;
  }
  ;
  ['meta', 'link', 'script'].forEach(type => {
    const metaType = meta[type];
    for (const att in metaType) {
      const attrs = Object.keys(metaType[att]).filter(att => att !== 'innerHTML').map(getAttr(metaType[att]));
      output += `<${type} ${attrs.join(' ')} data-qmeta="${att}">`;
      if (type === 'script') {
        output += `${metaType[att].innerHTML || ''}</script>`;
      }
    }
  });
  return output;
}
function getServerMeta(app, html, ctx) {
  const meta = {
    title: '',
    titleTemplate: null,
    meta: {},
    link: {},
    htmlAttr: {},
    bodyAttr: {},
    noscript: {}
  };
  parseMeta(app, meta);
  normalize(meta);
  const nonce = ctx !== void 0 && ctx.nonce !== void 0 ? ` nonce="${ctx.nonce}"` : '';
  const tokens = {
    '%%Q_HTML_ATTRS%%': Object.keys(meta.htmlAttr).filter(htmlFilter).map(getAttr(meta.htmlAttr)).join(' '),
    '%%Q_HEAD_TAGS%%': getHead(meta),
    '%%Q_BODY_ATTRS%%': Object.keys(meta.bodyAttr).filter(bodyFilter).map(getAttr(meta.bodyAttr)).join(' '),
    '%%Q_BODY_TAGS%%': Object.keys(meta.noscript).map(name => `<noscript data-qmeta="${name}">${meta.noscript[name]}</noscript>`).join('') + `<script${nonce}>window.__Q_META__=${delete meta.noscript && JSON.stringify(meta)}</script>`
  };
  Object.keys(tokens).forEach(key => {
    html = html.replace(key, tokens[key]);
  });
  return html;
}
function beforeCreate() {
  if (typeof this.$options.meta === 'function') {
    if (this.$options.computed === void 0) {
      this.$options.computed = {};
    }
    this.$options.computed.__qMeta = this.$options.meta;
  } else if (hasMeta(this) === true) {
    this.__qMeta = this.$options.meta;
  }
}

// needs to be really fast
function hasMeta(vm) {
  return vm.$options.meta !== void 0 && vm.$options.meta !== null;
}
function triggerMeta() {
  hasMeta(this) === true && this.__qMetaUpdate();
}
/* harmony default export */ var Meta = ({
  install({
    queues
  }) {
    if (Platform["e" /* isSSR */] === true) {
      external_vue_default.a.prototype.$getMetaHTML = app => {
        return (html, ctx) => getServerMeta(app, html, ctx);
      };
      external_vue_default.a.mixin({
        beforeCreate
      });
      queues.server.push((_, ctx) => {
        ctx.ssr.Q_HTML_ATTRS += ' %%Q_HTML_ATTRS%%';
        Object.assign(ctx.ssr, {
          Q_HEAD_TAGS: '%%Q_HEAD_TAGS%%',
          Q_BODY_ATTRS: '%%Q_BODY_ATTRS%%',
          Q_BODY_TAGS: '%%Q_BODY_TAGS%%'
        });
      });
    } else {
      ssrTakeover = Platform["c" /* fromSSR */];
      external_vue_default.a.mixin({
        beforeCreate,
        created() {
          if (hasMeta(this) === true) {
            this.__qMetaUnwatch = this.$watch('__qMeta', this.__qMetaUpdate);
          }
        },
        activated: triggerMeta,
        deactivated: triggerMeta,
        beforeMount: triggerMeta,
        destroyed() {
          if (hasMeta(this) === true) {
            this.__qMetaUnwatch();
            this.__qMetaUpdate();
          }
        },
        methods: {
          __qMetaUpdate() {
            clearTimeout(updateId);
            updateId = setTimeout(updateClient.bind(this), 50);
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/Notify.js










let Notify_uid = 0,
  Notify_vm;
const Notify_defaults = {};
const groups = {};
const notificationsList = {};
const positionClass = {};
const emptyRE = /^\s*$/;
const positionList = ['top-left', 'top-right', 'bottom-left', 'bottom-right', 'top', 'bottom', 'left', 'right', 'center'];
const badgePositions = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
const notifTypes = {
  positive: {
    icon: $q => $q.iconSet.type.positive,
    color: 'positive'
  },
  negative: {
    icon: $q => $q.iconSet.type.negative,
    color: 'negative'
  },
  warning: {
    icon: $q => $q.iconSet.type.warning,
    color: 'warning',
    textColor: 'dark'
  },
  info: {
    icon: $q => $q.iconSet.type.info,
    color: 'info'
  },
  ongoing: {
    group: false,
    timeout: 0,
    spinner: true,
    color: 'grey-8'
  }
};
function addNotification(config, vm, originalApi) {
  if (!config) {
    return logError('parameter required');
  }
  let Api;
  const notif = {
    textColor: 'white'
  };
  if (config.ignoreDefaults !== true) {
    Object.assign(notif, Notify_defaults);
  }
  if (Object(is["d" /* isObject */])(config) === false) {
    if (notif.type) {
      Object.assign(notif, notifTypes[notif.type]);
    }
    config = {
      message: config
    };
  }
  Object.assign(notif, notifTypes[config.type || notif.type], config);
  if (typeof notif.icon === 'function') {
    notif.icon = notif.icon(vm.$q);
  }
  if (!notif.spinner) {
    notif.spinner = false;
  } else if (notif.spinner === true) {
    notif.spinner = QSpinner["a" /* default */];
  }
  notif.meta = {
    hasMedia: Boolean(notif.spinner !== false || notif.icon || notif.avatar),
    hasText: hasContent(notif.message) || hasContent(notif.caption)
  };
  if (notif.position) {
    if (positionList.includes(notif.position) === false) {
      return logError('wrong position', config);
    }
  } else {
    notif.position = 'bottom';
  }
  if (notif.timeout === void 0) {
    notif.timeout = 5000;
  } else {
    const t = parseInt(notif.timeout, 10);
    if (isNaN(t) || t < 0) {
      return logError('wrong timeout', config);
    }
    notif.timeout = t;
  }
  if (notif.timeout === 0) {
    notif.progress = false;
  } else if (notif.progress === true) {
    notif.meta.progressClass = 'q-notification__progress' + (notif.progressClass ? ` ${notif.progressClass}` : '');
    notif.meta.progressStyle = {
      animationDuration: `${notif.timeout + 1000}ms`
    };
  }
  const actions = (Array.isArray(config.actions) === true ? config.actions : []).concat(config.ignoreDefaults !== true && Array.isArray(Notify_defaults.actions) === true ? Notify_defaults.actions : []).concat(notifTypes[config.type] !== void 0 && Array.isArray(notifTypes[config.type].actions) === true ? notifTypes[config.type].actions : []);
  const {
    closeBtn
  } = notif;
  closeBtn && actions.push({
    label: typeof closeBtn === 'string' ? closeBtn : vm.$q.lang.label.close
  });
  notif.actions = actions.map(({
    handler,
    noDismiss,
    style,
    class: klass,
    attrs,
    ...props
  }) => ({
    staticClass: klass,
    style,
    props: {
      flat: true,
      ...props
    },
    attrs,
    on: {
      click: typeof handler === 'function' ? () => {
        handler();
        noDismiss !== true && dismiss();
      } : () => {
        dismiss();
      }
    }
  }));
  if (notif.multiLine === void 0) {
    notif.multiLine = notif.actions.length > 1;
  }
  Object.assign(notif.meta, {
    staticClass: 'q-notification row items-stretch' + ` q-notification--${notif.multiLine === true ? 'multi-line' : 'standard'}` + (notif.color !== void 0 ? ` bg-${notif.color}` : '') + (notif.textColor !== void 0 ? ` text-${notif.textColor}` : '') + (notif.classes !== void 0 ? ` ${notif.classes}` : ''),
    wrapperClass: 'q-notification__wrapper col relative-position border-radius-inherit ' + (notif.multiLine === true ? 'column no-wrap justify-center' : 'row items-center'),
    contentClass: 'q-notification__content row items-center' + (notif.multiLine === true ? '' : ' col'),
    leftClass: notif.meta.hasText === true ? 'additional' : 'single',
    attrs: {
      role: 'alert',
      ...notif.attrs
    }
  });
  if (notif.group === false) {
    notif.group = void 0;
    notif.meta.group = void 0;
  } else {
    if (notif.group === void 0 || notif.group === true) {
      // do not replace notifications with different buttons
      notif.group = [notif.message, notif.caption, notif.multiline].concat(notif.actions.map(({
        props
      }) => `${props.label}*${props.icon}`)).join('|');
    }
    notif.meta.group = notif.group + '|' + notif.position;
  }
  if (notif.actions.length === 0) {
    notif.actions = void 0;
  } else {
    notif.meta.actionsClass = 'q-notification__actions row items-center ' + (notif.multiLine === true ? 'justify-end' : 'col-auto') + (notif.meta.hasMedia === true ? ' q-notification__actions--with-media' : '');
  }
  if (originalApi !== void 0) {
    // reset timeout if any
    clearTimeout(originalApi.notif.meta.timer);

    // retain uid
    notif.meta.uid = originalApi.notif.meta.uid;

    // replace notif
    const index = notificationsList[notif.position].indexOf(originalApi.notif);
    notificationsList[notif.position][index] = notif;
  } else {
    const original = groups[notif.meta.group];

    // woohoo, it's a new notification
    if (original === void 0) {
      notif.meta.uid = Notify_uid++;
      notif.meta.badge = 1;
      if (['left', 'right', 'center'].indexOf(notif.position) !== -1) {
        notificationsList[notif.position].splice(Math.floor(notificationsList[notif.position].length / 2), 0, notif);
      } else {
        const action = notif.position.indexOf('top') > -1 ? 'unshift' : 'push';
        notificationsList[notif.position][action](notif);
      }
      if (notif.group !== void 0) {
        groups[notif.meta.group] = notif;
      }
    }
    // ok, so it's NOT a new one
    else {
      // reset timeout if any
      clearTimeout(original.meta.timer);
      if (notif.badgePosition !== void 0) {
        if (badgePositions.includes(notif.badgePosition) === false) {
          return logError('wrong badgePosition', config);
        }
      } else {
        notif.badgePosition = `top-${notif.position.indexOf('left') > -1 ? 'right' : 'left'}`;
      }
      notif.meta.uid = original.meta.uid;
      notif.meta.badge = original.meta.badge + 1;
      notif.meta.badgeClass = `q-notification__badge q-notification__badge--${notif.badgePosition}` + (notif.badgeColor !== void 0 ? ` bg-${notif.badgeColor}` : '') + (notif.badgeTextColor !== void 0 ? ` text-${notif.badgeTextColor}` : '') + (notif.badgeClass ? ` ${notif.badgeClass}` : '');
      const index = notificationsList[notif.position].indexOf(original);
      notificationsList[notif.position][index] = groups[notif.meta.group] = notif;
    }
  }
  const dismiss = () => {
    removeNotification(notif, vm);
    Api = void 0;
  };
  vm.$forceUpdate();
  if (notif.timeout > 0) {
    notif.meta.timer = setTimeout(() => {
      dismiss();
    }, notif.timeout + /* show duration */1000);
  }

  // only non-groupable can be updated
  if (notif.group !== void 0) {
    return props => {
      if (props !== void 0) {
        logError('trying to update a grouped one which is forbidden', config);
      } else {
        dismiss();
      }
    };
  }
  Api = {
    dismiss,
    config,
    notif
  };
  if (originalApi !== void 0) {
    Object.assign(originalApi, Api);
    return;
  }
  return props => {
    // if notification wasn't previously dismissed
    if (Api !== void 0) {
      // if no params, then we must dismiss the notification
      if (props === void 0) {
        Api.dismiss();
      }
      // otherwise we're updating it
      else {
        const newNotif = Object.assign({}, Api.config, props, {
          group: false,
          position: notif.position
        });
        addNotification(newNotif, vm, Api);
      }
    }
  };
}
function removeNotification(notif, vm) {
  clearTimeout(notif.meta.timer);
  const index = notificationsList[notif.position].indexOf(notif);
  if (index !== -1) {
    if (notif.group !== void 0) {
      delete groups[notif.meta.group];
    }
    const el = vm.$refs['' + notif.meta.uid];
    if (el) {
      const {
        width,
        height
      } = getComputedStyle(el);
      el.style.left = `${el.offsetLeft}px`;
      el.style.width = width;
      el.style.height = height;
    }
    notificationsList[notif.position].splice(index, 1);
    vm.$forceUpdate();
    if (typeof notif.onDismiss === 'function') {
      notif.onDismiss();
    }
  }
}
function hasContent(str) {
  return str !== void 0 && str !== null && emptyRE.test(str) !== true;
}
function logError(error, config) {
  console.error(`Notify: ${error}`, config);
  return false;
}
const Notifications = {
  name: 'QNotifications',
  // hide App from Vue devtools
  devtools: {
    hide: true
  },
  beforeCreate() {
    // prevent error in Vue devtools
    this._routerRoot === void 0 && (this._routerRoot = {});
  },
  render(h) {
    return h('div', {
      staticClass: 'q-notifications'
    }, positionList.map(pos => {
      return h('transition-group', {
        key: pos,
        staticClass: positionClass[pos],
        tag: 'div',
        props: {
          name: `q-notification--${pos}`,
          mode: 'out-in'
        }
      }, notificationsList[pos].map(notif => {
        const {
          meta
        } = notif;
        const mainChild = [];
        if (meta.hasMedia === true) {
          if (notif.spinner !== false) {
            mainChild.push(h(notif.spinner, {
              staticClass: 'q-notification__spinner q-notification__spinner--' + meta.leftClass,
              props: {
                color: notif.spinnerColor,
                size: notif.spinnerSize
              }
            }));
          } else if (notif.icon) {
            mainChild.push(h(QIcon["a" /* default */], {
              staticClass: 'q-notification__icon q-notification__icon--' + meta.leftClass,
              attrs: {
                role: 'img'
              },
              props: {
                name: notif.icon,
                color: notif.iconColor,
                size: notif.iconSize
              }
            }));
          } else if (notif.avatar) {
            mainChild.push(h(QAvatar, {
              staticClass: 'q-notification__avatar q-notification__avatar--' + meta.leftClass
            }, [h('img', {
              attrs: {
                src: notif.avatar,
                'aria-hidden': 'true'
              }
            })]));
          }
        }
        if (meta.hasText === true) {
          let msgChild;
          const msgData = {
            staticClass: 'q-notification__message col'
          };
          if (notif.html === true) {
            msgData.domProps = {
              innerHTML: notif.caption ? `<div>${notif.message}</div><div class="q-notification__caption">${notif.caption}</div>` : notif.message
            };
          } else {
            const msgNode = [notif.message];
            msgChild = notif.caption ? [h('div', msgNode), h('div', {
              staticClass: 'q-notification__caption'
            }, [notif.caption])] : msgNode;
          }
          mainChild.push(h('div', msgData, msgChild));
        }
        const child = [h('div', {
          staticClass: meta.contentClass
        }, mainChild)];
        notif.progress === true && child.push(h('div', {
          key: `${meta.uid}|p|${meta.badge}`,
          staticClass: meta.progressClass,
          style: meta.progressStyle
        }));
        notif.actions !== void 0 && child.push(h('div', {
          staticClass: meta.actionsClass
        }, notif.actions.map(action => h(QBtn["a" /* default */], {
          ...action
        }))));
        meta.badge > 1 && child.push(h('div', {
          key: `${meta.uid}|${meta.badge}`,
          staticClass: meta.badgeClass,
          style: notif.badgeStyle
        }, [meta.badge]));
        return h('div', {
          ref: '' + meta.uid,
          key: meta.uid,
          staticClass: meta.staticClass,
          attrs: meta.attrs
        }, [h('div', {
          staticClass: meta.wrapperClass
        }, child)]);
      }));
    }));
  },
  mounted() {
    if (this.$q.fullscreen !== void 0 && this.$q.fullscreen.isCapable === true) {
      const append = () => {
        const newParent = Object(dom["c" /* getBodyFullscreenElement */])(this.$q.fullscreen.activeEl);
        if (this.$el.parentElement !== newParent) {
          newParent.appendChild(this.$el);
        }
      };
      this.unwatchFullscreen = this.$watch('$q.fullscreen.activeEl', Object(debounce["a" /* default */])(append, 50));
      if (this.$q.fullscreen.isActive === true) {
        append();
      }
    }
  },
  beforeDestroy() {
    this.unwatchFullscreen !== void 0 && this.unwatchFullscreen();
  }
};
/* harmony default export */ var Notify = ({
  setDefaults(opts) {
    if (Platform["e" /* isSSR */] !== true && Object(is["d" /* isObject */])(opts) === true) {
      Object.assign(Notify_defaults, opts);
    }
  },
  registerType(typeName, typeOpts) {
    if (Platform["e" /* isSSR */] !== true && Object(is["d" /* isObject */])(typeOpts) === true) {
      notifTypes[typeName] = typeOpts;
    }
  },
  install({
    $q
  }) {
    $q.notify = this.create = Platform["e" /* isSSR */] === true ? utils_event["g" /* noop */] : opts => addNotification(opts, Notify_vm);
    $q.notify.setDefaults = this.setDefaults;
    $q.notify.registerType = this.registerType;
    if ($q.config.notify !== void 0) {
      this.setDefaults($q.config.notify);
    }
    if (Platform["e" /* isSSR */] !== true) {
      positionList.forEach(pos => {
        notificationsList[pos] = [];
        const vert = ['left', 'center', 'right'].includes(pos) === true ? 'center' : pos.indexOf('top') > -1 ? 'top' : 'bottom',
          align = pos.indexOf('left') > -1 ? 'start' : pos.indexOf('right') > -1 ? 'end' : 'center',
          classes = ['left', 'right'].includes(pos) ? `items-${pos === 'left' ? 'start' : 'end'} justify-center` : pos === 'center' ? 'flex-center' : `items-${align}`;
        positionClass[pos] = `q-notifications__list q-notifications__list--${vert} fixed column no-wrap ${classes}`;
      });
      const node = document.createElement('div');
      document.body.appendChild(node);
      Notify_vm = new external_vue_default.a(Notifications);
      Notify_vm.$mount(node);
    }
  }
});
// EXTERNAL MODULE: /workspace/node_modules/quasar/src/plugins/Screen.js
var Screen = __webpack_require__("0807");

// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/private/web-storage.js


function web_storage_encode(value) {
  if (Object(is["a" /* isDate */])(value) === true) {
    return '__q_date|' + value.toUTCString();
  }
  if (Object(is["e" /* isRegexp */])(value) === true) {
    return '__q_expr|' + value.source;
  }
  if (typeof value === 'number') {
    return '__q_numb|' + value;
  }
  if (typeof value === 'boolean') {
    return '__q_bool|' + (value ? '1' : '0');
  }
  if (typeof value === 'string') {
    return '__q_strn|' + value;
  }
  if (typeof value === 'function') {
    return '__q_strn|' + value.toString();
  }
  if (value === Object(value)) {
    return '__q_objt|' + JSON.stringify(value);
  }

  // hmm, we don't know what to do with it,
  // so just return it as is
  return value;
}
function web_storage_decode(value) {
  const length = value.length;
  if (length < 9) {
    // then it wasn't encoded by us
    return value;
  }
  const type = value.substr(0, 8);
  const source = value.substring(9);
  switch (type) {
    case '__q_date':
      return new Date(source);
    case '__q_expr':
      return new RegExp(source);
    case '__q_numb':
      return Number(source);
    case '__q_bool':
      return Boolean(source === '1');
    case '__q_strn':
      return '' + source;
    case '__q_objt':
      return JSON.parse(source);
    default:
      // hmm, we reached here, we don't know the type,
      // then it means it wasn't encoded by us, so just
      // return whatever value it is
      return value;
  }
}
function getEmptyStorage() {
  const getVal = () => null;
  return {
    has: () => false,
    getLength: () => 0,
    getItem: getVal,
    getIndex: getVal,
    getKey: getVal,
    getAll: () => {},
    getAllKeys: () => [],
    set: utils_event["g" /* noop */],
    remove: utils_event["g" /* noop */],
    clear: utils_event["g" /* noop */],
    isEmpty: () => true
  };
}
function getStorage(type) {
  const webStorage = window[type + 'Storage'],
    get = key => {
      const item = webStorage.getItem(key);
      return item ? web_storage_decode(item) : null;
    };
  return {
    has: key => webStorage.getItem(key) !== null,
    getLength: () => webStorage.length,
    getItem: get,
    getIndex: index => {
      return index < webStorage.length ? get(webStorage.key(index)) : null;
    },
    getKey: index => {
      return index < webStorage.length ? webStorage.key(index) : null;
    },
    getAll: () => {
      let key;
      const result = {},
        len = webStorage.length;
      for (let i = 0; i < len; i++) {
        key = webStorage.key(i);
        result[key] = get(key);
      }
      return result;
    },
    getAllKeys: () => {
      const result = [],
        len = webStorage.length;
      for (let i = 0; i < len; i++) {
        result.push(webStorage.key(i));
      }
      return result;
    },
    set: (key, value) => {
      webStorage.setItem(key, web_storage_encode(value));
    },
    remove: key => {
      webStorage.removeItem(key);
    },
    clear: () => {
      webStorage.clear();
    },
    isEmpty: () => webStorage.length === 0
  };
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/LocalStorage.js


/* harmony default export */ var LocalStorage = ({
  install({
    $q
  }) {
    const storage = Platform["e" /* isSSR */] === true || Platform["a" /* client */].has.webStorage === false ? getEmptyStorage() : getStorage('local');
    $q.localStorage = storage;
    Object.assign(this, storage);
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins/SessionStorage.js


/* harmony default export */ var SessionStorage = ({
  install({
    $q
  }) {
    const storage = Platform["e" /* isSSR */] === true || Platform["a" /* client */].has.webStorage === false ? getEmptyStorage() : getStorage('session');
    $q.sessionStorage = storage;
    Object.assign(this, storage);
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/plugins.js
















// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/copy-to-clipboard.js
function fallback(text) {
  const area = document.createElement('textarea');
  area.value = text;
  area.contentEditable = true;
  area.style.position = 'fixed'; // avoid scrolling to bottom

  document.body.appendChild(area);
  area.focus();
  area.select();
  const res = document.execCommand('copy');
  area.remove();
  return res;
}
/* harmony default export */ var copy_to_clipboard = (function (text) {
  return navigator.clipboard !== void 0 ? navigator.clipboard.writeText(text) : new Promise((resolve, reject) => {
    const res = fallback(text);
    if (res) {
      resolve(true);
    } else {
      reject(res);
    }
  });
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/export-file.js
function clean(link) {
  // allow time for iOS
  setTimeout(() => {
    window.URL.revokeObjectURL(link.href);
  }, 10000);
  link.remove();
}
/* harmony default export */ var export_file = (function (fileName, rawData, mimeType) {
  const blob = new Blob([rawData], {
    type: mimeType || 'text/plain'
  });

  // IE11 has its own stuff...
  if (window.navigator.msSaveOrOpenBlob) {
    return window.navigator.msSaveOrOpenBlob(blob, fileName);
  }
  const link = document.createElement('a');
  link.download = fileName;
  link.href = window.URL.createObjectURL(blob);
  link.classList.add('hidden');
  link.style.position = 'fixed'; // avoid scrolling to bottom
  document.body.appendChild(link);
  try {
    link.click();
    clean(link);
    return true;
  } catch (err) {
    clean(link);
    return err;
  }
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/open-url.js



function parseFeatures(winFeatures) {
  const cfg = Object.assign({
    noopener: true
  }, winFeatures);
  const feat = [];
  Object.keys(cfg).forEach(key => {
    if (cfg[key] === true) {
      feat.push(key);
    }
  });
  return feat.join(',');
}
function openWindow(url, reject, windowFeatures) {
  let open = window.open;
  if (Platform["b" /* default */].is.cordova === true) {
    if (cordova !== void 0 && cordova.InAppBrowser !== void 0 && cordova.InAppBrowser.open !== void 0) {
      open = cordova.InAppBrowser.open;
    } else if (navigator !== void 0 && navigator.app !== void 0) {
      return navigator.app.loadUrl(url, {
        openExternal: true
      });
    }
  } else if (external_vue_default.a.prototype.$q.electron !== void 0) {
    return external_vue_default.a.prototype.$q.electron.shell.openExternal(url);
  }
  const win = open(url, '_blank', parseFeatures(windowFeatures));
  if (win) {
    Platform["b" /* default */].is.desktop && win.focus();
    return win;
  } else {
    reject && reject();
  }
}
/* harmony default export */ var open_url = ((url, reject, windowFeatures) => {
  if (Platform["b" /* default */].is.ios === true && window.SafariViewController !== void 0) {
    window.SafariViewController.isAvailable(available => {
      if (available) {
        window.SafariViewController.show({
          url
        }, utils_event["g" /* noop */], reject);
      } else {
        openWindow(url, reject, windowFeatures);
      }
    });
    return;
  }
  return openWindow(url, reject, windowFeatures);
});
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils/run-sequential-promises.js
function parsePromises(sequentialPromises) {
  const isList = Array.isArray(sequentialPromises);
  if (isList === true) {
    const totalJobs = sequentialPromises.length;
    return {
      isList,
      totalJobs,
      resultAggregator: Array(totalJobs).fill(null)
    };
  }
  const resultKeys = Object.keys(sequentialPromises);
  const resultAggregator = {};
  resultKeys.forEach(keyName => {
    resultAggregator[keyName] = null;
  });
  return {
    isList,
    totalJobs: resultKeys.length,
    resultAggregator,
    resultKeys
  };
}

/**
 * Run a list of Promises sequentially, optionally on multiple threads.
 *
 * @param {*} sequentialPromises - Array of Functions or Object with Functions as values
 *                          Array of Function form: [ (resultAggregator: Array) => Promise<any>, ... ]
 *                          Object form: { [key: string]: (resultAggregator: object) => Promise<any>, ... }
 * @param {*} opts - Optional options Object
 *                   Object form: { threadsNumber?: number, abortOnFail?: boolean }
 *                   Default: { threadsNumber: 1, abortOnFail: true }
 *                   When configuring threadsNumber AND using http requests, be
 *                       aware of the maximum threads that the hosting browser
 *                       supports (usually 5); any number of threads above that
 *                       won't add any real benefits
 * @returns Promise<Array<Object> | Object>
 *    With opts.abortOnFail set to true (which is default):
 *        When sequentialPromises param is Array:
 *          The Promise resolves with an Array of Objects of the following form:
 *             [ { key: number, status: 'fulfilled', value: any }, ... ]
 *          The Promise rejects with an Object of the following form:
 *             { key: number, status: 'rejected', reason: Error, resultAggregator: array }
 *        When sequentialPromises param is Object:
 *          The Promise resolves with an Object of the following form:
 *             { [key: string]: { key: string, status: 'fulfilled', value: any }, ... }
 *          The Promise rejects with an Object of the following form:
 *             { key: string, status: 'rejected', reason: Error, resultAggregator: object }
 *    With opts.abortOnFail set to false:
 *       The Promise is never rejected (no catch() needed)
 *       The Promise resolves with:
 *          An Array of Objects (when sequentialPromises param is also an Array) of the following form:
 *             [ { key: number, status: 'fulfilled', value: any } | { status: 'rejected', reason: Error }, ... ]
 *          An Object (when sequentialPromises param is also an Object) of the following form:
 *             { [key: string]: { key: string, status: 'fulfilled', value: any } | { key: string, status: 'rejected', reason: Error }, ... }
 */
function runSequentialPromises(sequentialPromises, {
  threadsNumber = 1,
  abortOnFail = true
} = {}) {
  let jobIndex = -1,
    hasAborted = false;
  const {
    isList,
    totalJobs,
    resultAggregator,
    resultKeys
  } = parsePromises(sequentialPromises);
  const getPromiseThread = () => new Promise((resolve, reject) => {
    function runNextPromise() {
      const currentJobIndex = ++jobIndex;
      if (hasAborted === true || currentJobIndex >= totalJobs) {
        resolve();
        return;
      }
      const key = isList === true ? currentJobIndex : resultKeys[currentJobIndex];
      sequentialPromises[key](resultAggregator).then(value => {
        if (hasAborted === true) {
          resolve();
          return; // early exit
        }
        resultAggregator[key] = {
          key,
          status: 'fulfilled',
          value
        };

        // timeout so it doesn't interfere with the .catch() below
        setTimeout(runNextPromise);
      }).catch(reason => {
        if (hasAborted === true) {
          resolve();
          return; // early exit
        }
        const result = {
          key,
          status: 'rejected',
          reason
        };
        resultAggregator[key] = result;
        if (abortOnFail === true) {
          hasAborted = true;
          reject({
            ...result,
            resultAggregator
          });
          return; // early exit
        }

        // timeout so no interference
        setTimeout(runNextPromise);
      });
    }
    runNextPromise();
  });
  const threads = Array(threadsNumber).fill(getPromiseThread());
  return Promise.all(threads).then(() => resultAggregator);
}
// CONCATENATED MODULE: /workspace/node_modules/quasar/src/utils.js




















// CONCATENATED MODULE: /workspace/node_modules/quasar/src/index.esm.js








/* harmony default export */ var index_esm = ({
  ...vue_plugin,
  install(Vue, opts) {
    vue_plugin.install(Vue, {
      components: components_namespaceObject,
      directives: directives_namespaceObject,
      plugins: plugins_namespaceObject,
      ...opts
    });
  }
});
// EXTERNAL MODULE: ./src/styles/quasar.styl
var quasar = __webpack_require__("a4ac");

// CONCATENATED MODULE: ./src/quasar.ts




// Vue.use({ install }, {
//   components: [
//     QBtn,
//     QCard,
//     QCardActions,
//     QCardSection,
//     QCheckbox,
//     QChip,
//     QDialog,
//     QDrawer,
//     QExpansionItem,
//     QIcon,
//     QInput,
//     QItem,
//     QItemSection,
//     QLayout,
//     QList,
//     QMenu,
//     QPage,
//     QPageContainer,
//     QScrollArea,
//     QSpinner,
//     QToggle,
//     QTooltip
//   ],
//   directives: [
//     ClosePopup
//   ],
//   plugins: [],
//   config: {}
// })
external_vue_default.a.use(index_esm, {
  config: {},
  components: {/* not needed if importStrategy is not 'manual' */},
  directives: {/* not needed if importStrategy is not 'manual' */}
  // plugins: { }
});
// EXTERNAL MODULE: ./src/axios.ts
var axios = __webpack_require__("f532");

// EXTERNAL MODULE: ./src/components/ClassExpansion.vue + 9 modules
var ClassExpansion = __webpack_require__("d66b");

// EXTERNAL MODULE: ./src/components/Image.vue + 4 modules
var components_Image = __webpack_require__("a142");

// EXTERNAL MODULE: ./src/components/ImageControl.vue + 9 modules
var ImageControl = __webpack_require__("8862");

// EXTERNAL MODULE: ./src/components/QCReview.vue + 36 modules
var QCReview = __webpack_require__("a5af");

// EXTERNAL MODULE: ./src/components/ViewGrid.vue + 9 modules
var ViewGrid = __webpack_require__("4b62");

// EXTERNAL MODULE: ./src/components/Worksheet.vue + 40 modules
var Worksheet = __webpack_require__("82fa");

// CONCATENATED MODULE: /workspace/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1d9ea752-vue-loader-template"}!/workspace/node_modules/cache-loader/dist/cjs.js??ref--13-0!/workspace/node_modules/babel-loader/lib!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-loader/lib/loaders/templateLoader.js??ref--7!/workspace/node_modules/pug-plain-loader!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ZoomControl.vue?vue&type=template&id=e6d9f240&scoped=true&lang=pug
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticStyle: {
      "padding": "40px 80px"
    }
  }, [_c('q-btn', {
    attrs: {
      "color": "grey-4",
      "text-color": "black",
      "label": "Flag for Edit"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleFlag();
      }
    }
  }), _c('q-btn', {
    staticClass: "q-ml-sm",
    attrs: {
      "disabled": _vm.disableNext,
      "color": "grey-4",
      "text-color": "black",
      "label": "Next"
    },
    on: {
      "click": function ($event) {
        return _vm.nextImage();
      }
    }
  }), _c('q-btn', {
    staticClass: "q-ml-sm",
    attrs: {
      "color": "grey-4",
      "text-color": "black",
      "label": "Reject Image"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleReject();
      }
    }
  })], 1);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/ZoomControl.vue?vue&type=template&id=e6d9f240&scoped=true&lang=pug

// EXTERNAL MODULE: external "vue-property-decorator"
var external_vue_property_decorator_ = __webpack_require__("01a6");

// EXTERNAL MODULE: external "@ht-lib/accounts-models"
var accounts_models_ = __webpack_require__("406b");

// CONCATENATED MODULE: /workspace/node_modules/babel-loader/lib!/workspace/node_modules/ts-loader??ref--14-1!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.transform-quasar-imports.js!/workspace/node_modules/vue-cli-plugin-quasar/lib/loader.auto-import.js?kebab!/workspace/node_modules/cache-loader/dist/cjs.js??ref--1-1!/workspace/node_modules/vue-loader/lib??vue-loader-options!./src/components/ZoomControl.vue?vue&type=script&lang=ts
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let ZoomControlvue_type_script_lang_ts_default_1 = class default_1 extends external_vue_property_decorator_["Vue"] {
  mounted() {
    this.listener = e => {
      switch (e.keyCode) {
        case 66:
          // b
          this.toggleFlag();
          break;
        case 78:
          // n
          this.nextImage();
          break;
        case 77:
          // m
          this.toggleReject();
          break;
      }
    };
    window.addEventListener('keydown', this.listener);
  }
  beforeDestroy() {
    window.removeEventListener('keydown', this.listener);
  }
  toggleReject() {
    const newStatus = this.image.status === accounts_models_["ImageStatus"].REJECTED ? accounts_models_["ImageStatus"].NONE : accounts_models_["ImageStatus"].REJECTED;
    this.status(this.image.longRef, newStatus);
  }
  toggleFlag() {
    const newStatus = this.image.status === accounts_models_["ImageStatus"].FLAGGED ? accounts_models_["ImageStatus"].NONE : accounts_models_["ImageStatus"].FLAGGED;
    this.status(this.image.longRef, newStatus);
  }
  get disableNext() {
    return !this.images.next;
  }
  nextImage() {
    if (!this.images || !this.images.next) {
      return;
    }
    this.$router.push({
      name: 'zoom',
      params: {
        imageRef: this.images.next.longRef
      }
    });
  }
};
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ZoomControlvue_type_script_lang_ts_default_1.prototype, "image", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ZoomControlvue_type_script_lang_ts_default_1.prototype, "images", void 0);
__decorate([Object(external_vue_property_decorator_["Prop"])({
  required: true
})], ZoomControlvue_type_script_lang_ts_default_1.prototype, "status", void 0);
ZoomControlvue_type_script_lang_ts_default_1 = __decorate([Object(external_vue_property_decorator_["Component"])({
  name: 'ZoomControl'
})], ZoomControlvue_type_script_lang_ts_default_1);
/* harmony default export */ var ZoomControlvue_type_script_lang_ts = (ZoomControlvue_type_script_lang_ts_default_1);
// CONCATENATED MODULE: ./src/components/ZoomControl.vue?vue&type=script&lang=ts
 /* harmony default export */ var components_ZoomControlvue_type_script_lang_ts = (ZoomControlvue_type_script_lang_ts); 
// EXTERNAL MODULE: /workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2ddd");

// EXTERNAL MODULE: /workspace/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js
var runtime_auto_import = __webpack_require__("d447");
var runtime_auto_import_default = /*#__PURE__*/__webpack_require__.n(runtime_auto_import);

// CONCATENATED MODULE: ./src/components/ZoomControl.vue





/* normalize component */

var ZoomControl_component = Object(componentNormalizer["a" /* default */])(
  components_ZoomControlvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "e6d9f240",
  null
  
)

/* harmony default export */ var ZoomControl = (ZoomControl_component.exports);


runtime_auto_import_default()(ZoomControl_component, 'components', {QBtn: QBtn["a" /* default */]});

// EXTERNAL MODULE: ./src/components/ZoomImage.vue + 4 modules
var ZoomImage = __webpack_require__("f9b2");

// CONCATENATED MODULE: ./src/components/index.ts








// EXTERNAL MODULE: ./src/features.ts
var features = __webpack_require__("8310");

// EXTERNAL MODULE: external "@ht-lib/accounts-common"
var accounts_common_ = __webpack_require__("03be");

// EXTERNAL MODULE: external "@ht-lib/image-util"
var image_util_ = __webpack_require__("38a2");

// EXTERNAL MODULE: external "@ht-lib/activity-collection"
var activity_collection_ = __webpack_require__("44d9");

// EXTERNAL MODULE: /workspace/node_modules/@firebase/util/dist/index.esm2017.js
var index_esm2017 = __webpack_require__("a7fa");

// CONCATENATED MODULE: /workspace/node_modules/@firebase/component/dist/esm/index.esm2017.js


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class index_esm2017_Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new index_esm2017["a" /* Deferred */]();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new index_esm2017_Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


//# sourceMappingURL=index.esm2017.js.map

// CONCATENATED MODULE: /workspace/node_modules/@firebase/logger/dist/esm/index.esm2017.js
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach(inst => {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    for (const instance of instances) {
        let customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = (instance, level, ...args) => {
                const message = args
                    .map(arg => {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(arg => arg)
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message,
                        args,
                        type: instance.name
                    });
                }
            };
        }
    }
}


//# sourceMappingURL=index.esm2017.js.map

// CONCATENATED MODULE: /workspace/node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



// CONCATENATED MODULE: /workspace/node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));



// CONCATENATED MODULE: /workspace/node_modules/@firebase/app/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}

const name$o = "@firebase/app";
const version$1 = "0.10.2";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger('@firebase/app');

const name$n = "@firebase/app-compat";

const name$m = "@firebase/analytics-compat";

const name$l = "@firebase/analytics";

const name$k = "@firebase/app-check-compat";

const name$j = "@firebase/app-check";

const name$i = "@firebase/auth";

const name$h = "@firebase/auth-compat";

const name$g = "@firebase/database";

const name$f = "@firebase/database-compat";

const name$e = "@firebase/functions";

const name$d = "@firebase/functions-compat";

const name$c = "@firebase/installations";

const name$b = "@firebase/installations-compat";

const name$a = "@firebase/messaging";

const name$9 = "@firebase/messaging-compat";

const name$8 = "@firebase/performance";

const name$7 = "@firebase/performance-compat";

const name$6 = "@firebase/remote-config";

const name$5 = "@firebase/remote-config-compat";

const name$4 = "@firebase/storage";

const name$3 = "@firebase/storage-compat";

const name$2 = "@firebase/firestore";

const name$1 = "@firebase/firestore-compat";

const index_esm2017_name = "firebase";
const index_esm2017_version = "10.11.1";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const index_esm2017_DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$o]: 'fire-core',
    [name$n]: 'fire-core-compat',
    [name$l]: 'fire-analytics',
    [name$m]: 'fire-analytics-compat',
    [name$j]: 'fire-app-check',
    [name$k]: 'fire-app-check-compat',
    [name$i]: 'fire-auth',
    [name$h]: 'fire-auth-compat',
    [name$g]: 'fire-rtdb',
    [name$f]: 'fire-rtdb-compat',
    [name$e]: 'fire-fn',
    [name$d]: 'fire-fn-compat',
    [name$c]: 'fire-iid',
    [name$b]: 'fire-iid-compat',
    [name$a]: 'fire-fcm',
    [name$9]: 'fire-fcm-compat',
    [name$8]: 'fire-perf',
    [name$7]: 'fire-perf-compat',
    [name$6]: 'fire-rc',
    [name$5]: 'fire-rc-compat',
    [name$4]: 'fire-gcs',
    [name$3]: 'fire-gcs-compat',
    [name$2]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [index_esm2017_name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * @internal
 */
const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    for (const serverApp of _serverApps.values()) {
        _addComponent(serverApp, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function _getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */
function _isFirebaseApp(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */
function _isFirebaseServerApp(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call initializeApp() first',
    ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new index_esm2017["b" /* ErrorFactory */]('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class index_esm2017_FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new Component('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */, { appName: this._name });
        }
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseServerAppImpl extends index_esm2017_FirebaseAppImpl {
    constructor(options, serverConfig, name, container) {
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined
            ? serverConfig.automaticDataCollectionEnabled
            : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name,
            automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) {
            // Construct the parent FirebaseAppImp object.
            super(options, config, container);
        }
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({ automaticDataCollectionEnabled }, serverConfig);
        this._finalizationRegistry = new FinalizationRegistry(() => {
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegisry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        registerVersion(name$o, version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) {
            return;
        }
        this._refCount++;
        if (obj !== undefined) {
            this._finalizationRegistry.register(obj, this);
        }
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) {
            return 0;
        }
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        void deleteApp(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */);
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = index_esm2017_version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: index_esm2017_DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    options || (options = Object(index_esm2017["i" /* getDefaultAppConfig */])());
    if (!options) {
        throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */);
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (Object(index_esm2017["g" /* deepEqual */])(options, existingApp.options) &&
            Object(index_esm2017["g" /* deepEqual */])(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new ComponentContainer(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new index_esm2017_FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
function initializeServerApp(_options, _serverAppConfig) {
    if (Object(index_esm2017["j" /* isBrowser */])()) {
        // FirebaseServerApp isn't designed to be run in browsers.
        throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */);
    }
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) {
        _serverAppConfig.automaticDataCollectionEnabled = false;
    }
    let appOptions;
    if (_isFirebaseApp(_options)) {
        appOptions = _options.options;
    }
    else {
        appOptions = _options;
    }
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) {
        delete nameObj.releaseOnDeref;
    }
    const hashCode = (s) => {
        return [...s].reduce((hash, c) => (Math.imul(31, hash) + c.charCodeAt(0)) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') {
            throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */, {});
        }
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = _serverApps.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new ComponentContainer(nameString);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    _serverApps.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function getApp(name = index_esm2017_DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === index_esm2017_DEFAULT_ENTRY_NAME && Object(index_esm2017["i" /* getDefaultAppConfig */])()) {
        return initializeApp();
    }
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function index_esm2017_getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
    let cleanupProviders = false;
    const name = app.name;
    if (_apps.has(name)) {
        cleanupProviders = true;
        _apps.delete(name);
    }
    else if (_serverApps.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            _serverApps.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container
            .getProviders()
            .map(provider => provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new Component(`${library}-version`, () => ({ library, version }), "VERSION" /* ComponentType.VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */);
    }
    setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function index_esm2017_setLogLevel(logLevel) {
    setLogLevel(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        try {
                            db.createObjectStore(STORE_NAME);
                        }
                        catch (e) {
                            // Safari/iOS browsers throw occasional exceptions on
                            // db.createObjectStore() that may be a bug. Avoid blocking
                            // the rest of the app functionality.
                            console.warn(e);
                        }
                }
            }
        }).catch(e => {
            throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    }
    catch (e) {
        if (e instanceof index_esm2017["c" /* FirebaseError */]) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    }
    catch (e) {
        if (e instanceof index_esm2017["c" /* FirebaseError */]) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class index_esm2017_HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new index_esm2017_HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container
            .getProvider('platform-logger')
            .getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) {
                return;
            }
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
            this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
            return;
        }
        else {
            // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({ date, agent });
        }
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) {
            await this._heartbeatsCachePromise;
        }
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null ||
            this._heartbeatsCache.heartbeats.length === 0) {
            return '';
        }
        const date = getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = Object(index_esm2017["d" /* base64urlEncodeWithoutPadding */])(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        }
        else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            void this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class index_esm2017_HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!Object(index_esm2017["k" /* isIndexedDBAvailable */])()) {
            return false;
        }
        else {
            return Object(index_esm2017["l" /* validateIndexedDBOpenable */])()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) {
                return idbHeartbeatObject;
            }
            else {
                return { heartbeats: [] };
            }
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return Object(index_esm2017["d" /* base64urlEncodeWithoutPadding */])(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new Component('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    _registerComponent(new Component('heartbeat', container => new index_esm2017_HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    // Register `app` package.
    registerVersion(name$o, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name$o, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');


//# sourceMappingURL=index.esm2017.js.map

// CONCATENATED MODULE: /workspace/node_modules/@firebase/app-compat/dist/esm/index.esm2017.js






/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 *
 * marked as internal because it references internal types exported from @firebase/app
 * @internal
 */
class esm_index_esm2017_FirebaseAppImpl {
    constructor(_delegate, firebase) {
        this._delegate = _delegate;
        this.firebase = firebase;
        // add itself to container
        _addComponent(_delegate, new Component('app-compat', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
        this.container = _delegate.container;
    }
    get automaticDataCollectionEnabled() {
        return this._delegate.automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this._delegate.automaticDataCollectionEnabled = val;
    }
    get name() {
        return this._delegate.name;
    }
    get options() {
        return this._delegate.options;
    }
    delete() {
        return new Promise(resolve => {
            this._delegate.checkDestroyed();
            resolve();
        }).then(() => {
            this.firebase.INTERNAL.removeApp(this.name);
            return deleteApp(this._delegate);
        });
    }
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    _getService(name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
        var _a;
        this._delegate.checkDestroyed();
        // Initialize instance if InstatiationMode is `EXPLICIT`.
        const provider = this._delegate.container.getProvider(name);
        if (!provider.isInitialized() &&
            ((_a = provider.getComponent()) === null || _a === void 0 ? void 0 : _a.instantiationMode) === "EXPLICIT" /* InstantiationMode.EXPLICIT */) {
            provider.initialize();
        }
        // getImmediate will always succeed because _getService is only called for registered components.
        return provider.getImmediate({
            identifier: instanceIdentifier
        });
    }
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get it again.
     *
     * NOTE: currently only firestore uses this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */
    _removeServiceInstance(name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
        this._delegate.container
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .getProvider(name)
            .clearInstance(instanceIdentifier);
    }
    /**
     * @param component the component being added to this app's container
     * @internal
     */
    _addComponent(component) {
        _addComponent(this._delegate, component);
    }
    _addOrOverwriteComponent(component) {
        _addOrOverwriteComponent(this._delegate, component);
    }
    toJSON() {
        return {
            name: this.name,
            automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
            options: this.options
        };
    }
}
// TODO: investigate why the following needs to be commented out
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
// (FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
//   FirebaseAppImpl.prototype.delete ||
//   console.log('dc');

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.'
};
const index_esm2017_ERROR_FACTORY = new index_esm2017["b" /* ErrorFactory */]('app-compat', 'Firebase', index_esm2017_ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    const apps = {};
    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const components = new Map<string, Component<any>>();
    // A namespace is a plain JavaScript Object.
    const namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeAppCompat,
        // @ts-ignore
        app,
        registerVersion: registerVersion,
        setLogLevel: index_esm2017_setLogLevel,
        onLog: onLog,
        // @ts-ignore
        apps: null,
        SDK_VERSION: SDK_VERSION,
        INTERNAL: {
            registerComponent: registerComponentCompat,
            removeApp,
            useAsService,
            modularAPIs: dist_esm_index_esm2017_namespaceObject
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || index_esm2017_DEFAULT_ENTRY_NAME;
        if (!Object(index_esm2017["e" /* contains */])(apps, name)) {
            throw index_esm2017_ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, { appName: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    /**
     * Create a new App instance (name must be unique).
     *
     * This function is idempotent. It can be called more than once and return the same instance using the same options and config.
     */
    function initializeAppCompat(options, rawConfig = {}) {
        const app = initializeApp(options, rawConfig);
        if (Object(index_esm2017["e" /* contains */])(apps, app.name)) {
            return apps[app.name];
        }
        const appCompat = new firebaseAppImpl(app, namespace);
        apps[app.name] = appCompat;
        return appCompat;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(name => apps[name]);
    }
    function registerComponentCompat(component) {
        const componentName = component.name;
        const componentNameWithoutCompat = componentName.replace('-compat', '');
        if (_registerComponent(component) &&
            component.type === "PUBLIC" /* ComponentType.PUBLIC */) {
            // create service namespace for public components
            // The Service namespace is an accessor function ...
            const serviceNamespace = (appArg = app()) => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (typeof appArg[componentNameWithoutCompat] !== 'function') {
                    // Invalid argument.
                    // This happens in the following case: firebase.storage('gs:/')
                    throw index_esm2017_ERROR_FACTORY.create("invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */, {
                        appName: componentName
                    });
                }
                // Forward service instance lookup to the FirebaseApp.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return appArg[componentNameWithoutCompat]();
            };
            // ... and a container for service-level properties.
            if (component.serviceProps !== undefined) {
                Object(index_esm2017["h" /* deepExtend */])(serviceNamespace, component.serviceProps);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            namespace[componentNameWithoutCompat] = serviceNamespace;
            // Patch the FirebaseAppImpl prototype
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            firebaseAppImpl.prototype[componentNameWithoutCompat] =
                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
                // option added to the no-explicit-any rule when ESlint releases it.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                function (...args) {
                    const serviceFxn = this._getService.bind(this, componentName);
                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
                };
        }
        return component.type === "PUBLIC" /* ComponentType.PUBLIC */
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                namespace[componentNameWithoutCompat]
            : null;
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        const useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    const namespace = createFirebaseNamespaceCore(esm_index_esm2017_FirebaseAppImpl);
    namespace.INTERNAL = Object.assign(Object.assign({}, namespace.INTERNAL), { createFirebaseNamespace,
        extendNamespace,
        createSubscribe: index_esm2017["f" /* createSubscribe */],
        ErrorFactory: index_esm2017["b" /* ErrorFactory */],
        deepExtend: index_esm2017["h" /* deepExtend */] });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        Object(index_esm2017["h" /* deepExtend */])(namespace, props);
    }
    return namespace;
}
const firebase$1 = createFirebaseNamespace();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_logger = new Logger('@firebase/app-compat');

const esm_index_esm2017_name = "@firebase/app-compat";
const esm_index_esm2017_version = "0.2.32";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_esm2017_registerCoreComponents(variant) {
    // Register `app` package.
    registerVersion(esm_index_esm2017_name, esm_index_esm2017_version, variant);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Firebase Lite detection
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (Object(index_esm2017["j" /* isBrowser */])() && self.firebase !== undefined) {
    index_esm2017_logger.warn(`
    Warning: Firebase is already defined in the global scope. Please make sure
    Firebase library is only loaded once.
  `);
    // eslint-disable-next-line
    const sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        index_esm2017_logger.warn(`
    Warning: You are trying to load Firebase while using Firebase Performance standalone script.
    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.
    `);
    }
}
const index_esm2017_firebase = firebase$1;
index_esm2017_registerCoreComponents();


//# sourceMappingURL=index.esm2017.js.map

// CONCATENATED MODULE: /workspace/node_modules/firebase/compat/app/dist/esm/index.esm.js



var index_esm_name = "firebase";
var index_esm_version = "10.11.1";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
index_esm2017_firebase.registerVersion(index_esm_name, index_esm_version, 'app-compat');
//# sourceMappingURL=index.esm.js.map

// CONCATENATED MODULE: ./src/firebase.ts




function setApp(app) {
  // TODO: Pass these dependenices in instead of requiring them directly.
  activity_collection_["setApp"](app);
  accounts_common_["setApp"](app);
  image_util_["setApp"](app);
}

// CONCATENATED MODULE: ./src/route.ts
function route(config) {
  const routeName = config.routeNamePrefix == null ? '' : config.routeNamePrefix + '/';
  return {
    path: routeName + 'qc/review/:jobId/:view',
    component: async () => await Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "a5af")),
    props: route => ({
      jobId: route.params.jobId,
      view: route.params.view,
      config
    }),
    children: [{
      path: ':imageRef?',
      props: route => ({
        view: route.params.view,
        imageRef: route.params.imageRef
      })
    }]
  };
}
// CONCATENATED MODULE: ./src/index.ts








function setThumbnailBucket(thumbnailBucket) {
  imageStore["a" /* ImageStore */].Instance.bucketName = thumbnailBucket;
}
function getThumbnailBucket() {
  return imageStore["a" /* ImageStore */].Instance.bucketName;
}

/***/ })

/******/ });
});
//# sourceMappingURL=index.umd.js.map